module.exports = /******/
function(modules) {
    /******/
    /******/
    // The require function
    /******/
    function __webpack_require__(moduleId) {
        /******/
        /******/
        // Check if module is in cache
        /******/
        if (installedModules[moduleId]) /******/
        return installedModules[moduleId].exports;
        /******/
        // Create a new module (and put it into the cache)
        /******/
        var module = installedModules[moduleId] = {
            /******/
            i: moduleId,
            /******/
            l: !1,
            /******/
            exports: {}
        };
        /******/
        /******/
        // Return the exports of the module
        /******/
        /******/
        /******/
        // Execute the module function
        /******/
        /******/
        /******/
        // Flag the module as loaded
        /******/
        return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
        module.l = !0, module.exports;
    }
    // webpackBootstrap
    /******/
    // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/
    // Load entry module and return exports
    /******/
    /******/
    /******/
    /******/
    // expose the modules object (__webpack_modules__)
    /******/
    /******/
    /******/
    // expose the module cache
    /******/
    /******/
    /******/
    // define getter function for harmony exports
    /******/
    /******/
    /******/
    // getDefaultExport function for compatibility with non-harmony modules
    /******/
    /******/
    /******/
    // Object.prototype.hasOwnProperty.call
    /******/
    /******/
    /******/
    // __webpack_public_path__
    /******/
    return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
    __webpack_require__.d = function(exports, name, getter) {
        /******/
        __webpack_require__.o(exports, name) || /******/
        Object.defineProperty(exports, name, {
            /******/
            configurable: !1,
            /******/
            enumerable: !0,
            /******/
            get: getter
        });
    }, __webpack_require__.n = function(module) {
        /******/
        var getter = module && module.__esModule ? /******/
        function() {
            return module.default;
        } : /******/
        function() {
            return module;
        };
        /******/
        /******/
        return __webpack_require__.d(getter, "a", getter), getter;
    }, __webpack_require__.o = function(object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
    }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = 144);
}([ /* 0 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    /**
 * Set the supplied SelectionState as the new current selection, and set
 * the `force` flag to trigger manual selection placement by the view.
 */
    function updateSelection(editorState, selection, forceSelection) {
        return EditorState.set(editorState, {
            selection: selection,
            forceSelection: forceSelection,
            nativelyRenderedContent: null,
            inlineStyleOverride: null
        });
    }
    /**
 * Regenerate the entire tree map for a given ContentState and decorator.
 * Returns an OrderedMap that maps all available ContentBlock objects.
 */
    function generateNewTreeMap(contentState, decorator) {
        return contentState.getBlockMap().map(function(block) {
            return BlockTree.generate(contentState, block, decorator);
        }).toOrderedMap();
    }
    /**
 * Regenerate tree map objects for all ContentBlocks that have changed
 * between the current editorState and newContent. Returns an OrderedMap
 * with only changed regenerated tree map objects.
 */
    function regenerateTreeForNewBlocks(editorState, newBlockMap, newEntityMap, decorator) {
        var contentState = editorState.getCurrentContent().set("entityMap", newEntityMap), prevBlockMap = contentState.getBlockMap();
        return editorState.getImmutable().get("treeMap").merge(newBlockMap.toSeq().filter(function(block, key) {
            return block !== prevBlockMap.get(key);
        }).map(function(block) {
            return BlockTree.generate(contentState, block, decorator);
        }));
    }
    /**
 * Generate tree map objects for a new decorator object, preserving any
 * decorations that are unchanged from the previous decorator.
 *
 * Note that in order for this to perform optimally, decoration Lists for
 * decorators should be preserved when possible to allow for direct immutable
 * List comparison.
 */
    function regenerateTreeForNewDecorator(content, blockMap, previousTreeMap, decorator, existingDecorator) {
        return previousTreeMap.merge(blockMap.toSeq().filter(function(block) {
            return decorator.getDecorations(block, content) !== existingDecorator.getDecorations(block, content);
        }).map(function(block) {
            return BlockTree.generate(content, block, decorator);
        }));
    }
    /**
 * Return whether a change should be considered a boundary state, given
 * the previous change type. Allows us to discard potential boundary states
 * during standard typing or deletion behavior.
 */
    function mustBecomeBoundary(editorState, changeType) {
        return changeType !== editorState.getLastChangeType() || "insert-characters" !== changeType && "backspace-character" !== changeType && "delete-character" !== changeType;
    }
    function getInlineStyleForCollapsedSelection(content, selection) {
        var startKey = selection.getStartKey(), startOffset = selection.getStartOffset(), startBlock = content.getBlockForKey(startKey);
        // If the cursor is not at the start of the block, look backward to
        // preserve the style of the preceding character.
        // If the cursor is not at the start of the block, look backward to
        // preserve the style of the preceding character.
        // The caret is at position zero in this block. If the block has any
        // text at all, use the style of the first character.
        return startOffset > 0 ? startBlock.getInlineStyleAt(startOffset - 1) : startBlock.getLength() ? startBlock.getInlineStyleAt(0) : lookUpwardForInlineStyle(content, startKey);
    }
    function getInlineStyleForNonCollapsedSelection(content, selection) {
        var startKey = selection.getStartKey(), startOffset = selection.getStartOffset(), startBlock = content.getBlockForKey(startKey);
        // If there is a character just inside the selection, use its style.
        // If there is a character just inside the selection, use its style.
        // Check if the selection at the end of a non-empty block. Use the last
        // style in the block.
        return startOffset < startBlock.getLength() ? startBlock.getInlineStyleAt(startOffset) : startOffset > 0 ? startBlock.getInlineStyleAt(startOffset - 1) : lookUpwardForInlineStyle(content, startKey);
    }
    function lookUpwardForInlineStyle(content, fromKey) {
        for (var previousLength, previousBlock = content.getBlockBefore(fromKey); previousBlock; ) {
            if (previousLength = previousBlock.getLength()) return previousBlock.getInlineStyleAt(previousLength - 1);
            previousBlock = content.getBlockBefore(previousBlock.getKey());
        }
        return OrderedSet();
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EditorState
 * 
 */
    var _assign = __webpack_require__(35), _extends = _assign || function(target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
        }
        return target;
    }, BlockTree = __webpack_require__(112), ContentState = __webpack_require__(81), EditorBidiService = __webpack_require__(189), Immutable = __webpack_require__(1), SelectionState = __webpack_require__(45), OrderedSet = Immutable.OrderedSet, Record = Immutable.Record, Stack = Immutable.Stack, defaultRecord = {
        allowUndo: !0,
        currentContent: null,
        decorator: null,
        directionMap: null,
        forceSelection: !1,
        inCompositionMode: !1,
        inlineStyleOverride: null,
        lastChangeType: null,
        nativelyRenderedContent: null,
        redoStack: Stack(),
        selection: null,
        treeMap: null,
        undoStack: Stack()
    }, EditorStateRecord = Record(defaultRecord), EditorState = function() {
        /**
   * Not for public consumption.
   */
        function EditorState(immutable) {
            _classCallCheck(this, EditorState), this._immutable = immutable;
        }
        /**
   * While editing, the user may apply inline style commands with a collapsed
   * cursor, intending to type text that adopts the specified style. In this
   * case, we track the specified style as an "override" that takes precedence
   * over the inline style of the text adjacent to the cursor.
   *
   * If null, there is no override in place.
   */
        /**
   * Get the appropriate inline style for the editor state. If an
   * override is in place, use it. Otherwise, the current style is
   * based on the location of the selection state.
   */
        /**
   * Incorporate native DOM selection changes into the EditorState. This
   * method can be used when we simply want to accept whatever the DOM
   * has given us to represent selection, and we do not need to re-render
   * the editor.
   *
   * To forcibly move the DOM selection, see `EditorState.forceSelection`.
   */
        /**
   * At times, we need to force the DOM selection to be where we
   * need it to be. This can occur when the anchor or focus nodes
   * are non-text nodes, for instance. In this case, we want to trigger
   * a re-render of the editor, which in turn forces selection into
   * the correct place in the DOM. The `forceSelection` method
   * accomplishes this.
   *
   * This method should be used in cases where you need to explicitly
   * move the DOM selection from one place to another without a change
   * in ContentState.
   */
        /**
   * Move selection to the end of the editor without forcing focus.
   */
        /**
   * Force focus to the end of the editor. This is useful in scenarios
   * where we want to programmatically focus the input and it makes sense
   * to allow the user to continue working seamlessly.
   */
        /**
   * Push the current ContentState onto the undo stack if it should be
   * considered a boundary state, and set the provided ContentState as the
   * new current content.
   */
        /**
   * Make the top ContentState in the undo stack the new current content and
   * push the current content onto the redo stack.
   */
        /**
   * Make the top ContentState in the redo stack the new current content and
   * push the current content onto the undo stack.
   */
        /**
   * Not for public consumption.
   */
        return EditorState.createEmpty = function(decorator) {
            return EditorState.createWithContent(ContentState.createFromText(""), decorator);
        }, EditorState.createWithContent = function(contentState, decorator) {
            var firstKey = contentState.getBlockMap().first().getKey();
            return EditorState.create({
                currentContent: contentState,
                undoStack: Stack(),
                redoStack: Stack(),
                decorator: decorator || null,
                selection: SelectionState.createEmpty(firstKey)
            });
        }, EditorState.create = function(config) {
            var currentContent = config.currentContent, decorator = config.decorator, recordConfig = _extends({}, config, {
                treeMap: generateNewTreeMap(currentContent, decorator),
                directionMap: EditorBidiService.getDirectionMap(currentContent)
            });
            return new EditorState(new EditorStateRecord(recordConfig));
        }, EditorState.set = function(editorState, put) {
            return new EditorState(editorState.getImmutable().withMutations(function(state) {
                var existingDecorator = state.get("decorator"), decorator = existingDecorator;
                null === put.decorator ? decorator = null : put.decorator && (decorator = put.decorator);
                var newContent = put.currentContent || editorState.getCurrentContent();
                if (decorator !== existingDecorator) {
                    var newTreeMap, treeMap = state.get("treeMap");
                    return newTreeMap = decorator && existingDecorator ? regenerateTreeForNewDecorator(newContent, newContent.getBlockMap(), treeMap, decorator, existingDecorator) : generateNewTreeMap(newContent, decorator), 
                    void state.merge({
                        decorator: decorator,
                        treeMap: newTreeMap,
                        nativelyRenderedContent: null
                    });
                }
                newContent !== editorState.getCurrentContent() && state.set("treeMap", regenerateTreeForNewBlocks(editorState, newContent.getBlockMap(), newContent.getEntityMap(), decorator)), 
                state.merge(put);
            }));
        }, EditorState.prototype.toJS = function() {
            return this.getImmutable().toJS();
        }, EditorState.prototype.getAllowUndo = function() {
            return this.getImmutable().get("allowUndo");
        }, EditorState.prototype.getCurrentContent = function() {
            return this.getImmutable().get("currentContent");
        }, EditorState.prototype.getUndoStack = function() {
            return this.getImmutable().get("undoStack");
        }, EditorState.prototype.getRedoStack = function() {
            return this.getImmutable().get("redoStack");
        }, EditorState.prototype.getSelection = function() {
            return this.getImmutable().get("selection");
        }, EditorState.prototype.getDecorator = function() {
            return this.getImmutable().get("decorator");
        }, EditorState.prototype.isInCompositionMode = function() {
            return this.getImmutable().get("inCompositionMode");
        }, EditorState.prototype.mustForceSelection = function() {
            return this.getImmutable().get("forceSelection");
        }, EditorState.prototype.getNativelyRenderedContent = function() {
            return this.getImmutable().get("nativelyRenderedContent");
        }, EditorState.prototype.getLastChangeType = function() {
            return this.getImmutable().get("lastChangeType");
        }, EditorState.prototype.getInlineStyleOverride = function() {
            return this.getImmutable().get("inlineStyleOverride");
        }, EditorState.setInlineStyleOverride = function(editorState, inlineStyleOverride) {
            return EditorState.set(editorState, {
                inlineStyleOverride: inlineStyleOverride
            });
        }, EditorState.prototype.getCurrentInlineStyle = function() {
            var override = this.getInlineStyleOverride();
            if (null != override) return override;
            var content = this.getCurrentContent(), selection = this.getSelection();
            return selection.isCollapsed() ? getInlineStyleForCollapsedSelection(content, selection) : getInlineStyleForNonCollapsedSelection(content, selection);
        }, EditorState.prototype.getBlockTree = function(blockKey) {
            return this.getImmutable().getIn([ "treeMap", blockKey ]);
        }, EditorState.prototype.isSelectionAtStartOfContent = function() {
            var firstKey = this.getCurrentContent().getBlockMap().first().getKey();
            return this.getSelection().hasEdgeWithin(firstKey, 0, 0);
        }, EditorState.prototype.isSelectionAtEndOfContent = function() {
            var content = this.getCurrentContent(), blockMap = content.getBlockMap(), last = blockMap.last(), end = last.getLength();
            return this.getSelection().hasEdgeWithin(last.getKey(), end, end);
        }, EditorState.prototype.getDirectionMap = function() {
            return this.getImmutable().get("directionMap");
        }, EditorState.acceptSelection = function(editorState, selection) {
            return updateSelection(editorState, selection, !1);
        }, EditorState.forceSelection = function(editorState, selection) {
            return selection.getHasFocus() || (selection = selection.set("hasFocus", !0)), updateSelection(editorState, selection, !0);
        }, EditorState.moveSelectionToEnd = function(editorState) {
            var content = editorState.getCurrentContent(), lastBlock = content.getLastBlock(), lastKey = lastBlock.getKey(), length = lastBlock.getLength();
            return EditorState.acceptSelection(editorState, new SelectionState({
                anchorKey: lastKey,
                anchorOffset: length,
                focusKey: lastKey,
                focusOffset: length,
                isBackward: !1
            }));
        }, EditorState.moveFocusToEnd = function(editorState) {
            var afterSelectionMove = EditorState.moveSelectionToEnd(editorState);
            return EditorState.forceSelection(afterSelectionMove, afterSelectionMove.getSelection());
        }, EditorState.push = function(editorState, contentState, changeType) {
            if (editorState.getCurrentContent() === contentState) return editorState;
            var forceSelection = "insert-characters" !== changeType, directionMap = EditorBidiService.getDirectionMap(contentState, editorState.getDirectionMap());
            if (!editorState.getAllowUndo()) return EditorState.set(editorState, {
                currentContent: contentState,
                directionMap: directionMap,
                lastChangeType: changeType,
                selection: contentState.getSelectionAfter(),
                forceSelection: forceSelection,
                inlineStyleOverride: null
            });
            var selection = editorState.getSelection(), currentContent = editorState.getCurrentContent(), undoStack = editorState.getUndoStack(), newContent = contentState;
            selection !== currentContent.getSelectionAfter() || mustBecomeBoundary(editorState, changeType) ? (undoStack = undoStack.push(currentContent), 
            newContent = newContent.set("selectionBefore", selection)) : "insert-characters" !== changeType && "backspace-character" !== changeType && "delete-character" !== changeType || (// Preserve the previous selection.
            newContent = newContent.set("selectionBefore", currentContent.getSelectionBefore()));
            var inlineStyleOverride = editorState.getInlineStyleOverride();
            -1 === [ "adjust-depth", "change-block-type", "split-block" ].indexOf(changeType) && (inlineStyleOverride = null);
            var editorStateChanges = {
                currentContent: newContent,
                directionMap: directionMap,
                undoStack: undoStack,
                redoStack: Stack(),
                lastChangeType: changeType,
                selection: contentState.getSelectionAfter(),
                forceSelection: forceSelection,
                inlineStyleOverride: inlineStyleOverride
            };
            return EditorState.set(editorState, editorStateChanges);
        }, EditorState.undo = function(editorState) {
            if (!editorState.getAllowUndo()) return editorState;
            var undoStack = editorState.getUndoStack(), newCurrentContent = undoStack.peek();
            if (!newCurrentContent) return editorState;
            var currentContent = editorState.getCurrentContent(), directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());
            return EditorState.set(editorState, {
                currentContent: newCurrentContent,
                directionMap: directionMap,
                undoStack: undoStack.shift(),
                redoStack: editorState.getRedoStack().push(currentContent),
                forceSelection: !0,
                inlineStyleOverride: null,
                lastChangeType: "undo",
                nativelyRenderedContent: null,
                selection: currentContent.getSelectionBefore()
            });
        }, EditorState.redo = function(editorState) {
            if (!editorState.getAllowUndo()) return editorState;
            var redoStack = editorState.getRedoStack(), newCurrentContent = redoStack.peek();
            if (!newCurrentContent) return editorState;
            var currentContent = editorState.getCurrentContent(), directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());
            return EditorState.set(editorState, {
                currentContent: newCurrentContent,
                directionMap: directionMap,
                undoStack: editorState.getUndoStack().push(currentContent),
                redoStack: redoStack.shift(),
                forceSelection: !0,
                inlineStyleOverride: null,
                lastChangeType: "redo",
                nativelyRenderedContent: null,
                selection: newCurrentContent.getSelectionAfter()
            });
        }, EditorState.prototype.getImmutable = function() {
            return this._immutable;
        }, EditorState;
    }();
    module.exports = EditorState;
}, /* 1 */
/***/
function(module, exports, __webpack_require__) {
    /**
 *  Copyright (c) 2014-2015, Facebook, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the BSD-style license found in the
 *  LICENSE file in the root directory of this source tree. An additional grant
 *  of patent rights can be found in the PATENTS file in the same directory.
 */
    !function(global, factory) {
        module.exports = factory();
    }(0, function() {
        "use strict";
        function createClass(ctor, superClass) {
            superClass && (ctor.prototype = Object.create(superClass.prototype)), ctor.prototype.constructor = ctor;
        }
        function Iterable(value) {
            return isIterable(value) ? value : Seq(value);
        }
        function KeyedIterable(value) {
            return isKeyed(value) ? value : KeyedSeq(value);
        }
        function IndexedIterable(value) {
            return isIndexed(value) ? value : IndexedSeq(value);
        }
        function SetIterable(value) {
            return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
        }
        function isIterable(maybeIterable) {
            return !(!maybeIterable || !maybeIterable[IS_ITERABLE_SENTINEL]);
        }
        function isKeyed(maybeKeyed) {
            return !(!maybeKeyed || !maybeKeyed[IS_KEYED_SENTINEL]);
        }
        function isIndexed(maybeIndexed) {
            return !(!maybeIndexed || !maybeIndexed[IS_INDEXED_SENTINEL]);
        }
        function isAssociative(maybeAssociative) {
            return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
        }
        function isOrdered(maybeOrdered) {
            return !(!maybeOrdered || !maybeOrdered[IS_ORDERED_SENTINEL]);
        }
        function MakeRef(ref) {
            return ref.value = !1, ref;
        }
        function SetRef(ref) {
            ref && (ref.value = !0);
        }
        // A function which returns a value representing an "owner" for transient writes
        // to tries. The return value will only ever equal itself, and will not equal
        // the return of any subsequent call of this function.
        function OwnerID() {}
        // http://jsperf.com/copy-array-inline
        function arrCopy(arr, offset) {
            offset = offset || 0;
            for (var len = Math.max(0, arr.length - offset), newArr = new Array(len), ii = 0; ii < len; ii++) newArr[ii] = arr[ii + offset];
            return newArr;
        }
        function ensureSize(iter) {
            return void 0 === iter.size && (iter.size = iter.__iterate(returnTrue)), iter.size;
        }
        function wrapIndex(iter, index) {
            // This implements "is array index" which the ECMAString spec defines as:
            //
            //     A String property name P is an array index if and only if
            //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
            //     to 2^32−1.
            //
            // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
            if ("number" != typeof index) {
                var uint32Index = index >>> 0;
                // N >>> 0 is shorthand for ToUint32
                if ("" + uint32Index !== index || 4294967295 === uint32Index) return NaN;
                index = uint32Index;
            }
            return index < 0 ? ensureSize(iter) + index : index;
        }
        function returnTrue() {
            return !0;
        }
        function wholeSlice(begin, end, size) {
            return (0 === begin || void 0 !== size && begin <= -size) && (void 0 === end || void 0 !== size && end >= size);
        }
        function resolveBegin(begin, size) {
            return resolveIndex(begin, size, 0);
        }
        function resolveEnd(end, size) {
            return resolveIndex(end, size, size);
        }
        function resolveIndex(index, size, defaultIndex) {
            return void 0 === index ? defaultIndex : index < 0 ? Math.max(0, size + index) : void 0 === size ? index : Math.min(size, index);
        }
        function Iterator(next) {
            this.next = next;
        }
        function iteratorValue(type, k, v, iteratorResult) {
            var value = 0 === type ? k : 1 === type ? v : [ k, v ];
            return iteratorResult ? iteratorResult.value = value : iteratorResult = {
                value: value,
                done: !1
            }, iteratorResult;
        }
        function iteratorDone() {
            return {
                value: void 0,
                done: !0
            };
        }
        function hasIterator(maybeIterable) {
            return !!getIteratorFn(maybeIterable);
        }
        function isIterator(maybeIterator) {
            return maybeIterator && "function" == typeof maybeIterator.next;
        }
        function getIterator(iterable) {
            var iteratorFn = getIteratorFn(iterable);
            return iteratorFn && iteratorFn.call(iterable);
        }
        function getIteratorFn(iterable) {
            var iteratorFn = iterable && (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL] || iterable[FAUX_ITERATOR_SYMBOL]);
            if ("function" == typeof iteratorFn) return iteratorFn;
        }
        function isArrayLike(value) {
            return value && "number" == typeof value.length;
        }
        function Seq(value) {
            return null === value || void 0 === value ? emptySequence() : isIterable(value) ? value.toSeq() : seqFromValue(value);
        }
        function KeyedSeq(value) {
            return null === value || void 0 === value ? emptySequence().toKeyedSeq() : isIterable(value) ? isKeyed(value) ? value.toSeq() : value.fromEntrySeq() : keyedSeqFromValue(value);
        }
        function IndexedSeq(value) {
            return null === value || void 0 === value ? emptySequence() : isIterable(value) ? isKeyed(value) ? value.entrySeq() : value.toIndexedSeq() : indexedSeqFromValue(value);
        }
        function SetSeq(value) {
            return (null === value || void 0 === value ? emptySequence() : isIterable(value) ? isKeyed(value) ? value.entrySeq() : value : indexedSeqFromValue(value)).toSetSeq();
        }
        function ArraySeq(array) {
            this._array = array, this.size = array.length;
        }
        function ObjectSeq(object) {
            var keys = Object.keys(object);
            this._object = object, this._keys = keys, this.size = keys.length;
        }
        function IterableSeq(iterable) {
            this._iterable = iterable, this.size = iterable.length || iterable.size;
        }
        function IteratorSeq(iterator) {
            this._iterator = iterator, this._iteratorCache = [];
        }
        // # pragma Helper functions
        function isSeq(maybeSeq) {
            return !(!maybeSeq || !maybeSeq[IS_SEQ_SENTINEL]);
        }
        function emptySequence() {
            return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
        }
        function keyedSeqFromValue(value) {
            var seq = Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() : isIterator(value) ? new IteratorSeq(value).fromEntrySeq() : hasIterator(value) ? new IterableSeq(value).fromEntrySeq() : "object" == typeof value ? new ObjectSeq(value) : void 0;
            if (!seq) throw new TypeError("Expected Array or iterable object of [k, v] entries, or keyed object: " + value);
            return seq;
        }
        function indexedSeqFromValue(value) {
            var seq = maybeIndexedSeqFromValue(value);
            if (!seq) throw new TypeError("Expected Array or iterable object of values: " + value);
            return seq;
        }
        function seqFromValue(value) {
            var seq = maybeIndexedSeqFromValue(value) || "object" == typeof value && new ObjectSeq(value);
            if (!seq) throw new TypeError("Expected Array or iterable object of values, or keyed object: " + value);
            return seq;
        }
        function maybeIndexedSeqFromValue(value) {
            return isArrayLike(value) ? new ArraySeq(value) : isIterator(value) ? new IteratorSeq(value) : hasIterator(value) ? new IterableSeq(value) : void 0;
        }
        function seqIterate(seq, fn, reverse, useKeys) {
            var cache = seq._cache;
            if (cache) {
                for (var maxIndex = cache.length - 1, ii = 0; ii <= maxIndex; ii++) {
                    var entry = cache[reverse ? maxIndex - ii : ii];
                    if (!1 === fn(entry[1], useKeys ? entry[0] : ii, seq)) return ii + 1;
                }
                return ii;
            }
            return seq.__iterateUncached(fn, reverse);
        }
        function seqIterator(seq, type, reverse, useKeys) {
            var cache = seq._cache;
            if (cache) {
                var maxIndex = cache.length - 1, ii = 0;
                return new Iterator(function() {
                    var entry = cache[reverse ? maxIndex - ii : ii];
                    return ii++ > maxIndex ? iteratorDone() : iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
                });
            }
            return seq.__iteratorUncached(type, reverse);
        }
        function fromJS(json, converter) {
            return converter ? fromJSWith(converter, json, "", {
                "": json
            }) : fromJSDefault(json);
        }
        function fromJSWith(converter, json, key, parentJSON) {
            return Array.isArray(json) ? converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k) {
                return fromJSWith(converter, v, k, json);
            })) : isPlainObj(json) ? converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k) {
                return fromJSWith(converter, v, k, json);
            })) : json;
        }
        function fromJSDefault(json) {
            return Array.isArray(json) ? IndexedSeq(json).map(fromJSDefault).toList() : isPlainObj(json) ? KeyedSeq(json).map(fromJSDefault).toMap() : json;
        }
        function isPlainObj(value) {
            return value && (value.constructor === Object || void 0 === value.constructor);
        }
        /**
   * An extension of the "same-value" algorithm as [described for use by ES6 Map
   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
   *
   * NaN is considered the same as NaN, however -0 and 0 are considered the same
   * value, which is different from the algorithm described by
   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
   *
   * This is extended further to allow Objects to describe the values they
   * represent, by way of `valueOf` or `equals` (and `hashCode`).
   *
   * Note: because of this extension, the key equality of Immutable.Map and the
   * value equality of Immutable.Set will differ from ES6 Map and Set.
   *
   * ### Defining custom values
   *
   * The easiest way to describe the value an object represents is by implementing
   * `valueOf`. For example, `Date` represents a value by returning a unix
   * timestamp for `valueOf`:
   *
   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
   *     var date2 = new Date(1234567890000);
   *     date1.valueOf(); // 1234567890000
   *     assert( date1 !== date2 );
   *     assert( Immutable.is( date1, date2 ) );
   *
   * Note: overriding `valueOf` may have other implications if you use this object
   * where JavaScript expects a primitive, such as implicit string coercion.
   *
   * For more complex types, especially collections, implementing `valueOf` may
   * not be performant. An alternative is to implement `equals` and `hashCode`.
   *
   * `equals` takes another object, presumably of similar type, and returns true
   * if the it is equal. Equality is symmetrical, so the same result should be
   * returned if this and the argument are flipped.
   *
   *     assert( a.equals(b) === b.equals(a) );
   *
   * `hashCode` returns a 32bit integer number representing the object which will
   * be used to determine how to store the value object in a Map or Set. You must
   * provide both or neither methods, one must not exist without the other.
   *
   * Also, an important relationship between these methods must be upheld: if two
   * values are equal, they *must* return the same hashCode. If the values are not
   * equal, they might have the same hashCode; this is called a hash collision,
   * and while undesirable for performance reasons, it is acceptable.
   *
   *     if (a.equals(b)) {
   *       assert( a.hashCode() === b.hashCode() );
   *     }
   *
   * All Immutable collections implement `equals` and `hashCode`.
   *
   */
        function is(valueA, valueB) {
            if (valueA === valueB || valueA !== valueA && valueB !== valueB) return !0;
            if (!valueA || !valueB) return !1;
            if ("function" == typeof valueA.valueOf && "function" == typeof valueB.valueOf) {
                if (valueA = valueA.valueOf(), valueB = valueB.valueOf(), valueA === valueB || valueA !== valueA && valueB !== valueB) return !0;
                if (!valueA || !valueB) return !1;
            }
            return !("function" != typeof valueA.equals || "function" != typeof valueB.equals || !valueA.equals(valueB));
        }
        function deepEqual(a, b) {
            if (a === b) return !0;
            if (!isIterable(b) || void 0 !== a.size && void 0 !== b.size && a.size !== b.size || void 0 !== a.__hash && void 0 !== b.__hash && a.__hash !== b.__hash || isKeyed(a) !== isKeyed(b) || isIndexed(a) !== isIndexed(b) || isOrdered(a) !== isOrdered(b)) return !1;
            if (0 === a.size && 0 === b.size) return !0;
            var notAssociative = !isAssociative(a);
            if (isOrdered(a)) {
                var entries = a.entries();
                return b.every(function(v, k) {
                    var entry = entries.next().value;
                    return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
                }) && entries.next().done;
            }
            var flipped = !1;
            if (void 0 === a.size) if (void 0 === b.size) "function" == typeof a.cacheResult && a.cacheResult(); else {
                flipped = !0;
                var _ = a;
                a = b, b = _;
            }
            var allEqual = !0, bSize = b.__iterate(function(v, k) {
                if (notAssociative ? !a.has(v) : flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) return allEqual = !1, 
                !1;
            });
            return allEqual && a.size === bSize;
        }
        function Repeat(value, times) {
            if (!(this instanceof Repeat)) return new Repeat(value, times);
            if (this._value = value, this.size = void 0 === times ? 1 / 0 : Math.max(0, times), 
            0 === this.size) {
                if (EMPTY_REPEAT) return EMPTY_REPEAT;
                EMPTY_REPEAT = this;
            }
        }
        function invariant(condition, error) {
            if (!condition) throw new Error(error);
        }
        function Range(start, end, step) {
            if (!(this instanceof Range)) return new Range(start, end, step);
            if (invariant(0 !== step, "Cannot step a Range by 0"), start = start || 0, void 0 === end && (end = 1 / 0), 
            step = void 0 === step ? 1 : Math.abs(step), end < start && (step = -step), this._start = start, 
            this._end = end, this._step = step, this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1), 
            0 === this.size) {
                if (EMPTY_RANGE) return EMPTY_RANGE;
                EMPTY_RANGE = this;
            }
        }
        function Collection() {
            throw TypeError("Abstract");
        }
        function KeyedCollection() {}
        function IndexedCollection() {}
        function SetCollection() {}
        // v8 has an optimization for storing 31-bit signed numbers.
        // Values which have either 00 or 11 as the high order bits qualify.
        // This function drops the highest order bit in a signed number, maintaining
        // the sign bit.
        function smi(i32) {
            return i32 >>> 1 & 1073741824 | 3221225471 & i32;
        }
        function hash(o) {
            if (!1 === o || null === o || void 0 === o) return 0;
            if ("function" == typeof o.valueOf && (!1 === (o = o.valueOf()) || null === o || void 0 === o)) return 0;
            if (!0 === o) return 1;
            var type = typeof o;
            if ("number" === type) {
                var h = 0 | o;
                for (h !== o && (h ^= 4294967295 * o); o > 4294967295; ) o /= 4294967295, h ^= o;
                return smi(h);
            }
            if ("string" === type) return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
            if ("function" == typeof o.hashCode) return o.hashCode();
            if ("object" === type) return hashJSObj(o);
            if ("function" == typeof o.toString) return hashString(o.toString());
            throw new Error("Value type " + type + " cannot be hashed.");
        }
        function cachedHashString(string) {
            var hash = stringHashCache[string];
            return void 0 === hash && (hash = hashString(string), STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE && (STRING_HASH_CACHE_SIZE = 0, 
            stringHashCache = {}), STRING_HASH_CACHE_SIZE++, stringHashCache[string] = hash), 
            hash;
        }
        // http://jsperf.com/hashing-strings
        function hashString(string) {
            for (var hash = 0, ii = 0; ii < string.length; ii++) hash = 31 * hash + string.charCodeAt(ii) | 0;
            return smi(hash);
        }
        function hashJSObj(obj) {
            var hash;
            if (usingWeakMap && void 0 !== (hash = weakMap.get(obj))) return hash;
            if (void 0 !== (hash = obj[UID_HASH_KEY])) return hash;
            if (!canDefineProperty) {
                if (void 0 !== (hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY])) return hash;
                if (void 0 !== (hash = getIENodeHash(obj))) return hash;
            }
            if (hash = ++objHashUID, 1073741824 & objHashUID && (objHashUID = 0), usingWeakMap) weakMap.set(obj, hash); else {
                if (void 0 !== isExtensible && !1 === isExtensible(obj)) throw new Error("Non-extensible objects are not allowed as keys.");
                if (canDefineProperty) Object.defineProperty(obj, UID_HASH_KEY, {
                    enumerable: !1,
                    configurable: !1,
                    writable: !1,
                    value: hash
                }); else if (void 0 !== obj.propertyIsEnumerable && obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) // Since we can't define a non-enumerable property on the object
                // we'll hijack one of the less-used non-enumerable properties to
                // save our hash on it. Since this is a function it will not show up in
                // `JSON.stringify` which is what we want.
                obj.propertyIsEnumerable = function() {
                    return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
                }, obj.propertyIsEnumerable[UID_HASH_KEY] = hash; else {
                    if (void 0 === obj.nodeType) throw new Error("Unable to set a non-enumerable property on object.");
                    // At this point we couldn't get the IE `uniqueID` to use as a hash
                    // and we couldn't use a non-enumerable property to exploit the
                    // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
                    // itself.
                    obj[UID_HASH_KEY] = hash;
                }
            }
            return hash;
        }
        // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
        // and avoid memory leaks from the IE cloneNode bug.
        function getIENodeHash(node) {
            if (node && node.nodeType > 0) switch (node.nodeType) {
              case 1:
                // Element
                return node.uniqueID;

              case 9:
                // Document
                return node.documentElement && node.documentElement.uniqueID;
            }
        }
        function assertNotInfinite(size) {
            invariant(size !== 1 / 0, "Cannot perform this action with an infinite size.");
        }
        // @pragma Construction
        function Map(value) {
            return null === value || void 0 === value ? emptyMap() : isMap(value) && !isOrdered(value) ? value : emptyMap().withMutations(function(map) {
                var iter = KeyedIterable(value);
                assertNotInfinite(iter.size), iter.forEach(function(v, k) {
                    return map.set(k, v);
                });
            });
        }
        function isMap(maybeMap) {
            return !(!maybeMap || !maybeMap[IS_MAP_SENTINEL]);
        }
        // #pragma Trie Nodes
        function ArrayMapNode(ownerID, entries) {
            this.ownerID = ownerID, this.entries = entries;
        }
        function BitmapIndexedNode(ownerID, bitmap, nodes) {
            this.ownerID = ownerID, this.bitmap = bitmap, this.nodes = nodes;
        }
        function HashArrayMapNode(ownerID, count, nodes) {
            this.ownerID = ownerID, this.count = count, this.nodes = nodes;
        }
        function HashCollisionNode(ownerID, keyHash, entries) {
            this.ownerID = ownerID, this.keyHash = keyHash, this.entries = entries;
        }
        function ValueNode(ownerID, keyHash, entry) {
            this.ownerID = ownerID, this.keyHash = keyHash, this.entry = entry;
        }
        function MapIterator(map, type, reverse) {
            this._type = type, this._reverse = reverse, this._stack = map._root && mapIteratorFrame(map._root);
        }
        function mapIteratorValue(type, entry) {
            return iteratorValue(type, entry[0], entry[1]);
        }
        function mapIteratorFrame(node, prev) {
            return {
                node: node,
                index: 0,
                __prev: prev
            };
        }
        function makeMap(size, root, ownerID, hash) {
            var map = Object.create(MapPrototype);
            return map.size = size, map._root = root, map.__ownerID = ownerID, map.__hash = hash, 
            map.__altered = !1, map;
        }
        function emptyMap() {
            return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
        }
        function updateMap(map, k, v) {
            var newRoot, newSize;
            if (map._root) {
                var didChangeSize = MakeRef(CHANGE_LENGTH), didAlter = MakeRef(DID_ALTER);
                if (newRoot = updateNode(map._root, map.__ownerID, 0, void 0, k, v, didChangeSize, didAlter), 
                !didAlter.value) return map;
                newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
            } else {
                if (v === NOT_SET) return map;
                newSize = 1, newRoot = new ArrayMapNode(map.__ownerID, [ [ k, v ] ]);
            }
            return map.__ownerID ? (map.size = newSize, map._root = newRoot, map.__hash = void 0, 
            map.__altered = !0, map) : newRoot ? makeMap(newSize, newRoot) : emptyMap();
        }
        function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
            return node ? node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) : value === NOT_SET ? node : (SetRef(didAlter), 
            SetRef(didChangeSize), new ValueNode(ownerID, keyHash, [ key, value ]));
        }
        function isLeafNode(node) {
            return node.constructor === ValueNode || node.constructor === HashCollisionNode;
        }
        function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
            if (node.keyHash === keyHash) return new HashCollisionNode(ownerID, keyHash, [ node.entry, entry ]);
            var newNode, idx1 = (0 === shift ? node.keyHash : node.keyHash >>> shift) & MASK, idx2 = (0 === shift ? keyHash : keyHash >>> shift) & MASK;
            return new BitmapIndexedNode(ownerID, 1 << idx1 | 1 << idx2, idx1 === idx2 ? [ mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry) ] : (newNode = new ValueNode(ownerID, keyHash, entry), 
            idx1 < idx2 ? [ node, newNode ] : [ newNode, node ]));
        }
        function createNodes(ownerID, entries, key, value) {
            ownerID || (ownerID = new OwnerID());
            for (var node = new ValueNode(ownerID, hash(key), [ key, value ]), ii = 0; ii < entries.length; ii++) {
                var entry = entries[ii];
                node = node.update(ownerID, 0, void 0, entry[0], entry[1]);
            }
            return node;
        }
        function packNodes(ownerID, nodes, count, excluding) {
            for (var bitmap = 0, packedII = 0, packedNodes = new Array(count), ii = 0, bit = 1, len = nodes.length; ii < len; ii++, 
            bit <<= 1) {
                var node = nodes[ii];
                void 0 !== node && ii !== excluding && (bitmap |= bit, packedNodes[packedII++] = node);
            }
            return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
        }
        function expandNodes(ownerID, nodes, bitmap, including, node) {
            for (var count = 0, expandedNodes = new Array(SIZE), ii = 0; 0 !== bitmap; ii++, 
            bitmap >>>= 1) expandedNodes[ii] = 1 & bitmap ? nodes[count++] : void 0;
            return expandedNodes[including] = node, new HashArrayMapNode(ownerID, count + 1, expandedNodes);
        }
        function mergeIntoMapWith(map, merger, iterables) {
            for (var iters = [], ii = 0; ii < iterables.length; ii++) {
                var value = iterables[ii], iter = KeyedIterable(value);
                isIterable(value) || (iter = iter.map(function(v) {
                    return fromJS(v);
                })), iters.push(iter);
            }
            return mergeIntoCollectionWith(map, merger, iters);
        }
        function deepMerger(existing, value, key) {
            return existing && existing.mergeDeep && isIterable(value) ? existing.mergeDeep(value) : is(existing, value) ? existing : value;
        }
        function deepMergerWith(merger) {
            return function(existing, value, key) {
                if (existing && existing.mergeDeepWith && isIterable(value)) return existing.mergeDeepWith(merger, value);
                var nextValue = merger(existing, value, key);
                return is(existing, nextValue) ? existing : nextValue;
            };
        }
        function mergeIntoCollectionWith(collection, merger, iters) {
            return iters = iters.filter(function(x) {
                return 0 !== x.size;
            }), 0 === iters.length ? collection : 0 !== collection.size || collection.__ownerID || 1 !== iters.length ? collection.withMutations(function(collection) {
                for (var mergeIntoMap = merger ? function(value, key) {
                    collection.update(key, NOT_SET, function(existing) {
                        return existing === NOT_SET ? value : merger(existing, value, key);
                    });
                } : function(value, key) {
                    collection.set(key, value);
                }, ii = 0; ii < iters.length; ii++) iters[ii].forEach(mergeIntoMap);
            }) : collection.constructor(iters[0]);
        }
        function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
            var isNotSet = existing === NOT_SET, step = keyPathIter.next();
            if (step.done) {
                var existingValue = isNotSet ? notSetValue : existing, newValue = updater(existingValue);
                return newValue === existingValue ? existing : newValue;
            }
            invariant(isNotSet || existing && existing.set, "invalid keyPath");
            var key = step.value, nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET), nextUpdated = updateInDeepMap(nextExisting, keyPathIter, notSetValue, updater);
            return nextUpdated === nextExisting ? existing : nextUpdated === NOT_SET ? existing.remove(key) : (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
        }
        function popCount(x) {
            return x -= x >> 1 & 1431655765, x = (858993459 & x) + (x >> 2 & 858993459), x = x + (x >> 4) & 252645135, 
            x += x >> 8, 127 & (x += x >> 16);
        }
        function setIn(array, idx, val, canEdit) {
            var newArray = canEdit ? array : arrCopy(array);
            return newArray[idx] = val, newArray;
        }
        function spliceIn(array, idx, val, canEdit) {
            var newLen = array.length + 1;
            if (canEdit && idx + 1 === newLen) return array[idx] = val, array;
            for (var newArray = new Array(newLen), after = 0, ii = 0; ii < newLen; ii++) ii === idx ? (newArray[ii] = val, 
            after = -1) : newArray[ii] = array[ii + after];
            return newArray;
        }
        function spliceOut(array, idx, canEdit) {
            var newLen = array.length - 1;
            if (canEdit && idx === newLen) return array.pop(), array;
            for (var newArray = new Array(newLen), after = 0, ii = 0; ii < newLen; ii++) ii === idx && (after = 1), 
            newArray[ii] = array[ii + after];
            return newArray;
        }
        // @pragma Construction
        function List(value) {
            var empty = emptyList();
            if (null === value || void 0 === value) return empty;
            if (isList(value)) return value;
            var iter = IndexedIterable(value), size = iter.size;
            return 0 === size ? empty : (assertNotInfinite(size), size > 0 && size < SIZE ? makeList(0, size, SHIFT, null, new VNode(iter.toArray())) : empty.withMutations(function(list) {
                list.setSize(size), iter.forEach(function(v, i) {
                    return list.set(i, v);
                });
            }));
        }
        function isList(maybeList) {
            return !(!maybeList || !maybeList[IS_LIST_SENTINEL]);
        }
        function VNode(array, ownerID) {
            this.array = array, this.ownerID = ownerID;
        }
        function iterateList(list, reverse) {
            function iterateNodeOrLeaf(node, level, offset) {
                return 0 === level ? iterateLeaf(node, offset) : iterateNode(node, level, offset);
            }
            function iterateLeaf(node, offset) {
                var array = offset === tailPos ? tail && tail.array : node && node.array, from = offset > left ? 0 : left - offset, to = right - offset;
                return to > SIZE && (to = SIZE), function() {
                    if (from === to) return DONE;
                    var idx = reverse ? --to : from++;
                    return array && array[idx];
                };
            }
            function iterateNode(node, level, offset) {
                var values, array = node && node.array, from = offset > left ? 0 : left - offset >> level, to = 1 + (right - offset >> level);
                return to > SIZE && (to = SIZE), function() {
                    for (;;) {
                        if (values) {
                            var value = values();
                            if (value !== DONE) return value;
                            values = null;
                        }
                        if (from === to) return DONE;
                        var idx = reverse ? --to : from++;
                        values = iterateNodeOrLeaf(array && array[idx], level - SHIFT, offset + (idx << level));
                    }
                };
            }
            var left = list._origin, right = list._capacity, tailPos = getTailOffset(right), tail = list._tail;
            return iterateNodeOrLeaf(list._root, list._level, 0);
        }
        function makeList(origin, capacity, level, root, tail, ownerID, hash) {
            var list = Object.create(ListPrototype);
            return list.size = capacity - origin, list._origin = origin, list._capacity = capacity, 
            list._level = level, list._root = root, list._tail = tail, list.__ownerID = ownerID, 
            list.__hash = hash, list.__altered = !1, list;
        }
        function emptyList() {
            return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
        }
        function updateList(list, index, value) {
            if ((index = wrapIndex(list, index)) !== index) return list;
            if (index >= list.size || index < 0) return list.withMutations(function(list) {
                index < 0 ? setListBounds(list, index).set(0, value) : setListBounds(list, 0, index + 1).set(index, value);
            });
            index += list._origin;
            var newTail = list._tail, newRoot = list._root, didAlter = MakeRef(DID_ALTER);
            return index >= getTailOffset(list._capacity) ? newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter) : newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter), 
            didAlter.value ? list.__ownerID ? (list._root = newRoot, list._tail = newTail, list.__hash = void 0, 
            list.__altered = !0, list) : makeList(list._origin, list._capacity, list._level, newRoot, newTail) : list;
        }
        function updateVNode(node, ownerID, level, index, value, didAlter) {
            var idx = index >>> level & MASK, nodeHas = node && idx < node.array.length;
            if (!nodeHas && void 0 === value) return node;
            var newNode;
            if (level > 0) {
                var lowerNode = node && node.array[idx], newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
                return newLowerNode === lowerNode ? node : (newNode = editableVNode(node, ownerID), 
                newNode.array[idx] = newLowerNode, newNode);
            }
            return nodeHas && node.array[idx] === value ? node : (SetRef(didAlter), newNode = editableVNode(node, ownerID), 
            void 0 === value && idx === newNode.array.length - 1 ? newNode.array.pop() : newNode.array[idx] = value, 
            newNode);
        }
        function editableVNode(node, ownerID) {
            return ownerID && node && ownerID === node.ownerID ? node : new VNode(node ? node.array.slice() : [], ownerID);
        }
        function listNodeFor(list, rawIndex) {
            if (rawIndex >= getTailOffset(list._capacity)) return list._tail;
            if (rawIndex < 1 << list._level + SHIFT) {
                for (var node = list._root, level = list._level; node && level > 0; ) node = node.array[rawIndex >>> level & MASK], 
                level -= SHIFT;
                return node;
            }
        }
        function setListBounds(list, begin, end) {
            // Sanitize begin & end using this shorthand for ToInt32(argument)
            // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
            void 0 !== begin && (begin |= 0), void 0 !== end && (end |= 0);
            var owner = list.__ownerID || new OwnerID(), oldOrigin = list._origin, oldCapacity = list._capacity, newOrigin = oldOrigin + begin, newCapacity = void 0 === end ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
            if (newOrigin === oldOrigin && newCapacity === oldCapacity) return list;
            // If it's going to end after it starts, it's empty.
            if (newOrigin >= newCapacity) return list.clear();
            for (var newLevel = list._level, newRoot = list._root, offsetShift = 0; newOrigin + offsetShift < 0; ) newRoot = new VNode(newRoot && newRoot.array.length ? [ void 0, newRoot ] : [], owner), 
            newLevel += SHIFT, offsetShift += 1 << newLevel;
            offsetShift && (newOrigin += offsetShift, oldOrigin += offsetShift, newCapacity += offsetShift, 
            oldCapacity += offsetShift);
            // New size might need creating a higher root.
            for (var oldTailOffset = getTailOffset(oldCapacity), newTailOffset = getTailOffset(newCapacity); newTailOffset >= 1 << newLevel + SHIFT; ) newRoot = new VNode(newRoot && newRoot.array.length ? [ newRoot ] : [], owner), 
            newLevel += SHIFT;
            // Locate or create the new tail.
            var oldTail = list._tail, newTail = newTailOffset < oldTailOffset ? listNodeFor(list, newCapacity - 1) : newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
            // Merge Tail into tree.
            if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
                newRoot = editableVNode(newRoot, owner);
                for (var node = newRoot, level = newLevel; level > SHIFT; level -= SHIFT) {
                    var idx = oldTailOffset >>> level & MASK;
                    node = node.array[idx] = editableVNode(node.array[idx], owner);
                }
                node.array[oldTailOffset >>> SHIFT & MASK] = oldTail;
            }
            // If the new origin is within the tail, then we do not need a root.
            if (// If the size has been reduced, there's a chance the tail needs to be trimmed.
            newCapacity < oldCapacity && (newTail = newTail && newTail.removeAfter(owner, 0, newCapacity)), 
            newOrigin >= newTailOffset) newOrigin -= newTailOffset, newCapacity -= newTailOffset, 
            newLevel = SHIFT, newRoot = null, newTail = newTail && newTail.removeBefore(owner, 0, newOrigin); else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
                // Identify the new top root node of the subtree of the old root.
                for (offsetShift = 0; newRoot; ) {
                    var beginIndex = newOrigin >>> newLevel & MASK;
                    if (beginIndex !== newTailOffset >>> newLevel & MASK) break;
                    beginIndex && (offsetShift += (1 << newLevel) * beginIndex), newLevel -= SHIFT, 
                    newRoot = newRoot.array[beginIndex];
                }
                // Trim the new sides of the new root.
                newRoot && newOrigin > oldOrigin && (newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift)), 
                newRoot && newTailOffset < oldTailOffset && (newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift)), 
                offsetShift && (newOrigin -= offsetShift, newCapacity -= offsetShift);
            }
            return list.__ownerID ? (list.size = newCapacity - newOrigin, list._origin = newOrigin, 
            list._capacity = newCapacity, list._level = newLevel, list._root = newRoot, list._tail = newTail, 
            list.__hash = void 0, list.__altered = !0, list) : makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
        }
        function mergeIntoListWith(list, merger, iterables) {
            for (var iters = [], maxSize = 0, ii = 0; ii < iterables.length; ii++) {
                var value = iterables[ii], iter = IndexedIterable(value);
                iter.size > maxSize && (maxSize = iter.size), isIterable(value) || (iter = iter.map(function(v) {
                    return fromJS(v);
                })), iters.push(iter);
            }
            return maxSize > list.size && (list = list.setSize(maxSize)), mergeIntoCollectionWith(list, merger, iters);
        }
        function getTailOffset(size) {
            return size < SIZE ? 0 : size - 1 >>> SHIFT << SHIFT;
        }
        // @pragma Construction
        function OrderedMap(value) {
            return null === value || void 0 === value ? emptyOrderedMap() : isOrderedMap(value) ? value : emptyOrderedMap().withMutations(function(map) {
                var iter = KeyedIterable(value);
                assertNotInfinite(iter.size), iter.forEach(function(v, k) {
                    return map.set(k, v);
                });
            });
        }
        function isOrderedMap(maybeOrderedMap) {
            return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
        }
        function makeOrderedMap(map, list, ownerID, hash) {
            var omap = Object.create(OrderedMap.prototype);
            return omap.size = map ? map.size : 0, omap._map = map, omap._list = list, omap.__ownerID = ownerID, 
            omap.__hash = hash, omap;
        }
        function emptyOrderedMap() {
            return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
        }
        function updateOrderedMap(omap, k, v) {
            var newMap, newList, map = omap._map, list = omap._list, i = map.get(k), has = void 0 !== i;
            if (v === NOT_SET) {
                // removed
                if (!has) return omap;
                list.size >= SIZE && list.size >= 2 * map.size ? (newList = list.filter(function(entry, idx) {
                    return void 0 !== entry && i !== idx;
                }), newMap = newList.toKeyedSeq().map(function(entry) {
                    return entry[0];
                }).flip().toMap(), omap.__ownerID && (newMap.__ownerID = newList.__ownerID = omap.__ownerID)) : (newMap = map.remove(k), 
                newList = i === list.size - 1 ? list.pop() : list.set(i, void 0));
            } else if (has) {
                if (v === list.get(i)[1]) return omap;
                newMap = map, newList = list.set(i, [ k, v ]);
            } else newMap = map.set(k, list.size), newList = list.set(list.size, [ k, v ]);
            return omap.__ownerID ? (omap.size = newMap.size, omap._map = newMap, omap._list = newList, 
            omap.__hash = void 0, omap) : makeOrderedMap(newMap, newList);
        }
        function ToKeyedSequence(indexed, useKeys) {
            this._iter = indexed, this._useKeys = useKeys, this.size = indexed.size;
        }
        function ToIndexedSequence(iter) {
            this._iter = iter, this.size = iter.size;
        }
        function ToSetSequence(iter) {
            this._iter = iter, this.size = iter.size;
        }
        function FromEntriesSequence(entries) {
            this._iter = entries, this.size = entries.size;
        }
        function flipFactory(iterable) {
            var flipSequence = makeSequence(iterable);
            return flipSequence._iter = iterable, flipSequence.size = iterable.size, flipSequence.flip = function() {
                return iterable;
            }, flipSequence.reverse = function() {
                var reversedSequence = iterable.reverse.apply(this);
                // super.reverse()
                return reversedSequence.flip = function() {
                    return iterable.reverse();
                }, reversedSequence;
            }, flipSequence.has = function(key) {
                return iterable.includes(key);
            }, flipSequence.includes = function(key) {
                return iterable.has(key);
            }, flipSequence.cacheResult = cacheResultThrough, flipSequence.__iterateUncached = function(fn, reverse) {
                var this$0 = this;
                return iterable.__iterate(function(v, k) {
                    return !1 !== fn(k, v, this$0);
                }, reverse);
            }, flipSequence.__iteratorUncached = function(type, reverse) {
                if (type === ITERATE_ENTRIES) {
                    var iterator = iterable.__iterator(type, reverse);
                    return new Iterator(function() {
                        var step = iterator.next();
                        if (!step.done) {
                            var k = step.value[0];
                            step.value[0] = step.value[1], step.value[1] = k;
                        }
                        return step;
                    });
                }
                return iterable.__iterator(type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES, reverse);
            }, flipSequence;
        }
        function mapFactory(iterable, mapper, context) {
            var mappedSequence = makeSequence(iterable);
            return mappedSequence.size = iterable.size, mappedSequence.has = function(key) {
                return iterable.has(key);
            }, mappedSequence.get = function(key, notSetValue) {
                var v = iterable.get(key, NOT_SET);
                return v === NOT_SET ? notSetValue : mapper.call(context, v, key, iterable);
            }, mappedSequence.__iterateUncached = function(fn, reverse) {
                var this$0 = this;
                return iterable.__iterate(function(v, k, c) {
                    return !1 !== fn(mapper.call(context, v, k, c), k, this$0);
                }, reverse);
            }, mappedSequence.__iteratorUncached = function(type, reverse) {
                var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
                return new Iterator(function() {
                    var step = iterator.next();
                    if (step.done) return step;
                    var entry = step.value, key = entry[0];
                    return iteratorValue(type, key, mapper.call(context, entry[1], key, iterable), step);
                });
            }, mappedSequence;
        }
        function reverseFactory(iterable, useKeys) {
            var reversedSequence = makeSequence(iterable);
            return reversedSequence._iter = iterable, reversedSequence.size = iterable.size, 
            reversedSequence.reverse = function() {
                return iterable;
            }, iterable.flip && (reversedSequence.flip = function() {
                var flipSequence = flipFactory(iterable);
                return flipSequence.reverse = function() {
                    return iterable.flip();
                }, flipSequence;
            }), reversedSequence.get = function(key, notSetValue) {
                return iterable.get(useKeys ? key : -1 - key, notSetValue);
            }, reversedSequence.has = function(key) {
                return iterable.has(useKeys ? key : -1 - key);
            }, reversedSequence.includes = function(value) {
                return iterable.includes(value);
            }, reversedSequence.cacheResult = cacheResultThrough, reversedSequence.__iterate = function(fn, reverse) {
                var this$0 = this;
                return iterable.__iterate(function(v, k) {
                    return fn(v, k, this$0);
                }, !reverse);
            }, reversedSequence.__iterator = function(type, reverse) {
                return iterable.__iterator(type, !reverse);
            }, reversedSequence;
        }
        function filterFactory(iterable, predicate, context, useKeys) {
            var filterSequence = makeSequence(iterable);
            return useKeys && (filterSequence.has = function(key) {
                var v = iterable.get(key, NOT_SET);
                return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
            }, filterSequence.get = function(key, notSetValue) {
                var v = iterable.get(key, NOT_SET);
                return v !== NOT_SET && predicate.call(context, v, key, iterable) ? v : notSetValue;
            }), filterSequence.__iterateUncached = function(fn, reverse) {
                var this$0 = this, iterations = 0;
                return iterable.__iterate(function(v, k, c) {
                    if (predicate.call(context, v, k, c)) return iterations++, fn(v, useKeys ? k : iterations - 1, this$0);
                }, reverse), iterations;
            }, filterSequence.__iteratorUncached = function(type, reverse) {
                var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse), iterations = 0;
                return new Iterator(function() {
                    for (;;) {
                        var step = iterator.next();
                        if (step.done) return step;
                        var entry = step.value, key = entry[0], value = entry[1];
                        if (predicate.call(context, value, key, iterable)) return iteratorValue(type, useKeys ? key : iterations++, value, step);
                    }
                });
            }, filterSequence;
        }
        function countByFactory(iterable, grouper, context) {
            var groups = Map().asMutable();
            return iterable.__iterate(function(v, k) {
                groups.update(grouper.call(context, v, k, iterable), 0, function(a) {
                    return a + 1;
                });
            }), groups.asImmutable();
        }
        function groupByFactory(iterable, grouper, context) {
            var isKeyedIter = isKeyed(iterable), groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
            iterable.__iterate(function(v, k) {
                groups.update(grouper.call(context, v, k, iterable), function(a) {
                    return a = a || [], a.push(isKeyedIter ? [ k, v ] : v), a;
                });
            });
            var coerce = iterableClass(iterable);
            return groups.map(function(arr) {
                return reify(iterable, coerce(arr));
            });
        }
        function sliceFactory(iterable, begin, end, useKeys) {
            var originalSize = iterable.size;
            if (// Sanitize begin & end using this shorthand for ToInt32(argument)
            // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
            void 0 !== begin && (begin |= 0), void 0 !== end && (end |= 0), wholeSlice(begin, end, originalSize)) return iterable;
            var resolvedBegin = resolveBegin(begin, originalSize), resolvedEnd = resolveEnd(end, originalSize);
            // begin or end will be NaN if they were provided as negative numbers and
            // this iterable's size is unknown. In that case, cache first so there is
            // a known size and these do not resolve to NaN.
            if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
            // Note: resolvedEnd is undefined when the original sequence's length is
            // unknown and this slice did not supply an end and should contain all
            // elements after resolvedBegin.
            // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
            var sliceSize, resolvedSize = resolvedEnd - resolvedBegin;
            resolvedSize === resolvedSize && (sliceSize = resolvedSize < 0 ? 0 : resolvedSize);
            var sliceSeq = makeSequence(iterable);
            // If iterable.size is undefined, the size of the realized sliceSeq is
            // unknown at this point unless the number of items to slice is 0
            return sliceSeq.size = 0 === sliceSize ? sliceSize : iterable.size && sliceSize || void 0, 
            !useKeys && isSeq(iterable) && sliceSize >= 0 && (sliceSeq.get = function(index, notSetValue) {
                return index = wrapIndex(this, index), index >= 0 && index < sliceSize ? iterable.get(index + resolvedBegin, notSetValue) : notSetValue;
            }), sliceSeq.__iterateUncached = function(fn, reverse) {
                var this$0 = this;
                if (0 === sliceSize) return 0;
                if (reverse) return this.cacheResult().__iterate(fn, reverse);
                var skipped = 0, isSkipping = !0, iterations = 0;
                return iterable.__iterate(function(v, k) {
                    if (!isSkipping || !(isSkipping = skipped++ < resolvedBegin)) return iterations++, 
                    !1 !== fn(v, useKeys ? k : iterations - 1, this$0) && iterations !== sliceSize;
                }), iterations;
            }, sliceSeq.__iteratorUncached = function(type, reverse) {
                if (0 !== sliceSize && reverse) return this.cacheResult().__iterator(type, reverse);
                // Don't bother instantiating parent iterator if taking 0.
                var iterator = 0 !== sliceSize && iterable.__iterator(type, reverse), skipped = 0, iterations = 0;
                return new Iterator(function() {
                    for (;skipped++ < resolvedBegin; ) iterator.next();
                    if (++iterations > sliceSize) return iteratorDone();
                    var step = iterator.next();
                    return useKeys || type === ITERATE_VALUES ? step : type === ITERATE_KEYS ? iteratorValue(type, iterations - 1, void 0, step) : iteratorValue(type, iterations - 1, step.value[1], step);
                });
            }, sliceSeq;
        }
        function takeWhileFactory(iterable, predicate, context) {
            var takeSequence = makeSequence(iterable);
            return takeSequence.__iterateUncached = function(fn, reverse) {
                var this$0 = this;
                if (reverse) return this.cacheResult().__iterate(fn, reverse);
                var iterations = 0;
                return iterable.__iterate(function(v, k, c) {
                    return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0);
                }), iterations;
            }, takeSequence.__iteratorUncached = function(type, reverse) {
                var this$0 = this;
                if (reverse) return this.cacheResult().__iterator(type, reverse);
                var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse), iterating = !0;
                return new Iterator(function() {
                    if (!iterating) return iteratorDone();
                    var step = iterator.next();
                    if (step.done) return step;
                    var entry = step.value, k = entry[0], v = entry[1];
                    return predicate.call(context, v, k, this$0) ? type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step) : (iterating = !1, 
                    iteratorDone());
                });
            }, takeSequence;
        }
        function skipWhileFactory(iterable, predicate, context, useKeys) {
            var skipSequence = makeSequence(iterable);
            return skipSequence.__iterateUncached = function(fn, reverse) {
                var this$0 = this;
                if (reverse) return this.cacheResult().__iterate(fn, reverse);
                var isSkipping = !0, iterations = 0;
                return iterable.__iterate(function(v, k, c) {
                    if (!isSkipping || !(isSkipping = predicate.call(context, v, k, c))) return iterations++, 
                    fn(v, useKeys ? k : iterations - 1, this$0);
                }), iterations;
            }, skipSequence.__iteratorUncached = function(type, reverse) {
                var this$0 = this;
                if (reverse) return this.cacheResult().__iterator(type, reverse);
                var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse), skipping = !0, iterations = 0;
                return new Iterator(function() {
                    var step, k, v;
                    do {
                        if (step = iterator.next(), step.done) return useKeys || type === ITERATE_VALUES ? step : type === ITERATE_KEYS ? iteratorValue(type, iterations++, void 0, step) : iteratorValue(type, iterations++, step.value[1], step);
                        var entry = step.value;
                        k = entry[0], v = entry[1], skipping && (skipping = predicate.call(context, v, k, this$0));
                    } while (skipping);
                    return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
                });
            }, skipSequence;
        }
        function concatFactory(iterable, values) {
            var isKeyedIterable = isKeyed(iterable), iters = [ iterable ].concat(values).map(function(v) {
                return isIterable(v) ? isKeyedIterable && (v = KeyedIterable(v)) : v = isKeyedIterable ? keyedSeqFromValue(v) : indexedSeqFromValue(Array.isArray(v) ? v : [ v ]), 
                v;
            }).filter(function(v) {
                return 0 !== v.size;
            });
            if (0 === iters.length) return iterable;
            if (1 === iters.length) {
                var singleton = iters[0];
                if (singleton === iterable || isKeyedIterable && isKeyed(singleton) || isIndexed(iterable) && isIndexed(singleton)) return singleton;
            }
            var concatSeq = new ArraySeq(iters);
            return isKeyedIterable ? concatSeq = concatSeq.toKeyedSeq() : isIndexed(iterable) || (concatSeq = concatSeq.toSetSeq()), 
            concatSeq = concatSeq.flatten(!0), concatSeq.size = iters.reduce(function(sum, seq) {
                if (void 0 !== sum) {
                    var size = seq.size;
                    if (void 0 !== size) return sum + size;
                }
            }, 0), concatSeq;
        }
        function flattenFactory(iterable, depth, useKeys) {
            var flatSequence = makeSequence(iterable);
            return flatSequence.__iterateUncached = function(fn, reverse) {
                function flatDeep(iter, currentDepth) {
                    var this$0 = this;
                    iter.__iterate(function(v, k) {
                        return (!depth || currentDepth < depth) && isIterable(v) ? flatDeep(v, currentDepth + 1) : !1 === fn(v, useKeys ? k : iterations++, this$0) && (stopped = !0), 
                        !stopped;
                    }, reverse);
                }
                var iterations = 0, stopped = !1;
                return flatDeep(iterable, 0), iterations;
            }, flatSequence.__iteratorUncached = function(type, reverse) {
                var iterator = iterable.__iterator(type, reverse), stack = [], iterations = 0;
                return new Iterator(function() {
                    for (;iterator; ) {
                        var step = iterator.next();
                        if (!1 === step.done) {
                            var v = step.value;
                            if (type === ITERATE_ENTRIES && (v = v[1]), depth && !(stack.length < depth) || !isIterable(v)) return useKeys ? step : iteratorValue(type, iterations++, v, step);
                            stack.push(iterator), iterator = v.__iterator(type, reverse);
                        } else iterator = stack.pop();
                    }
                    return iteratorDone();
                });
            }, flatSequence;
        }
        function flatMapFactory(iterable, mapper, context) {
            var coerce = iterableClass(iterable);
            return iterable.toSeq().map(function(v, k) {
                return coerce(mapper.call(context, v, k, iterable));
            }).flatten(!0);
        }
        function interposeFactory(iterable, separator) {
            var interposedSequence = makeSequence(iterable);
            return interposedSequence.size = iterable.size && 2 * iterable.size - 1, interposedSequence.__iterateUncached = function(fn, reverse) {
                var this$0 = this, iterations = 0;
                return iterable.__iterate(function(v, k) {
                    return (!iterations || !1 !== fn(separator, iterations++, this$0)) && !1 !== fn(v, iterations++, this$0);
                }, reverse), iterations;
            }, interposedSequence.__iteratorUncached = function(type, reverse) {
                var step, iterator = iterable.__iterator(ITERATE_VALUES, reverse), iterations = 0;
                return new Iterator(function() {
                    return (!step || iterations % 2) && (step = iterator.next(), step.done) ? step : iterations % 2 ? iteratorValue(type, iterations++, separator) : iteratorValue(type, iterations++, step.value, step);
                });
            }, interposedSequence;
        }
        function sortFactory(iterable, comparator, mapper) {
            comparator || (comparator = defaultComparator);
            var isKeyedIterable = isKeyed(iterable), index = 0, entries = iterable.toSeq().map(function(v, k) {
                return [ k, v, index++, mapper ? mapper(v, k, iterable) : v ];
            }).toArray();
            return entries.sort(function(a, b) {
                return comparator(a[3], b[3]) || a[2] - b[2];
            }).forEach(isKeyedIterable ? function(v, i) {
                entries[i].length = 2;
            } : function(v, i) {
                entries[i] = v[1];
            }), isKeyedIterable ? KeyedSeq(entries) : isIndexed(iterable) ? IndexedSeq(entries) : SetSeq(entries);
        }
        function maxFactory(iterable, comparator, mapper) {
            if (comparator || (comparator = defaultComparator), mapper) {
                var entry = iterable.toSeq().map(function(v, k) {
                    return [ v, mapper(v, k, iterable) ];
                }).reduce(function(a, b) {
                    return maxCompare(comparator, a[1], b[1]) ? b : a;
                });
                return entry && entry[0];
            }
            return iterable.reduce(function(a, b) {
                return maxCompare(comparator, a, b) ? b : a;
            });
        }
        function maxCompare(comparator, a, b) {
            var comp = comparator(b, a);
            // b is considered the new max if the comparator declares them equal, but
            // they are not equal and b is in fact a nullish value.
            return 0 === comp && b !== a && (void 0 === b || null === b || b !== b) || comp > 0;
        }
        function zipWithFactory(keyIter, zipper, iters) {
            var zipSequence = makeSequence(keyIter);
            // Note: this a generic base implementation of __iterate in terms of
            // __iterator which may be more generically useful in the future.
            return zipSequence.size = new ArraySeq(iters).map(function(i) {
                return i.size;
            }).min(), zipSequence.__iterate = function(fn, reverse) {
                for (/* generic:
      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        iterations++;
        if (fn(step.value[1], step.value[0], this) === false) {
          break;
        }
      }
      return iterations;
      */
                // indexed:
                var step, iterator = this.__iterator(ITERATE_VALUES, reverse), iterations = 0; !(step = iterator.next()).done && !1 !== fn(step.value, iterations++, this); ) ;
                return iterations;
            }, zipSequence.__iteratorUncached = function(type, reverse) {
                var iterators = iters.map(function(i) {
                    return i = Iterable(i), getIterator(reverse ? i.reverse() : i);
                }), iterations = 0, isDone = !1;
                return new Iterator(function() {
                    var steps;
                    return isDone || (steps = iterators.map(function(i) {
                        return i.next();
                    }), isDone = steps.some(function(s) {
                        return s.done;
                    })), isDone ? iteratorDone() : iteratorValue(type, iterations++, zipper.apply(null, steps.map(function(s) {
                        return s.value;
                    })));
                });
            }, zipSequence;
        }
        // #pragma Helper Functions
        function reify(iter, seq) {
            return isSeq(iter) ? seq : iter.constructor(seq);
        }
        function validateEntry(entry) {
            if (entry !== Object(entry)) throw new TypeError("Expected [K, V] tuple: " + entry);
        }
        function resolveSize(iter) {
            return assertNotInfinite(iter.size), ensureSize(iter);
        }
        function iterableClass(iterable) {
            return isKeyed(iterable) ? KeyedIterable : isIndexed(iterable) ? IndexedIterable : SetIterable;
        }
        function makeSequence(iterable) {
            return Object.create((isKeyed(iterable) ? KeyedSeq : isIndexed(iterable) ? IndexedSeq : SetSeq).prototype);
        }
        function cacheResultThrough() {
            return this._iter.cacheResult ? (this._iter.cacheResult(), this.size = this._iter.size, 
            this) : Seq.prototype.cacheResult.call(this);
        }
        function defaultComparator(a, b) {
            return a > b ? 1 : a < b ? -1 : 0;
        }
        function forceIterator(keyPath) {
            var iter = getIterator(keyPath);
            if (!iter) {
                // Array might not be iterable in this environment, so we need a fallback
                // to our wrapped type.
                if (!isArrayLike(keyPath)) throw new TypeError("Expected iterable or array-like: " + keyPath);
                iter = getIterator(Iterable(keyPath));
            }
            return iter;
        }
        function Record(defaultValues, name) {
            var hasInitialized, RecordType = function(values) {
                if (values instanceof RecordType) return values;
                if (!(this instanceof RecordType)) return new RecordType(values);
                if (!hasInitialized) {
                    hasInitialized = !0;
                    var keys = Object.keys(defaultValues);
                    setProps(RecordTypePrototype, keys), RecordTypePrototype.size = keys.length, RecordTypePrototype._name = name, 
                    RecordTypePrototype._keys = keys, RecordTypePrototype._defaultValues = defaultValues;
                }
                this._map = Map(values);
            }, RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
            return RecordTypePrototype.constructor = RecordType, RecordType;
        }
        function makeRecord(likeRecord, map, ownerID) {
            var record = Object.create(Object.getPrototypeOf(likeRecord));
            return record._map = map, record.__ownerID = ownerID, record;
        }
        function recordName(record) {
            return record._name || record.constructor.name || "Record";
        }
        function setProps(prototype, names) {
            try {
                names.forEach(setProp.bind(void 0, prototype));
            } catch (error) {}
        }
        function setProp(prototype, name) {
            Object.defineProperty(prototype, name, {
                get: function() {
                    return this.get(name);
                },
                set: function(value) {
                    invariant(this.__ownerID, "Cannot set on an immutable record."), this.set(name, value);
                }
            });
        }
        // @pragma Construction
        function Set(value) {
            return null === value || void 0 === value ? emptySet() : isSet(value) && !isOrdered(value) ? value : emptySet().withMutations(function(set) {
                var iter = SetIterable(value);
                assertNotInfinite(iter.size), iter.forEach(function(v) {
                    return set.add(v);
                });
            });
        }
        function isSet(maybeSet) {
            return !(!maybeSet || !maybeSet[IS_SET_SENTINEL]);
        }
        function updateSet(set, newMap) {
            return set.__ownerID ? (set.size = newMap.size, set._map = newMap, set) : newMap === set._map ? set : 0 === newMap.size ? set.__empty() : set.__make(newMap);
        }
        function makeSet(map, ownerID) {
            var set = Object.create(SetPrototype);
            return set.size = map ? map.size : 0, set._map = map, set.__ownerID = ownerID, set;
        }
        function emptySet() {
            return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
        }
        // @pragma Construction
        function OrderedSet(value) {
            return null === value || void 0 === value ? emptyOrderedSet() : isOrderedSet(value) ? value : emptyOrderedSet().withMutations(function(set) {
                var iter = SetIterable(value);
                assertNotInfinite(iter.size), iter.forEach(function(v) {
                    return set.add(v);
                });
            });
        }
        function isOrderedSet(maybeOrderedSet) {
            return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
        }
        function makeOrderedSet(map, ownerID) {
            var set = Object.create(OrderedSetPrototype);
            return set.size = map ? map.size : 0, set._map = map, set.__ownerID = ownerID, set;
        }
        function emptyOrderedSet() {
            return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
        }
        // @pragma Construction
        function Stack(value) {
            return null === value || void 0 === value ? emptyStack() : isStack(value) ? value : emptyStack().unshiftAll(value);
        }
        function isStack(maybeStack) {
            return !(!maybeStack || !maybeStack[IS_STACK_SENTINEL]);
        }
        function makeStack(size, head, ownerID, hash) {
            var map = Object.create(StackPrototype);
            return map.size = size, map._head = head, map.__ownerID = ownerID, map.__hash = hash, 
            map.__altered = !1, map;
        }
        function emptyStack() {
            return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
        }
        /**
   * Contributes additional methods to a constructor
   */
        function mixin(ctor, methods) {
            var keyCopier = function(key) {
                ctor.prototype[key] = methods[key];
            };
            return Object.keys(methods).forEach(keyCopier), Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(methods).forEach(keyCopier), 
            ctor;
        }
        // #pragma Helper functions
        function keyMapper(v, k) {
            return k;
        }
        function entryMapper(v, k) {
            return [ k, v ];
        }
        function not(predicate) {
            return function() {
                return !predicate.apply(this, arguments);
            };
        }
        function neg(predicate) {
            return function() {
                return -predicate.apply(this, arguments);
            };
        }
        function quoteString(value) {
            return "string" == typeof value ? JSON.stringify(value) : value;
        }
        function defaultZipper() {
            return arrCopy(arguments);
        }
        function defaultNegComparator(a, b) {
            return a < b ? 1 : a > b ? -1 : 0;
        }
        function hashIterable(iterable) {
            if (iterable.size === 1 / 0) return 0;
            var ordered = isOrdered(iterable), keyed = isKeyed(iterable), h = ordered ? 1 : 0;
            return murmurHashOfSize(iterable.__iterate(keyed ? ordered ? function(v, k) {
                h = 31 * h + hashMerge(hash(v), hash(k)) | 0;
            } : function(v, k) {
                h = h + hashMerge(hash(v), hash(k)) | 0;
            } : ordered ? function(v) {
                h = 31 * h + hash(v) | 0;
            } : function(v) {
                h = h + hash(v) | 0;
            }), h);
        }
        function murmurHashOfSize(size, h) {
            return h = imul(h, 3432918353), h = imul(h << 15 | h >>> -15, 461845907), h = imul(h << 13 | h >>> -13, 5), 
            h = (h + 3864292196 | 0) ^ size, h = imul(h ^ h >>> 16, 2246822507), h = imul(h ^ h >>> 13, 3266489909), 
            h = smi(h ^ h >>> 16);
        }
        function hashMerge(a, b) {
            return a ^ b + 2654435769 + (a << 6) + (a >> 2) | 0;
        }
        var SLICE$0 = Array.prototype.slice;
        createClass(KeyedIterable, Iterable), createClass(IndexedIterable, Iterable), createClass(SetIterable, Iterable), 
        Iterable.isIterable = isIterable, Iterable.isKeyed = isKeyed, Iterable.isIndexed = isIndexed, 
        Iterable.isAssociative = isAssociative, Iterable.isOrdered = isOrdered, Iterable.Keyed = KeyedIterable, 
        Iterable.Indexed = IndexedIterable, Iterable.Set = SetIterable;
        var IS_ITERABLE_SENTINEL = "@@__IMMUTABLE_ITERABLE__@@", IS_KEYED_SENTINEL = "@@__IMMUTABLE_KEYED__@@", IS_INDEXED_SENTINEL = "@@__IMMUTABLE_INDEXED__@@", IS_ORDERED_SENTINEL = "@@__IMMUTABLE_ORDERED__@@", SHIFT = 5, SIZE = 1 << SHIFT, MASK = SIZE - 1, NOT_SET = {}, CHANGE_LENGTH = {
            value: !1
        }, DID_ALTER = {
            value: !1
        }, ITERATE_KEYS = 0, ITERATE_VALUES = 1, ITERATE_ENTRIES = 2, REAL_ITERATOR_SYMBOL = "function" == typeof Symbol && Symbol.iterator, FAUX_ITERATOR_SYMBOL = "@@iterator", ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
        Iterator.prototype.toString = function() {
            return "[Iterator]";
        }, Iterator.KEYS = ITERATE_KEYS, Iterator.VALUES = ITERATE_VALUES, Iterator.ENTRIES = ITERATE_ENTRIES, 
        Iterator.prototype.inspect = Iterator.prototype.toSource = function() {
            return this.toString();
        }, Iterator.prototype[ITERATOR_SYMBOL] = function() {
            return this;
        }, createClass(Seq, Iterable), Seq.of = function() {
            return Seq(arguments);
        }, Seq.prototype.toSeq = function() {
            return this;
        }, Seq.prototype.toString = function() {
            return this.__toString("Seq {", "}");
        }, Seq.prototype.cacheResult = function() {
            return !this._cache && this.__iterateUncached && (this._cache = this.entrySeq().toArray(), 
            this.size = this._cache.length), this;
        }, // abstract __iterateUncached(fn, reverse)
        Seq.prototype.__iterate = function(fn, reverse) {
            return seqIterate(this, fn, reverse, !0);
        }, // abstract __iteratorUncached(type, reverse)
        Seq.prototype.__iterator = function(type, reverse) {
            return seqIterator(this, type, reverse, !0);
        }, createClass(KeyedSeq, Seq), KeyedSeq.prototype.toKeyedSeq = function() {
            return this;
        }, createClass(IndexedSeq, Seq), IndexedSeq.of = function() {
            return IndexedSeq(arguments);
        }, IndexedSeq.prototype.toIndexedSeq = function() {
            return this;
        }, IndexedSeq.prototype.toString = function() {
            return this.__toString("Seq [", "]");
        }, IndexedSeq.prototype.__iterate = function(fn, reverse) {
            return seqIterate(this, fn, reverse, !1);
        }, IndexedSeq.prototype.__iterator = function(type, reverse) {
            return seqIterator(this, type, reverse, !1);
        }, createClass(SetSeq, Seq), SetSeq.of = function() {
            return SetSeq(arguments);
        }, SetSeq.prototype.toSetSeq = function() {
            return this;
        }, Seq.isSeq = isSeq, Seq.Keyed = KeyedSeq, Seq.Set = SetSeq, Seq.Indexed = IndexedSeq;
        var IS_SEQ_SENTINEL = "@@__IMMUTABLE_SEQ__@@";
        Seq.prototype[IS_SEQ_SENTINEL] = !0, createClass(ArraySeq, IndexedSeq), ArraySeq.prototype.get = function(index, notSetValue) {
            return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
        }, ArraySeq.prototype.__iterate = function(fn, reverse) {
            for (var array = this._array, maxIndex = array.length - 1, ii = 0; ii <= maxIndex; ii++) if (!1 === fn(array[reverse ? maxIndex - ii : ii], ii, this)) return ii + 1;
            return ii;
        }, ArraySeq.prototype.__iterator = function(type, reverse) {
            var array = this._array, maxIndex = array.length - 1, ii = 0;
            return new Iterator(function() {
                return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++]);
            });
        }, createClass(ObjectSeq, KeyedSeq), ObjectSeq.prototype.get = function(key, notSetValue) {
            return void 0 === notSetValue || this.has(key) ? this._object[key] : notSetValue;
        }, ObjectSeq.prototype.has = function(key) {
            return this._object.hasOwnProperty(key);
        }, ObjectSeq.prototype.__iterate = function(fn, reverse) {
            for (var object = this._object, keys = this._keys, maxIndex = keys.length - 1, ii = 0; ii <= maxIndex; ii++) {
                var key = keys[reverse ? maxIndex - ii : ii];
                if (!1 === fn(object[key], key, this)) return ii + 1;
            }
            return ii;
        }, ObjectSeq.prototype.__iterator = function(type, reverse) {
            var object = this._object, keys = this._keys, maxIndex = keys.length - 1, ii = 0;
            return new Iterator(function() {
                var key = keys[reverse ? maxIndex - ii : ii];
                return ii++ > maxIndex ? iteratorDone() : iteratorValue(type, key, object[key]);
            });
        }, ObjectSeq.prototype[IS_ORDERED_SENTINEL] = !0, createClass(IterableSeq, IndexedSeq), 
        IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
            if (reverse) return this.cacheResult().__iterate(fn, reverse);
            var iterable = this._iterable, iterator = getIterator(iterable), iterations = 0;
            if (isIterator(iterator)) for (var step; !(step = iterator.next()).done && !1 !== fn(step.value, iterations++, this); ) ;
            return iterations;
        }, IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
            if (reverse) return this.cacheResult().__iterator(type, reverse);
            var iterable = this._iterable, iterator = getIterator(iterable);
            if (!isIterator(iterator)) return new Iterator(iteratorDone);
            var iterations = 0;
            return new Iterator(function() {
                var step = iterator.next();
                return step.done ? step : iteratorValue(type, iterations++, step.value);
            });
        }, createClass(IteratorSeq, IndexedSeq), IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
            if (reverse) return this.cacheResult().__iterate(fn, reverse);
            for (var iterator = this._iterator, cache = this._iteratorCache, iterations = 0; iterations < cache.length; ) if (!1 === fn(cache[iterations], iterations++, this)) return iterations;
            for (var step; !(step = iterator.next()).done; ) {
                var val = step.value;
                if (cache[iterations] = val, !1 === fn(val, iterations++, this)) break;
            }
            return iterations;
        }, IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
            if (reverse) return this.cacheResult().__iterator(type, reverse);
            var iterator = this._iterator, cache = this._iteratorCache, iterations = 0;
            return new Iterator(function() {
                if (iterations >= cache.length) {
                    var step = iterator.next();
                    if (step.done) return step;
                    cache[iterations] = step.value;
                }
                return iteratorValue(type, iterations, cache[iterations++]);
            });
        };
        var EMPTY_SEQ;
        createClass(Repeat, IndexedSeq), Repeat.prototype.toString = function() {
            return 0 === this.size ? "Repeat []" : "Repeat [ " + this._value + " " + this.size + " times ]";
        }, Repeat.prototype.get = function(index, notSetValue) {
            return this.has(index) ? this._value : notSetValue;
        }, Repeat.prototype.includes = function(searchValue) {
            return is(this._value, searchValue);
        }, Repeat.prototype.slice = function(begin, end) {
            var size = this.size;
            return wholeSlice(begin, end, size) ? this : new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
        }, Repeat.prototype.reverse = function() {
            return this;
        }, Repeat.prototype.indexOf = function(searchValue) {
            return is(this._value, searchValue) ? 0 : -1;
        }, Repeat.prototype.lastIndexOf = function(searchValue) {
            return is(this._value, searchValue) ? this.size : -1;
        }, Repeat.prototype.__iterate = function(fn, reverse) {
            for (var ii = 0; ii < this.size; ii++) if (!1 === fn(this._value, ii, this)) return ii + 1;
            return ii;
        }, Repeat.prototype.__iterator = function(type, reverse) {
            var this$0 = this, ii = 0;
            return new Iterator(function() {
                return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone();
            });
        }, Repeat.prototype.equals = function(other) {
            return other instanceof Repeat ? is(this._value, other._value) : deepEqual(other);
        };
        var EMPTY_REPEAT;
        createClass(Range, IndexedSeq), Range.prototype.toString = function() {
            return 0 === this.size ? "Range []" : "Range [ " + this._start + "..." + this._end + (this._step > 1 ? " by " + this._step : "") + " ]";
        }, Range.prototype.get = function(index, notSetValue) {
            return this.has(index) ? this._start + wrapIndex(this, index) * this._step : notSetValue;
        }, Range.prototype.includes = function(searchValue) {
            var possibleIndex = (searchValue - this._start) / this._step;
            return possibleIndex >= 0 && possibleIndex < this.size && possibleIndex === Math.floor(possibleIndex);
        }, Range.prototype.slice = function(begin, end) {
            return wholeSlice(begin, end, this.size) ? this : (begin = resolveBegin(begin, this.size), 
            end = resolveEnd(end, this.size), end <= begin ? new Range(0, 0) : new Range(this.get(begin, this._end), this.get(end, this._end), this._step));
        }, Range.prototype.indexOf = function(searchValue) {
            var offsetValue = searchValue - this._start;
            if (offsetValue % this._step == 0) {
                var index = offsetValue / this._step;
                if (index >= 0 && index < this.size) return index;
            }
            return -1;
        }, Range.prototype.lastIndexOf = function(searchValue) {
            return this.indexOf(searchValue);
        }, Range.prototype.__iterate = function(fn, reverse) {
            for (var maxIndex = this.size - 1, step = this._step, value = reverse ? this._start + maxIndex * step : this._start, ii = 0; ii <= maxIndex; ii++) {
                if (!1 === fn(value, ii, this)) return ii + 1;
                value += reverse ? -step : step;
            }
            return ii;
        }, Range.prototype.__iterator = function(type, reverse) {
            var maxIndex = this.size - 1, step = this._step, value = reverse ? this._start + maxIndex * step : this._start, ii = 0;
            return new Iterator(function() {
                var v = value;
                return value += reverse ? -step : step, ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
            });
        }, Range.prototype.equals = function(other) {
            return other instanceof Range ? this._start === other._start && this._end === other._end && this._step === other._step : deepEqual(this, other);
        };
        var EMPTY_RANGE;
        createClass(Collection, Iterable), createClass(KeyedCollection, Collection), createClass(IndexedCollection, Collection), 
        createClass(SetCollection, Collection), Collection.Keyed = KeyedCollection, Collection.Indexed = IndexedCollection, 
        Collection.Set = SetCollection;
        var weakMap, imul = "function" == typeof Math.imul && -2 === Math.imul(4294967295, 2) ? Math.imul : function(a, b) {
            a |= 0, // int
            b |= 0;
            // int
            var c = 65535 & a, d = 65535 & b;
            // Shift by 0 fixes the sign on the high part.
            return c * d + ((a >>> 16) * d + c * (b >>> 16) << 16 >>> 0) | 0;
        }, isExtensible = Object.isExtensible, canDefineProperty = function() {
            try {
                return Object.defineProperty({}, "@", {}), !0;
            } catch (e) {
                return !1;
            }
        }(), usingWeakMap = "function" == typeof WeakMap;
        usingWeakMap && (weakMap = new WeakMap());
        var objHashUID = 0, UID_HASH_KEY = "__immutablehash__";
        "function" == typeof Symbol && (UID_HASH_KEY = Symbol(UID_HASH_KEY));
        var STRING_HASH_CACHE_MIN_STRLEN = 16, STRING_HASH_CACHE_MAX_SIZE = 255, STRING_HASH_CACHE_SIZE = 0, stringHashCache = {};
        createClass(Map, KeyedCollection), Map.prototype.toString = function() {
            return this.__toString("Map {", "}");
        }, // @pragma Access
        Map.prototype.get = function(k, notSetValue) {
            return this._root ? this._root.get(0, void 0, k, notSetValue) : notSetValue;
        }, // @pragma Modification
        Map.prototype.set = function(k, v) {
            return updateMap(this, k, v);
        }, Map.prototype.setIn = function(keyPath, v) {
            return this.updateIn(keyPath, NOT_SET, function() {
                return v;
            });
        }, Map.prototype.remove = function(k) {
            return updateMap(this, k, NOT_SET);
        }, Map.prototype.deleteIn = function(keyPath) {
            return this.updateIn(keyPath, function() {
                return NOT_SET;
            });
        }, Map.prototype.update = function(k, notSetValue, updater) {
            return 1 === arguments.length ? k(this) : this.updateIn([ k ], notSetValue, updater);
        }, Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
            updater || (updater = notSetValue, notSetValue = void 0);
            var updatedValue = updateInDeepMap(this, forceIterator(keyPath), notSetValue, updater);
            return updatedValue === NOT_SET ? void 0 : updatedValue;
        }, Map.prototype.clear = function() {
            return 0 === this.size ? this : this.__ownerID ? (this.size = 0, this._root = null, 
            this.__hash = void 0, this.__altered = !0, this) : emptyMap();
        }, // @pragma Composition
        Map.prototype.merge = function() {
            return mergeIntoMapWith(this, void 0, arguments);
        }, Map.prototype.mergeWith = function(merger) {
            return mergeIntoMapWith(this, merger, SLICE$0.call(arguments, 1));
        }, Map.prototype.mergeIn = function(keyPath) {
            var iters = SLICE$0.call(arguments, 1);
            return this.updateIn(keyPath, emptyMap(), function(m) {
                return "function" == typeof m.merge ? m.merge.apply(m, iters) : iters[iters.length - 1];
            });
        }, Map.prototype.mergeDeep = function() {
            return mergeIntoMapWith(this, deepMerger, arguments);
        }, Map.prototype.mergeDeepWith = function(merger) {
            var iters = SLICE$0.call(arguments, 1);
            return mergeIntoMapWith(this, deepMergerWith(merger), iters);
        }, Map.prototype.mergeDeepIn = function(keyPath) {
            var iters = SLICE$0.call(arguments, 1);
            return this.updateIn(keyPath, emptyMap(), function(m) {
                return "function" == typeof m.mergeDeep ? m.mergeDeep.apply(m, iters) : iters[iters.length - 1];
            });
        }, Map.prototype.sort = function(comparator) {
            // Late binding
            return OrderedMap(sortFactory(this, comparator));
        }, Map.prototype.sortBy = function(mapper, comparator) {
            // Late binding
            return OrderedMap(sortFactory(this, comparator, mapper));
        }, // @pragma Mutability
        Map.prototype.withMutations = function(fn) {
            var mutable = this.asMutable();
            return fn(mutable), mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
        }, Map.prototype.asMutable = function() {
            return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
        }, Map.prototype.asImmutable = function() {
            return this.__ensureOwner();
        }, Map.prototype.wasAltered = function() {
            return this.__altered;
        }, Map.prototype.__iterator = function(type, reverse) {
            return new MapIterator(this, type, reverse);
        }, Map.prototype.__iterate = function(fn, reverse) {
            var this$0 = this, iterations = 0;
            return this._root && this._root.iterate(function(entry) {
                return iterations++, fn(entry[1], entry[0], this$0);
            }, reverse), iterations;
        }, Map.prototype.__ensureOwner = function(ownerID) {
            return ownerID === this.__ownerID ? this : ownerID ? makeMap(this.size, this._root, ownerID, this.__hash) : (this.__ownerID = ownerID, 
            this.__altered = !1, this);
        }, Map.isMap = isMap;
        var IS_MAP_SENTINEL = "@@__IMMUTABLE_MAP__@@", MapPrototype = Map.prototype;
        MapPrototype[IS_MAP_SENTINEL] = !0, MapPrototype.delete = MapPrototype.remove, MapPrototype.removeIn = MapPrototype.deleteIn, 
        ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
            for (var entries = this.entries, ii = 0, len = entries.length; ii < len; ii++) if (is(key, entries[ii][0])) return entries[ii][1];
            return notSetValue;
        }, ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
            for (var removed = value === NOT_SET, entries = this.entries, idx = 0, len = entries.length; idx < len && !is(key, entries[idx][0]); idx++) ;
            var exists = idx < len;
            if (exists ? entries[idx][1] === value : removed) return this;
            if (SetRef(didAlter), (removed || !exists) && SetRef(didChangeSize), !removed || 1 !== entries.length) {
                if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) return createNodes(ownerID, entries, key, value);
                var isEditable = ownerID && ownerID === this.ownerID, newEntries = isEditable ? entries : arrCopy(entries);
                return exists ? removed ? idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop() : newEntries[idx] = [ key, value ] : newEntries.push([ key, value ]), 
                isEditable ? (this.entries = newEntries, this) : new ArrayMapNode(ownerID, newEntries);
            }
        }, BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
            void 0 === keyHash && (keyHash = hash(key));
            var bit = 1 << ((0 === shift ? keyHash : keyHash >>> shift) & MASK), bitmap = this.bitmap;
            return 0 == (bitmap & bit) ? notSetValue : this.nodes[popCount(bitmap & bit - 1)].get(shift + SHIFT, keyHash, key, notSetValue);
        }, BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
            void 0 === keyHash && (keyHash = hash(key));
            var keyHashFrag = (0 === shift ? keyHash : keyHash >>> shift) & MASK, bit = 1 << keyHashFrag, bitmap = this.bitmap, exists = 0 != (bitmap & bit);
            if (!exists && value === NOT_SET) return this;
            var idx = popCount(bitmap & bit - 1), nodes = this.nodes, node = exists ? nodes[idx] : void 0, newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
            if (newNode === node) return this;
            if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
            if (exists && !newNode && 2 === nodes.length && isLeafNode(nodes[1 ^ idx])) return nodes[1 ^ idx];
            if (exists && newNode && 1 === nodes.length && isLeafNode(newNode)) return newNode;
            var isEditable = ownerID && ownerID === this.ownerID, newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit, newNodes = exists ? newNode ? setIn(nodes, idx, newNode, isEditable) : spliceOut(nodes, idx, isEditable) : spliceIn(nodes, idx, newNode, isEditable);
            return isEditable ? (this.bitmap = newBitmap, this.nodes = newNodes, this) : new BitmapIndexedNode(ownerID, newBitmap, newNodes);
        }, HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
            void 0 === keyHash && (keyHash = hash(key));
            var idx = (0 === shift ? keyHash : keyHash >>> shift) & MASK, node = this.nodes[idx];
            return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
        }, HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
            void 0 === keyHash && (keyHash = hash(key));
            var idx = (0 === shift ? keyHash : keyHash >>> shift) & MASK, removed = value === NOT_SET, nodes = this.nodes, node = nodes[idx];
            if (removed && !node) return this;
            var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
            if (newNode === node) return this;
            var newCount = this.count;
            if (node) {
                if (!newNode && --newCount < MIN_HASH_ARRAY_MAP_SIZE) return packNodes(ownerID, nodes, newCount, idx);
            } else newCount++;
            var isEditable = ownerID && ownerID === this.ownerID, newNodes = setIn(nodes, idx, newNode, isEditable);
            return isEditable ? (this.count = newCount, this.nodes = newNodes, this) : new HashArrayMapNode(ownerID, newCount, newNodes);
        }, HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
            for (var entries = this.entries, ii = 0, len = entries.length; ii < len; ii++) if (is(key, entries[ii][0])) return entries[ii][1];
            return notSetValue;
        }, HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
            void 0 === keyHash && (keyHash = hash(key));
            var removed = value === NOT_SET;
            if (keyHash !== this.keyHash) return removed ? this : (SetRef(didAlter), SetRef(didChangeSize), 
            mergeIntoNode(this, ownerID, shift, keyHash, [ key, value ]));
            for (var entries = this.entries, idx = 0, len = entries.length; idx < len && !is(key, entries[idx][0]); idx++) ;
            var exists = idx < len;
            if (exists ? entries[idx][1] === value : removed) return this;
            if (SetRef(didAlter), (removed || !exists) && SetRef(didChangeSize), removed && 2 === len) return new ValueNode(ownerID, this.keyHash, entries[1 ^ idx]);
            var isEditable = ownerID && ownerID === this.ownerID, newEntries = isEditable ? entries : arrCopy(entries);
            return exists ? removed ? idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop() : newEntries[idx] = [ key, value ] : newEntries.push([ key, value ]), 
            isEditable ? (this.entries = newEntries, this) : new HashCollisionNode(ownerID, this.keyHash, newEntries);
        }, ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
            return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
        }, ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
            var removed = value === NOT_SET, keyMatch = is(key, this.entry[0]);
            return (keyMatch ? value === this.entry[1] : removed) ? this : (SetRef(didAlter), 
            removed ? void SetRef(didChangeSize) : keyMatch ? ownerID && ownerID === this.ownerID ? (this.entry[1] = value, 
            this) : new ValueNode(ownerID, this.keyHash, [ key, value ]) : (SetRef(didChangeSize), 
            mergeIntoNode(this, ownerID, shift, hash(key), [ key, value ])));
        }, // #pragma Iterators
        ArrayMapNode.prototype.iterate = HashCollisionNode.prototype.iterate = function(fn, reverse) {
            for (var entries = this.entries, ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) if (!1 === fn(entries[reverse ? maxIndex - ii : ii])) return !1;
        }, BitmapIndexedNode.prototype.iterate = HashArrayMapNode.prototype.iterate = function(fn, reverse) {
            for (var nodes = this.nodes, ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
                var node = nodes[reverse ? maxIndex - ii : ii];
                if (node && !1 === node.iterate(fn, reverse)) return !1;
            }
        }, ValueNode.prototype.iterate = function(fn, reverse) {
            return fn(this.entry);
        }, createClass(MapIterator, Iterator), MapIterator.prototype.next = function() {
            for (var type = this._type, stack = this._stack; stack; ) {
                var maxIndex, node = stack.node, index = stack.index++;
                if (node.entry) {
                    if (0 === index) return mapIteratorValue(type, node.entry);
                } else if (node.entries) {
                    if (maxIndex = node.entries.length - 1, index <= maxIndex) return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
                } else if (maxIndex = node.nodes.length - 1, index <= maxIndex) {
                    var subNode = node.nodes[this._reverse ? maxIndex - index : index];
                    if (subNode) {
                        if (subNode.entry) return mapIteratorValue(type, subNode.entry);
                        stack = this._stack = mapIteratorFrame(subNode, stack);
                    }
                    continue;
                }
                stack = this._stack = this._stack.__prev;
            }
            return iteratorDone();
        };
        var EMPTY_MAP, MAX_ARRAY_MAP_SIZE = SIZE / 4, MAX_BITMAP_INDEXED_SIZE = SIZE / 2, MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
        createClass(List, IndexedCollection), List.of = function() {
            return this(arguments);
        }, List.prototype.toString = function() {
            return this.__toString("List [", "]");
        }, // @pragma Access
        List.prototype.get = function(index, notSetValue) {
            if ((index = wrapIndex(this, index)) >= 0 && index < this.size) {
                index += this._origin;
                var node = listNodeFor(this, index);
                return node && node.array[index & MASK];
            }
            return notSetValue;
        }, // @pragma Modification
        List.prototype.set = function(index, value) {
            return updateList(this, index, value);
        }, List.prototype.remove = function(index) {
            return this.has(index) ? 0 === index ? this.shift() : index === this.size - 1 ? this.pop() : this.splice(index, 1) : this;
        }, List.prototype.insert = function(index, value) {
            return this.splice(index, 0, value);
        }, List.prototype.clear = function() {
            return 0 === this.size ? this : this.__ownerID ? (this.size = this._origin = this._capacity = 0, 
            this._level = SHIFT, this._root = this._tail = null, this.__hash = void 0, this.__altered = !0, 
            this) : emptyList();
        }, List.prototype.push = function() {
            var values = arguments, oldSize = this.size;
            return this.withMutations(function(list) {
                setListBounds(list, 0, oldSize + values.length);
                for (var ii = 0; ii < values.length; ii++) list.set(oldSize + ii, values[ii]);
            });
        }, List.prototype.pop = function() {
            return setListBounds(this, 0, -1);
        }, List.prototype.unshift = function() {
            var values = arguments;
            return this.withMutations(function(list) {
                setListBounds(list, -values.length);
                for (var ii = 0; ii < values.length; ii++) list.set(ii, values[ii]);
            });
        }, List.prototype.shift = function() {
            return setListBounds(this, 1);
        }, // @pragma Composition
        List.prototype.merge = function() {
            return mergeIntoListWith(this, void 0, arguments);
        }, List.prototype.mergeWith = function(merger) {
            return mergeIntoListWith(this, merger, SLICE$0.call(arguments, 1));
        }, List.prototype.mergeDeep = function() {
            return mergeIntoListWith(this, deepMerger, arguments);
        }, List.prototype.mergeDeepWith = function(merger) {
            var iters = SLICE$0.call(arguments, 1);
            return mergeIntoListWith(this, deepMergerWith(merger), iters);
        }, List.prototype.setSize = function(size) {
            return setListBounds(this, 0, size);
        }, // @pragma Iteration
        List.prototype.slice = function(begin, end) {
            var size = this.size;
            return wholeSlice(begin, end, size) ? this : setListBounds(this, resolveBegin(begin, size), resolveEnd(end, size));
        }, List.prototype.__iterator = function(type, reverse) {
            var index = 0, values = iterateList(this, reverse);
            return new Iterator(function() {
                var value = values();
                return value === DONE ? iteratorDone() : iteratorValue(type, index++, value);
            });
        }, List.prototype.__iterate = function(fn, reverse) {
            for (var value, index = 0, values = iterateList(this, reverse); (value = values()) !== DONE && !1 !== fn(value, index++, this); ) ;
            return index;
        }, List.prototype.__ensureOwner = function(ownerID) {
            return ownerID === this.__ownerID ? this : ownerID ? makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash) : (this.__ownerID = ownerID, 
            this);
        }, List.isList = isList;
        var IS_LIST_SENTINEL = "@@__IMMUTABLE_LIST__@@", ListPrototype = List.prototype;
        ListPrototype[IS_LIST_SENTINEL] = !0, ListPrototype.delete = ListPrototype.remove, 
        ListPrototype.setIn = MapPrototype.setIn, ListPrototype.deleteIn = ListPrototype.removeIn = MapPrototype.removeIn, 
        ListPrototype.update = MapPrototype.update, ListPrototype.updateIn = MapPrototype.updateIn, 
        ListPrototype.mergeIn = MapPrototype.mergeIn, ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn, 
        ListPrototype.withMutations = MapPrototype.withMutations, ListPrototype.asMutable = MapPrototype.asMutable, 
        ListPrototype.asImmutable = MapPrototype.asImmutable, ListPrototype.wasAltered = MapPrototype.wasAltered, 
        // TODO: seems like these methods are very similar
        VNode.prototype.removeBefore = function(ownerID, level, index) {
            if (index === level ? 1 << level : 0 === this.array.length) return this;
            var originIndex = index >>> level & MASK;
            if (originIndex >= this.array.length) return new VNode([], ownerID);
            var newChild, removingFirst = 0 === originIndex;
            if (level > 0) {
                var oldChild = this.array[originIndex];
                if ((newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index)) === oldChild && removingFirst) return this;
            }
            if (removingFirst && !newChild) return this;
            var editable = editableVNode(this, ownerID);
            if (!removingFirst) for (var ii = 0; ii < originIndex; ii++) editable.array[ii] = void 0;
            return newChild && (editable.array[originIndex] = newChild), editable;
        }, VNode.prototype.removeAfter = function(ownerID, level, index) {
            if (index === (level ? 1 << level : 0) || 0 === this.array.length) return this;
            var sizeIndex = index - 1 >>> level & MASK;
            if (sizeIndex >= this.array.length) return this;
            var newChild;
            if (level > 0) {
                var oldChild = this.array[sizeIndex];
                if ((newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index)) === oldChild && sizeIndex === this.array.length - 1) return this;
            }
            var editable = editableVNode(this, ownerID);
            return editable.array.splice(sizeIndex + 1), newChild && (editable.array[sizeIndex] = newChild), 
            editable;
        };
        var EMPTY_LIST, DONE = {};
        createClass(OrderedMap, Map), OrderedMap.of = function() {
            return this(arguments);
        }, OrderedMap.prototype.toString = function() {
            return this.__toString("OrderedMap {", "}");
        }, // @pragma Access
        OrderedMap.prototype.get = function(k, notSetValue) {
            var index = this._map.get(k);
            return void 0 !== index ? this._list.get(index)[1] : notSetValue;
        }, // @pragma Modification
        OrderedMap.prototype.clear = function() {
            return 0 === this.size ? this : this.__ownerID ? (this.size = 0, this._map.clear(), 
            this._list.clear(), this) : emptyOrderedMap();
        }, OrderedMap.prototype.set = function(k, v) {
            return updateOrderedMap(this, k, v);
        }, OrderedMap.prototype.remove = function(k) {
            return updateOrderedMap(this, k, NOT_SET);
        }, OrderedMap.prototype.wasAltered = function() {
            return this._map.wasAltered() || this._list.wasAltered();
        }, OrderedMap.prototype.__iterate = function(fn, reverse) {
            var this$0 = this;
            return this._list.__iterate(function(entry) {
                return entry && fn(entry[1], entry[0], this$0);
            }, reverse);
        }, OrderedMap.prototype.__iterator = function(type, reverse) {
            return this._list.fromEntrySeq().__iterator(type, reverse);
        }, OrderedMap.prototype.__ensureOwner = function(ownerID) {
            if (ownerID === this.__ownerID) return this;
            var newMap = this._map.__ensureOwner(ownerID), newList = this._list.__ensureOwner(ownerID);
            return ownerID ? makeOrderedMap(newMap, newList, ownerID, this.__hash) : (this.__ownerID = ownerID, 
            this._map = newMap, this._list = newList, this);
        }, OrderedMap.isOrderedMap = isOrderedMap, OrderedMap.prototype[IS_ORDERED_SENTINEL] = !0, 
        OrderedMap.prototype.delete = OrderedMap.prototype.remove;
        var EMPTY_ORDERED_MAP;
        createClass(ToKeyedSequence, KeyedSeq), ToKeyedSequence.prototype.get = function(key, notSetValue) {
            return this._iter.get(key, notSetValue);
        }, ToKeyedSequence.prototype.has = function(key) {
            return this._iter.has(key);
        }, ToKeyedSequence.prototype.valueSeq = function() {
            return this._iter.valueSeq();
        }, ToKeyedSequence.prototype.reverse = function() {
            var this$0 = this, reversedSequence = reverseFactory(this, !0);
            return this._useKeys || (reversedSequence.valueSeq = function() {
                return this$0._iter.toSeq().reverse();
            }), reversedSequence;
        }, ToKeyedSequence.prototype.map = function(mapper, context) {
            var this$0 = this, mappedSequence = mapFactory(this, mapper, context);
            return this._useKeys || (mappedSequence.valueSeq = function() {
                return this$0._iter.toSeq().map(mapper, context);
            }), mappedSequence;
        }, ToKeyedSequence.prototype.__iterate = function(fn, reverse) {
            var ii, this$0 = this;
            return this._iter.__iterate(this._useKeys ? function(v, k) {
                return fn(v, k, this$0);
            } : (ii = reverse ? resolveSize(this) : 0, function(v) {
                return fn(v, reverse ? --ii : ii++, this$0);
            }), reverse);
        }, ToKeyedSequence.prototype.__iterator = function(type, reverse) {
            if (this._useKeys) return this._iter.__iterator(type, reverse);
            var iterator = this._iter.__iterator(ITERATE_VALUES, reverse), ii = reverse ? resolveSize(this) : 0;
            return new Iterator(function() {
                var step = iterator.next();
                return step.done ? step : iteratorValue(type, reverse ? --ii : ii++, step.value, step);
            });
        }, ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = !0, createClass(ToIndexedSequence, IndexedSeq), 
        ToIndexedSequence.prototype.includes = function(value) {
            return this._iter.includes(value);
        }, ToIndexedSequence.prototype.__iterate = function(fn, reverse) {
            var this$0 = this, iterations = 0;
            return this._iter.__iterate(function(v) {
                return fn(v, iterations++, this$0);
            }, reverse);
        }, ToIndexedSequence.prototype.__iterator = function(type, reverse) {
            var iterator = this._iter.__iterator(ITERATE_VALUES, reverse), iterations = 0;
            return new Iterator(function() {
                var step = iterator.next();
                return step.done ? step : iteratorValue(type, iterations++, step.value, step);
            });
        }, createClass(ToSetSequence, SetSeq), ToSetSequence.prototype.has = function(key) {
            return this._iter.includes(key);
        }, ToSetSequence.prototype.__iterate = function(fn, reverse) {
            var this$0 = this;
            return this._iter.__iterate(function(v) {
                return fn(v, v, this$0);
            }, reverse);
        }, ToSetSequence.prototype.__iterator = function(type, reverse) {
            var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
            return new Iterator(function() {
                var step = iterator.next();
                return step.done ? step : iteratorValue(type, step.value, step.value, step);
            });
        }, createClass(FromEntriesSequence, KeyedSeq), FromEntriesSequence.prototype.entrySeq = function() {
            return this._iter.toSeq();
        }, FromEntriesSequence.prototype.__iterate = function(fn, reverse) {
            var this$0 = this;
            return this._iter.__iterate(function(entry) {
                // Check if entry exists first so array access doesn't throw for holes
                // in the parent iteration.
                if (entry) {
                    validateEntry(entry);
                    var indexedIterable = isIterable(entry);
                    return fn(indexedIterable ? entry.get(1) : entry[1], indexedIterable ? entry.get(0) : entry[0], this$0);
                }
            }, reverse);
        }, FromEntriesSequence.prototype.__iterator = function(type, reverse) {
            var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
            return new Iterator(function() {
                for (;;) {
                    var step = iterator.next();
                    if (step.done) return step;
                    var entry = step.value;
                    // Check if entry exists first so array access doesn't throw for holes
                    // in the parent iteration.
                    if (entry) {
                        validateEntry(entry);
                        var indexedIterable = isIterable(entry);
                        return iteratorValue(type, indexedIterable ? entry.get(0) : entry[0], indexedIterable ? entry.get(1) : entry[1], step);
                    }
                }
            });
        }, ToIndexedSequence.prototype.cacheResult = ToKeyedSequence.prototype.cacheResult = ToSetSequence.prototype.cacheResult = FromEntriesSequence.prototype.cacheResult = cacheResultThrough, 
        createClass(Record, KeyedCollection), Record.prototype.toString = function() {
            return this.__toString(recordName(this) + " {", "}");
        }, // @pragma Access
        Record.prototype.has = function(k) {
            return this._defaultValues.hasOwnProperty(k);
        }, Record.prototype.get = function(k, notSetValue) {
            if (!this.has(k)) return notSetValue;
            var defaultVal = this._defaultValues[k];
            return this._map ? this._map.get(k, defaultVal) : defaultVal;
        }, // @pragma Modification
        Record.prototype.clear = function() {
            if (this.__ownerID) return this._map && this._map.clear(), this;
            var RecordType = this.constructor;
            return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
        }, Record.prototype.set = function(k, v) {
            if (!this.has(k)) throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
            var newMap = this._map && this._map.set(k, v);
            return this.__ownerID || newMap === this._map ? this : makeRecord(this, newMap);
        }, Record.prototype.remove = function(k) {
            if (!this.has(k)) return this;
            var newMap = this._map && this._map.remove(k);
            return this.__ownerID || newMap === this._map ? this : makeRecord(this, newMap);
        }, Record.prototype.wasAltered = function() {
            return this._map.wasAltered();
        }, Record.prototype.__iterator = function(type, reverse) {
            var this$0 = this;
            return KeyedIterable(this._defaultValues).map(function(_, k) {
                return this$0.get(k);
            }).__iterator(type, reverse);
        }, Record.prototype.__iterate = function(fn, reverse) {
            var this$0 = this;
            return KeyedIterable(this._defaultValues).map(function(_, k) {
                return this$0.get(k);
            }).__iterate(fn, reverse);
        }, Record.prototype.__ensureOwner = function(ownerID) {
            if (ownerID === this.__ownerID) return this;
            var newMap = this._map && this._map.__ensureOwner(ownerID);
            return ownerID ? makeRecord(this, newMap, ownerID) : (this.__ownerID = ownerID, 
            this._map = newMap, this);
        };
        var RecordPrototype = Record.prototype;
        RecordPrototype.delete = RecordPrototype.remove, RecordPrototype.deleteIn = RecordPrototype.removeIn = MapPrototype.removeIn, 
        RecordPrototype.merge = MapPrototype.merge, RecordPrototype.mergeWith = MapPrototype.mergeWith, 
        RecordPrototype.mergeIn = MapPrototype.mergeIn, RecordPrototype.mergeDeep = MapPrototype.mergeDeep, 
        RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith, RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn, 
        RecordPrototype.setIn = MapPrototype.setIn, RecordPrototype.update = MapPrototype.update, 
        RecordPrototype.updateIn = MapPrototype.updateIn, RecordPrototype.withMutations = MapPrototype.withMutations, 
        RecordPrototype.asMutable = MapPrototype.asMutable, RecordPrototype.asImmutable = MapPrototype.asImmutable, 
        createClass(Set, SetCollection), Set.of = function() {
            return this(arguments);
        }, Set.fromKeys = function(value) {
            return this(KeyedIterable(value).keySeq());
        }, Set.prototype.toString = function() {
            return this.__toString("Set {", "}");
        }, // @pragma Access
        Set.prototype.has = function(value) {
            return this._map.has(value);
        }, // @pragma Modification
        Set.prototype.add = function(value) {
            return updateSet(this, this._map.set(value, !0));
        }, Set.prototype.remove = function(value) {
            return updateSet(this, this._map.remove(value));
        }, Set.prototype.clear = function() {
            return updateSet(this, this._map.clear());
        }, // @pragma Composition
        Set.prototype.union = function() {
            var iters = SLICE$0.call(arguments, 0);
            return iters = iters.filter(function(x) {
                return 0 !== x.size;
            }), 0 === iters.length ? this : 0 !== this.size || this.__ownerID || 1 !== iters.length ? this.withMutations(function(set) {
                for (var ii = 0; ii < iters.length; ii++) SetIterable(iters[ii]).forEach(function(value) {
                    return set.add(value);
                });
            }) : this.constructor(iters[0]);
        }, Set.prototype.intersect = function() {
            var iters = SLICE$0.call(arguments, 0);
            if (0 === iters.length) return this;
            iters = iters.map(function(iter) {
                return SetIterable(iter);
            });
            var originalSet = this;
            return this.withMutations(function(set) {
                originalSet.forEach(function(value) {
                    iters.every(function(iter) {
                        return iter.includes(value);
                    }) || set.remove(value);
                });
            });
        }, Set.prototype.subtract = function() {
            var iters = SLICE$0.call(arguments, 0);
            if (0 === iters.length) return this;
            iters = iters.map(function(iter) {
                return SetIterable(iter);
            });
            var originalSet = this;
            return this.withMutations(function(set) {
                originalSet.forEach(function(value) {
                    iters.some(function(iter) {
                        return iter.includes(value);
                    }) && set.remove(value);
                });
            });
        }, Set.prototype.merge = function() {
            return this.union.apply(this, arguments);
        }, Set.prototype.mergeWith = function(merger) {
            var iters = SLICE$0.call(arguments, 1);
            return this.union.apply(this, iters);
        }, Set.prototype.sort = function(comparator) {
            // Late binding
            return OrderedSet(sortFactory(this, comparator));
        }, Set.prototype.sortBy = function(mapper, comparator) {
            // Late binding
            return OrderedSet(sortFactory(this, comparator, mapper));
        }, Set.prototype.wasAltered = function() {
            return this._map.wasAltered();
        }, Set.prototype.__iterate = function(fn, reverse) {
            var this$0 = this;
            return this._map.__iterate(function(_, k) {
                return fn(k, k, this$0);
            }, reverse);
        }, Set.prototype.__iterator = function(type, reverse) {
            return this._map.map(function(_, k) {
                return k;
            }).__iterator(type, reverse);
        }, Set.prototype.__ensureOwner = function(ownerID) {
            if (ownerID === this.__ownerID) return this;
            var newMap = this._map.__ensureOwner(ownerID);
            return ownerID ? this.__make(newMap, ownerID) : (this.__ownerID = ownerID, this._map = newMap, 
            this);
        }, Set.isSet = isSet;
        var IS_SET_SENTINEL = "@@__IMMUTABLE_SET__@@", SetPrototype = Set.prototype;
        SetPrototype[IS_SET_SENTINEL] = !0, SetPrototype.delete = SetPrototype.remove, SetPrototype.mergeDeep = SetPrototype.merge, 
        SetPrototype.mergeDeepWith = SetPrototype.mergeWith, SetPrototype.withMutations = MapPrototype.withMutations, 
        SetPrototype.asMutable = MapPrototype.asMutable, SetPrototype.asImmutable = MapPrototype.asImmutable, 
        SetPrototype.__empty = emptySet, SetPrototype.__make = makeSet;
        var EMPTY_SET;
        createClass(OrderedSet, Set), OrderedSet.of = function() {
            return this(arguments);
        }, OrderedSet.fromKeys = function(value) {
            return this(KeyedIterable(value).keySeq());
        }, OrderedSet.prototype.toString = function() {
            return this.__toString("OrderedSet {", "}");
        }, OrderedSet.isOrderedSet = isOrderedSet;
        var OrderedSetPrototype = OrderedSet.prototype;
        OrderedSetPrototype[IS_ORDERED_SENTINEL] = !0, OrderedSetPrototype.__empty = emptyOrderedSet, 
        OrderedSetPrototype.__make = makeOrderedSet;
        var EMPTY_ORDERED_SET;
        createClass(Stack, IndexedCollection), Stack.of = function() {
            return this(arguments);
        }, Stack.prototype.toString = function() {
            return this.__toString("Stack [", "]");
        }, // @pragma Access
        Stack.prototype.get = function(index, notSetValue) {
            var head = this._head;
            for (index = wrapIndex(this, index); head && index--; ) head = head.next;
            return head ? head.value : notSetValue;
        }, Stack.prototype.peek = function() {
            return this._head && this._head.value;
        }, // @pragma Modification
        Stack.prototype.push = function() {
            if (0 === arguments.length) return this;
            for (var newSize = this.size + arguments.length, head = this._head, ii = arguments.length - 1; ii >= 0; ii--) head = {
                value: arguments[ii],
                next: head
            };
            return this.__ownerID ? (this.size = newSize, this._head = head, this.__hash = void 0, 
            this.__altered = !0, this) : makeStack(newSize, head);
        }, Stack.prototype.pushAll = function(iter) {
            if (iter = IndexedIterable(iter), 0 === iter.size) return this;
            assertNotInfinite(iter.size);
            var newSize = this.size, head = this._head;
            return iter.reverse().forEach(function(value) {
                newSize++, head = {
                    value: value,
                    next: head
                };
            }), this.__ownerID ? (this.size = newSize, this._head = head, this.__hash = void 0, 
            this.__altered = !0, this) : makeStack(newSize, head);
        }, Stack.prototype.pop = function() {
            return this.slice(1);
        }, Stack.prototype.unshift = function() {
            return this.push.apply(this, arguments);
        }, Stack.prototype.unshiftAll = function(iter) {
            return this.pushAll(iter);
        }, Stack.prototype.shift = function() {
            return this.pop.apply(this, arguments);
        }, Stack.prototype.clear = function() {
            return 0 === this.size ? this : this.__ownerID ? (this.size = 0, this._head = void 0, 
            this.__hash = void 0, this.__altered = !0, this) : emptyStack();
        }, Stack.prototype.slice = function(begin, end) {
            if (wholeSlice(begin, end, this.size)) return this;
            var resolvedBegin = resolveBegin(begin, this.size);
            if (resolveEnd(end, this.size) !== this.size) // super.slice(begin, end);
            return IndexedCollection.prototype.slice.call(this, begin, end);
            for (var newSize = this.size - resolvedBegin, head = this._head; resolvedBegin--; ) head = head.next;
            return this.__ownerID ? (this.size = newSize, this._head = head, this.__hash = void 0, 
            this.__altered = !0, this) : makeStack(newSize, head);
        }, // @pragma Mutability
        Stack.prototype.__ensureOwner = function(ownerID) {
            return ownerID === this.__ownerID ? this : ownerID ? makeStack(this.size, this._head, ownerID, this.__hash) : (this.__ownerID = ownerID, 
            this.__altered = !1, this);
        }, // @pragma Iteration
        Stack.prototype.__iterate = function(fn, reverse) {
            if (reverse) return this.reverse().__iterate(fn);
            for (var iterations = 0, node = this._head; node && !1 !== fn(node.value, iterations++, this); ) node = node.next;
            return iterations;
        }, Stack.prototype.__iterator = function(type, reverse) {
            if (reverse) return this.reverse().__iterator(type);
            var iterations = 0, node = this._head;
            return new Iterator(function() {
                if (node) {
                    var value = node.value;
                    return node = node.next, iteratorValue(type, iterations++, value);
                }
                return iteratorDone();
            });
        }, Stack.isStack = isStack;
        var IS_STACK_SENTINEL = "@@__IMMUTABLE_STACK__@@", StackPrototype = Stack.prototype;
        StackPrototype[IS_STACK_SENTINEL] = !0, StackPrototype.withMutations = MapPrototype.withMutations, 
        StackPrototype.asMutable = MapPrototype.asMutable, StackPrototype.asImmutable = MapPrototype.asImmutable, 
        StackPrototype.wasAltered = MapPrototype.wasAltered;
        var EMPTY_STACK;
        Iterable.Iterator = Iterator, mixin(Iterable, {
            // ### Conversion to other types
            toArray: function() {
                assertNotInfinite(this.size);
                var array = new Array(this.size || 0);
                return this.valueSeq().__iterate(function(v, i) {
                    array[i] = v;
                }), array;
            },
            toIndexedSeq: function() {
                return new ToIndexedSequence(this);
            },
            toJS: function() {
                return this.toSeq().map(function(value) {
                    return value && "function" == typeof value.toJS ? value.toJS() : value;
                }).__toJS();
            },
            toJSON: function() {
                return this.toSeq().map(function(value) {
                    return value && "function" == typeof value.toJSON ? value.toJSON() : value;
                }).__toJS();
            },
            toKeyedSeq: function() {
                return new ToKeyedSequence(this, !0);
            },
            toMap: function() {
                // Use Late Binding here to solve the circular dependency.
                return Map(this.toKeyedSeq());
            },
            toObject: function() {
                assertNotInfinite(this.size);
                var object = {};
                return this.__iterate(function(v, k) {
                    object[k] = v;
                }), object;
            },
            toOrderedMap: function() {
                // Use Late Binding here to solve the circular dependency.
                return OrderedMap(this.toKeyedSeq());
            },
            toOrderedSet: function() {
                // Use Late Binding here to solve the circular dependency.
                return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
            },
            toSet: function() {
                // Use Late Binding here to solve the circular dependency.
                return Set(isKeyed(this) ? this.valueSeq() : this);
            },
            toSetSeq: function() {
                return new ToSetSequence(this);
            },
            toSeq: function() {
                return isIndexed(this) ? this.toIndexedSeq() : isKeyed(this) ? this.toKeyedSeq() : this.toSetSeq();
            },
            toStack: function() {
                // Use Late Binding here to solve the circular dependency.
                return Stack(isKeyed(this) ? this.valueSeq() : this);
            },
            toList: function() {
                // Use Late Binding here to solve the circular dependency.
                return List(isKeyed(this) ? this.valueSeq() : this);
            },
            // ### Common JavaScript methods and properties
            toString: function() {
                return "[Iterable]";
            },
            __toString: function(head, tail) {
                return 0 === this.size ? head + tail : head + " " + this.toSeq().map(this.__toStringMapper).join(", ") + " " + tail;
            },
            // ### ES6 Collection methods (ES6 Array and Map)
            concat: function() {
                return reify(this, concatFactory(this, SLICE$0.call(arguments, 0)));
            },
            includes: function(searchValue) {
                return this.some(function(value) {
                    return is(value, searchValue);
                });
            },
            entries: function() {
                return this.__iterator(ITERATE_ENTRIES);
            },
            every: function(predicate, context) {
                assertNotInfinite(this.size);
                var returnValue = !0;
                return this.__iterate(function(v, k, c) {
                    if (!predicate.call(context, v, k, c)) return returnValue = !1, !1;
                }), returnValue;
            },
            filter: function(predicate, context) {
                return reify(this, filterFactory(this, predicate, context, !0));
            },
            find: function(predicate, context, notSetValue) {
                var entry = this.findEntry(predicate, context);
                return entry ? entry[1] : notSetValue;
            },
            findEntry: function(predicate, context) {
                var found;
                return this.__iterate(function(v, k, c) {
                    if (predicate.call(context, v, k, c)) return found = [ k, v ], !1;
                }), found;
            },
            findLastEntry: function(predicate, context) {
                return this.toSeq().reverse().findEntry(predicate, context);
            },
            forEach: function(sideEffect, context) {
                return assertNotInfinite(this.size), this.__iterate(context ? sideEffect.bind(context) : sideEffect);
            },
            join: function(separator) {
                assertNotInfinite(this.size), separator = void 0 !== separator ? "" + separator : ",";
                var joined = "", isFirst = !0;
                return this.__iterate(function(v) {
                    isFirst ? isFirst = !1 : joined += separator, joined += null !== v && void 0 !== v ? v.toString() : "";
                }), joined;
            },
            keys: function() {
                return this.__iterator(ITERATE_KEYS);
            },
            map: function(mapper, context) {
                return reify(this, mapFactory(this, mapper, context));
            },
            reduce: function(reducer, initialReduction, context) {
                assertNotInfinite(this.size);
                var reduction, useFirst;
                return arguments.length < 2 ? useFirst = !0 : reduction = initialReduction, this.__iterate(function(v, k, c) {
                    useFirst ? (useFirst = !1, reduction = v) : reduction = reducer.call(context, reduction, v, k, c);
                }), reduction;
            },
            reduceRight: function(reducer, initialReduction, context) {
                var reversed = this.toKeyedSeq().reverse();
                return reversed.reduce.apply(reversed, arguments);
            },
            reverse: function() {
                return reify(this, reverseFactory(this, !0));
            },
            slice: function(begin, end) {
                return reify(this, sliceFactory(this, begin, end, !0));
            },
            some: function(predicate, context) {
                return !this.every(not(predicate), context);
            },
            sort: function(comparator) {
                return reify(this, sortFactory(this, comparator));
            },
            values: function() {
                return this.__iterator(ITERATE_VALUES);
            },
            // ### More sequential methods
            butLast: function() {
                return this.slice(0, -1);
            },
            isEmpty: function() {
                return void 0 !== this.size ? 0 === this.size : !this.some(function() {
                    return !0;
                });
            },
            count: function(predicate, context) {
                return ensureSize(predicate ? this.toSeq().filter(predicate, context) : this);
            },
            countBy: function(grouper, context) {
                return countByFactory(this, grouper, context);
            },
            equals: function(other) {
                return deepEqual(this, other);
            },
            entrySeq: function() {
                var iterable = this;
                if (iterable._cache) // We cache as an entries array, so we can just return the cache!
                return new ArraySeq(iterable._cache);
                var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
                return entriesSequence.fromEntrySeq = function() {
                    return iterable.toSeq();
                }, entriesSequence;
            },
            filterNot: function(predicate, context) {
                return this.filter(not(predicate), context);
            },
            findLast: function(predicate, context, notSetValue) {
                return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
            },
            first: function() {
                return this.find(returnTrue);
            },
            flatMap: function(mapper, context) {
                return reify(this, flatMapFactory(this, mapper, context));
            },
            flatten: function(depth) {
                return reify(this, flattenFactory(this, depth, !0));
            },
            fromEntrySeq: function() {
                return new FromEntriesSequence(this);
            },
            get: function(searchKey, notSetValue) {
                return this.find(function(_, key) {
                    return is(key, searchKey);
                }, void 0, notSetValue);
            },
            getIn: function(searchKeyPath, notSetValue) {
                for (var step, nested = this, iter = forceIterator(searchKeyPath); !(step = iter.next()).done; ) {
                    var key = step.value;
                    if ((nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET) === NOT_SET) return notSetValue;
                }
                return nested;
            },
            groupBy: function(grouper, context) {
                return groupByFactory(this, grouper, context);
            },
            has: function(searchKey) {
                return this.get(searchKey, NOT_SET) !== NOT_SET;
            },
            hasIn: function(searchKeyPath) {
                return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
            },
            isSubset: function(iter) {
                return iter = "function" == typeof iter.includes ? iter : Iterable(iter), this.every(function(value) {
                    return iter.includes(value);
                });
            },
            isSuperset: function(iter) {
                return iter = "function" == typeof iter.isSubset ? iter : Iterable(iter), iter.isSubset(this);
            },
            keySeq: function() {
                return this.toSeq().map(keyMapper).toIndexedSeq();
            },
            last: function() {
                return this.toSeq().reverse().first();
            },
            max: function(comparator) {
                return maxFactory(this, comparator);
            },
            maxBy: function(mapper, comparator) {
                return maxFactory(this, comparator, mapper);
            },
            min: function(comparator) {
                return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
            },
            minBy: function(mapper, comparator) {
                return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
            },
            rest: function() {
                return this.slice(1);
            },
            skip: function(amount) {
                return this.slice(Math.max(0, amount));
            },
            skipLast: function(amount) {
                return reify(this, this.toSeq().reverse().skip(amount).reverse());
            },
            skipWhile: function(predicate, context) {
                return reify(this, skipWhileFactory(this, predicate, context, !0));
            },
            skipUntil: function(predicate, context) {
                return this.skipWhile(not(predicate), context);
            },
            sortBy: function(mapper, comparator) {
                return reify(this, sortFactory(this, comparator, mapper));
            },
            take: function(amount) {
                return this.slice(0, Math.max(0, amount));
            },
            takeLast: function(amount) {
                return reify(this, this.toSeq().reverse().take(amount).reverse());
            },
            takeWhile: function(predicate, context) {
                return reify(this, takeWhileFactory(this, predicate, context));
            },
            takeUntil: function(predicate, context) {
                return this.takeWhile(not(predicate), context);
            },
            valueSeq: function() {
                return this.toIndexedSeq();
            },
            // ### Hashable Object
            hashCode: function() {
                return this.__hash || (this.__hash = hashIterable(this));
            }
        });
        // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
        // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
        // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
        // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
        var IterablePrototype = Iterable.prototype;
        IterablePrototype[IS_ITERABLE_SENTINEL] = !0, IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values, 
        IterablePrototype.__toJS = IterablePrototype.toArray, IterablePrototype.__toStringMapper = quoteString, 
        IterablePrototype.inspect = IterablePrototype.toSource = function() {
            return this.toString();
        }, IterablePrototype.chain = IterablePrototype.flatMap, IterablePrototype.contains = IterablePrototype.includes, 
        // Temporary warning about using length
        function() {
            try {
                Object.defineProperty(IterablePrototype, "length", {
                    get: function() {
                        if (!Iterable.noLengthWarning) {
                            var stack;
                            try {
                                throw new Error();
                            } catch (error) {
                                stack = error.stack;
                            }
                            if (-1 === stack.indexOf("_wrapObject")) return console && console.warn && console.warn("iterable.length has been deprecated, use iterable.size or iterable.count(). This warning will become a silent error in a future version. " + stack), 
                            this.size;
                        }
                    }
                });
            } catch (e) {}
        }(), mixin(KeyedIterable, {
            // ### More sequential methods
            flip: function() {
                return reify(this, flipFactory(this));
            },
            findKey: function(predicate, context) {
                var entry = this.findEntry(predicate, context);
                return entry && entry[0];
            },
            findLastKey: function(predicate, context) {
                return this.toSeq().reverse().findKey(predicate, context);
            },
            keyOf: function(searchValue) {
                return this.findKey(function(value) {
                    return is(value, searchValue);
                });
            },
            lastKeyOf: function(searchValue) {
                return this.findLastKey(function(value) {
                    return is(value, searchValue);
                });
            },
            mapEntries: function(mapper, context) {
                var this$0 = this, iterations = 0;
                return reify(this, this.toSeq().map(function(v, k) {
                    return mapper.call(context, [ k, v ], iterations++, this$0);
                }).fromEntrySeq());
            },
            mapKeys: function(mapper, context) {
                var this$0 = this;
                return reify(this, this.toSeq().flip().map(function(k, v) {
                    return mapper.call(context, k, v, this$0);
                }).flip());
            }
        });
        var KeyedIterablePrototype = KeyedIterable.prototype;
        // Mixin subclasses
        return KeyedIterablePrototype[IS_KEYED_SENTINEL] = !0, KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries, 
        KeyedIterablePrototype.__toJS = IterablePrototype.toObject, KeyedIterablePrototype.__toStringMapper = function(v, k) {
            return JSON.stringify(k) + ": " + quoteString(v);
        }, mixin(IndexedIterable, {
            // ### Conversion to other types
            toKeyedSeq: function() {
                return new ToKeyedSequence(this, !1);
            },
            // ### ES6 Collection methods (ES6 Array and Map)
            filter: function(predicate, context) {
                return reify(this, filterFactory(this, predicate, context, !1));
            },
            findIndex: function(predicate, context) {
                var entry = this.findEntry(predicate, context);
                return entry ? entry[0] : -1;
            },
            indexOf: function(searchValue) {
                var key = this.toKeyedSeq().keyOf(searchValue);
                return void 0 === key ? -1 : key;
            },
            lastIndexOf: function(searchValue) {
                var key = this.toKeyedSeq().reverse().keyOf(searchValue);
                return void 0 === key ? -1 : key;
            },
            reverse: function() {
                return reify(this, reverseFactory(this, !1));
            },
            slice: function(begin, end) {
                return reify(this, sliceFactory(this, begin, end, !1));
            },
            splice: function(index, removeNum) {
                var numArgs = arguments.length;
                if (removeNum = Math.max(0 | removeNum, 0), 0 === numArgs || 2 === numArgs && !removeNum) return this;
                // If index is negative, it should resolve relative to the size of the
                // collection. However size may be expensive to compute if not cached, so
                // only call count() if the number is in fact negative.
                index = resolveBegin(index, index < 0 ? this.count() : this.size);
                var spliced = this.slice(0, index);
                return reify(this, 1 === numArgs ? spliced : spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum)));
            },
            // ### More collection methods
            findLastIndex: function(predicate, context) {
                var key = this.toKeyedSeq().findLastKey(predicate, context);
                return void 0 === key ? -1 : key;
            },
            first: function() {
                return this.get(0);
            },
            flatten: function(depth) {
                return reify(this, flattenFactory(this, depth, !1));
            },
            get: function(index, notSetValue) {
                return index = wrapIndex(this, index), index < 0 || this.size === 1 / 0 || void 0 !== this.size && index > this.size ? notSetValue : this.find(function(_, key) {
                    return key === index;
                }, void 0, notSetValue);
            },
            has: function(index) {
                return (index = wrapIndex(this, index)) >= 0 && (void 0 !== this.size ? this.size === 1 / 0 || index < this.size : -1 !== this.indexOf(index));
            },
            interpose: function(separator) {
                return reify(this, interposeFactory(this, separator));
            },
            interleave: function() {
                var iterables = [ this ].concat(arrCopy(arguments)), zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables), interleaved = zipped.flatten(!0);
                return zipped.size && (interleaved.size = zipped.size * iterables.length), reify(this, interleaved);
            },
            last: function() {
                return this.get(-1);
            },
            skipWhile: function(predicate, context) {
                return reify(this, skipWhileFactory(this, predicate, context, !1));
            },
            zip: function() {
                return reify(this, zipWithFactory(this, defaultZipper, [ this ].concat(arrCopy(arguments))));
            },
            zipWith: function(zipper) {
                var iterables = arrCopy(arguments);
                return iterables[0] = this, reify(this, zipWithFactory(this, zipper, iterables));
            }
        }), IndexedIterable.prototype[IS_INDEXED_SENTINEL] = !0, IndexedIterable.prototype[IS_ORDERED_SENTINEL] = !0, 
        mixin(SetIterable, {
            // ### ES6 Collection methods (ES6 Array and Map)
            get: function(value, notSetValue) {
                return this.has(value) ? value : notSetValue;
            },
            includes: function(value) {
                return this.has(value);
            },
            // ### More sequential methods
            keySeq: function() {
                return this.valueSeq();
            }
        }), SetIterable.prototype.has = IterablePrototype.includes, mixin(KeyedSeq, KeyedIterable.prototype), 
        mixin(IndexedSeq, IndexedIterable.prototype), mixin(SetSeq, SetIterable.prototype), 
        mixin(KeyedCollection, KeyedIterable.prototype), mixin(IndexedCollection, IndexedIterable.prototype), 
        mixin(SetCollection, SetIterable.prototype), {
            Iterable: Iterable,
            Seq: Seq,
            Collection: Collection,
            Map: Map,
            OrderedMap: OrderedMap,
            List: List,
            Stack: Stack,
            Set: Set,
            OrderedSet: OrderedSet,
            Record: Record,
            Range: Range,
            Repeat: Repeat,
            is: is,
            fromJS: fromJS
        };
    });
}, /* 2 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function invariant(condition, format, a, b, c, d, e, f) {
        if (validateFormat(format), !condition) {
            var error;
            if (void 0 === format) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings."); else {
                var args = [ a, b, c, d, e, f ], argIndex = 0;
                error = new Error(format.replace(/%s/g, function() {
                    return args[argIndex++];
                })), error.name = "Invariant Violation";
            }
            // we don't care about invariant's own frame
            throw error.framesToPop = 1, error;
        }
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */
    /**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */
    var validateFormat = function(format) {};
    module.exports = invariant;
}, /* 3 */
/***/
function(module, exports) {
    module.exports = require("react");
}, /* 4 */
/***/
function(module, exports) {
    var core = module.exports = {
        version: "2.5.1"
    };
    "number" == typeof __e && (__e = core);
}, /* 5 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftModifier
 * @typechecks
 * 
 */
    var CharacterMetadata = __webpack_require__(11), ContentStateInlineStyle = __webpack_require__(178), DraftFeatureFlags = __webpack_require__(109), Immutable = __webpack_require__(1), applyEntityToContentState = __webpack_require__(179), getCharacterRemovalRange = __webpack_require__(181), getContentStateFragment = __webpack_require__(57), insertFragmentIntoContentState = __webpack_require__(184), insertTextIntoContentState = __webpack_require__(185), invariant = __webpack_require__(2), modifyBlockForContentState = __webpack_require__(186), removeEntitiesAtEdges = __webpack_require__(110), removeRangeFromContentState = __webpack_require__(187), splitBlockInContentState = __webpack_require__(188), OrderedSet = Immutable.OrderedSet, DraftModifier = {
        replaceText: function(contentState, rangeToReplace, text, inlineStyle, entityKey) {
            var withoutEntities = removeEntitiesAtEdges(contentState, rangeToReplace), withoutText = removeRangeFromContentState(withoutEntities, rangeToReplace), character = CharacterMetadata.create({
                style: inlineStyle || OrderedSet(),
                entity: entityKey || null
            });
            return insertTextIntoContentState(withoutText, withoutText.getSelectionAfter(), text, character);
        },
        insertText: function(contentState, targetRange, text, inlineStyle, entityKey) {
            return targetRange.isCollapsed() || invariant(!1), DraftModifier.replaceText(contentState, targetRange, text, inlineStyle, entityKey);
        },
        moveText: function(contentState, removalRange, targetRange) {
            var movedFragment = getContentStateFragment(contentState, removalRange), afterRemoval = DraftModifier.removeRange(contentState, removalRange, "backward");
            return DraftModifier.replaceWithFragment(afterRemoval, targetRange, movedFragment);
        },
        replaceWithFragment: function(contentState, targetRange, fragment) {
            var withoutEntities = removeEntitiesAtEdges(contentState, targetRange), withoutText = removeRangeFromContentState(withoutEntities, targetRange);
            return insertFragmentIntoContentState(withoutText, withoutText.getSelectionAfter(), fragment);
        },
        removeRange: function(contentState, rangeToRemove, removalDirection) {
            var startKey = void 0, endKey = void 0, startBlock = void 0, endBlock = void 0;
            rangeToRemove.getIsBackward() && (rangeToRemove = rangeToRemove.merge({
                anchorKey: rangeToRemove.getFocusKey(),
                anchorOffset: rangeToRemove.getFocusOffset(),
                focusKey: rangeToRemove.getAnchorKey(),
                focusOffset: rangeToRemove.getAnchorOffset(),
                isBackward: !1
            })), startKey = rangeToRemove.getAnchorKey(), endKey = rangeToRemove.getFocusKey(), 
            startBlock = contentState.getBlockForKey(startKey), endBlock = contentState.getBlockForKey(endKey);
            var startOffset = rangeToRemove.getStartOffset(), endOffset = rangeToRemove.getEndOffset(), startEntityKey = startBlock.getEntityAt(startOffset), endEntityKey = endBlock.getEntityAt(endOffset - 1);
            // Check whether the selection state overlaps with a single entity.
            // If so, try to remove the appropriate substring of the entity text.
            if (startKey === endKey && startEntityKey && startEntityKey === endEntityKey) {
                var _adjustedRemovalRange = getCharacterRemovalRange(contentState.getEntityMap(), startBlock, endBlock, rangeToRemove, removalDirection);
                return removeRangeFromContentState(contentState, _adjustedRemovalRange);
            }
            var adjustedRemovalRange = rangeToRemove;
            DraftFeatureFlags.draft_segmented_entities_behavior && (// Adjust the selection to properly delete segemented and immutable
            // entities
            adjustedRemovalRange = getCharacterRemovalRange(contentState.getEntityMap(), startBlock, endBlock, rangeToRemove, removalDirection));
            var withoutEntities = removeEntitiesAtEdges(contentState, adjustedRemovalRange);
            return removeRangeFromContentState(withoutEntities, adjustedRemovalRange);
        },
        splitBlock: function(contentState, selectionState) {
            var withoutEntities = removeEntitiesAtEdges(contentState, selectionState), withoutText = removeRangeFromContentState(withoutEntities, selectionState);
            return splitBlockInContentState(withoutText, withoutText.getSelectionAfter());
        },
        applyInlineStyle: function(contentState, selectionState, inlineStyle) {
            return ContentStateInlineStyle.add(contentState, selectionState, inlineStyle);
        },
        removeInlineStyle: function(contentState, selectionState, inlineStyle) {
            return ContentStateInlineStyle.remove(contentState, selectionState, inlineStyle);
        },
        setBlockType: function(contentState, selectionState, blockType) {
            return modifyBlockForContentState(contentState, selectionState, function(block) {
                return block.merge({
                    type: blockType,
                    depth: 0
                });
            });
        },
        setBlockData: function(contentState, selectionState, blockData) {
            return modifyBlockForContentState(contentState, selectionState, function(block) {
                return block.merge({
                    data: blockData
                });
            });
        },
        mergeBlockData: function(contentState, selectionState, blockData) {
            return modifyBlockForContentState(contentState, selectionState, function(block) {
                return block.merge({
                    data: block.getData().merge(blockData)
                });
            });
        },
        applyEntity: function(contentState, selectionState, entityKey) {
            var withoutEntities = removeEntitiesAtEdges(contentState, selectionState);
            return applyEntityToContentState(withoutEntities, selectionState, entityKey);
        }
    };
    module.exports = DraftModifier;
}, /* 6 */
/***/
function(module, exports, __webpack_require__) {
    var store = __webpack_require__(71)("wks"), uid = __webpack_require__(50), Symbol = __webpack_require__(12).Symbol, USE_SYMBOL = "function" == typeof Symbol;
    (module.exports = function(name) {
        return store[name] || (store[name] = USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)("Symbol." + name));
    }).store = store;
}, /* 7 */
/***/
function(module, exports, __webpack_require__) {
    var global = __webpack_require__(12), core = __webpack_require__(4), ctx = __webpack_require__(31), hide = __webpack_require__(25), $export = function(type, name, source) {
        var key, own, out, IS_FORCED = type & $export.F, IS_GLOBAL = type & $export.G, IS_STATIC = type & $export.S, IS_PROTO = type & $export.P, IS_BIND = type & $export.B, IS_WRAP = type & $export.W, exports = IS_GLOBAL ? core : core[name] || (core[name] = {}), expProto = exports.prototype, target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {}).prototype;
        IS_GLOBAL && (source = name);
        for (key in source) // contains in native
        (own = !IS_FORCED && target && void 0 !== target[key]) && key in exports || (// export native or passed
        out = own ? target[key] : source[key], // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && "function" != typeof target[key] ? source[key] : IS_BIND && own ? ctx(out, global) : IS_WRAP && target[key] == out ? function(C) {
            var F = function(a, b, c) {
                if (this instanceof C) {
                    switch (arguments.length) {
                      case 0:
                        return new C();

                      case 1:
                        return new C(a);

                      case 2:
                        return new C(a, b);
                    }
                    return new C(a, b, c);
                }
                return C.apply(this, arguments);
            };
            return F.prototype = C.prototype, F;
        }(out) : IS_PROTO && "function" == typeof out ? ctx(Function.call, out) : out, // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        IS_PROTO && ((exports.virtual || (exports.virtual = {}))[key] = out, // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
        type & $export.R && expProto && !expProto[key] && hide(expProto, key, out)));
    };
    // type bitmap
    $export.F = 1, // forced
    $export.G = 2, // global
    $export.S = 4, // static
    $export.P = 8, // proto
    $export.B = 16, // bind
    $export.W = 32, // wrap
    $export.U = 64, // safe
    $export.R = 128, // real proto method for `library`
    module.exports = $export;
}, /* 8 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */
    var nullthrows = function(x) {
        if (null != x) return x;
        throw new Error("Got unexpected null or undefined");
    };
    module.exports = nullthrows;
}, /* 9 */
/***/
function(module, exports, __webpack_require__) {
    var anObject = __webpack_require__(26), IE8_DOM_DEFINE = __webpack_require__(98), toPrimitive = __webpack_require__(65), dP = Object.defineProperty;
    exports.f = __webpack_require__(13) ? Object.defineProperty : function(O, P, Attributes) {
        if (anObject(O), P = toPrimitive(P, !0), anObject(Attributes), IE8_DOM_DEFINE) try {
            return dP(O, P, Attributes);
        } catch (e) {}
        if ("get" in Attributes || "set" in Attributes) throw TypeError("Accessors not supported!");
        return "value" in Attributes && (O[P] = Attributes.value), O;
    };
}, /* 10 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule Draft
 */
    var AtomicBlockUtils = __webpack_require__(177), BlockMapBuilder = __webpack_require__(44), CharacterMetadata = __webpack_require__(11), CompositeDraftDecorator = __webpack_require__(192), ContentBlock = __webpack_require__(34), ContentState = __webpack_require__(81), DefaultDraftBlockRenderMap = __webpack_require__(84), DefaultDraftInlineStyle = __webpack_require__(115), DraftEditor = __webpack_require__(193), DraftEditorBlock = __webpack_require__(117), DraftEntity = __webpack_require__(58), DraftModifier = __webpack_require__(5), DraftEntityInstance = __webpack_require__(113), EditorState = __webpack_require__(0), KeyBindingUtil = __webpack_require__(62), RichTextEditorUtil = __webpack_require__(254), SelectionState = __webpack_require__(45), convertFromDraftStateToRaw = __webpack_require__(256), convertFromHTMLToContentBlocks = __webpack_require__(130), convertFromRawToDraftState = __webpack_require__(259), generateRandomKey = __webpack_require__(16), getDefaultKeyBinding = __webpack_require__(90), getVisibleSelectionRect = __webpack_require__(263), DraftPublic = {
        Editor: DraftEditor,
        EditorBlock: DraftEditorBlock,
        EditorState: EditorState,
        CompositeDecorator: CompositeDraftDecorator,
        Entity: DraftEntity,
        EntityInstance: DraftEntityInstance,
        BlockMapBuilder: BlockMapBuilder,
        CharacterMetadata: CharacterMetadata,
        ContentBlock: ContentBlock,
        ContentState: ContentState,
        SelectionState: SelectionState,
        AtomicBlockUtils: AtomicBlockUtils,
        KeyBindingUtil: KeyBindingUtil,
        Modifier: DraftModifier,
        RichUtils: RichTextEditorUtil,
        DefaultDraftBlockRenderMap: DefaultDraftBlockRenderMap,
        DefaultDraftInlineStyle: DefaultDraftInlineStyle,
        convertFromHTML: convertFromHTMLToContentBlocks,
        convertFromRaw: convertFromRawToDraftState,
        convertToRaw: convertFromDraftStateToRaw,
        genKey: generateRandomKey,
        getDefaultKeyBinding: getDefaultKeyBinding,
        getVisibleSelectionRect: getVisibleSelectionRect
    };
    module.exports = DraftPublic;
}, /* 11 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule CharacterMetadata
 * @typechecks
 * 
 */
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !call || "object" != typeof call && "function" != typeof call ? self : call;
    }
    function _inherits(subClass, superClass) {
        if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
    }
    var _require = __webpack_require__(1), Map = _require.Map, OrderedSet = _require.OrderedSet, Record = _require.Record, EMPTY_SET = OrderedSet(), defaultRecord = {
        style: EMPTY_SET,
        entity: null
    }, CharacterMetadataRecord = Record(defaultRecord), CharacterMetadata = function(_CharacterMetadataRec) {
        function CharacterMetadata() {
            return _classCallCheck(this, CharacterMetadata), _possibleConstructorReturn(this, _CharacterMetadataRec.apply(this, arguments));
        }
        /**
   * Use this function instead of the `CharacterMetadata` constructor.
   * Since most content generally uses only a very small number of
   * style/entity permutations, we can reuse these objects as often as
   * possible.
   */
        return _inherits(CharacterMetadata, _CharacterMetadataRec), CharacterMetadata.prototype.getStyle = function() {
            return this.get("style");
        }, CharacterMetadata.prototype.getEntity = function() {
            return this.get("entity");
        }, CharacterMetadata.prototype.hasStyle = function(style) {
            return this.getStyle().includes(style);
        }, CharacterMetadata.applyStyle = function(record, style) {
            var withStyle = record.set("style", record.getStyle().add(style));
            return CharacterMetadata.create(withStyle);
        }, CharacterMetadata.removeStyle = function(record, style) {
            var withoutStyle = record.set("style", record.getStyle().remove(style));
            return CharacterMetadata.create(withoutStyle);
        }, CharacterMetadata.applyEntity = function(record, entityKey) {
            var withEntity = record.getEntity() === entityKey ? record : record.set("entity", entityKey);
            return CharacterMetadata.create(withEntity);
        }, CharacterMetadata.create = function(config) {
            if (!config) return EMPTY;
            var defaultConfig = {
                style: EMPTY_SET,
                entity: null
            }, configMap = Map(defaultConfig).merge(config), existing = pool.get(configMap);
            if (existing) return existing;
            var newCharacter = new CharacterMetadata(configMap);
            return pool = pool.set(configMap, newCharacter), newCharacter;
        }, CharacterMetadata;
    }(CharacterMetadataRecord), EMPTY = new CharacterMetadata(), pool = Map([ [ Map(defaultRecord), EMPTY ] ]);
    CharacterMetadata.EMPTY = EMPTY, module.exports = CharacterMetadata;
}, /* 12 */
/***/
function(module, exports) {
    // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
    var global = module.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
    "number" == typeof __g && (__g = global);
}, /* 13 */
/***/
function(module, exports, __webpack_require__) {
    // Thank's IE8 for his funny defineProperty
    module.exports = !__webpack_require__(32)(function() {
        return 7 != Object.defineProperty({}, "a", {
            get: function() {
                return 7;
            }
        }).a;
    });
}, /* 14 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    exports.__esModule = !0, exports.default = function(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    };
}, /* 15 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    exports.__esModule = !0;
    var _defineProperty = __webpack_require__(101), _defineProperty2 = function(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }(_defineProperty);
    exports.default = function() {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 
                "value" in descriptor && (descriptor.writable = !0), (0, _defineProperty2.default)(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), 
            Constructor;
        };
    }();
}, /* 16 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function generateRandomKey() {
        for (var key = void 0; void 0 === key || seenKeys.hasOwnProperty(key) || !isNaN(+key); ) key = Math.floor(Math.random() * MULTIPLIER).toString(32);
        return seenKeys[key] = !0, key;
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule generateRandomKey
 * @typechecks
 * 
 */
    var seenKeys = {}, MULTIPLIER = Math.pow(2, 24);
    module.exports = generateRandomKey;
}, /* 17 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Checks to see whether `name` and `version` satisfy `query`.
 *
 * @param {string} name Name of the browser, device, engine or platform
 * @param {?string} version Version of the browser, engine or platform
 * @param {string} query Query of form "Name [range expression]"
 * @param {?function} normalizer Optional pre-processor for range expression
 * @return {boolean}
 */
    function compare(name, version, query, normalizer) {
        // check for exact match with no version
        if (name === query) return !0;
        // check for non-matching names
        if (!query.startsWith(name)) return !1;
        // full comparison with version
        var range = query.slice(name.length);
        return !!version && (range = normalizer ? normalizer(range) : range, VersionRange.contains(range, version));
    }
    /**
 * Normalizes `version` by stripping any "NT" prefix, but only on the Windows
 * platform.
 *
 * Mimics the stripping performed by the `UserAgentWindowsPlatform` PHP class.
 *
 * @param {string} version
 * @return {string}
 */
    function normalizePlatformVersion(version) {
        return "Windows" === UserAgentData.platformName ? version.replace(/^\s*NT/, "") : version;
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */
    var UserAgentData = __webpack_require__(198), VersionRange = __webpack_require__(201), mapObject = __webpack_require__(202), memoizeStringOnly = __webpack_require__(203), UserAgent = {
        /**
   * Check if the User Agent browser matches `query`.
   *
   * `query` should be a string like "Chrome" or "Chrome > 33".
   *
   * Valid browser names include:
   *
   * - ACCESS NetFront
   * - AOL
   * - Amazon Silk
   * - Android
   * - BlackBerry
   * - BlackBerry PlayBook
   * - Chrome
   * - Chrome for iOS
   * - Chrome frame
   * - Facebook PHP SDK
   * - Facebook for iOS
   * - Firefox
   * - IE
   * - IE Mobile
   * - Mobile Safari
   * - Motorola Internet Browser
   * - Nokia
   * - Openwave Mobile Browser
   * - Opera
   * - Opera Mini
   * - Opera Mobile
   * - Safari
   * - UIWebView
   * - Unknown
   * - webOS
   * - etc...
   *
   * An authoritative list can be found in the PHP `BrowserDetector` class and
   * related classes in the same file (see calls to `new UserAgentBrowser` here:
   * https://fburl.com/50728104).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
        isBrowser: function(query) {
            return compare(UserAgentData.browserName, UserAgentData.browserFullVersion, query);
        },
        /**
   * Check if the User Agent browser uses a 32 or 64 bit architecture.
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "32" or "64".
   * @return {boolean}
   */
        isBrowserArchitecture: function(query) {
            return compare(UserAgentData.browserArchitecture, null, query);
        },
        /**
   * Check if the User Agent device matches `query`.
   *
   * `query` should be a string like "iPhone" or "iPad".
   *
   * Valid device names include:
   *
   * - Kindle
   * - Kindle Fire
   * - Unknown
   * - iPad
   * - iPhone
   * - iPod
   * - etc...
   *
   * An authoritative list can be found in the PHP `DeviceDetector` class and
   * related classes in the same file (see calls to `new UserAgentDevice` here:
   * https://fburl.com/50728332).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name"
   * @return {boolean}
   */
        isDevice: function(query) {
            return compare(UserAgentData.deviceName, null, query);
        },
        /**
   * Check if the User Agent rendering engine matches `query`.
   *
   * `query` should be a string like "WebKit" or "WebKit >= 537".
   *
   * Valid engine names include:
   *
   * - Gecko
   * - Presto
   * - Trident
   * - WebKit
   * - etc...
   *
   * An authoritative list can be found in the PHP `RenderingEngineDetector`
   * class related classes in the same file (see calls to `new
   * UserAgentRenderingEngine` here: https://fburl.com/50728617).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
        isEngine: function(query) {
            return compare(UserAgentData.engineName, UserAgentData.engineVersion, query);
        },
        /**
   * Check if the User Agent platform matches `query`.
   *
   * `query` should be a string like "Windows" or "iOS 5 - 6".
   *
   * Valid platform names include:
   *
   * - Android
   * - BlackBerry OS
   * - Java ME
   * - Linux
   * - Mac OS X
   * - Mac OS X Calendar
   * - Mac OS X Internet Account
   * - Symbian
   * - SymbianOS
   * - Windows
   * - Windows Mobile
   * - Windows Phone
   * - iOS
   * - iOS Facebook Integration Account
   * - iOS Facebook Social Sharing UI
   * - webOS
   * - Chrome OS
   * - etc...
   *
   * An authoritative list can be found in the PHP `PlatformDetector` class and
   * related classes in the same file (see calls to `new UserAgentPlatform`
   * here: https://fburl.com/50729226).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
        isPlatform: function(query) {
            return compare(UserAgentData.platformName, UserAgentData.platformFullVersion, query, normalizePlatformVersion);
        },
        /**
   * Check if the User Agent platform is a 32 or 64 bit architecture.
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "32" or "64".
   * @return {boolean}
   */
        isPlatformArchitecture: function(query) {
            return compare(UserAgentData.platformArchitecture, null, query);
        }
    };
    module.exports = mapObject(UserAgent, memoizeStringOnly);
}, /* 18 */
/***/
function(module, exports, __webpack_require__) {
    function addStylesToDom(styles, options) {
        for (var i = 0; i < styles.length; i++) {
            var item = styles[i], domStyle = stylesInDom[item.id];
            if (domStyle) {
                domStyle.refs++;
                for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j](item.parts[j]);
                for (;j < item.parts.length; j++) domStyle.parts.push(addStyle(item.parts[j], options));
            } else {
                for (var parts = [], j = 0; j < item.parts.length; j++) parts.push(addStyle(item.parts[j], options));
                stylesInDom[item.id] = {
                    id: item.id,
                    refs: 1,
                    parts: parts
                };
            }
        }
    }
    function listToStyles(list, options) {
        for (var styles = [], newStyles = {}, i = 0; i < list.length; i++) {
            var item = list[i], id = options.base ? item[0] + options.base : item[0], css = item[1], media = item[2], sourceMap = item[3], part = {
                css: css,
                media: media,
                sourceMap: sourceMap
            };
            newStyles[id] ? newStyles[id].parts.push(part) : styles.push(newStyles[id] = {
                id: id,
                parts: [ part ]
            });
        }
        return styles;
    }
    function insertStyleElement(options, style) {
        var target = getElement(options.insertInto);
        if (!target) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
        var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];
        if ("top" === options.insertAt) lastStyleElementInsertedAtTop ? lastStyleElementInsertedAtTop.nextSibling ? target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling) : target.appendChild(style) : target.insertBefore(style, target.firstChild), 
        stylesInsertedAtTop.push(style); else {
            if ("bottom" !== options.insertAt) throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
            target.appendChild(style);
        }
    }
    function removeStyleElement(style) {
        if (null === style.parentNode) return !1;
        style.parentNode.removeChild(style);
        var idx = stylesInsertedAtTop.indexOf(style);
        idx >= 0 && stylesInsertedAtTop.splice(idx, 1);
    }
    function createStyleElement(options) {
        var style = document.createElement("style");
        return options.attrs.type = "text/css", addAttrs(style, options.attrs), insertStyleElement(options, style), 
        style;
    }
    function createLinkElement(options) {
        var link = document.createElement("link");
        return options.attrs.type = "text/css", options.attrs.rel = "stylesheet", addAttrs(link, options.attrs), 
        insertStyleElement(options, link), link;
    }
    function addAttrs(el, attrs) {
        Object.keys(attrs).forEach(function(key) {
            el.setAttribute(key, attrs[key]);
        });
    }
    function addStyle(obj, options) {
        var style, update, remove, result;
        // If a transform function was defined, run it on the css
        if (options.transform && obj.css) {
            if (!(result = options.transform(obj.css))) // If the transform function returns a falsy value, don't add this css.
            // This allows conditional loading of css
            return function() {};
            // If transform returns a value, use that instead of the original css.
            // This allows running runtime transformations on the css.
            obj.css = result;
        }
        if (options.singleton) {
            var styleIndex = singletonCounter++;
            style = singleton || (singleton = createStyleElement(options)), update = applyToSingletonTag.bind(null, style, styleIndex, !1), 
            remove = applyToSingletonTag.bind(null, style, styleIndex, !0);
        } else obj.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (style = createLinkElement(options), 
        update = updateLink.bind(null, style, options), remove = function() {
            removeStyleElement(style), style.href && URL.revokeObjectURL(style.href);
        }) : (style = createStyleElement(options), update = applyToTag.bind(null, style), 
        remove = function() {
            removeStyleElement(style);
        });
        return update(obj), function(newObj) {
            if (newObj) {
                if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) return;
                update(obj = newObj);
            } else remove();
        };
    }
    function applyToSingletonTag(style, index, remove, obj) {
        var css = remove ? "" : obj.css;
        if (style.styleSheet) style.styleSheet.cssText = replaceText(index, css); else {
            var cssNode = document.createTextNode(css), childNodes = style.childNodes;
            childNodes[index] && style.removeChild(childNodes[index]), childNodes.length ? style.insertBefore(cssNode, childNodes[index]) : style.appendChild(cssNode);
        }
    }
    function applyToTag(style, obj) {
        var css = obj.css, media = obj.media;
        if (media && style.setAttribute("media", media), style.styleSheet) style.styleSheet.cssText = css; else {
            for (;style.firstChild; ) style.removeChild(style.firstChild);
            style.appendChild(document.createTextNode(css));
        }
    }
    function updateLink(link, options, obj) {
        var css = obj.css, sourceMap = obj.sourceMap, autoFixUrls = void 0 === options.convertToAbsoluteUrls && sourceMap;
        (options.convertToAbsoluteUrls || autoFixUrls) && (css = fixUrls(css)), sourceMap && (// http://stackoverflow.com/a/26603875
        css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */");
        var blob = new Blob([ css ], {
            type: "text/css"
        }), oldSrc = link.href;
        link.href = URL.createObjectURL(blob), oldSrc && URL.revokeObjectURL(oldSrc);
    }
    /*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
    var stylesInDom = {}, isOldIE = function(fn) {
        var memo;
        return function() {
            return void 0 === memo && (memo = fn.apply(this, arguments)), memo;
        };
    }(function() {
        // Test for IE <= 9 as proposed by Browserhacks
        // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
        // Tests for existence of standard globals is to allow style-loader
        // to operate correctly into non-standard environments
        // @see https://github.com/webpack-contrib/style-loader/issues/177
        return window && document && document.all && !window.atob;
    }), getElement = function(fn) {
        var memo = {};
        return function(selector) {
            return void 0 === memo[selector] && (memo[selector] = fn.call(this, selector)), 
            memo[selector];
        };
    }(function(target) {
        return document.querySelector(target);
    }), singleton = null, singletonCounter = 0, stylesInsertedAtTop = [], fixUrls = __webpack_require__(300);
    module.exports = function(list, options) {
        if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
        options = options || {}, options.attrs = "object" == typeof options.attrs ? options.attrs : {}, 
        // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
        // tags it will allow on a page
        options.singleton || (options.singleton = isOldIE()), // By default, add <style> tags to the <head> element
        options.insertInto || (options.insertInto = "head"), // By default, add <style> tags to the bottom of the target
        options.insertAt || (options.insertAt = "bottom");
        var styles = listToStyles(list, options);
        return addStylesToDom(styles, options), function(newList) {
            for (var mayRemove = [], i = 0; i < styles.length; i++) {
                var item = styles[i], domStyle = stylesInDom[item.id];
                domStyle.refs--, mayRemove.push(domStyle);
            }
            if (newList) {
                addStylesToDom(listToStyles(newList, options), options);
            }
            for (var i = 0; i < mayRemove.length; i++) {
                var domStyle = mayRemove[i];
                if (0 === domStyle.refs) {
                    for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();
                    delete stylesInDom[domStyle.id];
                }
            }
        };
    };
    var replaceText = function() {
        var textStore = [];
        return function(index, replacement) {
            return textStore[index] = replacement, textStore.filter(Boolean).join("\n");
        };
    }();
}, /* 19 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    exports.__esModule = !0;
    var _assign = __webpack_require__(96), _assign2 = function(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }(_assign);
    exports.default = _assign2.default || function(target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
        }
        return target;
    };
}, /* 20 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = {
        default: __webpack_require__(152),
        __esModule: !0
    };
}, /* 21 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    exports.__esModule = !0;
    var _typeof2 = __webpack_require__(74), _typeof3 = function(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }(_typeof2);
    exports.default = function(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !call || "object" !== (void 0 === call ? "undefined" : (0, _typeof3.default)(call)) && "function" != typeof call ? self : call;
    };
}, /* 22 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    exports.__esModule = !0;
    var _setPrototypeOf = __webpack_require__(170), _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf), _create = __webpack_require__(174), _create2 = _interopRequireDefault(_create), _typeof2 = __webpack_require__(74), _typeof3 = _interopRequireDefault(_typeof2);
    exports.default = function(subClass, superClass) {
        if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function, not " + (void 0 === superClass ? "undefined" : (0, 
        _typeof3.default)(superClass)));
        subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), superClass && (_setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass);
    };
}, /* 23 */
/***/
function(module, exports, __webpack_require__) {
    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
    /*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
    /* global define */
    !function() {
        "use strict";
        function classNames() {
            for (var classes = [], i = 0; i < arguments.length; i++) {
                var arg = arguments[i];
                if (arg) {
                    var argType = typeof arg;
                    if ("string" === argType || "number" === argType) classes.push(arg); else if (Array.isArray(arg)) classes.push(classNames.apply(null, arg)); else if ("object" === argType) for (var key in arg) hasOwn.call(arg, key) && arg[key] && classes.push(key);
                }
            }
            return classes.join(" ");
        }
        var hasOwn = {}.hasOwnProperty;
        void 0 !== module && module.exports ? module.exports = classNames : (__WEBPACK_AMD_DEFINE_ARRAY__ = [], 
        void 0 !== (__WEBPACK_AMD_DEFINE_RESULT__ = function() {
            return classNames;
        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }();
}, /* 24 */
/***/
function(module, exports) {
    function cssWithMappingToString(item, useSourceMap) {
        var content = item[1] || "", cssMapping = item[3];
        if (!cssMapping) return content;
        if (useSourceMap && "function" == typeof btoa) {
            var sourceMapping = toComment(cssMapping);
            return [ content ].concat(cssMapping.sources.map(function(source) {
                return "/*# sourceURL=" + cssMapping.sourceRoot + source + " */";
            })).concat([ sourceMapping ]).join("\n");
        }
        return [ content ].join("\n");
    }
    // Adapted from convert-source-map (MIT)
    function toComment(sourceMap) {
        return "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
    }
    /*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
    // css base code, injected by the css-loader
    module.exports = function(useSourceMap) {
        var list = [];
        // return the list of modules as css string
        // import a list of modules into the list
        return list.toString = function() {
            return this.map(function(item) {
                var content = cssWithMappingToString(item, useSourceMap);
                return item[2] ? "@media " + item[2] + "{" + content + "}" : content;
            }).join("");
        }, list.i = function(modules, mediaQuery) {
            "string" == typeof modules && (modules = [ [ null, modules, "" ] ]);
            for (var alreadyImportedModules = {}, i = 0; i < this.length; i++) {
                var id = this[i][0];
                "number" == typeof id && (alreadyImportedModules[id] = !0);
            }
            for (i = 0; i < modules.length; i++) {
                var item = modules[i];
                // skip already imported module
                // this implementation is not 100% perfect for weird media query combinations
                //  when a module is imported multiple times with different media queries.
                //  I hope this will never occur (Hey this way we have smaller bundles)
                "number" == typeof item[0] && alreadyImportedModules[item[0]] || (mediaQuery && !item[2] ? item[2] = mediaQuery : mediaQuery && (item[2] = "(" + item[2] + ") and (" + mediaQuery + ")"), 
                list.push(item));
            }
        }, list;
    };
}, /* 25 */
/***/
function(module, exports, __webpack_require__) {
    var dP = __webpack_require__(9), createDesc = __webpack_require__(41);
    module.exports = __webpack_require__(13) ? function(object, key, value) {
        return dP.f(object, key, createDesc(1, value));
    } : function(object, key, value) {
        return object[key] = value, object;
    };
}, /* 26 */
/***/
function(module, exports, __webpack_require__) {
    var isObject = __webpack_require__(27);
    module.exports = function(it) {
        if (!isObject(it)) throw TypeError(it + " is not an object!");
        return it;
    };
}, /* 27 */
/***/
function(module, exports) {
    module.exports = function(it) {
        return "object" == typeof it ? null !== it : "function" == typeof it;
    };
}, /* 28 */
/***/
function(module, exports) {
    var g;
    // This works in non-strict mode
    g = function() {
        return this;
    }();
    try {
        // This works if eval is allowed (see CSP)
        g = g || Function("return this")() || (0, eval)("this");
    } catch (e) {
        // This works if the window reference is available
        "object" == typeof window && (g = window);
    }
    // g can still be undefined, but nothing to do about it...
    // We return undefined, instead of nothing here, so it's
    // easier to handle this case. if(!global) { ...}
    module.exports = g;
}, /* 29 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _Constants = __webpack_require__(270);
    Object.keys(_Constants).forEach(function(key) {
        "default" !== key && "__esModule" !== key && Object.defineProperty(exports, key, {
            enumerable: !0,
            get: function() {
                return _Constants[key];
            }
        });
    }), Object.defineProperty(exports, "Constants", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_Constants).default;
        }
    });
    var _getEntityRanges = __webpack_require__(271);
    Object.defineProperty(exports, "getEntityRanges", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_getEntityRanges).default;
        }
    });
    var _getSelectedBlocks = __webpack_require__(92);
    Object.defineProperty(exports, "getSelectedBlocks", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_getSelectedBlocks).default;
        }
    });
    var _selectionContainsEntity = __webpack_require__(272);
    Object.defineProperty(exports, "selectionContainsEntity", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_selectionContainsEntity).default;
        }
    });
    var _callModifierForSelectedBlocks = __webpack_require__(273);
    Object.defineProperty(exports, "callModifierForSelectedBlocks", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_callModifierForSelectedBlocks).default;
        }
    });
}, /* 30 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function isExcluded(methodName) {
        return !0 === REACT_EXCLUDE_METHODS[methodName];
    }
    function isFunction(item) {
        return "function" == typeof item;
    }
    function autobind(instance, proto) {
        null == proto && (proto = Object.getPrototypeOf(instance));
        for (var propertyNames = Object.getOwnPropertyNames(proto), _iterator = propertyNames, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
            var _ref;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                if (_i = _iterator.next(), _i.done) break;
                _ref = _i.value;
            }
            var name = _ref;
            isFunction(proto[name]) && !isExcluded(name) && (instance[name] = proto[name].bind(instance));
        }
    }
    exports.__esModule = !0, exports.default = autobind;
    // The following React methods should not be automatically bound.
    var REACT_EXCLUDE_METHODS = {
        getChildContext: !0,
        render: !0,
        componentWillMount: !0,
        componentDidMount: !0,
        componentWillReceiveProps: !0,
        shouldComponentUpdate: !0,
        componentWillUpdate: !0,
        componentDidUpdate: !0,
        componentWillUnmount: !0
    };
}, /* 31 */
/***/
function(module, exports, __webpack_require__) {
    // optional / simple context binding
    var aFunction = __webpack_require__(97);
    module.exports = function(fn, that, length) {
        if (aFunction(fn), void 0 === that) return fn;
        switch (length) {
          case 1:
            return function(a) {
                return fn.call(that, a);
            };

          case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };

          case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
        }
        return function() {
            return fn.apply(that, arguments);
        };
    };
}, /* 32 */
/***/
function(module, exports) {
    module.exports = function(exec) {
        try {
            return !!exec();
        } catch (e) {
            return !0;
        }
    };
}, /* 33 */
/***/
function(module, exports) {
    var hasOwnProperty = {}.hasOwnProperty;
    module.exports = function(it, key) {
        return hasOwnProperty.call(it, key);
    };
}, /* 34 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ContentBlock
 * 
 */
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !call || "object" != typeof call && "function" != typeof call ? self : call;
    }
    function _inherits(subClass, superClass) {
        if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
    }
    function haveEqualStyle(charA, charB) {
        return charA.getStyle() === charB.getStyle();
    }
    function haveEqualEntity(charA, charB) {
        return charA.getEntity() === charB.getEntity();
    }
    var Immutable = __webpack_require__(1), findRangesImmutable = __webpack_require__(56), List = Immutable.List, Map = Immutable.Map, OrderedSet = Immutable.OrderedSet, Record = Immutable.Record, EMPTY_SET = OrderedSet(), defaultRecord = {
        key: "",
        type: "unstyled",
        text: "",
        characterList: List(),
        depth: 0,
        data: Map()
    }, ContentBlockRecord = Record(defaultRecord), ContentBlock = function(_ContentBlockRecord) {
        function ContentBlock() {
            return _classCallCheck(this, ContentBlock), _possibleConstructorReturn(this, _ContentBlockRecord.apply(this, arguments));
        }
        /**
   * Execute a callback for every contiguous range of styles within the block.
   */
        /**
   * Execute a callback for every contiguous range of entities within the block.
   */
        return _inherits(ContentBlock, _ContentBlockRecord), ContentBlock.prototype.getKey = function() {
            return this.get("key");
        }, ContentBlock.prototype.getType = function() {
            return this.get("type");
        }, ContentBlock.prototype.getText = function() {
            return this.get("text");
        }, ContentBlock.prototype.getCharacterList = function() {
            return this.get("characterList");
        }, ContentBlock.prototype.getLength = function() {
            return this.getText().length;
        }, ContentBlock.prototype.getDepth = function() {
            return this.get("depth");
        }, ContentBlock.prototype.getData = function() {
            return this.get("data");
        }, ContentBlock.prototype.getInlineStyleAt = function(offset) {
            var character = this.getCharacterList().get(offset);
            return character ? character.getStyle() : EMPTY_SET;
        }, ContentBlock.prototype.getEntityAt = function(offset) {
            var character = this.getCharacterList().get(offset);
            return character ? character.getEntity() : null;
        }, ContentBlock.prototype.findStyleRanges = function(filterFn, callback) {
            findRangesImmutable(this.getCharacterList(), haveEqualStyle, filterFn, callback);
        }, ContentBlock.prototype.findEntityRanges = function(filterFn, callback) {
            findRangesImmutable(this.getCharacterList(), haveEqualEntity, filterFn, callback);
        }, ContentBlock;
    }(ContentBlockRecord);
    module.exports = ContentBlock;
}, /* 35 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function toObject(val) {
        if (null === val || void 0 === val) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(val);
    }
    /*
object-assign
(c) Sindre Sorhus
@license MIT
*/
    /* eslint-disable no-unused-vars */
    var getOwnPropertySymbols = Object.getOwnPropertySymbols, hasOwnProperty = Object.prototype.hasOwnProperty, propIsEnumerable = Object.prototype.propertyIsEnumerable;
    module.exports = function() {
        try {
            if (!Object.assign) return !1;
            // Detect buggy property enumeration order in older V8 versions.
            // https://bugs.chromium.org/p/v8/issues/detail?id=4118
            var test1 = new String("abc");
            if (// eslint-disable-line no-new-wrappers
            test1[5] = "de", "5" === Object.getOwnPropertyNames(test1)[0]) return !1;
            for (var test2 = {}, i = 0; i < 10; i++) test2["_" + String.fromCharCode(i)] = i;
            if ("0123456789" !== Object.getOwnPropertyNames(test2).map(function(n) {
                return test2[n];
            }).join("")) return !1;
            // https://bugs.chromium.org/p/v8/issues/detail?id=3056
            var test3 = {};
            return "abcdefghijklmnopqrst".split("").forEach(function(letter) {
                test3[letter] = letter;
            }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, test3)).join("");
        } catch (err) {
            // We don't expect any of the above to throw, but better to be safe.
            return !1;
        }
    }() ? Object.assign : function(target, source) {
        for (var from, symbols, to = toObject(target), s = 1; s < arguments.length; s++) {
            from = Object(arguments[s]);
            for (var key in from) hasOwnProperty.call(from, key) && (to[key] = from[key]);
            if (getOwnPropertySymbols) {
                symbols = getOwnPropertySymbols(from);
                for (var i = 0; i < symbols.length; i++) propIsEnumerable.call(from, symbols[i]) && (to[symbols[i]] = from[symbols[i]]);
            }
        }
        return to;
    };
}, /* 36 */
/***/
function(module, exports) {
    module.exports = require("react-dom");
}, /* 37 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * @param {number} codeUnit   A Unicode code-unit, in range [0, 0x10FFFF]
 * @return {boolean}          Whether code-unit is in a surrogate (hi/low) range
 */
    function isCodeUnitInSurrogateRange(codeUnit) {
        return SURROGATE_HIGH_START <= codeUnit && codeUnit <= SURROGATE_LOW_END;
    }
    /**
 * Returns whether the two characters starting at `index` form a surrogate pair.
 * For example, given the string s = "\uD83D\uDE0A", (s, 0) returns true and
 * (s, 1) returns false.
 *
 * @param {string} str
 * @param {number} index
 * @return {boolean}
 */
    function isSurrogatePair(str, index) {
        if (0 <= index && index < str.length || invariant(!1), index + 1 === str.length) return !1;
        var first = str.charCodeAt(index), second = str.charCodeAt(index + 1);
        return SURROGATE_HIGH_START <= first && first <= SURROGATE_HIGH_END && SURROGATE_LOW_START <= second && second <= SURROGATE_LOW_END;
    }
    /**
 * @param {string} str  Non-empty string
 * @return {boolean}    True if the input includes any surrogate code units
 */
    function hasSurrogateUnit(str) {
        return SURROGATE_UNITS_REGEX.test(str);
    }
    /**
 * Return the length of the original Unicode character at given position in the
 * String by looking into the UTF-16 code unit; that is equal to 1 for any
 * non-surrogate characters in BMP ([U+0000..U+D7FF] and [U+E000, U+FFFF]); and
 * returns 2 for the hi/low surrogates ([U+D800..U+DFFF]), which are in fact
 * representing non-BMP characters ([U+10000..U+10FFFF]).
 *
 * Examples:
 * - '\u0020' => 1
 * - '\u3020' => 1
 * - '\uD835' => 2
 * - '\uD835\uDDEF' => 2
 * - '\uDDEF' => 2
 *
 * @param {string} str  Non-empty string
 * @param {number} pos  Position in the string to look for one code unit
 * @return {number}      Number 1 or 2
 */
    function getUTF16Length(str, pos) {
        return 1 + isCodeUnitInSurrogateRange(str.charCodeAt(pos));
    }
    /**
 * Fully Unicode-enabled replacement for String#length
 *
 * @param {string} str  Valid Unicode string
 * @return {number}     The number of Unicode characters in the string
 */
    function strlen(str) {
        // Call the native functions if there's no surrogate char
        if (!hasSurrogateUnit(str)) return str.length;
        for (var len = 0, pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) len++;
        return len;
    }
    /**
 * Fully Unicode-enabled replacement for String#substr()
 *
 * @param {string} str      Valid Unicode string
 * @param {number} start    Location in Unicode sequence to begin extracting
 * @param {?number} length  The number of Unicode characters to extract
 *                          (default: to the end of the string)
 * @return {string}         Extracted sub-string
 */
    function substr(str, start, length) {
        // Call the native functions if there's no surrogate char
        if (start = start || 0, length = void 0 === length ? 1 / 0 : length || 0, !hasSurrogateUnit(str)) return str.substr(start, length);
        // Obvious cases
        var size = str.length;
        if (size <= 0 || start > size || length <= 0) return "";
        // Find the actual starting position
        var posA = 0;
        if (start > 0) {
            for (;start > 0 && posA < size; start--) posA += getUTF16Length(str, posA);
            if (posA >= size) return "";
        } else if (start < 0) {
            for (posA = size; start < 0 && 0 < posA; start++) posA -= getUTF16Length(str, posA - 1);
            posA < 0 && (posA = 0);
        }
        // Find the actual ending position
        var posB = size;
        if (length < size) for (posB = posA; length > 0 && posB < size; length--) posB += getUTF16Length(str, posB);
        return str.substring(posA, posB);
    }
    /**
 * Fully Unicode-enabled replacement for String#substring()
 *
 * @param {string} str    Valid Unicode string
 * @param {number} start  Location in Unicode sequence to begin extracting
 * @param {?number} end   Location in Unicode sequence to end extracting
 *                        (default: end of the string)
 * @return {string}       Extracted sub-string
 */
    function substring(str, start, end) {
        start = start || 0, end = void 0 === end ? 1 / 0 : end || 0, start < 0 && (start = 0), 
        end < 0 && (end = 0);
        var length = Math.abs(end - start);
        return start = start < end ? start : end, substr(str, start, length);
    }
    /**
 * Get a list of Unicode code-points from a String
 *
 * @param {string} str        Valid Unicode string
 * @return {array<number>}    A list of code-points in [0..0x10FFFF]
 */
    function getCodePoints(str) {
        for (var codePoints = [], pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) codePoints.push(str.codePointAt(pos));
        return codePoints;
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */
    /**
 * Unicode-enabled replacesments for basic String functions.
 *
 * All the functions in this module assume that the input string is a valid
 * UTF-16 encoding of a Unicode sequence. If it's not the case, the behavior
 * will be undefined.
 *
 * WARNING: Since this module is typechecks-enforced, you may find new bugs
 * when replacing normal String functions with ones provided here.
 */
    var invariant = __webpack_require__(2), SURROGATE_HIGH_START = 55296, SURROGATE_HIGH_END = 56319, SURROGATE_LOW_START = 56320, SURROGATE_LOW_END = 57343, SURROGATE_UNITS_REGEX = /[\uD800-\uDFFF]/, UnicodeUtils = {
        getCodePoints: getCodePoints,
        getUTF16Length: getUTF16Length,
        hasSurrogateUnit: hasSurrogateUnit,
        isCodeUnitInSurrogateRange: isCodeUnitInSurrogateRange,
        isSurrogatePair: isSurrogatePair,
        strlen: strlen,
        substring: substring,
        substr: substr
    };
    module.exports = UnicodeUtils;
}, /* 38 */
/***/
function(module, exports, __webpack_require__) {
    // to indexed object, toObject with fallback for non-array-like ES3 strings
    var IObject = __webpack_require__(66), defined = __webpack_require__(68);
    module.exports = function(it) {
        return IObject(defined(it));
    };
}, /* 39 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    exports.__esModule = !0, exports.default = function(obj, keys) {
        var target = {};
        for (var i in obj) keys.indexOf(i) >= 0 || Object.prototype.hasOwnProperty.call(obj, i) && (target[i] = obj[i]);
        return target;
    };
}, /* 40 */
/***/
function(module, exports) {
    module.exports = {};
}, /* 41 */
/***/
function(module, exports) {
    module.exports = function(bitmap, value) {
        return {
            enumerable: !(1 & bitmap),
            configurable: !(2 & bitmap),
            writable: !(4 & bitmap),
            value: value
        };
    };
}, /* 42 */
/***/
function(module, exports, __webpack_require__) {
    // 7.1.13 ToObject(argument)
    var defined = __webpack_require__(68);
    module.exports = function(it) {
        return Object(defined(it));
    };
}, /* 43 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    var $at = __webpack_require__(157)(!0);
    // 21.1.3.27 String.prototype[@@iterator]()
    __webpack_require__(75)(String, "String", function(iterated) {
        this._t = String(iterated), // target
        this._i = 0;
    }, function() {
        var point, O = this._t, index = this._i;
        return index >= O.length ? {
            value: void 0,
            done: !0
        } : (point = $at(O, index), this._i += point.length, {
            value: point,
            done: !1
        });
    });
}, /* 44 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule BlockMapBuilder
 * 
 */
    var Immutable = __webpack_require__(1), OrderedMap = Immutable.OrderedMap, BlockMapBuilder = {
        createFromArray: function(blocks) {
            return OrderedMap(blocks.map(function(block) {
                return [ block.getKey(), block ];
            }));
        }
    };
    module.exports = BlockMapBuilder;
}, /* 45 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SelectionState
 * @typechecks
 * 
 */
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !call || "object" != typeof call && "function" != typeof call ? self : call;
    }
    function _inherits(subClass, superClass) {
        if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
    }
    var Immutable = __webpack_require__(1), Record = Immutable.Record, defaultRecord = {
        anchorKey: "",
        anchorOffset: 0,
        focusKey: "",
        focusOffset: 0,
        isBackward: !1,
        hasFocus: !1
    }, SelectionStateRecord = Record(defaultRecord), SelectionState = function(_SelectionStateRecord) {
        function SelectionState() {
            return _classCallCheck(this, SelectionState), _possibleConstructorReturn(this, _SelectionStateRecord.apply(this, arguments));
        }
        /**
   * Return whether the specified range overlaps with an edge of the
   * SelectionState.
   */
        return _inherits(SelectionState, _SelectionStateRecord), SelectionState.prototype.serialize = function() {
            return "Anchor: " + this.getAnchorKey() + ":" + this.getAnchorOffset() + ", Focus: " + this.getFocusKey() + ":" + this.getFocusOffset() + ", Is Backward: " + String(this.getIsBackward()) + ", Has Focus: " + String(this.getHasFocus());
        }, SelectionState.prototype.getAnchorKey = function() {
            return this.get("anchorKey");
        }, SelectionState.prototype.getAnchorOffset = function() {
            return this.get("anchorOffset");
        }, SelectionState.prototype.getFocusKey = function() {
            return this.get("focusKey");
        }, SelectionState.prototype.getFocusOffset = function() {
            return this.get("focusOffset");
        }, SelectionState.prototype.getIsBackward = function() {
            return this.get("isBackward");
        }, SelectionState.prototype.getHasFocus = function() {
            return this.get("hasFocus");
        }, SelectionState.prototype.hasEdgeWithin = function(blockKey, start, end) {
            var anchorKey = this.getAnchorKey(), focusKey = this.getFocusKey();
            if (anchorKey === focusKey && anchorKey === blockKey) {
                var selectionStart = this.getStartOffset();
                return start <= this.getEndOffset() && selectionStart <= end;
            }
            if (blockKey !== anchorKey && blockKey !== focusKey) return !1;
            var offsetToCheck = blockKey === anchorKey ? this.getAnchorOffset() : this.getFocusOffset();
            return start <= offsetToCheck && end >= offsetToCheck;
        }, SelectionState.prototype.isCollapsed = function() {
            return this.getAnchorKey() === this.getFocusKey() && this.getAnchorOffset() === this.getFocusOffset();
        }, SelectionState.prototype.getStartKey = function() {
            return this.getIsBackward() ? this.getFocusKey() : this.getAnchorKey();
        }, SelectionState.prototype.getStartOffset = function() {
            return this.getIsBackward() ? this.getFocusOffset() : this.getAnchorOffset();
        }, SelectionState.prototype.getEndKey = function() {
            return this.getIsBackward() ? this.getAnchorKey() : this.getFocusKey();
        }, SelectionState.prototype.getEndOffset = function() {
            return this.getIsBackward() ? this.getAnchorOffset() : this.getFocusOffset();
        }, SelectionState.createEmpty = function(key) {
            return new SelectionState({
                anchorKey: key,
                anchorOffset: 0,
                focusKey: key,
                focusOffset: 0,
                isBackward: !1,
                hasFocus: !1
            });
        }, SelectionState;
    }(SelectionStateRecord);
    module.exports = SelectionState;
}, /* 46 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */
    /**
 * This function is used to mark string literals representing CSS class names
 * so that they can be transformed statically. This allows for modularization
 * and minification of CSS class names.
 *
 * In static_upstream, this function is actually implemented, but it should
 * eventually be replaced with something more descriptive, and the transform
 * that is used in the main stack should be ported for use elsewhere.
 *
 * @param string|object className to modularize, or an object of key/values.
 *                      In the object case, the values are conditions that
 *                      determine if the className keys should be included.
 * @param [string ...]  Variable list of classNames in the string case.
 * @return string       Renderable space-separated CSS className.
 */
    function cx(classNames) {
        return "object" == typeof classNames ? Object.keys(classNames).filter(function(className) {
            return classNames[className];
        }).map(replace).join(" ") : Array.prototype.map.call(arguments, replace).join(" ");
    }
    function replace(str) {
        return str.replace(/\//g, "-");
    }
    module.exports = cx;
}, /* 47 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * For a collapsed selection state, remove text based on the specified strategy.
 * If the selection state is not collapsed, remove the entire selected range.
 */
    function removeTextWithStrategy(editorState, strategy, direction) {
        var selection = editorState.getSelection(), content = editorState.getCurrentContent(), target = selection;
        if (selection.isCollapsed()) {
            if ("forward" === direction) {
                if (editorState.isSelectionAtEndOfContent()) return content;
            } else if (editorState.isSelectionAtStartOfContent()) return content;
            if ((target = strategy(editorState)) === selection) return content;
        }
        return DraftModifier.removeRange(content, target, direction);
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule removeTextWithStrategy
 * 
 */
    var DraftModifier = __webpack_require__(5);
    module.exports = removeTextWithStrategy;
}, /* 48 */
/***/
function(module, exports, __webpack_require__) {
    // 19.1.2.14 / 15.2.3.14 Object.keys(O)
    var $keys = __webpack_require__(100), enumBugKeys = __webpack_require__(72);
    module.exports = Object.keys || function(O) {
        return $keys(O, enumBugKeys);
    };
}, /* 49 */
/***/
function(module, exports, __webpack_require__) {
    // 7.1.15 ToLength
    var toInteger = __webpack_require__(69), min = Math.min;
    module.exports = function(it) {
        return it > 0 ? min(toInteger(it), 9007199254740991) : 0;
    };
}, /* 50 */
/***/
function(module, exports) {
    var id = 0, px = Math.random();
    module.exports = function(key) {
        return "Symbol(".concat(void 0 === key ? "" : key, ")_", (++id + px).toString(36));
    };
}, /* 51 */
/***/
function(module, exports) {
    exports.f = {}.propertyIsEnumerable;
}, /* 52 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    exports.__esModule = !0;
    var _defineProperty = __webpack_require__(101), _defineProperty2 = function(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }(_defineProperty);
    exports.default = function(obj, key, value) {
        return key in obj ? (0, _defineProperty2.default)(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : obj[key] = value, obj;
    };
}, /* 53 */
/***/
function(module, exports, __webpack_require__) {
    // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
    var anObject = __webpack_require__(26), dPs = __webpack_require__(159), enumBugKeys = __webpack_require__(72), IE_PROTO = __webpack_require__(70)("IE_PROTO"), Empty = function() {}, createDict = function() {
        // Thrash, waste and sodomy: IE GC bug
        var iframeDocument, iframe = __webpack_require__(99)("iframe"), i = enumBugKeys.length;
        for (iframe.style.display = "none", __webpack_require__(160).appendChild(iframe), 
        iframe.src = "javascript:", // eslint-disable-line no-script-url
        // createDict = iframe.contentWindow.Object;
        // html.removeChild(iframe);
        iframeDocument = iframe.contentWindow.document, iframeDocument.open(), iframeDocument.write("<script>document.F=Object<\/script>"), 
        iframeDocument.close(), createDict = iframeDocument.F; i--; ) delete createDict.prototype[enumBugKeys[i]];
        return createDict();
    };
    module.exports = Object.create || function(O, Properties) {
        var result;
        // add "__proto__" for Object.getPrototypeOf polyfill
        return null !== O ? (Empty.prototype = anObject(O), result = new Empty(), Empty.prototype = null, 
        result[IE_PROTO] = O) : result = createDict(), void 0 === Properties ? result : dPs(result, Properties);
    };
}, /* 54 */
/***/
function(module, exports, __webpack_require__) {
    var def = __webpack_require__(9).f, has = __webpack_require__(33), TAG = __webpack_require__(6)("toStringTag");
    module.exports = function(it, tag, stat) {
        it && !has(it = stat ? it : it.prototype, TAG) && def(it, TAG, {
            configurable: !0,
            value: tag
        });
    };
}, /* 55 */
/***/
function(module, exports, __webpack_require__) {
    __webpack_require__(161);
    for (var global = __webpack_require__(12), hide = __webpack_require__(25), Iterators = __webpack_require__(40), TO_STRING_TAG = __webpack_require__(6)("toStringTag"), DOMIterables = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","), i = 0; i < DOMIterables.length; i++) {
        var NAME = DOMIterables[i], Collection = global[NAME], proto = Collection && Collection.prototype;
        proto && !proto[TO_STRING_TAG] && hide(proto, TO_STRING_TAG, NAME), Iterators[NAME] = Iterators.Array;
    }
}, /* 56 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule findRangesImmutable
 * 
 */
    /**
 * Search through an array to find contiguous stretches of elements that
 * match a specified filter function.
 *
 * When ranges are found, execute a specified `found` function to supply
 * the values to the caller.
 */
    function findRangesImmutable(haystack, areEqualFn, filterFn, foundFn) {
        if (haystack.size) {
            var cursor = 0;
            haystack.reduce(function(value, nextValue, nextIndex) {
                return areEqualFn(value, nextValue) || (filterFn(value) && foundFn(cursor, nextIndex), 
                cursor = nextIndex), nextValue;
            }), filterFn(haystack.last()) && foundFn(cursor, haystack.count());
        }
    }
    module.exports = findRangesImmutable;
}, /* 57 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function getContentStateFragment(contentState, selectionState) {
        var startKey = selectionState.getStartKey(), startOffset = selectionState.getStartOffset(), endKey = selectionState.getEndKey(), endOffset = selectionState.getEndOffset(), contentWithoutEdgeEntities = removeEntitiesAtEdges(contentState, selectionState), blockMap = contentWithoutEdgeEntities.getBlockMap(), blockKeys = blockMap.keySeq(), startIndex = blockKeys.indexOf(startKey), endIndex = blockKeys.indexOf(endKey) + 1;
        return blockMap.slice(startIndex, endIndex).map(function(block, blockKey) {
            var newKey = generateRandomKey(), text = block.getText(), chars = block.getCharacterList();
            return startKey === endKey ? block.merge({
                key: newKey,
                text: text.slice(startOffset, endOffset),
                characterList: chars.slice(startOffset, endOffset)
            }) : blockKey === startKey ? block.merge({
                key: newKey,
                text: text.slice(startOffset),
                characterList: chars.slice(startOffset)
            }) : blockKey === endKey ? block.merge({
                key: newKey,
                text: text.slice(0, endOffset),
                characterList: chars.slice(0, endOffset)
            }) : block.set("key", newKey);
        }).toOrderedMap();
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getContentStateFragment
 * @typechecks
 * 
 */
    var generateRandomKey = __webpack_require__(16), removeEntitiesAtEdges = __webpack_require__(110);
    module.exports = getContentStateFragment;
}, /* 58 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Temporary utility for generating the warnings
 */
    function logWarning(oldMethodCall, newMethodCall) {
        console.warn("WARNING: " + oldMethodCall + ' will be deprecated soon!\nPlease use "' + newMethodCall + '" instead.');
    }
    var _assign = __webpack_require__(35), _extends = _assign || function(target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
        }
        return target;
    }, DraftEntityInstance = __webpack_require__(113), Immutable = __webpack_require__(1), invariant = __webpack_require__(2), Map = Immutable.Map, instances = Map(), instanceKey = 0, DraftEntity = {
        /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.getLastCreatedEntityKey' instead.
   * ---
   * Get the random key string from whatever entity was last created.
   * We need this to support the new API, as part of transitioning to put Entity
   * storage in contentState.
   */
        getLastCreatedEntityKey: function() {
            return logWarning("DraftEntity.getLastCreatedEntityKey", "contentState.getLastCreatedEntityKey"), 
            DraftEntity.__getLastCreatedEntityKey();
        },
        /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.createEntity' instead.
   * ---
   * Create a DraftEntityInstance and store it for later retrieval.
   *
   * A random key string will be generated and returned. This key may
   * be used to track the entity's usage in a ContentBlock, and for
   * retrieving data about the entity at render time.
   */
        create: function(type, mutability, data) {
            return logWarning("DraftEntity.create", "contentState.createEntity"), DraftEntity.__create(type, mutability, data);
        },
        /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.addEntity' instead.
   * ---
   * Add an existing DraftEntityInstance to the DraftEntity map. This is
   * useful when restoring instances from the server.
   */
        add: function(instance) {
            return logWarning("DraftEntity.add", "contentState.addEntity"), DraftEntity.__add(instance);
        },
        /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.getEntity' instead.
   * ---
   * Retrieve the entity corresponding to the supplied key string.
   */
        get: function(key) {
            return logWarning("DraftEntity.get", "contentState.getEntity"), DraftEntity.__get(key);
        },
        /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.mergeEntityData' instead.
   * ---
   * Entity instances are immutable. If you need to update the data for an
   * instance, this method will merge your data updates and return a new
   * instance.
   */
        mergeData: function(key, toMerge) {
            return logWarning("DraftEntity.mergeData", "contentState.mergeEntityData"), DraftEntity.__mergeData(key, toMerge);
        },
        /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.replaceEntityData' instead.
   * ---
   * Completely replace the data for a given instance.
   */
        replaceData: function(key, newData) {
            return logWarning("DraftEntity.replaceData", "contentState.replaceEntityData"), 
            DraftEntity.__replaceData(key, newData);
        },
        // ***********************************WARNING******************************
        // --- the above public API will be deprecated in the next version of Draft!
        // The methods below this line are private - don't call them directly.
        /**
   * Get the random key string from whatever entity was last created.
   * We need this to support the new API, as part of transitioning to put Entity
   * storage in contentState.
   */
        __getLastCreatedEntityKey: function() {
            return "" + instanceKey;
        },
        /**
   * Create a DraftEntityInstance and store it for later retrieval.
   *
   * A random key string will be generated and returned. This key may
   * be used to track the entity's usage in a ContentBlock, and for
   * retrieving data about the entity at render time.
   */
        __create: function(type, mutability, data) {
            return DraftEntity.__add(new DraftEntityInstance({
                type: type,
                mutability: mutability,
                data: data || {}
            }));
        },
        /**
   * Add an existing DraftEntityInstance to the DraftEntity map. This is
   * useful when restoring instances from the server.
   */
        __add: function(instance) {
            var key = "" + ++instanceKey;
            return instances = instances.set(key, instance), key;
        },
        /**
   * Retrieve the entity corresponding to the supplied key string.
   */
        __get: function(key) {
            var instance = instances.get(key);
            return instance || invariant(!1), instance;
        },
        /**
   * Entity instances are immutable. If you need to update the data for an
   * instance, this method will merge your data updates and return a new
   * instance.
   */
        __mergeData: function(key, toMerge) {
            var instance = DraftEntity.__get(key), newData = _extends({}, instance.getData(), toMerge), newInstance = instance.set("data", newData);
            return instances = instances.set(key, newInstance), newInstance;
        },
        /**
   * Completely replace the data for a given instance.
   */
        __replaceData: function(key, newData) {
            var instance = DraftEntity.__get(key), newInstance = instance.set("data", newData);
            return instances = instances.set(key, newInstance), newInstance;
        }
    };
    module.exports = DraftEntity;
}, /* 59 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */
    module.exports = {
        BACKSPACE: 8,
        TAB: 9,
        RETURN: 13,
        ALT: 18,
        ESC: 27,
        SPACE: 32,
        PAGE_UP: 33,
        PAGE_DOWN: 34,
        END: 35,
        HOME: 36,
        LEFT: 37,
        UP: 38,
        RIGHT: 39,
        DOWN: 40,
        DELETE: 46,
        COMMA: 188,
        PERIOD: 190,
        A: 65,
        Z: 90,
        ZERO: 48,
        NUMPAD_0: 96,
        NUMPAD_9: 105
    };
}, /* 60 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftOffsetKey
 * 
 */
    var DraftOffsetKey = {
        encode: function(blockKey, decoratorKey, leafKey) {
            return blockKey + "-" + decoratorKey + "-" + leafKey;
        },
        decode: function(offsetKey) {
            var _offsetKey$split = offsetKey.split("-"), blockKey = _offsetKey$split[0], decoratorKey = _offsetKey$split[1], leafKey = _offsetKey$split[2];
            return {
                blockKey: blockKey,
                decoratorKey: parseInt(decoratorKey, 10),
                leafKey: parseInt(leafKey, 10)
            };
        }
    };
    module.exports = DraftOffsetKey;
}, /* 61 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isEventHandled
 * @typechecks
 * 
 */
    /**
 * Utility method for determining whether or not the value returned
 * from a handler indicates that it was handled.
 */
    function isEventHandled(value) {
        return "handled" === value || !0 === value;
    }
    module.exports = isEventHandled;
}, /* 62 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule KeyBindingUtil
 * @typechecks
 * 
 */
    var UserAgent = __webpack_require__(17), isOSX = UserAgent.isPlatform("Mac OS X"), KeyBindingUtil = {
        /**
   * Check whether the ctrlKey modifier is *not* being used in conjunction with
   * the altKey modifier. If they are combined, the result is an `altGraph`
   * key modifier, which should not be handled by this set of key bindings.
   */
        isCtrlKeyCommand: function(e) {
            return !!e.ctrlKey && !e.altKey;
        },
        isOptionKeyCommand: function(e) {
            return isOSX && e.altKey;
        },
        hasCommandModifier: function(e) {
            return isOSX ? !!e.metaKey && !e.altKey : KeyBindingUtil.isCtrlKeyCommand(e);
        }
    };
    module.exports = KeyBindingUtil;
}, /* 63 */
/***/
function(module, exports, __webpack_require__) {
    var ctx = __webpack_require__(31), call = __webpack_require__(134), isArrayIter = __webpack_require__(135), anObject = __webpack_require__(26), toLength = __webpack_require__(49), getIterFn = __webpack_require__(93), BREAK = {}, RETURN = {}, exports = module.exports = function(iterable, entries, fn, that, ITERATOR) {
        var length, step, iterator, result, iterFn = ITERATOR ? function() {
            return iterable;
        } : getIterFn(iterable), f = ctx(fn, that, entries ? 2 : 1), index = 0;
        if ("function" != typeof iterFn) throw TypeError(iterable + " is not iterable!");
        // fast case for arrays with default iterator
        if (isArrayIter(iterFn)) {
            for (length = toLength(iterable.length); length > index; index++) if ((result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index])) === BREAK || result === RETURN) return result;
        } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done; ) if ((result = call(iterator, f, step.value, entries)) === BREAK || result === RETURN) return result;
    };
    exports.BREAK = BREAK, exports.RETURN = RETURN;
}, /* 64 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _defineProperty2 = __webpack_require__(52), _defineProperty3 = _interopRequireDefault(_defineProperty2), _objectWithoutProperties2 = __webpack_require__(39), _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2), _getPrototypeOf = __webpack_require__(20), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(14), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(15), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(21), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(22), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(3), _react2 = _interopRequireDefault(_react), _classnames = __webpack_require__(23), _classnames2 = _interopRequireDefault(_classnames), _Button = __webpack_require__(139), _Button2 = _interopRequireDefault(_Button), _ButtonWrap = __webpack_require__(301), _ButtonWrap2 = _interopRequireDefault(_ButtonWrap), _IconButton = __webpack_require__(304), _IconButton2 = _interopRequireDefault(_IconButton), IconButton = function(_Component) {
        function IconButton() {
            return (0, _classCallCheck3.default)(this, IconButton), (0, _possibleConstructorReturn3.default)(this, (IconButton.__proto__ || (0, 
            _getPrototypeOf2.default)(IconButton)).apply(this, arguments));
        }
        return (0, _inherits3.default)(IconButton, _Component), (0, _createClass3.default)(IconButton, [ {
            key: "render",
            value: function() {
                var _cx, props = this.props, className = props.className, iconName = props.iconName, label = props.label, children = props.children, isActive = props.isActive, otherProps = (0, 
                _objectWithoutProperties3.default)(props, [ "className", "iconName", "label", "children", "isActive" ]);
                return className = (0, _classnames2.default)(className, (_cx = {}, (0, _defineProperty3.default)(_cx, _IconButton2.default.root, !0), 
                (0, _defineProperty3.default)(_cx, _IconButton2.default.isActive, isActive), _cx)), 
                _react2.default.createElement(_ButtonWrap2.default, null, _react2.default.createElement(_Button2.default, (0, 
                _extends3.default)({}, otherProps, {
                    title: label,
                    className: className
                }), _react2.default.createElement("span", {
                    className: _IconButton2.default["icon-" + iconName]
                })), children);
            }
        } ]), IconButton;
    }(_react.Component);
    exports.default = IconButton;
}, /* 65 */
/***/
function(module, exports, __webpack_require__) {
    // 7.1.1 ToPrimitive(input [, PreferredType])
    var isObject = __webpack_require__(27);
    // instead of the ES6 spec version, we didn't implement @@toPrimitive case
    // and the second argument - flag - preferred type is a string
    module.exports = function(it, S) {
        if (!isObject(it)) return it;
        var fn, val;
        if (S && "function" == typeof (fn = it.toString) && !isObject(val = fn.call(it))) return val;
        if ("function" == typeof (fn = it.valueOf) && !isObject(val = fn.call(it))) return val;
        if (!S && "function" == typeof (fn = it.toString) && !isObject(val = fn.call(it))) return val;
        throw TypeError("Can't convert object to primitive value");
    };
}, /* 66 */
/***/
function(module, exports, __webpack_require__) {
    // fallback for non-array-like ES3 and non-enumerable old V8 strings
    var cof = __webpack_require__(67);
    // eslint-disable-next-line no-prototype-builtins
    module.exports = Object("z").propertyIsEnumerable(0) ? Object : function(it) {
        return "String" == cof(it) ? it.split("") : Object(it);
    };
}, /* 67 */
/***/
function(module, exports) {
    var toString = {}.toString;
    module.exports = function(it) {
        return toString.call(it).slice(8, -1);
    };
}, /* 68 */
/***/
function(module, exports) {
    // 7.2.1 RequireObjectCoercible(argument)
    module.exports = function(it) {
        if (void 0 == it) throw TypeError("Can't call method on  " + it);
        return it;
    };
}, /* 69 */
/***/
function(module, exports) {
    // 7.1.4 ToInteger
    var ceil = Math.ceil, floor = Math.floor;
    module.exports = function(it) {
        return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
    };
}, /* 70 */
/***/
function(module, exports, __webpack_require__) {
    var shared = __webpack_require__(71)("keys"), uid = __webpack_require__(50);
    module.exports = function(key) {
        return shared[key] || (shared[key] = uid(key));
    };
}, /* 71 */
/***/
function(module, exports, __webpack_require__) {
    var global = __webpack_require__(12), store = global["__core-js_shared__"] || (global["__core-js_shared__"] = {});
    module.exports = function(key) {
        return store[key] || (store[key] = {});
    };
}, /* 72 */
/***/
function(module, exports) {
    // IE 8- don't enum bug keys
    module.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
}, /* 73 */
/***/
function(module, exports) {
    exports.f = Object.getOwnPropertySymbols;
}, /* 74 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    exports.__esModule = !0;
    var _iterator = __webpack_require__(155), _iterator2 = _interopRequireDefault(_iterator), _symbol = __webpack_require__(163), _symbol2 = _interopRequireDefault(_symbol), _typeof = "function" == typeof _symbol2.default && "symbol" == typeof _iterator2.default ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof _symbol2.default && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj;
    };
    exports.default = "function" == typeof _symbol2.default && "symbol" === _typeof(_iterator2.default) ? function(obj) {
        return void 0 === obj ? "undefined" : _typeof(obj);
    } : function(obj) {
        return obj && "function" == typeof _symbol2.default && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : void 0 === obj ? "undefined" : _typeof(obj);
    };
}, /* 75 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    var LIBRARY = __webpack_require__(76), $export = __webpack_require__(7), redefine = __webpack_require__(103), hide = __webpack_require__(25), has = __webpack_require__(33), Iterators = __webpack_require__(40), $iterCreate = __webpack_require__(158), setToStringTag = __webpack_require__(54), getPrototypeOf = __webpack_require__(102), ITERATOR = __webpack_require__(6)("iterator"), BUGGY = !([].keys && "next" in [].keys()), returnThis = function() {
        return this;
    };
    module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
        $iterCreate(Constructor, NAME, next);
        var methods, key, IteratorPrototype, getMethod = function(kind) {
            if (!BUGGY && kind in proto) return proto[kind];
            switch (kind) {
              case "keys":
              case "values":
                return function() {
                    return new Constructor(this, kind);
                };
            }
            return function() {
                return new Constructor(this, kind);
            };
        }, TAG = NAME + " Iterator", DEF_VALUES = "values" == DEFAULT, VALUES_BUG = !1, proto = Base.prototype, $native = proto[ITERATOR] || proto["@@iterator"] || DEFAULT && proto[DEFAULT], $default = $native || getMethod(DEFAULT), $entries = DEFAULT ? DEF_VALUES ? getMethod("entries") : $default : void 0, $anyNative = "Array" == NAME ? proto.entries || $native : $native;
        if (// Fix native
        $anyNative && (IteratorPrototype = getPrototypeOf($anyNative.call(new Base()))) !== Object.prototype && IteratorPrototype.next && (// Set @@toStringTag to native iterators
        setToStringTag(IteratorPrototype, TAG, !0), // fix for some old engines
        LIBRARY || has(IteratorPrototype, ITERATOR) || hide(IteratorPrototype, ITERATOR, returnThis)), 
        // fix Array#{values, @@iterator}.name in V8 / FF
        DEF_VALUES && $native && "values" !== $native.name && (VALUES_BUG = !0, $default = function() {
            return $native.call(this);
        }), // Define iterator
        LIBRARY && !FORCED || !BUGGY && !VALUES_BUG && proto[ITERATOR] || hide(proto, ITERATOR, $default), 
        // Plug for library
        Iterators[NAME] = $default, Iterators[TAG] = returnThis, DEFAULT) if (methods = {
            values: DEF_VALUES ? $default : getMethod("values"),
            keys: IS_SET ? $default : getMethod("keys"),
            entries: $entries
        }, FORCED) for (key in methods) key in proto || redefine(proto, key, methods[key]); else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
        return methods;
    };
}, /* 76 */
/***/
function(module, exports) {
    module.exports = !0;
}, /* 77 */
/***/
function(module, exports, __webpack_require__) {
    exports.f = __webpack_require__(6);
}, /* 78 */
/***/
function(module, exports, __webpack_require__) {
    var META = __webpack_require__(50)("meta"), isObject = __webpack_require__(27), has = __webpack_require__(33), setDesc = __webpack_require__(9).f, id = 0, isExtensible = Object.isExtensible || function() {
        return !0;
    }, FREEZE = !__webpack_require__(32)(function() {
        return isExtensible(Object.preventExtensions({}));
    }), setMeta = function(it) {
        setDesc(it, META, {
            value: {
                i: "O" + ++id,
                // object ID
                w: {}
            }
        });
    }, fastKey = function(it, create) {
        // return primitive with prefix
        if (!isObject(it)) return "symbol" == typeof it ? it : ("string" == typeof it ? "S" : "P") + it;
        if (!has(it, META)) {
            // can't set metadata to uncaught frozen object
            if (!isExtensible(it)) return "F";
            // not necessary to add metadata
            if (!create) return "E";
            // add missing metadata
            setMeta(it);
        }
        return it[META].i;
    }, getWeak = function(it, create) {
        if (!has(it, META)) {
            // can't set metadata to uncaught frozen object
            if (!isExtensible(it)) return !0;
            // not necessary to add metadata
            if (!create) return !1;
            // add missing metadata
            setMeta(it);
        }
        return it[META].w;
    }, onFreeze = function(it) {
        return FREEZE && meta.NEED && isExtensible(it) && !has(it, META) && setMeta(it), 
        it;
    }, meta = module.exports = {
        KEY: META,
        NEED: !1,
        fastKey: fastKey,
        getWeak: getWeak,
        onFreeze: onFreeze
    };
}, /* 79 */
/***/
function(module, exports, __webpack_require__) {
    var global = __webpack_require__(12), core = __webpack_require__(4), LIBRARY = __webpack_require__(76), wksExt = __webpack_require__(77), defineProperty = __webpack_require__(9).f;
    module.exports = function(name) {
        var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
        "_" == name.charAt(0) || name in $Symbol || defineProperty($Symbol, name, {
            value: wksExt.f(name)
        });
    };
}, /* 80 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */
    function makeEmptyFunction(arg) {
        return function() {
            return arg;
        };
    }
    /**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
    var emptyFunction = function() {};
    emptyFunction.thatReturns = makeEmptyFunction, emptyFunction.thatReturnsFalse = makeEmptyFunction(!1), 
    emptyFunction.thatReturnsTrue = makeEmptyFunction(!0), emptyFunction.thatReturnsNull = makeEmptyFunction(null), 
    emptyFunction.thatReturnsThis = function() {
        return this;
    }, emptyFunction.thatReturnsArgument = function(arg) {
        return arg;
    }, module.exports = emptyFunction;
}, /* 81 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ContentState
 * @typechecks
 * 
 */
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !call || "object" != typeof call && "function" != typeof call ? self : call;
    }
    function _inherits(subClass, superClass) {
        if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
    }
    var BlockMapBuilder = __webpack_require__(44), CharacterMetadata = __webpack_require__(11), ContentBlock = __webpack_require__(34), DraftEntity = __webpack_require__(58), Immutable = __webpack_require__(1), SelectionState = __webpack_require__(45), generateRandomKey = __webpack_require__(16), sanitizeDraftText = __webpack_require__(82), List = Immutable.List, Record = Immutable.Record, Repeat = Immutable.Repeat, defaultRecord = {
        entityMap: null,
        blockMap: null,
        selectionBefore: null,
        selectionAfter: null
    }, ContentStateRecord = Record(defaultRecord), ContentState = function(_ContentStateRecord) {
        function ContentState() {
            return _classCallCheck(this, ContentState), _possibleConstructorReturn(this, _ContentStateRecord.apply(this, arguments));
        }
        return _inherits(ContentState, _ContentStateRecord), ContentState.prototype.getEntityMap = function() {
            // TODO: update this when we fully remove DraftEntity
            return DraftEntity;
        }, ContentState.prototype.getBlockMap = function() {
            return this.get("blockMap");
        }, ContentState.prototype.getSelectionBefore = function() {
            return this.get("selectionBefore");
        }, ContentState.prototype.getSelectionAfter = function() {
            return this.get("selectionAfter");
        }, ContentState.prototype.getBlockForKey = function(key) {
            return this.getBlockMap().get(key);
        }, ContentState.prototype.getKeyBefore = function(key) {
            return this.getBlockMap().reverse().keySeq().skipUntil(function(v) {
                return v === key;
            }).skip(1).first();
        }, ContentState.prototype.getKeyAfter = function(key) {
            return this.getBlockMap().keySeq().skipUntil(function(v) {
                return v === key;
            }).skip(1).first();
        }, ContentState.prototype.getBlockAfter = function(key) {
            return this.getBlockMap().skipUntil(function(_, k) {
                return k === key;
            }).skip(1).first();
        }, ContentState.prototype.getBlockBefore = function(key) {
            return this.getBlockMap().reverse().skipUntil(function(_, k) {
                return k === key;
            }).skip(1).first();
        }, ContentState.prototype.getBlocksAsArray = function() {
            return this.getBlockMap().toArray();
        }, ContentState.prototype.getFirstBlock = function() {
            return this.getBlockMap().first();
        }, ContentState.prototype.getLastBlock = function() {
            return this.getBlockMap().last();
        }, ContentState.prototype.getPlainText = function(delimiter) {
            return this.getBlockMap().map(function(block) {
                return block ? block.getText() : "";
            }).join(delimiter || "\n");
        }, ContentState.prototype.getLastCreatedEntityKey = function() {
            // TODO: update this when we fully remove DraftEntity
            return DraftEntity.__getLastCreatedEntityKey();
        }, ContentState.prototype.hasText = function() {
            var blockMap = this.getBlockMap();
            return blockMap.size > 1 || blockMap.first().getLength() > 0;
        }, ContentState.prototype.createEntity = function(type, mutability, data) {
            // TODO: update this when we fully remove DraftEntity
            return DraftEntity.__create(type, mutability, data), this;
        }, ContentState.prototype.mergeEntityData = function(key, toMerge) {
            // TODO: update this when we fully remove DraftEntity
            return DraftEntity.__mergeData(key, toMerge), this;
        }, ContentState.prototype.replaceEntityData = function(key, newData) {
            // TODO: update this when we fully remove DraftEntity
            return DraftEntity.__replaceData(key, newData), this;
        }, ContentState.prototype.addEntity = function(instance) {
            // TODO: update this when we fully remove DraftEntity
            return DraftEntity.__add(instance), this;
        }, ContentState.prototype.getEntity = function(key) {
            // TODO: update this when we fully remove DraftEntity
            return DraftEntity.__get(key);
        }, ContentState.createFromBlockArray = function(// TODO: update flow type when we completely deprecate the old entity API
        blocks, entityMap) {
            // TODO: remove this when we completely deprecate the old entity API
            var theBlocks = Array.isArray(blocks) ? blocks : blocks.contentBlocks, blockMap = BlockMapBuilder.createFromArray(theBlocks), selectionState = blockMap.isEmpty() ? new SelectionState() : SelectionState.createEmpty(blockMap.first().getKey());
            return new ContentState({
                blockMap: blockMap,
                entityMap: entityMap || DraftEntity,
                selectionBefore: selectionState,
                selectionAfter: selectionState
            });
        }, ContentState.createFromText = function(text) {
            var delimiter = arguments.length <= 1 || void 0 === arguments[1] ? /\r\n?|\n/g : arguments[1], strings = text.split(delimiter), blocks = strings.map(function(block) {
                return block = sanitizeDraftText(block), new ContentBlock({
                    key: generateRandomKey(),
                    text: block,
                    type: "unstyled",
                    characterList: List(Repeat(CharacterMetadata.EMPTY, block.length))
                });
            });
            return ContentState.createFromBlockArray(blocks);
        }, ContentState;
    }(ContentStateRecord);
    module.exports = ContentState;
}, /* 82 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function sanitizeDraftText(input) {
        return input.replace(REGEX_BLOCK_DELIMITER, "");
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule sanitizeDraftText
 * 
 */
    var REGEX_BLOCK_DELIMITER = new RegExp("\r", "g");
    module.exports = sanitizeDraftText;
}, /* 83 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    // == Helpers ==
    /**
 * Check if a directionality value is a Strong one
 */
    function isStrong(dir) {
        return dir === LTR || dir === RTL;
    }
    /**
 * Get string value to be used for `dir` HTML attribute or `direction` CSS
 * property.
 */
    function getHTMLDir(dir) {
        return isStrong(dir) || invariant(!1), dir === LTR ? "ltr" : "rtl";
    }
    /**
 * Get string value to be used for `dir` HTML attribute or `direction` CSS
 * property, but returns null if `dir` has same value as `otherDir`.
 * `null`.
 */
    function getHTMLDirIfDifferent(dir, otherDir) {
        return isStrong(dir) || invariant(!1), isStrong(otherDir) || invariant(!1), dir === otherDir ? null : getHTMLDir(dir);
    }
    // == Global Direction ==
    /**
 * Set the global direction.
 */
    function setGlobalDir(dir) {
        globalDir = dir;
    }
    /**
 * Initialize the global direction
 */
    function initGlobalDir() {
        setGlobalDir(LTR);
    }
    /**
 * Get the global direction
 */
    function getGlobalDir() {
        return globalDir || this.initGlobalDir(), globalDir || invariant(!1), globalDir;
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 * 
 */
    /**
 * Constants to represent text directionality
 *
 * Also defines a *global* direciton, to be used in bidi algorithms as a
 * default fallback direciton, when no better direction is found or provided.
 *
 * NOTE: Use `setGlobalDir()`, or update `initGlobalDir()`, to set the initial
 *       global direction value based on the application.
 *
 * Part of the implementation of Unicode Bidirectional Algorithm (UBA)
 * Unicode Standard Annex #9 (UAX9)
 * http://www.unicode.org/reports/tr9/
 */
    var invariant = __webpack_require__(2), LTR = "LTR", RTL = "RTL", globalDir = null, UnicodeBidiDirection = {
        // Values
        NEUTRAL: "NEUTRAL",
        LTR: LTR,
        RTL: RTL,
        // Helpers
        isStrong: isStrong,
        getHTMLDir: getHTMLDir,
        getHTMLDirIfDifferent: getHTMLDirIfDifferent,
        // Global Direction
        setGlobalDir: setGlobalDir,
        initGlobalDir: initGlobalDir,
        getGlobalDir: getGlobalDir
    };
    module.exports = UnicodeBidiDirection;
}, /* 84 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DefaultDraftBlockRenderMap
 * 
 */
    var _require = __webpack_require__(1), Map = _require.Map, React = __webpack_require__(3), cx = __webpack_require__(46), UL_WRAP = React.createElement("ul", {
        className: cx("public/DraftStyleDefault/ul")
    }), OL_WRAP = React.createElement("ol", {
        className: cx("public/DraftStyleDefault/ol")
    }), PRE_WRAP = React.createElement("pre", {
        className: cx("public/DraftStyleDefault/pre")
    }), DefaultDraftBlockRenderMap = Map({
        "header-one": {
            element: "h1"
        },
        "header-two": {
            element: "h2"
        },
        "header-three": {
            element: "h3"
        },
        "header-four": {
            element: "h4"
        },
        "header-five": {
            element: "h5"
        },
        "header-six": {
            element: "h6"
        },
        "unordered-list-item": {
            element: "li",
            wrapper: UL_WRAP
        },
        "ordered-list-item": {
            element: "li",
            wrapper: OL_WRAP
        },
        blockquote: {
            element: "blockquote"
        },
        atomic: {
            element: "figure"
        },
        "code-block": {
            element: "pre",
            wrapper: PRE_WRAP
        },
        unstyled: {
            element: "div",
            aliasedElements: [ "p" ]
        }
    });
    module.exports = DefaultDraftBlockRenderMap;
}, /* 85 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getEntityKeyForSelection
 * @typechecks
 * 
 */
    /**
 * Return the entity key that should be used when inserting text for the
 * specified target selection, only if the entity is `MUTABLE`. `IMMUTABLE`
 * and `SEGMENTED` entities should not be used for insertion behavior.
 */
    function getEntityKeyForSelection(contentState, targetSelection) {
        var entityKey;
        if (targetSelection.isCollapsed()) {
            var key = targetSelection.getAnchorKey(), offset = targetSelection.getAnchorOffset();
            return offset > 0 ? (entityKey = contentState.getBlockForKey(key).getEntityAt(offset - 1), 
            filterKey(contentState.getEntityMap(), entityKey)) : null;
        }
        var startKey = targetSelection.getStartKey(), startOffset = targetSelection.getStartOffset(), startBlock = contentState.getBlockForKey(startKey);
        return entityKey = startOffset === startBlock.getLength() ? null : startBlock.getEntityAt(startOffset), 
        filterKey(contentState.getEntityMap(), entityKey);
    }
    /**
 * Determine whether an entity key corresponds to a `MUTABLE` entity. If so,
 * return it. If not, return null.
 */
    function filterKey(entityMap, entityKey) {
        if (entityKey) {
            return "MUTABLE" === entityMap.__get(entityKey).getMutability() ? entityKey : null;
        }
        return null;
    }
    module.exports = getEntityKeyForSelection;
}, /* 86 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * @param {DOMNode} element [description]
 * @param {string} name Overflow style property name.
 * @return {boolean} True if the supplied ndoe is scrollable.
 */
    function _isNodeScrollable(element, name) {
        var overflow = Style.get(element, name);
        return "auto" === overflow || "scroll" === overflow;
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */
    var getStyleProperty = __webpack_require__(208), Style = {
        /**
   * Gets the style property for the supplied node. This will return either the
   * computed style, if available, or the declared style.
   *
   * @param {DOMNode} node
   * @param {string} name Style property name.
   * @return {?string} Style property value.
   */
        get: getStyleProperty,
        /**
   * Determines the nearest ancestor of a node that is scrollable.
   *
   * NOTE: This can be expensive if used repeatedly or on a node nested deeply.
   *
   * @param {?DOMNode} node Node from which to start searching.
   * @return {?DOMWindow|DOMElement} Scroll parent of the supplied node.
   */
        getScrollParent: function(node) {
            if (!node) return null;
            for (var ownerDocument = node.ownerDocument; node && node !== ownerDocument.body; ) {
                if (_isNodeScrollable(node, "overflow") || _isNodeScrollable(node, "overflowY") || _isNodeScrollable(node, "overflowX")) return node;
                node = node.parentNode;
            }
            return ownerDocument.defaultView || ownerDocument.parentWindow;
        }
    };
    module.exports = Style;
}, /* 87 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are bounded. This means that if the scroll position is
 * negative or exceeds the element boundaries (which is possible using inertial
 * scrolling), you will get zero or the maximum scroll position, respectively.
 *
 * If you need the unbound scroll position, use `getUnboundedScrollPosition`.
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */
    function getScrollPosition(scrollable) {
        var documentScrollElement = getDocumentScrollElement(scrollable.ownerDocument || scrollable.document);
        scrollable.Window && scrollable instanceof scrollable.Window && (scrollable = documentScrollElement);
        var scrollPosition = getUnboundedScrollPosition(scrollable), viewport = scrollable === documentScrollElement ? scrollable.ownerDocument.documentElement : scrollable, xMax = scrollable.scrollWidth - viewport.clientWidth, yMax = scrollable.scrollHeight - viewport.clientHeight;
        return scrollPosition.x = Math.max(0, Math.min(scrollPosition.x, xMax)), scrollPosition.y = Math.max(0, Math.min(scrollPosition.y, yMax)), 
        scrollPosition;
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */
    var getDocumentScrollElement = __webpack_require__(213), getUnboundedScrollPosition = __webpack_require__(214);
    module.exports = getScrollPosition;
}, /* 88 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Get the key from the node's nearest offset-aware ancestor.
 */
    function findAncestorOffsetKey(node) {
        for (var searchNode = node; searchNode && searchNode !== document.documentElement; ) {
            var key = getSelectionOffsetKeyForNode(searchNode);
            if (null != key) return key;
            searchNode = searchNode.parentNode;
        }
        return null;
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule findAncestorOffsetKey
 * @typechecks
 * 
 */
    var getSelectionOffsetKeyForNode = __webpack_require__(122);
    module.exports = findAncestorOffsetKey;
}, /* 89 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule moveSelectionBackward
 * 
 */
    /**
 * Given a collapsed selection, move the focus `maxDistance` backward within
 * the selected block. If the selection will go beyond the start of the block,
 * move focus to the end of the previous block, but no further.
 *
 * This function is not Unicode-aware, so surrogate pairs will be treated
 * as having length 2.
 */
    function moveSelectionBackward(editorState, maxDistance) {
        var selection = editorState.getSelection(), content = editorState.getCurrentContent(), key = selection.getStartKey(), offset = selection.getStartOffset(), focusKey = key, focusOffset = 0;
        if (maxDistance > offset) {
            var keyBefore = content.getKeyBefore(key);
            if (null == keyBefore) focusKey = key; else {
                focusKey = keyBefore;
                focusOffset = content.getBlockForKey(keyBefore).getText().length;
            }
        } else focusOffset = offset - maxDistance;
        return selection.merge({
            focusKey: focusKey,
            focusOffset: focusOffset,
            isBackward: !0
        });
    }
    module.exports = moveSelectionBackward;
}, /* 90 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function shouldRemoveWord(e) {
        return isOSX && e.altKey || isCtrlKeyCommand(e);
    }
    /**
 * Get the appropriate undo/redo command for a Z key command.
 */
    function getZCommand(e) {
        return hasCommandModifier(e) ? e.shiftKey ? "redo" : "undo" : null;
    }
    function getDeleteCommand(e) {
        // Allow default "cut" behavior for Windows on Shift + Delete.
        // Allow default "cut" behavior for Windows on Shift + Delete.
        return isWindows && e.shiftKey ? null : shouldRemoveWord(e) ? "delete-word" : "delete";
    }
    function getBackspaceCommand(e) {
        return hasCommandModifier(e) && isOSX ? "backspace-to-start-of-line" : shouldRemoveWord(e) ? "backspace-word" : "backspace";
    }
    /**
 * Retrieve a bound key command for the given event.
 */
    function getDefaultKeyBinding(e) {
        switch (e.keyCode) {
          case 66:
            // B
            return hasCommandModifier(e) ? "bold" : null;

          case 68:
            // D
            return isCtrlKeyCommand(e) ? "delete" : null;

          case 72:
            // H
            return isCtrlKeyCommand(e) ? "backspace" : null;

          case 73:
            // I
            return hasCommandModifier(e) ? "italic" : null;

          case 74:
            // J
            return hasCommandModifier(e) ? "code" : null;

          case 75:
            // K
            return !isWindows && isCtrlKeyCommand(e) ? "secondary-cut" : null;

          case 77:
          case 79:
            // O
            return isCtrlKeyCommand(e) ? "split-block" : null;

          case 84:
            // T
            return isOSX && isCtrlKeyCommand(e) ? "transpose-characters" : null;

          case 85:
            // U
            return hasCommandModifier(e) ? "underline" : null;

          case 87:
            // W
            return isOSX && isCtrlKeyCommand(e) ? "backspace-word" : null;

          case 89:
            // Y
            // Y
            return isCtrlKeyCommand(e) ? isWindows ? "redo" : "secondary-paste" : null;

          case 90:
            // Z
            return getZCommand(e) || null;

          case Keys.RETURN:
            return "split-block";

          case Keys.DELETE:
            return getDeleteCommand(e);

          case Keys.BACKSPACE:
            return getBackspaceCommand(e);

          // LEFT/RIGHT handlers serve as a workaround for a Firefox bug.
            case Keys.LEFT:
            return shouldFixFirefoxMovement && hasCommandModifier(e) ? "move-selection-to-start-of-block" : null;

          case Keys.RIGHT:
            return shouldFixFirefoxMovement && hasCommandModifier(e) ? "move-selection-to-end-of-block" : null;

          default:
            return null;
        }
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getDefaultKeyBinding
 * @typechecks
 * 
 */
    var KeyBindingUtil = __webpack_require__(62), Keys = __webpack_require__(59), UserAgent = __webpack_require__(17), isOSX = UserAgent.isPlatform("Mac OS X"), isWindows = UserAgent.isPlatform("Windows"), shouldFixFirefoxMovement = isOSX && UserAgent.isBrowser("Firefox < 29"), hasCommandModifier = KeyBindingUtil.hasCommandModifier, isCtrlKeyCommand = KeyBindingUtil.isCtrlKeyCommand;
    module.exports = getDefaultKeyBinding;
}, /* 91 */
/***/
function(module, exports, __webpack_require__) {
    /**
 *  Copyright (c) 2014-2015, Facebook, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the BSD-style license found in the
 *  LICENSE file in the root directory of this source tree. An additional grant
 *  of patent rights can be found in the PATENTS file in the same directory.
 */
    !function(global, factory) {
        module.exports = factory();
    }(0, function() {
        "use strict";
        function createClass(ctor, superClass) {
            superClass && (ctor.prototype = Object.create(superClass.prototype)), ctor.prototype.constructor = ctor;
        }
        function Iterable(value) {
            return isIterable(value) ? value : Seq(value);
        }
        function KeyedIterable(value) {
            return isKeyed(value) ? value : KeyedSeq(value);
        }
        function IndexedIterable(value) {
            return isIndexed(value) ? value : IndexedSeq(value);
        }
        function SetIterable(value) {
            return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
        }
        function isIterable(maybeIterable) {
            return !(!maybeIterable || !maybeIterable[IS_ITERABLE_SENTINEL]);
        }
        function isKeyed(maybeKeyed) {
            return !(!maybeKeyed || !maybeKeyed[IS_KEYED_SENTINEL]);
        }
        function isIndexed(maybeIndexed) {
            return !(!maybeIndexed || !maybeIndexed[IS_INDEXED_SENTINEL]);
        }
        function isAssociative(maybeAssociative) {
            return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
        }
        function isOrdered(maybeOrdered) {
            return !(!maybeOrdered || !maybeOrdered[IS_ORDERED_SENTINEL]);
        }
        function MakeRef(ref) {
            return ref.value = !1, ref;
        }
        function SetRef(ref) {
            ref && (ref.value = !0);
        }
        // A function which returns a value representing an "owner" for transient writes
        // to tries. The return value will only ever equal itself, and will not equal
        // the return of any subsequent call of this function.
        function OwnerID() {}
        // http://jsperf.com/copy-array-inline
        function arrCopy(arr, offset) {
            offset = offset || 0;
            for (var len = Math.max(0, arr.length - offset), newArr = new Array(len), ii = 0; ii < len; ii++) newArr[ii] = arr[ii + offset];
            return newArr;
        }
        function ensureSize(iter) {
            return void 0 === iter.size && (iter.size = iter.__iterate(returnTrue)), iter.size;
        }
        function wrapIndex(iter, index) {
            // This implements "is array index" which the ECMAString spec defines as:
            //
            //     A String property name P is an array index if and only if
            //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
            //     to 2^32−1.
            //
            // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
            if ("number" != typeof index) {
                var uint32Index = index >>> 0;
                // N >>> 0 is shorthand for ToUint32
                if ("" + uint32Index !== index || 4294967295 === uint32Index) return NaN;
                index = uint32Index;
            }
            return index < 0 ? ensureSize(iter) + index : index;
        }
        function returnTrue() {
            return !0;
        }
        function wholeSlice(begin, end, size) {
            return (0 === begin || void 0 !== size && begin <= -size) && (void 0 === end || void 0 !== size && end >= size);
        }
        function resolveBegin(begin, size) {
            return resolveIndex(begin, size, 0);
        }
        function resolveEnd(end, size) {
            return resolveIndex(end, size, size);
        }
        function resolveIndex(index, size, defaultIndex) {
            return void 0 === index ? defaultIndex : index < 0 ? Math.max(0, size + index) : void 0 === size ? index : Math.min(size, index);
        }
        function Iterator(next) {
            this.next = next;
        }
        function iteratorValue(type, k, v, iteratorResult) {
            var value = 0 === type ? k : 1 === type ? v : [ k, v ];
            return iteratorResult ? iteratorResult.value = value : iteratorResult = {
                value: value,
                done: !1
            }, iteratorResult;
        }
        function iteratorDone() {
            return {
                value: void 0,
                done: !0
            };
        }
        function hasIterator(maybeIterable) {
            return !!getIteratorFn(maybeIterable);
        }
        function isIterator(maybeIterator) {
            return maybeIterator && "function" == typeof maybeIterator.next;
        }
        function getIterator(iterable) {
            var iteratorFn = getIteratorFn(iterable);
            return iteratorFn && iteratorFn.call(iterable);
        }
        function getIteratorFn(iterable) {
            var iteratorFn = iterable && (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL] || iterable[FAUX_ITERATOR_SYMBOL]);
            if ("function" == typeof iteratorFn) return iteratorFn;
        }
        function isArrayLike(value) {
            return value && "number" == typeof value.length;
        }
        function Seq(value) {
            return null === value || void 0 === value ? emptySequence() : isIterable(value) ? value.toSeq() : seqFromValue(value);
        }
        function KeyedSeq(value) {
            return null === value || void 0 === value ? emptySequence().toKeyedSeq() : isIterable(value) ? isKeyed(value) ? value.toSeq() : value.fromEntrySeq() : keyedSeqFromValue(value);
        }
        function IndexedSeq(value) {
            return null === value || void 0 === value ? emptySequence() : isIterable(value) ? isKeyed(value) ? value.entrySeq() : value.toIndexedSeq() : indexedSeqFromValue(value);
        }
        function SetSeq(value) {
            return (null === value || void 0 === value ? emptySequence() : isIterable(value) ? isKeyed(value) ? value.entrySeq() : value : indexedSeqFromValue(value)).toSetSeq();
        }
        function ArraySeq(array) {
            this._array = array, this.size = array.length;
        }
        function ObjectSeq(object) {
            var keys = Object.keys(object);
            this._object = object, this._keys = keys, this.size = keys.length;
        }
        function IterableSeq(iterable) {
            this._iterable = iterable, this.size = iterable.length || iterable.size;
        }
        function IteratorSeq(iterator) {
            this._iterator = iterator, this._iteratorCache = [];
        }
        // # pragma Helper functions
        function isSeq(maybeSeq) {
            return !(!maybeSeq || !maybeSeq[IS_SEQ_SENTINEL]);
        }
        function emptySequence() {
            return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
        }
        function keyedSeqFromValue(value) {
            var seq = Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() : isIterator(value) ? new IteratorSeq(value).fromEntrySeq() : hasIterator(value) ? new IterableSeq(value).fromEntrySeq() : "object" == typeof value ? new ObjectSeq(value) : void 0;
            if (!seq) throw new TypeError("Expected Array or iterable object of [k, v] entries, or keyed object: " + value);
            return seq;
        }
        function indexedSeqFromValue(value) {
            var seq = maybeIndexedSeqFromValue(value);
            if (!seq) throw new TypeError("Expected Array or iterable object of values: " + value);
            return seq;
        }
        function seqFromValue(value) {
            var seq = maybeIndexedSeqFromValue(value) || "object" == typeof value && new ObjectSeq(value);
            if (!seq) throw new TypeError("Expected Array or iterable object of values, or keyed object: " + value);
            return seq;
        }
        function maybeIndexedSeqFromValue(value) {
            return isArrayLike(value) ? new ArraySeq(value) : isIterator(value) ? new IteratorSeq(value) : hasIterator(value) ? new IterableSeq(value) : void 0;
        }
        function seqIterate(seq, fn, reverse, useKeys) {
            var cache = seq._cache;
            if (cache) {
                for (var maxIndex = cache.length - 1, ii = 0; ii <= maxIndex; ii++) {
                    var entry = cache[reverse ? maxIndex - ii : ii];
                    if (!1 === fn(entry[1], useKeys ? entry[0] : ii, seq)) return ii + 1;
                }
                return ii;
            }
            return seq.__iterateUncached(fn, reverse);
        }
        function seqIterator(seq, type, reverse, useKeys) {
            var cache = seq._cache;
            if (cache) {
                var maxIndex = cache.length - 1, ii = 0;
                return new Iterator(function() {
                    var entry = cache[reverse ? maxIndex - ii : ii];
                    return ii++ > maxIndex ? iteratorDone() : iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
                });
            }
            return seq.__iteratorUncached(type, reverse);
        }
        function fromJS(json, converter) {
            return converter ? fromJSWith(converter, json, "", {
                "": json
            }) : fromJSDefault(json);
        }
        function fromJSWith(converter, json, key, parentJSON) {
            return Array.isArray(json) ? converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k) {
                return fromJSWith(converter, v, k, json);
            })) : isPlainObj(json) ? converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k) {
                return fromJSWith(converter, v, k, json);
            })) : json;
        }
        function fromJSDefault(json) {
            return Array.isArray(json) ? IndexedSeq(json).map(fromJSDefault).toList() : isPlainObj(json) ? KeyedSeq(json).map(fromJSDefault).toMap() : json;
        }
        function isPlainObj(value) {
            return value && (value.constructor === Object || void 0 === value.constructor);
        }
        /**
   * An extension of the "same-value" algorithm as [described for use by ES6 Map
   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
   *
   * NaN is considered the same as NaN, however -0 and 0 are considered the same
   * value, which is different from the algorithm described by
   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
   *
   * This is extended further to allow Objects to describe the values they
   * represent, by way of `valueOf` or `equals` (and `hashCode`).
   *
   * Note: because of this extension, the key equality of Immutable.Map and the
   * value equality of Immutable.Set will differ from ES6 Map and Set.
   *
   * ### Defining custom values
   *
   * The easiest way to describe the value an object represents is by implementing
   * `valueOf`. For example, `Date` represents a value by returning a unix
   * timestamp for `valueOf`:
   *
   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
   *     var date2 = new Date(1234567890000);
   *     date1.valueOf(); // 1234567890000
   *     assert( date1 !== date2 );
   *     assert( Immutable.is( date1, date2 ) );
   *
   * Note: overriding `valueOf` may have other implications if you use this object
   * where JavaScript expects a primitive, such as implicit string coercion.
   *
   * For more complex types, especially collections, implementing `valueOf` may
   * not be performant. An alternative is to implement `equals` and `hashCode`.
   *
   * `equals` takes another object, presumably of similar type, and returns true
   * if the it is equal. Equality is symmetrical, so the same result should be
   * returned if this and the argument are flipped.
   *
   *     assert( a.equals(b) === b.equals(a) );
   *
   * `hashCode` returns a 32bit integer number representing the object which will
   * be used to determine how to store the value object in a Map or Set. You must
   * provide both or neither methods, one must not exist without the other.
   *
   * Also, an important relationship between these methods must be upheld: if two
   * values are equal, they *must* return the same hashCode. If the values are not
   * equal, they might have the same hashCode; this is called a hash collision,
   * and while undesirable for performance reasons, it is acceptable.
   *
   *     if (a.equals(b)) {
   *       assert( a.hashCode() === b.hashCode() );
   *     }
   *
   * All Immutable collections implement `equals` and `hashCode`.
   *
   */
        function is(valueA, valueB) {
            if (valueA === valueB || valueA !== valueA && valueB !== valueB) return !0;
            if (!valueA || !valueB) return !1;
            if ("function" == typeof valueA.valueOf && "function" == typeof valueB.valueOf) {
                if (valueA = valueA.valueOf(), valueB = valueB.valueOf(), valueA === valueB || valueA !== valueA && valueB !== valueB) return !0;
                if (!valueA || !valueB) return !1;
            }
            return !("function" != typeof valueA.equals || "function" != typeof valueB.equals || !valueA.equals(valueB));
        }
        function deepEqual(a, b) {
            if (a === b) return !0;
            if (!isIterable(b) || void 0 !== a.size && void 0 !== b.size && a.size !== b.size || void 0 !== a.__hash && void 0 !== b.__hash && a.__hash !== b.__hash || isKeyed(a) !== isKeyed(b) || isIndexed(a) !== isIndexed(b) || isOrdered(a) !== isOrdered(b)) return !1;
            if (0 === a.size && 0 === b.size) return !0;
            var notAssociative = !isAssociative(a);
            if (isOrdered(a)) {
                var entries = a.entries();
                return b.every(function(v, k) {
                    var entry = entries.next().value;
                    return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
                }) && entries.next().done;
            }
            var flipped = !1;
            if (void 0 === a.size) if (void 0 === b.size) "function" == typeof a.cacheResult && a.cacheResult(); else {
                flipped = !0;
                var _ = a;
                a = b, b = _;
            }
            var allEqual = !0, bSize = b.__iterate(function(v, k) {
                if (notAssociative ? !a.has(v) : flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) return allEqual = !1, 
                !1;
            });
            return allEqual && a.size === bSize;
        }
        function Repeat(value, times) {
            if (!(this instanceof Repeat)) return new Repeat(value, times);
            if (this._value = value, this.size = void 0 === times ? 1 / 0 : Math.max(0, times), 
            0 === this.size) {
                if (EMPTY_REPEAT) return EMPTY_REPEAT;
                EMPTY_REPEAT = this;
            }
        }
        function invariant(condition, error) {
            if (!condition) throw new Error(error);
        }
        function Range(start, end, step) {
            if (!(this instanceof Range)) return new Range(start, end, step);
            if (invariant(0 !== step, "Cannot step a Range by 0"), start = start || 0, void 0 === end && (end = 1 / 0), 
            step = void 0 === step ? 1 : Math.abs(step), end < start && (step = -step), this._start = start, 
            this._end = end, this._step = step, this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1), 
            0 === this.size) {
                if (EMPTY_RANGE) return EMPTY_RANGE;
                EMPTY_RANGE = this;
            }
        }
        function Collection() {
            throw TypeError("Abstract");
        }
        function KeyedCollection() {}
        function IndexedCollection() {}
        function SetCollection() {}
        // v8 has an optimization for storing 31-bit signed numbers.
        // Values which have either 00 or 11 as the high order bits qualify.
        // This function drops the highest order bit in a signed number, maintaining
        // the sign bit.
        function smi(i32) {
            return i32 >>> 1 & 1073741824 | 3221225471 & i32;
        }
        function hash(o) {
            if (!1 === o || null === o || void 0 === o) return 0;
            if ("function" == typeof o.valueOf && (!1 === (o = o.valueOf()) || null === o || void 0 === o)) return 0;
            if (!0 === o) return 1;
            var type = typeof o;
            if ("number" === type) {
                if (o !== o || o === 1 / 0) return 0;
                var h = 0 | o;
                for (h !== o && (h ^= 4294967295 * o); o > 4294967295; ) o /= 4294967295, h ^= o;
                return smi(h);
            }
            if ("string" === type) return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
            if ("function" == typeof o.hashCode) return o.hashCode();
            if ("object" === type) return hashJSObj(o);
            if ("function" == typeof o.toString) return hashString(o.toString());
            throw new Error("Value type " + type + " cannot be hashed.");
        }
        function cachedHashString(string) {
            var hash = stringHashCache[string];
            return void 0 === hash && (hash = hashString(string), STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE && (STRING_HASH_CACHE_SIZE = 0, 
            stringHashCache = {}), STRING_HASH_CACHE_SIZE++, stringHashCache[string] = hash), 
            hash;
        }
        // http://jsperf.com/hashing-strings
        function hashString(string) {
            for (var hash = 0, ii = 0; ii < string.length; ii++) hash = 31 * hash + string.charCodeAt(ii) | 0;
            return smi(hash);
        }
        function hashJSObj(obj) {
            var hash;
            if (usingWeakMap && void 0 !== (hash = weakMap.get(obj))) return hash;
            if (void 0 !== (hash = obj[UID_HASH_KEY])) return hash;
            if (!canDefineProperty) {
                if (void 0 !== (hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY])) return hash;
                if (void 0 !== (hash = getIENodeHash(obj))) return hash;
            }
            if (hash = ++objHashUID, 1073741824 & objHashUID && (objHashUID = 0), usingWeakMap) weakMap.set(obj, hash); else {
                if (void 0 !== isExtensible && !1 === isExtensible(obj)) throw new Error("Non-extensible objects are not allowed as keys.");
                if (canDefineProperty) Object.defineProperty(obj, UID_HASH_KEY, {
                    enumerable: !1,
                    configurable: !1,
                    writable: !1,
                    value: hash
                }); else if (void 0 !== obj.propertyIsEnumerable && obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) // Since we can't define a non-enumerable property on the object
                // we'll hijack one of the less-used non-enumerable properties to
                // save our hash on it. Since this is a function it will not show up in
                // `JSON.stringify` which is what we want.
                obj.propertyIsEnumerable = function() {
                    return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
                }, obj.propertyIsEnumerable[UID_HASH_KEY] = hash; else {
                    if (void 0 === obj.nodeType) throw new Error("Unable to set a non-enumerable property on object.");
                    // At this point we couldn't get the IE `uniqueID` to use as a hash
                    // and we couldn't use a non-enumerable property to exploit the
                    // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
                    // itself.
                    obj[UID_HASH_KEY] = hash;
                }
            }
            return hash;
        }
        // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
        // and avoid memory leaks from the IE cloneNode bug.
        function getIENodeHash(node) {
            if (node && node.nodeType > 0) switch (node.nodeType) {
              case 1:
                // Element
                return node.uniqueID;

              case 9:
                // Document
                return node.documentElement && node.documentElement.uniqueID;
            }
        }
        function assertNotInfinite(size) {
            invariant(size !== 1 / 0, "Cannot perform this action with an infinite size.");
        }
        // @pragma Construction
        function Map(value) {
            return null === value || void 0 === value ? emptyMap() : isMap(value) && !isOrdered(value) ? value : emptyMap().withMutations(function(map) {
                var iter = KeyedIterable(value);
                assertNotInfinite(iter.size), iter.forEach(function(v, k) {
                    return map.set(k, v);
                });
            });
        }
        function isMap(maybeMap) {
            return !(!maybeMap || !maybeMap[IS_MAP_SENTINEL]);
        }
        // #pragma Trie Nodes
        function ArrayMapNode(ownerID, entries) {
            this.ownerID = ownerID, this.entries = entries;
        }
        function BitmapIndexedNode(ownerID, bitmap, nodes) {
            this.ownerID = ownerID, this.bitmap = bitmap, this.nodes = nodes;
        }
        function HashArrayMapNode(ownerID, count, nodes) {
            this.ownerID = ownerID, this.count = count, this.nodes = nodes;
        }
        function HashCollisionNode(ownerID, keyHash, entries) {
            this.ownerID = ownerID, this.keyHash = keyHash, this.entries = entries;
        }
        function ValueNode(ownerID, keyHash, entry) {
            this.ownerID = ownerID, this.keyHash = keyHash, this.entry = entry;
        }
        function MapIterator(map, type, reverse) {
            this._type = type, this._reverse = reverse, this._stack = map._root && mapIteratorFrame(map._root);
        }
        function mapIteratorValue(type, entry) {
            return iteratorValue(type, entry[0], entry[1]);
        }
        function mapIteratorFrame(node, prev) {
            return {
                node: node,
                index: 0,
                __prev: prev
            };
        }
        function makeMap(size, root, ownerID, hash) {
            var map = Object.create(MapPrototype);
            return map.size = size, map._root = root, map.__ownerID = ownerID, map.__hash = hash, 
            map.__altered = !1, map;
        }
        function emptyMap() {
            return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
        }
        function updateMap(map, k, v) {
            var newRoot, newSize;
            if (map._root) {
                var didChangeSize = MakeRef(CHANGE_LENGTH), didAlter = MakeRef(DID_ALTER);
                if (newRoot = updateNode(map._root, map.__ownerID, 0, void 0, k, v, didChangeSize, didAlter), 
                !didAlter.value) return map;
                newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
            } else {
                if (v === NOT_SET) return map;
                newSize = 1, newRoot = new ArrayMapNode(map.__ownerID, [ [ k, v ] ]);
            }
            return map.__ownerID ? (map.size = newSize, map._root = newRoot, map.__hash = void 0, 
            map.__altered = !0, map) : newRoot ? makeMap(newSize, newRoot) : emptyMap();
        }
        function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
            return node ? node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) : value === NOT_SET ? node : (SetRef(didAlter), 
            SetRef(didChangeSize), new ValueNode(ownerID, keyHash, [ key, value ]));
        }
        function isLeafNode(node) {
            return node.constructor === ValueNode || node.constructor === HashCollisionNode;
        }
        function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
            if (node.keyHash === keyHash) return new HashCollisionNode(ownerID, keyHash, [ node.entry, entry ]);
            var newNode, idx1 = (0 === shift ? node.keyHash : node.keyHash >>> shift) & MASK, idx2 = (0 === shift ? keyHash : keyHash >>> shift) & MASK;
            return new BitmapIndexedNode(ownerID, 1 << idx1 | 1 << idx2, idx1 === idx2 ? [ mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry) ] : (newNode = new ValueNode(ownerID, keyHash, entry), 
            idx1 < idx2 ? [ node, newNode ] : [ newNode, node ]));
        }
        function createNodes(ownerID, entries, key, value) {
            ownerID || (ownerID = new OwnerID());
            for (var node = new ValueNode(ownerID, hash(key), [ key, value ]), ii = 0; ii < entries.length; ii++) {
                var entry = entries[ii];
                node = node.update(ownerID, 0, void 0, entry[0], entry[1]);
            }
            return node;
        }
        function packNodes(ownerID, nodes, count, excluding) {
            for (var bitmap = 0, packedII = 0, packedNodes = new Array(count), ii = 0, bit = 1, len = nodes.length; ii < len; ii++, 
            bit <<= 1) {
                var node = nodes[ii];
                void 0 !== node && ii !== excluding && (bitmap |= bit, packedNodes[packedII++] = node);
            }
            return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
        }
        function expandNodes(ownerID, nodes, bitmap, including, node) {
            for (var count = 0, expandedNodes = new Array(SIZE), ii = 0; 0 !== bitmap; ii++, 
            bitmap >>>= 1) expandedNodes[ii] = 1 & bitmap ? nodes[count++] : void 0;
            return expandedNodes[including] = node, new HashArrayMapNode(ownerID, count + 1, expandedNodes);
        }
        function mergeIntoMapWith(map, merger, iterables) {
            for (var iters = [], ii = 0; ii < iterables.length; ii++) {
                var value = iterables[ii], iter = KeyedIterable(value);
                isIterable(value) || (iter = iter.map(function(v) {
                    return fromJS(v);
                })), iters.push(iter);
            }
            return mergeIntoCollectionWith(map, merger, iters);
        }
        function deepMerger(existing, value, key) {
            return existing && existing.mergeDeep && isIterable(value) ? existing.mergeDeep(value) : is(existing, value) ? existing : value;
        }
        function deepMergerWith(merger) {
            return function(existing, value, key) {
                if (existing && existing.mergeDeepWith && isIterable(value)) return existing.mergeDeepWith(merger, value);
                var nextValue = merger(existing, value, key);
                return is(existing, nextValue) ? existing : nextValue;
            };
        }
        function mergeIntoCollectionWith(collection, merger, iters) {
            return iters = iters.filter(function(x) {
                return 0 !== x.size;
            }), 0 === iters.length ? collection : 0 !== collection.size || collection.__ownerID || 1 !== iters.length ? collection.withMutations(function(collection) {
                for (var mergeIntoMap = merger ? function(value, key) {
                    collection.update(key, NOT_SET, function(existing) {
                        return existing === NOT_SET ? value : merger(existing, value, key);
                    });
                } : function(value, key) {
                    collection.set(key, value);
                }, ii = 0; ii < iters.length; ii++) iters[ii].forEach(mergeIntoMap);
            }) : collection.constructor(iters[0]);
        }
        function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
            var isNotSet = existing === NOT_SET, step = keyPathIter.next();
            if (step.done) {
                var existingValue = isNotSet ? notSetValue : existing, newValue = updater(existingValue);
                return newValue === existingValue ? existing : newValue;
            }
            invariant(isNotSet || existing && existing.set, "invalid keyPath");
            var key = step.value, nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET), nextUpdated = updateInDeepMap(nextExisting, keyPathIter, notSetValue, updater);
            return nextUpdated === nextExisting ? existing : nextUpdated === NOT_SET ? existing.remove(key) : (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
        }
        function popCount(x) {
            return x -= x >> 1 & 1431655765, x = (858993459 & x) + (x >> 2 & 858993459), x = x + (x >> 4) & 252645135, 
            x += x >> 8, 127 & (x += x >> 16);
        }
        function setIn(array, idx, val, canEdit) {
            var newArray = canEdit ? array : arrCopy(array);
            return newArray[idx] = val, newArray;
        }
        function spliceIn(array, idx, val, canEdit) {
            var newLen = array.length + 1;
            if (canEdit && idx + 1 === newLen) return array[idx] = val, array;
            for (var newArray = new Array(newLen), after = 0, ii = 0; ii < newLen; ii++) ii === idx ? (newArray[ii] = val, 
            after = -1) : newArray[ii] = array[ii + after];
            return newArray;
        }
        function spliceOut(array, idx, canEdit) {
            var newLen = array.length - 1;
            if (canEdit && idx === newLen) return array.pop(), array;
            for (var newArray = new Array(newLen), after = 0, ii = 0; ii < newLen; ii++) ii === idx && (after = 1), 
            newArray[ii] = array[ii + after];
            return newArray;
        }
        // @pragma Construction
        function List(value) {
            var empty = emptyList();
            if (null === value || void 0 === value) return empty;
            if (isList(value)) return value;
            var iter = IndexedIterable(value), size = iter.size;
            return 0 === size ? empty : (assertNotInfinite(size), size > 0 && size < SIZE ? makeList(0, size, SHIFT, null, new VNode(iter.toArray())) : empty.withMutations(function(list) {
                list.setSize(size), iter.forEach(function(v, i) {
                    return list.set(i, v);
                });
            }));
        }
        function isList(maybeList) {
            return !(!maybeList || !maybeList[IS_LIST_SENTINEL]);
        }
        function VNode(array, ownerID) {
            this.array = array, this.ownerID = ownerID;
        }
        function iterateList(list, reverse) {
            function iterateNodeOrLeaf(node, level, offset) {
                return 0 === level ? iterateLeaf(node, offset) : iterateNode(node, level, offset);
            }
            function iterateLeaf(node, offset) {
                var array = offset === tailPos ? tail && tail.array : node && node.array, from = offset > left ? 0 : left - offset, to = right - offset;
                return to > SIZE && (to = SIZE), function() {
                    if (from === to) return DONE;
                    var idx = reverse ? --to : from++;
                    return array && array[idx];
                };
            }
            function iterateNode(node, level, offset) {
                var values, array = node && node.array, from = offset > left ? 0 : left - offset >> level, to = 1 + (right - offset >> level);
                return to > SIZE && (to = SIZE), function() {
                    for (;;) {
                        if (values) {
                            var value = values();
                            if (value !== DONE) return value;
                            values = null;
                        }
                        if (from === to) return DONE;
                        var idx = reverse ? --to : from++;
                        values = iterateNodeOrLeaf(array && array[idx], level - SHIFT, offset + (idx << level));
                    }
                };
            }
            var left = list._origin, right = list._capacity, tailPos = getTailOffset(right), tail = list._tail;
            return iterateNodeOrLeaf(list._root, list._level, 0);
        }
        function makeList(origin, capacity, level, root, tail, ownerID, hash) {
            var list = Object.create(ListPrototype);
            return list.size = capacity - origin, list._origin = origin, list._capacity = capacity, 
            list._level = level, list._root = root, list._tail = tail, list.__ownerID = ownerID, 
            list.__hash = hash, list.__altered = !1, list;
        }
        function emptyList() {
            return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
        }
        function updateList(list, index, value) {
            if ((index = wrapIndex(list, index)) !== index) return list;
            if (index >= list.size || index < 0) return list.withMutations(function(list) {
                index < 0 ? setListBounds(list, index).set(0, value) : setListBounds(list, 0, index + 1).set(index, value);
            });
            index += list._origin;
            var newTail = list._tail, newRoot = list._root, didAlter = MakeRef(DID_ALTER);
            return index >= getTailOffset(list._capacity) ? newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter) : newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter), 
            didAlter.value ? list.__ownerID ? (list._root = newRoot, list._tail = newTail, list.__hash = void 0, 
            list.__altered = !0, list) : makeList(list._origin, list._capacity, list._level, newRoot, newTail) : list;
        }
        function updateVNode(node, ownerID, level, index, value, didAlter) {
            var idx = index >>> level & MASK, nodeHas = node && idx < node.array.length;
            if (!nodeHas && void 0 === value) return node;
            var newNode;
            if (level > 0) {
                var lowerNode = node && node.array[idx], newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
                return newLowerNode === lowerNode ? node : (newNode = editableVNode(node, ownerID), 
                newNode.array[idx] = newLowerNode, newNode);
            }
            return nodeHas && node.array[idx] === value ? node : (SetRef(didAlter), newNode = editableVNode(node, ownerID), 
            void 0 === value && idx === newNode.array.length - 1 ? newNode.array.pop() : newNode.array[idx] = value, 
            newNode);
        }
        function editableVNode(node, ownerID) {
            return ownerID && node && ownerID === node.ownerID ? node : new VNode(node ? node.array.slice() : [], ownerID);
        }
        function listNodeFor(list, rawIndex) {
            if (rawIndex >= getTailOffset(list._capacity)) return list._tail;
            if (rawIndex < 1 << list._level + SHIFT) {
                for (var node = list._root, level = list._level; node && level > 0; ) node = node.array[rawIndex >>> level & MASK], 
                level -= SHIFT;
                return node;
            }
        }
        function setListBounds(list, begin, end) {
            // Sanitize begin & end using this shorthand for ToInt32(argument)
            // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
            void 0 !== begin && (begin |= 0), void 0 !== end && (end |= 0);
            var owner = list.__ownerID || new OwnerID(), oldOrigin = list._origin, oldCapacity = list._capacity, newOrigin = oldOrigin + begin, newCapacity = void 0 === end ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
            if (newOrigin === oldOrigin && newCapacity === oldCapacity) return list;
            // If it's going to end after it starts, it's empty.
            if (newOrigin >= newCapacity) return list.clear();
            for (var newLevel = list._level, newRoot = list._root, offsetShift = 0; newOrigin + offsetShift < 0; ) newRoot = new VNode(newRoot && newRoot.array.length ? [ void 0, newRoot ] : [], owner), 
            newLevel += SHIFT, offsetShift += 1 << newLevel;
            offsetShift && (newOrigin += offsetShift, oldOrigin += offsetShift, newCapacity += offsetShift, 
            oldCapacity += offsetShift);
            // New size might need creating a higher root.
            for (var oldTailOffset = getTailOffset(oldCapacity), newTailOffset = getTailOffset(newCapacity); newTailOffset >= 1 << newLevel + SHIFT; ) newRoot = new VNode(newRoot && newRoot.array.length ? [ newRoot ] : [], owner), 
            newLevel += SHIFT;
            // Locate or create the new tail.
            var oldTail = list._tail, newTail = newTailOffset < oldTailOffset ? listNodeFor(list, newCapacity - 1) : newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
            // Merge Tail into tree.
            if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
                newRoot = editableVNode(newRoot, owner);
                for (var node = newRoot, level = newLevel; level > SHIFT; level -= SHIFT) {
                    var idx = oldTailOffset >>> level & MASK;
                    node = node.array[idx] = editableVNode(node.array[idx], owner);
                }
                node.array[oldTailOffset >>> SHIFT & MASK] = oldTail;
            }
            // If the new origin is within the tail, then we do not need a root.
            if (// If the size has been reduced, there's a chance the tail needs to be trimmed.
            newCapacity < oldCapacity && (newTail = newTail && newTail.removeAfter(owner, 0, newCapacity)), 
            newOrigin >= newTailOffset) newOrigin -= newTailOffset, newCapacity -= newTailOffset, 
            newLevel = SHIFT, newRoot = null, newTail = newTail && newTail.removeBefore(owner, 0, newOrigin); else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
                // Identify the new top root node of the subtree of the old root.
                for (offsetShift = 0; newRoot; ) {
                    var beginIndex = newOrigin >>> newLevel & MASK;
                    if (beginIndex !== newTailOffset >>> newLevel & MASK) break;
                    beginIndex && (offsetShift += (1 << newLevel) * beginIndex), newLevel -= SHIFT, 
                    newRoot = newRoot.array[beginIndex];
                }
                // Trim the new sides of the new root.
                newRoot && newOrigin > oldOrigin && (newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift)), 
                newRoot && newTailOffset < oldTailOffset && (newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift)), 
                offsetShift && (newOrigin -= offsetShift, newCapacity -= offsetShift);
            }
            return list.__ownerID ? (list.size = newCapacity - newOrigin, list._origin = newOrigin, 
            list._capacity = newCapacity, list._level = newLevel, list._root = newRoot, list._tail = newTail, 
            list.__hash = void 0, list.__altered = !0, list) : makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
        }
        function mergeIntoListWith(list, merger, iterables) {
            for (var iters = [], maxSize = 0, ii = 0; ii < iterables.length; ii++) {
                var value = iterables[ii], iter = IndexedIterable(value);
                iter.size > maxSize && (maxSize = iter.size), isIterable(value) || (iter = iter.map(function(v) {
                    return fromJS(v);
                })), iters.push(iter);
            }
            return maxSize > list.size && (list = list.setSize(maxSize)), mergeIntoCollectionWith(list, merger, iters);
        }
        function getTailOffset(size) {
            return size < SIZE ? 0 : size - 1 >>> SHIFT << SHIFT;
        }
        // @pragma Construction
        function OrderedMap(value) {
            return null === value || void 0 === value ? emptyOrderedMap() : isOrderedMap(value) ? value : emptyOrderedMap().withMutations(function(map) {
                var iter = KeyedIterable(value);
                assertNotInfinite(iter.size), iter.forEach(function(v, k) {
                    return map.set(k, v);
                });
            });
        }
        function isOrderedMap(maybeOrderedMap) {
            return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
        }
        function makeOrderedMap(map, list, ownerID, hash) {
            var omap = Object.create(OrderedMap.prototype);
            return omap.size = map ? map.size : 0, omap._map = map, omap._list = list, omap.__ownerID = ownerID, 
            omap.__hash = hash, omap;
        }
        function emptyOrderedMap() {
            return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
        }
        function updateOrderedMap(omap, k, v) {
            var newMap, newList, map = omap._map, list = omap._list, i = map.get(k), has = void 0 !== i;
            if (v === NOT_SET) {
                // removed
                if (!has) return omap;
                list.size >= SIZE && list.size >= 2 * map.size ? (newList = list.filter(function(entry, idx) {
                    return void 0 !== entry && i !== idx;
                }), newMap = newList.toKeyedSeq().map(function(entry) {
                    return entry[0];
                }).flip().toMap(), omap.__ownerID && (newMap.__ownerID = newList.__ownerID = omap.__ownerID)) : (newMap = map.remove(k), 
                newList = i === list.size - 1 ? list.pop() : list.set(i, void 0));
            } else if (has) {
                if (v === list.get(i)[1]) return omap;
                newMap = map, newList = list.set(i, [ k, v ]);
            } else newMap = map.set(k, list.size), newList = list.set(list.size, [ k, v ]);
            return omap.__ownerID ? (omap.size = newMap.size, omap._map = newMap, omap._list = newList, 
            omap.__hash = void 0, omap) : makeOrderedMap(newMap, newList);
        }
        function ToKeyedSequence(indexed, useKeys) {
            this._iter = indexed, this._useKeys = useKeys, this.size = indexed.size;
        }
        function ToIndexedSequence(iter) {
            this._iter = iter, this.size = iter.size;
        }
        function ToSetSequence(iter) {
            this._iter = iter, this.size = iter.size;
        }
        function FromEntriesSequence(entries) {
            this._iter = entries, this.size = entries.size;
        }
        function flipFactory(iterable) {
            var flipSequence = makeSequence(iterable);
            return flipSequence._iter = iterable, flipSequence.size = iterable.size, flipSequence.flip = function() {
                return iterable;
            }, flipSequence.reverse = function() {
                var reversedSequence = iterable.reverse.apply(this);
                // super.reverse()
                return reversedSequence.flip = function() {
                    return iterable.reverse();
                }, reversedSequence;
            }, flipSequence.has = function(key) {
                return iterable.includes(key);
            }, flipSequence.includes = function(key) {
                return iterable.has(key);
            }, flipSequence.cacheResult = cacheResultThrough, flipSequence.__iterateUncached = function(fn, reverse) {
                var this$0 = this;
                return iterable.__iterate(function(v, k) {
                    return !1 !== fn(k, v, this$0);
                }, reverse);
            }, flipSequence.__iteratorUncached = function(type, reverse) {
                if (type === ITERATE_ENTRIES) {
                    var iterator = iterable.__iterator(type, reverse);
                    return new Iterator(function() {
                        var step = iterator.next();
                        if (!step.done) {
                            var k = step.value[0];
                            step.value[0] = step.value[1], step.value[1] = k;
                        }
                        return step;
                    });
                }
                return iterable.__iterator(type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES, reverse);
            }, flipSequence;
        }
        function mapFactory(iterable, mapper, context) {
            var mappedSequence = makeSequence(iterable);
            return mappedSequence.size = iterable.size, mappedSequence.has = function(key) {
                return iterable.has(key);
            }, mappedSequence.get = function(key, notSetValue) {
                var v = iterable.get(key, NOT_SET);
                return v === NOT_SET ? notSetValue : mapper.call(context, v, key, iterable);
            }, mappedSequence.__iterateUncached = function(fn, reverse) {
                var this$0 = this;
                return iterable.__iterate(function(v, k, c) {
                    return !1 !== fn(mapper.call(context, v, k, c), k, this$0);
                }, reverse);
            }, mappedSequence.__iteratorUncached = function(type, reverse) {
                var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
                return new Iterator(function() {
                    var step = iterator.next();
                    if (step.done) return step;
                    var entry = step.value, key = entry[0];
                    return iteratorValue(type, key, mapper.call(context, entry[1], key, iterable), step);
                });
            }, mappedSequence;
        }
        function reverseFactory(iterable, useKeys) {
            var reversedSequence = makeSequence(iterable);
            return reversedSequence._iter = iterable, reversedSequence.size = iterable.size, 
            reversedSequence.reverse = function() {
                return iterable;
            }, iterable.flip && (reversedSequence.flip = function() {
                var flipSequence = flipFactory(iterable);
                return flipSequence.reverse = function() {
                    return iterable.flip();
                }, flipSequence;
            }), reversedSequence.get = function(key, notSetValue) {
                return iterable.get(useKeys ? key : -1 - key, notSetValue);
            }, reversedSequence.has = function(key) {
                return iterable.has(useKeys ? key : -1 - key);
            }, reversedSequence.includes = function(value) {
                return iterable.includes(value);
            }, reversedSequence.cacheResult = cacheResultThrough, reversedSequence.__iterate = function(fn, reverse) {
                var this$0 = this;
                return iterable.__iterate(function(v, k) {
                    return fn(v, k, this$0);
                }, !reverse);
            }, reversedSequence.__iterator = function(type, reverse) {
                return iterable.__iterator(type, !reverse);
            }, reversedSequence;
        }
        function filterFactory(iterable, predicate, context, useKeys) {
            var filterSequence = makeSequence(iterable);
            return useKeys && (filterSequence.has = function(key) {
                var v = iterable.get(key, NOT_SET);
                return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
            }, filterSequence.get = function(key, notSetValue) {
                var v = iterable.get(key, NOT_SET);
                return v !== NOT_SET && predicate.call(context, v, key, iterable) ? v : notSetValue;
            }), filterSequence.__iterateUncached = function(fn, reverse) {
                var this$0 = this, iterations = 0;
                return iterable.__iterate(function(v, k, c) {
                    if (predicate.call(context, v, k, c)) return iterations++, fn(v, useKeys ? k : iterations - 1, this$0);
                }, reverse), iterations;
            }, filterSequence.__iteratorUncached = function(type, reverse) {
                var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse), iterations = 0;
                return new Iterator(function() {
                    for (;;) {
                        var step = iterator.next();
                        if (step.done) return step;
                        var entry = step.value, key = entry[0], value = entry[1];
                        if (predicate.call(context, value, key, iterable)) return iteratorValue(type, useKeys ? key : iterations++, value, step);
                    }
                });
            }, filterSequence;
        }
        function countByFactory(iterable, grouper, context) {
            var groups = Map().asMutable();
            return iterable.__iterate(function(v, k) {
                groups.update(grouper.call(context, v, k, iterable), 0, function(a) {
                    return a + 1;
                });
            }), groups.asImmutable();
        }
        function groupByFactory(iterable, grouper, context) {
            var isKeyedIter = isKeyed(iterable), groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
            iterable.__iterate(function(v, k) {
                groups.update(grouper.call(context, v, k, iterable), function(a) {
                    return a = a || [], a.push(isKeyedIter ? [ k, v ] : v), a;
                });
            });
            var coerce = iterableClass(iterable);
            return groups.map(function(arr) {
                return reify(iterable, coerce(arr));
            });
        }
        function sliceFactory(iterable, begin, end, useKeys) {
            var originalSize = iterable.size;
            if (// Sanitize begin & end using this shorthand for ToInt32(argument)
            // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
            void 0 !== begin && (begin |= 0), void 0 !== end && (end === 1 / 0 ? end = originalSize : end |= 0), 
            wholeSlice(begin, end, originalSize)) return iterable;
            var resolvedBegin = resolveBegin(begin, originalSize), resolvedEnd = resolveEnd(end, originalSize);
            // begin or end will be NaN if they were provided as negative numbers and
            // this iterable's size is unknown. In that case, cache first so there is
            // a known size and these do not resolve to NaN.
            if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
            // Note: resolvedEnd is undefined when the original sequence's length is
            // unknown and this slice did not supply an end and should contain all
            // elements after resolvedBegin.
            // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
            var sliceSize, resolvedSize = resolvedEnd - resolvedBegin;
            resolvedSize === resolvedSize && (sliceSize = resolvedSize < 0 ? 0 : resolvedSize);
            var sliceSeq = makeSequence(iterable);
            // If iterable.size is undefined, the size of the realized sliceSeq is
            // unknown at this point unless the number of items to slice is 0
            return sliceSeq.size = 0 === sliceSize ? sliceSize : iterable.size && sliceSize || void 0, 
            !useKeys && isSeq(iterable) && sliceSize >= 0 && (sliceSeq.get = function(index, notSetValue) {
                return index = wrapIndex(this, index), index >= 0 && index < sliceSize ? iterable.get(index + resolvedBegin, notSetValue) : notSetValue;
            }), sliceSeq.__iterateUncached = function(fn, reverse) {
                var this$0 = this;
                if (0 === sliceSize) return 0;
                if (reverse) return this.cacheResult().__iterate(fn, reverse);
                var skipped = 0, isSkipping = !0, iterations = 0;
                return iterable.__iterate(function(v, k) {
                    if (!isSkipping || !(isSkipping = skipped++ < resolvedBegin)) return iterations++, 
                    !1 !== fn(v, useKeys ? k : iterations - 1, this$0) && iterations !== sliceSize;
                }), iterations;
            }, sliceSeq.__iteratorUncached = function(type, reverse) {
                if (0 !== sliceSize && reverse) return this.cacheResult().__iterator(type, reverse);
                // Don't bother instantiating parent iterator if taking 0.
                var iterator = 0 !== sliceSize && iterable.__iterator(type, reverse), skipped = 0, iterations = 0;
                return new Iterator(function() {
                    for (;skipped++ < resolvedBegin; ) iterator.next();
                    if (++iterations > sliceSize) return iteratorDone();
                    var step = iterator.next();
                    return useKeys || type === ITERATE_VALUES ? step : type === ITERATE_KEYS ? iteratorValue(type, iterations - 1, void 0, step) : iteratorValue(type, iterations - 1, step.value[1], step);
                });
            }, sliceSeq;
        }
        function takeWhileFactory(iterable, predicate, context) {
            var takeSequence = makeSequence(iterable);
            return takeSequence.__iterateUncached = function(fn, reverse) {
                var this$0 = this;
                if (reverse) return this.cacheResult().__iterate(fn, reverse);
                var iterations = 0;
                return iterable.__iterate(function(v, k, c) {
                    return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0);
                }), iterations;
            }, takeSequence.__iteratorUncached = function(type, reverse) {
                var this$0 = this;
                if (reverse) return this.cacheResult().__iterator(type, reverse);
                var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse), iterating = !0;
                return new Iterator(function() {
                    if (!iterating) return iteratorDone();
                    var step = iterator.next();
                    if (step.done) return step;
                    var entry = step.value, k = entry[0], v = entry[1];
                    return predicate.call(context, v, k, this$0) ? type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step) : (iterating = !1, 
                    iteratorDone());
                });
            }, takeSequence;
        }
        function skipWhileFactory(iterable, predicate, context, useKeys) {
            var skipSequence = makeSequence(iterable);
            return skipSequence.__iterateUncached = function(fn, reverse) {
                var this$0 = this;
                if (reverse) return this.cacheResult().__iterate(fn, reverse);
                var isSkipping = !0, iterations = 0;
                return iterable.__iterate(function(v, k, c) {
                    if (!isSkipping || !(isSkipping = predicate.call(context, v, k, c))) return iterations++, 
                    fn(v, useKeys ? k : iterations - 1, this$0);
                }), iterations;
            }, skipSequence.__iteratorUncached = function(type, reverse) {
                var this$0 = this;
                if (reverse) return this.cacheResult().__iterator(type, reverse);
                var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse), skipping = !0, iterations = 0;
                return new Iterator(function() {
                    var step, k, v;
                    do {
                        if (step = iterator.next(), step.done) return useKeys || type === ITERATE_VALUES ? step : type === ITERATE_KEYS ? iteratorValue(type, iterations++, void 0, step) : iteratorValue(type, iterations++, step.value[1], step);
                        var entry = step.value;
                        k = entry[0], v = entry[1], skipping && (skipping = predicate.call(context, v, k, this$0));
                    } while (skipping);
                    return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
                });
            }, skipSequence;
        }
        function concatFactory(iterable, values) {
            var isKeyedIterable = isKeyed(iterable), iters = [ iterable ].concat(values).map(function(v) {
                return isIterable(v) ? isKeyedIterable && (v = KeyedIterable(v)) : v = isKeyedIterable ? keyedSeqFromValue(v) : indexedSeqFromValue(Array.isArray(v) ? v : [ v ]), 
                v;
            }).filter(function(v) {
                return 0 !== v.size;
            });
            if (0 === iters.length) return iterable;
            if (1 === iters.length) {
                var singleton = iters[0];
                if (singleton === iterable || isKeyedIterable && isKeyed(singleton) || isIndexed(iterable) && isIndexed(singleton)) return singleton;
            }
            var concatSeq = new ArraySeq(iters);
            return isKeyedIterable ? concatSeq = concatSeq.toKeyedSeq() : isIndexed(iterable) || (concatSeq = concatSeq.toSetSeq()), 
            concatSeq = concatSeq.flatten(!0), concatSeq.size = iters.reduce(function(sum, seq) {
                if (void 0 !== sum) {
                    var size = seq.size;
                    if (void 0 !== size) return sum + size;
                }
            }, 0), concatSeq;
        }
        function flattenFactory(iterable, depth, useKeys) {
            var flatSequence = makeSequence(iterable);
            return flatSequence.__iterateUncached = function(fn, reverse) {
                function flatDeep(iter, currentDepth) {
                    var this$0 = this;
                    iter.__iterate(function(v, k) {
                        return (!depth || currentDepth < depth) && isIterable(v) ? flatDeep(v, currentDepth + 1) : !1 === fn(v, useKeys ? k : iterations++, this$0) && (stopped = !0), 
                        !stopped;
                    }, reverse);
                }
                var iterations = 0, stopped = !1;
                return flatDeep(iterable, 0), iterations;
            }, flatSequence.__iteratorUncached = function(type, reverse) {
                var iterator = iterable.__iterator(type, reverse), stack = [], iterations = 0;
                return new Iterator(function() {
                    for (;iterator; ) {
                        var step = iterator.next();
                        if (!1 === step.done) {
                            var v = step.value;
                            if (type === ITERATE_ENTRIES && (v = v[1]), depth && !(stack.length < depth) || !isIterable(v)) return useKeys ? step : iteratorValue(type, iterations++, v, step);
                            stack.push(iterator), iterator = v.__iterator(type, reverse);
                        } else iterator = stack.pop();
                    }
                    return iteratorDone();
                });
            }, flatSequence;
        }
        function flatMapFactory(iterable, mapper, context) {
            var coerce = iterableClass(iterable);
            return iterable.toSeq().map(function(v, k) {
                return coerce(mapper.call(context, v, k, iterable));
            }).flatten(!0);
        }
        function interposeFactory(iterable, separator) {
            var interposedSequence = makeSequence(iterable);
            return interposedSequence.size = iterable.size && 2 * iterable.size - 1, interposedSequence.__iterateUncached = function(fn, reverse) {
                var this$0 = this, iterations = 0;
                return iterable.__iterate(function(v, k) {
                    return (!iterations || !1 !== fn(separator, iterations++, this$0)) && !1 !== fn(v, iterations++, this$0);
                }, reverse), iterations;
            }, interposedSequence.__iteratorUncached = function(type, reverse) {
                var step, iterator = iterable.__iterator(ITERATE_VALUES, reverse), iterations = 0;
                return new Iterator(function() {
                    return (!step || iterations % 2) && (step = iterator.next(), step.done) ? step : iterations % 2 ? iteratorValue(type, iterations++, separator) : iteratorValue(type, iterations++, step.value, step);
                });
            }, interposedSequence;
        }
        function sortFactory(iterable, comparator, mapper) {
            comparator || (comparator = defaultComparator);
            var isKeyedIterable = isKeyed(iterable), index = 0, entries = iterable.toSeq().map(function(v, k) {
                return [ k, v, index++, mapper ? mapper(v, k, iterable) : v ];
            }).toArray();
            return entries.sort(function(a, b) {
                return comparator(a[3], b[3]) || a[2] - b[2];
            }).forEach(isKeyedIterable ? function(v, i) {
                entries[i].length = 2;
            } : function(v, i) {
                entries[i] = v[1];
            }), isKeyedIterable ? KeyedSeq(entries) : isIndexed(iterable) ? IndexedSeq(entries) : SetSeq(entries);
        }
        function maxFactory(iterable, comparator, mapper) {
            if (comparator || (comparator = defaultComparator), mapper) {
                var entry = iterable.toSeq().map(function(v, k) {
                    return [ v, mapper(v, k, iterable) ];
                }).reduce(function(a, b) {
                    return maxCompare(comparator, a[1], b[1]) ? b : a;
                });
                return entry && entry[0];
            }
            return iterable.reduce(function(a, b) {
                return maxCompare(comparator, a, b) ? b : a;
            });
        }
        function maxCompare(comparator, a, b) {
            var comp = comparator(b, a);
            // b is considered the new max if the comparator declares them equal, but
            // they are not equal and b is in fact a nullish value.
            return 0 === comp && b !== a && (void 0 === b || null === b || b !== b) || comp > 0;
        }
        function zipWithFactory(keyIter, zipper, iters) {
            var zipSequence = makeSequence(keyIter);
            // Note: this a generic base implementation of __iterate in terms of
            // __iterator which may be more generically useful in the future.
            return zipSequence.size = new ArraySeq(iters).map(function(i) {
                return i.size;
            }).min(), zipSequence.__iterate = function(fn, reverse) {
                for (/* generic:
      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        iterations++;
        if (fn(step.value[1], step.value[0], this) === false) {
          break;
        }
      }
      return iterations;
      */
                // indexed:
                var step, iterator = this.__iterator(ITERATE_VALUES, reverse), iterations = 0; !(step = iterator.next()).done && !1 !== fn(step.value, iterations++, this); ) ;
                return iterations;
            }, zipSequence.__iteratorUncached = function(type, reverse) {
                var iterators = iters.map(function(i) {
                    return i = Iterable(i), getIterator(reverse ? i.reverse() : i);
                }), iterations = 0, isDone = !1;
                return new Iterator(function() {
                    var steps;
                    return isDone || (steps = iterators.map(function(i) {
                        return i.next();
                    }), isDone = steps.some(function(s) {
                        return s.done;
                    })), isDone ? iteratorDone() : iteratorValue(type, iterations++, zipper.apply(null, steps.map(function(s) {
                        return s.value;
                    })));
                });
            }, zipSequence;
        }
        // #pragma Helper Functions
        function reify(iter, seq) {
            return isSeq(iter) ? seq : iter.constructor(seq);
        }
        function validateEntry(entry) {
            if (entry !== Object(entry)) throw new TypeError("Expected [K, V] tuple: " + entry);
        }
        function resolveSize(iter) {
            return assertNotInfinite(iter.size), ensureSize(iter);
        }
        function iterableClass(iterable) {
            return isKeyed(iterable) ? KeyedIterable : isIndexed(iterable) ? IndexedIterable : SetIterable;
        }
        function makeSequence(iterable) {
            return Object.create((isKeyed(iterable) ? KeyedSeq : isIndexed(iterable) ? IndexedSeq : SetSeq).prototype);
        }
        function cacheResultThrough() {
            return this._iter.cacheResult ? (this._iter.cacheResult(), this.size = this._iter.size, 
            this) : Seq.prototype.cacheResult.call(this);
        }
        function defaultComparator(a, b) {
            return a > b ? 1 : a < b ? -1 : 0;
        }
        function forceIterator(keyPath) {
            var iter = getIterator(keyPath);
            if (!iter) {
                // Array might not be iterable in this environment, so we need a fallback
                // to our wrapped type.
                if (!isArrayLike(keyPath)) throw new TypeError("Expected iterable or array-like: " + keyPath);
                iter = getIterator(Iterable(keyPath));
            }
            return iter;
        }
        function Record(defaultValues, name) {
            var hasInitialized, RecordType = function(values) {
                if (values instanceof RecordType) return values;
                if (!(this instanceof RecordType)) return new RecordType(values);
                if (!hasInitialized) {
                    hasInitialized = !0;
                    var keys = Object.keys(defaultValues);
                    setProps(RecordTypePrototype, keys), RecordTypePrototype.size = keys.length, RecordTypePrototype._name = name, 
                    RecordTypePrototype._keys = keys, RecordTypePrototype._defaultValues = defaultValues;
                }
                this._map = Map(values);
            }, RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
            return RecordTypePrototype.constructor = RecordType, RecordType;
        }
        function makeRecord(likeRecord, map, ownerID) {
            var record = Object.create(Object.getPrototypeOf(likeRecord));
            return record._map = map, record.__ownerID = ownerID, record;
        }
        function recordName(record) {
            return record._name || record.constructor.name || "Record";
        }
        function setProps(prototype, names) {
            try {
                names.forEach(setProp.bind(void 0, prototype));
            } catch (error) {}
        }
        function setProp(prototype, name) {
            Object.defineProperty(prototype, name, {
                get: function() {
                    return this.get(name);
                },
                set: function(value) {
                    invariant(this.__ownerID, "Cannot set on an immutable record."), this.set(name, value);
                }
            });
        }
        // @pragma Construction
        function Set(value) {
            return null === value || void 0 === value ? emptySet() : isSet(value) && !isOrdered(value) ? value : emptySet().withMutations(function(set) {
                var iter = SetIterable(value);
                assertNotInfinite(iter.size), iter.forEach(function(v) {
                    return set.add(v);
                });
            });
        }
        function isSet(maybeSet) {
            return !(!maybeSet || !maybeSet[IS_SET_SENTINEL]);
        }
        function updateSet(set, newMap) {
            return set.__ownerID ? (set.size = newMap.size, set._map = newMap, set) : newMap === set._map ? set : 0 === newMap.size ? set.__empty() : set.__make(newMap);
        }
        function makeSet(map, ownerID) {
            var set = Object.create(SetPrototype);
            return set.size = map ? map.size : 0, set._map = map, set.__ownerID = ownerID, set;
        }
        function emptySet() {
            return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
        }
        // @pragma Construction
        function OrderedSet(value) {
            return null === value || void 0 === value ? emptyOrderedSet() : isOrderedSet(value) ? value : emptyOrderedSet().withMutations(function(set) {
                var iter = SetIterable(value);
                assertNotInfinite(iter.size), iter.forEach(function(v) {
                    return set.add(v);
                });
            });
        }
        function isOrderedSet(maybeOrderedSet) {
            return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
        }
        function makeOrderedSet(map, ownerID) {
            var set = Object.create(OrderedSetPrototype);
            return set.size = map ? map.size : 0, set._map = map, set.__ownerID = ownerID, set;
        }
        function emptyOrderedSet() {
            return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
        }
        // @pragma Construction
        function Stack(value) {
            return null === value || void 0 === value ? emptyStack() : isStack(value) ? value : emptyStack().unshiftAll(value);
        }
        function isStack(maybeStack) {
            return !(!maybeStack || !maybeStack[IS_STACK_SENTINEL]);
        }
        function makeStack(size, head, ownerID, hash) {
            var map = Object.create(StackPrototype);
            return map.size = size, map._head = head, map.__ownerID = ownerID, map.__hash = hash, 
            map.__altered = !1, map;
        }
        function emptyStack() {
            return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
        }
        /**
   * Contributes additional methods to a constructor
   */
        function mixin(ctor, methods) {
            var keyCopier = function(key) {
                ctor.prototype[key] = methods[key];
            };
            return Object.keys(methods).forEach(keyCopier), Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(methods).forEach(keyCopier), 
            ctor;
        }
        // #pragma Helper functions
        function keyMapper(v, k) {
            return k;
        }
        function entryMapper(v, k) {
            return [ k, v ];
        }
        function not(predicate) {
            return function() {
                return !predicate.apply(this, arguments);
            };
        }
        function neg(predicate) {
            return function() {
                return -predicate.apply(this, arguments);
            };
        }
        function quoteString(value) {
            return "string" == typeof value ? JSON.stringify(value) : String(value);
        }
        function defaultZipper() {
            return arrCopy(arguments);
        }
        function defaultNegComparator(a, b) {
            return a < b ? 1 : a > b ? -1 : 0;
        }
        function hashIterable(iterable) {
            if (iterable.size === 1 / 0) return 0;
            var ordered = isOrdered(iterable), keyed = isKeyed(iterable), h = ordered ? 1 : 0;
            return murmurHashOfSize(iterable.__iterate(keyed ? ordered ? function(v, k) {
                h = 31 * h + hashMerge(hash(v), hash(k)) | 0;
            } : function(v, k) {
                h = h + hashMerge(hash(v), hash(k)) | 0;
            } : ordered ? function(v) {
                h = 31 * h + hash(v) | 0;
            } : function(v) {
                h = h + hash(v) | 0;
            }), h);
        }
        function murmurHashOfSize(size, h) {
            return h = imul(h, 3432918353), h = imul(h << 15 | h >>> -15, 461845907), h = imul(h << 13 | h >>> -13, 5), 
            h = (h + 3864292196 | 0) ^ size, h = imul(h ^ h >>> 16, 2246822507), h = imul(h ^ h >>> 13, 3266489909), 
            h = smi(h ^ h >>> 16);
        }
        function hashMerge(a, b) {
            return a ^ b + 2654435769 + (a << 6) + (a >> 2) | 0;
        }
        var SLICE$0 = Array.prototype.slice;
        createClass(KeyedIterable, Iterable), createClass(IndexedIterable, Iterable), createClass(SetIterable, Iterable), 
        Iterable.isIterable = isIterable, Iterable.isKeyed = isKeyed, Iterable.isIndexed = isIndexed, 
        Iterable.isAssociative = isAssociative, Iterable.isOrdered = isOrdered, Iterable.Keyed = KeyedIterable, 
        Iterable.Indexed = IndexedIterable, Iterable.Set = SetIterable;
        var IS_ITERABLE_SENTINEL = "@@__IMMUTABLE_ITERABLE__@@", IS_KEYED_SENTINEL = "@@__IMMUTABLE_KEYED__@@", IS_INDEXED_SENTINEL = "@@__IMMUTABLE_INDEXED__@@", IS_ORDERED_SENTINEL = "@@__IMMUTABLE_ORDERED__@@", SHIFT = 5, SIZE = 1 << SHIFT, MASK = SIZE - 1, NOT_SET = {}, CHANGE_LENGTH = {
            value: !1
        }, DID_ALTER = {
            value: !1
        }, ITERATE_KEYS = 0, ITERATE_VALUES = 1, ITERATE_ENTRIES = 2, REAL_ITERATOR_SYMBOL = "function" == typeof Symbol && Symbol.iterator, FAUX_ITERATOR_SYMBOL = "@@iterator", ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
        Iterator.prototype.toString = function() {
            return "[Iterator]";
        }, Iterator.KEYS = ITERATE_KEYS, Iterator.VALUES = ITERATE_VALUES, Iterator.ENTRIES = ITERATE_ENTRIES, 
        Iterator.prototype.inspect = Iterator.prototype.toSource = function() {
            return this.toString();
        }, Iterator.prototype[ITERATOR_SYMBOL] = function() {
            return this;
        }, createClass(Seq, Iterable), Seq.of = function() {
            return Seq(arguments);
        }, Seq.prototype.toSeq = function() {
            return this;
        }, Seq.prototype.toString = function() {
            return this.__toString("Seq {", "}");
        }, Seq.prototype.cacheResult = function() {
            return !this._cache && this.__iterateUncached && (this._cache = this.entrySeq().toArray(), 
            this.size = this._cache.length), this;
        }, // abstract __iterateUncached(fn, reverse)
        Seq.prototype.__iterate = function(fn, reverse) {
            return seqIterate(this, fn, reverse, !0);
        }, // abstract __iteratorUncached(type, reverse)
        Seq.prototype.__iterator = function(type, reverse) {
            return seqIterator(this, type, reverse, !0);
        }, createClass(KeyedSeq, Seq), KeyedSeq.prototype.toKeyedSeq = function() {
            return this;
        }, createClass(IndexedSeq, Seq), IndexedSeq.of = function() {
            return IndexedSeq(arguments);
        }, IndexedSeq.prototype.toIndexedSeq = function() {
            return this;
        }, IndexedSeq.prototype.toString = function() {
            return this.__toString("Seq [", "]");
        }, IndexedSeq.prototype.__iterate = function(fn, reverse) {
            return seqIterate(this, fn, reverse, !1);
        }, IndexedSeq.prototype.__iterator = function(type, reverse) {
            return seqIterator(this, type, reverse, !1);
        }, createClass(SetSeq, Seq), SetSeq.of = function() {
            return SetSeq(arguments);
        }, SetSeq.prototype.toSetSeq = function() {
            return this;
        }, Seq.isSeq = isSeq, Seq.Keyed = KeyedSeq, Seq.Set = SetSeq, Seq.Indexed = IndexedSeq;
        var IS_SEQ_SENTINEL = "@@__IMMUTABLE_SEQ__@@";
        Seq.prototype[IS_SEQ_SENTINEL] = !0, createClass(ArraySeq, IndexedSeq), ArraySeq.prototype.get = function(index, notSetValue) {
            return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
        }, ArraySeq.prototype.__iterate = function(fn, reverse) {
            for (var array = this._array, maxIndex = array.length - 1, ii = 0; ii <= maxIndex; ii++) if (!1 === fn(array[reverse ? maxIndex - ii : ii], ii, this)) return ii + 1;
            return ii;
        }, ArraySeq.prototype.__iterator = function(type, reverse) {
            var array = this._array, maxIndex = array.length - 1, ii = 0;
            return new Iterator(function() {
                return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++]);
            });
        }, createClass(ObjectSeq, KeyedSeq), ObjectSeq.prototype.get = function(key, notSetValue) {
            return void 0 === notSetValue || this.has(key) ? this._object[key] : notSetValue;
        }, ObjectSeq.prototype.has = function(key) {
            return this._object.hasOwnProperty(key);
        }, ObjectSeq.prototype.__iterate = function(fn, reverse) {
            for (var object = this._object, keys = this._keys, maxIndex = keys.length - 1, ii = 0; ii <= maxIndex; ii++) {
                var key = keys[reverse ? maxIndex - ii : ii];
                if (!1 === fn(object[key], key, this)) return ii + 1;
            }
            return ii;
        }, ObjectSeq.prototype.__iterator = function(type, reverse) {
            var object = this._object, keys = this._keys, maxIndex = keys.length - 1, ii = 0;
            return new Iterator(function() {
                var key = keys[reverse ? maxIndex - ii : ii];
                return ii++ > maxIndex ? iteratorDone() : iteratorValue(type, key, object[key]);
            });
        }, ObjectSeq.prototype[IS_ORDERED_SENTINEL] = !0, createClass(IterableSeq, IndexedSeq), 
        IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
            if (reverse) return this.cacheResult().__iterate(fn, reverse);
            var iterable = this._iterable, iterator = getIterator(iterable), iterations = 0;
            if (isIterator(iterator)) for (var step; !(step = iterator.next()).done && !1 !== fn(step.value, iterations++, this); ) ;
            return iterations;
        }, IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
            if (reverse) return this.cacheResult().__iterator(type, reverse);
            var iterable = this._iterable, iterator = getIterator(iterable);
            if (!isIterator(iterator)) return new Iterator(iteratorDone);
            var iterations = 0;
            return new Iterator(function() {
                var step = iterator.next();
                return step.done ? step : iteratorValue(type, iterations++, step.value);
            });
        }, createClass(IteratorSeq, IndexedSeq), IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
            if (reverse) return this.cacheResult().__iterate(fn, reverse);
            for (var iterator = this._iterator, cache = this._iteratorCache, iterations = 0; iterations < cache.length; ) if (!1 === fn(cache[iterations], iterations++, this)) return iterations;
            for (var step; !(step = iterator.next()).done; ) {
                var val = step.value;
                if (cache[iterations] = val, !1 === fn(val, iterations++, this)) break;
            }
            return iterations;
        }, IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
            if (reverse) return this.cacheResult().__iterator(type, reverse);
            var iterator = this._iterator, cache = this._iteratorCache, iterations = 0;
            return new Iterator(function() {
                if (iterations >= cache.length) {
                    var step = iterator.next();
                    if (step.done) return step;
                    cache[iterations] = step.value;
                }
                return iteratorValue(type, iterations, cache[iterations++]);
            });
        };
        var EMPTY_SEQ;
        createClass(Repeat, IndexedSeq), Repeat.prototype.toString = function() {
            return 0 === this.size ? "Repeat []" : "Repeat [ " + this._value + " " + this.size + " times ]";
        }, Repeat.prototype.get = function(index, notSetValue) {
            return this.has(index) ? this._value : notSetValue;
        }, Repeat.prototype.includes = function(searchValue) {
            return is(this._value, searchValue);
        }, Repeat.prototype.slice = function(begin, end) {
            var size = this.size;
            return wholeSlice(begin, end, size) ? this : new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
        }, Repeat.prototype.reverse = function() {
            return this;
        }, Repeat.prototype.indexOf = function(searchValue) {
            return is(this._value, searchValue) ? 0 : -1;
        }, Repeat.prototype.lastIndexOf = function(searchValue) {
            return is(this._value, searchValue) ? this.size : -1;
        }, Repeat.prototype.__iterate = function(fn, reverse) {
            for (var ii = 0; ii < this.size; ii++) if (!1 === fn(this._value, ii, this)) return ii + 1;
            return ii;
        }, Repeat.prototype.__iterator = function(type, reverse) {
            var this$0 = this, ii = 0;
            return new Iterator(function() {
                return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone();
            });
        }, Repeat.prototype.equals = function(other) {
            return other instanceof Repeat ? is(this._value, other._value) : deepEqual(other);
        };
        var EMPTY_REPEAT;
        createClass(Range, IndexedSeq), Range.prototype.toString = function() {
            return 0 === this.size ? "Range []" : "Range [ " + this._start + "..." + this._end + (1 !== this._step ? " by " + this._step : "") + " ]";
        }, Range.prototype.get = function(index, notSetValue) {
            return this.has(index) ? this._start + wrapIndex(this, index) * this._step : notSetValue;
        }, Range.prototype.includes = function(searchValue) {
            var possibleIndex = (searchValue - this._start) / this._step;
            return possibleIndex >= 0 && possibleIndex < this.size && possibleIndex === Math.floor(possibleIndex);
        }, Range.prototype.slice = function(begin, end) {
            return wholeSlice(begin, end, this.size) ? this : (begin = resolveBegin(begin, this.size), 
            end = resolveEnd(end, this.size), end <= begin ? new Range(0, 0) : new Range(this.get(begin, this._end), this.get(end, this._end), this._step));
        }, Range.prototype.indexOf = function(searchValue) {
            var offsetValue = searchValue - this._start;
            if (offsetValue % this._step == 0) {
                var index = offsetValue / this._step;
                if (index >= 0 && index < this.size) return index;
            }
            return -1;
        }, Range.prototype.lastIndexOf = function(searchValue) {
            return this.indexOf(searchValue);
        }, Range.prototype.__iterate = function(fn, reverse) {
            for (var maxIndex = this.size - 1, step = this._step, value = reverse ? this._start + maxIndex * step : this._start, ii = 0; ii <= maxIndex; ii++) {
                if (!1 === fn(value, ii, this)) return ii + 1;
                value += reverse ? -step : step;
            }
            return ii;
        }, Range.prototype.__iterator = function(type, reverse) {
            var maxIndex = this.size - 1, step = this._step, value = reverse ? this._start + maxIndex * step : this._start, ii = 0;
            return new Iterator(function() {
                var v = value;
                return value += reverse ? -step : step, ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
            });
        }, Range.prototype.equals = function(other) {
            return other instanceof Range ? this._start === other._start && this._end === other._end && this._step === other._step : deepEqual(this, other);
        };
        var EMPTY_RANGE;
        createClass(Collection, Iterable), createClass(KeyedCollection, Collection), createClass(IndexedCollection, Collection), 
        createClass(SetCollection, Collection), Collection.Keyed = KeyedCollection, Collection.Indexed = IndexedCollection, 
        Collection.Set = SetCollection;
        var weakMap, imul = "function" == typeof Math.imul && -2 === Math.imul(4294967295, 2) ? Math.imul : function(a, b) {
            a |= 0, // int
            b |= 0;
            // int
            var c = 65535 & a, d = 65535 & b;
            // Shift by 0 fixes the sign on the high part.
            return c * d + ((a >>> 16) * d + c * (b >>> 16) << 16 >>> 0) | 0;
        }, isExtensible = Object.isExtensible, canDefineProperty = function() {
            try {
                return Object.defineProperty({}, "@", {}), !0;
            } catch (e) {
                return !1;
            }
        }(), usingWeakMap = "function" == typeof WeakMap;
        usingWeakMap && (weakMap = new WeakMap());
        var objHashUID = 0, UID_HASH_KEY = "__immutablehash__";
        "function" == typeof Symbol && (UID_HASH_KEY = Symbol(UID_HASH_KEY));
        var STRING_HASH_CACHE_MIN_STRLEN = 16, STRING_HASH_CACHE_MAX_SIZE = 255, STRING_HASH_CACHE_SIZE = 0, stringHashCache = {};
        createClass(Map, KeyedCollection), Map.of = function() {
            var keyValues = SLICE$0.call(arguments, 0);
            return emptyMap().withMutations(function(map) {
                for (var i = 0; i < keyValues.length; i += 2) {
                    if (i + 1 >= keyValues.length) throw new Error("Missing value for key: " + keyValues[i]);
                    map.set(keyValues[i], keyValues[i + 1]);
                }
            });
        }, Map.prototype.toString = function() {
            return this.__toString("Map {", "}");
        }, // @pragma Access
        Map.prototype.get = function(k, notSetValue) {
            return this._root ? this._root.get(0, void 0, k, notSetValue) : notSetValue;
        }, // @pragma Modification
        Map.prototype.set = function(k, v) {
            return updateMap(this, k, v);
        }, Map.prototype.setIn = function(keyPath, v) {
            return this.updateIn(keyPath, NOT_SET, function() {
                return v;
            });
        }, Map.prototype.remove = function(k) {
            return updateMap(this, k, NOT_SET);
        }, Map.prototype.deleteIn = function(keyPath) {
            return this.updateIn(keyPath, function() {
                return NOT_SET;
            });
        }, Map.prototype.update = function(k, notSetValue, updater) {
            return 1 === arguments.length ? k(this) : this.updateIn([ k ], notSetValue, updater);
        }, Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
            updater || (updater = notSetValue, notSetValue = void 0);
            var updatedValue = updateInDeepMap(this, forceIterator(keyPath), notSetValue, updater);
            return updatedValue === NOT_SET ? void 0 : updatedValue;
        }, Map.prototype.clear = function() {
            return 0 === this.size ? this : this.__ownerID ? (this.size = 0, this._root = null, 
            this.__hash = void 0, this.__altered = !0, this) : emptyMap();
        }, // @pragma Composition
        Map.prototype.merge = function() {
            return mergeIntoMapWith(this, void 0, arguments);
        }, Map.prototype.mergeWith = function(merger) {
            return mergeIntoMapWith(this, merger, SLICE$0.call(arguments, 1));
        }, Map.prototype.mergeIn = function(keyPath) {
            var iters = SLICE$0.call(arguments, 1);
            return this.updateIn(keyPath, emptyMap(), function(m) {
                return "function" == typeof m.merge ? m.merge.apply(m, iters) : iters[iters.length - 1];
            });
        }, Map.prototype.mergeDeep = function() {
            return mergeIntoMapWith(this, deepMerger, arguments);
        }, Map.prototype.mergeDeepWith = function(merger) {
            var iters = SLICE$0.call(arguments, 1);
            return mergeIntoMapWith(this, deepMergerWith(merger), iters);
        }, Map.prototype.mergeDeepIn = function(keyPath) {
            var iters = SLICE$0.call(arguments, 1);
            return this.updateIn(keyPath, emptyMap(), function(m) {
                return "function" == typeof m.mergeDeep ? m.mergeDeep.apply(m, iters) : iters[iters.length - 1];
            });
        }, Map.prototype.sort = function(comparator) {
            // Late binding
            return OrderedMap(sortFactory(this, comparator));
        }, Map.prototype.sortBy = function(mapper, comparator) {
            // Late binding
            return OrderedMap(sortFactory(this, comparator, mapper));
        }, // @pragma Mutability
        Map.prototype.withMutations = function(fn) {
            var mutable = this.asMutable();
            return fn(mutable), mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
        }, Map.prototype.asMutable = function() {
            return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
        }, Map.prototype.asImmutable = function() {
            return this.__ensureOwner();
        }, Map.prototype.wasAltered = function() {
            return this.__altered;
        }, Map.prototype.__iterator = function(type, reverse) {
            return new MapIterator(this, type, reverse);
        }, Map.prototype.__iterate = function(fn, reverse) {
            var this$0 = this, iterations = 0;
            return this._root && this._root.iterate(function(entry) {
                return iterations++, fn(entry[1], entry[0], this$0);
            }, reverse), iterations;
        }, Map.prototype.__ensureOwner = function(ownerID) {
            return ownerID === this.__ownerID ? this : ownerID ? makeMap(this.size, this._root, ownerID, this.__hash) : (this.__ownerID = ownerID, 
            this.__altered = !1, this);
        }, Map.isMap = isMap;
        var IS_MAP_SENTINEL = "@@__IMMUTABLE_MAP__@@", MapPrototype = Map.prototype;
        MapPrototype[IS_MAP_SENTINEL] = !0, MapPrototype.delete = MapPrototype.remove, MapPrototype.removeIn = MapPrototype.deleteIn, 
        ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
            for (var entries = this.entries, ii = 0, len = entries.length; ii < len; ii++) if (is(key, entries[ii][0])) return entries[ii][1];
            return notSetValue;
        }, ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
            for (var removed = value === NOT_SET, entries = this.entries, idx = 0, len = entries.length; idx < len && !is(key, entries[idx][0]); idx++) ;
            var exists = idx < len;
            if (exists ? entries[idx][1] === value : removed) return this;
            if (SetRef(didAlter), (removed || !exists) && SetRef(didChangeSize), !removed || 1 !== entries.length) {
                if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) return createNodes(ownerID, entries, key, value);
                var isEditable = ownerID && ownerID === this.ownerID, newEntries = isEditable ? entries : arrCopy(entries);
                return exists ? removed ? idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop() : newEntries[idx] = [ key, value ] : newEntries.push([ key, value ]), 
                isEditable ? (this.entries = newEntries, this) : new ArrayMapNode(ownerID, newEntries);
            }
        }, BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
            void 0 === keyHash && (keyHash = hash(key));
            var bit = 1 << ((0 === shift ? keyHash : keyHash >>> shift) & MASK), bitmap = this.bitmap;
            return 0 == (bitmap & bit) ? notSetValue : this.nodes[popCount(bitmap & bit - 1)].get(shift + SHIFT, keyHash, key, notSetValue);
        }, BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
            void 0 === keyHash && (keyHash = hash(key));
            var keyHashFrag = (0 === shift ? keyHash : keyHash >>> shift) & MASK, bit = 1 << keyHashFrag, bitmap = this.bitmap, exists = 0 != (bitmap & bit);
            if (!exists && value === NOT_SET) return this;
            var idx = popCount(bitmap & bit - 1), nodes = this.nodes, node = exists ? nodes[idx] : void 0, newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
            if (newNode === node) return this;
            if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
            if (exists && !newNode && 2 === nodes.length && isLeafNode(nodes[1 ^ idx])) return nodes[1 ^ idx];
            if (exists && newNode && 1 === nodes.length && isLeafNode(newNode)) return newNode;
            var isEditable = ownerID && ownerID === this.ownerID, newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit, newNodes = exists ? newNode ? setIn(nodes, idx, newNode, isEditable) : spliceOut(nodes, idx, isEditable) : spliceIn(nodes, idx, newNode, isEditable);
            return isEditable ? (this.bitmap = newBitmap, this.nodes = newNodes, this) : new BitmapIndexedNode(ownerID, newBitmap, newNodes);
        }, HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
            void 0 === keyHash && (keyHash = hash(key));
            var idx = (0 === shift ? keyHash : keyHash >>> shift) & MASK, node = this.nodes[idx];
            return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
        }, HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
            void 0 === keyHash && (keyHash = hash(key));
            var idx = (0 === shift ? keyHash : keyHash >>> shift) & MASK, removed = value === NOT_SET, nodes = this.nodes, node = nodes[idx];
            if (removed && !node) return this;
            var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
            if (newNode === node) return this;
            var newCount = this.count;
            if (node) {
                if (!newNode && --newCount < MIN_HASH_ARRAY_MAP_SIZE) return packNodes(ownerID, nodes, newCount, idx);
            } else newCount++;
            var isEditable = ownerID && ownerID === this.ownerID, newNodes = setIn(nodes, idx, newNode, isEditable);
            return isEditable ? (this.count = newCount, this.nodes = newNodes, this) : new HashArrayMapNode(ownerID, newCount, newNodes);
        }, HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
            for (var entries = this.entries, ii = 0, len = entries.length; ii < len; ii++) if (is(key, entries[ii][0])) return entries[ii][1];
            return notSetValue;
        }, HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
            void 0 === keyHash && (keyHash = hash(key));
            var removed = value === NOT_SET;
            if (keyHash !== this.keyHash) return removed ? this : (SetRef(didAlter), SetRef(didChangeSize), 
            mergeIntoNode(this, ownerID, shift, keyHash, [ key, value ]));
            for (var entries = this.entries, idx = 0, len = entries.length; idx < len && !is(key, entries[idx][0]); idx++) ;
            var exists = idx < len;
            if (exists ? entries[idx][1] === value : removed) return this;
            if (SetRef(didAlter), (removed || !exists) && SetRef(didChangeSize), removed && 2 === len) return new ValueNode(ownerID, this.keyHash, entries[1 ^ idx]);
            var isEditable = ownerID && ownerID === this.ownerID, newEntries = isEditable ? entries : arrCopy(entries);
            return exists ? removed ? idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop() : newEntries[idx] = [ key, value ] : newEntries.push([ key, value ]), 
            isEditable ? (this.entries = newEntries, this) : new HashCollisionNode(ownerID, this.keyHash, newEntries);
        }, ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
            return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
        }, ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
            var removed = value === NOT_SET, keyMatch = is(key, this.entry[0]);
            return (keyMatch ? value === this.entry[1] : removed) ? this : (SetRef(didAlter), 
            removed ? void SetRef(didChangeSize) : keyMatch ? ownerID && ownerID === this.ownerID ? (this.entry[1] = value, 
            this) : new ValueNode(ownerID, this.keyHash, [ key, value ]) : (SetRef(didChangeSize), 
            mergeIntoNode(this, ownerID, shift, hash(key), [ key, value ])));
        }, // #pragma Iterators
        ArrayMapNode.prototype.iterate = HashCollisionNode.prototype.iterate = function(fn, reverse) {
            for (var entries = this.entries, ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) if (!1 === fn(entries[reverse ? maxIndex - ii : ii])) return !1;
        }, BitmapIndexedNode.prototype.iterate = HashArrayMapNode.prototype.iterate = function(fn, reverse) {
            for (var nodes = this.nodes, ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
                var node = nodes[reverse ? maxIndex - ii : ii];
                if (node && !1 === node.iterate(fn, reverse)) return !1;
            }
        }, ValueNode.prototype.iterate = function(fn, reverse) {
            return fn(this.entry);
        }, createClass(MapIterator, Iterator), MapIterator.prototype.next = function() {
            for (var type = this._type, stack = this._stack; stack; ) {
                var maxIndex, node = stack.node, index = stack.index++;
                if (node.entry) {
                    if (0 === index) return mapIteratorValue(type, node.entry);
                } else if (node.entries) {
                    if (maxIndex = node.entries.length - 1, index <= maxIndex) return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
                } else if (maxIndex = node.nodes.length - 1, index <= maxIndex) {
                    var subNode = node.nodes[this._reverse ? maxIndex - index : index];
                    if (subNode) {
                        if (subNode.entry) return mapIteratorValue(type, subNode.entry);
                        stack = this._stack = mapIteratorFrame(subNode, stack);
                    }
                    continue;
                }
                stack = this._stack = this._stack.__prev;
            }
            return iteratorDone();
        };
        var EMPTY_MAP, MAX_ARRAY_MAP_SIZE = SIZE / 4, MAX_BITMAP_INDEXED_SIZE = SIZE / 2, MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
        createClass(List, IndexedCollection), List.of = function() {
            return this(arguments);
        }, List.prototype.toString = function() {
            return this.__toString("List [", "]");
        }, // @pragma Access
        List.prototype.get = function(index, notSetValue) {
            if ((index = wrapIndex(this, index)) >= 0 && index < this.size) {
                index += this._origin;
                var node = listNodeFor(this, index);
                return node && node.array[index & MASK];
            }
            return notSetValue;
        }, // @pragma Modification
        List.prototype.set = function(index, value) {
            return updateList(this, index, value);
        }, List.prototype.remove = function(index) {
            return this.has(index) ? 0 === index ? this.shift() : index === this.size - 1 ? this.pop() : this.splice(index, 1) : this;
        }, List.prototype.insert = function(index, value) {
            return this.splice(index, 0, value);
        }, List.prototype.clear = function() {
            return 0 === this.size ? this : this.__ownerID ? (this.size = this._origin = this._capacity = 0, 
            this._level = SHIFT, this._root = this._tail = null, this.__hash = void 0, this.__altered = !0, 
            this) : emptyList();
        }, List.prototype.push = function() {
            var values = arguments, oldSize = this.size;
            return this.withMutations(function(list) {
                setListBounds(list, 0, oldSize + values.length);
                for (var ii = 0; ii < values.length; ii++) list.set(oldSize + ii, values[ii]);
            });
        }, List.prototype.pop = function() {
            return setListBounds(this, 0, -1);
        }, List.prototype.unshift = function() {
            var values = arguments;
            return this.withMutations(function(list) {
                setListBounds(list, -values.length);
                for (var ii = 0; ii < values.length; ii++) list.set(ii, values[ii]);
            });
        }, List.prototype.shift = function() {
            return setListBounds(this, 1);
        }, // @pragma Composition
        List.prototype.merge = function() {
            return mergeIntoListWith(this, void 0, arguments);
        }, List.prototype.mergeWith = function(merger) {
            return mergeIntoListWith(this, merger, SLICE$0.call(arguments, 1));
        }, List.prototype.mergeDeep = function() {
            return mergeIntoListWith(this, deepMerger, arguments);
        }, List.prototype.mergeDeepWith = function(merger) {
            var iters = SLICE$0.call(arguments, 1);
            return mergeIntoListWith(this, deepMergerWith(merger), iters);
        }, List.prototype.setSize = function(size) {
            return setListBounds(this, 0, size);
        }, // @pragma Iteration
        List.prototype.slice = function(begin, end) {
            var size = this.size;
            return wholeSlice(begin, end, size) ? this : setListBounds(this, resolveBegin(begin, size), resolveEnd(end, size));
        }, List.prototype.__iterator = function(type, reverse) {
            var index = 0, values = iterateList(this, reverse);
            return new Iterator(function() {
                var value = values();
                return value === DONE ? iteratorDone() : iteratorValue(type, index++, value);
            });
        }, List.prototype.__iterate = function(fn, reverse) {
            for (var value, index = 0, values = iterateList(this, reverse); (value = values()) !== DONE && !1 !== fn(value, index++, this); ) ;
            return index;
        }, List.prototype.__ensureOwner = function(ownerID) {
            return ownerID === this.__ownerID ? this : ownerID ? makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash) : (this.__ownerID = ownerID, 
            this);
        }, List.isList = isList;
        var IS_LIST_SENTINEL = "@@__IMMUTABLE_LIST__@@", ListPrototype = List.prototype;
        ListPrototype[IS_LIST_SENTINEL] = !0, ListPrototype.delete = ListPrototype.remove, 
        ListPrototype.setIn = MapPrototype.setIn, ListPrototype.deleteIn = ListPrototype.removeIn = MapPrototype.removeIn, 
        ListPrototype.update = MapPrototype.update, ListPrototype.updateIn = MapPrototype.updateIn, 
        ListPrototype.mergeIn = MapPrototype.mergeIn, ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn, 
        ListPrototype.withMutations = MapPrototype.withMutations, ListPrototype.asMutable = MapPrototype.asMutable, 
        ListPrototype.asImmutable = MapPrototype.asImmutable, ListPrototype.wasAltered = MapPrototype.wasAltered, 
        // TODO: seems like these methods are very similar
        VNode.prototype.removeBefore = function(ownerID, level, index) {
            if (index === level ? 1 << level : 0 === this.array.length) return this;
            var originIndex = index >>> level & MASK;
            if (originIndex >= this.array.length) return new VNode([], ownerID);
            var newChild, removingFirst = 0 === originIndex;
            if (level > 0) {
                var oldChild = this.array[originIndex];
                if ((newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index)) === oldChild && removingFirst) return this;
            }
            if (removingFirst && !newChild) return this;
            var editable = editableVNode(this, ownerID);
            if (!removingFirst) for (var ii = 0; ii < originIndex; ii++) editable.array[ii] = void 0;
            return newChild && (editable.array[originIndex] = newChild), editable;
        }, VNode.prototype.removeAfter = function(ownerID, level, index) {
            if (index === (level ? 1 << level : 0) || 0 === this.array.length) return this;
            var sizeIndex = index - 1 >>> level & MASK;
            if (sizeIndex >= this.array.length) return this;
            var newChild;
            if (level > 0) {
                var oldChild = this.array[sizeIndex];
                if ((newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index)) === oldChild && sizeIndex === this.array.length - 1) return this;
            }
            var editable = editableVNode(this, ownerID);
            return editable.array.splice(sizeIndex + 1), newChild && (editable.array[sizeIndex] = newChild), 
            editable;
        };
        var EMPTY_LIST, DONE = {};
        createClass(OrderedMap, Map), OrderedMap.of = function() {
            return this(arguments);
        }, OrderedMap.prototype.toString = function() {
            return this.__toString("OrderedMap {", "}");
        }, // @pragma Access
        OrderedMap.prototype.get = function(k, notSetValue) {
            var index = this._map.get(k);
            return void 0 !== index ? this._list.get(index)[1] : notSetValue;
        }, // @pragma Modification
        OrderedMap.prototype.clear = function() {
            return 0 === this.size ? this : this.__ownerID ? (this.size = 0, this._map.clear(), 
            this._list.clear(), this) : emptyOrderedMap();
        }, OrderedMap.prototype.set = function(k, v) {
            return updateOrderedMap(this, k, v);
        }, OrderedMap.prototype.remove = function(k) {
            return updateOrderedMap(this, k, NOT_SET);
        }, OrderedMap.prototype.wasAltered = function() {
            return this._map.wasAltered() || this._list.wasAltered();
        }, OrderedMap.prototype.__iterate = function(fn, reverse) {
            var this$0 = this;
            return this._list.__iterate(function(entry) {
                return entry && fn(entry[1], entry[0], this$0);
            }, reverse);
        }, OrderedMap.prototype.__iterator = function(type, reverse) {
            return this._list.fromEntrySeq().__iterator(type, reverse);
        }, OrderedMap.prototype.__ensureOwner = function(ownerID) {
            if (ownerID === this.__ownerID) return this;
            var newMap = this._map.__ensureOwner(ownerID), newList = this._list.__ensureOwner(ownerID);
            return ownerID ? makeOrderedMap(newMap, newList, ownerID, this.__hash) : (this.__ownerID = ownerID, 
            this._map = newMap, this._list = newList, this);
        }, OrderedMap.isOrderedMap = isOrderedMap, OrderedMap.prototype[IS_ORDERED_SENTINEL] = !0, 
        OrderedMap.prototype.delete = OrderedMap.prototype.remove;
        var EMPTY_ORDERED_MAP;
        createClass(ToKeyedSequence, KeyedSeq), ToKeyedSequence.prototype.get = function(key, notSetValue) {
            return this._iter.get(key, notSetValue);
        }, ToKeyedSequence.prototype.has = function(key) {
            return this._iter.has(key);
        }, ToKeyedSequence.prototype.valueSeq = function() {
            return this._iter.valueSeq();
        }, ToKeyedSequence.prototype.reverse = function() {
            var this$0 = this, reversedSequence = reverseFactory(this, !0);
            return this._useKeys || (reversedSequence.valueSeq = function() {
                return this$0._iter.toSeq().reverse();
            }), reversedSequence;
        }, ToKeyedSequence.prototype.map = function(mapper, context) {
            var this$0 = this, mappedSequence = mapFactory(this, mapper, context);
            return this._useKeys || (mappedSequence.valueSeq = function() {
                return this$0._iter.toSeq().map(mapper, context);
            }), mappedSequence;
        }, ToKeyedSequence.prototype.__iterate = function(fn, reverse) {
            var ii, this$0 = this;
            return this._iter.__iterate(this._useKeys ? function(v, k) {
                return fn(v, k, this$0);
            } : (ii = reverse ? resolveSize(this) : 0, function(v) {
                return fn(v, reverse ? --ii : ii++, this$0);
            }), reverse);
        }, ToKeyedSequence.prototype.__iterator = function(type, reverse) {
            if (this._useKeys) return this._iter.__iterator(type, reverse);
            var iterator = this._iter.__iterator(ITERATE_VALUES, reverse), ii = reverse ? resolveSize(this) : 0;
            return new Iterator(function() {
                var step = iterator.next();
                return step.done ? step : iteratorValue(type, reverse ? --ii : ii++, step.value, step);
            });
        }, ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = !0, createClass(ToIndexedSequence, IndexedSeq), 
        ToIndexedSequence.prototype.includes = function(value) {
            return this._iter.includes(value);
        }, ToIndexedSequence.prototype.__iterate = function(fn, reverse) {
            var this$0 = this, iterations = 0;
            return this._iter.__iterate(function(v) {
                return fn(v, iterations++, this$0);
            }, reverse);
        }, ToIndexedSequence.prototype.__iterator = function(type, reverse) {
            var iterator = this._iter.__iterator(ITERATE_VALUES, reverse), iterations = 0;
            return new Iterator(function() {
                var step = iterator.next();
                return step.done ? step : iteratorValue(type, iterations++, step.value, step);
            });
        }, createClass(ToSetSequence, SetSeq), ToSetSequence.prototype.has = function(key) {
            return this._iter.includes(key);
        }, ToSetSequence.prototype.__iterate = function(fn, reverse) {
            var this$0 = this;
            return this._iter.__iterate(function(v) {
                return fn(v, v, this$0);
            }, reverse);
        }, ToSetSequence.prototype.__iterator = function(type, reverse) {
            var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
            return new Iterator(function() {
                var step = iterator.next();
                return step.done ? step : iteratorValue(type, step.value, step.value, step);
            });
        }, createClass(FromEntriesSequence, KeyedSeq), FromEntriesSequence.prototype.entrySeq = function() {
            return this._iter.toSeq();
        }, FromEntriesSequence.prototype.__iterate = function(fn, reverse) {
            var this$0 = this;
            return this._iter.__iterate(function(entry) {
                // Check if entry exists first so array access doesn't throw for holes
                // in the parent iteration.
                if (entry) {
                    validateEntry(entry);
                    var indexedIterable = isIterable(entry);
                    return fn(indexedIterable ? entry.get(1) : entry[1], indexedIterable ? entry.get(0) : entry[0], this$0);
                }
            }, reverse);
        }, FromEntriesSequence.prototype.__iterator = function(type, reverse) {
            var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
            return new Iterator(function() {
                for (;;) {
                    var step = iterator.next();
                    if (step.done) return step;
                    var entry = step.value;
                    // Check if entry exists first so array access doesn't throw for holes
                    // in the parent iteration.
                    if (entry) {
                        validateEntry(entry);
                        var indexedIterable = isIterable(entry);
                        return iteratorValue(type, indexedIterable ? entry.get(0) : entry[0], indexedIterable ? entry.get(1) : entry[1], step);
                    }
                }
            });
        }, ToIndexedSequence.prototype.cacheResult = ToKeyedSequence.prototype.cacheResult = ToSetSequence.prototype.cacheResult = FromEntriesSequence.prototype.cacheResult = cacheResultThrough, 
        createClass(Record, KeyedCollection), Record.prototype.toString = function() {
            return this.__toString(recordName(this) + " {", "}");
        }, // @pragma Access
        Record.prototype.has = function(k) {
            return this._defaultValues.hasOwnProperty(k);
        }, Record.prototype.get = function(k, notSetValue) {
            if (!this.has(k)) return notSetValue;
            var defaultVal = this._defaultValues[k];
            return this._map ? this._map.get(k, defaultVal) : defaultVal;
        }, // @pragma Modification
        Record.prototype.clear = function() {
            if (this.__ownerID) return this._map && this._map.clear(), this;
            var RecordType = this.constructor;
            return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
        }, Record.prototype.set = function(k, v) {
            if (!this.has(k)) throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
            if (this._map && !this._map.has(k)) {
                if (v === this._defaultValues[k]) return this;
            }
            var newMap = this._map && this._map.set(k, v);
            return this.__ownerID || newMap === this._map ? this : makeRecord(this, newMap);
        }, Record.prototype.remove = function(k) {
            if (!this.has(k)) return this;
            var newMap = this._map && this._map.remove(k);
            return this.__ownerID || newMap === this._map ? this : makeRecord(this, newMap);
        }, Record.prototype.wasAltered = function() {
            return this._map.wasAltered();
        }, Record.prototype.__iterator = function(type, reverse) {
            var this$0 = this;
            return KeyedIterable(this._defaultValues).map(function(_, k) {
                return this$0.get(k);
            }).__iterator(type, reverse);
        }, Record.prototype.__iterate = function(fn, reverse) {
            var this$0 = this;
            return KeyedIterable(this._defaultValues).map(function(_, k) {
                return this$0.get(k);
            }).__iterate(fn, reverse);
        }, Record.prototype.__ensureOwner = function(ownerID) {
            if (ownerID === this.__ownerID) return this;
            var newMap = this._map && this._map.__ensureOwner(ownerID);
            return ownerID ? makeRecord(this, newMap, ownerID) : (this.__ownerID = ownerID, 
            this._map = newMap, this);
        };
        var RecordPrototype = Record.prototype;
        RecordPrototype.delete = RecordPrototype.remove, RecordPrototype.deleteIn = RecordPrototype.removeIn = MapPrototype.removeIn, 
        RecordPrototype.merge = MapPrototype.merge, RecordPrototype.mergeWith = MapPrototype.mergeWith, 
        RecordPrototype.mergeIn = MapPrototype.mergeIn, RecordPrototype.mergeDeep = MapPrototype.mergeDeep, 
        RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith, RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn, 
        RecordPrototype.setIn = MapPrototype.setIn, RecordPrototype.update = MapPrototype.update, 
        RecordPrototype.updateIn = MapPrototype.updateIn, RecordPrototype.withMutations = MapPrototype.withMutations, 
        RecordPrototype.asMutable = MapPrototype.asMutable, RecordPrototype.asImmutable = MapPrototype.asImmutable, 
        createClass(Set, SetCollection), Set.of = function() {
            return this(arguments);
        }, Set.fromKeys = function(value) {
            return this(KeyedIterable(value).keySeq());
        }, Set.prototype.toString = function() {
            return this.__toString("Set {", "}");
        }, // @pragma Access
        Set.prototype.has = function(value) {
            return this._map.has(value);
        }, // @pragma Modification
        Set.prototype.add = function(value) {
            return updateSet(this, this._map.set(value, !0));
        }, Set.prototype.remove = function(value) {
            return updateSet(this, this._map.remove(value));
        }, Set.prototype.clear = function() {
            return updateSet(this, this._map.clear());
        }, // @pragma Composition
        Set.prototype.union = function() {
            var iters = SLICE$0.call(arguments, 0);
            return iters = iters.filter(function(x) {
                return 0 !== x.size;
            }), 0 === iters.length ? this : 0 !== this.size || this.__ownerID || 1 !== iters.length ? this.withMutations(function(set) {
                for (var ii = 0; ii < iters.length; ii++) SetIterable(iters[ii]).forEach(function(value) {
                    return set.add(value);
                });
            }) : this.constructor(iters[0]);
        }, Set.prototype.intersect = function() {
            var iters = SLICE$0.call(arguments, 0);
            if (0 === iters.length) return this;
            iters = iters.map(function(iter) {
                return SetIterable(iter);
            });
            var originalSet = this;
            return this.withMutations(function(set) {
                originalSet.forEach(function(value) {
                    iters.every(function(iter) {
                        return iter.includes(value);
                    }) || set.remove(value);
                });
            });
        }, Set.prototype.subtract = function() {
            var iters = SLICE$0.call(arguments, 0);
            if (0 === iters.length) return this;
            iters = iters.map(function(iter) {
                return SetIterable(iter);
            });
            var originalSet = this;
            return this.withMutations(function(set) {
                originalSet.forEach(function(value) {
                    iters.some(function(iter) {
                        return iter.includes(value);
                    }) && set.remove(value);
                });
            });
        }, Set.prototype.merge = function() {
            return this.union.apply(this, arguments);
        }, Set.prototype.mergeWith = function(merger) {
            var iters = SLICE$0.call(arguments, 1);
            return this.union.apply(this, iters);
        }, Set.prototype.sort = function(comparator) {
            // Late binding
            return OrderedSet(sortFactory(this, comparator));
        }, Set.prototype.sortBy = function(mapper, comparator) {
            // Late binding
            return OrderedSet(sortFactory(this, comparator, mapper));
        }, Set.prototype.wasAltered = function() {
            return this._map.wasAltered();
        }, Set.prototype.__iterate = function(fn, reverse) {
            var this$0 = this;
            return this._map.__iterate(function(_, k) {
                return fn(k, k, this$0);
            }, reverse);
        }, Set.prototype.__iterator = function(type, reverse) {
            return this._map.map(function(_, k) {
                return k;
            }).__iterator(type, reverse);
        }, Set.prototype.__ensureOwner = function(ownerID) {
            if (ownerID === this.__ownerID) return this;
            var newMap = this._map.__ensureOwner(ownerID);
            return ownerID ? this.__make(newMap, ownerID) : (this.__ownerID = ownerID, this._map = newMap, 
            this);
        }, Set.isSet = isSet;
        var IS_SET_SENTINEL = "@@__IMMUTABLE_SET__@@", SetPrototype = Set.prototype;
        SetPrototype[IS_SET_SENTINEL] = !0, SetPrototype.delete = SetPrototype.remove, SetPrototype.mergeDeep = SetPrototype.merge, 
        SetPrototype.mergeDeepWith = SetPrototype.mergeWith, SetPrototype.withMutations = MapPrototype.withMutations, 
        SetPrototype.asMutable = MapPrototype.asMutable, SetPrototype.asImmutable = MapPrototype.asImmutable, 
        SetPrototype.__empty = emptySet, SetPrototype.__make = makeSet;
        var EMPTY_SET;
        createClass(OrderedSet, Set), OrderedSet.of = function() {
            return this(arguments);
        }, OrderedSet.fromKeys = function(value) {
            return this(KeyedIterable(value).keySeq());
        }, OrderedSet.prototype.toString = function() {
            return this.__toString("OrderedSet {", "}");
        }, OrderedSet.isOrderedSet = isOrderedSet;
        var OrderedSetPrototype = OrderedSet.prototype;
        OrderedSetPrototype[IS_ORDERED_SENTINEL] = !0, OrderedSetPrototype.__empty = emptyOrderedSet, 
        OrderedSetPrototype.__make = makeOrderedSet;
        var EMPTY_ORDERED_SET;
        createClass(Stack, IndexedCollection), Stack.of = function() {
            return this(arguments);
        }, Stack.prototype.toString = function() {
            return this.__toString("Stack [", "]");
        }, // @pragma Access
        Stack.prototype.get = function(index, notSetValue) {
            var head = this._head;
            for (index = wrapIndex(this, index); head && index--; ) head = head.next;
            return head ? head.value : notSetValue;
        }, Stack.prototype.peek = function() {
            return this._head && this._head.value;
        }, // @pragma Modification
        Stack.prototype.push = function() {
            if (0 === arguments.length) return this;
            for (var newSize = this.size + arguments.length, head = this._head, ii = arguments.length - 1; ii >= 0; ii--) head = {
                value: arguments[ii],
                next: head
            };
            return this.__ownerID ? (this.size = newSize, this._head = head, this.__hash = void 0, 
            this.__altered = !0, this) : makeStack(newSize, head);
        }, Stack.prototype.pushAll = function(iter) {
            if (iter = IndexedIterable(iter), 0 === iter.size) return this;
            assertNotInfinite(iter.size);
            var newSize = this.size, head = this._head;
            return iter.reverse().forEach(function(value) {
                newSize++, head = {
                    value: value,
                    next: head
                };
            }), this.__ownerID ? (this.size = newSize, this._head = head, this.__hash = void 0, 
            this.__altered = !0, this) : makeStack(newSize, head);
        }, Stack.prototype.pop = function() {
            return this.slice(1);
        }, Stack.prototype.unshift = function() {
            return this.push.apply(this, arguments);
        }, Stack.prototype.unshiftAll = function(iter) {
            return this.pushAll(iter);
        }, Stack.prototype.shift = function() {
            return this.pop.apply(this, arguments);
        }, Stack.prototype.clear = function() {
            return 0 === this.size ? this : this.__ownerID ? (this.size = 0, this._head = void 0, 
            this.__hash = void 0, this.__altered = !0, this) : emptyStack();
        }, Stack.prototype.slice = function(begin, end) {
            if (wholeSlice(begin, end, this.size)) return this;
            var resolvedBegin = resolveBegin(begin, this.size);
            if (resolveEnd(end, this.size) !== this.size) // super.slice(begin, end);
            return IndexedCollection.prototype.slice.call(this, begin, end);
            for (var newSize = this.size - resolvedBegin, head = this._head; resolvedBegin--; ) head = head.next;
            return this.__ownerID ? (this.size = newSize, this._head = head, this.__hash = void 0, 
            this.__altered = !0, this) : makeStack(newSize, head);
        }, // @pragma Mutability
        Stack.prototype.__ensureOwner = function(ownerID) {
            return ownerID === this.__ownerID ? this : ownerID ? makeStack(this.size, this._head, ownerID, this.__hash) : (this.__ownerID = ownerID, 
            this.__altered = !1, this);
        }, // @pragma Iteration
        Stack.prototype.__iterate = function(fn, reverse) {
            if (reverse) return this.reverse().__iterate(fn);
            for (var iterations = 0, node = this._head; node && !1 !== fn(node.value, iterations++, this); ) node = node.next;
            return iterations;
        }, Stack.prototype.__iterator = function(type, reverse) {
            if (reverse) return this.reverse().__iterator(type);
            var iterations = 0, node = this._head;
            return new Iterator(function() {
                if (node) {
                    var value = node.value;
                    return node = node.next, iteratorValue(type, iterations++, value);
                }
                return iteratorDone();
            });
        }, Stack.isStack = isStack;
        var IS_STACK_SENTINEL = "@@__IMMUTABLE_STACK__@@", StackPrototype = Stack.prototype;
        StackPrototype[IS_STACK_SENTINEL] = !0, StackPrototype.withMutations = MapPrototype.withMutations, 
        StackPrototype.asMutable = MapPrototype.asMutable, StackPrototype.asImmutable = MapPrototype.asImmutable, 
        StackPrototype.wasAltered = MapPrototype.wasAltered;
        var EMPTY_STACK;
        Iterable.Iterator = Iterator, mixin(Iterable, {
            // ### Conversion to other types
            toArray: function() {
                assertNotInfinite(this.size);
                var array = new Array(this.size || 0);
                return this.valueSeq().__iterate(function(v, i) {
                    array[i] = v;
                }), array;
            },
            toIndexedSeq: function() {
                return new ToIndexedSequence(this);
            },
            toJS: function() {
                return this.toSeq().map(function(value) {
                    return value && "function" == typeof value.toJS ? value.toJS() : value;
                }).__toJS();
            },
            toJSON: function() {
                return this.toSeq().map(function(value) {
                    return value && "function" == typeof value.toJSON ? value.toJSON() : value;
                }).__toJS();
            },
            toKeyedSeq: function() {
                return new ToKeyedSequence(this, !0);
            },
            toMap: function() {
                // Use Late Binding here to solve the circular dependency.
                return Map(this.toKeyedSeq());
            },
            toObject: function() {
                assertNotInfinite(this.size);
                var object = {};
                return this.__iterate(function(v, k) {
                    object[k] = v;
                }), object;
            },
            toOrderedMap: function() {
                // Use Late Binding here to solve the circular dependency.
                return OrderedMap(this.toKeyedSeq());
            },
            toOrderedSet: function() {
                // Use Late Binding here to solve the circular dependency.
                return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
            },
            toSet: function() {
                // Use Late Binding here to solve the circular dependency.
                return Set(isKeyed(this) ? this.valueSeq() : this);
            },
            toSetSeq: function() {
                return new ToSetSequence(this);
            },
            toSeq: function() {
                return isIndexed(this) ? this.toIndexedSeq() : isKeyed(this) ? this.toKeyedSeq() : this.toSetSeq();
            },
            toStack: function() {
                // Use Late Binding here to solve the circular dependency.
                return Stack(isKeyed(this) ? this.valueSeq() : this);
            },
            toList: function() {
                // Use Late Binding here to solve the circular dependency.
                return List(isKeyed(this) ? this.valueSeq() : this);
            },
            // ### Common JavaScript methods and properties
            toString: function() {
                return "[Iterable]";
            },
            __toString: function(head, tail) {
                return 0 === this.size ? head + tail : head + " " + this.toSeq().map(this.__toStringMapper).join(", ") + " " + tail;
            },
            // ### ES6 Collection methods (ES6 Array and Map)
            concat: function() {
                return reify(this, concatFactory(this, SLICE$0.call(arguments, 0)));
            },
            includes: function(searchValue) {
                return this.some(function(value) {
                    return is(value, searchValue);
                });
            },
            entries: function() {
                return this.__iterator(ITERATE_ENTRIES);
            },
            every: function(predicate, context) {
                assertNotInfinite(this.size);
                var returnValue = !0;
                return this.__iterate(function(v, k, c) {
                    if (!predicate.call(context, v, k, c)) return returnValue = !1, !1;
                }), returnValue;
            },
            filter: function(predicate, context) {
                return reify(this, filterFactory(this, predicate, context, !0));
            },
            find: function(predicate, context, notSetValue) {
                var entry = this.findEntry(predicate, context);
                return entry ? entry[1] : notSetValue;
            },
            forEach: function(sideEffect, context) {
                return assertNotInfinite(this.size), this.__iterate(context ? sideEffect.bind(context) : sideEffect);
            },
            join: function(separator) {
                assertNotInfinite(this.size), separator = void 0 !== separator ? "" + separator : ",";
                var joined = "", isFirst = !0;
                return this.__iterate(function(v) {
                    isFirst ? isFirst = !1 : joined += separator, joined += null !== v && void 0 !== v ? v.toString() : "";
                }), joined;
            },
            keys: function() {
                return this.__iterator(ITERATE_KEYS);
            },
            map: function(mapper, context) {
                return reify(this, mapFactory(this, mapper, context));
            },
            reduce: function(reducer, initialReduction, context) {
                assertNotInfinite(this.size);
                var reduction, useFirst;
                return arguments.length < 2 ? useFirst = !0 : reduction = initialReduction, this.__iterate(function(v, k, c) {
                    useFirst ? (useFirst = !1, reduction = v) : reduction = reducer.call(context, reduction, v, k, c);
                }), reduction;
            },
            reduceRight: function(reducer, initialReduction, context) {
                var reversed = this.toKeyedSeq().reverse();
                return reversed.reduce.apply(reversed, arguments);
            },
            reverse: function() {
                return reify(this, reverseFactory(this, !0));
            },
            slice: function(begin, end) {
                return reify(this, sliceFactory(this, begin, end, !0));
            },
            some: function(predicate, context) {
                return !this.every(not(predicate), context);
            },
            sort: function(comparator) {
                return reify(this, sortFactory(this, comparator));
            },
            values: function() {
                return this.__iterator(ITERATE_VALUES);
            },
            // ### More sequential methods
            butLast: function() {
                return this.slice(0, -1);
            },
            isEmpty: function() {
                return void 0 !== this.size ? 0 === this.size : !this.some(function() {
                    return !0;
                });
            },
            count: function(predicate, context) {
                return ensureSize(predicate ? this.toSeq().filter(predicate, context) : this);
            },
            countBy: function(grouper, context) {
                return countByFactory(this, grouper, context);
            },
            equals: function(other) {
                return deepEqual(this, other);
            },
            entrySeq: function() {
                var iterable = this;
                if (iterable._cache) // We cache as an entries array, so we can just return the cache!
                return new ArraySeq(iterable._cache);
                var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
                return entriesSequence.fromEntrySeq = function() {
                    return iterable.toSeq();
                }, entriesSequence;
            },
            filterNot: function(predicate, context) {
                return this.filter(not(predicate), context);
            },
            findEntry: function(predicate, context, notSetValue) {
                var found = notSetValue;
                return this.__iterate(function(v, k, c) {
                    if (predicate.call(context, v, k, c)) return found = [ k, v ], !1;
                }), found;
            },
            findKey: function(predicate, context) {
                var entry = this.findEntry(predicate, context);
                return entry && entry[0];
            },
            findLast: function(predicate, context, notSetValue) {
                return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
            },
            findLastEntry: function(predicate, context, notSetValue) {
                return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
            },
            findLastKey: function(predicate, context) {
                return this.toKeyedSeq().reverse().findKey(predicate, context);
            },
            first: function() {
                return this.find(returnTrue);
            },
            flatMap: function(mapper, context) {
                return reify(this, flatMapFactory(this, mapper, context));
            },
            flatten: function(depth) {
                return reify(this, flattenFactory(this, depth, !0));
            },
            fromEntrySeq: function() {
                return new FromEntriesSequence(this);
            },
            get: function(searchKey, notSetValue) {
                return this.find(function(_, key) {
                    return is(key, searchKey);
                }, void 0, notSetValue);
            },
            getIn: function(searchKeyPath, notSetValue) {
                for (var step, nested = this, iter = forceIterator(searchKeyPath); !(step = iter.next()).done; ) {
                    var key = step.value;
                    if ((nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET) === NOT_SET) return notSetValue;
                }
                return nested;
            },
            groupBy: function(grouper, context) {
                return groupByFactory(this, grouper, context);
            },
            has: function(searchKey) {
                return this.get(searchKey, NOT_SET) !== NOT_SET;
            },
            hasIn: function(searchKeyPath) {
                return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
            },
            isSubset: function(iter) {
                return iter = "function" == typeof iter.includes ? iter : Iterable(iter), this.every(function(value) {
                    return iter.includes(value);
                });
            },
            isSuperset: function(iter) {
                return iter = "function" == typeof iter.isSubset ? iter : Iterable(iter), iter.isSubset(this);
            },
            keyOf: function(searchValue) {
                return this.findKey(function(value) {
                    return is(value, searchValue);
                });
            },
            keySeq: function() {
                return this.toSeq().map(keyMapper).toIndexedSeq();
            },
            last: function() {
                return this.toSeq().reverse().first();
            },
            lastKeyOf: function(searchValue) {
                return this.toKeyedSeq().reverse().keyOf(searchValue);
            },
            max: function(comparator) {
                return maxFactory(this, comparator);
            },
            maxBy: function(mapper, comparator) {
                return maxFactory(this, comparator, mapper);
            },
            min: function(comparator) {
                return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
            },
            minBy: function(mapper, comparator) {
                return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
            },
            rest: function() {
                return this.slice(1);
            },
            skip: function(amount) {
                return this.slice(Math.max(0, amount));
            },
            skipLast: function(amount) {
                return reify(this, this.toSeq().reverse().skip(amount).reverse());
            },
            skipWhile: function(predicate, context) {
                return reify(this, skipWhileFactory(this, predicate, context, !0));
            },
            skipUntil: function(predicate, context) {
                return this.skipWhile(not(predicate), context);
            },
            sortBy: function(mapper, comparator) {
                return reify(this, sortFactory(this, comparator, mapper));
            },
            take: function(amount) {
                return this.slice(0, Math.max(0, amount));
            },
            takeLast: function(amount) {
                return reify(this, this.toSeq().reverse().take(amount).reverse());
            },
            takeWhile: function(predicate, context) {
                return reify(this, takeWhileFactory(this, predicate, context));
            },
            takeUntil: function(predicate, context) {
                return this.takeWhile(not(predicate), context);
            },
            valueSeq: function() {
                return this.toIndexedSeq();
            },
            // ### Hashable Object
            hashCode: function() {
                return this.__hash || (this.__hash = hashIterable(this));
            }
        });
        // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
        // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
        // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
        // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
        var IterablePrototype = Iterable.prototype;
        IterablePrototype[IS_ITERABLE_SENTINEL] = !0, IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values, 
        IterablePrototype.__toJS = IterablePrototype.toArray, IterablePrototype.__toStringMapper = quoteString, 
        IterablePrototype.inspect = IterablePrototype.toSource = function() {
            return this.toString();
        }, IterablePrototype.chain = IterablePrototype.flatMap, IterablePrototype.contains = IterablePrototype.includes, 
        mixin(KeyedIterable, {
            // ### More sequential methods
            flip: function() {
                return reify(this, flipFactory(this));
            },
            mapEntries: function(mapper, context) {
                var this$0 = this, iterations = 0;
                return reify(this, this.toSeq().map(function(v, k) {
                    return mapper.call(context, [ k, v ], iterations++, this$0);
                }).fromEntrySeq());
            },
            mapKeys: function(mapper, context) {
                var this$0 = this;
                return reify(this, this.toSeq().flip().map(function(k, v) {
                    return mapper.call(context, k, v, this$0);
                }).flip());
            }
        });
        var KeyedIterablePrototype = KeyedIterable.prototype;
        // Mixin subclasses
        return KeyedIterablePrototype[IS_KEYED_SENTINEL] = !0, KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries, 
        KeyedIterablePrototype.__toJS = IterablePrototype.toObject, KeyedIterablePrototype.__toStringMapper = function(v, k) {
            return JSON.stringify(k) + ": " + quoteString(v);
        }, mixin(IndexedIterable, {
            // ### Conversion to other types
            toKeyedSeq: function() {
                return new ToKeyedSequence(this, !1);
            },
            // ### ES6 Collection methods (ES6 Array and Map)
            filter: function(predicate, context) {
                return reify(this, filterFactory(this, predicate, context, !1));
            },
            findIndex: function(predicate, context) {
                var entry = this.findEntry(predicate, context);
                return entry ? entry[0] : -1;
            },
            indexOf: function(searchValue) {
                var key = this.keyOf(searchValue);
                return void 0 === key ? -1 : key;
            },
            lastIndexOf: function(searchValue) {
                var key = this.lastKeyOf(searchValue);
                return void 0 === key ? -1 : key;
            },
            reverse: function() {
                return reify(this, reverseFactory(this, !1));
            },
            slice: function(begin, end) {
                return reify(this, sliceFactory(this, begin, end, !1));
            },
            splice: function(index, removeNum) {
                var numArgs = arguments.length;
                if (removeNum = Math.max(0 | removeNum, 0), 0 === numArgs || 2 === numArgs && !removeNum) return this;
                // If index is negative, it should resolve relative to the size of the
                // collection. However size may be expensive to compute if not cached, so
                // only call count() if the number is in fact negative.
                index = resolveBegin(index, index < 0 ? this.count() : this.size);
                var spliced = this.slice(0, index);
                return reify(this, 1 === numArgs ? spliced : spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum)));
            },
            // ### More collection methods
            findLastIndex: function(predicate, context) {
                var entry = this.findLastEntry(predicate, context);
                return entry ? entry[0] : -1;
            },
            first: function() {
                return this.get(0);
            },
            flatten: function(depth) {
                return reify(this, flattenFactory(this, depth, !1));
            },
            get: function(index, notSetValue) {
                return index = wrapIndex(this, index), index < 0 || this.size === 1 / 0 || void 0 !== this.size && index > this.size ? notSetValue : this.find(function(_, key) {
                    return key === index;
                }, void 0, notSetValue);
            },
            has: function(index) {
                return (index = wrapIndex(this, index)) >= 0 && (void 0 !== this.size ? this.size === 1 / 0 || index < this.size : -1 !== this.indexOf(index));
            },
            interpose: function(separator) {
                return reify(this, interposeFactory(this, separator));
            },
            interleave: function() {
                var iterables = [ this ].concat(arrCopy(arguments)), zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables), interleaved = zipped.flatten(!0);
                return zipped.size && (interleaved.size = zipped.size * iterables.length), reify(this, interleaved);
            },
            keySeq: function() {
                return Range(0, this.size);
            },
            last: function() {
                return this.get(-1);
            },
            skipWhile: function(predicate, context) {
                return reify(this, skipWhileFactory(this, predicate, context, !1));
            },
            zip: function() {
                return reify(this, zipWithFactory(this, defaultZipper, [ this ].concat(arrCopy(arguments))));
            },
            zipWith: function(zipper) {
                var iterables = arrCopy(arguments);
                return iterables[0] = this, reify(this, zipWithFactory(this, zipper, iterables));
            }
        }), IndexedIterable.prototype[IS_INDEXED_SENTINEL] = !0, IndexedIterable.prototype[IS_ORDERED_SENTINEL] = !0, 
        mixin(SetIterable, {
            // ### ES6 Collection methods (ES6 Array and Map)
            get: function(value, notSetValue) {
                return this.has(value) ? value : notSetValue;
            },
            includes: function(value) {
                return this.has(value);
            },
            // ### More sequential methods
            keySeq: function() {
                return this.valueSeq();
            }
        }), SetIterable.prototype.has = IterablePrototype.includes, SetIterable.prototype.contains = SetIterable.prototype.includes, 
        mixin(KeyedSeq, KeyedIterable.prototype), mixin(IndexedSeq, IndexedIterable.prototype), 
        mixin(SetSeq, SetIterable.prototype), mixin(KeyedCollection, KeyedIterable.prototype), 
        mixin(IndexedCollection, IndexedIterable.prototype), mixin(SetCollection, SetIterable.prototype), 
        {
            Iterable: Iterable,
            Seq: Seq,
            Collection: Collection,
            Map: Map,
            OrderedMap: OrderedMap,
            List: List,
            Stack: Stack,
            Set: Set,
            OrderedSet: OrderedSet,
            Record: Record,
            Range: Range,
            Repeat: Repeat,
            is: is,
            fromJS: fromJS
        };
    });
}, /* 92 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), /**
 * Returns an array of all `ContentBlock` instances within two block keys
 *
 * @param  {object} contentState A draft.js `ContentState` instance
 * @param  {string} anchorKey    The block key to start searching from
 * @param  {string} focusKey     The block key until which to search
 *
 * @return {array} An array containing the found content blocks
 */
    exports.default = function(contentState, anchorKey, focusKey) {
        var isSameBlock = anchorKey === focusKey, startingBlock = contentState.getBlockForKey(anchorKey);
        if (!startingBlock) return [];
        var selectedBlocks = [ startingBlock ];
        if (!isSameBlock) for (var blockKey = anchorKey; blockKey !== focusKey; ) {
            var nextBlock = contentState.getBlockAfter(blockKey);
            if (!nextBlock) {
                selectedBlocks = [];
                break;
            }
            selectedBlocks.push(nextBlock), blockKey = nextBlock.getKey();
        }
        return selectedBlocks;
    };
}, /* 93 */
/***/
function(module, exports, __webpack_require__) {
    var classof = __webpack_require__(94), ITERATOR = __webpack_require__(6)("iterator"), Iterators = __webpack_require__(40);
    module.exports = __webpack_require__(4).getIteratorMethod = function(it) {
        if (void 0 != it) return it[ITERATOR] || it["@@iterator"] || Iterators[classof(it)];
    };
}, /* 94 */
/***/
function(module, exports, __webpack_require__) {
    // getting tag from 19.1.3.6 Object.prototype.toString()
    var cof = __webpack_require__(67), TAG = __webpack_require__(6)("toStringTag"), ARG = "Arguments" == cof(function() {
        return arguments;
    }()), tryGet = function(it, key) {
        try {
            return it[key];
        } catch (e) {}
    };
    module.exports = function(it) {
        var O, T, B;
        return void 0 === it ? "Undefined" : null === it ? "Null" : "string" == typeof (T = tryGet(O = Object(it), TAG)) ? T : ARG ? cof(O) : "Object" == (B = cof(O)) && "function" == typeof O.callee ? "Arguments" : B;
    };
}, /* 95 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function ButtonGroup(props) {
        var className = (0, _classnames2.default)(props.className, _ButtonGroup2.default.root);
        return _react2.default.createElement("div", (0, _extends3.default)({}, props, {
            className: className
        }));
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2);
    exports.default = ButtonGroup;
    var _react = __webpack_require__(3), _react2 = _interopRequireDefault(_react), _classnames = __webpack_require__(23), _classnames2 = _interopRequireDefault(_classnames), _ButtonGroup = __webpack_require__(308), _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
}, /* 96 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = {
        default: __webpack_require__(145),
        __esModule: !0
    };
}, /* 97 */
/***/
function(module, exports) {
    module.exports = function(it) {
        if ("function" != typeof it) throw TypeError(it + " is not a function!");
        return it;
    };
}, /* 98 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = !__webpack_require__(13) && !__webpack_require__(32)(function() {
        return 7 != Object.defineProperty(__webpack_require__(99)("div"), "a", {
            get: function() {
                return 7;
            }
        }).a;
    });
}, /* 99 */
/***/
function(module, exports, __webpack_require__) {
    var isObject = __webpack_require__(27), document = __webpack_require__(12).document, is = isObject(document) && isObject(document.createElement);
    module.exports = function(it) {
        return is ? document.createElement(it) : {};
    };
}, /* 100 */
/***/
function(module, exports, __webpack_require__) {
    var has = __webpack_require__(33), toIObject = __webpack_require__(38), arrayIndexOf = __webpack_require__(148)(!1), IE_PROTO = __webpack_require__(70)("IE_PROTO");
    module.exports = function(object, names) {
        var key, O = toIObject(object), i = 0, result = [];
        for (key in O) key != IE_PROTO && has(O, key) && result.push(key);
        // Don't enum bug & hidden keys
        for (;names.length > i; ) has(O, key = names[i++]) && (~arrayIndexOf(result, key) || result.push(key));
        return result;
    };
}, /* 101 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = {
        default: __webpack_require__(150),
        __esModule: !0
    };
}, /* 102 */
/***/
function(module, exports, __webpack_require__) {
    // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
    var has = __webpack_require__(33), toObject = __webpack_require__(42), IE_PROTO = __webpack_require__(70)("IE_PROTO"), ObjectProto = Object.prototype;
    module.exports = Object.getPrototypeOf || function(O) {
        return O = toObject(O), has(O, IE_PROTO) ? O[IE_PROTO] : "function" == typeof O.constructor && O instanceof O.constructor ? O.constructor.prototype : O instanceof Object ? ObjectProto : null;
    };
}, /* 103 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = __webpack_require__(25);
}, /* 104 */
/***/
function(module, exports) {
    module.exports = function(done, value) {
        return {
            value: value,
            done: !!done
        };
    };
}, /* 105 */
/***/
function(module, exports, __webpack_require__) {
    // 7.2.2 IsArray(argument)
    var cof = __webpack_require__(67);
    module.exports = Array.isArray || function(arg) {
        return "Array" == cof(arg);
    };
}, /* 106 */
/***/
function(module, exports, __webpack_require__) {
    // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
    var $keys = __webpack_require__(100), hiddenKeys = __webpack_require__(72).concat("length", "prototype");
    exports.f = Object.getOwnPropertyNames || function(O) {
        return $keys(O, hiddenKeys);
    };
}, /* 107 */
/***/
function(module, exports, __webpack_require__) {
    var pIE = __webpack_require__(51), createDesc = __webpack_require__(41), toIObject = __webpack_require__(38), toPrimitive = __webpack_require__(65), has = __webpack_require__(33), IE8_DOM_DEFINE = __webpack_require__(98), gOPD = Object.getOwnPropertyDescriptor;
    exports.f = __webpack_require__(13) ? gOPD : function(O, P) {
        if (O = toIObject(O), P = toPrimitive(P, !0), IE8_DOM_DEFINE) try {
            return gOPD(O, P);
        } catch (e) {}
        if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
    };
}, /* 108 */
/***/
function(module, exports) {}, /* 109 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftFeatureFlags
 * 
 */
    var DraftFeatureFlags = {
        draft_killswitch_allow_nontextnodes: !1,
        draft_segmented_entities_behavior: !1
    };
    module.exports = DraftFeatureFlags;
}, /* 110 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function removeEntitiesAtEdges(contentState, selectionState) {
        var blockMap = contentState.getBlockMap(), entityMap = contentState.getEntityMap(), updatedBlocks = {}, startKey = selectionState.getStartKey(), startOffset = selectionState.getStartOffset(), startBlock = blockMap.get(startKey), updatedStart = removeForBlock(entityMap, startBlock, startOffset);
        updatedStart !== startBlock && (updatedBlocks[startKey] = updatedStart);
        var endKey = selectionState.getEndKey(), endOffset = selectionState.getEndOffset(), endBlock = blockMap.get(endKey);
        startKey === endKey && (endBlock = updatedStart);
        var updatedEnd = removeForBlock(entityMap, endBlock, endOffset);
        return updatedEnd !== endBlock && (updatedBlocks[endKey] = updatedEnd), Object.keys(updatedBlocks).length ? contentState.merge({
            blockMap: blockMap.merge(updatedBlocks),
            selectionAfter: selectionState
        }) : contentState.set("selectionAfter", selectionState);
    }
    function getRemovalRange(characters, key, offset) {
        var removalRange;
        return findRangesImmutable(characters, function(a, b) {
            return a.getEntity() === b.getEntity();
        }, function(element) {
            return element.getEntity() === key;
        }, function(start, end) {
            start <= offset && end >= offset && (removalRange = {
                start: start,
                end: end
            });
        }), "object" != typeof removalRange && invariant(!1), removalRange;
    }
    function removeForBlock(entityMap, block, offset) {
        var chars = block.getCharacterList(), charBefore = offset > 0 ? chars.get(offset - 1) : void 0, charAfter = offset < chars.count() ? chars.get(offset) : void 0, entityBeforeCursor = charBefore ? charBefore.getEntity() : void 0, entityAfterCursor = charAfter ? charAfter.getEntity() : void 0;
        if (entityAfterCursor && entityAfterCursor === entityBeforeCursor) {
            if ("MUTABLE" !== entityMap.__get(entityAfterCursor).getMutability()) {
                for (var current, _getRemovalRange = getRemovalRange(chars, entityAfterCursor, offset), start = _getRemovalRange.start, end = _getRemovalRange.end; start < end; ) current = chars.get(start), 
                chars = chars.set(start, CharacterMetadata.applyEntity(current, null)), start++;
                return block.set("characterList", chars);
            }
        }
        return block;
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule removeEntitiesAtEdges
 * 
 */
    var CharacterMetadata = __webpack_require__(11), findRangesImmutable = __webpack_require__(56), invariant = __webpack_require__(2);
    module.exports = removeEntitiesAtEdges;
}, /* 111 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule insertIntoList
 * 
 */
    /**
 * Maintain persistence for target list when appending and prepending.
 */
    function insertIntoList(targetList, toInsert, offset) {
        if (offset === targetList.count()) toInsert.forEach(function(c) {
            targetList = targetList.push(c);
        }); else if (0 === offset) toInsert.reverse().forEach(function(c) {
            targetList = targetList.unshift(c);
        }); else {
            var head = targetList.slice(0, offset), tail = targetList.slice(offset);
            targetList = head.concat(toInsert, tail).toList();
        }
        return targetList;
    }
    module.exports = insertIntoList;
}, /* 112 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Generate LeafRange records for a given character list.
 */
    function generateLeaves(characters, offset) {
        var leaves = [], inlineStyles = characters.map(function(c) {
            return c.getStyle();
        }).toList();
        return findRangesImmutable(inlineStyles, areEqual, returnTrue, function(start, end) {
            leaves.push(new LeafRange({
                start: start + offset,
                end: end + offset
            }));
        }), List(leaves);
    }
    function areEqual(a, b) {
        return a === b;
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule BlockTree
 * 
 */
    var Immutable = __webpack_require__(1), emptyFunction = __webpack_require__(80), findRangesImmutable = __webpack_require__(56), List = Immutable.List, Repeat = Immutable.Repeat, Record = Immutable.Record, returnTrue = emptyFunction.thatReturnsTrue, defaultLeafRange = {
        start: null,
        end: null
    }, LeafRange = Record(defaultLeafRange), defaultDecoratorRange = {
        start: null,
        end: null,
        decoratorKey: null,
        leaves: null
    }, DecoratorRange = Record(defaultDecoratorRange), BlockTree = {
        /**
   * Generate a block tree for a given ContentBlock/decorator pair.
   */
        generate: function(contentState, block, decorator) {
            var textLength = block.getLength();
            if (!textLength) return List.of(new DecoratorRange({
                start: 0,
                end: 0,
                decoratorKey: null,
                leaves: List.of(new LeafRange({
                    start: 0,
                    end: 0
                }))
            }));
            var leafSets = [], decorations = decorator ? decorator.getDecorations(block, contentState) : List(Repeat(null, textLength)), chars = block.getCharacterList();
            return findRangesImmutable(decorations, areEqual, returnTrue, function(start, end) {
                leafSets.push(new DecoratorRange({
                    start: start,
                    end: end,
                    decoratorKey: decorations.get(start),
                    leaves: generateLeaves(chars.slice(start, end).toList(), start)
                }));
            }), List(leafSets);
        },
        /**
   * Create a string representation of the given tree map. This allows us
   * to rapidly determine whether a tree has undergone a significant
   * structural change.
   */
        getFingerprint: function(tree) {
            return tree.map(function(leafSet) {
                var decoratorKey = leafSet.get("decoratorKey");
                return (null !== decoratorKey ? decoratorKey + "." + (leafSet.get("end") - leafSet.get("start")) : "") + "." + leafSet.get("leaves").size;
            }).join("-");
        }
    };
    module.exports = BlockTree;
}, /* 113 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEntityInstance
 * 
 */
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !call || "object" != typeof call && "function" != typeof call ? self : call;
    }
    function _inherits(subClass, superClass) {
        if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
    }
    var Immutable = __webpack_require__(1), Record = Immutable.Record, DraftEntityInstanceRecord = Record({
        type: "TOKEN",
        mutability: "IMMUTABLE",
        data: Object
    }), DraftEntityInstance = function(_DraftEntityInstanceR) {
        function DraftEntityInstance() {
            return _classCallCheck(this, DraftEntityInstance), _possibleConstructorReturn(this, _DraftEntityInstanceR.apply(this, arguments));
        }
        return _inherits(DraftEntityInstance, _DraftEntityInstanceR), DraftEntityInstance.prototype.getType = function() {
            return this.get("type");
        }, DraftEntityInstance.prototype.getMutability = function() {
            return this.get("mutability");
        }, DraftEntityInstance.prototype.getData = function() {
            return this.get("data");
        }, DraftEntityInstance;
    }(DraftEntityInstanceRecord);
    module.exports = DraftEntityInstance;
}, /* 114 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Returns the first strong character (has Bidi_Class value of L, R, or AL).
 *
 * @param str  A text block; e.g. paragraph, table cell, tag
 * @return     A character with strong bidi direction, or null if not found
 */
    function firstStrongChar(str) {
        var match = REGEX_STRONG.exec(str);
        return null == match ? null : match[0];
    }
    /**
 * Returns the direction of a block of text, based on the direction of its
 * first strong character (has Bidi_Class value of L, R, or AL).
 *
 * @param str  A text block; e.g. paragraph, table cell, tag
 * @return     The resolved direction
 */
    function firstStrongCharDir(str) {
        var strongChar = firstStrongChar(str);
        return null == strongChar ? UnicodeBidiDirection.NEUTRAL : REGEX_RTL.exec(strongChar) ? UnicodeBidiDirection.RTL : UnicodeBidiDirection.LTR;
    }
    /**
 * Returns the direction of a block of text, based on the direction of its
 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
 * direction, if no strong character is found.
 *
 * This function is supposed to be used in respect to Higher-Level Protocol
 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
 *
 * @param str       A text block; e.g. paragraph, table cell, tag
 * @param fallback  Fallback direction, used if no strong direction detected
 *                  for the block (default = NEUTRAL)
 * @return          The resolved direction
 */
    function resolveBlockDir(str, fallback) {
        if (fallback = fallback || UnicodeBidiDirection.NEUTRAL, !str.length) return fallback;
        var blockDir = firstStrongCharDir(str);
        return blockDir === UnicodeBidiDirection.NEUTRAL ? fallback : blockDir;
    }
    /**
 * Returns the direction of a block of text, based on the direction of its
 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
 * direction, if no strong character is found.
 *
 * NOTE: This function is similar to resolveBlockDir(), but uses the global
 * direction as the fallback, so it *always* returns a Strong direction,
 * making it useful for integration in places that you need to make the final
 * decision, like setting some CSS class.
 *
 * This function is supposed to be used in respect to Higher-Level Protocol
 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
 *
 * @param str             A text block; e.g. paragraph, table cell
 * @param strongFallback  Fallback direction, used if no strong direction
 *                        detected for the block (default = global direction)
 * @return                The resolved Strong direction
 */
    function getDirection(str, strongFallback) {
        return strongFallback || (strongFallback = UnicodeBidiDirection.getGlobalDir()), 
        UnicodeBidiDirection.isStrong(strongFallback) || invariant(!1), resolveBlockDir(str, strongFallback);
    }
    /**
 * Returns true if getDirection(arguments...) returns LTR.
 *
 * @param str             A text block; e.g. paragraph, table cell
 * @param strongFallback  Fallback direction, used if no strong direction
 *                        detected for the block (default = global direction)
 * @return                True if the resolved direction is LTR
 */
    function isDirectionLTR(str, strongFallback) {
        return getDirection(str, strongFallback) === UnicodeBidiDirection.LTR;
    }
    /**
 * Returns true if getDirection(arguments...) returns RTL.
 *
 * @param str             A text block; e.g. paragraph, table cell
 * @param strongFallback  Fallback direction, used if no strong direction
 *                        detected for the block (default = global direction)
 * @return                True if the resolved direction is RTL
 */
    function isDirectionRTL(str, strongFallback) {
        return getDirection(str, strongFallback) === UnicodeBidiDirection.RTL;
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 * 
 */
    /**
 * Basic (stateless) API for text direction detection
 *
 * Part of our implementation of Unicode Bidirectional Algorithm (UBA)
 * Unicode Standard Annex #9 (UAX9)
 * http://www.unicode.org/reports/tr9/
 */
    var UnicodeBidiDirection = __webpack_require__(83), invariant = __webpack_require__(2), RANGE_BY_BIDI_TYPE = {
        L: "A-Za-zªµºÀ-ÖØ-öø-ƺƻƼ-ƿǀ-ǃǄ-ʓʔʕ-ʯʰ-ʸʻ-ˁː-ˑˠ-ˤˮͰ-ͳͶ-ͷͺͻ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁ҂Ҋ-ԯԱ-Ֆՙ՚-՟ա-և։ःऄ-हऻऽा-ीॉ-ौॎ-ॏॐक़-ॡ।-॥०-९॰ॱॲ-ঀং-ঃঅ-ঌএ-ঐও-নপ-রলশ-হঽা-ীে-ৈো-ৌৎৗড়-ঢ়য়-ৡ০-৯ৰ-ৱ৴-৹৺ਃਅ-ਊਏ-ਐਓ-ਨਪ-ਰਲ-ਲ਼ਵ-ਸ਼ਸ-ਹਾ-ੀਖ਼-ੜਫ਼੦-੯ੲ-ੴઃઅ-ઍએ-ઑઓ-નપ-રલ-ળવ-હઽા-ીૉો-ૌૐૠ-ૡ૦-૯૰ଂ-ଃଅ-ଌଏ-ଐଓ-ନପ-ରଲ-ଳଵ-ହଽାୀେ-ୈୋ-ୌୗଡ଼-ଢ଼ୟ-ୡ୦-୯୰ୱ୲-୷ஃஅ-ஊஎ-ஐஒ-கங-சஜஞ-டண-தந-பம-ஹா-ிு-ூெ-ைொ-ௌௐௗ௦-௯௰-௲ఁ-ఃఅ-ఌఎ-ఐఒ-నప-హఽు-ౄౘ-ౙౠ-ౡ౦-౯౿ಂ-ಃಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽಾಿೀ-ೄೆೇ-ೈೊ-ೋೕ-ೖೞೠ-ೡ೦-೯ೱ-ೲം-ഃഅ-ഌഎ-ഐഒ-ഺഽാ-ീെ-ൈൊ-ൌൎൗൠ-ൡ൦-൯൰-൵൹ൺ-ൿං-ඃඅ-ඖක-නඳ-රලව-ෆා-ෑෘ-ෟ෦-෯ෲ-ෳ෴ก-ะา-ำเ-ๅๆ๏๐-๙๚-๛ກ-ຂຄງ-ຈຊຍດ-ທນ-ຟມ-ຣລວສ-ຫອ-ະາ-ຳຽເ-ໄໆ໐-໙ໜ-ໟༀ༁-༃༄-༒༓༔༕-༗༚-༟༠-༩༪-༳༴༶༸༾-༿ཀ-ཇཉ-ཬཿ྅ྈ-ྌ྾-࿅࿇-࿌࿎-࿏࿐-࿔࿕-࿘࿙-࿚က-ဪါ-ာေးျ-ြဿ၀-၉၊-၏ၐ-ၕၖ-ၗၚ-ၝၡၢ-ၤၥ-ၦၧ-ၭၮ-ၰၵ-ႁႃ-ႄႇ-ႌႎႏ႐-႙ႚ-ႜ႞-႟Ⴀ-ჅჇჍა-ჺ჻ჼჽ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚ፠-፨፩-፼ᎀ-ᎏᎠ-Ᏼᐁ-ᙬ᙭-᙮ᙯ-ᙿᚁ-ᚚᚠ-ᛪ᛫-᛭ᛮ-ᛰᛱ-ᛸᜀ-ᜌᜎ-ᜑᜠ-ᜱ᜵-᜶ᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳាើ-ៅះ-ៈ។-៖ៗ៘-៚ៜ០-៩᠐-᠙ᠠ-ᡂᡃᡄ-ᡷᢀ-ᢨᢪᢰ-ᣵᤀ-ᤞᤣ-ᤦᤩ-ᤫᤰ-ᤱᤳ-ᤸ᥆-᥏ᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧀᧁ-ᧇᧈ-ᧉ᧐-᧙᧚ᨀ-ᨖᨙ-ᨚ᨞-᨟ᨠ-ᩔᩕᩗᩡᩣ-ᩤᩭ-ᩲ᪀-᪉᪐-᪙᪠-᪦ᪧ᪨-᪭ᬄᬅ-ᬳᬵᬻᬽ-ᭁᭃ-᭄ᭅ-ᭋ᭐-᭙᭚-᭠᭡-᭪᭴-᭼ᮂᮃ-ᮠᮡᮦ-ᮧ᮪ᮮ-ᮯ᮰-᮹ᮺ-ᯥᯧᯪ-ᯬᯮ᯲-᯳᯼-᯿ᰀ-ᰣᰤ-ᰫᰴ-ᰵ᰻-᰿᱀-᱉ᱍ-ᱏ᱐-᱙ᱚ-ᱷᱸ-ᱽ᱾-᱿᳀-᳇᳓᳡ᳩ-ᳬᳮ-ᳱᳲ-ᳳᳵ-ᳶᴀ-ᴫᴬ-ᵪᵫ-ᵷᵸᵹ-ᶚᶛ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼ‎ⁱⁿₐ-ₜℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℴℵ-ℸℹℼ-ℿⅅ-ⅉⅎ⅏Ⅰ-ↂↃ-ↄↅ-ↈ⌶-⍺⎕⒜-ⓩ⚬⠀-⣿Ⰰ-Ⱞⰰ-ⱞⱠ-ⱻⱼ-ⱽⱾ-ⳤⳫ-ⳮⳲ-ⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯ⵰ⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞ々〆〇〡-〩〮-〯〱-〵〸-〺〻〼ぁ-ゖゝ-ゞゟァ-ヺー-ヾヿㄅ-ㄭㄱ-ㆎ㆐-㆑㆒-㆕㆖-㆟ㆠ-ㆺㇰ-ㇿ㈀-㈜㈠-㈩㈪-㉇㉈-㉏㉠-㉻㉿㊀-㊉㊊-㊰㋀-㋋㋐-㋾㌀-㍶㍻-㏝㏠-㏾㐀-䶵一-鿌ꀀ-ꀔꀕꀖ-ꒌꓐ-ꓷꓸ-ꓽ꓾-꓿ꔀ-ꘋꘌꘐ-ꘟ꘠-꘩ꘪ-ꘫꙀ-ꙭꙮꚀ-ꚛꚜ-ꚝꚠ-ꛥꛦ-ꛯ꛲-꛷Ꜣ-ꝯꝰꝱ-ꞇ꞉-꞊Ꞌ-ꞎꞐ-ꞭꞰ-Ʇꟷꟸ-ꟹꟺꟻ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꠣ-ꠤꠧ꠰-꠵꠶-꠷ꡀ-ꡳꢀ-ꢁꢂ-ꢳꢴ-ꣃ꣎-꣏꣐-꣙ꣲ-ꣷ꣸-꣺ꣻ꤀-꤉ꤊ-ꤥ꤮-꤯ꤰ-ꥆꥒ-꥓꥟ꥠ-ꥼꦃꦄ-ꦲꦴ-ꦵꦺ-ꦻꦽ-꧀꧁-꧍ꧏ꧐-꧙꧞-꧟ꧠ-ꧤꧦꧧ-ꧯ꧰-꧹ꧺ-ꧾꨀ-ꨨꨯ-ꨰꨳ-ꨴꩀ-ꩂꩄ-ꩋꩍ꩐-꩙꩜-꩟ꩠ-ꩯꩰꩱ-ꩶ꩷-꩹ꩺꩻꩽꩾ-ꪯꪱꪵ-ꪶꪹ-ꪽꫀꫂꫛ-ꫜꫝ꫞-꫟ꫠ-ꫪꫫꫮ-ꫯ꫰-꫱ꫲꫳ-ꫴꫵꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚ꭛ꭜ-ꭟꭤ-ꭥꯀ-ꯢꯣ-ꯤꯦ-ꯧꯩ-ꯪ꯫꯬꯰-꯹가-힣ힰ-ퟆퟋ-ퟻ-豈-舘並-龎ﬀ-ﬆﬓ-ﬗＡ-Ｚａ-ｚｦ-ｯｰｱ-ﾝﾞ-ﾟﾠ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ",
        R: "֐־׀׃׆׈-׏א-ת׫-ׯװ-ײ׳-״׵-׿߀-߉ߊ-ߪߴ-ߵߺ߻-߿ࠀ-ࠕࠚࠤࠨ࠮-࠯࠰-࠾࠿ࡀ-ࡘ࡜-࡝࡞࡟-࢟‏יִײַ-ﬨשׁ-זּ﬷טּ-לּ﬽מּ﬿נּ-סּ﭂ףּ-פּ﭅צּ-ﭏ",
        AL: "؈؋؍؛؜؝؞-؟ؠ-ؿـف-ي٭ٮ-ٯٱ-ۓ۔ەۥ-ۦۮ-ۯۺ-ۼ۽-۾ۿ܀-܍܎܏ܐܒ-ܯ݋-݌ݍ-ޥޱ޲-޿ࢠ-ࢲࢳ-ࣣﭐ-ﮱ﮲-﯁﯂-﯒ﯓ-ﴽ﵀-﵏ﵐ-ﶏ﶐-﶑ﶒ-ﷇ﷈-﷏ﷰ-ﷻ﷼﷾-﷿ﹰ-ﹴ﹵ﹶ-ﻼ﻽-﻾"
    }, REGEX_STRONG = new RegExp("[" + RANGE_BY_BIDI_TYPE.L + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + "]"), REGEX_RTL = new RegExp("[" + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + "]"), UnicodeBidi = {
        firstStrongChar: firstStrongChar,
        firstStrongCharDir: firstStrongCharDir,
        resolveBlockDir: resolveBlockDir,
        getDirection: getDirection,
        isDirectionLTR: isDirectionLTR,
        isDirectionRTL: isDirectionRTL
    };
    module.exports = UnicodeBidi;
}, /* 115 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DefaultDraftInlineStyle
 * 
 */
    module.exports = {
        BOLD: {
            fontWeight: "bold"
        },
        CODE: {
            fontFamily: "monospace",
            wordWrap: "break-word"
        },
        ITALIC: {
            fontStyle: "italic"
        },
        STRIKETHROUGH: {
            textDecoration: "line-through"
        },
        UNDERLINE: {
            textDecoration: "underline"
        }
    };
}, /* 116 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isSelectionAtLeafStart
 * @typechecks
 * 
 */
    function isSelectionAtLeafStart(editorState) {
        var selection = editorState.getSelection(), anchorKey = selection.getAnchorKey(), blockTree = editorState.getBlockTree(anchorKey), offset = selection.getStartOffset(), isAtStart = !1;
        return blockTree.some(function(leafSet) {
            return offset === leafSet.get("start") ? (isAtStart = !0, !0) : offset < leafSet.get("end") && leafSet.get("leaves").some(function(leaf) {
                var leafStart = leaf.get("start");
                return offset === leafStart && (isAtStart = !0, !0);
            });
        }), isAtStart;
    }
    module.exports = isSelectionAtLeafStart;
}, /* 117 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !call || "object" != typeof call && "function" != typeof call ? self : call;
    }
    function _inherits(subClass, superClass) {
        if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
    }
    /**
 * Return whether a block overlaps with either edge of the `SelectionState`.
 */
    function isBlockOnSelectionEdge(selection, key) {
        return selection.getAnchorKey() === key || selection.getFocusKey() === key;
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorBlock.react
 * @typechecks
 * 
 */
    var _assign = __webpack_require__(35), _extends = _assign || function(target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
        }
        return target;
    }, DraftEditorLeaf = __webpack_require__(196), DraftOffsetKey = __webpack_require__(60), React = __webpack_require__(3), ReactDOM = __webpack_require__(36), Scroll = __webpack_require__(120), Style = __webpack_require__(86), UnicodeBidi = __webpack_require__(114), UnicodeBidiDirection = __webpack_require__(83), cx = __webpack_require__(46), getElementPosition = __webpack_require__(211), getScrollPosition = __webpack_require__(87), getViewportDimensions = __webpack_require__(215), invariant = __webpack_require__(2), nullthrows = __webpack_require__(8), DraftEditorBlock = function(_React$Component) {
        function DraftEditorBlock() {
            return _classCallCheck(this, DraftEditorBlock), _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        /**
   * When a block is mounted and overlaps the selection state, we need to make
   * sure that the cursor is visible to match native behavior. This may not
   * be the case if the user has pressed `RETURN` or pasted some content, since
   * programatically creating these new blocks and setting the DOM selection
   * will miss out on the browser natively scrolling to that position.
   *
   * To replicate native behavior, if the block overlaps the selection state
   * on mount, force the scroll position. Check the scroll state of the scroll
   * parent, and adjust it to align the entire block to the bottom of the
   * scroll parent.
   */
        return _inherits(DraftEditorBlock, _React$Component), DraftEditorBlock.prototype.shouldComponentUpdate = function(nextProps) {
            return this.props.block !== nextProps.block || this.props.tree !== nextProps.tree || this.props.direction !== nextProps.direction || isBlockOnSelectionEdge(nextProps.selection, nextProps.block.getKey()) && nextProps.forceSelection;
        }, DraftEditorBlock.prototype.componentDidMount = function() {
            var selection = this.props.selection, endKey = selection.getEndKey();
            if (selection.getHasFocus() && endKey === this.props.block.getKey()) {
                var scrollDelta, blockNode = ReactDOM.findDOMNode(this), scrollParent = Style.getScrollParent(blockNode), scrollPosition = getScrollPosition(scrollParent);
                if (scrollParent === window) {
                    var nodePosition = getElementPosition(blockNode);
                    scrollDelta = nodePosition.y + nodePosition.height - getViewportDimensions().height, 
                    scrollDelta > 0 && window.scrollTo(scrollPosition.x, scrollPosition.y + scrollDelta + 10);
                } else {
                    blockNode instanceof HTMLElement || invariant(!1);
                    scrollDelta = blockNode.offsetHeight + blockNode.offsetTop - (scrollParent.offsetHeight + scrollPosition.y), 
                    scrollDelta > 0 && Scroll.setTop(scrollParent, Scroll.getTop(scrollParent) + scrollDelta + 10);
                }
            }
        }, DraftEditorBlock.prototype._renderChildren = function() {
            var _this2 = this, block = this.props.block, blockKey = block.getKey(), text = block.getText(), lastLeafSet = this.props.tree.size - 1, hasSelection = isBlockOnSelectionEdge(this.props.selection, blockKey);
            return this.props.tree.map(function(leafSet, ii) {
                var leavesForLeafSet = leafSet.get("leaves"), lastLeaf = leavesForLeafSet.size - 1, leaves = leavesForLeafSet.map(function(leaf, jj) {
                    var offsetKey = DraftOffsetKey.encode(blockKey, ii, jj), start = leaf.get("start"), end = leaf.get("end");
                    return React.createElement(DraftEditorLeaf, {
                        key: offsetKey,
                        offsetKey: offsetKey,
                        block: block,
                        start: start,
                        selection: hasSelection ? _this2.props.selection : void 0,
                        forceSelection: _this2.props.forceSelection,
                        text: text.slice(start, end),
                        styleSet: block.getInlineStyleAt(start),
                        customStyleMap: _this2.props.customStyleMap,
                        customStyleFn: _this2.props.customStyleFn,
                        isLast: ii === lastLeafSet && jj === lastLeaf
                    });
                }).toArray(), decoratorKey = leafSet.get("decoratorKey");
                if (null == decoratorKey) return leaves;
                if (!_this2.props.decorator) return leaves;
                var decorator = nullthrows(_this2.props.decorator), DecoratorComponent = decorator.getComponentForKey(decoratorKey);
                if (!DecoratorComponent) return leaves;
                var decoratorProps = decorator.getPropsForKey(decoratorKey), decoratorOffsetKey = DraftOffsetKey.encode(blockKey, ii, 0), decoratedText = text.slice(leavesForLeafSet.first().get("start"), leavesForLeafSet.last().get("end")), dir = UnicodeBidiDirection.getHTMLDirIfDifferent(UnicodeBidi.getDirection(decoratedText), _this2.props.direction);
                return React.createElement(DecoratorComponent, _extends({}, decoratorProps, {
                    contentState: _this2.props.contentState,
                    decoratedText: decoratedText,
                    dir: dir,
                    key: decoratorOffsetKey,
                    entityKey: block.getEntityAt(leafSet.get("start")),
                    offsetKey: decoratorOffsetKey
                }), leaves);
            }).toArray();
        }, DraftEditorBlock.prototype.render = function() {
            var _props = this.props, direction = _props.direction, offsetKey = _props.offsetKey, className = cx({
                "public/DraftStyleDefault/block": !0,
                "public/DraftStyleDefault/ltr": "LTR" === direction,
                "public/DraftStyleDefault/rtl": "RTL" === direction
            });
            return React.createElement("div", {
                "data-offset-key": offsetKey,
                className: className
            }, this._renderChildren());
        }, DraftEditorBlock;
    }(React.Component);
    module.exports = DraftEditorBlock;
}, /* 118 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /*eslint-disable no-bitwise */
    /**
 * Checks if a given DOM node contains or is another DOM node.
 */
    function containsNode(outerNode, innerNode) {
        return !(!outerNode || !innerNode) && (outerNode === innerNode || !isTextNode(outerNode) && (isTextNode(innerNode) ? containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : !!outerNode.compareDocumentPosition && !!(16 & outerNode.compareDocumentPosition(innerNode))));
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */
    var isTextNode = __webpack_require__(206);
    module.exports = containsNode;
}, /* 119 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */
    /* eslint-disable fb-www/typeof-undefined */
    /**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
    function getActiveElement(doc) {
        if (void 0 === (doc = doc || ("undefined" != typeof document ? document : void 0))) return null;
        try {
            return doc.activeElement || doc.body;
        } catch (e) {
            return doc.body;
        }
    }
    module.exports = getActiveElement;
}, /* 120 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */
    /**
 * @param {DOMElement} element
 * @param {DOMDocument} doc
 * @return {boolean}
 */
    function _isViewportScrollElement(element, doc) {
        return !!doc && (element === doc.documentElement || element === doc.body);
    }
    /**
 * Scroll Module. This class contains 4 simple static functions
 * to be used to access Element.scrollTop/scrollLeft properties.
 * To solve the inconsistencies between browsers when either
 * document.body or document.documentElement is supplied,
 * below logic will be used to alleviate the issue:
 *
 * 1. If 'element' is either 'document.body' or 'document.documentElement,
 *    get whichever element's 'scroll{Top,Left}' is larger.
 * 2. If 'element' is either 'document.body' or 'document.documentElement',
 *    set the 'scroll{Top,Left}' on both elements.
 */
    var Scroll = {
        /**
   * @param {DOMElement} element
   * @return {number}
   */
        getTop: function(element) {
            var doc = element.ownerDocument;
            // In practice, they will either both have the same value,
            // or one will be zero and the other will be the scroll position
            // of the viewport. So we can use `X || Y` instead of `Math.max(X, Y)`
            return _isViewportScrollElement(element, doc) ? doc.body.scrollTop || doc.documentElement.scrollTop : element.scrollTop;
        },
        /**
   * @param {DOMElement} element
   * @param {number} newTop
   */
        setTop: function(element, newTop) {
            var doc = element.ownerDocument;
            _isViewportScrollElement(element, doc) ? doc.body.scrollTop = doc.documentElement.scrollTop = newTop : element.scrollTop = newTop;
        },
        /**
   * @param {DOMElement} element
   * @return {number}
   */
        getLeft: function(element) {
            var doc = element.ownerDocument;
            return _isViewportScrollElement(element, doc) ? doc.body.scrollLeft || doc.documentElement.scrollLeft : element.scrollLeft;
        },
        /**
   * @param {DOMElement} element
   * @param {number} newLeft
   */
        setLeft: function(element, newLeft) {
            var doc = element.ownerDocument;
            _isViewportScrollElement(element, doc) ? doc.body.scrollLeft = doc.documentElement.scrollLeft = newLeft : element.scrollLeft = newLeft;
        }
    };
    module.exports = Scroll;
}, /* 121 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    /**
 * If DataTransferItem is a file then return the Blob of data.
 *
 * @param {object} item
 * @return {?blob}
 */
    function getFileFromDataTransfer(item) {
        if ("file" == item.kind) return item.getAsFile();
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */
    var PhotosMimeType = __webpack_require__(218), createArrayFromMixed = __webpack_require__(219), emptyFunction = __webpack_require__(80), CR_LF_REGEX = new RegExp("\r\n", "g"), RICH_TEXT_TYPES = {
        "text/rtf": 1,
        "text/html": 1
    }, DataTransfer = function() {
        /**
   * @param {object} data
   */
        function DataTransfer(data) {
            _classCallCheck(this, DataTransfer), this.data = data, // Types could be DOMStringList or array
            this.types = data.types ? createArrayFromMixed(data.types) : [];
        }
        /**
   * Is this likely to be a rich text data transfer?
   *
   * @return {boolean}
   */
        /**
   * Get raw text.
   *
   * @return {?string}
   */
        /**
   * Get HTML paste data
   *
   * @return {?string}
   */
        /**
   * Is this a link data transfer?
   *
   * @return {boolean}
   */
        /**
   * Get a link url.
   *
   * @return {?string}
   */
        /**
   * Is this an image data transfer?
   *
   * @return {boolean}
   */
        /**
   * Get files.
   *
   * @return {array}
   */
        /**
   * Are there any files to fetch?
   *
   * @return {boolean}
   */
        return DataTransfer.prototype.isRichText = function() {
            // If HTML is available, treat this data as rich text. This way, we avoid
            // using a pasted image if it is packaged with HTML -- this may occur with
            // pastes from MS Word, for example.  However this is only rich text if
            // there's accompanying text.
            // If HTML is available, treat this data as rich text. This way, we avoid
            // using a pasted image if it is packaged with HTML -- this may occur with
            // pastes from MS Word, for example.  However this is only rich text if
            // there's accompanying text.
            // When an image is copied from a preview window, you end up with two
            // DataTransferItems one of which is a file's metadata as text.  Skip those.
            return !(!this.getHTML() || !this.getText()) || !this.isImage() && this.types.some(function(type) {
                return RICH_TEXT_TYPES[type];
            });
        }, DataTransfer.prototype.getText = function() {
            var text;
            return this.data.getData && (this.types.length ? -1 != this.types.indexOf("text/plain") && (text = this.data.getData("text/plain")) : text = this.data.getData("Text")), 
            text ? text.replace(CR_LF_REGEX, "\n") : null;
        }, DataTransfer.prototype.getHTML = function() {
            if (this.data.getData) {
                if (!this.types.length) return this.data.getData("Text");
                if (-1 != this.types.indexOf("text/html")) return this.data.getData("text/html");
            }
        }, DataTransfer.prototype.isLink = function() {
            return this.types.some(function(type) {
                return -1 != type.indexOf("Url") || -1 != type.indexOf("text/uri-list") || type.indexOf("text/x-moz-url");
            });
        }, DataTransfer.prototype.getLink = function() {
            if (this.data.getData) {
                if (-1 != this.types.indexOf("text/x-moz-url")) {
                    return this.data.getData("text/x-moz-url").split("\n")[0];
                }
                return -1 != this.types.indexOf("text/uri-list") ? this.data.getData("text/uri-list") : this.data.getData("url");
            }
            return null;
        }, DataTransfer.prototype.isImage = function() {
            if (this.types.some(function(type) {
                // Firefox will have a type of application/x-moz-file for images during
                // dragging
                return -1 != type.indexOf("application/x-moz-file");
            })) return !0;
            for (var items = this.getFiles(), i = 0; i < items.length; i++) {
                var type = items[i].type;
                if (!PhotosMimeType.isImage(type)) return !1;
            }
            return !0;
        }, DataTransfer.prototype.getCount = function() {
            return this.data.hasOwnProperty("items") ? this.data.items.length : this.data.hasOwnProperty("mozItemCount") ? this.data.mozItemCount : this.data.files ? this.data.files.length : null;
        }, DataTransfer.prototype.getFiles = function() {
            return this.data.items ? Array.prototype.slice.call(this.data.items).map(getFileFromDataTransfer).filter(emptyFunction.thatReturnsArgument) : this.data.files ? Array.prototype.slice.call(this.data.files) : [];
        }, DataTransfer.prototype.hasFiles = function() {
            return this.getFiles().length > 0;
        }, DataTransfer;
    }();
    module.exports = DataTransfer;
}, /* 122 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getSelectionOffsetKeyForNode
 * @typechecks
 * 
 */
    /**
 * Get offset key from a node or it's child nodes. Return the first offset key
 * found on the DOM tree of given node.
 */
    function getSelectionOffsetKeyForNode(node) {
        if (node instanceof Element) {
            var offsetKey = node.getAttribute("data-offset-key");
            if (offsetKey) return offsetKey;
            for (var ii = 0; ii < node.childNodes.length; ii++) {
                var childOffsetKey = getSelectionOffsetKeyForNode(node.childNodes[ii]);
                if (childOffsetKey) return childOffsetKey;
            }
        }
        return null;
    }
    module.exports = getSelectionOffsetKeyForNode;
}, /* 123 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /* WEBPACK VAR INJECTION */
    (function(global) {
        /**
 * Extract the text content from a file list.
 */
        function getTextContentFromFiles(files, callback) {
            var readCount = 0, results = [];
            files.forEach(function(/*blob*/ file) {
                readFile(file, function(/*string*/ text) {
                    readCount++, text && results.push(text.slice(0, TEXT_SIZE_UPPER_BOUND)), readCount == files.length && callback(results.join("\r"));
                });
            });
        }
        /**
 * todo isaac: Do work to turn html/rtf into a content fragment.
 */
        function readFile(file, callback) {
            if (!global.FileReader || file.type && !(file.type in TEXT_TYPES)) return void callback("");
            if ("" === file.type) {
                var contents = "";
                // Special-case text clippings, which have an empty type but include
                // `.textClipping` in the file name. `readAsText` results in an empty
                // string for text clippings, so we force the file name to serve
                // as the text value for the file.
                return TEXT_CLIPPING_REGEX.test(file.name) && (contents = file.name.replace(TEXT_CLIPPING_REGEX, "")), 
                void callback(contents);
            }
            var reader = new FileReader();
            reader.onload = function() {
                callback(reader.result);
            }, reader.onerror = function() {
                callback("");
            }, reader.readAsText(file);
        }
        /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getTextContentFromFiles
 * 
 */
        var TEXT_CLIPPING_REGEX = /\.textClipping$/, TEXT_TYPES = {
            "text/plain": !0,
            "text/html": !0,
            "text/rtf": !0
        }, TEXT_SIZE_UPPER_BOUND = 5e3;
        module.exports = getTextContentFromFiles;
    }).call(exports, __webpack_require__(28));
}, /* 124 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function getUpdatedSelectionState(editorState, anchorKey, anchorOffset, focusKey, focusOffset) {
        var selection = nullthrows(editorState.getSelection()), anchorPath = DraftOffsetKey.decode(anchorKey), anchorBlockKey = anchorPath.blockKey, anchorLeaf = editorState.getBlockTree(anchorBlockKey).getIn([ anchorPath.decoratorKey, "leaves", anchorPath.leafKey ]), focusPath = DraftOffsetKey.decode(focusKey), focusBlockKey = focusPath.blockKey, focusLeaf = editorState.getBlockTree(focusBlockKey).getIn([ focusPath.decoratorKey, "leaves", focusPath.leafKey ]), anchorLeafStart = anchorLeaf.get("start"), focusLeafStart = focusLeaf.get("start"), anchorBlockOffset = anchorLeaf ? anchorLeafStart + anchorOffset : null, focusBlockOffset = focusLeaf ? focusLeafStart + focusOffset : null;
        if (selection.getAnchorKey() === anchorBlockKey && selection.getAnchorOffset() === anchorBlockOffset && selection.getFocusKey() === focusBlockKey && selection.getFocusOffset() === focusBlockOffset) return selection;
        var isBackward = !1;
        if (anchorBlockKey === focusBlockKey) {
            var anchorLeafEnd = anchorLeaf.get("end"), focusLeafEnd = focusLeaf.get("end");
            isBackward = focusLeafStart === anchorLeafStart && focusLeafEnd === anchorLeafEnd ? focusOffset < anchorOffset : focusLeafStart < anchorLeafStart;
        } else {
            isBackward = editorState.getCurrentContent().getBlockMap().keySeq().skipUntil(function(v) {
                return v === anchorBlockKey || v === focusBlockKey;
            }).first() === focusBlockKey;
        }
        return selection.merge({
            anchorKey: anchorBlockKey,
            anchorOffset: anchorBlockOffset,
            focusKey: focusBlockKey,
            focusOffset: focusBlockOffset,
            isBackward: isBackward
        });
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getUpdatedSelectionState
 * 
 */
    var DraftOffsetKey = __webpack_require__(60), nullthrows = __webpack_require__(8);
    module.exports = getUpdatedSelectionState;
}, /* 125 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function getFragmentFromSelection(editorState) {
        var selectionState = editorState.getSelection();
        return selectionState.isCollapsed() ? null : getContentStateFragment(editorState.getCurrentContent(), selectionState);
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getFragmentFromSelection
 * 
 */
    var getContentStateFragment = __webpack_require__(57);
    module.exports = getFragmentFromSelection;
}, /* 126 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    // In Chrome, the client rects will include the entire bounds of all nodes that
    // begin (have a start tag) within the selection, even if the selection does
    // not overlap the entire node. To resolve this, we split the range at each
    // start tag and join the client rects together.
    // https://code.google.com/p/chromium/issues/detail?id=324437
    /* eslint-disable consistent-return */
    function getRangeClientRectsChrome(range) {
        for (var tempRange = range.cloneRange(), clientRects = [], ancestor = range.endContainer; null != ancestor; ancestor = ancestor.parentNode) {
            // If we've climbed up to the common ancestor, we can now use the
            // original start point and stop climbing the tree.
            var atCommonAncestor = ancestor === range.commonAncestorContainer;
            atCommonAncestor ? tempRange.setStart(range.startContainer, range.startOffset) : tempRange.setStart(tempRange.endContainer, 0);
            var rects = Array.from(tempRange.getClientRects());
            if (clientRects.push(rects), atCommonAncestor) {
                var _ref;
                return clientRects.reverse(), (_ref = []).concat.apply(_ref, clientRects);
            }
            tempRange.setEndBefore(ancestor);
        }
        invariant(!1);
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getRangeClientRects
 * @typechecks
 * 
 */
    var UserAgent = __webpack_require__(17), invariant = __webpack_require__(2), isChrome = UserAgent.isBrowser("Chrome"), getRangeClientRects = isChrome ? getRangeClientRectsChrome : function(range) {
        return Array.from(range.getClientRects());
    };
    module.exports = getRangeClientRects;
}, /* 127 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Convert the current selection range to an anchor/focus pair of offset keys
 * and values that can be interpreted by components.
 */
    function getDraftEditorSelectionWithNodes(editorState, root, anchorNode, anchorOffset, focusNode, focusOffset) {
        var anchorIsTextNode = anchorNode.nodeType === Node.TEXT_NODE, focusIsTextNode = focusNode.nodeType === Node.TEXT_NODE;
        // If the selection range lies only on text nodes, the task is simple.
        // Find the nearest offset-aware elements and use the
        // offset values supplied by the selection range.
        if (anchorIsTextNode && focusIsTextNode) return {
            selectionState: getUpdatedSelectionState(editorState, nullthrows(findAncestorOffsetKey(anchorNode)), anchorOffset, nullthrows(findAncestorOffsetKey(focusNode)), focusOffset),
            needsRecovery: !1
        };
        var anchorPoint = null, focusPoint = null, needsRecovery = !0;
        // An element is selected. Convert this selection range into leaf offset
        // keys and offset values for consumption at the component level. This
        // is common in Firefox, where select-all and triple click behavior leads
        // to entire elements being selected.
        //
        // Note that we use the `needsRecovery` parameter in the callback here. This
        // is because when certain elements are selected, the behavior for subsequent
        // cursor movement (e.g. via arrow keys) is uncertain and may not match
        // expectations at the component level. For example, if an entire <div> is
        // selected and the user presses the right arrow, Firefox keeps the selection
        // on the <div>. If we allow subsequent keypresses to insert characters
        // natively, they will be inserted into a browser-created text node to the
        // right of that <div>. This is obviously undesirable.
        //
        // With the `needsRecovery` flag, we inform the caller that it is responsible
        // for manually setting the selection state on the rendered document to
        // ensure proper selection state maintenance.
        // If the selection is collapsed on an empty block, don't force recovery.
        // This way, on arrow key selection changes, the browser can move the
        // cursor from a non-zero offset on one block, through empty blocks,
        // to a matching non-zero offset on other text blocks.
        return anchorIsTextNode ? (anchorPoint = {
            key: nullthrows(findAncestorOffsetKey(anchorNode)),
            offset: anchorOffset
        }, focusPoint = getPointForNonTextNode(root, focusNode, focusOffset)) : focusIsTextNode ? (focusPoint = {
            key: nullthrows(findAncestorOffsetKey(focusNode)),
            offset: focusOffset
        }, anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset)) : (anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset), 
        focusPoint = getPointForNonTextNode(root, focusNode, focusOffset), anchorNode === focusNode && anchorOffset === focusOffset && (needsRecovery = !!anchorNode.firstChild && "BR" !== anchorNode.firstChild.nodeName)), 
        {
            selectionState: getUpdatedSelectionState(editorState, anchorPoint.key, anchorPoint.offset, focusPoint.key, focusPoint.offset),
            needsRecovery: needsRecovery
        };
    }
    /**
 * Identify the first leaf descendant for the given node.
 */
    function getFirstLeaf(node) {
        for (;node.firstChild && getSelectionOffsetKeyForNode(node.firstChild); ) node = node.firstChild;
        return node;
    }
    /**
 * Identify the last leaf descendant for the given node.
 */
    function getLastLeaf(node) {
        for (;node.lastChild && getSelectionOffsetKeyForNode(node.lastChild); ) node = node.lastChild;
        return node;
    }
    function getPointForNonTextNode(editorRoot, startNode, childOffset) {
        var node = startNode, offsetKey = findAncestorOffsetKey(node);
        // If the child offset is zero and we have an offset key, we're done.
        // If there's no offset key because the entire editor is selected,
        // find the leftmost ("first") leaf in the tree and use that as the offset
        // key.
        if (null != offsetKey || editorRoot && (editorRoot === node || editorRoot.firstChild === node) || invariant(!1), 
        // If the editorRoot is the selection, step downward into the content
        // wrapper.
        editorRoot === node && (node = node.firstChild, node instanceof Element && "true" === node.getAttribute("data-contents") || invariant(!1), 
        childOffset > 0 && (childOffset = node.childNodes.length)), 0 === childOffset) {
            var key = null;
            if (null != offsetKey) key = offsetKey; else {
                var firstLeaf = getFirstLeaf(node);
                key = nullthrows(getSelectionOffsetKeyForNode(firstLeaf));
            }
            return {
                key: key,
                offset: 0
            };
        }
        var nodeBeforeCursor = node.childNodes[childOffset - 1], leafKey = null, textLength = null;
        if (getSelectionOffsetKeyForNode(nodeBeforeCursor)) {
            // Otherwise, we'll look at the child to the left of the cursor and find
            // the last leaf node in its subtree.
            var lastLeaf = getLastLeaf(nodeBeforeCursor);
            leafKey = nullthrows(getSelectionOffsetKeyForNode(lastLeaf)), textLength = getTextContentLength(lastLeaf);
        } else // Our target node may be a leaf or a text node, in which case we're
        // already where we want to be and can just use the child's length as
        // our offset.
        leafKey = nullthrows(offsetKey), textLength = getTextContentLength(nodeBeforeCursor);
        return {
            key: leafKey,
            offset: textLength
        };
    }
    /**
 * Return the length of a node's textContent, regarding single newline
 * characters as zero-length. This allows us to avoid problems with identifying
 * the correct selection offset for empty blocks in IE, in which we
 * render newlines instead of break tags.
 */
    function getTextContentLength(node) {
        var textContent = node.textContent;
        return "\n" === textContent ? 0 : textContent.length;
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getDraftEditorSelectionWithNodes
 * @typechecks
 * 
 */
    var findAncestorOffsetKey = __webpack_require__(88), getSelectionOffsetKeyForNode = __webpack_require__(122), getUpdatedSelectionState = __webpack_require__(124), invariant = __webpack_require__(2), nullthrows = __webpack_require__(8);
    module.exports = getDraftEditorSelectionWithNodes;
}, /* 128 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function getRemovableWord(text, isBackward) {
        var matches = isBackward ? BACKSPACE_REGEX.exec(text) : DELETE_REGEX.exec(text);
        return matches ? matches[0] : text;
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftRemovableWord
 * @typechecks
 * 
 */
    var TokenizeUtil = __webpack_require__(238), punctuation = TokenizeUtil.getPunctuation(), WHITESPACE_AND_PUNCTUATION = "\\s|(?![_])" + punctuation, DELETE_STRING = "^(?:" + WHITESPACE_AND_PUNCTUATION + ")*(?:['‘’]|(?!" + WHITESPACE_AND_PUNCTUATION + ").)*(?:(?!" + WHITESPACE_AND_PUNCTUATION + ").)", DELETE_REGEX = new RegExp(DELETE_STRING), BACKSPACE_STRING = "(?:(?!" + WHITESPACE_AND_PUNCTUATION + ").)(?:['‘’]|(?!" + WHITESPACE_AND_PUNCTUATION + ").)*(?:" + WHITESPACE_AND_PUNCTUATION + ")*$", BACKSPACE_REGEX = new RegExp(BACKSPACE_STRING), DraftRemovableWord = {
        getBackward: function(text) {
            return getRemovableWord(text, !0);
        },
        getForward: function(text) {
            return getRemovableWord(text, !1);
        }
    };
    module.exports = DraftRemovableWord;
}, /* 129 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule moveSelectionForward
 * 
 */
    /**
 * Given a collapsed selection, move the focus `maxDistance` forward within
 * the selected block. If the selection will go beyond the end of the block,
 * move focus to the start of the next block, but no further.
 *
 * This function is not Unicode-aware, so surrogate pairs will be treated
 * as having length 2.
 */
    function moveSelectionForward(editorState, maxDistance) {
        var focusOffset, selection = editorState.getSelection(), key = selection.getStartKey(), offset = selection.getStartOffset(), content = editorState.getCurrentContent(), focusKey = key;
        return maxDistance > content.getBlockForKey(key).getText().length - offset ? (focusKey = content.getKeyAfter(key), 
        focusOffset = 0) : focusOffset = offset + maxDistance, selection.merge({
            focusKey: focusKey,
            focusOffset: focusOffset
        });
    }
    module.exports = moveSelectionForward;
}, /* 130 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function getEmptyChunk() {
        return {
            text: "",
            inlines: [],
            entities: [],
            blocks: []
        };
    }
    function getWhitespaceChunk(inEntity) {
        var entities = new Array(1);
        return inEntity && (entities[0] = inEntity), {
            text: SPACE,
            inlines: [ OrderedSet() ],
            entities: entities,
            blocks: []
        };
    }
    function getSoftNewlineChunk() {
        return {
            text: "\n",
            inlines: [ OrderedSet() ],
            entities: new Array(1),
            blocks: []
        };
    }
    function getBlockDividerChunk(block, depth) {
        return {
            text: "\r",
            inlines: [ OrderedSet() ],
            entities: new Array(1),
            blocks: [ {
                type: block,
                depth: Math.max(0, Math.min(MAX_DEPTH, depth))
            } ]
        };
    }
    function getListBlockType(tag, lastList) {
        return "li" === tag ? "ol" === lastList ? "ordered-list-item" : "unordered-list-item" : null;
    }
    function getBlockMapSupportedTags(blockRenderMap) {
        var unstyledElement = blockRenderMap.get("unstyled").element, tags = new Set([]);
        return blockRenderMap.forEach(function(draftBlock) {
            draftBlock.aliasedElements && draftBlock.aliasedElements.forEach(function(tag) {
                tags = tags.add(tag);
            }), tags = tags.add(draftBlock.element);
        }), tags.filter(function(tag) {
            return tag && tag !== unstyledElement;
        }).toArray().sort();
    }
    // custom element conversions
    function getMultiMatchedType(tag, lastList, multiMatchExtractor) {
        for (var ii = 0; ii < multiMatchExtractor.length; ii++) {
            var matchType = multiMatchExtractor[ii](tag, lastList);
            if (matchType) return matchType;
        }
        return null;
    }
    function getBlockTypeForTag(tag, lastList, blockRenderMap) {
        var matchedTypes = blockRenderMap.filter(function(draftBlock) {
            return draftBlock.element === tag || draftBlock.wrapper === tag || draftBlock.aliasedElements && draftBlock.aliasedElements.some(function(alias) {
                return alias === tag;
            });
        }).keySeq().toSet().toArray().sort();
        // if we dont have any matched type, return unstyled
        // if we have one matched type return it
        // if we have multi matched types use the multi-match function to gather type
        switch (matchedTypes.length) {
          case 0:
            return "unstyled";

          case 1:
            return matchedTypes[0];

          default:
            return getMultiMatchedType(tag, lastList, [ getListBlockType ]) || "unstyled";
        }
    }
    function processInlineTag(tag, node, currentStyle) {
        var styleToCheck = inlineTags[tag];
        return styleToCheck ? currentStyle = currentStyle.add(styleToCheck).toOrderedSet() : node instanceof HTMLElement && function() {
            var htmlElement = node;
            currentStyle = currentStyle.withMutations(function(style) {
                var fontWeight = htmlElement.style.fontWeight, fontStyle = htmlElement.style.fontStyle, textDecoration = htmlElement.style.textDecoration;
                boldValues.indexOf(fontWeight) >= 0 ? style.add("BOLD") : notBoldValues.indexOf(fontWeight) >= 0 && style.remove("BOLD"), 
                "italic" === fontStyle ? style.add("ITALIC") : "normal" === fontStyle && style.remove("ITALIC"), 
                "underline" === textDecoration && style.add("UNDERLINE"), "line-through" === textDecoration && style.add("STRIKETHROUGH"), 
                "none" === textDecoration && (style.remove("UNDERLINE"), style.remove("STRIKETHROUGH"));
            }).toOrderedSet();
        }(), currentStyle;
    }
    function joinChunks(A, B) {
        // Sometimes two blocks will touch in the DOM and we need to strip the
        // extra delimiter to preserve niceness.
        var lastInA = A.text.slice(-1), firstInB = B.text.slice(0, 1);
        // Kill whitespace after blocks
        if ("\r" === lastInA && "\r" === firstInB && (A.text = A.text.slice(0, -1), A.inlines.pop(), 
        A.entities.pop(), A.blocks.pop()), "\r" === lastInA) {
            if (B.text === SPACE || "\n" === B.text) return A;
            firstInB !== SPACE && "\n" !== firstInB || (B.text = B.text.slice(1), B.inlines.shift(), 
            B.entities.shift());
        }
        return {
            text: A.text + B.text,
            inlines: A.inlines.concat(B.inlines),
            entities: A.entities.concat(B.entities),
            blocks: A.blocks.concat(B.blocks)
        };
    }
    /**
 * Check to see if we have anything like <p> <blockquote> <h1>... to create
 * block tags from. If we do, we can use those and ignore <div> tags. If we
 * don't, we can treat <div> tags as meaningful (unstyled) blocks.
 */
    function containsSemanticBlockMarkup(html, blockTags) {
        return blockTags.some(function(tag) {
            return -1 !== html.indexOf("<" + tag);
        });
    }
    function hasValidLinkText(link) {
        link instanceof HTMLAnchorElement || invariant(!1);
        var protocol = link.protocol;
        return "http:" === protocol || "https:" === protocol || "mailto:" === protocol;
    }
    function genFragment(entityMap, node, inlineStyle, lastList, inBlock, blockTags, depth, blockRenderMap, inEntity) {
        var nodeName = node.nodeName.toLowerCase(), newBlock = !1, nextBlockType = "unstyled", lastLastBlock = lastBlock, newEntityMap = entityMap;
        // Base Case
        if ("#text" === nodeName) {
            var text = node.textContent;
            // Can't use empty string because MSWord
            // save the last block so we can use it later
            return "" === text.trim() && "pre" !== inBlock ? {
                chunk: getWhitespaceChunk(inEntity),
                entityMap: entityMap
            } : ("pre" !== inBlock && (text = text.replace(REGEX_LF, SPACE)), lastBlock = nodeName, 
            {
                chunk: {
                    text: text,
                    inlines: Array(text.length).fill(inlineStyle),
                    entities: Array(text.length).fill(inEntity),
                    blocks: []
                },
                entityMap: entityMap
            });
        }
        // BR tags
        if (// save the last block so we can use it later
        lastBlock = nodeName, "br" === nodeName) return "br" !== lastLastBlock || inBlock && "unstyled" !== getBlockTypeForTag(inBlock, lastList, blockRenderMap) ? {
            chunk: getSoftNewlineChunk(),
            entityMap: entityMap
        } : {
            chunk: getBlockDividerChunk("unstyled", depth),
            entityMap: entityMap
        };
        // IMG tags
        "img" === nodeName && node instanceof HTMLImageElement && node.attributes.getNamedItem("src") && node.attributes.getNamedItem("src").value && function() {
            var image = node, entityConfig = {};
            imgAttr.forEach(function(attr) {
                var imageAttribute = image.getAttribute(attr);
                imageAttribute && (entityConfig[attr] = imageAttribute);
            });
            var imageURI = new URI(entityConfig.src).toString();
            node.textContent = imageURI, // Output src if no decorator
            // TODO: update this when we remove DraftEntity entirely
            inEntity = DraftEntity.__create("IMAGE", "MUTABLE", entityConfig || {});
        }();
        var chunk = getEmptyChunk(), newChunk = null;
        // Inline tags
        inlineStyle = processInlineTag(nodeName, node, inlineStyle), // Handle lists
        "ul" !== nodeName && "ol" !== nodeName || (lastList && (depth += 1), lastList = nodeName), 
        // Block Tags
        inBlock || -1 === blockTags.indexOf(nodeName) ? lastList && "li" === inBlock && "li" === nodeName && (chunk = getBlockDividerChunk(getBlockTypeForTag(nodeName, lastList, blockRenderMap), depth), 
        inBlock = nodeName, newBlock = !0, nextBlockType = "ul" === lastList ? "unordered-list-item" : "ordered-list-item") : (chunk = getBlockDividerChunk(getBlockTypeForTag(nodeName, lastList, blockRenderMap), depth), 
        inBlock = nodeName, newBlock = !0);
        // Recurse through children
        var child = node.firstChild;
        null != child && (nodeName = child.nodeName.toLowerCase());
        for (var entityId = null; child; ) {
            child instanceof HTMLAnchorElement && child.href && hasValidLinkText(child) ? function() {
                var anchor = child, entityConfig = {};
                anchorAttr.forEach(function(attr) {
                    var anchorAttribute = anchor.getAttribute(attr);
                    anchorAttribute && (entityConfig[attr] = anchorAttribute);
                }), entityConfig.url = new URI(anchor.href).toString(), // TODO: update this when we remove DraftEntity completely
                entityId = DraftEntity.__create("LINK", "MUTABLE", entityConfig || {});
            }() : entityId = void 0;
            var _genFragment = genFragment(newEntityMap, child, inlineStyle, lastList, inBlock, blockTags, depth, blockRenderMap, entityId || inEntity), generatedChunk = _genFragment.chunk, maybeUpdatedEntityMap = _genFragment.entityMap;
            newChunk = generatedChunk, newEntityMap = maybeUpdatedEntityMap, chunk = joinChunks(chunk, newChunk);
            var sibling = child.nextSibling;
            // Put in a newline to break up blocks inside blocks
            sibling && blockTags.indexOf(nodeName) >= 0 && inBlock && (chunk = joinChunks(chunk, getSoftNewlineChunk())), 
            sibling && (nodeName = sibling.nodeName.toLowerCase()), child = sibling;
        }
        return newBlock && (chunk = joinChunks(chunk, getBlockDividerChunk(nextBlockType, depth))), 
        {
            chunk: chunk,
            entityMap: newEntityMap
        };
    }
    function getChunkForHTML(html, DOMBuilder, blockRenderMap, entityMap) {
        html = html.trim().replace(REGEX_CR, "").replace(REGEX_NBSP, SPACE).replace(REGEX_CARRIAGE, "").replace(REGEX_ZWS, "");
        var supportedBlockTags = getBlockMapSupportedTags(blockRenderMap), safeBody = DOMBuilder(html);
        if (!safeBody) return null;
        lastBlock = null;
        // Sometimes we aren't dealing with content that contains nice semantic
        // tags. In this case, use divs to separate everything out into paragraphs
        // and hope for the best.
        var workingBlocks = containsSemanticBlockMarkup(html, supportedBlockTags) ? supportedBlockTags : [ "div" ], _genFragment2 = genFragment(entityMap, safeBody, OrderedSet(), "ul", null, workingBlocks, -1, blockRenderMap), chunk = _genFragment2.chunk, newEntityMap = _genFragment2.entityMap;
        // join with previous block to prevent weirdness on paste
        // Kill block delimiter at the end
        // If we saw no block tags, put an unstyled one in
        // Sometimes we start with text that isn't in a block, which is then
        // followed by blocks. Need to fix up the blocks to add in
        // an unstyled block for this content
        return 0 === chunk.text.indexOf("\r") && (chunk = {
            text: chunk.text.slice(1),
            inlines: chunk.inlines.slice(1),
            entities: chunk.entities.slice(1),
            blocks: chunk.blocks
        }), "\r" === chunk.text.slice(-1) && (chunk.text = chunk.text.slice(0, -1), chunk.inlines = chunk.inlines.slice(0, -1), 
        chunk.entities = chunk.entities.slice(0, -1), chunk.blocks.pop()), 0 === chunk.blocks.length && chunk.blocks.push({
            type: "unstyled",
            depth: 0
        }), chunk.text.split("\r").length === chunk.blocks.length + 1 && chunk.blocks.unshift({
            type: "unstyled",
            depth: 0
        }), {
            chunk: chunk,
            entityMap: newEntityMap
        };
    }
    function convertFromHTMLtoContentBlocks(html) {
        var DOMBuilder = arguments.length <= 1 || void 0 === arguments[1] ? getSafeBodyFromHTML : arguments[1], blockRenderMap = arguments.length <= 2 || void 0 === arguments[2] ? DefaultDraftBlockRenderMap : arguments[2], chunkData = getChunkForHTML(html, DOMBuilder, blockRenderMap, DraftEntity);
        if (null == chunkData) return null;
        var chunk = chunkData.chunk, newEntityMap = chunkData.entityMap, start = 0;
        return {
            contentBlocks: chunk.text.split("\r").map(function(textBlock, ii) {
                // Make absolutely certain that our text is acceptable.
                textBlock = sanitizeDraftText(textBlock);
                var end = start + textBlock.length, inlines = nullthrows(chunk).inlines.slice(start, end), entities = nullthrows(chunk).entities.slice(start, end), characterList = List(inlines.map(function(style, ii) {
                    var data = {
                        style: style,
                        entity: null
                    };
                    return entities[ii] && (data.entity = entities[ii]), CharacterMetadata.create(data);
                }));
                return start = end + 1, new ContentBlock({
                    key: generateRandomKey(),
                    type: nullthrows(chunk).blocks[ii].type,
                    depth: nullthrows(chunk).blocks[ii].depth,
                    text: textBlock,
                    characterList: characterList
                });
            }),
            entityMap: newEntityMap
        };
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule convertFromHTMLToContentBlocks
 * @typechecks
 * 
 */
    var lastBlock, CharacterMetadata = __webpack_require__(11), ContentBlock = __webpack_require__(34), DefaultDraftBlockRenderMap = __webpack_require__(84), DraftEntity = __webpack_require__(58), Immutable = __webpack_require__(1), URI = __webpack_require__(249), generateRandomKey = __webpack_require__(16), getSafeBodyFromHTML = __webpack_require__(131), invariant = __webpack_require__(2), nullthrows = __webpack_require__(8), sanitizeDraftText = __webpack_require__(82), _require = __webpack_require__(1), Set = _require.Set, List = Immutable.List, OrderedSet = Immutable.OrderedSet, SPACE = " ", MAX_DEPTH = 4, REGEX_CR = new RegExp("\r", "g"), REGEX_LF = new RegExp("\n", "g"), REGEX_NBSP = new RegExp("&nbsp;", "g"), REGEX_CARRIAGE = new RegExp("&#13;?", "g"), REGEX_ZWS = new RegExp("&#8203;?", "g"), boldValues = [ "bold", "bolder", "500", "600", "700", "800", "900" ], notBoldValues = [ "light", "lighter", "100", "200", "300", "400" ], inlineTags = {
        b: "BOLD",
        code: "CODE",
        del: "STRIKETHROUGH",
        em: "ITALIC",
        i: "ITALIC",
        s: "STRIKETHROUGH",
        strike: "STRIKETHROUGH",
        strong: "BOLD",
        u: "UNDERLINE"
    }, anchorAttr = [ "className", "href", "rel", "target", "title" ], imgAttr = [ "alt", "className", "height", "src", "width" ];
    module.exports = convertFromHTMLtoContentBlocks;
}, /* 131 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    // Provides a dom node that will not execute scripts
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation.createHTMLDocument
    // https://developer.mozilla.org/en-US/Add-ons/Code_snippets/HTML_to_DOM
    function getSafeBodyFromHTML(html) {
        var doc, root = null;
        // Provides a safe context
        return !isOldIE && document.implementation && document.implementation.createHTMLDocument && (doc = document.implementation.createHTMLDocument("foo"), 
        doc.documentElement || invariant(!1), doc.documentElement.innerHTML = html, root = doc.getElementsByTagName("body")[0]), 
        root;
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getSafeBodyFromHTML
 * 
 */
    var UserAgent = __webpack_require__(17), invariant = __webpack_require__(2), isOldIE = UserAgent.isBrowser("IE <= 9");
    module.exports = getSafeBodyFromHTML;
}, /* 132 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftStringKey
 * @typechecks
 * 
 */
    var DraftStringKey = {
        stringify: function(key) {
            return "_" + String(key);
        },
        unstringify: function(key) {
            return key.slice(1);
        }
    };
    module.exports = DraftStringKey;
}, /* 133 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = {
        default: __webpack_require__(276),
        __esModule: !0
    };
}, /* 134 */
/***/
function(module, exports, __webpack_require__) {
    // call something on iterator step with safe closing on error
    var anObject = __webpack_require__(26);
    module.exports = function(iterator, fn, value, entries) {
        try {
            return entries ? fn(anObject(value)[0], value[1]) : fn(value);
        } catch (e) {
            var ret = iterator.return;
            throw void 0 !== ret && anObject(ret.call(iterator)), e;
        }
    };
}, /* 135 */
/***/
function(module, exports, __webpack_require__) {
    // check on default Array iterator
    var Iterators = __webpack_require__(40), ITERATOR = __webpack_require__(6)("iterator"), ArrayProto = Array.prototype;
    module.exports = function(it) {
        return void 0 !== it && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
    };
}, /* 136 */
/***/
function(module, exports, __webpack_require__) {
    var hide = __webpack_require__(25);
    module.exports = function(target, src, safe) {
        for (var key in src) safe && target[key] ? target[key] = src[key] : hide(target, key, src[key]);
        return target;
    };
}, /* 137 */
/***/
function(module, exports) {
    module.exports = function(it, Constructor, name, forbiddenField) {
        if (!(it instanceof Constructor) || void 0 !== forbiddenField && forbiddenField in it) throw TypeError(name + ": incorrect invocation!");
        return it;
    };
}, /* 138 */
/***/
function(module, exports, __webpack_require__) {
    var isObject = __webpack_require__(27);
    module.exports = function(it, TYPE) {
        if (!isObject(it) || it._t !== TYPE) throw TypeError("Incompatible receiver, " + TYPE + " required!");
        return it;
    };
}, /* 139 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _objectWithoutProperties2 = __webpack_require__(39), _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2), _getPrototypeOf = __webpack_require__(20), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(14), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(15), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(21), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(22), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(3), _react2 = _interopRequireDefault(_react), _classnames = __webpack_require__(23), _classnames2 = _interopRequireDefault(_classnames), _classAutobind = __webpack_require__(30), _classAutobind2 = _interopRequireDefault(_classAutobind), _Button = __webpack_require__(298), _Button2 = _interopRequireDefault(_Button), Button = function(_Component) {
        function Button() {
            (0, _classCallCheck3.default)(this, Button);
            var _this = (0, _possibleConstructorReturn3.default)(this, (Button.__proto__ || (0, 
            _getPrototypeOf2.default)(Button)).apply(this, arguments));
            return (0, _classAutobind2.default)(_this), _this;
        }
        return (0, _inherits3.default)(Button, _Component), (0, _createClass3.default)(Button, [ {
            key: "render",
            value: function() {
                var props = this.props, className = props.className, isDisabled = props.isDisabled, focusOnClick = props.focusOnClick, formSubmit = props.formSubmit, otherProps = (0, 
                _objectWithoutProperties3.default)(props, [ "className", "isDisabled", "focusOnClick", "formSubmit" ]);
                className = (0, _classnames2.default)(className, _Button2.default.root);
                var onMouseDown = !1 === focusOnClick ? this._onMouseDownPreventDefault : props.onMouseDown, type = formSubmit ? "submit" : "button";
                return _react2.default.createElement("button", (0, _extends3.default)({
                    type: type
                }, otherProps, {
                    onMouseDown: onMouseDown,
                    className: className,
                    disabled: isDisabled
                }), props.children);
            }
        }, {
            key: "_onMouseDownPreventDefault",
            value: function(event) {
                event.preventDefault();
                var onMouseDown = this.props.onMouseDown;
                null != onMouseDown && onMouseDown(event);
            }
        } ]), Button;
    }(_react.Component);
    exports.default = Button;
}, /* 140 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _slicedToArray2 = __webpack_require__(312), _slicedToArray3 = _interopRequireDefault(_slicedToArray2), _from = __webpack_require__(133), _from2 = _interopRequireDefault(_from), _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _objectWithoutProperties2 = __webpack_require__(39), _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2), _getPrototypeOf = __webpack_require__(20), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(14), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(15), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(21), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(22), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(3), _react2 = _interopRequireDefault(_react), _classAutobind = __webpack_require__(30), _classAutobind2 = _interopRequireDefault(_classAutobind), _classnames = __webpack_require__(23), _classnames2 = _interopRequireDefault(_classnames), _Dropdown = __webpack_require__(319), _Dropdown2 = _interopRequireDefault(_Dropdown), Dropdown = function(_Component) {
        function Dropdown() {
            (0, _classCallCheck3.default)(this, Dropdown);
            var _this = (0, _possibleConstructorReturn3.default)(this, (Dropdown.__proto__ || (0, 
            _getPrototypeOf2.default)(Dropdown)).apply(this, arguments));
            return (0, _classAutobind2.default)(_this), _this;
        }
        return (0, _inherits3.default)(Dropdown, _Component), (0, _createClass3.default)(Dropdown, [ {
            key: "render",
            value: function() {
                var _props = this.props, choices = _props.choices, selectedKey = _props.selectedKey, className = _props.className, otherProps = (0, 
                _objectWithoutProperties3.default)(_props, [ "choices", "selectedKey", "className" ]);
                className = (0, _classnames2.default)(className, _Dropdown2.default.root);
                var selectedItem = null == selectedKey ? null : choices.get(selectedKey), selectedValue = selectedItem && selectedItem.label || "";
                return _react2.default.createElement("span", {
                    className: className,
                    title: selectedValue
                }, _react2.default.createElement("select", (0, _extends3.default)({}, otherProps, {
                    value: selectedKey,
                    onChange: this._onChange
                }), this._renderChoices()), _react2.default.createElement("span", {
                    className: _Dropdown2.default.value
                }, selectedValue));
            }
        }, {
            key: "_onChange",
            value: function(event) {
                var value = event.target.value;
                this.props.onChange(value);
            }
        }, {
            key: "_renderChoices",
            value: function() {
                var choices = this.props.choices;
                return (0, _from2.default)(choices.entries()).map(function(_ref) {
                    var _ref2 = (0, _slicedToArray3.default)(_ref, 2), key = _ref2[0], _ref2$ = _ref2[1], label = _ref2$.label, className = _ref2$.className;
                    return _react2.default.createElement("option", {
                        key: key,
                        value: key,
                        className: className
                    }, label);
                });
            }
        } ]), Dropdown;
    }(_react.Component);
    exports.default = Dropdown;
}, /* 141 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _stateFromElement = __webpack_require__(335);
    Object.keys(_stateFromElement).forEach(function(key) {
        "default" !== key && "__esModule" !== key && Object.defineProperty(exports, key, {
            enumerable: !0,
            get: function() {
                return _stateFromElement[key];
            }
        });
    });
}, /* 142 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _SyntheticDOM = __webpack_require__(337);
    Object.keys(_SyntheticDOM).forEach(function(key) {
        "default" !== key && "__esModule" !== key && Object.defineProperty(exports, key, {
            enumerable: !0,
            get: function() {
                return _SyntheticDOM[key];
            }
        });
    });
}, /* 143 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Block Lexer
 */
    function Lexer(options) {
        this.tokens = [], this.tokens.links = {}, this.options = assign({}, options || defaults), 
        this.rules = block.normal, this.options.gfm && (this.rules = block.gfm);
    }
    /**
 * Inline Lexer & Compiler
 */
    function InlineLexer(links, options) {
        if (this.options = assign({}, options || defaults), this.links = links, this.rules = inline.normal, 
        this.renderer = this.options.renderer || new Renderer(), this.renderer.options = this.options, 
        !this.links) throw new Error("Tokens array requires a `links` property.");
        this.options.gfm ? this.options.breaks ? this.rules = inline.breaks : this.rules = inline.gfm : this.options.pedantic && (this.rules = inline.pedantic);
    }
    /**
 * Renderer
 */
    function Renderer(options) {
        this.options = options || {};
    }
    /**
 * Parsing & Compiling
 */
    function Parser(options) {
        this.tokens = [], this.token = null, this.options = assign({}, options || defaults), 
        this.options.renderer = this.options.renderer || new Renderer(), this.renderer = this.options.renderer, 
        this.renderer.options = this.options;
    }
    /**
 * Helpers
 */
    function replace(regex, options) {
        return regex = regex.source, options = options || "", function self(name, val) {
            return name ? (val = val.source || val, val = val.replace(/(^|[^\[])\^/g, "$1"), 
            regex = regex.replace(name, val), self) : new RegExp(regex, options);
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _syntheticDom = __webpack_require__(142), hasOwnProperty = Object.prototype.hasOwnProperty, assign = Object.assign || function(obj) {
        for (var i = 1; i < arguments.length; i++) {
            var target = arguments[i];
            for (var key in target) hasOwnProperty.call(target, key) && (obj[key] = target[key]);
        }
        return obj;
    }, noop = function() {};
    noop.exec = noop;
    var defaults = {
        gfm: !0,
        breaks: !1,
        pedantic: !1,
        smartLists: !1,
        silent: !1,
        langPrefix: "lang-",
        renderer: new Renderer(),
        xhtml: !1
    }, block = {
        newline: /^\n+/,
        code: /^( {4}[^\n]+\n*)+/,
        fences: noop,
        hr: /^( *[-*_]){3,} *(?:\n+|$)/,
        heading: /^ *(#{1,6}) *([^\n]+?) *#* *(?:\n+|$)/,
        nptable: noop,
        lheading: /^([^\n]+)\n *(=|-){2,} *(?:\n+|$)/,
        blockquote: /^( *>[^\n]+(\n(?!def)[^\n]+)*\n*)+/,
        list: /^( *)(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,
        def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +["(]([^\n]+)[")])? *(?:\n+|$)/,
        paragraph: /^((?:[^\n]+\n?(?!hr|heading|lheading|blockquote|def))+)\n*/,
        text: /^[^\n]+/
    };
    block.bullet = /(?:[*+-]|\d+\.)/, block.item = /^( *)(bull) [^\n]*(?:\n(?!\1bull )[^\n]*)*/, 
    block.item = replace(block.item, "gm")(/bull/g, block.bullet)(), block.list = replace(block.list)(/bull/g, block.bullet)("hr", "\\n+(?=\\1?(?:[-*_] *){3,}(?:\\n+|$))")("def", "\\n+(?=" + block.def.source + ")")(), 
    block.blockquote = replace(block.blockquote)("def", block.def)(), block.paragraph = replace(block.paragraph)("hr", block.hr)("heading", block.heading)("lheading", block.lheading)("blockquote", block.blockquote)("def", block.def)(), 
    /**
 * Normal Block Grammar
 */
    block.normal = assign({}, block), /**
 * GFM Block Grammar
 */
    block.gfm = assign({}, block.normal, {
        fences: /^ *(`{3,}|~{3,})[ \.]*(\S+)? *\n([\s\S]+?)\s*\1 *(?:\n+|$)/,
        paragraph: /^/,
        heading: /^ *(#{1,6}) +([^\n]+?) *#* *(?:\n+|$)/
    }), block.gfm.paragraph = replace(block.paragraph)("(?!", "(?!" + block.gfm.fences.source.replace("\\1", "\\2") + "|" + block.list.source.replace("\\1", "\\3") + "|")(), 
    /**
 * Expose Block Rules
 */
    Lexer.rules = block, /**
 * Static Lex Method
 */
    Lexer.parse = function(src, options) {
        return new Lexer(options).parse(src);
    }, /**
 * Preprocessing
 */
    Lexer.prototype.parse = function(src) {
        return src = src.replace(/\r\n|\r/g, "\n").replace(/\t/g, "    ").replace(/\u00a0/g, " ").replace(/\u2424/g, "\n"), 
        this.token(src, !0);
    }, /**
 * Lexing
 */
    Lexer.prototype.token = function(src, top, bq) {
        var next, loose, cap, bull, b, item, space, i, l;
        for (src = src.replace(/^ +$/gm, ""); src; ) // code
        if (// newline
        (cap = this.rules.newline.exec(src)) && (src = src.substring(cap[0].length), cap[0].length > 1 && this.tokens.push({
            type: "space"
        })), cap = this.rules.code.exec(src)) src = src.substring(cap[0].length), cap = cap[0].replace(/^ {4}/gm, ""), 
        this.tokens.push({
            type: "code",
            text: this.options.pedantic ? cap : cap.replace(/\n+$/, "")
        }); else // fences (gfm)
        if (cap = this.rules.fences.exec(src)) src = src.substring(cap[0].length), this.tokens.push({
            type: "code",
            lang: cap[2],
            text: cap[3]
        }); else // heading
        if (cap = this.rules.heading.exec(src)) src = src.substring(cap[0].length), this.tokens.push({
            type: "heading",
            depth: cap[1].length,
            text: cap[2]
        }); else // lheading
        if (cap = this.rules.lheading.exec(src)) src = src.substring(cap[0].length), this.tokens.push({
            type: "heading",
            depth: "=" === cap[2] ? 1 : 2,
            text: cap[1]
        }); else // hr
        if (cap = this.rules.hr.exec(src)) src = src.substring(cap[0].length), this.tokens.push({
            type: "hr"
        }); else // blockquote
        if (cap = this.rules.blockquote.exec(src)) src = src.substring(cap[0].length), this.tokens.push({
            type: "blockquote_start"
        }), cap = cap[0].replace(/^ *> ?/gm, ""), // Pass `top` to keep the current
        // "toplevel" state. This is exactly
        // how markdown.pl works.
        this.token(cap, top, !0), this.tokens.push({
            type: "blockquote_end"
        }); else // list
        if (cap = this.rules.list.exec(src)) {
            for (src = src.substring(cap[0].length), bull = cap[2], this.tokens.push({
                type: "list_start",
                ordered: bull.length > 1
            }), // Get each top-level item.
            cap = cap[0].match(this.rules.item), next = !1, l = cap.length, i = 0; i < l; i++) item = cap[i], 
            // Remove the list item's bullet
            // so it is seen as the next token.
            space = item.length, item = item.replace(/^ *([*+-]|\d+\.) +/, ""), // Outdent whatever the
            // list item contains. Hacky.
            ~item.indexOf("\n ") && (space -= item.length, item = this.options.pedantic ? item.replace(/^ {1,4}/gm, "") : item.replace(new RegExp("^ {1," + space + "}", "gm"), "")), 
            // Determine whether the next list item belongs here.
            // Backpedal if it does not belong in this list.
            this.options.smartLists && i !== l - 1 && (b = block.bullet.exec(cap[i + 1])[0], 
            bull === b || bull.length > 1 && b.length > 1 || (src = cap.slice(i + 1).join("\n") + src, 
            i = l - 1)), // Determine whether item is loose or not.
            // Use: /(^|\n)(?! )[^\n]+\n\n(?!\s*$)/
            // for discount behavior.
            loose = next || /\n\n(?!\s*$)/.test(item), i !== l - 1 && (next = "\n" === item.charAt(item.length - 1), 
            loose || (loose = next)), this.tokens.push({
                type: loose ? "loose_item_start" : "list_item_start"
            }), // Recurse.
            this.token(item, !1, bq), this.tokens.push({
                type: "list_item_end"
            });
            this.tokens.push({
                type: "list_end"
            });
        } else // def
        if (!bq && top && (cap = this.rules.def.exec(src))) src = src.substring(cap[0].length), 
        this.tokens.links[cap[1].toLowerCase()] = {
            href: cap[2],
            title: cap[3]
        }; else // top-level paragraph
        if (top && (cap = this.rules.paragraph.exec(src))) src = src.substring(cap[0].length), 
        this.tokens.push({
            type: "paragraph",
            text: "\n" === cap[1].charAt(cap[1].length - 1) ? cap[1].slice(0, -1) : cap[1]
        }); else // text
        if (cap = this.rules.text.exec(src)) // Top-level should never reach here.
        src = src.substring(cap[0].length), this.tokens.push({
            type: "text",
            text: cap[0]
        }); else if (src) throw new Error("Infinite loop on byte: " + src.charCodeAt(0));
        return this.tokens;
    };
    /**
 * Inline-Level Grammar
 */
    var inline = {
        escape: /^\\([\\`*{}\[\]()#+\-.!_>])/,
        link: /^!?\[(inside)\]\(href\)/,
        reflink: /^!?\[(inside)\]\s*\[([^\]]*)\]/,
        nolink: /^!?\[((?:\[[^\]]*\]|[^\[\]])*)\]/,
        strong: /^__([\s\S]+?)__(?!_)|^\*\*([\s\S]+?)\*\*(?!\*)/,
        em: /^\b_((?:__|[\s\S])+?)_\b|^\*((?:\*\*|[\s\S])+?)\*(?!\*)/,
        code: /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,
        br: /^ {2,}\n(?!\s*$)/,
        del: noop,
        ins: noop,
        text: /^[\s\S]+?(?=[\\<!\[_*`]| {2,}\n|$)/
    };
    inline._inside = /(?:\[[^\]]*\]|[^\[\]]|\](?=[^\[]*\]))*/, inline._href = /\s*<?([\s\S]*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*/, 
    inline.link = replace(inline.link)("inside", inline._inside)("href", inline._href)(), 
    inline.reflink = replace(inline.reflink)("inside", inline._inside)(), /**
 * Normal Inline Grammar
 */
    inline.normal = assign({}, inline), /**
 * Pedantic Inline Grammar
 */
    inline.pedantic = assign({}, inline.normal, {
        strong: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
        em: /^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/
    }), /**
 * GFM Inline Grammar
 */
    inline.gfm = assign({}, inline.normal, {
        escape: replace(inline.escape)("])", "~|])")(),
        del: /^~~(?=\S)([\s\S]*?\S)~~/,
        ins: /^\+\+(?=\S)([\s\S]*?\S)\+\+/,
        text: replace(inline.text)("]|", "~+]|")()
    }), /**
 * GFM + Line Breaks Inline Grammar
 */
    inline.breaks = assign({}, inline.gfm, {
        br: replace(inline.br)("{2,}", "*")(),
        text: replace(inline.gfm.text)("{2,}", "*")()
    }), /**
 * Expose Inline Rules
 */
    InlineLexer.rules = inline, /**
 * Static Lexing/Compiling Method
 */
    InlineLexer.parse = function(src, links, options) {
        return new InlineLexer(links, options).parse(src);
    }, /**
 * Lexing/Compiling
 */
    InlineLexer.prototype.parse = function(src) {
        for (var link, cap, out = new _syntheticDom.FragmentNode(); src; ) // escape
        if (cap = this.rules.escape.exec(src)) src = src.substring(cap[0].length), out.appendChild(new _syntheticDom.TextNode(cap[1])); else // link
        if (cap = this.rules.link.exec(src)) src = src.substring(cap[0].length), this.inLink = !0, 
        out.appendChild(this.outputLink(cap, {
            href: cap[2],
            title: cap[3]
        })), this.inLink = !1; else // reflink, nolink
        if ((cap = this.rules.reflink.exec(src)) || (cap = this.rules.nolink.exec(src))) {
            if (src = src.substring(cap[0].length), link = (cap[2] || cap[1]).replace(/\s+/g, " "), 
            !(link = this.links[link.toLowerCase()]) || !link.href) {
                out.appendChild(new _syntheticDom.TextNode(cap[0].charAt(0))), src = cap[0].substring(1) + src;
                continue;
            }
            this.inLink = !0, out.appendChild(this.outputLink(cap, link)), this.inLink = !1;
        } else // strong
        if (cap = this.rules.strong.exec(src)) src = src.substring(cap[0].length), out.appendChild(this.renderer.strong(this.parse(cap[2] || cap[1]))); else // em
        if (cap = this.rules.em.exec(src)) src = src.substring(cap[0].length), out.appendChild(this.renderer.em(this.parse(cap[2] || cap[1]))); else // code
        if (cap = this.rules.code.exec(src)) src = src.substring(cap[0].length), out.appendChild(this.renderer.codespan(cap[2])); else // br
        if (cap = this.rules.br.exec(src)) src = src.substring(cap[0].length), out.appendChild(this.renderer.br()); else // del (gfm)
        if (cap = this.rules.del.exec(src)) src = src.substring(cap[0].length), out.appendChild(this.renderer.del(this.parse(cap[1]))); else // ins (gfm extended)
        if (cap = this.rules.ins.exec(src)) src = src.substring(cap[0].length), out.appendChild(this.renderer.ins(this.parse(cap[1]))); else // text
        if (cap = this.rules.text.exec(src)) src = src.substring(cap[0].length), out.appendChild(this.renderer.text(new _syntheticDom.TextNode(cap[0]))); else if (src) throw new Error("Infinite loop on byte: " + src.charCodeAt(0));
        return out;
    }, /**
 * Compile Link
 */
    InlineLexer.prototype.outputLink = function(cap, link) {
        var href = link.href, title = link.title;
        return "!" !== cap[0].charAt(0) ? this.renderer.link(href, title, this.parse(cap[1])) : this.renderer.image(href, title, cap[1]);
    }, Renderer.prototype.code = function(childNode, lang) {
        var attributes = [];
        lang && attributes.push({
            name: "class",
            value: this.options.langPrefix + lang
        });
        var codeNode = new _syntheticDom.ElementNode("code", attributes, [ childNode ]);
        return new _syntheticDom.ElementNode("pre", [], [ codeNode ]);
    }, Renderer.prototype.blockquote = function(childNode) {
        return new _syntheticDom.ElementNode("blockquote", [], [ childNode ]);
    }, Renderer.prototype.heading = function(childNode, level) {
        return new _syntheticDom.ElementNode("h" + level, [], [ childNode ]);
    }, Renderer.prototype.hr = function() {
        return new _syntheticDom.ElementNode("hr", [], _syntheticDom.SELF_CLOSING);
    }, Renderer.prototype.list = function(childNode, isOrdered) {
        return new _syntheticDom.ElementNode(isOrdered ? "ol" : "ul", [], [ childNode ]);
    }, Renderer.prototype.listitem = function(childNode) {
        return new _syntheticDom.ElementNode("li", [], [ childNode ]);
    }, Renderer.prototype.paragraph = function(childNode) {
        return new _syntheticDom.ElementNode("p", [], [ childNode ]);
    }, // span level renderer
    Renderer.prototype.strong = function(childNode) {
        return new _syntheticDom.ElementNode("strong", [], [ childNode ]);
    }, Renderer.prototype.em = function(childNode) {
        return new _syntheticDom.ElementNode("em", [], [ childNode ]);
    }, Renderer.prototype.codespan = function(text) {
        return new _syntheticDom.ElementNode("code", [], [ new _syntheticDom.TextNode(text) ]);
    }, Renderer.prototype.br = function() {
        return new _syntheticDom.ElementNode("br", [], _syntheticDom.SELF_CLOSING);
    }, Renderer.prototype.del = function(childNode) {
        return new _syntheticDom.ElementNode("del", [], [ childNode ]);
    }, Renderer.prototype.ins = function(childNode) {
        return new _syntheticDom.ElementNode("ins", [], [ childNode ]);
    }, Renderer.prototype.link = function(href, title, childNode) {
        var attributes = [ {
            name: "href",
            value: href
        } ];
        return title && attributes.push({
            name: "title",
            value: title
        }), new _syntheticDom.ElementNode("a", attributes, [ childNode ]);
    }, Renderer.prototype.image = function(href, title, alt) {
        var attributes = [ {
            name: "src",
            value: href
        } ];
        return title && attributes.push({
            name: "title",
            value: title
        }), alt && attributes.push({
            name: "alt",
            value: alt
        }), new _syntheticDom.ElementNode("img", attributes, _syntheticDom.SELF_CLOSING);
    }, Renderer.prototype.text = function(childNode) {
        return childNode;
    }, /**
 * Static Parse Method
 */
    Parser.parse = function(src, options, renderer) {
        return new Parser(options, renderer).parse(src);
    }, /**
 * Parse Loop
 */
    Parser.prototype.parse = function(src) {
        this.inline = new InlineLexer(src.links, this.options, this.renderer), this.tokens = src.slice().reverse();
        for (var out = new _syntheticDom.FragmentNode(); this.next(); ) out.appendChild(this.tok());
        return out;
    }, /**
 * Next Token
 */
    Parser.prototype.next = function() {
        return this.token = this.tokens.pop();
    }, /**
 * Preview Next Token
 */
    Parser.prototype.peek = function() {
        return this.tokens[this.tokens.length - 1] || 0;
    }, /**
 * Parse Text Tokens
 */
    Parser.prototype.parseText = function() {
        for (var body = this.token.text; "text" === this.peek().type; ) body += "\n" + this.next().text;
        return this.inline.parse(body);
    }, /**
 * Parse Current Token
 */
    Parser.prototype.tok = function() {
        switch (this.token.type) {
          case "space":
            return new _syntheticDom.TextNode("");

          case "hr":
            return this.renderer.hr();

          case "heading":
            return this.renderer.heading(this.inline.parse(this.token.text), this.token.depth);

          case "code":
            return this.renderer.code(this.token.text, this.token.lang);

          case "blockquote_start":
            for (var body = new _syntheticDom.FragmentNode(); "blockquote_end" !== this.next().type; ) body.appendChild(this.tok());
            return this.renderer.blockquote(body);

          case "list_start":
            for (var _body = new _syntheticDom.FragmentNode(), ordered = this.token.ordered; "list_end" !== this.next().type; ) _body.appendChild(this.tok());
            return this.renderer.list(_body, ordered);

          case "list_item_start":
            for (var _body2 = new _syntheticDom.FragmentNode(); "list_item_end" !== this.next().type; ) _body2.appendChild("text" === this.token.type ? this.parseText() : this.tok());
            return this.renderer.listitem(_body2);

          case "loose_item_start":
            for (var _body3 = new _syntheticDom.FragmentNode(); "list_item_end" !== this.next().type; ) _body3.appendChild(this.tok());
            return this.renderer.listitem(_body3);

          case "paragraph":
            return this.renderer.paragraph(this.inline.parse(this.token.text));

          case "text":
            return this.renderer.paragraph(this.parseText());
        }
    };
    var MarkdownParser = {
        parse: function(src, options) {
            options = assign({}, defaults, options);
            try {
                var fragment = Parser.parse(Lexer.parse(src, options), options);
            } catch (e) {
                if (!options.silent) throw e;
                fragment = new _syntheticDom.FragmentNode([ new _syntheticDom.ElementNode("p", [], [ new _syntheticDom.TextNode("An error occured:") ]), new _syntheticDom.ElementNode("pre", [], [ new _syntheticDom.TextNode(e.message) ]) ]);
            }
            return options.getAST ? new _syntheticDom.ElementNode("body", [], [ fragment ]) : fragment.toString(this.options.xhtml);
        }
    };
    exports.default = MarkdownParser;
}, /* 144 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function defaultBlockStyleFn(block) {
        var result = _RichTextEditor2.default.block;
        switch (block.getType()) {
          case "unstyled":
            return (0, _classnames2.default)(result, _RichTextEditor2.default.paragraph);

          case "blockquote":
            return (0, _classnames2.default)(result, _RichTextEditor2.default.blockquote);

          case "code-block":
            return (0, _classnames2.default)(result, _RichTextEditor2.default.codeBlock);

          default:
            return result;
        }
    }
    function createEmptyValue() {
        return _EditorValue2.default.createEmpty(decorator);
    }
    function createValueFromString(markup, format, options) {
        return _EditorValue2.default.createFromString(markup, format, decorator, options);
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.Dropdown = exports.Button = exports.ButtonGroup = exports.createValueFromString = exports.createEmptyValue = exports.decorator = exports.EditorValue = void 0;
    var _assign = __webpack_require__(96), _assign2 = _interopRequireDefault(_assign), _defineProperty2 = __webpack_require__(52), _defineProperty3 = _interopRequireDefault(_defineProperty2), _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _objectWithoutProperties2 = __webpack_require__(39), _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2), _getPrototypeOf = __webpack_require__(20), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(14), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(15), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(21), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(22), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(3), _react2 = _interopRequireDefault(_react), _draftJs = __webpack_require__(10), _getDefaultKeyBinding = __webpack_require__(90), _getDefaultKeyBinding2 = _interopRequireDefault(_getDefaultKeyBinding), _changeBlockDepth = __webpack_require__(265), _changeBlockDepth2 = _interopRequireDefault(_changeBlockDepth), _changeBlockType = __webpack_require__(266), _changeBlockType2 = _interopRequireDefault(_changeBlockType), _getBlocksInSelection = __webpack_require__(267), _getBlocksInSelection2 = _interopRequireDefault(_getBlocksInSelection), _insertBlockAfter = __webpack_require__(268), _insertBlockAfter2 = _interopRequireDefault(_insertBlockAfter), _isListItem = __webpack_require__(269), _isListItem2 = _interopRequireDefault(_isListItem), _isSoftNewlineEvent = __webpack_require__(274), _isSoftNewlineEvent2 = _interopRequireDefault(_isSoftNewlineEvent), _EditorToolbar = __webpack_require__(275), _EditorToolbar2 = _interopRequireDefault(_EditorToolbar), _EditorValue = __webpack_require__(325), _EditorValue2 = _interopRequireDefault(_EditorValue), _LinkDecorator = __webpack_require__(344), _LinkDecorator2 = _interopRequireDefault(_LinkDecorator), _ImageDecorator = __webpack_require__(345), _ImageDecorator2 = _interopRequireDefault(_ImageDecorator), _composite = __webpack_require__(349), _composite2 = _interopRequireDefault(_composite), _classnames = __webpack_require__(23), _classnames2 = _interopRequireDefault(_classnames), _classAutobind = __webpack_require__(30), _classAutobind2 = _interopRequireDefault(_classAutobind), _events = __webpack_require__(350), _events2 = _interopRequireDefault(_events), _draftJsUtils = __webpack_require__(29);
    __webpack_require__(351);
    var _RichTextEditor = __webpack_require__(353), _RichTextEditor2 = _interopRequireDefault(_RichTextEditor), _ButtonGroup = __webpack_require__(95), _ButtonGroup2 = _interopRequireDefault(_ButtonGroup), _Button = __webpack_require__(139), _Button2 = _interopRequireDefault(_Button), _Dropdown = __webpack_require__(140), _Dropdown2 = _interopRequireDefault(_Dropdown), styleMap = {
        CODE: {
            backgroundColor: "#f3f3f3",
            fontFamily: '"Inconsolata", "Menlo", "Consolas", monospace',
            fontSize: 16,
            padding: 2
        }
    }, RichTextEditor = function(_Component) {
        function RichTextEditor() {
            (0, _classCallCheck3.default)(this, RichTextEditor);
            var _this = (0, _possibleConstructorReturn3.default)(this, (RichTextEditor.__proto__ || (0, 
            _getPrototypeOf2.default)(RichTextEditor)).apply(this, arguments));
            return _this._keyEmitter = new _events2.default(), (0, _classAutobind2.default)(_this), 
            _this;
        }
        return (0, _inherits3.default)(RichTextEditor, _Component), (0, _createClass3.default)(RichTextEditor, [ {
            key: "componentDidMount",
            value: function() {
                this.props.autoFocus && this._focus();
            }
        }, {
            key: "render",
            value: function() {
                var _cx, _props = this.props, value = _props.value, className = _props.className, toolbarClassName = _props.toolbarClassName, editorClassName = _props.editorClassName, placeholder = _props.placeholder, customStyleMap = _props.customStyleMap, readOnly = _props.readOnly, disabled = _props.disabled, toolbarConfig = _props.toolbarConfig, blockStyleFn = _props.blockStyleFn, customControls = _props.customControls, keyBindingFn = _props.keyBindingFn, rootStyle = _props.rootStyle, toolbarStyle = _props.toolbarStyle, editorStyle = _props.editorStyle, otherProps = (0, 
                _objectWithoutProperties3.default)(_props, [ "value", "className", "toolbarClassName", "editorClassName", "placeholder", "customStyleMap", "readOnly", "disabled", "toolbarConfig", "blockStyleFn", "customControls", "keyBindingFn", "rootStyle", "toolbarStyle", "editorStyle" ]), editorState = value.getEditorState();
                customStyleMap = customStyleMap ? (0, _extends3.default)({}, styleMap, customStyleMap) : styleMap;
                // If the user changes block type before entering any text, we can either
                // style the placeholder or hide it. Let's just hide it for now.
                var combinedEditorClassName = (0, _classnames2.default)((_cx = {}, (0, _defineProperty3.default)(_cx, _RichTextEditor2.default.editor, !0), 
                (0, _defineProperty3.default)(_cx, _RichTextEditor2.default.hidePlaceholder, this._shouldHidePlaceholder()), 
                _cx), editorClassName);
                null == readOnly && (readOnly = disabled);
                var editorToolbar = void 0;
                return readOnly || (editorToolbar = _react2.default.createElement(_EditorToolbar2.default, {
                    rootStyle: toolbarStyle,
                    className: toolbarClassName,
                    keyEmitter: this._keyEmitter,
                    editorState: editorState,
                    onChange: this._onChange,
                    focusEditor: this._focus,
                    toolbarConfig: toolbarConfig,
                    customControls: customControls
                })), _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_RichTextEditor2.default.root, className),
                    style: rootStyle
                }, editorToolbar, _react2.default.createElement("div", {
                    className: combinedEditorClassName,
                    style: editorStyle
                }, _react2.default.createElement(_draftJs.Editor, (0, _extends3.default)({}, otherProps, {
                    blockStyleFn: (0, _composite2.default)(defaultBlockStyleFn, blockStyleFn),
                    customStyleMap: customStyleMap,
                    editorState: editorState,
                    handleReturn: this._handleReturn,
                    keyBindingFn: keyBindingFn || this._customKeyHandler,
                    handleKeyCommand: this._handleKeyCommand,
                    onTab: this._onTab,
                    onChange: this._onChange,
                    placeholder: placeholder,
                    ref: "editor",
                    spellCheck: !0,
                    readOnly: readOnly
                }))));
            }
        }, {
            key: "_shouldHidePlaceholder",
            value: function() {
                var editorState = this.props.value.getEditorState(), contentState = editorState.getCurrentContent();
                return !contentState.hasText() && "unstyled" !== contentState.getBlockMap().first().getType();
            }
        }, {
            key: "_handleReturn",
            value: function(event) {
                var handleReturn = this.props.handleReturn;
                return !(null == handleReturn || !handleReturn(event)) || (!!this._handleReturnSoftNewline(event) || (!!this._handleReturnEmptyListItem() || !!this._handleReturnSpecialBlock()));
            }
        }, {
            key: "_handleReturnSoftNewline",
            value: function(event) {
                var editorState = this.props.value.getEditorState();
                if ((0, _isSoftNewlineEvent2.default)(event)) {
                    var selection = editorState.getSelection();
                    if (selection.isCollapsed()) this._onChange(_draftJs.RichUtils.insertSoftNewline(editorState)); else {
                        var content = editorState.getCurrentContent(), newContent = _draftJs.Modifier.removeRange(content, selection, "forward"), newSelection = newContent.getSelectionAfter(), _block = newContent.getBlockForKey(newSelection.getStartKey());
                        newContent = _draftJs.Modifier.insertText(newContent, newSelection, "\n", _block.getInlineStyleAt(newSelection.getStartOffset()), null), 
                        this._onChange(_draftJs.EditorState.push(editorState, newContent, "insert-fragment"));
                    }
                    return !0;
                }
                return !1;
            }
        }, {
            key: "_handleReturnEmptyListItem",
            value: function() {
                var editorState = this.props.value.getEditorState(), selection = editorState.getSelection();
                if (selection.isCollapsed()) {
                    var contentState = editorState.getCurrentContent(), blockKey = selection.getStartKey(), _block2 = contentState.getBlockForKey(blockKey);
                    if ((0, _isListItem2.default)(_block2) && 0 === _block2.getLength()) {
                        var depth = _block2.getDepth(), newState = 0 === depth ? (0, _changeBlockType2.default)(editorState, blockKey, _draftJsUtils.BLOCK_TYPE.UNSTYLED) : (0, 
                        _changeBlockDepth2.default)(editorState, blockKey, depth - 1);
                        return this._onChange(newState), !0;
                    }
                }
                return !1;
            }
        }, {
            key: "_handleReturnSpecialBlock",
            value: function() {
                var editorState = this.props.value.getEditorState(), selection = editorState.getSelection();
                if (selection.isCollapsed()) {
                    var contentState = editorState.getCurrentContent(), blockKey = selection.getStartKey(), _block3 = contentState.getBlockForKey(blockKey);
                    if (!(0, _isListItem2.default)(_block3) && _block3.getType() !== _draftJsUtils.BLOCK_TYPE.UNSTYLED && _block3.getLength() === selection.getStartOffset()) {
                        var newEditorState = (0, _insertBlockAfter2.default)(editorState, blockKey, _draftJsUtils.BLOCK_TYPE.UNSTYLED);
                        return this._onChange(newEditorState), !0;
                    }
                }
                return !1;
            }
        }, {
            key: "_onTab",
            value: function(event) {
                var editorState = this.props.value.getEditorState(), newEditorState = _draftJs.RichUtils.onTab(event, editorState, 2);
                newEditorState !== editorState && this._onChange(newEditorState);
            }
        }, {
            key: "_customKeyHandler",
            value: function(event) {
                // Allow toolbar to catch key combinations.
                var eventFlags = {};
                return this._keyEmitter.emit("keypress", event, eventFlags), eventFlags.wasHandled ? null : (0, 
                _getDefaultKeyBinding2.default)(event);
            }
        }, {
            key: "_handleKeyCommand",
            value: function(command) {
                var editorState = this.props.value.getEditorState(), newEditorState = _draftJs.RichUtils.handleKeyCommand(editorState, command);
                return !!newEditorState && (this._onChange(newEditorState), !0);
            }
        }, {
            key: "_onChange",
            value: function(editorState) {
                var _props2 = this.props, onChange = _props2.onChange, value = _props2.value;
                if (null != onChange) {
                    var newValue = value.setEditorState(editorState), newEditorState = newValue.getEditorState();
                    this._handleInlineImageSelection(newEditorState), onChange(newValue);
                }
            }
        }, {
            key: "_handleInlineImageSelection",
            value: function(editorState) {
                var selection = editorState.getSelection(), blocks = (0, _getBlocksInSelection2.default)(editorState), selectImage = function(block, offset) {
                    var imageKey = block.getEntityAt(offset);
                    _draftJs.Entity.mergeData(imageKey, {
                        selected: !0
                    });
                }, isInMiddleBlock = function(index) {
                    return index > 0 && index < blocks.size - 1;
                }, isWithinStartBlockSelection = function(offset, index) {
                    return 0 === index && offset > selection.getStartOffset();
                }, isWithinEndBlockSelection = function(offset, index) {
                    return index === blocks.size - 1 && offset < selection.getEndOffset();
                };
                blocks.toIndexedSeq().forEach(function(block, index) {
                    _ImageDecorator2.default.strategy(block, function(offset) {
                        (isWithinStartBlockSelection(offset, index) || isInMiddleBlock(index) || isWithinEndBlockSelection(offset, index)) && selectImage(block, offset);
                    });
                });
            }
        }, {
            key: "_focus",
            value: function() {
                this.refs.editor.focus();
            }
        } ]), RichTextEditor;
    }(_react.Component);
    exports.default = RichTextEditor;
    var decorator = new _draftJs.CompositeDecorator([ _LinkDecorator2.default, _ImageDecorator2.default ]);
    // $FlowIssue - This should probably not be done this way.
    (0, _assign2.default)(RichTextEditor, {
        EditorValue: _EditorValue2.default,
        decorator: decorator,
        createEmptyValue: createEmptyValue,
        createValueFromString: createValueFromString,
        ButtonGroup: _ButtonGroup2.default,
        Button: _Button2.default,
        Dropdown: _Dropdown2.default
    }), exports.EditorValue = _EditorValue2.default, exports.decorator = decorator, 
    exports.createEmptyValue = createEmptyValue, exports.createValueFromString = createValueFromString, 
    exports.ButtonGroup = _ButtonGroup2.default, exports.Button = _Button2.default, 
    exports.Dropdown = _Dropdown2.default;
}, /* 145 */
/***/
function(module, exports, __webpack_require__) {
    __webpack_require__(146), module.exports = __webpack_require__(4).Object.assign;
}, /* 146 */
/***/
function(module, exports, __webpack_require__) {
    // 19.1.3.1 Object.assign(target, source)
    var $export = __webpack_require__(7);
    $export($export.S + $export.F, "Object", {
        assign: __webpack_require__(147)
    });
}, /* 147 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    // 19.1.2.1 Object.assign(target, source, ...)
    var getKeys = __webpack_require__(48), gOPS = __webpack_require__(73), pIE = __webpack_require__(51), toObject = __webpack_require__(42), IObject = __webpack_require__(66), $assign = Object.assign;
    // should work with symbols and should have deterministic property order (V8 bug)
    module.exports = !$assign || __webpack_require__(32)(function() {
        var A = {}, B = {}, S = Symbol(), K = "abcdefghijklmnopqrst";
        return A[S] = 7, K.split("").forEach(function(k) {
            B[k] = k;
        }), 7 != $assign({}, A)[S] || Object.keys($assign({}, B)).join("") != K;
    }) ? function(target, source) {
        for (// eslint-disable-line no-unused-vars
        var T = toObject(target), aLen = arguments.length, index = 1, getSymbols = gOPS.f, isEnum = pIE.f; aLen > index; ) for (var key, S = IObject(arguments[index++]), keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S), length = keys.length, j = 0; length > j; ) isEnum.call(S, key = keys[j++]) && (T[key] = S[key]);
        return T;
    } : $assign;
}, /* 148 */
/***/
function(module, exports, __webpack_require__) {
    // false -> Array#indexOf
    // true  -> Array#includes
    var toIObject = __webpack_require__(38), toLength = __webpack_require__(49), toAbsoluteIndex = __webpack_require__(149);
    module.exports = function(IS_INCLUDES) {
        return function($this, el, fromIndex) {
            var value, O = toIObject($this), length = toLength(O.length), index = toAbsoluteIndex(fromIndex, length);
            // Array#includes uses SameValueZero equality algorithm
            // eslint-disable-next-line no-self-compare
            if (IS_INCLUDES && el != el) {
                for (;length > index; ) // eslint-disable-next-line no-self-compare
                if ((value = O[index++]) != value) return !0;
            } else for (;length > index; index++) if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
            return !IS_INCLUDES && -1;
        };
    };
}, /* 149 */
/***/
function(module, exports, __webpack_require__) {
    var toInteger = __webpack_require__(69), max = Math.max, min = Math.min;
    module.exports = function(index, length) {
        return index = toInteger(index), index < 0 ? max(index + length, 0) : min(index, length);
    };
}, /* 150 */
/***/
function(module, exports, __webpack_require__) {
    __webpack_require__(151);
    var $Object = __webpack_require__(4).Object;
    module.exports = function(it, key, desc) {
        return $Object.defineProperty(it, key, desc);
    };
}, /* 151 */
/***/
function(module, exports, __webpack_require__) {
    var $export = __webpack_require__(7);
    // 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
    $export($export.S + $export.F * !__webpack_require__(13), "Object", {
        defineProperty: __webpack_require__(9).f
    });
}, /* 152 */
/***/
function(module, exports, __webpack_require__) {
    __webpack_require__(153), module.exports = __webpack_require__(4).Object.getPrototypeOf;
}, /* 153 */
/***/
function(module, exports, __webpack_require__) {
    // 19.1.2.9 Object.getPrototypeOf(O)
    var toObject = __webpack_require__(42), $getPrototypeOf = __webpack_require__(102);
    __webpack_require__(154)("getPrototypeOf", function() {
        return function(it) {
            return $getPrototypeOf(toObject(it));
        };
    });
}, /* 154 */
/***/
function(module, exports, __webpack_require__) {
    // most Object methods by ES6 should accept primitives
    var $export = __webpack_require__(7), core = __webpack_require__(4), fails = __webpack_require__(32);
    module.exports = function(KEY, exec) {
        var fn = (core.Object || {})[KEY] || Object[KEY], exp = {};
        exp[KEY] = exec(fn), $export($export.S + $export.F * fails(function() {
            fn(1);
        }), "Object", exp);
    };
}, /* 155 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = {
        default: __webpack_require__(156),
        __esModule: !0
    };
}, /* 156 */
/***/
function(module, exports, __webpack_require__) {
    __webpack_require__(43), __webpack_require__(55), module.exports = __webpack_require__(77).f("iterator");
}, /* 157 */
/***/
function(module, exports, __webpack_require__) {
    var toInteger = __webpack_require__(69), defined = __webpack_require__(68);
    // true  -> String#at
    // false -> String#codePointAt
    module.exports = function(TO_STRING) {
        return function(that, pos) {
            var a, b, s = String(defined(that)), i = toInteger(pos), l = s.length;
            return i < 0 || i >= l ? TO_STRING ? "" : void 0 : (a = s.charCodeAt(i), a < 55296 || a > 56319 || i + 1 === l || (b = s.charCodeAt(i + 1)) < 56320 || b > 57343 ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : b - 56320 + (a - 55296 << 10) + 65536);
        };
    };
}, /* 158 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    var create = __webpack_require__(53), descriptor = __webpack_require__(41), setToStringTag = __webpack_require__(54), IteratorPrototype = {};
    // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
    __webpack_require__(25)(IteratorPrototype, __webpack_require__(6)("iterator"), function() {
        return this;
    }), module.exports = function(Constructor, NAME, next) {
        Constructor.prototype = create(IteratorPrototype, {
            next: descriptor(1, next)
        }), setToStringTag(Constructor, NAME + " Iterator");
    };
}, /* 159 */
/***/
function(module, exports, __webpack_require__) {
    var dP = __webpack_require__(9), anObject = __webpack_require__(26), getKeys = __webpack_require__(48);
    module.exports = __webpack_require__(13) ? Object.defineProperties : function(O, Properties) {
        anObject(O);
        for (var P, keys = getKeys(Properties), length = keys.length, i = 0; length > i; ) dP.f(O, P = keys[i++], Properties[P]);
        return O;
    };
}, /* 160 */
/***/
function(module, exports, __webpack_require__) {
    var document = __webpack_require__(12).document;
    module.exports = document && document.documentElement;
}, /* 161 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    var addToUnscopables = __webpack_require__(162), step = __webpack_require__(104), Iterators = __webpack_require__(40), toIObject = __webpack_require__(38);
    // 22.1.3.4 Array.prototype.entries()
    // 22.1.3.13 Array.prototype.keys()
    // 22.1.3.29 Array.prototype.values()
    // 22.1.3.30 Array.prototype[@@iterator]()
    module.exports = __webpack_require__(75)(Array, "Array", function(iterated, kind) {
        this._t = toIObject(iterated), // target
        this._i = 0, // next index
        this._k = kind;
    }, function() {
        var O = this._t, kind = this._k, index = this._i++;
        return !O || index >= O.length ? (this._t = void 0, step(1)) : "keys" == kind ? step(0, index) : "values" == kind ? step(0, O[index]) : step(0, [ index, O[index] ]);
    }, "values"), // argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
    Iterators.Arguments = Iterators.Array, addToUnscopables("keys"), addToUnscopables("values"), 
    addToUnscopables("entries");
}, /* 162 */
/***/
function(module, exports) {
    module.exports = function() {};
}, /* 163 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = {
        default: __webpack_require__(164),
        __esModule: !0
    };
}, /* 164 */
/***/
function(module, exports, __webpack_require__) {
    __webpack_require__(165), __webpack_require__(108), __webpack_require__(168), __webpack_require__(169), 
    module.exports = __webpack_require__(4).Symbol;
}, /* 165 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    // ECMAScript 6 symbols shim
    var global = __webpack_require__(12), has = __webpack_require__(33), DESCRIPTORS = __webpack_require__(13), $export = __webpack_require__(7), redefine = __webpack_require__(103), META = __webpack_require__(78).KEY, $fails = __webpack_require__(32), shared = __webpack_require__(71), setToStringTag = __webpack_require__(54), uid = __webpack_require__(50), wks = __webpack_require__(6), wksExt = __webpack_require__(77), wksDefine = __webpack_require__(79), enumKeys = __webpack_require__(166), isArray = __webpack_require__(105), anObject = __webpack_require__(26), toIObject = __webpack_require__(38), toPrimitive = __webpack_require__(65), createDesc = __webpack_require__(41), _create = __webpack_require__(53), gOPNExt = __webpack_require__(167), $GOPD = __webpack_require__(107), $DP = __webpack_require__(9), $keys = __webpack_require__(48), gOPD = $GOPD.f, dP = $DP.f, gOPN = gOPNExt.f, $Symbol = global.Symbol, $JSON = global.JSON, _stringify = $JSON && $JSON.stringify, HIDDEN = wks("_hidden"), TO_PRIMITIVE = wks("toPrimitive"), isEnum = {}.propertyIsEnumerable, SymbolRegistry = shared("symbol-registry"), AllSymbols = shared("symbols"), OPSymbols = shared("op-symbols"), ObjectProto = Object.prototype, USE_NATIVE = "function" == typeof $Symbol, QObject = global.QObject, setter = !QObject || !QObject.prototype || !QObject.prototype.findChild, setSymbolDesc = DESCRIPTORS && $fails(function() {
        return 7 != _create(dP({}, "a", {
            get: function() {
                return dP(this, "a", {
                    value: 7
                }).a;
            }
        })).a;
    }) ? function(it, key, D) {
        var protoDesc = gOPD(ObjectProto, key);
        protoDesc && delete ObjectProto[key], dP(it, key, D), protoDesc && it !== ObjectProto && dP(ObjectProto, key, protoDesc);
    } : dP, wrap = function(tag) {
        var sym = AllSymbols[tag] = _create($Symbol.prototype);
        return sym._k = tag, sym;
    }, isSymbol = USE_NATIVE && "symbol" == typeof $Symbol.iterator ? function(it) {
        return "symbol" == typeof it;
    } : function(it) {
        return it instanceof $Symbol;
    }, $defineProperty = function(it, key, D) {
        return it === ObjectProto && $defineProperty(OPSymbols, key, D), anObject(it), key = toPrimitive(key, !0), 
        anObject(D), has(AllSymbols, key) ? (D.enumerable ? (has(it, HIDDEN) && it[HIDDEN][key] && (it[HIDDEN][key] = !1), 
        D = _create(D, {
            enumerable: createDesc(0, !1)
        })) : (has(it, HIDDEN) || dP(it, HIDDEN, createDesc(1, {})), it[HIDDEN][key] = !0), 
        setSymbolDesc(it, key, D)) : dP(it, key, D);
    }, $defineProperties = function(it, P) {
        anObject(it);
        for (var key, keys = enumKeys(P = toIObject(P)), i = 0, l = keys.length; l > i; ) $defineProperty(it, key = keys[i++], P[key]);
        return it;
    }, $create = function(it, P) {
        return void 0 === P ? _create(it) : $defineProperties(_create(it), P);
    }, $propertyIsEnumerable = function(key) {
        var E = isEnum.call(this, key = toPrimitive(key, !0));
        return !(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) && (!(E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key]) || E);
    }, $getOwnPropertyDescriptor = function(it, key) {
        if (it = toIObject(it), key = toPrimitive(key, !0), it !== ObjectProto || !has(AllSymbols, key) || has(OPSymbols, key)) {
            var D = gOPD(it, key);
            return !D || !has(AllSymbols, key) || has(it, HIDDEN) && it[HIDDEN][key] || (D.enumerable = !0), 
            D;
        }
    }, $getOwnPropertyNames = function(it) {
        for (var key, names = gOPN(toIObject(it)), result = [], i = 0; names.length > i; ) has(AllSymbols, key = names[i++]) || key == HIDDEN || key == META || result.push(key);
        return result;
    }, $getOwnPropertySymbols = function(it) {
        for (var key, IS_OP = it === ObjectProto, names = gOPN(IS_OP ? OPSymbols : toIObject(it)), result = [], i = 0; names.length > i; ) !has(AllSymbols, key = names[i++]) || IS_OP && !has(ObjectProto, key) || result.push(AllSymbols[key]);
        return result;
    };
    // 19.4.1.1 Symbol([description])
    USE_NATIVE || ($Symbol = function() {
        if (this instanceof $Symbol) throw TypeError("Symbol is not a constructor!");
        var tag = uid(arguments.length > 0 ? arguments[0] : void 0), $set = function(value) {
            this === ObjectProto && $set.call(OPSymbols, value), has(this, HIDDEN) && has(this[HIDDEN], tag) && (this[HIDDEN][tag] = !1), 
            setSymbolDesc(this, tag, createDesc(1, value));
        };
        return DESCRIPTORS && setter && setSymbolDesc(ObjectProto, tag, {
            configurable: !0,
            set: $set
        }), wrap(tag);
    }, redefine($Symbol.prototype, "toString", function() {
        return this._k;
    }), $GOPD.f = $getOwnPropertyDescriptor, $DP.f = $defineProperty, __webpack_require__(106).f = gOPNExt.f = $getOwnPropertyNames, 
    __webpack_require__(51).f = $propertyIsEnumerable, __webpack_require__(73).f = $getOwnPropertySymbols, 
    DESCRIPTORS && !__webpack_require__(76) && redefine(ObjectProto, "propertyIsEnumerable", $propertyIsEnumerable, !0), 
    wksExt.f = function(name) {
        return wrap(wks(name));
    }), $export($export.G + $export.W + $export.F * !USE_NATIVE, {
        Symbol: $Symbol
    });
    for (var es6Symbols = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), j = 0; es6Symbols.length > j; ) wks(es6Symbols[j++]);
    for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k; ) wksDefine(wellKnownSymbols[k++]);
    $export($export.S + $export.F * !USE_NATIVE, "Symbol", {
        // 19.4.2.1 Symbol.for(key)
        for: function(key) {
            return has(SymbolRegistry, key += "") ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
        },
        // 19.4.2.5 Symbol.keyFor(sym)
        keyFor: function(sym) {
            if (!isSymbol(sym)) throw TypeError(sym + " is not a symbol!");
            for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
        },
        useSetter: function() {
            setter = !0;
        },
        useSimple: function() {
            setter = !1;
        }
    }), $export($export.S + $export.F * !USE_NATIVE, "Object", {
        // 19.1.2.2 Object.create(O [, Properties])
        create: $create,
        // 19.1.2.4 Object.defineProperty(O, P, Attributes)
        defineProperty: $defineProperty,
        // 19.1.2.3 Object.defineProperties(O, Properties)
        defineProperties: $defineProperties,
        // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
        getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
        // 19.1.2.7 Object.getOwnPropertyNames(O)
        getOwnPropertyNames: $getOwnPropertyNames,
        // 19.1.2.8 Object.getOwnPropertySymbols(O)
        getOwnPropertySymbols: $getOwnPropertySymbols
    }), // 24.3.2 JSON.stringify(value [, replacer [, space]])
    $JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function() {
        var S = $Symbol();
        // MS Edge converts symbol values to JSON as {}
        // WebKit converts symbol values to JSON as null
        // V8 throws on boxed symbols
        return "[null]" != _stringify([ S ]) || "{}" != _stringify({
            a: S
        }) || "{}" != _stringify(Object(S));
    })), "JSON", {
        stringify: function(it) {
            if (void 0 !== it && !isSymbol(it)) {
                for (// IE8 returns string on undefined
                var replacer, $replacer, args = [ it ], i = 1; arguments.length > i; ) args.push(arguments[i++]);
                return replacer = args[1], "function" == typeof replacer && ($replacer = replacer), 
                !$replacer && isArray(replacer) || (replacer = function(key, value) {
                    if ($replacer && (value = $replacer.call(this, key, value)), !isSymbol(value)) return value;
                }), args[1] = replacer, _stringify.apply($JSON, args);
            }
        }
    }), // 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
    $Symbol.prototype[TO_PRIMITIVE] || __webpack_require__(25)($Symbol.prototype, TO_PRIMITIVE, $Symbol.prototype.valueOf), 
    // 19.4.3.5 Symbol.prototype[@@toStringTag]
    setToStringTag($Symbol, "Symbol"), // 20.2.1.9 Math[@@toStringTag]
    setToStringTag(Math, "Math", !0), // 24.3.3 JSON[@@toStringTag]
    setToStringTag(global.JSON, "JSON", !0);
}, /* 166 */
/***/
function(module, exports, __webpack_require__) {
    // all enumerable object keys, includes symbols
    var getKeys = __webpack_require__(48), gOPS = __webpack_require__(73), pIE = __webpack_require__(51);
    module.exports = function(it) {
        var result = getKeys(it), getSymbols = gOPS.f;
        if (getSymbols) for (var key, symbols = getSymbols(it), isEnum = pIE.f, i = 0; symbols.length > i; ) isEnum.call(it, key = symbols[i++]) && result.push(key);
        return result;
    };
}, /* 167 */
/***/
function(module, exports, __webpack_require__) {
    // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
    var toIObject = __webpack_require__(38), gOPN = __webpack_require__(106).f, toString = {}.toString, windowNames = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], getWindowNames = function(it) {
        try {
            return gOPN(it);
        } catch (e) {
            return windowNames.slice();
        }
    };
    module.exports.f = function(it) {
        return windowNames && "[object Window]" == toString.call(it) ? getWindowNames(it) : gOPN(toIObject(it));
    };
}, /* 168 */
/***/
function(module, exports, __webpack_require__) {
    __webpack_require__(79)("asyncIterator");
}, /* 169 */
/***/
function(module, exports, __webpack_require__) {
    __webpack_require__(79)("observable");
}, /* 170 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = {
        default: __webpack_require__(171),
        __esModule: !0
    };
}, /* 171 */
/***/
function(module, exports, __webpack_require__) {
    __webpack_require__(172), module.exports = __webpack_require__(4).Object.setPrototypeOf;
}, /* 172 */
/***/
function(module, exports, __webpack_require__) {
    // 19.1.3.19 Object.setPrototypeOf(O, proto)
    var $export = __webpack_require__(7);
    $export($export.S, "Object", {
        setPrototypeOf: __webpack_require__(173).set
    });
}, /* 173 */
/***/
function(module, exports, __webpack_require__) {
    // Works with __proto__ only. Old v8 can't work with null proto objects.
    /* eslint-disable no-proto */
    var isObject = __webpack_require__(27), anObject = __webpack_require__(26), check = function(O, proto) {
        if (anObject(O), !isObject(proto) && null !== proto) throw TypeError(proto + ": can't set as prototype!");
    };
    module.exports = {
        set: Object.setPrototypeOf || ("__proto__" in {} ? // eslint-disable-line
        function(test, buggy, set) {
            try {
                set = __webpack_require__(31)(Function.call, __webpack_require__(107).f(Object.prototype, "__proto__").set, 2), 
                set(test, []), buggy = !(test instanceof Array);
            } catch (e) {
                buggy = !0;
            }
            return function(O, proto) {
                return check(O, proto), buggy ? O.__proto__ = proto : set(O, proto), O;
            };
        }({}, !1) : void 0),
        check: check
    };
}, /* 174 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = {
        default: __webpack_require__(175),
        __esModule: !0
    };
}, /* 175 */
/***/
function(module, exports, __webpack_require__) {
    __webpack_require__(176);
    var $Object = __webpack_require__(4).Object;
    module.exports = function(P, D) {
        return $Object.create(P, D);
    };
}, /* 176 */
/***/
function(module, exports, __webpack_require__) {
    var $export = __webpack_require__(7);
    // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
    $export($export.S, "Object", {
        create: __webpack_require__(53)
    });
}, /* 177 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule AtomicBlockUtils
 * @typechecks
 * 
 */
    var BlockMapBuilder = __webpack_require__(44), CharacterMetadata = __webpack_require__(11), ContentBlock = __webpack_require__(34), DraftModifier = __webpack_require__(5), EditorState = __webpack_require__(0), Immutable = (__webpack_require__(45), 
    __webpack_require__(1)), generateRandomKey = __webpack_require__(16), moveBlockInContentState = __webpack_require__(191), List = Immutable.List, Repeat = Immutable.Repeat, AtomicBlockUtils = {
        insertAtomicBlock: function(editorState, entityKey, character) {
            var contentState = editorState.getCurrentContent(), selectionState = editorState.getSelection(), afterRemoval = DraftModifier.removeRange(contentState, selectionState, "backward"), targetSelection = afterRemoval.getSelectionAfter(), afterSplit = DraftModifier.splitBlock(afterRemoval, targetSelection), insertionTarget = afterSplit.getSelectionAfter(), asAtomicBlock = DraftModifier.setBlockType(afterSplit, insertionTarget, "atomic"), charData = CharacterMetadata.create({
                entity: entityKey
            }), fragmentArray = [ new ContentBlock({
                key: generateRandomKey(),
                type: "atomic",
                text: character,
                characterList: List(Repeat(charData, character.length))
            }), new ContentBlock({
                key: generateRandomKey(),
                type: "unstyled",
                text: "",
                characterList: List()
            }) ], fragment = BlockMapBuilder.createFromArray(fragmentArray), withAtomicBlock = DraftModifier.replaceWithFragment(asAtomicBlock, insertionTarget, fragment), newContent = withAtomicBlock.merge({
                selectionBefore: selectionState,
                selectionAfter: withAtomicBlock.getSelectionAfter().set("hasFocus", !0)
            });
            return EditorState.push(editorState, newContent, "insert-fragment");
        },
        moveAtomicBlock: function(editorState, atomicBlock, targetRange, insertionMode) {
            var contentState = editorState.getCurrentContent(), selectionState = editorState.getSelection(), withMovedAtomicBlock = void 0;
            if ("before" === insertionMode || "after" === insertionMode) {
                var targetBlock = contentState.getBlockForKey("before" === insertionMode ? targetRange.getStartKey() : targetRange.getEndKey());
                withMovedAtomicBlock = moveBlockInContentState(contentState, atomicBlock, targetBlock, insertionMode);
            } else {
                var afterRemoval = DraftModifier.removeRange(contentState, targetRange, "backward"), selectionAfterRemoval = afterRemoval.getSelectionAfter(), _targetBlock = afterRemoval.getBlockForKey(selectionAfterRemoval.getFocusKey());
                if (0 === selectionAfterRemoval.getStartOffset()) withMovedAtomicBlock = moveBlockInContentState(afterRemoval, atomicBlock, _targetBlock, "before"); else if (selectionAfterRemoval.getEndOffset() === _targetBlock.getLength()) withMovedAtomicBlock = moveBlockInContentState(afterRemoval, atomicBlock, _targetBlock, "after"); else {
                    var afterSplit = DraftModifier.splitBlock(afterRemoval, selectionAfterRemoval), selectionAfterSplit = afterSplit.getSelectionAfter(), _targetBlock2 = afterSplit.getBlockForKey(selectionAfterSplit.getFocusKey());
                    withMovedAtomicBlock = moveBlockInContentState(afterSplit, atomicBlock, _targetBlock2, "before");
                }
            }
            var newContent = withMovedAtomicBlock.merge({
                selectionBefore: selectionState,
                selectionAfter: withMovedAtomicBlock.getSelectionAfter().set("hasFocus", !0)
            });
            return EditorState.push(editorState, newContent, "move-block");
        }
    };
    module.exports = AtomicBlockUtils;
}, /* 178 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function modifyInlineStyle(contentState, selectionState, inlineStyle, addOrRemove) {
        var blockMap = contentState.getBlockMap(), startKey = selectionState.getStartKey(), startOffset = selectionState.getStartOffset(), endKey = selectionState.getEndKey(), endOffset = selectionState.getEndOffset(), newBlocks = blockMap.skipUntil(function(_, k) {
            return k === startKey;
        }).takeUntil(function(_, k) {
            return k === endKey;
        }).concat(Map([ [ endKey, blockMap.get(endKey) ] ])).map(function(block, blockKey) {
            var sliceStart, sliceEnd;
            startKey === endKey ? (sliceStart = startOffset, sliceEnd = endOffset) : (sliceStart = blockKey === startKey ? startOffset : 0, 
            sliceEnd = blockKey === endKey ? endOffset : block.getLength());
            for (var current, chars = block.getCharacterList(); sliceStart < sliceEnd; ) current = chars.get(sliceStart), 
            chars = chars.set(sliceStart, addOrRemove ? CharacterMetadata.applyStyle(current, inlineStyle) : CharacterMetadata.removeStyle(current, inlineStyle)), 
            sliceStart++;
            return block.set("characterList", chars);
        });
        return contentState.merge({
            blockMap: blockMap.merge(newBlocks),
            selectionBefore: selectionState,
            selectionAfter: selectionState
        });
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ContentStateInlineStyle
 * @typechecks
 * 
 */
    var CharacterMetadata = __webpack_require__(11), _require = __webpack_require__(1), Map = _require.Map, ContentStateInlineStyle = {
        add: function(contentState, selectionState, inlineStyle) {
            return modifyInlineStyle(contentState, selectionState, inlineStyle, !0);
        },
        remove: function(contentState, selectionState, inlineStyle) {
            return modifyInlineStyle(contentState, selectionState, inlineStyle, !1);
        }
    };
    module.exports = ContentStateInlineStyle;
}, /* 179 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function applyEntityToContentState(contentState, selectionState, entityKey) {
        var blockMap = contentState.getBlockMap(), startKey = selectionState.getStartKey(), startOffset = selectionState.getStartOffset(), endKey = selectionState.getEndKey(), endOffset = selectionState.getEndOffset(), newBlocks = blockMap.skipUntil(function(_, k) {
            return k === startKey;
        }).takeUntil(function(_, k) {
            return k === endKey;
        }).toOrderedMap().merge(Immutable.OrderedMap([ [ endKey, blockMap.get(endKey) ] ])).map(function(block, blockKey) {
            var sliceStart = blockKey === startKey ? startOffset : 0, sliceEnd = blockKey === endKey ? endOffset : block.getLength();
            return applyEntityToContentBlock(block, sliceStart, sliceEnd, entityKey);
        });
        return contentState.merge({
            blockMap: blockMap.merge(newBlocks),
            selectionBefore: selectionState,
            selectionAfter: selectionState
        });
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule applyEntityToContentState
 * @typechecks
 * 
 */
    var Immutable = __webpack_require__(1), applyEntityToContentBlock = __webpack_require__(180);
    module.exports = applyEntityToContentState;
}, /* 180 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function applyEntityToContentBlock(contentBlock, start, end, entityKey) {
        for (var characterList = contentBlock.getCharacterList(); start < end; ) characterList = characterList.set(start, CharacterMetadata.applyEntity(characterList.get(start), entityKey)), 
        start++;
        return contentBlock.set("characterList", characterList);
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule applyEntityToContentBlock
 * @typechecks
 * 
 */
    var CharacterMetadata = __webpack_require__(11);
    module.exports = applyEntityToContentBlock;
}, /* 181 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Given a SelectionState and a removal direction, determine the entire range
 * that should be removed from a ContentState. This is based on any entities
 * within the target, with their `mutability` values taken into account.
 *
 * For instance, if we are attempting to remove part of an "immutable" entity
 * range, the entire entity must be removed. The returned `SelectionState`
 * will be adjusted accordingly.
 */
    function getCharacterRemovalRange(entityMap, startBlock, endBlock, selectionState, direction) {
        var start = selectionState.getStartOffset(), end = selectionState.getEndOffset(), startEntityKey = startBlock.getEntityAt(start), endEntityKey = endBlock.getEntityAt(end - 1);
        if (!startEntityKey && !endEntityKey) return selectionState;
        var newSelectionState = selectionState;
        if (startEntityKey && startEntityKey === endEntityKey) newSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, !0, !0); else if (startEntityKey && endEntityKey) {
            var startSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, !1, !0), endSelectionState = getEntityRemovalRange(entityMap, endBlock, newSelectionState, direction, endEntityKey, !1, !1);
            newSelectionState = newSelectionState.merge({
                anchorOffset: startSelectionState.getAnchorOffset(),
                focusOffset: endSelectionState.getFocusOffset(),
                isBackward: !1
            });
        } else if (startEntityKey) {
            var _startSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, !1, !0);
            newSelectionState = newSelectionState.merge({
                anchorOffset: _startSelectionState.getStartOffset(),
                isBackward: !1
            });
        } else if (endEntityKey) {
            var _endSelectionState = getEntityRemovalRange(entityMap, endBlock, newSelectionState, direction, endEntityKey, !1, !1);
            newSelectionState = newSelectionState.merge({
                focusOffset: _endSelectionState.getEndOffset(),
                isBackward: !1
            });
        }
        return newSelectionState;
    }
    function getEntityRemovalRange(entityMap, block, selectionState, direction, entityKey, isEntireSelectionWithinEntity, isEntityAtStart) {
        var start = selectionState.getStartOffset(), end = selectionState.getEndOffset(), entity = entityMap.__get(entityKey), mutability = entity.getMutability(), sideToConsider = isEntityAtStart ? start : end;
        // `MUTABLE` entities can just have the specified range of text removed
        // directly. No adjustments are needed.
        if ("MUTABLE" === mutability) return selectionState;
        // Find the entity range that overlaps with our removal range.
        var entityRanges = getRangesForDraftEntity(block, entityKey).filter(function(range) {
            return sideToConsider <= range.end && sideToConsider >= range.start;
        });
        1 != entityRanges.length && invariant(!1);
        var entityRange = entityRanges[0];
        // For `IMMUTABLE` entity types, we will remove the entire entity range.
        if ("IMMUTABLE" === mutability) return selectionState.merge({
            anchorOffset: entityRange.start,
            focusOffset: entityRange.end,
            isBackward: !1
        });
        // For `SEGMENTED` entity types, determine the appropriate segment to
        // remove.
        isEntireSelectionWithinEntity || (isEntityAtStart ? end = entityRange.end : start = entityRange.start);
        var removalRange = DraftEntitySegments.getRemovalRange(start, end, block.getText().slice(entityRange.start, entityRange.end), entityRange.start, direction);
        return selectionState.merge({
            anchorOffset: removalRange.start,
            focusOffset: removalRange.end,
            isBackward: !1
        });
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getCharacterRemovalRange
 * @typechecks
 * 
 */
    var DraftEntitySegments = __webpack_require__(182), getRangesForDraftEntity = __webpack_require__(183), invariant = __webpack_require__(2);
    module.exports = getCharacterRemovalRange;
}, /* 182 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEntitySegments
 * @typechecks
 * 
 */
    /**
 * Identify the range to delete from a segmented entity.
 *
 * Rules:
 *
 *  Example: 'John F. Kennedy'
 *
 *   - Deletion from within any non-whitespace (i.e. ['John', 'F.', 'Kennedy'])
 *     will return the range of that text.
 *
 *       'John F. Kennedy' -> 'John F.'
 *                  ^
 *
 *   - Forward deletion of whitespace will remove the following section:
 *
 *       'John F. Kennedy' -> 'John Kennedy'
 *            ^
 *
 *   - Backward deletion of whitespace will remove the previous section:
 *
 *       'John F. Kennedy' -> 'F. Kennedy'
 *            ^
 */
    var DraftEntitySegments = {
        getRemovalRange: function(selectionStart, selectionEnd, text, entityStart, direction) {
            var segments = text.split(" ");
            segments = segments.map(function(/*string*/ segment, /*number*/ ii) {
                if ("forward" === direction) {
                    if (ii > 0) return " " + segment;
                } else if (ii < segments.length - 1) return segment + " ";
                return segment;
            });
            for (var segmentEnd, segment, segmentStart = entityStart, removalStart = null, removalEnd = null, jj = 0; jj < segments.length; jj++) {
                // Our selection overlaps this segment.
                if (segment = segments[jj], segmentEnd = segmentStart + segment.length, selectionStart < segmentEnd && segmentStart < selectionEnd) null !== removalStart ? removalEnd = segmentEnd : (removalStart = segmentStart, 
                removalEnd = segmentEnd); else if (null !== removalStart) break;
                segmentStart = segmentEnd;
            }
            var entityEnd = entityStart + text.length, atStart = removalStart === entityStart, atEnd = removalEnd === entityEnd;
            return (!atStart && atEnd || atStart && !atEnd) && ("forward" === direction ? removalEnd !== entityEnd && removalEnd++ : removalStart !== entityStart && removalStart--), 
            {
                start: removalStart,
                end: removalEnd
            };
        }
    };
    module.exports = DraftEntitySegments;
}, /* 183 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Obtain the start and end positions of the range that has the
 * specified entity applied to it.
 *
 * Entity keys are applied only to contiguous stretches of text, so this
 * method searches for the first instance of the entity key and returns
 * the subsequent range.
 */
    function getRangesForDraftEntity(block, key) {
        var ranges = [];
        return block.findEntityRanges(function(c) {
            return c.getEntity() === key;
        }, function(start, end) {
            ranges.push({
                start: start,
                end: end
            });
        }), ranges.length || invariant(!1), ranges;
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getRangesForDraftEntity
 * @typechecks
 * 
 */
    var invariant = __webpack_require__(2);
    module.exports = getRangesForDraftEntity;
}, /* 184 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function insertFragmentIntoContentState(contentState, selectionState, fragment) {
        selectionState.isCollapsed() || invariant(!1);
        var finalKey, finalOffset, targetKey = selectionState.getStartKey(), targetOffset = selectionState.getStartOffset(), blockMap = contentState.getBlockMap(), fragmentSize = fragment.size;
        if (1 === fragmentSize) {
            var targetBlock = blockMap.get(targetKey), pastedBlock = fragment.first(), text = targetBlock.getText(), chars = targetBlock.getCharacterList(), newBlock = targetBlock.merge({
                text: text.slice(0, targetOffset) + pastedBlock.getText() + text.slice(targetOffset),
                characterList: insertIntoList(chars, pastedBlock.getCharacterList(), targetOffset),
                data: pastedBlock.getData()
            });
            return blockMap = blockMap.set(targetKey, newBlock), finalKey = targetKey, finalOffset = targetOffset + pastedBlock.getText().length, 
            contentState.merge({
                blockMap: blockMap.set(targetKey, newBlock),
                selectionBefore: selectionState,
                selectionAfter: selectionState.merge({
                    anchorKey: finalKey,
                    anchorOffset: finalOffset,
                    focusKey: finalKey,
                    focusOffset: finalOffset,
                    isBackward: !1
                })
            });
        }
        var newBlockArr = [];
        return contentState.getBlockMap().forEach(function(block, blockKey) {
            if (blockKey !== targetKey) return void newBlockArr.push(block);
            var text = block.getText(), chars = block.getCharacterList(), blockSize = text.length, headText = text.slice(0, targetOffset), headCharacters = chars.slice(0, targetOffset), appendToHead = fragment.first(), modifiedHead = block.merge({
                text: headText + appendToHead.getText(),
                characterList: headCharacters.concat(appendToHead.getCharacterList()),
                type: headText ? block.getType() : appendToHead.getType(),
                data: appendToHead.getData()
            });
            newBlockArr.push(modifiedHead), // Insert fragment blocks after the head and before the tail.
            fragment.slice(1, fragmentSize - 1).forEach(function(fragmentBlock) {
                newBlockArr.push(fragmentBlock.set("key", generateRandomKey()));
            });
            // Modify tail portion of block.
            var tailText = text.slice(targetOffset, blockSize), tailCharacters = chars.slice(targetOffset, blockSize), prependToTail = fragment.last();
            finalKey = generateRandomKey();
            var modifiedTail = prependToTail.merge({
                key: finalKey,
                text: prependToTail.getText() + tailText,
                characterList: prependToTail.getCharacterList().concat(tailCharacters),
                data: prependToTail.getData()
            });
            newBlockArr.push(modifiedTail);
        }), finalOffset = fragment.last().getLength(), contentState.merge({
            blockMap: BlockMapBuilder.createFromArray(newBlockArr),
            selectionBefore: selectionState,
            selectionAfter: selectionState.merge({
                anchorKey: finalKey,
                anchorOffset: finalOffset,
                focusKey: finalKey,
                focusOffset: finalOffset,
                isBackward: !1
            })
        });
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule insertFragmentIntoContentState
 * @typechecks
 * 
 */
    var BlockMapBuilder = __webpack_require__(44), generateRandomKey = __webpack_require__(16), insertIntoList = __webpack_require__(111), invariant = __webpack_require__(2);
    module.exports = insertFragmentIntoContentState;
}, /* 185 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function insertTextIntoContentState(contentState, selectionState, text, characterMetadata) {
        selectionState.isCollapsed() || invariant(!1);
        var len = text.length;
        if (!len) return contentState;
        var blockMap = contentState.getBlockMap(), key = selectionState.getStartKey(), offset = selectionState.getStartOffset(), block = blockMap.get(key), blockText = block.getText(), newBlock = block.merge({
            text: blockText.slice(0, offset) + text + blockText.slice(offset, block.getLength()),
            characterList: insertIntoList(block.getCharacterList(), Repeat(characterMetadata, len).toList(), offset)
        }), newOffset = offset + len;
        return contentState.merge({
            blockMap: blockMap.set(key, newBlock),
            selectionAfter: selectionState.merge({
                anchorOffset: newOffset,
                focusOffset: newOffset
            })
        });
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule insertTextIntoContentState
 * @typechecks
 * 
 */
    var Immutable = __webpack_require__(1), insertIntoList = __webpack_require__(111), invariant = __webpack_require__(2), Repeat = Immutable.Repeat;
    module.exports = insertTextIntoContentState;
}, /* 186 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function modifyBlockForContentState(contentState, selectionState, operation) {
        var startKey = selectionState.getStartKey(), endKey = selectionState.getEndKey(), blockMap = contentState.getBlockMap(), newBlocks = blockMap.toSeq().skipUntil(function(_, k) {
            return k === startKey;
        }).takeUntil(function(_, k) {
            return k === endKey;
        }).concat(Map([ [ endKey, blockMap.get(endKey) ] ])).map(operation);
        return contentState.merge({
            blockMap: blockMap.merge(newBlocks),
            selectionBefore: selectionState,
            selectionAfter: selectionState
        });
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule modifyBlockForContentState
 * @typechecks
 * 
 */
    var Immutable = __webpack_require__(1), Map = Immutable.Map;
    module.exports = modifyBlockForContentState;
}, /* 187 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function removeRangeFromContentState(contentState, selectionState) {
        if (selectionState.isCollapsed()) return contentState;
        var characterList, blockMap = contentState.getBlockMap(), startKey = selectionState.getStartKey(), startOffset = selectionState.getStartOffset(), endKey = selectionState.getEndKey(), endOffset = selectionState.getEndOffset(), startBlock = blockMap.get(startKey), endBlock = blockMap.get(endKey);
        characterList = startBlock === endBlock ? removeFromList(startBlock.getCharacterList(), startOffset, endOffset) : startBlock.getCharacterList().slice(0, startOffset).concat(endBlock.getCharacterList().slice(endOffset));
        var modifiedStart = startBlock.merge({
            text: startBlock.getText().slice(0, startOffset) + endBlock.getText().slice(endOffset),
            characterList: characterList
        }), newBlocks = blockMap.toSeq().skipUntil(function(_, k) {
            return k === startKey;
        }).takeUntil(function(_, k) {
            return k === endKey;
        }).concat(Immutable.Map([ [ endKey, null ] ])).map(function(_, k) {
            return k === startKey ? modifiedStart : null;
        });
        return blockMap = blockMap.merge(newBlocks).filter(function(block) {
            return !!block;
        }), contentState.merge({
            blockMap: blockMap,
            selectionBefore: selectionState,
            selectionAfter: selectionState.merge({
                anchorKey: startKey,
                anchorOffset: startOffset,
                focusKey: startKey,
                focusOffset: startOffset,
                isBackward: !1
            })
        });
    }
    /**
 * Maintain persistence for target list when removing characters on the
 * head and tail of the character list.
 */
    function removeFromList(targetList, startOffset, endOffset) {
        if (0 === startOffset) for (;startOffset < endOffset; ) targetList = targetList.shift(), 
        startOffset++; else if (endOffset === targetList.count()) for (;endOffset > startOffset; ) targetList = targetList.pop(), 
        endOffset--; else {
            var head = targetList.slice(0, startOffset), tail = targetList.slice(endOffset);
            targetList = head.concat(tail).toList();
        }
        return targetList;
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule removeRangeFromContentState
 * 
 */
    var Immutable = __webpack_require__(1);
    module.exports = removeRangeFromContentState;
}, /* 188 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function splitBlockInContentState(contentState, selectionState) {
        selectionState.isCollapsed() || invariant(!1);
        var key = selectionState.getAnchorKey(), offset = selectionState.getAnchorOffset(), blockMap = contentState.getBlockMap(), blockToSplit = blockMap.get(key), text = blockToSplit.getText(), chars = blockToSplit.getCharacterList(), blockAbove = blockToSplit.merge({
            text: text.slice(0, offset),
            characterList: chars.slice(0, offset)
        }), keyBelow = generateRandomKey(), blockBelow = blockAbove.merge({
            key: keyBelow,
            text: text.slice(offset),
            characterList: chars.slice(offset),
            data: Map()
        }), blocksBefore = blockMap.toSeq().takeUntil(function(v) {
            return v === blockToSplit;
        }), blocksAfter = blockMap.toSeq().skipUntil(function(v) {
            return v === blockToSplit;
        }).rest(), newBlocks = blocksBefore.concat([ [ blockAbove.getKey(), blockAbove ], [ blockBelow.getKey(), blockBelow ] ], blocksAfter).toOrderedMap();
        return contentState.merge({
            blockMap: newBlocks,
            selectionBefore: selectionState,
            selectionAfter: selectionState.merge({
                anchorKey: keyBelow,
                anchorOffset: 0,
                focusKey: keyBelow,
                focusOffset: 0,
                isBackward: !1
            })
        });
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule splitBlockInContentState
 * @typechecks
 * 
 */
    var Immutable = __webpack_require__(1), generateRandomKey = __webpack_require__(16), invariant = __webpack_require__(2), Map = Immutable.Map;
    module.exports = splitBlockInContentState;
}, /* 189 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EditorBidiService
 * @typechecks
 * 
 */
    var bidiService, Immutable = __webpack_require__(1), UnicodeBidiService = __webpack_require__(190), nullthrows = __webpack_require__(8), OrderedMap = Immutable.OrderedMap, EditorBidiService = {
        getDirectionMap: function(content, prevBidiMap) {
            bidiService ? bidiService.reset() : bidiService = new UnicodeBidiService();
            var blockMap = content.getBlockMap(), nextBidi = blockMap.valueSeq().map(function(block) {
                return nullthrows(bidiService).getDirection(block.getText());
            }), bidiMap = OrderedMap(blockMap.keySeq().zip(nextBidi));
            return null != prevBidiMap && Immutable.is(prevBidiMap, bidiMap) ? prevBidiMap : bidiMap;
        }
    };
    module.exports = EditorBidiService;
}, /* 190 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 * 
 */
    /**
 * Stateful API for text direction detection
 *
 * This class can be used in applications where you need to detect the
 * direction of a sequence of text blocks, where each direction shall be used
 * as the fallback direction for the next one.
 *
 * NOTE: A default direction, if not provided, is set based on the global
 *       direction, as defined by `UnicodeBidiDirection`.
 *
 * == Example ==
 * ```
 * var UnicodeBidiService = require('UnicodeBidiService');
 *
 * var bidiService = new UnicodeBidiService();
 *
 * ...
 *
 * bidiService.reset();
 * for (var para in paragraphs) {
 *   var dir = bidiService.getDirection(para);
 *   ...
 * }
 * ```
 *
 * Part of our implementation of Unicode Bidirectional Algorithm (UBA)
 * Unicode Standard Annex #9 (UAX9)
 * http://www.unicode.org/reports/tr9/
 */
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    var UnicodeBidi = __webpack_require__(114), UnicodeBidiDirection = __webpack_require__(83), invariant = __webpack_require__(2), UnicodeBidiService = function() {
        /**
   * Stateful class for paragraph direction detection
   *
   * @param defaultDir  Default direction of the service
   */
        function UnicodeBidiService(defaultDir) {
            _classCallCheck(this, UnicodeBidiService), defaultDir ? UnicodeBidiDirection.isStrong(defaultDir) || invariant(!1) : defaultDir = UnicodeBidiDirection.getGlobalDir(), 
            this._defaultDir = defaultDir, this.reset();
        }
        /**
   * Reset the internal state
   *
   * Instead of creating a new instance, you can just reset() your instance
   * everytime you start a new loop.
   */
        /**
   * Returns the direction of a block of text, and remembers it as the
   * fall-back direction for the next paragraph.
   *
   * @param str  A text block, e.g. paragraph, table cell, tag
   * @return     The resolved direction
   */
        return UnicodeBidiService.prototype.reset = function() {
            this._lastDir = this._defaultDir;
        }, UnicodeBidiService.prototype.getDirection = function(str) {
            return this._lastDir = UnicodeBidi.getDirection(str, this._lastDir), this._lastDir;
        }, UnicodeBidiService;
    }();
    module.exports = UnicodeBidiService;
}, /* 191 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function moveBlockInContentState(contentState, blockToBeMoved, targetBlock, insertionMode) {
        blockToBeMoved.getKey() === targetBlock.getKey() && invariant(!1), "replace" === insertionMode && invariant(!1);
        var targetKey = targetBlock.getKey(), blockBefore = contentState.getBlockBefore(targetKey), blockAfter = contentState.getBlockAfter(targetKey), blockMap = contentState.getBlockMap(), blockMapWithoutBlockToBeMoved = blockMap.delete(blockToBeMoved.getKey()), blocksBefore = blockMapWithoutBlockToBeMoved.toSeq().takeUntil(function(v) {
            return v === targetBlock;
        }), blocksAfter = blockMapWithoutBlockToBeMoved.toSeq().skipUntil(function(v) {
            return v === targetBlock;
        }).skip(1), newBlocks = void 0;
        return "before" === insertionMode ? (blockBefore && blockBefore.getKey() === blockToBeMoved.getKey() && invariant(!1), 
        newBlocks = blocksBefore.concat([ [ blockToBeMoved.getKey(), blockToBeMoved ], [ targetBlock.getKey(), targetBlock ] ], blocksAfter).toOrderedMap()) : "after" === insertionMode && (blockAfter && blockAfter.getKey() === blockToBeMoved.getKey() && invariant(!1), 
        newBlocks = blocksBefore.concat([ [ targetBlock.getKey(), targetBlock ], [ blockToBeMoved.getKey(), blockToBeMoved ] ], blocksAfter).toOrderedMap()), 
        contentState.merge({
            blockMap: newBlocks,
            selectionBefore: contentState.getSelectionAfter(),
            selectionAfter: contentState.getSelectionAfter().merge({
                anchorKey: blockToBeMoved.getKey(),
                focusKey: blockToBeMoved.getKey()
            })
        });
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule moveBlockInContentState
 * @typechecks
 * 
 */
    var invariant = __webpack_require__(2);
    module.exports = moveBlockInContentState;
}, /* 192 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule CompositeDraftDecorator
 * @typechecks
 * 
 */
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    /**
 * Determine whether we can occupy the specified slice of the decorations
 * array.
 */
    function canOccupySlice(decorations, start, end) {
        for (var ii = start; ii < end; ii++) if (null != decorations[ii]) return !1;
        return !0;
    }
    /**
 * Splice the specified component into our decoration array at the desired
 * range.
 */
    function occupySlice(targetArr, start, end, componentKey) {
        for (var ii = start; ii < end; ii++) targetArr[ii] = componentKey;
    }
    var Immutable = __webpack_require__(1), List = Immutable.List, CompositeDraftDecorator = function() {
        function CompositeDraftDecorator(decorators) {
            _classCallCheck(this, CompositeDraftDecorator), // Copy the decorator array, since we use this array order to determine
            // precedence of decoration matching. If the array is mutated externally,
            // we don't want to be affected here.
            this._decorators = decorators.slice();
        }
        return CompositeDraftDecorator.prototype.getDecorations = function(block, contentState) {
            var decorations = Array(block.getText().length).fill(null);
            return this._decorators.forEach(function(/*object*/ decorator, /*number*/ ii) {
                var counter = 0;
                (0, decorator.strategy)(block, function(/*number*/ start, /*number*/ end) {
                    // Find out if any of our matching range is already occupied
                    // by another decorator. If so, discard the match. Otherwise, store
                    // the component key for rendering.
                    canOccupySlice(decorations, start, end) && (occupySlice(decorations, start, end, ii + "." + counter), 
                    counter++);
                }, contentState);
            }), List(decorations);
        }, CompositeDraftDecorator.prototype.getComponentForKey = function(key) {
            var componentKey = parseInt(key.split(".")[0], 10);
            return this._decorators[componentKey].component;
        }, CompositeDraftDecorator.prototype.getPropsForKey = function(key) {
            var componentKey = parseInt(key.split(".")[0], 10);
            return this._decorators[componentKey].props;
        }, CompositeDraftDecorator;
    }();
    module.exports = CompositeDraftDecorator;
}, /* 193 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !call || "object" != typeof call && "function" != typeof call ? self : call;
    }
    function _inherits(subClass, superClass) {
        if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditor.react
 * @typechecks
 * 
 * @preventMunge
 */
    var _assign = __webpack_require__(35), _extends = _assign || function(target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
        }
        return target;
    }, DefaultDraftBlockRenderMap = __webpack_require__(84), DefaultDraftInlineStyle = __webpack_require__(115), DraftEditorCompositionHandler = __webpack_require__(194), DraftEditorContents = __webpack_require__(195), DraftEditorDragHandler = __webpack_require__(217), DraftEditorEditHandler = __webpack_require__(220), DraftEditorPlaceholder = __webpack_require__(253), EditorState = __webpack_require__(0), React = __webpack_require__(3), ReactDOM = __webpack_require__(36), Scroll = __webpack_require__(120), Style = __webpack_require__(86), UserAgent = __webpack_require__(17), cx = __webpack_require__(46), emptyFunction = __webpack_require__(80), generateRandomKey = __webpack_require__(16), getDefaultKeyBinding = __webpack_require__(90), getScrollPosition = __webpack_require__(87), invariant = __webpack_require__(2), nullthrows = __webpack_require__(8), isIE = UserAgent.isBrowser("IE"), allowSpellCheck = !isIE, handlerMap = {
        edit: DraftEditorEditHandler,
        composite: DraftEditorCompositionHandler,
        drag: DraftEditorDragHandler,
        cut: null,
        render: null
    }, DraftEditor = function(_React$Component) {
        function DraftEditor(props) {
            _classCallCheck(this, DraftEditor);
            var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
            // Manual binding for public and internal methods.
            // See `_restoreEditorDOM()`.
            return _this._blockSelectEvents = !1, _this._clipboard = null, _this._handler = null, 
            _this._dragCount = 0, _this._editorKey = props.editorKey || generateRandomKey(), 
            _this._placeholderAccessibilityID = "placeholder-" + _this._editorKey, _this._latestEditorState = props.editorState, 
            _this._onBeforeInput = _this._buildHandler("onBeforeInput"), _this._onBlur = _this._buildHandler("onBlur"), 
            _this._onCharacterData = _this._buildHandler("onCharacterData"), _this._onCompositionEnd = _this._buildHandler("onCompositionEnd"), 
            _this._onCompositionStart = _this._buildHandler("onCompositionStart"), _this._onCopy = _this._buildHandler("onCopy"), 
            _this._onCut = _this._buildHandler("onCut"), _this._onDragEnd = _this._buildHandler("onDragEnd"), 
            _this._onDragOver = _this._buildHandler("onDragOver"), _this._onDragStart = _this._buildHandler("onDragStart"), 
            _this._onDrop = _this._buildHandler("onDrop"), _this._onInput = _this._buildHandler("onInput"), 
            _this._onFocus = _this._buildHandler("onFocus"), _this._onKeyDown = _this._buildHandler("onKeyDown"), 
            _this._onKeyPress = _this._buildHandler("onKeyPress"), _this._onKeyUp = _this._buildHandler("onKeyUp"), 
            _this._onMouseDown = _this._buildHandler("onMouseDown"), _this._onMouseUp = _this._buildHandler("onMouseUp"), 
            _this._onPaste = _this._buildHandler("onPaste"), _this._onSelect = _this._buildHandler("onSelect"), 
            _this.focus = _this._focus.bind(_this), _this.blur = _this._blur.bind(_this), _this.setMode = _this._setMode.bind(_this), 
            _this.exitCurrentMode = _this._exitCurrentMode.bind(_this), _this.restoreEditorDOM = _this._restoreEditorDOM.bind(_this), 
            _this.setClipboard = _this._setClipboard.bind(_this), _this.getClipboard = _this._getClipboard.bind(_this), 
            _this.getEditorKey = function() {
                return _this._editorKey;
            }, _this.update = _this._update.bind(_this), _this.onDragEnter = _this._onDragEnter.bind(_this), 
            _this.onDragLeave = _this._onDragLeave.bind(_this), _this.state = {
                contentsKey: 0
            }, _this;
        }
        /**
   * Build a method that will pass the event to the specified handler method.
   * This allows us to look up the correct handler function for the current
   * editor mode, if any has been specified.
   */
        /**
   * Define proxies that can route events to the current handler.
   */
        /**
   * Prevent selection events from affecting the current editor state. This
   * is mostly intended to defend against IE, which fires off `selectionchange`
   * events regardless of whether the selection is set via the browser or
   * programmatically. We only care about selection events that occur because
   * of browser interaction, not re-renders and forced selections.
   */
        /**
   * Used via `this.focus()`.
   *
   * Force focus back onto the editor node.
   *
   * Forcing focus causes the browser to scroll to the top of the editor, which
   * may be undesirable when the editor is taller than the viewport. To solve
   * this, either use a specified scroll position (in cases like `cut` behavior
   * where it should be restored to a known position) or store the current
   * scroll state and put it back in place after focus has been forced.
   */
        /**
   * Used via `this.setMode(...)`.
   *
   * Set the behavior mode for the editor component. This switches the current
   * handler module to ensure that DOM events are managed appropriately for
   * the active mode.
   */
        /**
   * Used via `this.restoreEditorDOM()`.
   *
   * Force a complete re-render of the DraftEditorContents based on the current
   * EditorState. This is useful when we know we are going to lose control of
   * the DOM state (cut command, IME) and we want to make sure that
   * reconciliation occurs on a version of the DOM that is synchronized with
   * our EditorState.
   */
        /**
   * Used via `this.setClipboard(...)`.
   *
   * Set the clipboard state for a cut/copy event.
   */
        /**
   * Used via `this.getClipboard()`.
   *
   * Retrieve the clipboard state for a cut/copy event.
   */
        /**
   * Used via `this.update(...)`.
   *
   * Propagate a new `EditorState` object to higher-level components. This is
   * the method by which event handlers inform the `DraftEditor` component of
   * state changes. A component that composes a `DraftEditor` **must** provide
   * an `onChange` prop to receive state updates passed along from this
   * function.
   */
        /**
   * Used in conjunction with `_onDragLeave()`, by counting the number of times
   * a dragged element enters and leaves the editor (or any of its children),
   * to determine when the dragged element absolutely leaves the editor.
   */
        /**
   * See `_onDragEnter()`.
   */
        return _inherits(DraftEditor, _React$Component), DraftEditor.prototype._buildHandler = function(eventName) {
            var _this2 = this;
            return function(e) {
                if (!_this2.props.readOnly) {
                    var method = _this2._handler && _this2._handler[eventName];
                    method && method(_this2, e);
                }
            };
        }, DraftEditor.prototype._showPlaceholder = function() {
            return !!this.props.placeholder && !this.props.editorState.isInCompositionMode() && !this.props.editorState.getCurrentContent().hasText();
        }, DraftEditor.prototype._renderPlaceholder = function() {
            return this._showPlaceholder() ? React.createElement(DraftEditorPlaceholder, {
                text: nullthrows(this.props.placeholder),
                editorState: this.props.editorState,
                textAlignment: this.props.textAlignment,
                accessibilityID: this._placeholderAccessibilityID
            }) : null;
        }, DraftEditor.prototype.render = function() {
            var _props = this.props, readOnly = _props.readOnly, textAlignment = _props.textAlignment, rootClass = cx({
                "DraftEditor/root": !0,
                "DraftEditor/alignLeft": "left" === textAlignment,
                "DraftEditor/alignRight": "right" === textAlignment,
                "DraftEditor/alignCenter": "center" === textAlignment
            }), contentStyle = {
                outline: "none",
                whiteSpace: "pre-wrap",
                wordWrap: "break-word"
            };
            return React.createElement("div", {
                className: rootClass
            }, this._renderPlaceholder(), React.createElement("div", {
                className: cx("DraftEditor/editorContainer"),
                ref: "editorContainer"
            }, React.createElement("div", {
                "aria-activedescendant": readOnly ? null : this.props.ariaActiveDescendantID,
                "aria-autocomplete": readOnly ? null : this.props.ariaAutoComplete,
                "aria-describedby": this._showPlaceholder() ? this._placeholderAccessibilityID : null,
                "aria-expanded": readOnly ? null : this.props.ariaExpanded,
                "aria-haspopup": readOnly ? null : this.props.ariaHasPopup,
                "aria-label": this.props.ariaLabel,
                "aria-owns": readOnly ? null : this.props.ariaOwneeID,
                autoCapitalize: this.props.autoCapitalize,
                autoComplete: this.props.autoComplete,
                autoCorrect: this.props.autoCorrect,
                className: cx({
                    // Chrome's built-in translation feature mutates the DOM in ways
                    // that Draft doesn't expect (ex: adding <font> tags inside
                    // DraftEditorLeaf spans) and causes problems. We add notranslate
                    // here which makes its autotranslation skip over this subtree.
                    notranslate: !readOnly,
                    "public/DraftEditor/content": !0
                }),
                contentEditable: !readOnly,
                "data-testid": this.props.webDriverTestID,
                onBeforeInput: this._onBeforeInput,
                onBlur: this._onBlur,
                onCompositionEnd: this._onCompositionEnd,
                onCompositionStart: this._onCompositionStart,
                onCopy: this._onCopy,
                onCut: this._onCut,
                onDragEnd: this._onDragEnd,
                onDragEnter: this.onDragEnter,
                onDragLeave: this.onDragLeave,
                onDragOver: this._onDragOver,
                onDragStart: this._onDragStart,
                onDrop: this._onDrop,
                onFocus: this._onFocus,
                onInput: this._onInput,
                onKeyDown: this._onKeyDown,
                onKeyPress: this._onKeyPress,
                onKeyUp: this._onKeyUp,
                onMouseUp: this._onMouseUp,
                onPaste: this._onPaste,
                onSelect: this._onSelect,
                ref: "editor",
                role: readOnly ? null : this.props.role || "textbox",
                spellCheck: allowSpellCheck && this.props.spellCheck,
                style: contentStyle,
                suppressContentEditableWarning: !0,
                tabIndex: this.props.tabIndex
            }, React.createElement(DraftEditorContents, {
                blockRenderMap: this.props.blockRenderMap,
                blockRendererFn: this.props.blockRendererFn,
                blockStyleFn: this.props.blockStyleFn,
                customStyleMap: _extends({}, DefaultDraftInlineStyle, this.props.customStyleMap),
                customStyleFn: this.props.customStyleFn,
                editorKey: this._editorKey,
                editorState: this.props.editorState,
                key: "contents" + this.state.contentsKey,
                textDirectionality: this.props.textDirectionality
            }))));
        }, DraftEditor.prototype.componentDidMount = function() {
            this.setMode("edit"), /**
     * IE has a hardcoded "feature" that attempts to convert link text into
     * anchors in contentEditable DOM. This breaks the editor's expectations of
     * the DOM, and control is lost. Disable it to make IE behave.
     * See: http://blogs.msdn.com/b/ieinternals/archive/2010/09/15/
     * ie9-beta-minor-change-list.aspx
     */
            isIE && document.execCommand("AutoUrlDetect", !1, !1);
        }, DraftEditor.prototype.componentWillUpdate = function(nextProps) {
            this._blockSelectEvents = !0, this._latestEditorState = nextProps.editorState;
        }, DraftEditor.prototype.componentDidUpdate = function() {
            this._blockSelectEvents = !1;
        }, DraftEditor.prototype._focus = function(scrollPosition) {
            var editorState = this.props.editorState, alreadyHasFocus = editorState.getSelection().getHasFocus(), editorNode = ReactDOM.findDOMNode(this.refs.editor), scrollParent = Style.getScrollParent(editorNode), _ref = scrollPosition || getScrollPosition(scrollParent), x = _ref.x, y = _ref.y;
            editorNode instanceof HTMLElement || invariant(!1), editorNode.focus(), scrollParent === window ? window.scrollTo(x, y) : Scroll.setTop(scrollParent, y), 
            // On Chrome and Safari, calling focus on contenteditable focuses the
            // cursor at the first character. This is something you don't expect when
            // you're clicking on an input element but not directly on a character.
            // Put the cursor back where it was before the blur.
            alreadyHasFocus || this.update(EditorState.forceSelection(editorState, editorState.getSelection()));
        }, DraftEditor.prototype._blur = function() {
            var editorNode = ReactDOM.findDOMNode(this.refs.editor);
            editorNode instanceof HTMLElement || invariant(!1), editorNode.blur();
        }, DraftEditor.prototype._setMode = function(mode) {
            this._handler = handlerMap[mode];
        }, DraftEditor.prototype._exitCurrentMode = function() {
            this.setMode("edit");
        }, DraftEditor.prototype._restoreEditorDOM = function(scrollPosition) {
            var _this3 = this;
            this.setState({
                contentsKey: this.state.contentsKey + 1
            }, function() {
                _this3._focus(scrollPosition);
            });
        }, DraftEditor.prototype._setClipboard = function(clipboard) {
            this._clipboard = clipboard;
        }, DraftEditor.prototype._getClipboard = function() {
            return this._clipboard;
        }, DraftEditor.prototype._update = function(editorState) {
            this._latestEditorState = editorState, this.props.onChange(editorState);
        }, DraftEditor.prototype._onDragEnter = function() {
            this._dragCount++;
        }, DraftEditor.prototype._onDragLeave = function() {
            0 === --this._dragCount && this.exitCurrentMode();
        }, DraftEditor;
    }(React.Component);
    DraftEditor.defaultProps = {
        blockRenderMap: DefaultDraftBlockRenderMap,
        blockRendererFn: emptyFunction.thatReturnsNull,
        blockStyleFn: emptyFunction.thatReturns(""),
        keyBindingFn: getDefaultKeyBinding,
        readOnly: !1,
        spellCheck: !1,
        stripPastedStyles: !1
    }, module.exports = DraftEditor;
}, /* 194 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorCompositionHandler
 * 
 */
    var DraftModifier = __webpack_require__(5), EditorState = __webpack_require__(0), Keys = __webpack_require__(59), getEntityKeyForSelection = __webpack_require__(85), isSelectionAtLeafStart = __webpack_require__(116), resolved = !1, stillComposing = !1, textInputData = "", DraftEditorCompositionHandler = {
        onBeforeInput: function(editor, e) {
            textInputData = (textInputData || "") + e.data;
        },
        /**
   * A `compositionstart` event has fired while we're still in composition
   * mode. Continue the current composition session to prevent a re-render.
   */
        onCompositionStart: function(editor) {
            stillComposing = !0;
        },
        /**
   * Attempt to end the current composition session.
   *
   * Defer handling because browser will still insert the chars into active
   * element after `compositionend`. If a `compositionstart` event fires
   * before `resolveComposition` executes, our composition session will
   * continue.
   *
   * The `resolved` flag is useful because certain IME interfaces fire the
   * `compositionend` event multiple times, thus queueing up multiple attempts
   * at handling the composition. Since handling the same composition event
   * twice could break the DOM, we only use the first event. Example: Arabic
   * Google Input Tools on Windows 8.1 fires `compositionend` three times.
   */
        onCompositionEnd: function(editor) {
            resolved = !1, stillComposing = !1, setTimeout(function() {
                resolved || DraftEditorCompositionHandler.resolveComposition(editor);
            }, 20);
        },
        /**
   * In Safari, keydown events may fire when committing compositions. If
   * the arrow keys are used to commit, prevent default so that the cursor
   * doesn't move, otherwise it will jump back noticeably on re-render.
   */
        onKeyDown: function(editor, e) {
            if (!stillComposing) // If a keydown event is received after compositionend but before the
            // 20ms timer expires (ex: type option-E then backspace, or type A then
            // backspace in 2-Set Korean), we should immediately resolve the
            // composition and reinterpret the key press in edit mode.
            return DraftEditorCompositionHandler.resolveComposition(editor), void editor._onKeyDown(e);
            e.which !== Keys.RIGHT && e.which !== Keys.LEFT || e.preventDefault();
        },
        /**
   * Keypress events may fire when committing compositions. In Firefox,
   * pressing RETURN commits the composition and inserts extra newline
   * characters that we do not want. `preventDefault` allows the composition
   * to be committed while preventing the extra characters.
   */
        onKeyPress: function(editor, e) {
            e.which === Keys.RETURN && e.preventDefault();
        },
        /**
   * Attempt to insert composed characters into the document.
   *
   * If we are still in a composition session, do nothing. Otherwise, insert
   * the characters into the document and terminate the composition session.
   *
   * If no characters were composed -- for instance, the user
   * deleted all composed characters and committed nothing new --
   * force a re-render. We also re-render when the composition occurs
   * at the beginning of a leaf, to ensure that if the browser has
   * created a new text node for the composition, we will discard it.
   *
   * Resetting innerHTML will move focus to the beginning of the editor,
   * so we update to force it back to the correct place.
   */
        resolveComposition: function(editor) {
            if (!stillComposing) {
                resolved = !0;
                var composedChars = textInputData;
                textInputData = "";
                var editorState = EditorState.set(editor._latestEditorState, {
                    inCompositionMode: !1
                }), currentStyle = editorState.getCurrentInlineStyle(), entityKey = getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection()), mustReset = !composedChars || isSelectionAtLeafStart(editorState) || currentStyle.size > 0 || null !== entityKey;
                if (mustReset && editor.restoreEditorDOM(), editor.exitCurrentMode(), composedChars) {
                    // If characters have been composed, re-rendering with the update
                    // is sufficient to reset the editor.
                    var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), composedChars, currentStyle, entityKey);
                    return void editor.update(EditorState.push(editorState, contentState, "insert-characters"));
                }
                mustReset && editor.update(EditorState.set(editorState, {
                    nativelyRenderedContent: null,
                    forceSelection: !0
                }));
            }
        }
    };
    module.exports = DraftEditorCompositionHandler;
}, /* 195 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !call || "object" != typeof call && "function" != typeof call ? self : call;
    }
    function _inherits(subClass, superClass) {
        if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
    }
    /**
 * Provide default styling for list items. This way, lists will be styled with
 * proper counters and indentation even if the caller does not specify
 * their own styling at all. If more than five levels of nesting are needed,
 * the necessary CSS classes can be provided via `blockStyleFn` configuration.
 */
    function getListItemClasses(type, depth, shouldResetCount, direction) {
        return cx({
            "public/DraftStyleDefault/unorderedListItem": "unordered-list-item" === type,
            "public/DraftStyleDefault/orderedListItem": "ordered-list-item" === type,
            "public/DraftStyleDefault/reset": shouldResetCount,
            "public/DraftStyleDefault/depth0": 0 === depth,
            "public/DraftStyleDefault/depth1": 1 === depth,
            "public/DraftStyleDefault/depth2": 2 === depth,
            "public/DraftStyleDefault/depth3": 3 === depth,
            "public/DraftStyleDefault/depth4": 4 === depth,
            "public/DraftStyleDefault/listLTR": "LTR" === direction,
            "public/DraftStyleDefault/listRTL": "RTL" === direction
        });
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorContents.react
 * @typechecks
 * 
 */
    var _assign = __webpack_require__(35), _extends = _assign || function(target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
        }
        return target;
    }, DraftEditorBlock = __webpack_require__(117), DraftOffsetKey = __webpack_require__(60), React = (__webpack_require__(0), 
    __webpack_require__(3)), cx = __webpack_require__(46), joinClasses = __webpack_require__(216), nullthrows = __webpack_require__(8), DraftEditorContents = function(_React$Component) {
        function DraftEditorContents() {
            return _classCallCheck(this, DraftEditorContents), _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        return _inherits(DraftEditorContents, _React$Component), DraftEditorContents.prototype.shouldComponentUpdate = function(nextProps) {
            var prevEditorState = this.props.editorState, nextEditorState = nextProps.editorState;
            // Text direction has changed for one or more blocks. We must re-render.
            if (prevEditorState.getDirectionMap() !== nextEditorState.getDirectionMap()) return !0;
            if (prevEditorState.getSelection().getHasFocus() !== nextEditorState.getSelection().getHasFocus()) return !0;
            var nextNativeContent = nextEditorState.getNativelyRenderedContent(), wasComposing = prevEditorState.isInCompositionMode(), nowComposing = nextEditorState.isInCompositionMode();
            // If the state is unchanged or we're currently rendering a natively
            // rendered state, there's nothing new to be done.
            if (prevEditorState === nextEditorState || null !== nextNativeContent && nextEditorState.getCurrentContent() === nextNativeContent || wasComposing && nowComposing) return !1;
            var prevContent = prevEditorState.getCurrentContent(), nextContent = nextEditorState.getCurrentContent(), prevDecorator = prevEditorState.getDecorator(), nextDecorator = nextEditorState.getDecorator();
            return wasComposing !== nowComposing || prevContent !== nextContent || prevDecorator !== nextDecorator || nextEditorState.mustForceSelection();
        }, DraftEditorContents.prototype.render = function() {
            for (var _props = this.props, blockRenderMap = _props.blockRenderMap, blockRendererFn = _props.blockRendererFn, customStyleMap = _props.customStyleMap, customStyleFn = _props.customStyleFn, editorState = _props.editorState, content = editorState.getCurrentContent(), selection = editorState.getSelection(), forceSelection = editorState.mustForceSelection(), decorator = editorState.getDecorator(), directionMap = nullthrows(editorState.getDirectionMap()), blocksAsArray = content.getBlocksAsArray(), processedBlocks = [], currentDepth = null, lastWrapperTemplate = null, ii = 0; ii < blocksAsArray.length; ii++) {
                var _block = blocksAsArray[ii], key = _block.getKey(), blockType = _block.getType(), customRenderer = blockRendererFn(_block), CustomComponent = void 0, customProps = void 0, customEditable = void 0;
                customRenderer && (CustomComponent = customRenderer.component, customProps = customRenderer.props, 
                customEditable = customRenderer.editable);
                var _textDirectionality = this.props.textDirectionality, direction = _textDirectionality || directionMap.get(key), offsetKey = DraftOffsetKey.encode(key, 0, 0), componentProps = {
                    contentState: content,
                    block: _block,
                    blockProps: customProps,
                    customStyleMap: customStyleMap,
                    customStyleFn: customStyleFn,
                    decorator: decorator,
                    direction: direction,
                    forceSelection: forceSelection,
                    key: key,
                    offsetKey: offsetKey,
                    selection: selection,
                    tree: editorState.getBlockTree(key)
                }, configForType = blockRenderMap.get(blockType), wrapperTemplate = configForType.wrapper, _Element = configForType.element || blockRenderMap.get("unstyled").element, depth = _block.getDepth(), className = this.props.blockStyleFn(_block);
                // List items are special snowflakes, since we handle nesting and
                // counters manually.
                if ("li" === _Element) {
                    className = joinClasses(className, getListItemClasses(blockType, depth, lastWrapperTemplate !== wrapperTemplate || null === currentDepth || depth > currentDepth, direction));
                }
                var Component = CustomComponent || DraftEditorBlock, childProps = {
                    className: className,
                    "data-block": !0,
                    "data-editor": this.props.editorKey,
                    "data-offset-key": offsetKey,
                    key: key
                };
                void 0 !== customEditable && (childProps = _extends({}, childProps, {
                    contentEditable: customEditable,
                    suppressContentEditableWarning: !0
                }));
                var child = React.createElement(_Element, childProps, React.createElement(Component, componentProps));
                processedBlocks.push({
                    block: child,
                    wrapperTemplate: wrapperTemplate,
                    key: key,
                    offsetKey: offsetKey
                }), currentDepth = wrapperTemplate ? _block.getDepth() : null, lastWrapperTemplate = wrapperTemplate;
            }
            for (var outputBlocks = [], _ii = 0; _ii < processedBlocks.length; ) {
                var info = processedBlocks[_ii];
                if (info.wrapperTemplate) {
                    var blocks = [];
                    do {
                        blocks.push(processedBlocks[_ii].block), _ii++;
                    } while (_ii < processedBlocks.length && processedBlocks[_ii].wrapperTemplate === info.wrapperTemplate);
                    var wrapperElement = React.cloneElement(info.wrapperTemplate, {
                        key: info.key + "-wrap",
                        "data-offset-key": info.offsetKey
                    }, blocks);
                    outputBlocks.push(wrapperElement);
                } else outputBlocks.push(info.block), _ii++;
            }
            return React.createElement("div", {
                "data-contents": "true"
            }, outputBlocks);
        }, DraftEditorContents;
    }(React.Component);
    module.exports = DraftEditorContents;
}, /* 196 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !call || "object" != typeof call && "function" != typeof call ? self : call;
    }
    function _inherits(subClass, superClass) {
        if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorLeaf.react
 * @typechecks
 * 
 */
    var _assign = __webpack_require__(35), DraftEditorTextNode = (__webpack_require__(34), 
    __webpack_require__(197)), React = __webpack_require__(3), ReactDOM = __webpack_require__(36), invariant = __webpack_require__(2), setDraftEditorSelection = __webpack_require__(204), DraftEditorLeaf = function(_React$Component) {
        function DraftEditorLeaf() {
            return _classCallCheck(this, DraftEditorLeaf), _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        /**
   * By making individual leaf instances aware of their context within
   * the text of the editor, we can set our selection range more
   * easily than we could in the non-React world.
   *
   * Note that this depends on our maintaining tight control over the
   * DOM structure of the DraftEditor component. If leaves had multiple
   * text nodes, this would be harder.
   */
        return _inherits(DraftEditorLeaf, _React$Component), DraftEditorLeaf.prototype._setSelection = function() {
            var selection = this.props.selection;
            // If selection state is irrelevant to the parent block, no-op.
            if (null != selection && selection.getHasFocus()) {
                var _props = this.props, block = _props.block, start = _props.start, text = _props.text, blockKey = block.getKey(), end = start + text.length;
                if (selection.hasEdgeWithin(blockKey, start, end)) {
                    // Determine the appropriate target node for selection. If the child
                    // is not a text node, it is a <br /> spacer. In this case, use the
                    // <span> itself as the selection target.
                    var node = ReactDOM.findDOMNode(this);
                    node || invariant(!1);
                    var child = node.firstChild;
                    child || invariant(!1);
                    var targetNode = void 0;
                    child.nodeType === Node.TEXT_NODE ? targetNode = child : "BR" === child.tagName ? targetNode = node : (targetNode = child.firstChild) || invariant(!1), 
                    setDraftEditorSelection(selection, targetNode, blockKey, start, end);
                }
            }
        }, DraftEditorLeaf.prototype.shouldComponentUpdate = function(nextProps) {
            var leafNode = ReactDOM.findDOMNode(this.refs.leaf);
            return leafNode || invariant(!1), leafNode.textContent !== nextProps.text || nextProps.styleSet !== this.props.styleSet || nextProps.forceSelection;
        }, DraftEditorLeaf.prototype.componentDidUpdate = function() {
            this._setSelection();
        }, DraftEditorLeaf.prototype.componentDidMount = function() {
            this._setSelection();
        }, DraftEditorLeaf.prototype.render = function() {
            var block = this.props.block, text = this.props.text;
            // If the leaf is at the end of its block and ends in a soft newline, append
            // an extra line feed character. Browsers collapse trailing newline
            // characters, which leaves the cursor in the wrong place after a
            // shift+enter. The extra character repairs this.
            text.endsWith("\n") && this.props.isLast && (text += "\n");
            var _props2 = this.props, customStyleMap = _props2.customStyleMap, customStyleFn = _props2.customStyleFn, offsetKey = _props2.offsetKey, styleSet = _props2.styleSet, styleObj = styleSet.reduce(function(map, styleName) {
                var mergedStyles = {}, style = customStyleMap[styleName];
                // .trim() is necessary for IE9/10/11 and Edge
                return void 0 !== style && map.textDecoration !== style.textDecoration && (mergedStyles.textDecoration = [ map.textDecoration, style.textDecoration ].join(" ").trim()), 
                _assign(map, style, mergedStyles);
            }, {});
            if (customStyleFn) {
                var newStyles = customStyleFn(styleSet, block);
                styleObj = _assign(styleObj, newStyles);
            }
            return React.createElement("span", {
                "data-offset-key": offsetKey,
                ref: "leaf",
                style: styleObj
            }, React.createElement(DraftEditorTextNode, null, text));
        }, DraftEditorLeaf;
    }(React.Component);
    module.exports = DraftEditorLeaf;
}, /* 197 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorTextNode.react
 * @typechecks
 * 
 */
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !call || "object" != typeof call && "function" != typeof call ? self : call;
    }
    function _inherits(subClass, superClass) {
        if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
    }
    /**
 * Check whether the node should be considered a newline.
 */
    function isNewline(node) {
        return useNewlineChar ? "\n" === node.textContent : "BR" === node.tagName;
    }
    var React = __webpack_require__(3), ReactDOM = __webpack_require__(36), UserAgent = __webpack_require__(17), invariant = __webpack_require__(2), useNewlineChar = UserAgent.isBrowser("IE <= 11"), NEWLINE_A = useNewlineChar ? React.createElement("span", {
        key: "A",
        "data-text": "true"
    }, "\n") : React.createElement("br", {
        key: "A",
        "data-text": "true"
    }), NEWLINE_B = useNewlineChar ? React.createElement("span", {
        key: "B",
        "data-text": "true"
    }, "\n") : React.createElement("br", {
        key: "B",
        "data-text": "true"
    }), DraftEditorTextNode = function(_React$Component) {
        function DraftEditorTextNode(props) {
            _classCallCheck(this, DraftEditorTextNode);
            var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
            return _this._forceFlag = !1, _this;
        }
        return _inherits(DraftEditorTextNode, _React$Component), DraftEditorTextNode.prototype.shouldComponentUpdate = function(nextProps) {
            var node = ReactDOM.findDOMNode(this), shouldBeNewline = "" === nextProps.children;
            return node instanceof Element || invariant(!1), shouldBeNewline ? !isNewline(node) : node.textContent !== nextProps.children;
        }, DraftEditorTextNode.prototype.componentWillUpdate = function() {
            // By flipping this flag, we also keep flipping keys which forces
            // React to remount this node every time it rerenders.
            this._forceFlag = !this._forceFlag;
        }, DraftEditorTextNode.prototype.render = function() {
            return "" === this.props.children ? this._forceFlag ? NEWLINE_A : NEWLINE_B : React.createElement("span", {
                key: this._forceFlag ? "A" : "B",
                "data-text": "true"
            }, this.props.children);
        }, DraftEditorTextNode;
    }(React.Component);
    module.exports = DraftEditorTextNode;
}, /* 198 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */
    /**
 * Usage note:
 * This module makes a best effort to export the same data we would internally.
 * At Facebook we use a server-generated module that does the parsing and
 * exports the data for the client to use. We can't rely on a server-side
 * implementation in open source so instead we make use of an open source
 * library to do the heavy lifting and then make some adjustments as necessary.
 * It's likely there will be some differences. Some we can smooth over.
 * Others are going to be harder.
 */
    var UAParser = __webpack_require__(199), UNKNOWN = "Unknown", PLATFORM_MAP = {
        "Mac OS": "Mac OS X"
    }, parser = new UAParser(), results = parser.getResult(), browserVersionData = /**
 * Get the version number in parts. This is very naive. We actually get major
 * version as a part of UAParser already, which is generally good enough, but
 * let's get the minor just in case.
 */
    function(version) {
        if (!version) return {
            major: "",
            minor: ""
        };
        var parts = version.split(".");
        return {
            major: parts[0],
            minor: parts[1]
        };
    }(results.browser.version), uaData = {
        browserArchitecture: results.cpu.architecture || UNKNOWN,
        browserFullVersion: results.browser.version || UNKNOWN,
        browserMinorVersion: browserVersionData.minor || UNKNOWN,
        browserName: results.browser.name || UNKNOWN,
        browserVersion: results.browser.major || UNKNOWN,
        deviceName: results.device.model || UNKNOWN,
        engineName: results.engine.name || UNKNOWN,
        engineVersion: results.engine.version || UNKNOWN,
        platformArchitecture: results.cpu.architecture || UNKNOWN,
        platformName: /**
 * Convert from UAParser platform name to what we expect.
 */
        function(name) {
            return PLATFORM_MAP[name] || name;
        }(results.os.name) || UNKNOWN,
        platformVersion: results.os.version || UNKNOWN,
        platformFullVersion: results.os.version || UNKNOWN
    };
    module.exports = uaData;
}, /* 199 */
/***/
function(module, exports, __webpack_require__) {
    var __WEBPACK_AMD_DEFINE_RESULT__;
    /**
 * UAParser.js v0.7.14
 * Lightweight JavaScript-based User-Agent string parser
 * https://github.com/faisalman/ua-parser-js
 *
 * Copyright © 2012-2016 Faisal Salman <fyzlman@gmail.com>
 * Dual licensed under GPLv2 & MIT
 */
    !function(window, undefined) {
        "use strict";
        //////////////
        // Constants
        /////////////
        var // deprecated
        MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", MOBILE = "mobile", TABLET = "tablet", util = {
            extend: function(regexes, extensions) {
                var margedRegexes = {};
                for (var i in regexes) extensions[i] && extensions[i].length % 2 == 0 ? margedRegexes[i] = extensions[i].concat(regexes[i]) : margedRegexes[i] = regexes[i];
                return margedRegexes;
            },
            has: function(str1, str2) {
                return "string" == typeof str1 && -1 !== str2.toLowerCase().indexOf(str1.toLowerCase());
            },
            lowerize: function(str) {
                return str.toLowerCase();
            },
            major: function(version) {
                /**
 * UAParser.js v0.7.14
 * Lightweight JavaScript-based User-Agent string parser
 * https://github.com/faisalman/ua-parser-js
 *
 * Copyright © 2012-2016 Faisal Salman <fyzlman@gmail.com>
 * Dual licensed under GPLv2 & MIT
 */
                return "string" == typeof version ? version.replace(/[^\d\.]/g, "").split(".")[0] : void 0;
            },
            trim: function(str) {
                return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
            }
        }, mapper = {
            rgx: function(ua, arrays) {
                //, args = arguments;
                /*// construct object barebones
            for (p = 0; p < args[1].length; p++) {
                q = args[1][p];
                result[typeof q === OBJ_TYPE ? q[0] : q] = undefined;
            }*/
                // loop through all regexes maps
                for (//var result = {},
                var j, k, p, q, matches, match, i = 0; i < arrays.length && !matches; ) {
                    var regex = arrays[i], // even sequence (0,2,4,..)
                    props = arrays[i + 1];
                    // try matching uastring with regexes
                    for (// odd sequence (1,3,5,..)
                    j = k = 0; j < regex.length && !matches; ) if (matches = regex[j++].exec(ua)) for (p = 0; p < props.length; p++) match = matches[++k], 
                    q = props[p], // check if given property is actually array
                    "object" == typeof q && q.length > 0 ? 2 == q.length ? "function" == typeof q[1] ? // assign modified match
                    this[q[0]] = q[1].call(this, match) : // assign given value, ignore regex match
                    this[q[0]] = q[1] : 3 == q.length ? // check whether function or regex
                    "function" != typeof q[1] || q[1].exec && q[1].test ? // sanitize match using given regex
                    this[q[0]] = match ? match.replace(q[1], q[2]) : void 0 : // call function (usually string mapper)
                    this[q[0]] = match ? q[1].call(this, match, q[2]) : void 0 : 4 == q.length && (this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : void 0) : this[q] = match || void 0;
                    i += 2;
                }
            },
            str: function(str, map) {
                for (var i in map) // check if array
                if ("object" == typeof map[i] && map[i].length > 0) {
                    for (var j = 0; j < map[i].length; j++) if (util.has(map[i][j], str)) return "?" === i ? void 0 : i;
                } else if (util.has(map[i], str)) return "?" === i ? void 0 : i;
                return str;
            }
        }, maps = {
            browser: {
                oldsafari: {
                    version: {
                        "1.0": "/8",
                        "1.2": "/1",
                        "1.3": "/3",
                        "2.0": "/412",
                        "2.0.2": "/416",
                        "2.0.3": "/417",
                        "2.0.4": "/419",
                        "?": "/"
                    }
                }
            },
            device: {
                amazon: {
                    model: {
                        "Fire Phone": [ "SD", "KF" ]
                    }
                },
                sprint: {
                    model: {
                        "Evo Shift 4G": "7373KT"
                    },
                    vendor: {
                        HTC: "APA",
                        Sprint: "Sprint"
                    }
                }
            },
            os: {
                windows: {
                    version: {
                        ME: "4.90",
                        "NT 3.11": "NT3.51",
                        "NT 4.0": "NT4.0",
                        "2000": "NT 5.0",
                        XP: [ "NT 5.1", "NT 5.2" ],
                        Vista: "NT 6.0",
                        "7": "NT 6.1",
                        "8": "NT 6.2",
                        "8.1": "NT 6.3",
                        "10": [ "NT 6.4", "NT 10.0" ],
                        RT: "ARM"
                    }
                }
            }
        }, regexes = {
            browser: [ [ // Presto based
            /(opera\smini)\/([\w\.-]+)/i, // Opera Mini
            /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i, // Opera Mobi/Tablet
            /(opera).+version\/([\w\.]+)/i, // Opera > 9.80
            /(opera)[\/\s]+([\w\.]+)/i ], [ NAME, VERSION ], [ /(opios)[\/\s]+([\w\.]+)/i ], [ [ NAME, "Opera Mini" ], VERSION ], [ /\s(opr)\/([\w\.]+)/i ], [ [ NAME, "Opera" ], VERSION ], [ // Mixed
            /(kindle)\/([\w\.]+)/i, // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]+)*/i, // Lunascape/Maxthon/Netfront/Jasmine/Blazer
            // Trident based
            /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i, // Avant/IEMobile/SlimBrowser/Baidu
            /(?:ms|\()(ie)\s([\w\.]+)/i, // Internet Explorer
            // Webkit/KHTML based
            /(rekonq)\/([\w\.]+)*/i, // Rekonq
            /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser)\/([\w\.-]+)/i ], [ NAME, VERSION ], [ /(trident).+rv[:\s]([\w\.]+).+like\sgecko/i ], [ [ NAME, "IE" ], VERSION ], [ /(edge)\/((\d+)?[\w\.]+)/i ], [ NAME, VERSION ], [ /(yabrowser)\/([\w\.]+)/i ], [ [ NAME, "Yandex" ], VERSION ], [ /(puffin)\/([\w\.]+)/i ], [ [ NAME, "Puffin" ], VERSION ], [ /((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i ], [ [ NAME, "UCBrowser" ], VERSION ], [ /(comodo_dragon)\/([\w\.]+)/i ], [ [ NAME, /_/g, " " ], VERSION ], [ /(micromessenger)\/([\w\.]+)/i ], [ [ NAME, "WeChat" ], VERSION ], [ /(QQ)\/([\d\.]+)/i ], [ NAME, VERSION ], [ /m?(qqbrowser)[\/\s]?([\w\.]+)/i ], [ NAME, VERSION ], [ /xiaomi\/miuibrowser\/([\w\.]+)/i ], [ VERSION, [ NAME, "MIUI Browser" ] ], [ /;fbav\/([\w\.]+);/i ], [ VERSION, [ NAME, "Facebook" ] ], [ /(headlesschrome) ([\w\.]+)/i ], [ VERSION, [ NAME, "Chrome Headless" ] ], [ /\swv\).+(chrome)\/([\w\.]+)/i ], [ [ NAME, /(.+)/, "$1 WebView" ], VERSION ], [ /((?:oculus|samsung)browser)\/([\w\.]+)/i ], [ [ NAME, /(.+(?:g|us))(.+)/, "$1 $2" ], VERSION ], [ // Oculus / Samsung Browser
            /android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i ], [ VERSION, [ NAME, "Android Browser" ] ], [ /(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i ], [ NAME, VERSION ], [ /(dolfin)\/([\w\.]+)/i ], [ [ NAME, "Dolphin" ], VERSION ], [ /((?:android.+)crmo|crios)\/([\w\.]+)/i ], [ [ NAME, "Chrome" ], VERSION ], [ /(coast)\/([\w\.]+)/i ], [ [ NAME, "Opera Coast" ], VERSION ], [ /fxios\/([\w\.-]+)/i ], [ VERSION, [ NAME, "Firefox" ] ], [ /version\/([\w\.]+).+?mobile\/\w+\s(safari)/i ], [ VERSION, [ NAME, "Mobile Safari" ] ], [ /version\/([\w\.]+).+?(mobile\s?safari|safari)/i ], [ VERSION, NAME ], [ /webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i ], [ NAME, [ VERSION, mapper.str, maps.browser.oldsafari.version ] ], [ /(konqueror)\/([\w\.]+)/i, // Konqueror
            /(webkit|khtml)\/([\w\.]+)/i ], [ NAME, VERSION ], [ // Gecko based
            /(navigator|netscape)\/([\w\.-]+)/i ], [ [ NAME, "Netscape" ], VERSION ], [ /(swiftfox)/i, // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i, // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
            /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix)\/([\w\.-]+)/i, // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i, // Mozilla
            // Other
            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i, // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
            /(links)\s\(([\w\.]+)/i, // Links
            /(gobrowser)\/?([\w\.]+)*/i, // GoBrowser
            /(ice\s?browser)\/v?([\w\._]+)/i, // ICE Browser
            /(mosaic)[\/\s]([\w\.]+)/i ], [ NAME, VERSION ] ],
            cpu: [ [ /(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i ], [ [ "architecture", "amd64" ] ], [ /(ia32(?=;))/i ], [ [ "architecture", util.lowerize ] ], [ /((?:i[346]|x)86)[;\)]/i ], [ [ "architecture", "ia32" ] ], [ // PocketPC mistakenly identified as PowerPC
            /windows\s(ce|mobile);\sppc;/i ], [ [ "architecture", "arm" ] ], [ /((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i ], [ [ "architecture", /ower/, "", util.lowerize ] ], [ /(sun4\w)[;\)]/i ], [ [ "architecture", "sparc" ] ], [ /((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+;))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i ], [ [ "architecture", util.lowerize ] ] ],
            device: [ [ /\((ipad|playbook);[\w\s\);-]+(rim|apple)/i ], [ MODEL, VENDOR, [ TYPE, TABLET ] ], [ /applecoremedia\/[\w\.]+ \((ipad)/ ], [ MODEL, [ VENDOR, "Apple" ], [ TYPE, TABLET ] ], [ /(apple\s{0,1}tv)/i ], [ [ MODEL, "Apple TV" ], [ VENDOR, "Apple" ] ], [ /(archos)\s(gamepad2?)/i, // Archos
            /(hp).+(touchpad)/i, // HP TouchPad
            /(hp).+(tablet)/i, // HP Tablet
            /(kindle)\/([\w\.]+)/i, // Kindle
            /\s(nook)[\w\s]+build\/(\w+)/i, // Nook
            /(dell)\s(strea[kpr\s\d]*[\dko])/i ], [ VENDOR, MODEL, [ TYPE, TABLET ] ], [ /(kf[A-z]+)\sbuild\/[\w\.]+.*silk\//i ], [ MODEL, [ VENDOR, "Amazon" ], [ TYPE, TABLET ] ], [ /(sd|kf)[0349hijorstuw]+\sbuild\/[\w\.]+.*silk\//i ], [ [ MODEL, mapper.str, maps.device.amazon.model ], [ VENDOR, "Amazon" ], [ TYPE, MOBILE ] ], [ /\((ip[honed|\s\w*]+);.+(apple)/i ], [ MODEL, VENDOR, [ TYPE, MOBILE ] ], [ /\((ip[honed|\s\w*]+);/i ], [ MODEL, [ VENDOR, "Apple" ], [ TYPE, MOBILE ] ], [ /(blackberry)[\s-]?(\w+)/i, // BlackBerry
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]+)*/i, // BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
            /(hp)\s([\w\s]+\w)/i, // HP iPAQ
            /(asus)-?(\w+)/i ], [ VENDOR, MODEL, [ TYPE, MOBILE ] ], [ /\(bb10;\s(\w+)/i ], [ MODEL, [ VENDOR, "BlackBerry" ], [ TYPE, MOBILE ] ], [ // Asus Tablets
            /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i ], [ MODEL, [ VENDOR, "Asus" ], [ TYPE, TABLET ] ], [ /(sony)\s(tablet\s[ps])\sbuild\//i, // Sony
            /(sony)?(?:sgp.+)\sbuild\//i ], [ [ VENDOR, "Sony" ], [ MODEL, "Xperia Tablet" ], [ TYPE, TABLET ] ], [ /android.+\s([c-g]\d{4}|so[-l]\w+)\sbuild\//i ], [ MODEL, [ VENDOR, "Sony" ], [ TYPE, MOBILE ] ], [ /\s(ouya)\s/i, // Ouya
            /(nintendo)\s([wids3u]+)/i ], [ VENDOR, MODEL, [ TYPE, "console" ] ], [ /android.+;\s(shield)\sbuild/i ], [ MODEL, [ VENDOR, "Nvidia" ], [ TYPE, "console" ] ], [ /(playstation\s[34portablevi]+)/i ], [ MODEL, [ VENDOR, "Sony" ], [ TYPE, "console" ] ], [ /(sprint\s(\w+))/i ], [ [ VENDOR, mapper.str, maps.device.sprint.vendor ], [ MODEL, mapper.str, maps.device.sprint.model ], [ TYPE, MOBILE ] ], [ /(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i ], [ VENDOR, MODEL, [ TYPE, TABLET ] ], [ /(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i, // HTC
            /(zte)-(\w+)*/i, // ZTE
            /(alcatel|geeksphone|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]+)*/i ], [ VENDOR, [ MODEL, /_/g, " " ], [ TYPE, MOBILE ] ], [ /(nexus\s9)/i ], [ MODEL, [ VENDOR, "HTC" ], [ TYPE, TABLET ] ], [ /d\/huawei([\w\s-]+)[;\)]/i, /(nexus\s6p)/i ], [ MODEL, [ VENDOR, "Huawei" ], [ TYPE, MOBILE ] ], [ /(microsoft);\s(lumia[\s\w]+)/i ], [ VENDOR, MODEL, [ TYPE, MOBILE ] ], [ /[\s\(;](xbox(?:\sone)?)[\s\);]/i ], [ MODEL, [ VENDOR, "Microsoft" ], [ TYPE, "console" ] ], [ /(kin\.[onetw]{3})/i ], [ [ MODEL, /\./g, " " ], [ VENDOR, "Microsoft" ], [ TYPE, MOBILE ] ], [ // Motorola
            /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?(:?\s4g)?)[\w\s]+build\//i, /mot[\s-]?(\w+)*/i, /(XT\d{3,4}) build\//i, /(nexus\s6)/i ], [ MODEL, [ VENDOR, "Motorola" ], [ TYPE, MOBILE ] ], [ /android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i ], [ MODEL, [ VENDOR, "Motorola" ], [ TYPE, TABLET ] ], [ /hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i ], [ [ VENDOR, util.trim ], [ MODEL, util.trim ], [ TYPE, "smarttv" ] ], [ /hbbtv.+maple;(\d+)/i ], [ [ MODEL, /^/, "SmartTV" ], [ VENDOR, "Samsung" ], [ TYPE, "smarttv" ] ], [ /\(dtv[\);].+(aquos)/i ], [ MODEL, [ VENDOR, "Sharp" ], [ TYPE, "smarttv" ] ], [ /android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i, /((SM-T\w+))/i ], [ [ VENDOR, "Samsung" ], MODEL, [ TYPE, TABLET ] ], [ // Samsung
            /smart-tv.+(samsung)/i ], [ VENDOR, [ TYPE, "smarttv" ], MODEL ], [ /((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i, /(sam[sung]*)[\s-]*(\w+-?[\w-]*)*/i, /sec-((sgh\w+))/i ], [ [ VENDOR, "Samsung" ], MODEL, [ TYPE, MOBILE ] ], [ /sie-(\w+)*/i ], [ MODEL, [ VENDOR, "Siemens" ], [ TYPE, MOBILE ] ], [ /(maemo|nokia).*(n900|lumia\s\d+)/i, // Nokia
            /(nokia)[\s_-]?([\w-]+)*/i ], [ [ VENDOR, "Nokia" ], MODEL, [ TYPE, MOBILE ] ], [ /android\s3\.[\s\w;-]{10}(a\d{3})/i ], [ MODEL, [ VENDOR, "Acer" ], [ TYPE, TABLET ] ], [ /android.+([vl]k\-?\d{3})\s+build/i ], [ MODEL, [ VENDOR, "LG" ], [ TYPE, TABLET ] ], [ /android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i ], [ [ VENDOR, "LG" ], MODEL, [ TYPE, TABLET ] ], [ /(lg) netcast\.tv/i ], [ VENDOR, MODEL, [ TYPE, "smarttv" ] ], [ /(nexus\s[45])/i, // LG
            /lg[e;\s\/-]+(\w+)*/i, /android.+lg(\-?[\d\w]+)\s+build/i ], [ MODEL, [ VENDOR, "LG" ], [ TYPE, MOBILE ] ], [ /android.+(ideatab[a-z0-9\-\s]+)/i ], [ MODEL, [ VENDOR, "Lenovo" ], [ TYPE, TABLET ] ], [ /linux;.+((jolla));/i ], [ VENDOR, MODEL, [ TYPE, MOBILE ] ], [ /((pebble))app\/[\d\.]+\s/i ], [ VENDOR, MODEL, [ TYPE, "wearable" ] ], [ /android.+;\s(oppo)\s?([\w\s]+)\sbuild/i ], [ VENDOR, MODEL, [ TYPE, MOBILE ] ], [ /crkey/i ], [ [ MODEL, "Chromecast" ], [ VENDOR, "Google" ] ], [ /android.+;\s(glass)\s\d/i ], [ MODEL, [ VENDOR, "Google" ], [ TYPE, "wearable" ] ], [ /android.+;\s(pixel c)\s/i ], [ MODEL, [ VENDOR, "Google" ], [ TYPE, TABLET ] ], [ /android.+;\s(pixel xl|pixel)\s/i ], [ MODEL, [ VENDOR, "Google" ], [ TYPE, MOBILE ] ], [ /android.+(\w+)\s+build\/hm\1/i, // Xiaomi Hongmi 'numeric' models
            /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i, // Xiaomi Hongmi
            /android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d\w)?)\s+build/i ], [ [ MODEL, /_/g, " " ], [ VENDOR, "Xiaomi" ], [ TYPE, MOBILE ] ], [ /android.+;\s(m[1-5]\snote)\sbuild/i ], [ MODEL, [ VENDOR, "Meizu" ], [ TYPE, TABLET ] ], [ /android.+a000(1)\s+build/i ], [ MODEL, [ VENDOR, "OnePlus" ], [ TYPE, MOBILE ] ], [ /android.+[;\/]\s*(RCT[\d\w]+)\s+build/i ], [ MODEL, [ VENDOR, "RCA" ], [ TYPE, TABLET ] ], [ /android.+[;\/]\s*(Venue[\d\s]*)\s+build/i ], [ MODEL, [ VENDOR, "Dell" ], [ TYPE, TABLET ] ], [ /android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i ], [ MODEL, [ VENDOR, "Verizon" ], [ TYPE, TABLET ] ], [ /android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i ], [ [ VENDOR, "Barnes & Noble" ], MODEL, [ TYPE, TABLET ] ], [ /android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i ], [ MODEL, [ VENDOR, "NuVision" ], [ TYPE, TABLET ] ], [ /android.+[;\/]\s*(zte)?.+(k\d{2})\s+build/i ], [ [ VENDOR, "ZTE" ], MODEL, [ TYPE, TABLET ] ], [ /android.+[;\/]\s*(gen\d{3})\s+build.*49h/i ], [ MODEL, [ VENDOR, "Swiss" ], [ TYPE, MOBILE ] ], [ /android.+[;\/]\s*(zur\d{3})\s+build/i ], [ MODEL, [ VENDOR, "Swiss" ], [ TYPE, TABLET ] ], [ /android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i ], [ MODEL, [ VENDOR, "Zeki" ], [ TYPE, TABLET ] ], [ /(android).+[;\/]\s+([YR]\d{2}x?.*)\s+build/i, /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(.+)\s+build/i ], [ [ VENDOR, "Dragon Touch" ], MODEL, [ TYPE, TABLET ] ], [ /android.+[;\/]\s*(NS-?.+)\s+build/i ], [ MODEL, [ VENDOR, "Insignia" ], [ TYPE, TABLET ] ], [ /android.+[;\/]\s*((NX|Next)-?.+)\s+build/i ], [ MODEL, [ VENDOR, "NextBook" ], [ TYPE, TABLET ] ], [ /android.+[;\/]\s*(Xtreme\_?)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i ], [ [ VENDOR, "Voice" ], MODEL, [ TYPE, MOBILE ] ], [ // Voice Xtreme Phones
            /android.+[;\/]\s*(LVTEL\-?)?(V1[12])\s+build/i ], [ [ VENDOR, "LvTel" ], MODEL, [ TYPE, MOBILE ] ], [ /android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i ], [ MODEL, [ VENDOR, "Envizen" ], [ TYPE, TABLET ] ], [ /android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(.*\b)\s+build/i ], [ VENDOR, MODEL, [ TYPE, TABLET ] ], [ /android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i ], [ MODEL, [ VENDOR, "MachSpeed" ], [ TYPE, TABLET ] ], [ /android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i ], [ VENDOR, MODEL, [ TYPE, TABLET ] ], [ /android.+[;\/]\s*TU_(1491)\s+build/i ], [ MODEL, [ VENDOR, "Rotor" ], [ TYPE, TABLET ] ], [ /android.+(KS(.+))\s+build/i ], [ MODEL, [ VENDOR, "Amazon" ], [ TYPE, TABLET ] ], [ /android.+(Gigaset)[\s\-]+(Q.+)\s+build/i ], [ VENDOR, MODEL, [ TYPE, TABLET ] ], [ /\s(tablet|tab)[;\/]/i, // Unidentifiable Tablet
            /\s(mobile)(?:[;\/]|\ssafari)/i ], [ [ TYPE, util.lowerize ], VENDOR, MODEL ], [ /(android.+)[;\/].+build/i ], [ MODEL, [ VENDOR, "Generic" ] ] ],
            engine: [ [ /windows.+\sedge\/([\w\.]+)/i ], [ VERSION, [ NAME, "EdgeHTML" ] ], [ /(presto)\/([\w\.]+)/i, // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m
            /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i, // KHTML/Tasman/Links
            /(icab)[\/\s]([23]\.[\d\.]+)/i ], [ NAME, VERSION ], [ /rv\:([\w\.]+).*(gecko)/i ], [ VERSION, NAME ] ],
            os: [ [ // Windows based
            /microsoft\s(windows)\s(vista|xp)/i ], [ NAME, VERSION ], [ /(windows)\snt\s6\.2;\s(arm)/i, // Windows RT
            /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s]+\w)*/i, // Windows Phone
            /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i ], [ NAME, [ VERSION, mapper.str, maps.os.windows.version ] ], [ /(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i ], [ [ NAME, "Windows" ], [ VERSION, mapper.str, maps.os.windows.version ] ], [ // Mobile/Embedded OS
            /\((bb)(10);/i ], [ [ NAME, "BlackBerry" ], VERSION ], [ /(blackberry)\w*\/?([\w\.]+)*/i, // Blackberry
            /(tizen)[\/\s]([\w\.]+)/i, // Tizen
            /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]+)*/i, // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki
            /linux;.+(sailfish);/i ], [ NAME, VERSION ], [ /(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]+)*/i ], [ [ NAME, "Symbian" ], VERSION ], [ /\((series40);/i ], [ NAME ], [ /mozilla.+\(mobile;.+gecko.+firefox/i ], [ [ NAME, "Firefox OS" ], VERSION ], [ // Console
            /(nintendo|playstation)\s([wids34portablevu]+)/i, // Nintendo/Playstation
            // GNU/Linux based
            /(mint)[\/\s\(]?(\w+)*/i, // Mint
            /(mageia|vectorlinux)[;\s]/i, // Mageia/VectorLinux
            /(joli|[kxln]?ubuntu|debian|[open]*suse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]+)*/i, // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
            // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
            /(hurd|linux)\s?([\w\.]+)*/i, // Hurd/Linux
            /(gnu)\s?([\w\.]+)*/i ], [ NAME, VERSION ], [ /(cros)\s[\w]+\s([\w\.]+\w)/i ], [ [ NAME, "Chromium OS" ], VERSION ], [ // Solaris
            /(sunos)\s?([\w\.]+\d)*/i ], [ [ NAME, "Solaris" ], VERSION ], [ // BSD based
            /\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]+)*/i ], [ NAME, VERSION ], [ /(haiku)\s(\w+)/i ], [ NAME, VERSION ], [ /cfnetwork\/.+darwin/i, /ip[honead]+(?:.*os\s([\w]+)*\slike\smac|;\sopera)/i ], [ [ VERSION, /_/g, "." ], [ NAME, "iOS" ] ], [ /(mac\sos\sx)\s?([\w\s\.]+\w)*/i, /(macintosh|mac(?=_powerpc)\s)/i ], [ [ NAME, "Mac OS" ], [ VERSION, /_/g, "." ] ], [ // Other
            /((?:open)?solaris)[\/\s-]?([\w\.]+)*/i, // Solaris
            /(aix)\s((\d)(?=\.|\)|\s)[\w\.]*)*/i, // AIX
            /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms)/i, // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS
            /(unix)\s?([\w\.]+)*/i ], [ NAME, VERSION ] ]
        }, Browser = function(name, version) {
            this[NAME] = name, this[VERSION] = version;
        }, CPU = function(arch) {
            this.architecture = arch;
        }, Device = function(vendor, model, type) {
            this[VENDOR] = vendor, this[MODEL] = model, this[TYPE] = type;
        }, Engine = Browser, OS = Browser, UAParser = function(uastring, extensions) {
            if ("object" == typeof uastring && (extensions = uastring, uastring = void 0), !(this instanceof UAParser)) return new UAParser(uastring, extensions).getResult();
            var ua = uastring || (window && window.navigator && window.navigator.userAgent ? window.navigator.userAgent : ""), rgxmap = extensions ? util.extend(regexes, extensions) : regexes, browser = new Browser(), cpu = new CPU(), device = new Device(), engine = new Engine(), os = new OS();
            return this.getBrowser = function() {
                // deprecated
                return mapper.rgx.call(browser, ua, rgxmap.browser), browser.major = util.major(browser.version), 
                browser;
            }, this.getCPU = function() {
                return mapper.rgx.call(cpu, ua, rgxmap.cpu), cpu;
            }, this.getDevice = function() {
                return mapper.rgx.call(device, ua, rgxmap.device), device;
            }, this.getEngine = function() {
                return mapper.rgx.call(engine, ua, rgxmap.engine), engine;
            }, this.getOS = function() {
                return mapper.rgx.call(os, ua, rgxmap.os), os;
            }, this.getResult = function() {
                return {
                    ua: this.getUA(),
                    browser: this.getBrowser(),
                    engine: this.getEngine(),
                    os: this.getOS(),
                    device: this.getDevice(),
                    cpu: this.getCPU()
                };
            }, this.getUA = function() {
                return ua;
            }, this.setUA = function(uastring) {
                return ua = uastring, browser = new Browser(), cpu = new CPU(), device = new Device(), 
                engine = new Engine(), os = new OS(), this;
            }, this;
        };
        UAParser.VERSION = "0.7.14", UAParser.BROWSER = {
            NAME: NAME,
            MAJOR: "major",
            // deprecated
            VERSION: VERSION
        }, UAParser.CPU = {
            ARCHITECTURE: "architecture"
        }, UAParser.DEVICE = {
            MODEL: MODEL,
            VENDOR: VENDOR,
            TYPE: TYPE,
            CONSOLE: "console",
            MOBILE: MOBILE,
            SMARTTV: "smarttv",
            TABLET: TABLET,
            WEARABLE: "wearable",
            EMBEDDED: "embedded"
        }, UAParser.ENGINE = {
            NAME: NAME,
            VERSION: VERSION
        }, UAParser.OS = {
            NAME: NAME,
            VERSION: VERSION
        }, //UAParser.Utils = util;
        ///////////
        // Export
        //////////
        // check js environment
        void 0 !== exports ? (// nodejs env
        void 0 !== module && module.exports && (exports = module.exports = UAParser), exports.UAParser = UAParser) : // requirejs env (optional)
        __webpack_require__(200) ? void 0 !== (__WEBPACK_AMD_DEFINE_RESULT__ = function() {
            return UAParser;
        }.call(exports, __webpack_require__, exports, module)) && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__) : window && (// browser env
        window.UAParser = UAParser);
        // jQuery/Zepto specific (optional)
        // Note:
        //   In AMD env the global scope should be kept clean, but jQuery is an exception.
        //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
        //   and we should catch that.
        var $ = window && (window.jQuery || window.Zepto);
        if (void 0 !== $) {
            var parser = new UAParser();
            $.ua = parser.getResult(), $.ua.get = function() {
                return parser.getUA();
            }, $.ua.set = function(uastring) {
                parser.setUA(uastring);
                var result = parser.getResult();
                for (var prop in result) $.ua[prop] = result[prop];
            };
        }
    }("object" == typeof window ? window : this);
}, /* 200 */
/***/
function(module, exports) {
    /* WEBPACK VAR INJECTION */
    (function(__webpack_amd_options__) {
        /* globals __webpack_amd_options__ */
        module.exports = __webpack_amd_options__;
    }).call(exports, {});
}, /* 201 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Splits input `range` on "||" and returns true if any subrange matches
 * `version`.
 *
 * @param {string} range
 * @param {string} version
 * @returns {boolean}
 */
    function checkOrExpression(range, version) {
        var expressions = range.split(orRegex);
        return expressions.length > 1 ? expressions.some(function(range) {
            return VersionRange.contains(range, version);
        }) : (range = expressions[0].trim(), checkRangeExpression(range, version));
    }
    /**
 * Splits input `range` on " - " (the surrounding whitespace is required) and
 * returns true if version falls between the two operands.
 *
 * @param {string} range
 * @param {string} version
 * @returns {boolean}
 */
    function checkRangeExpression(range, version) {
        var expressions = range.split(rangeRegex);
        if (expressions.length > 0 && expressions.length <= 2 || invariant(!1), 1 === expressions.length) return checkSimpleExpression(expressions[0], version);
        var startVersion = expressions[0], endVersion = expressions[1];
        return isSimpleVersion(startVersion) && isSimpleVersion(endVersion) || invariant(!1), 
        checkSimpleExpression(">=" + startVersion, version) && checkSimpleExpression("<=" + endVersion, version);
    }
    /**
 * Checks if `range` matches `version`. `range` should be a "simple" range (ie.
 * not a compound range using the " - " or "||" operators).
 *
 * @param {string} range
 * @param {string} version
 * @returns {boolean}
 */
    function checkSimpleExpression(range, version) {
        if ("" === (range = range.trim())) return !0;
        var versionComponents = version.split(componentRegex), _getModifierAndCompon = getModifierAndComponents(range), modifier = _getModifierAndCompon.modifier, rangeComponents = _getModifierAndCompon.rangeComponents;
        switch (modifier) {
          case "<":
            return checkLessThan(versionComponents, rangeComponents);

          case "<=":
            return checkLessThanOrEqual(versionComponents, rangeComponents);

          case ">=":
            return checkGreaterThanOrEqual(versionComponents, rangeComponents);

          case ">":
            return checkGreaterThan(versionComponents, rangeComponents);

          case "~":
          case "~>":
            return checkApproximateVersion(versionComponents, rangeComponents);

          default:
            return checkEqual(versionComponents, rangeComponents);
        }
    }
    /**
 * Checks whether `a` is less than `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
    function checkLessThan(a, b) {
        return -1 === compareComponents(a, b);
    }
    /**
 * Checks whether `a` is less than or equal to `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
    function checkLessThanOrEqual(a, b) {
        var result = compareComponents(a, b);
        return -1 === result || 0 === result;
    }
    /**
 * Checks whether `a` is equal to `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
    function checkEqual(a, b) {
        return 0 === compareComponents(a, b);
    }
    /**
 * Checks whether `a` is greater than or equal to `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
    function checkGreaterThanOrEqual(a, b) {
        var result = compareComponents(a, b);
        return 1 === result || 0 === result;
    }
    /**
 * Checks whether `a` is greater than `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
    function checkGreaterThan(a, b) {
        return 1 === compareComponents(a, b);
    }
    /**
 * Checks whether `a` is "reasonably close" to `b` (as described in
 * https://www.npmjs.org/doc/misc/semver.html). For example, if `b` is "1.3.1"
 * then "reasonably close" is defined as ">= 1.3.1 and < 1.4".
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
    function checkApproximateVersion(a, b) {
        var lowerBound = b.slice(), upperBound = b.slice();
        upperBound.length > 1 && upperBound.pop();
        var lastIndex = upperBound.length - 1, numeric = parseInt(upperBound[lastIndex], 10);
        return isNumber(numeric) && (upperBound[lastIndex] = numeric + 1 + ""), checkGreaterThanOrEqual(a, lowerBound) && checkLessThan(a, upperBound);
    }
    /**
 * Extracts the optional modifier (<, <=, =, >=, >, ~, ~>) and version
 * components from `range`.
 *
 * For example, given `range` ">= 1.2.3" returns an object with a `modifier` of
 * `">="` and `components` of `[1, 2, 3]`.
 *
 * @param {string} range
 * @returns {object}
 */
    function getModifierAndComponents(range) {
        var rangeComponents = range.split(componentRegex), matches = rangeComponents[0].match(modifierRegex);
        return matches || invariant(!1), {
            modifier: matches[1],
            rangeComponents: [ matches[2] ].concat(rangeComponents.slice(1))
        };
    }
    /**
 * Determines if `number` is a number.
 *
 * @param {mixed} number
 * @returns {boolean}
 */
    function isNumber(number) {
        return !isNaN(number) && isFinite(number);
    }
    /**
 * Tests whether `range` is a "simple" version number without any modifiers
 * (">", "~" etc).
 *
 * @param {string} range
 * @returns {boolean}
 */
    function isSimpleVersion(range) {
        return !getModifierAndComponents(range).modifier;
    }
    /**
 * Zero-pads array `array` until it is at least `length` long.
 *
 * @param {array} array
 * @param {number} length
 */
    function zeroPad(array, length) {
        for (var i = array.length; i < length; i++) array[i] = "0";
    }
    /**
 * Normalizes `a` and `b` in preparation for comparison by doing the following:
 *
 * - zero-pads `a` and `b`
 * - marks any "x", "X" or "*" component in `b` as equivalent by zero-ing it out
 *   in both `a` and `b`
 * - marks any final "*" component in `b` as a greedy wildcard by zero-ing it
 *   and all of its successors in `a`
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {array<array<string>>}
 */
    function normalizeVersions(a, b) {
        a = a.slice(), b = b.slice(), zeroPad(a, b.length);
        // mark "x" and "*" components as equal
        for (var i = 0; i < b.length; i++) {
            var matches = b[i].match(/^[x*]$/i);
            if (matches && (b[i] = a[i] = "0", "*" === matches[0] && i === b.length - 1)) for (var j = i; j < a.length; j++) a[j] = "0";
        }
        return zeroPad(b, a.length), [ a, b ];
    }
    /**
 * Returns the numerical -- not the lexicographical -- ordering of `a` and `b`.
 *
 * For example, `10-alpha` is greater than `2-beta`.
 *
 * @param {string} a
 * @param {string} b
 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
 * or greater than `b`, respectively
 */
    function compareNumeric(a, b) {
        var aPrefix = a.match(numericRegex)[1], bPrefix = b.match(numericRegex)[1], aNumeric = parseInt(aPrefix, 10), bNumeric = parseInt(bPrefix, 10);
        return isNumber(aNumeric) && isNumber(bNumeric) && aNumeric !== bNumeric ? compare(aNumeric, bNumeric) : compare(a, b);
    }
    /**
 * Returns the ordering of `a` and `b`.
 *
 * @param {string|number} a
 * @param {string|number} b
 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
 * or greater than `b`, respectively
 */
    function compare(a, b) {
        return typeof a != typeof b && invariant(!1), a > b ? 1 : a < b ? -1 : 0;
    }
    /**
 * Compares arrays of version components.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
 * or greater than `b`, respectively
 */
    function compareComponents(a, b) {
        for (var _normalizeVersions = normalizeVersions(a, b), aNormalized = _normalizeVersions[0], bNormalized = _normalizeVersions[1], i = 0; i < bNormalized.length; i++) {
            var result = compareNumeric(aNormalized[i], bNormalized[i]);
            if (result) return result;
        }
        return 0;
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */
    var invariant = __webpack_require__(2), componentRegex = /\./, orRegex = /\|\|/, rangeRegex = /\s+\-\s+/, modifierRegex = /^(<=|<|=|>=|~>|~|>|)?\s*(.+)/, numericRegex = /^(\d*)(.*)/, VersionRange = {
        /**
   * Checks whether `version` satisfies the `range` specification.
   *
   * We support a subset of the expressions defined in
   * https://www.npmjs.org/doc/misc/semver.html:
   *
   *    version   Must match version exactly
   *    =version  Same as just version
   *    >version  Must be greater than version
   *    >=version Must be greater than or equal to version
   *    <version  Must be less than version
   *    <=version Must be less than or equal to version
   *    ~version  Must be at least version, but less than the next significant
   *              revision above version:
   *              "~1.2.3" is equivalent to ">= 1.2.3 and < 1.3"
   *    ~>version Equivalent to ~version
   *    1.2.x     Must match "1.2.x", where "x" is a wildcard that matches
   *              anything
   *    1.2.*     Similar to "1.2.x", but "*" in the trailing position is a
   *              "greedy" wildcard, so will match any number of additional
   *              components:
   *              "1.2.*" will match "1.2.1", "1.2.1.1", "1.2.1.1.1" etc
   *    *         Any version
   *    ""        (Empty string) Same as *
   *    v1 - v2   Equivalent to ">= v1 and <= v2"
   *    r1 || r2  Passes if either r1 or r2 are satisfied
   *
   * @param {string} range
   * @param {string} version
   * @returns {boolean}
   */
        contains: function(range, version) {
            return checkOrExpression(range.trim(), version.trim());
        }
    };
    module.exports = VersionRange;
}, /* 202 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Executes the provided `callback` once for each enumerable own property in the
 * object and constructs a new object from the results. The `callback` is
 * invoked with three arguments:
 *
 *  - the property value
 *  - the property name
 *  - the object being traversed
 *
 * Properties that are added after the call to `mapObject` will not be visited
 * by `callback`. If the values of existing properties are changed, the value
 * passed to `callback` will be the value at the time `mapObject` visits them.
 * Properties that are deleted before being visited are not visited.
 *
 * @grep function objectMap()
 * @grep function objMap()
 *
 * @param {?object} object
 * @param {function} callback
 * @param {*} context
 * @return {?object}
 */
    function mapObject(object, callback, context) {
        if (!object) return null;
        var result = {};
        for (var name in object) hasOwnProperty.call(object, name) && (result[name] = callback.call(context, object[name], name, object));
        return result;
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    module.exports = mapObject;
}, /* 203 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 * @typechecks static-only
 */
    /**
 * Memoizes the return value of a function that accepts one string argument.
 */
    function memoizeStringOnly(callback) {
        var cache = {};
        return function(string) {
            return cache.hasOwnProperty(string) || (cache[string] = callback.call(this, string)), 
            cache[string];
        };
    }
    module.exports = memoizeStringOnly;
}, /* 204 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /* WEBPACK VAR INJECTION */
    (function(global) {
        function getAnonymizedDOM(node) {
            if (!node) return "[empty]";
            var anonymized = anonymizeText(node);
            return anonymized.nodeType === Node.TEXT_NODE ? anonymized.textContent : (anonymized instanceof Element || invariant(!1), 
            anonymized.innerHTML);
        }
        function anonymizeText(node) {
            if (node.nodeType === Node.TEXT_NODE) {
                var length = node.textContent.length;
                return document.createTextNode("[text " + length + "]");
            }
            for (var clone = node.cloneNode(), childNodes = node.childNodes, ii = 0; ii < childNodes.length; ii++) clone.appendChild(anonymizeText(childNodes[ii]));
            return clone;
        }
        function getAnonymizedEditorDOM(node) {
            for (// grabbing the DOM content of the Draft editor
            var currentNode = node; currentNode; ) {
                if (currentNode instanceof Element && currentNode.hasAttribute("contenteditable")) // found the Draft editor container
                return getAnonymizedDOM(currentNode);
                currentNode = currentNode.parentNode;
            }
            return "Could not find contentEditable parent of node";
        }
        function getNodeLength(node) {
            return null === node.nodeValue ? node.childNodes.length : node.nodeValue.length;
        }
        /**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 */
        function setDraftEditorSelection(selectionState, node, blockKey, nodeStart, nodeEnd) {
            // It's possible that the editor has been removed from the DOM but
            // our selection code doesn't know it yet. Forcing selection in
            // this case may lead to errors, so just bail now.
            if (containsNode(document.documentElement, node)) {
                var selection = global.getSelection(), anchorKey = selectionState.getAnchorKey(), anchorOffset = selectionState.getAnchorOffset(), focusKey = selectionState.getFocusKey(), focusOffset = selectionState.getFocusOffset(), isBackward = selectionState.getIsBackward();
                // IE doesn't support backward selection. Swap key/offset pairs.
                if (!selection.extend && isBackward) {
                    var tempKey = anchorKey, tempOffset = anchorOffset;
                    anchorKey = focusKey, anchorOffset = focusOffset, focusKey = tempKey, focusOffset = tempOffset, 
                    isBackward = !1;
                }
                var hasAnchor = anchorKey === blockKey && nodeStart <= anchorOffset && nodeEnd >= anchorOffset, hasFocus = focusKey === blockKey && nodeStart <= focusOffset && nodeEnd >= focusOffset;
                // If the selection is entirely bound within this node, set the selection
                // and be done.
                if (hasAnchor && hasFocus) return selection.removeAllRanges(), addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState), 
                void addFocusToSelection(selection, node, focusOffset - nodeStart, selectionState);
                if (isBackward) {
                    // If this node has the anchor, we may assume that the correct
                    // focus information is already stored on the selection object.
                    // We keep track of it, reset the selection range, and extend it
                    // back to the focus point.
                    if (// If this node has the focus, set the selection range to be a
                    // collapsed range beginning here. Later, when we encounter the anchor,
                    // we'll use this information to extend the selection.
                    hasFocus && (selection.removeAllRanges(), addPointToSelection(selection, node, focusOffset - nodeStart, selectionState)), 
                    hasAnchor) {
                        var storedFocusNode = selection.focusNode, storedFocusOffset = selection.focusOffset;
                        selection.removeAllRanges(), addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState), 
                        addFocusToSelection(selection, storedFocusNode, storedFocusOffset, selectionState);
                    }
                } else // If the anchor is within this node, set the range start.
                hasAnchor && (selection.removeAllRanges(), addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState)), 
                // If the focus is within this node, we can assume that we have
                // already set the appropriate start range on the selection, and
                // can simply extend the selection.
                hasFocus && addFocusToSelection(selection, node, focusOffset - nodeStart, selectionState);
            }
        }
        /**
 * Extend selection towards focus point.
 */
        function addFocusToSelection(selection, node, offset, selectionState) {
            if (selection.extend && containsNode(getActiveElement(), node)) // If `extend` is called while another element has focus, an error is
            // thrown. We therefore disable `extend` if the active element is somewhere
            // other than the node we are selecting. This should only occur in Firefox,
            // since it is the only browser to support multiple selections.
            // See https://bugzilla.mozilla.org/show_bug.cgi?id=921444.
            // logging to catch bug that is being reported in t16250795
            offset > getNodeLength(node) && // the call to 'selection.extend' is about to throw
            DraftJsDebugLogging.logSelectionStateFailure({
                anonymizedDom: getAnonymizedEditorDOM(node),
                extraParams: JSON.stringify({
                    offset: offset
                }),
                selectionState: JSON.stringify(selectionState.toJS())
            }), selection.extend(node, offset); else {
                // IE doesn't support extend. This will mean no backward selection.
                // Extract the existing selection range and add focus to it.
                // Additionally, clone the selection range. IE11 throws an
                // InvalidStateError when attempting to access selection properties
                // after the range is detached.
                var range = selection.getRangeAt(0);
                range.setEnd(node, offset), selection.addRange(range.cloneRange());
            }
        }
        function addPointToSelection(selection, node, offset, selectionState) {
            var range = document.createRange();
            // logging to catch bug that is being reported in t16250795
            offset > getNodeLength(node) && // in this case we know that the call to 'range.setStart' is about to throw
            DraftJsDebugLogging.logSelectionStateFailure({
                anonymizedDom: getAnonymizedEditorDOM(node),
                extraParams: JSON.stringify({
                    offset: offset
                }),
                selectionState: JSON.stringify(selectionState.toJS())
            }), range.setStart(node, offset), selection.addRange(range);
        }
        /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule setDraftEditorSelection
 * @typechecks
 * 
 */
        var DraftJsDebugLogging = __webpack_require__(205), containsNode = __webpack_require__(118), getActiveElement = __webpack_require__(119), invariant = __webpack_require__(2);
        module.exports = setDraftEditorSelection;
    }).call(exports, __webpack_require__(28));
}, /* 205 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftJsDebugLogging
 */
    module.exports = {
        logSelectionStateFailure: function() {
            return null;
        }
    };
}, /* 206 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
    function isTextNode(object) {
        return isNode(object) && 3 == object.nodeType;
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */
    var isNode = __webpack_require__(207);
    module.exports = isTextNode;
}, /* 207 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */
    /**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
    function isNode(object) {
        var doc = object ? object.ownerDocument || object : document, defaultView = doc.defaultView || window;
        return !(!object || !("function" == typeof defaultView.Node ? object instanceof defaultView.Node : "object" == typeof object && "number" == typeof object.nodeType && "string" == typeof object.nodeName));
    }
    module.exports = isNode;
}, /* 208 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function asString(value) {
        return null == value ? value : String(value);
    }
    function getStyleProperty(/*DOMNode*/ node, /*string*/ name) {
        var computedStyle = void 0;
        // W3C Standard
        if (window.getComputedStyle && (// In certain cases such as within an iframe in FF3, this returns null.
        computedStyle = window.getComputedStyle(node, null))) return asString(computedStyle.getPropertyValue(hyphenate(name)));
        // Safari
        if (document.defaultView && document.defaultView.getComputedStyle) {
            // A Safari bug causes this to return null for `display: none` elements.
            if (computedStyle = document.defaultView.getComputedStyle(node, null)) return asString(computedStyle.getPropertyValue(hyphenate(name)));
            if ("display" === name) return "none";
        }
        // Internet Explorer
        // Internet Explorer
        return asString(node.currentStyle ? "float" === name ? node.currentStyle.cssFloat || node.currentStyle.styleFloat : node.currentStyle[camelize(name)] : node.style && node.style[camelize(name)]);
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */
    var camelize = __webpack_require__(209), hyphenate = __webpack_require__(210);
    module.exports = getStyleProperty;
}, /* 209 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
    function camelize(string) {
        return string.replace(_hyphenPattern, function(_, character) {
            return character.toUpperCase();
        });
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */
    var _hyphenPattern = /-(.)/g;
    module.exports = camelize;
}, /* 210 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
    function hyphenate(string) {
        return string.replace(_uppercasePattern, "-$1").toLowerCase();
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */
    var _uppercasePattern = /([A-Z])/g;
    module.exports = hyphenate;
}, /* 211 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Gets an element's position in pixels relative to the viewport. The returned
 * object represents the position of the element's top left corner.
 *
 * @param {DOMElement} element
 * @return {object}
 */
    function getElementPosition(element) {
        var rect = getElementRect(element);
        return {
            x: rect.left,
            y: rect.top,
            width: rect.right - rect.left,
            height: rect.bottom - rect.top
        };
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */
    var getElementRect = __webpack_require__(212);
    module.exports = getElementPosition;
}, /* 212 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Gets an element's bounding rect in pixels relative to the viewport.
 *
 * @param {DOMElement} elem
 * @return {object}
 */
    function getElementRect(elem) {
        var docElem = elem.ownerDocument.documentElement;
        // FF 2, Safari 3 and Opera 9.5- do not support getBoundingClientRect().
        // IE9- will throw if the element is not in the document.
        if (!("getBoundingClientRect" in elem && containsNode(docElem, elem))) return {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        // Subtracts clientTop/Left because IE8- added a 2px border to the
        // <html> element (see http://fburl.com/1493213). IE 7 in
        // Quicksmode does not report clientLeft/clientTop so there
        // will be an unaccounted offset of 2px when in quirksmode
        var rect = elem.getBoundingClientRect();
        return {
            left: Math.round(rect.left) - docElem.clientLeft,
            right: Math.round(rect.right) - docElem.clientLeft,
            top: Math.round(rect.top) - docElem.clientTop,
            bottom: Math.round(rect.bottom) - docElem.clientTop
        };
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */
    var containsNode = __webpack_require__(118);
    module.exports = getElementRect;
}, /* 213 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Gets the element with the document scroll properties such as `scrollLeft` and
 * `scrollHeight`. This may differ across different browsers.
 *
 * NOTE: The return value can be null if the DOM is not yet ready.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
    function getDocumentScrollElement(doc) {
        return doc = doc || document, doc.scrollingElement ? doc.scrollingElement : isWebkit || "CSS1Compat" !== doc.compatMode ? doc.body : doc.documentElement;
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */
    var isWebkit = "undefined" != typeof navigator && navigator.userAgent.indexOf("AppleWebKit") > -1;
    module.exports = getDocumentScrollElement;
}, /* 214 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */
    /**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */
    function getUnboundedScrollPosition(scrollable) {
        return scrollable.Window && scrollable instanceof scrollable.Window ? {
            x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
            y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
        } : {
            x: scrollable.scrollLeft,
            y: scrollable.scrollTop
        };
    }
    module.exports = getUnboundedScrollPosition;
}, /* 215 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function getViewportWidth() {
        var width = void 0;
        return document.documentElement && (width = document.documentElement.clientWidth), 
        !width && document.body && (width = document.body.clientWidth), width || 0;
    }
    /**
   * Copyright (c) 2013-present, Facebook, Inc.
   * All rights reserved.
   *
   * This source code is licensed under the BSD-style license found in the
   * LICENSE file in the root directory of this source tree. An additional grant
   * of patent rights can be found in the PATENTS file in the same directory.
   *
   * 
   * @typechecks
   */
    function getViewportHeight() {
        var height = void 0;
        return document.documentElement && (height = document.documentElement.clientHeight), 
        !height && document.body && (height = document.body.clientHeight), height || 0;
    }
    /**
 * Gets the viewport dimensions including any scrollbars.
 */
    function getViewportDimensions() {
        return {
            width: window.innerWidth || getViewportWidth(),
            height: window.innerHeight || getViewportHeight()
        };
    }
    /**
 * Gets the viewport dimensions excluding any scrollbars.
 */
    getViewportDimensions.withoutScrollbars = function() {
        return {
            width: getViewportWidth(),
            height: getViewportHeight()
        };
    }, module.exports = getViewportDimensions;
}, /* 216 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks static-only
 */
    /**
 * Combines multiple className strings into one.
 * http://jsperf.com/joinclasses-args-vs-array
 *
 * @param {...?string} className
 * @return {string}
 */
    function joinClasses(className) {
        className || (className = "");
        var nextClass = void 0, argLength = arguments.length;
        if (argLength > 1) for (var ii = 1; ii < argLength; ii++) (nextClass = arguments[ii]) && (className = (className ? className + " " : "") + nextClass);
        return className;
    }
    module.exports = joinClasses;
}, /* 217 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Get a SelectionState for the supplied mouse event.
 */
    function getSelectionForEvent(event, editorState) {
        var node = null, offset = null;
        if ("function" == typeof document.caretRangeFromPoint) {
            var dropRange = document.caretRangeFromPoint(event.x, event.y);
            node = dropRange.startContainer, offset = dropRange.startOffset;
        } else {
            if (!event.rangeParent) return null;
            node = event.rangeParent, offset = event.rangeOffset;
        }
        node = nullthrows(node), offset = nullthrows(offset);
        var offsetKey = nullthrows(findAncestorOffsetKey(node));
        return getUpdatedSelectionState(editorState, offsetKey, offset, offsetKey, offset);
    }
    function moveText(editorState, targetSelection) {
        var newContentState = DraftModifier.moveText(editorState.getCurrentContent(), editorState.getSelection(), targetSelection);
        return EditorState.push(editorState, newContentState, "insert-fragment");
    }
    /**
 * Insert text at a specified selection.
 */
    function insertTextAtSelection(editorState, selection, text) {
        var newContentState = DraftModifier.insertText(editorState.getCurrentContent(), selection, text, editorState.getCurrentInlineStyle());
        return EditorState.push(editorState, newContentState, "insert-fragment");
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorDragHandler
 * @typechecks
 * 
 */
    var DataTransfer = __webpack_require__(121), DraftModifier = __webpack_require__(5), EditorState = __webpack_require__(0), findAncestorOffsetKey = __webpack_require__(88), getTextContentFromFiles = __webpack_require__(123), getUpdatedSelectionState = __webpack_require__(124), nullthrows = __webpack_require__(8), isEventHandled = __webpack_require__(61), DraftEditorDragHandler = {
        /**
   * Drag originating from input terminated.
   */
        onDragEnd: function(editor) {
            editor.exitCurrentMode();
        },
        /**
   * Handle data being dropped.
   */
        onDrop: function(editor, e) {
            var data = new DataTransfer(e.nativeEvent.dataTransfer), editorState = editor._latestEditorState, dropSelection = getSelectionForEvent(e.nativeEvent, editorState);
            if (e.preventDefault(), editor.exitCurrentMode(), null != dropSelection) {
                var files = data.getFiles();
                if (files.length > 0) {
                    if (editor.props.handleDroppedFiles && isEventHandled(editor.props.handleDroppedFiles(dropSelection, files))) return;
                    return void getTextContentFromFiles(files, function(fileText) {
                        fileText && editor.update(insertTextAtSelection(editorState, dropSelection, fileText));
                    });
                }
                var dragType = editor._internalDrag ? "internal" : "external";
                if (!editor.props.handleDrop || !isEventHandled(editor.props.handleDrop(dropSelection, data, dragType))) return editor._internalDrag ? void editor.update(moveText(editorState, dropSelection)) : void editor.update(insertTextAtSelection(editorState, dropSelection, data.getText()));
            }
        }
    };
    module.exports = DraftEditorDragHandler;
}, /* 218 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function getParts(mimeString) {
        return mimeString.split("/");
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */
    var PhotosMimeType = {
        isImage: function(mimeString) {
            return "image" === getParts(mimeString)[0];
        },
        isJpeg: function(mimeString) {
            var parts = getParts(mimeString);
            // see http://fburl.com/10972194
            return PhotosMimeType.isImage(mimeString) && ("jpeg" === parts[1] || "pjpeg" === parts[1]);
        }
    };
    module.exports = PhotosMimeType;
}, /* 219 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
    function toArray(obj) {
        var length = obj.length;
        // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
        // without method will throw during the slice call and skip straight to the
        // fallback.
        if (// Some browsers builtin objects can report typeof 'function' (e.g. NodeList
        // in old versions of Safari).
        (Array.isArray(obj) || "object" != typeof obj && "function" != typeof obj) && invariant(!1), 
        "number" != typeof length && invariant(!1), 0 === length || length - 1 in obj || invariant(!1), 
        "function" == typeof obj.callee && invariant(!1), obj.hasOwnProperty) try {
            return Array.prototype.slice.call(obj);
        } catch (e) {}
        for (var ret = Array(length), ii = 0; ii < length; ii++) ret[ii] = obj[ii];
        return ret;
    }
    /**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
    function hasArrayNature(obj) {
        // not null/false
        // arrays are objects, NodeLists are functions in Safari
        // quacks like an array
        // not window
        // no DOM node should be considered an array-like
        // a 'select' element has 'length' and 'item' properties on IE8
        // a real array
        // arguments
        // HTMLCollection/NodeList
        return !!obj && ("object" == typeof obj || "function" == typeof obj) && "length" in obj && !("setInterval" in obj) && "number" != typeof obj.nodeType && (Array.isArray(obj) || "callee" in obj || "item" in obj);
    }
    /**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
    function createArrayFromMixed(obj) {
        return hasArrayNature(obj) ? Array.isArray(obj) ? obj.slice() : toArray(obj) : [ obj ];
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */
    var invariant = __webpack_require__(2);
    module.exports = createArrayFromMixed;
}, /* 220 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorEditHandler
 * 
 */
    var onBeforeInput = __webpack_require__(221), onBlur = __webpack_require__(225), onCompositionStart = __webpack_require__(226), onCopy = __webpack_require__(227), onCut = __webpack_require__(228), onDragOver = __webpack_require__(229), onDragStart = __webpack_require__(230), onFocus = __webpack_require__(231), onInput = __webpack_require__(232), onKeyDown = __webpack_require__(233), onPaste = __webpack_require__(247), onSelect = __webpack_require__(251), DraftEditorEditHandler = {
        onBeforeInput: onBeforeInput,
        onBlur: onBlur,
        onCompositionStart: onCompositionStart,
        onCopy: onCopy,
        onCut: onCut,
        onDragOver: onDragOver,
        onDragStart: onDragStart,
        onFocus: onFocus,
        onInput: onInput,
        onKeyDown: onKeyDown,
        onPaste: onPaste,
        onSelect: onSelect
    };
    module.exports = DraftEditorEditHandler;
}, /* 221 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function mustPreventDefaultForCharacter(character) {
        return isFirefox && (character == FF_QUICKFIND_CHAR || character == FF_QUICKFIND_LINK_CHAR);
    }
    /**
 * Replace the current selection with the specified text string, with the
 * inline style and entity key applied to the newly inserted text.
 */
    function replaceText(editorState, text, inlineStyle, entityKey) {
        var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), text, inlineStyle, entityKey);
        return EditorState.push(editorState, contentState, "insert-characters");
    }
    /**
 * When `onBeforeInput` executes, the browser is attempting to insert a
 * character into the editor. Apply this character data to the document,
 * allowing native insertion if possible.
 *
 * Native insertion is encouraged in order to limit re-rendering and to
 * preserve spellcheck highlighting, which disappears or flashes if re-render
 * occurs on the relevant text nodes.
 */
    function editOnBeforeInput(editor, e) {
        void 0 !== editor._pendingStateFromBeforeInput && (editor.update(editor._pendingStateFromBeforeInput), 
        editor._pendingStateFromBeforeInput = void 0);
        var editorState = editor._latestEditorState, chars = e.data;
        // In some cases (ex: IE ideographic space insertion) no character data
        // is provided. There's nothing to do when this happens.
        if (chars) {
            // Allow the top-level component to handle the insertion manually. This is
            // useful when triggering interesting behaviors for a character insertion,
            // Simple examples: replacing a raw text ':)' with a smile emoji or image
            // decorator, or setting a block to be a list item after typing '- ' at the
            // start of the block.
            if (editor.props.handleBeforeInput && isEventHandled(editor.props.handleBeforeInput(chars, editorState))) return void e.preventDefault();
            // If selection is collapsed, conditionally allow native behavior. This
            // reduces re-renders and preserves spellcheck highlighting. If the selection
            // is not collapsed, we will re-render.
            var selection = editorState.getSelection();
            if (!selection.isCollapsed()) return e.preventDefault(), void editor.update(replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())));
            var mayAllowNative = !isSelectionAtLeafStart(editorState), newEditorState = replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection()));
            if (!mayAllowNative) return e.preventDefault(), void editor.update(newEditorState);
            var anchorKey = selection.getAnchorKey(), anchorTree = editorState.getBlockTree(anchorKey), originalFingerprint = BlockTree.getFingerprint(anchorTree), newFingerprint = BlockTree.getFingerprint(newEditorState.getBlockTree(anchorKey));
            mustPreventDefaultForCharacter(chars) || originalFingerprint !== newFingerprint || nullthrows(newEditorState.getDirectionMap()).get(anchorKey) !== nullthrows(editorState.getDirectionMap()).get(anchorKey) ? (e.preventDefault(), 
            editor.update(newEditorState)) : (newEditorState = EditorState.set(newEditorState, {
                nativelyRenderedContent: newEditorState.getCurrentContent()
            }), // The native event is allowed to occur. To allow user onChange handlers to
            // change the inserted text, we wait until the text is actually inserted
            // before we actually update our state. That way when we rerender, the text
            // we see in the DOM will already have been inserted properly.
            editor._pendingStateFromBeforeInput = newEditorState, setImmediate(function() {
                void 0 !== editor._pendingStateFromBeforeInput && (editor.update(editor._pendingStateFromBeforeInput), 
                editor._pendingStateFromBeforeInput = void 0);
            }));
        }
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnBeforeInput
 * 
 */
    var BlockTree = __webpack_require__(112), DraftModifier = __webpack_require__(5), EditorState = __webpack_require__(0), UserAgent = __webpack_require__(17), getEntityKeyForSelection = __webpack_require__(85), isSelectionAtLeafStart = __webpack_require__(116), nullthrows = __webpack_require__(8), setImmediate = __webpack_require__(222), isEventHandled = __webpack_require__(61), FF_QUICKFIND_CHAR = "'", FF_QUICKFIND_LINK_CHAR = "/", isFirefox = UserAgent.isBrowser("Firefox");
    module.exports = editOnBeforeInput;
}, /* 222 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /* WEBPACK VAR INJECTION */
    (function(global) {
        /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */
        // setimmediate adds setImmediate to the global. We want to make sure we export
        // the actual function.
        __webpack_require__(223), module.exports = global.setImmediate;
    }).call(exports, __webpack_require__(28));
}, /* 223 */
/***/
function(module, exports, __webpack_require__) {
    /* WEBPACK VAR INJECTION */
    (function(global, process) {
        !function(global, undefined) {
            "use strict";
            function setImmediate(callback) {
                // Callback can either be a function or a string
                "function" != typeof callback && (callback = new Function("" + callback));
                for (var args = new Array(arguments.length - 1), i = 0; i < args.length; i++) args[i] = arguments[i + 1];
                // Store and register the task
                var task = {
                    callback: callback,
                    args: args
                };
                return tasksByHandle[nextHandle] = task, registerImmediate(nextHandle), nextHandle++;
            }
            function clearImmediate(handle) {
                delete tasksByHandle[handle];
            }
            function run(task) {
                var callback = task.callback, args = task.args;
                switch (args.length) {
                  case 0:
                    callback();
                    break;

                  case 1:
                    callback(args[0]);
                    break;

                  case 2:
                    callback(args[0], args[1]);
                    break;

                  case 3:
                    callback(args[0], args[1], args[2]);
                    break;

                  default:
                    callback.apply(undefined, args);
                }
            }
            function runIfPresent(handle) {
                // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
                // So if we're currently running a task, we'll need to delay this invocation.
                if (currentlyRunningATask) // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
                // "too much recursion" error.
                setTimeout(runIfPresent, 0, handle); else {
                    var task = tasksByHandle[handle];
                    if (task) {
                        currentlyRunningATask = !0;
                        try {
                            run(task);
                        } finally {
                            clearImmediate(handle), currentlyRunningATask = !1;
                        }
                    }
                }
            }
            if (!global.setImmediate) {
                var registerImmediate, nextHandle = 1, tasksByHandle = {}, currentlyRunningATask = !1, doc = global.document, attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
                attachTo = attachTo && attachTo.setTimeout ? attachTo : global, // Don't get fooled by e.g. browserify environments.
                "[object process]" === {}.toString.call(global.process) ? // For Node.js before 0.9
                function() {
                    registerImmediate = function(handle) {
                        process.nextTick(function() {
                            runIfPresent(handle);
                        });
                    };
                }() : function() {
                    // The test against `importScripts` prevents this implementation from being installed inside a web worker,
                    // where `global.postMessage` means something completely different and can't be used for this purpose.
                    if (global.postMessage && !global.importScripts) {
                        var postMessageIsAsynchronous = !0, oldOnMessage = global.onmessage;
                        return global.onmessage = function() {
                            postMessageIsAsynchronous = !1;
                        }, global.postMessage("", "*"), global.onmessage = oldOnMessage, postMessageIsAsynchronous;
                    }
                }() ? // For non-IE10 modern browsers
                function() {
                    // Installs an event handler on `global` for the `message` event: see
                    // * https://developer.mozilla.org/en/DOM/window.postMessage
                    // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
                    var messagePrefix = "setImmediate$" + Math.random() + "$", onGlobalMessage = function(event) {
                        event.source === global && "string" == typeof event.data && 0 === event.data.indexOf(messagePrefix) && runIfPresent(+event.data.slice(messagePrefix.length));
                    };
                    global.addEventListener ? global.addEventListener("message", onGlobalMessage, !1) : global.attachEvent("onmessage", onGlobalMessage), 
                    registerImmediate = function(handle) {
                        global.postMessage(messagePrefix + handle, "*");
                    };
                }() : global.MessageChannel ? // For web workers, where supported
                function() {
                    var channel = new MessageChannel();
                    channel.port1.onmessage = function(event) {
                        runIfPresent(event.data);
                    }, registerImmediate = function(handle) {
                        channel.port2.postMessage(handle);
                    };
                }() : doc && "onreadystatechange" in doc.createElement("script") ? // For IE 6–8
                function() {
                    var html = doc.documentElement;
                    registerImmediate = function(handle) {
                        // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
                        // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
                        var script = doc.createElement("script");
                        script.onreadystatechange = function() {
                            runIfPresent(handle), script.onreadystatechange = null, html.removeChild(script), 
                            script = null;
                        }, html.appendChild(script);
                    };
                }() : // For older browsers
                function() {
                    registerImmediate = function(handle) {
                        setTimeout(runIfPresent, 0, handle);
                    };
                }(), attachTo.setImmediate = setImmediate, attachTo.clearImmediate = clearImmediate;
            }
        }("undefined" == typeof self ? void 0 === global ? this : global : self);
    }).call(exports, __webpack_require__(28), __webpack_require__(224));
}, /* 224 */
/***/
function(module, exports) {
    function defaultSetTimout() {
        throw new Error("setTimeout has not been defined");
    }
    function defaultClearTimeout() {
        throw new Error("clearTimeout has not been defined");
    }
    function runTimeout(fun) {
        if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
        return setTimeout(fun, 0);
        // if setTimeout wasn't available but was latter defined
        if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) return cachedSetTimeout = setTimeout, 
        setTimeout(fun, 0);
        try {
            // when when somebody has screwed with setTimeout but no I.E. maddness
            return cachedSetTimeout(fun, 0);
        } catch (e) {
            try {
                // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
                return cachedSetTimeout.call(null, fun, 0);
            } catch (e) {
                // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
                return cachedSetTimeout.call(this, fun, 0);
            }
        }
    }
    function runClearTimeout(marker) {
        if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
        return clearTimeout(marker);
        // if clearTimeout wasn't available but was latter defined
        if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) return cachedClearTimeout = clearTimeout, 
        clearTimeout(marker);
        try {
            // when when somebody has screwed with setTimeout but no I.E. maddness
            return cachedClearTimeout(marker);
        } catch (e) {
            try {
                // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
                return cachedClearTimeout.call(null, marker);
            } catch (e) {
                // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
                // Some versions of I.E. have different rules for clearTimeout vs setTimeout
                return cachedClearTimeout.call(this, marker);
            }
        }
    }
    function cleanUpNextTick() {
        draining && currentQueue && (draining = !1, currentQueue.length ? queue = currentQueue.concat(queue) : queueIndex = -1, 
        queue.length && drainQueue());
    }
    function drainQueue() {
        if (!draining) {
            var timeout = runTimeout(cleanUpNextTick);
            draining = !0;
            for (var len = queue.length; len; ) {
                for (currentQueue = queue, queue = []; ++queueIndex < len; ) currentQueue && currentQueue[queueIndex].run();
                queueIndex = -1, len = queue.length;
            }
            currentQueue = null, draining = !1, runClearTimeout(timeout);
        }
    }
    // v8 likes predictible objects
    function Item(fun, array) {
        this.fun = fun, this.array = array;
    }
    function noop() {}
    // shim for using process in browser
    var cachedSetTimeout, cachedClearTimeout, process = module.exports = {};
    !function() {
        try {
            cachedSetTimeout = "function" == typeof setTimeout ? setTimeout : defaultSetTimout;
        } catch (e) {
            cachedSetTimeout = defaultSetTimout;
        }
        try {
            cachedClearTimeout = "function" == typeof clearTimeout ? clearTimeout : defaultClearTimeout;
        } catch (e) {
            cachedClearTimeout = defaultClearTimeout;
        }
    }();
    var currentQueue, queue = [], draining = !1, queueIndex = -1;
    process.nextTick = function(fun) {
        var args = new Array(arguments.length - 1);
        if (arguments.length > 1) for (var i = 1; i < arguments.length; i++) args[i - 1] = arguments[i];
        queue.push(new Item(fun, args)), 1 !== queue.length || draining || runTimeout(drainQueue);
    }, Item.prototype.run = function() {
        this.fun.apply(null, this.array);
    }, process.title = "browser", process.browser = !0, process.env = {}, process.argv = [], 
    process.version = "", // empty string to avoid regexp issues
    process.versions = {}, process.on = noop, process.addListener = noop, process.once = noop, 
    process.off = noop, process.removeListener = noop, process.removeAllListeners = noop, 
    process.emit = noop, process.prependListener = noop, process.prependOnceListener = noop, 
    process.listeners = function(name) {
        return [];
    }, process.binding = function(name) {
        throw new Error("process.binding is not supported");
    }, process.cwd = function() {
        return "/";
    }, process.chdir = function(dir) {
        throw new Error("process.chdir is not supported");
    }, process.umask = function() {
        return 0;
    };
}, /* 225 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /* WEBPACK VAR INJECTION */
    (function(global) {
        function editOnBlur(editor, e) {
            // Webkit has a bug in which blurring a contenteditable by clicking on
            // other active elements will trigger the `blur` event but will not remove
            // the DOM selection from the contenteditable. We therefore force the
            // issue to be certain, checking whether the active element is `body`
            // to force it when blurring occurs within the window (as opposed to
            // clicking to another tab or window).
            isWebKit && getActiveElement() === document.body && global.getSelection().removeAllRanges();
            var editorState = editor._latestEditorState, currentSelection = editorState.getSelection();
            if (currentSelection.getHasFocus()) {
                var selection = currentSelection.set("hasFocus", !1);
                editor.props.onBlur && editor.props.onBlur(e), editor.update(EditorState.acceptSelection(editorState, selection));
            }
        }
        /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnBlur
 * 
 */
        var EditorState = __webpack_require__(0), UserAgent = __webpack_require__(17), getActiveElement = __webpack_require__(119), isWebKit = UserAgent.isEngine("WebKit");
        module.exports = editOnBlur;
    }).call(exports, __webpack_require__(28));
}, /* 226 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * The user has begun using an IME input system. Switching to `composite` mode
 * allows handling composition input and disables other edit behavior.
 */
    function editOnCompositionStart(editor, e) {
        editor.setMode("composite"), editor.update(EditorState.set(editor._latestEditorState, {
            inCompositionMode: !0
        })), // Allow composition handler to interpret the compositionstart event
        editor._onCompositionStart(e);
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnCompositionStart
 * 
 */
    var EditorState = __webpack_require__(0);
    module.exports = editOnCompositionStart;
}, /* 227 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * If we have a selection, create a ContentState fragment and store
 * it in our internal clipboard. Subsequent paste events will use this
 * fragment if no external clipboard data is supplied.
 */
    function editOnCopy(editor, e) {
        // No selection, so there's nothing to copy.
        if (editor._latestEditorState.getSelection().isCollapsed()) return void e.preventDefault();
        editor.setClipboard(getFragmentFromSelection(editor._latestEditorState));
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnCopy
 * 
 */
    var getFragmentFromSelection = __webpack_require__(125);
    module.exports = editOnCopy;
}, /* 228 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * On `cut` events, native behavior is allowed to occur so that the system
 * clipboard is set properly. This means that we need to take steps to recover
 * the editor DOM state after the `cut` has occurred in order to maintain
 * control of the component.
 *
 * In addition, we can keep a copy of the removed fragment, including all
 * styles and entities, for use as an internal paste.
 */
    function editOnCut(editor, e) {
        var editorState = editor._latestEditorState;
        // No selection, so there's nothing to cut.
        if (editorState.getSelection().isCollapsed()) return void e.preventDefault();
        // Track the current scroll position so that it can be forced back in place
        // after the editor regains control of the DOM.
        var scrollParent = Style.getScrollParent(e.target), _getScrollPosition = getScrollPosition(scrollParent), x = _getScrollPosition.x, y = _getScrollPosition.y, fragment = getFragmentFromSelection(editorState);
        editor.setClipboard(fragment), // Set `cut` mode to disable all event handling temporarily.
        editor.setMode("cut"), // Let native `cut` behavior occur, then recover control.
        setTimeout(function() {
            editor.restoreEditorDOM({
                x: x,
                y: y
            }), editor.exitCurrentMode(), editor.update(removeFragment(editorState));
        }, 0);
    }
    function removeFragment(editorState) {
        var newContent = DraftModifier.removeRange(editorState.getCurrentContent(), editorState.getSelection(), "forward");
        return EditorState.push(editorState, newContent, "remove-range");
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnCut
 * 
 */
    var DraftModifier = __webpack_require__(5), EditorState = __webpack_require__(0), Style = __webpack_require__(86), getFragmentFromSelection = __webpack_require__(125), getScrollPosition = __webpack_require__(87);
    module.exports = editOnCut;
}, /* 229 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnDragOver
 * 
 */
    /**
 * Drag behavior has begun from outside the editor element.
 */
    function editOnDragOver(editor, e) {
        editor._internalDrag = !1, editor.setMode("drag"), e.preventDefault();
    }
    module.exports = editOnDragOver;
}, /* 230 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnDragStart
 * 
 */
    /**
 * A `dragstart` event has begun within the text editor component.
 */
    function editOnDragStart(editor) {
        editor._internalDrag = !0, editor.setMode("drag");
    }
    module.exports = editOnDragStart;
}, /* 231 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function editOnFocus(editor, e) {
        var editorState = editor._latestEditorState, currentSelection = editorState.getSelection();
        if (!currentSelection.getHasFocus()) {
            var selection = currentSelection.set("hasFocus", !0);
            editor.props.onFocus && editor.props.onFocus(e), // When the tab containing this text editor is hidden and the user does a
            // find-in-page in a _different_ tab, Chrome on Mac likes to forget what the
            // selection was right after sending this focus event and (if you let it)
            // moves the cursor back to the beginning of the editor, so we force the
            // selection here instead of simply accepting it in order to preserve the
            // old cursor position. See https://crbug.com/540004.
            editor.update(EditorState.forceSelection(editorState, selection));
        }
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnFocus
 * 
 */
    var EditorState = __webpack_require__(0);
    module.exports = editOnFocus;
}, /* 232 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /* WEBPACK VAR INJECTION */
    (function(global) {
        /**
 * This function is intended to handle spellcheck and autocorrect changes,
 * which occur in the DOM natively without any opportunity to observe or
 * interpret the changes before they occur.
 *
 * The `input` event fires in contentEditable elements reliably for non-IE
 * browsers, immediately after changes occur to the editor DOM. Since our other
 * handlers override or otherwise handle cover other varieties of text input,
 * the DOM state should match the model in all controlled input cases. Thus,
 * when an `input` change leads to a DOM/model mismatch, the change should be
 * due to a spellcheck change, and we can incorporate it into our model.
 */
        function editOnInput(editor) {
            void 0 !== editor._pendingStateFromBeforeInput && (editor.update(editor._pendingStateFromBeforeInput), 
            editor._pendingStateFromBeforeInput = void 0);
            var domSelection = global.getSelection(), anchorNode = domSelection.anchorNode, isCollapsed = domSelection.isCollapsed, isNotTextNode = anchorNode.nodeType !== Node.TEXT_NODE, isNotTextOrElementNode = anchorNode.nodeType !== Node.TEXT_NODE && anchorNode.nodeType !== Node.ELEMENT_NODE;
            if (DraftFeatureFlags.draft_killswitch_allow_nontextnodes) {
                if (isNotTextNode) return;
            } else if (isNotTextOrElementNode) // TODO: (t16149272) figure out context for this change
            return;
            if (anchorNode.nodeType === Node.TEXT_NODE && (null !== anchorNode.previousSibling || null !== anchorNode.nextSibling)) {
                // When typing at the beginning of a visual line, Chrome splits the text
                // nodes into two. Why? No one knows. This commit is suspicious:
                // https://chromium.googlesource.com/chromium/src/+/a3b600981286b135632371477f902214c55a1724
                // To work around, we'll merge the sibling text nodes back into this one.
                var span = anchorNode.parentNode;
                anchorNode.nodeValue = span.textContent;
                for (var child = span.firstChild; null !== child; child = child.nextSibling) child !== anchorNode && span.removeChild(child);
            }
            var domText = anchorNode.textContent, editorState = editor._latestEditorState, offsetKey = nullthrows(findAncestorOffsetKey(anchorNode)), _DraftOffsetKey$decod = DraftOffsetKey.decode(offsetKey), blockKey = _DraftOffsetKey$decod.blockKey, decoratorKey = _DraftOffsetKey$decod.decoratorKey, leafKey = _DraftOffsetKey$decod.leafKey, _editorState$getBlock = editorState.getBlockTree(blockKey).getIn([ decoratorKey, "leaves", leafKey ]), start = _editorState$getBlock.start, end = _editorState$getBlock.end, content = editorState.getCurrentContent(), block = content.getBlockForKey(blockKey), modelText = block.getText().slice(start, end);
            // No change -- the DOM is up to date. Nothing to do here.
            if (// Special-case soft newlines here. If the DOM text ends in a soft newline,
            // we will have manually inserted an extra soft newline in DraftEditorLeaf.
            // We want to remove this extra newline for the purpose of our comparison
            // of DOM and model text.
            domText.endsWith(DOUBLE_NEWLINE) && (domText = domText.slice(0, -1)), domText !== modelText) {
                var anchorOffset, focusOffset, startOffset, endOffset, selection = editorState.getSelection(), targetRange = selection.merge({
                    anchorOffset: start,
                    focusOffset: end,
                    isBackward: !1
                }), entityKey = block.getEntityAt(start), entity = entityKey && content.getEntity(entityKey), entityType = entity && entity.getMutability(), preserveEntity = "MUTABLE" === entityType, changeType = preserveEntity ? "spellcheck-change" : "apply-entity", newContent = DraftModifier.replaceText(content, targetRange, domText, block.getInlineStyleAt(start), preserveEntity ? block.getEntityAt(start) : null);
                if (isGecko) // Firefox selection does not change while the context menu is open, so
                // we preserve the anchor and focus values of the DOM selection.
                anchorOffset = domSelection.anchorOffset, focusOffset = domSelection.focusOffset, 
                startOffset = start + Math.min(anchorOffset, focusOffset), endOffset = startOffset + Math.abs(anchorOffset - focusOffset), 
                anchorOffset = startOffset, focusOffset = endOffset; else {
                    // Browsers other than Firefox may adjust DOM selection while the context
                    // menu is open, and Safari autocorrect is prone to providing an inaccurate
                    // DOM selection. Don't trust it. Instead, use our existing SelectionState
                    // and adjust it based on the number of characters changed during the
                    // mutation.
                    var charDelta = domText.length - modelText.length;
                    startOffset = selection.getStartOffset(), endOffset = selection.getEndOffset(), 
                    anchorOffset = isCollapsed ? endOffset + charDelta : startOffset, focusOffset = endOffset + charDelta;
                }
                // Segmented entities are completely or partially removed when their
                // text content changes. For this case we do not want any text to be selected
                // after the change, so we are not merging the selection.
                var contentWithAdjustedDOMSelection = newContent.merge({
                    selectionBefore: content.getSelectionAfter(),
                    selectionAfter: selection.merge({
                        anchorOffset: anchorOffset,
                        focusOffset: focusOffset
                    })
                });
                editor.update(EditorState.push(editorState, contentWithAdjustedDOMSelection, changeType));
            }
        }
        /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnInput
 * 
 */
        var DraftFeatureFlags = __webpack_require__(109), DraftModifier = __webpack_require__(5), DraftOffsetKey = __webpack_require__(60), EditorState = __webpack_require__(0), UserAgent = __webpack_require__(17), findAncestorOffsetKey = __webpack_require__(88), nullthrows = __webpack_require__(8), isGecko = UserAgent.isEngine("Gecko"), DOUBLE_NEWLINE = "\n\n";
        module.exports = editOnInput;
    }).call(exports, __webpack_require__(28));
}, /* 233 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Map a `DraftEditorCommand` command value to a corresponding function.
 */
    function onKeyCommand(command, editorState) {
        switch (command) {
          case "redo":
            return EditorState.redo(editorState);

          case "delete":
            return keyCommandPlainDelete(editorState);

          case "delete-word":
            return keyCommandDeleteWord(editorState);

          case "backspace":
            return keyCommandPlainBackspace(editorState);

          case "backspace-word":
            return keyCommandBackspaceWord(editorState);

          case "backspace-to-start-of-line":
            return keyCommandBackspaceToStartOfLine(editorState);

          case "split-block":
            return keyCommandInsertNewline(editorState);

          case "transpose-characters":
            return keyCommandTransposeCharacters(editorState);

          case "move-selection-to-start-of-block":
            return keyCommandMoveSelectionToStartOfBlock(editorState);

          case "move-selection-to-end-of-block":
            return keyCommandMoveSelectionToEndOfBlock(editorState);

          case "secondary-cut":
            return SecondaryClipboard.cut(editorState);

          case "secondary-paste":
            return SecondaryClipboard.paste(editorState);

          default:
            return editorState;
        }
    }
    /**
 * Intercept keydown behavior to handle keys and commands manually, if desired.
 *
 * Keydown combinations may be mapped to `DraftCommand` values, which may
 * correspond to command functions that modify the editor or its contents.
 *
 * See `getDefaultKeyBinding` for defaults. Alternatively, the top-level
 * component may provide a custom mapping via the `keyBindingFn` prop.
 */
    function editOnKeyDown(editor, e) {
        var keyCode = e.which, editorState = editor._latestEditorState;
        switch (keyCode) {
          case Keys.RETURN:
            // The top-level component may manually handle newline insertion. If
            // no special handling is performed, fall through to command handling.
            if (e.preventDefault(), editor.props.handleReturn && isEventHandled(editor.props.handleReturn(e, editorState))) return;
            break;

          case Keys.ESC:
            return e.preventDefault(), void (editor.props.onEscape && editor.props.onEscape(e));

          case Keys.TAB:
            return void (editor.props.onTab && editor.props.onTab(e));

          case Keys.UP:
            return void (editor.props.onUpArrow && editor.props.onUpArrow(e));

          case Keys.DOWN:
            return void (editor.props.onDownArrow && editor.props.onDownArrow(e));

          case Keys.SPACE:
            // Handling for OSX where option + space scrolls.
            if (isChrome && isOptionKeyCommand(e)) {
                e.preventDefault();
                // Insert a nbsp into the editor.
                var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), " ");
                return void editor.update(EditorState.push(editorState, contentState, "insert-characters"));
            }
        }
        var command = editor.props.keyBindingFn(e);
        // If no command is specified, allow keydown event to continue.
        if (command) {
            if ("undo" === command) // Since undo requires some special updating behavior to keep the editor
            // in sync, handle it separately.
            return void keyCommandUndo(e, editorState, editor.update);
            // Allow components higher up the tree to handle the command first.
            if (// At this point, we know that we're handling a command of some kind, so
            // we don't want to insert a character following the keydown.
            e.preventDefault(), !editor.props.handleKeyCommand || !isEventHandled(editor.props.handleKeyCommand(command, editorState))) {
                var newState = onKeyCommand(command, editorState);
                newState !== editorState && editor.update(newState);
            }
        }
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnKeyDown
 * 
 */
    var DraftModifier = __webpack_require__(5), EditorState = __webpack_require__(0), KeyBindingUtil = __webpack_require__(62), Keys = __webpack_require__(59), SecondaryClipboard = __webpack_require__(234), UserAgent = __webpack_require__(17), keyCommandBackspaceToStartOfLine = __webpack_require__(235), keyCommandBackspaceWord = __webpack_require__(237), keyCommandDeleteWord = __webpack_require__(239), keyCommandInsertNewline = __webpack_require__(240), keyCommandPlainBackspace = __webpack_require__(241), keyCommandPlainDelete = __webpack_require__(242), keyCommandMoveSelectionToEndOfBlock = __webpack_require__(243), keyCommandMoveSelectionToStartOfBlock = __webpack_require__(244), keyCommandTransposeCharacters = __webpack_require__(245), keyCommandUndo = __webpack_require__(246), isEventHandled = __webpack_require__(61), isOptionKeyCommand = KeyBindingUtil.isOptionKeyCommand, isChrome = UserAgent.isBrowser("Chrome");
    module.exports = editOnKeyDown;
}, /* 234 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SecondaryClipboard
 * 
 */
    var DraftModifier = __webpack_require__(5), EditorState = __webpack_require__(0), getContentStateFragment = __webpack_require__(57), nullthrows = __webpack_require__(8), clipboard = null, SecondaryClipboard = {
        cut: function(editorState) {
            var content = editorState.getCurrentContent(), selection = editorState.getSelection(), targetRange = null;
            if (selection.isCollapsed()) {
                var anchorKey = selection.getAnchorKey(), blockEnd = content.getBlockForKey(anchorKey).getLength();
                if (blockEnd === selection.getAnchorOffset()) return editorState;
                targetRange = selection.set("focusOffset", blockEnd);
            } else targetRange = selection;
            targetRange = nullthrows(targetRange), clipboard = getContentStateFragment(content, targetRange);
            var afterRemoval = DraftModifier.removeRange(content, targetRange, "forward");
            return afterRemoval === content ? editorState : EditorState.push(editorState, afterRemoval, "remove-range");
        },
        paste: function(editorState) {
            if (!clipboard) return editorState;
            var newContent = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), clipboard);
            return EditorState.push(editorState, newContent, "insert-fragment");
        }
    };
    module.exports = SecondaryClipboard;
}, /* 235 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /* WEBPACK VAR INJECTION */
    (function(global) {
        function keyCommandBackspaceToStartOfLine(editorState) {
            var afterRemoval = removeTextWithStrategy(editorState, function(strategyState) {
                var selection = strategyState.getSelection();
                if (selection.isCollapsed() && 0 === selection.getAnchorOffset()) return moveSelectionBackward(strategyState, 1);
                var domSelection = global.getSelection(), range = domSelection.getRangeAt(0);
                return range = expandRangeToStartOfLine(range), getDraftEditorSelectionWithNodes(strategyState, null, range.endContainer, range.endOffset, range.startContainer, range.startOffset).selectionState;
            }, "backward");
            return afterRemoval === editorState.getCurrentContent() ? editorState : EditorState.push(editorState, afterRemoval, "remove-range");
        }
        /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandBackspaceToStartOfLine
 * 
 */
        var EditorState = __webpack_require__(0), expandRangeToStartOfLine = __webpack_require__(236), getDraftEditorSelectionWithNodes = __webpack_require__(127), moveSelectionBackward = __webpack_require__(89), removeTextWithStrategy = __webpack_require__(47);
        module.exports = keyCommandBackspaceToStartOfLine;
    }).call(exports, __webpack_require__(28));
}, /* 236 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Return the computed line height, in pixels, for the provided element.
 */
    function getLineHeightPx(element) {
        var computed = getComputedStyle(element), div = document.createElement("div");
        div.style.fontFamily = computed.fontFamily, div.style.fontSize = computed.fontSize, 
        div.style.fontStyle = computed.fontStyle, div.style.fontWeight = computed.fontWeight, 
        div.style.lineHeight = computed.lineHeight, div.style.position = "absolute", div.textContent = "M";
        var documentBody = document.body;
        documentBody || invariant(!1), // forced layout here
        documentBody.appendChild(div);
        var rect = div.getBoundingClientRect();
        return documentBody.removeChild(div), rect.height;
    }
    /**
 * Return whether every ClientRect in the provided list lies on the same line.
 *
 * We assume that the rects on the same line all contain the baseline, so the
 * lowest top line needs to be above the highest bottom line (i.e., if you were
 * to project the rects onto the y-axis, their intersection would be nonempty).
 *
 * In addition, we require that no two boxes are lineHeight (or more) apart at
 * either top or bottom, which helps protect against false positives for fonts
 * with extremely large glyph heights (e.g., with a font size of 17px, Zapfino
 * produces rects of height 58px!).
 */
    function areRectsOnOneLine(rects, lineHeight) {
        for (var minTop = 1 / 0, minBottom = 1 / 0, maxTop = -1 / 0, maxBottom = -1 / 0, ii = 0; ii < rects.length; ii++) {
            var rect = rects[ii];
            0 !== rect.width && 1 !== rect.width && (minTop = Math.min(minTop, rect.top), minBottom = Math.min(minBottom, rect.bottom), 
            maxTop = Math.max(maxTop, rect.top), maxBottom = Math.max(maxBottom, rect.bottom));
        }
        return maxTop <= minBottom && maxTop - minTop < lineHeight && maxBottom - minBottom < lineHeight;
    }
    /**
 * Return the length of a node, as used by Range offsets.
 */
    function getNodeLength(node) {
        // http://www.w3.org/TR/dom/#concept-node-length
        switch (node.nodeType) {
          case Node.DOCUMENT_TYPE_NODE:
            return 0;

          case Node.TEXT_NODE:
          case Node.PROCESSING_INSTRUCTION_NODE:
          case Node.COMMENT_NODE:
            return node.length;

          default:
            return node.childNodes.length;
        }
    }
    /**
 * Given a collapsed range, move the start position backwards as far as
 * possible while the range still spans only a single line.
 */
    function expandRangeToStartOfLine(range) {
        range.collapsed || invariant(!1), range = range.cloneRange();
        var containingElement = range.startContainer;
        1 !== containingElement.nodeType && (containingElement = containingElement.parentNode);
        var lineHeight = getLineHeightPx(containingElement), bestContainer = range.endContainer, bestOffset = range.endOffset;
        for (range.setStart(range.startContainer, 0); areRectsOnOneLine(getRangeClientRects(range), lineHeight) && (bestContainer = range.startContainer, 
        bestOffset = range.startOffset, bestContainer.parentNode || invariant(!1), range.setStartBefore(bestContainer), 
        1 !== bestContainer.nodeType || "inline" === getComputedStyle(bestContainer).display); ) ;
        for (// In the above example, range now spans from "<div>" to "under",
        // bestContainer is <div>, and bestOffset is 1 (index of <q> inside <div>)].
        // Picking out which child to recurse into here is a special case since we
        // don't want to check past <q> -- once we find that the final range starts
        // in <span>, we can look at all of its children (and all of their children)
        // to find the break point.
        // At all times, (bestContainer, bestOffset) is the latest single-line start
        // point that we know of.
        var currentContainer = bestContainer, maxIndexToConsider = bestOffset - 1; ;) {
            for (var nodeValue = currentContainer.nodeValue, ii = maxIndexToConsider; ii >= 0; ii--) if (!(null != nodeValue && ii > 0 && UnicodeUtils.isSurrogatePair(nodeValue, ii - 1))) {
                if (range.setStart(currentContainer, ii), !areRectsOnOneLine(getRangeClientRects(range), lineHeight)) break;
                bestContainer = currentContainer, bestOffset = ii;
            }
            if (-1 === ii || 0 === currentContainer.childNodes.length) // If ii === -1, then (bestContainer, bestOffset), which is equal to
            // (currentContainer, 0), was a single-line start point but a start
            // point before currentContainer wasn't, so the line break seems to
            // have occurred immediately after currentContainer's start tag
            //
            // If currentContainer.childNodes.length === 0, we're already at a
            // terminal node (e.g., text node) and should return our current best.
            break;
            currentContainer = currentContainer.childNodes[ii], maxIndexToConsider = getNodeLength(currentContainer);
        }
        return range.setStart(bestContainer, bestOffset), range;
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule expandRangeToStartOfLine
 * @typechecks
 * 
 */
    var UnicodeUtils = __webpack_require__(37), getRangeClientRects = __webpack_require__(126), invariant = __webpack_require__(2);
    module.exports = expandRangeToStartOfLine;
}, /* 237 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Delete the word that is left of the cursor, as well as any spaces or
 * punctuation after the word.
 */
    function keyCommandBackspaceWord(editorState) {
        var afterRemoval = removeTextWithStrategy(editorState, function(strategyState) {
            var selection = strategyState.getSelection(), offset = selection.getStartOffset();
            // If there are no words before the cursor, remove the preceding newline.
            if (0 === offset) return moveSelectionBackward(strategyState, 1);
            var key = selection.getStartKey(), content = strategyState.getCurrentContent(), text = content.getBlockForKey(key).getText().slice(0, offset), toRemove = DraftRemovableWord.getBackward(text);
            return moveSelectionBackward(strategyState, toRemove.length || 1);
        }, "backward");
        return afterRemoval === editorState.getCurrentContent() ? editorState : EditorState.push(editorState, afterRemoval, "remove-range");
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandBackspaceWord
 * 
 */
    var DraftRemovableWord = __webpack_require__(128), EditorState = __webpack_require__(0), moveSelectionBackward = __webpack_require__(89), removeTextWithStrategy = __webpack_require__(47);
    module.exports = keyCommandBackspaceWord;
}, /* 238 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    module.exports = {
        getPunctuation: function() {
            return "[.,+*?$|#{}()'\\^\\-\\[\\]\\\\\\/!@%\"~=<>_:;・、。〈-】〔-〟：-？！-／［-｀｛-･⸮؟٪-٬؛،؍﴾﴿᠁।၊။‐-‧‰-⁞¡-±´-¸º»¿]";
        }
    };
}, /* 239 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Delete the word that is right of the cursor, as well as any spaces or
 * punctuation before the word.
 */
    function keyCommandDeleteWord(editorState) {
        var afterRemoval = removeTextWithStrategy(editorState, function(strategyState) {
            var selection = strategyState.getSelection(), offset = selection.getStartOffset(), key = selection.getStartKey(), content = strategyState.getCurrentContent(), text = content.getBlockForKey(key).getText().slice(offset), toRemove = DraftRemovableWord.getForward(text);
            // If there are no words in front of the cursor, remove the newline.
            return moveSelectionForward(strategyState, toRemove.length || 1);
        }, "forward");
        return afterRemoval === editorState.getCurrentContent() ? editorState : EditorState.push(editorState, afterRemoval, "remove-range");
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandDeleteWord
 * 
 */
    var DraftRemovableWord = __webpack_require__(128), EditorState = __webpack_require__(0), moveSelectionForward = __webpack_require__(129), removeTextWithStrategy = __webpack_require__(47);
    module.exports = keyCommandDeleteWord;
}, /* 240 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function keyCommandInsertNewline(editorState) {
        var contentState = DraftModifier.splitBlock(editorState.getCurrentContent(), editorState.getSelection());
        return EditorState.push(editorState, contentState, "split-block");
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandInsertNewline
 * 
 */
    var DraftModifier = __webpack_require__(5), EditorState = __webpack_require__(0);
    module.exports = keyCommandInsertNewline;
}, /* 241 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Remove the selected range. If the cursor is collapsed, remove the preceding
 * character. This operation is Unicode-aware, so removing a single character
 * will remove a surrogate pair properly as well.
 */
    function keyCommandPlainBackspace(editorState) {
        var afterRemoval = removeTextWithStrategy(editorState, function(strategyState) {
            var selection = strategyState.getSelection(), content = strategyState.getCurrentContent(), key = selection.getAnchorKey(), offset = selection.getAnchorOffset(), charBehind = content.getBlockForKey(key).getText()[offset - 1];
            return moveSelectionBackward(strategyState, charBehind ? UnicodeUtils.getUTF16Length(charBehind, 0) : 1);
        }, "backward");
        if (afterRemoval === editorState.getCurrentContent()) return editorState;
        var selection = editorState.getSelection();
        return EditorState.push(editorState, afterRemoval.set("selectionBefore", selection), selection.isCollapsed() ? "backspace-character" : "remove-range");
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandPlainBackspace
 * 
 */
    var EditorState = __webpack_require__(0), UnicodeUtils = __webpack_require__(37), moveSelectionBackward = __webpack_require__(89), removeTextWithStrategy = __webpack_require__(47);
    module.exports = keyCommandPlainBackspace;
}, /* 242 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Remove the selected range. If the cursor is collapsed, remove the following
 * character. This operation is Unicode-aware, so removing a single character
 * will remove a surrogate pair properly as well.
 */
    function keyCommandPlainDelete(editorState) {
        var afterRemoval = removeTextWithStrategy(editorState, function(strategyState) {
            var selection = strategyState.getSelection(), content = strategyState.getCurrentContent(), key = selection.getAnchorKey(), offset = selection.getAnchorOffset(), charAhead = content.getBlockForKey(key).getText()[offset];
            return moveSelectionForward(strategyState, charAhead ? UnicodeUtils.getUTF16Length(charAhead, 0) : 1);
        }, "forward");
        if (afterRemoval === editorState.getCurrentContent()) return editorState;
        var selection = editorState.getSelection();
        return EditorState.push(editorState, afterRemoval.set("selectionBefore", selection), selection.isCollapsed() ? "delete-character" : "remove-range");
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandPlainDelete
 * 
 */
    var EditorState = __webpack_require__(0), UnicodeUtils = __webpack_require__(37), moveSelectionForward = __webpack_require__(129), removeTextWithStrategy = __webpack_require__(47);
    module.exports = keyCommandPlainDelete;
}, /* 243 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * See comment for `moveSelectionToStartOfBlock`.
 */
    function keyCommandMoveSelectionToEndOfBlock(editorState) {
        var selection = editorState.getSelection(), endKey = selection.getEndKey(), content = editorState.getCurrentContent(), textLength = content.getBlockForKey(endKey).getLength();
        return EditorState.set(editorState, {
            selection: selection.merge({
                anchorKey: endKey,
                anchorOffset: textLength,
                focusKey: endKey,
                focusOffset: textLength,
                isBackward: !1
            }),
            forceSelection: !0
        });
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandMoveSelectionToEndOfBlock
 * 
 */
    var EditorState = __webpack_require__(0);
    module.exports = keyCommandMoveSelectionToEndOfBlock;
}, /* 244 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Collapse selection at the start of the first selected block. This is used
 * for Firefox versions that attempt to navigate forward/backward instead of
 * moving the cursor. Other browsers are able to move the cursor natively.
 */
    function keyCommandMoveSelectionToStartOfBlock(editorState) {
        var selection = editorState.getSelection(), startKey = selection.getStartKey();
        return EditorState.set(editorState, {
            selection: selection.merge({
                anchorKey: startKey,
                anchorOffset: 0,
                focusKey: startKey,
                focusOffset: 0,
                isBackward: !1
            }),
            forceSelection: !0
        });
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandMoveSelectionToStartOfBlock
 * 
 */
    var EditorState = __webpack_require__(0);
    module.exports = keyCommandMoveSelectionToStartOfBlock;
}, /* 245 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Transpose the characters on either side of a collapsed cursor, or
 * if the cursor is at the end of the block, transpose the last two
 * characters.
 */
    function keyCommandTransposeCharacters(editorState) {
        var selection = editorState.getSelection();
        if (!selection.isCollapsed()) return editorState;
        var offset = selection.getAnchorOffset();
        if (0 === offset) return editorState;
        var blockKey = selection.getAnchorKey(), content = editorState.getCurrentContent(), block = content.getBlockForKey(blockKey), length = block.getLength();
        // Nothing to transpose if there aren't two characters.
        if (length <= 1) return editorState;
        var removalRange, finalSelection;
        offset === length ? (// The cursor is at the end of the block. Swap the last two characters.
        removalRange = selection.set("anchorOffset", offset - 1), finalSelection = selection) : (removalRange = selection.set("focusOffset", offset + 1), 
        finalSelection = removalRange.set("anchorOffset", offset + 1));
        // Extract the character to move as a fragment. This preserves its
        // styling and entity, if any.
        var movedFragment = getContentStateFragment(content, removalRange), afterRemoval = DraftModifier.removeRange(content, removalRange, "backward"), selectionAfter = afterRemoval.getSelectionAfter(), targetOffset = selectionAfter.getAnchorOffset() - 1, targetRange = selectionAfter.merge({
            anchorOffset: targetOffset,
            focusOffset: targetOffset
        }), afterInsert = DraftModifier.replaceWithFragment(afterRemoval, targetRange, movedFragment), newEditorState = EditorState.push(editorState, afterInsert, "insert-fragment");
        return EditorState.acceptSelection(newEditorState, finalSelection);
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandTransposeCharacters
 * 
 */
    var DraftModifier = __webpack_require__(5), EditorState = __webpack_require__(0), getContentStateFragment = __webpack_require__(57);
    module.exports = keyCommandTransposeCharacters;
}, /* 246 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function keyCommandUndo(e, editorState, updateFn) {
        var undoneState = EditorState.undo(editorState);
        // If the last change to occur was a spellcheck change, allow the undo
        // event to fall through to the browser. This allows the browser to record
        // the unwanted change, which should soon lead it to learn not to suggest
        // the correction again.
        if ("spellcheck-change" === editorState.getLastChangeType()) {
            var nativelyRenderedContent = undoneState.getCurrentContent();
            return void updateFn(EditorState.set(undoneState, {
                nativelyRenderedContent: nativelyRenderedContent
            }));
        }
        if (// Otheriwse, manage the undo behavior manually.
        e.preventDefault(), !editorState.getNativelyRenderedContent()) return void updateFn(undoneState);
        // Trigger a re-render with the current content state to ensure that the
        // component tree has up-to-date props for comparison.
        updateFn(EditorState.set(editorState, {
            nativelyRenderedContent: null
        })), // Wait to ensure that the re-render has occurred before performing
        // the undo action.
        setTimeout(function() {
            updateFn(undoneState);
        }, 0);
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandUndo
 * 
 */
    var EditorState = __webpack_require__(0);
    module.exports = keyCommandUndo;
}, /* 247 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Paste content.
 */
    function editOnPaste(editor, e) {
        e.preventDefault();
        var data = new DataTransfer(e.clipboardData);
        // Get files, unless this is likely to be a string the user wants inline.
        if (!data.isRichText()) {
            var files = data.getFiles(), defaultFileText = data.getText();
            if (files.length > 0) {
                // Allow customized paste handling for images, etc. Otherwise, fall
                // through to insert text contents into the editor.
                if (editor.props.handlePastedFiles && isEventHandled(editor.props.handlePastedFiles(files))) return;
                return void getTextContentFromFiles(files, function(/*string*/ fileText) {
                    if (fileText = fileText || defaultFileText) {
                        var editorState = editor._latestEditorState, blocks = splitTextIntoTextBlocks(fileText), character = CharacterMetadata.create({
                            style: editorState.getCurrentInlineStyle(),
                            entity: getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())
                        }), text = DraftPasteProcessor.processText(blocks, character), fragment = BlockMapBuilder.createFromArray(text), withInsertedText = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment);
                        editor.update(EditorState.push(editorState, withInsertedText, "insert-fragment"));
                    }
                });
            }
        }
        var textBlocks = [], text = data.getText(), html = data.getHTML(), editorState = editor._latestEditorState;
        if (!editor.props.handlePastedText || !isEventHandled(editor.props.handlePastedText(text, html, editorState))) {
            if (text && (textBlocks = splitTextIntoTextBlocks(text)), !editor.props.stripPastedStyles) {
                // If the text from the paste event is rich content that matches what we
                // already have on the internal clipboard, assume that we should just use
                // the clipboard fragment for the paste. This will allow us to preserve
                // styling and entities, if any are present. Note that newlines are
                // stripped during comparison -- this is because copy/paste within the
                // editor in Firefox and IE will not include empty lines. The resulting
                // paste will preserve the newlines correctly.
                var internalClipboard = editor.getClipboard();
                if (data.isRichText() && internalClipboard) {
                    if (// If the editorKey is present in the pasted HTML, it should be safe to
                    // assume this is an internal paste.
                    -1 !== html.indexOf(editor.getEditorKey()) || // The copy may have been made within a single block, in which case the
                    // editor key won't be part of the paste. In this case, just check
                    // whether the pasted text matches the internal clipboard.
                    1 === textBlocks.length && 1 === internalClipboard.size && internalClipboard.first().getText() === text) return void editor.update(insertFragment(editor._latestEditorState, internalClipboard));
                } else if (internalClipboard && data.types.includes("com.apple.webarchive") && !data.types.includes("text/html") && areTextBlocksAndClipboardEqual(textBlocks, internalClipboard)) // Safari does not properly store text/html in some cases.
                // Use the internalClipboard if present and equal to what is on
                // the clipboard. See https://bugs.webkit.org/show_bug.cgi?id=19893.
                return void editor.update(insertFragment(editor._latestEditorState, internalClipboard));
                // If there is html paste data, try to parse that.
                if (html) {
                    var htmlFragment = DraftPasteProcessor.processHTML(html, editor.props.blockRenderMap);
                    if (htmlFragment) {
                        var contentBlocks = htmlFragment.contentBlocks, entityMap = htmlFragment.entityMap;
                        if (contentBlocks) {
                            var htmlMap = BlockMapBuilder.createFromArray(contentBlocks);
                            return void editor.update(insertFragment(editor._latestEditorState, htmlMap, entityMap));
                        }
                    }
                }
                // Otherwise, create a new fragment from our pasted text. Also
                // empty the internal clipboard, since it's no longer valid.
                editor.setClipboard(null);
            }
            if (textBlocks.length) {
                var character = CharacterMetadata.create({
                    style: editorState.getCurrentInlineStyle(),
                    entity: getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())
                }), textFragment = DraftPasteProcessor.processText(textBlocks, character), textMap = BlockMapBuilder.createFromArray(textFragment);
                editor.update(insertFragment(editor._latestEditorState, textMap));
            }
        }
    }
    function insertFragment(editorState, fragment, entityMap) {
        var newContent = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment);
        // TODO: merge the entity map once we stop using DraftEntity
        // like this:
        // const mergedEntityMap = newContent.getEntityMap().merge(entityMap);
        return EditorState.push(editorState, newContent.set("entityMap", entityMap), "insert-fragment");
    }
    function areTextBlocksAndClipboardEqual(textBlocks, blockMap) {
        return textBlocks.length === blockMap.size && blockMap.valueSeq().every(function(block, ii) {
            return block.getText() === textBlocks[ii];
        });
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnPaste
 * 
 */
    var BlockMapBuilder = __webpack_require__(44), CharacterMetadata = __webpack_require__(11), DataTransfer = __webpack_require__(121), DraftModifier = __webpack_require__(5), DraftPasteProcessor = __webpack_require__(248), EditorState = __webpack_require__(0), getEntityKeyForSelection = __webpack_require__(85), getTextContentFromFiles = __webpack_require__(123), isEventHandled = __webpack_require__(61), splitTextIntoTextBlocks = __webpack_require__(250);
    module.exports = editOnPaste;
}, /* 248 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftPasteProcessor
 * @typechecks
 * 
 */
    var ContentBlock = (__webpack_require__(11), __webpack_require__(34)), Immutable = __webpack_require__(1), convertFromHTMLtoContentBlocks = __webpack_require__(130), generateRandomKey = __webpack_require__(16), getSafeBodyFromHTML = __webpack_require__(131), sanitizeDraftText = __webpack_require__(82), List = Immutable.List, Repeat = Immutable.Repeat, DraftPasteProcessor = {
        processHTML: function(html, blockRenderMap) {
            return convertFromHTMLtoContentBlocks(html, getSafeBodyFromHTML, blockRenderMap);
        },
        processText: function(textBlocks, character) {
            return textBlocks.map(function(textLine) {
                return textLine = sanitizeDraftText(textLine), new ContentBlock({
                    key: generateRandomKey(),
                    type: "unstyled",
                    text: textLine,
                    characterList: List(Repeat(character, textLine.length))
                });
            });
        }
    };
    module.exports = DraftPasteProcessor;
}, /* 249 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    var URI = function() {
        function URI(uri) {
            _classCallCheck(this, URI), this._uri = uri;
        }
        return URI.prototype.toString = function() {
            return this._uri;
        }, URI;
    }();
    module.exports = URI;
}, /* 250 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function splitTextIntoTextBlocks(text) {
        return text.split(NEWLINE_REGEX);
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule splitTextIntoTextBlocks
 * 
 */
    var NEWLINE_REGEX = /\r\n?|\n/g;
    module.exports = splitTextIntoTextBlocks;
}, /* 251 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function editOnSelect(editor) {
        if (!editor._blockSelectEvents && editor._latestEditorState === editor.props.editorState) {
            var editorState = editor.props.editorState, editorNode = ReactDOM.findDOMNode(editor.refs.editorContainer);
            editorNode || invariant(!1), editorNode.firstChild instanceof HTMLElement || invariant(!1);
            var documentSelection = getDraftEditorSelection(editorState, editorNode.firstChild), updatedSelectionState = documentSelection.selectionState;
            updatedSelectionState !== editorState.getSelection() && (editorState = documentSelection.needsRecovery ? EditorState.forceSelection(editorState, updatedSelectionState) : EditorState.acceptSelection(editorState, updatedSelectionState), 
            editor.update(editorState));
        }
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnSelect
 * 
 */
    var EditorState = __webpack_require__(0), ReactDOM = __webpack_require__(36), getDraftEditorSelection = __webpack_require__(252), invariant = __webpack_require__(2);
    module.exports = editOnSelect;
}, /* 252 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /* WEBPACK VAR INJECTION */
    (function(global) {
        /**
 * Convert the current selection range to an anchor/focus pair of offset keys
 * and values that can be interpreted by components.
 */
        function getDraftEditorSelection(editorState, root) {
            var selection = global.getSelection();
            // No active selection.
            // No active selection.
            return 0 === selection.rangeCount ? {
                selectionState: editorState.getSelection().set("hasFocus", !1),
                needsRecovery: !1
            } : getDraftEditorSelectionWithNodes(editorState, root, selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
        }
        /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getDraftEditorSelection
 * @typechecks
 * 
 */
        var getDraftEditorSelectionWithNodes = __webpack_require__(127);
        module.exports = getDraftEditorSelection;
    }).call(exports, __webpack_require__(28));
}, /* 253 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorPlaceholder.react
 * @typechecks
 * 
 */
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !call || "object" != typeof call && "function" != typeof call ? self : call;
    }
    function _inherits(subClass, superClass) {
        if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
    }
    var React = __webpack_require__(3), cx = __webpack_require__(46), DraftEditorPlaceholder = function(_React$Component) {
        function DraftEditorPlaceholder() {
            return _classCallCheck(this, DraftEditorPlaceholder), _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        return _inherits(DraftEditorPlaceholder, _React$Component), DraftEditorPlaceholder.prototype.shouldComponentUpdate = function(nextProps) {
            return this.props.text !== nextProps.text || this.props.editorState.getSelection().getHasFocus() !== nextProps.editorState.getSelection().getHasFocus();
        }, DraftEditorPlaceholder.prototype.render = function() {
            var hasFocus = this.props.editorState.getSelection().getHasFocus(), className = cx({
                "public/DraftEditorPlaceholder/root": !0,
                "public/DraftEditorPlaceholder/hasFocus": hasFocus
            });
            return React.createElement("div", {
                className: className
            }, React.createElement("div", {
                className: cx("public/DraftEditorPlaceholder/inner"),
                id: this.props.accessibilityID
            }, this.props.text));
        }, DraftEditorPlaceholder;
    }(React.Component);
    module.exports = DraftEditorPlaceholder;
}, /* 254 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule RichTextEditorUtil
 * @typechecks
 * 
 */
    var DraftModifier = __webpack_require__(5), EditorState = __webpack_require__(0), adjustBlockDepthForContentState = (__webpack_require__(45), 
    __webpack_require__(255)), nullthrows = __webpack_require__(8), RichTextEditorUtil = {
        currentBlockContainsLink: function(editorState) {
            var selection = editorState.getSelection(), contentState = editorState.getCurrentContent(), entityMap = contentState.getEntityMap();
            return contentState.getBlockForKey(selection.getAnchorKey()).getCharacterList().slice(selection.getStartOffset(), selection.getEndOffset()).some(function(v) {
                var entity = v.getEntity();
                return !!entity && "LINK" === entityMap.__get(entity).getType();
            });
        },
        getCurrentBlockType: function(editorState) {
            var selection = editorState.getSelection();
            return editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
        },
        getDataObjectForLinkURL: function(uri) {
            return {
                url: uri.toString()
            };
        },
        handleKeyCommand: function(editorState, command) {
            switch (command) {
              case "bold":
                return RichTextEditorUtil.toggleInlineStyle(editorState, "BOLD");

              case "italic":
                return RichTextEditorUtil.toggleInlineStyle(editorState, "ITALIC");

              case "underline":
                return RichTextEditorUtil.toggleInlineStyle(editorState, "UNDERLINE");

              case "code":
                return RichTextEditorUtil.toggleCode(editorState);

              case "backspace":
              case "backspace-word":
              case "backspace-to-start-of-line":
                return RichTextEditorUtil.onBackspace(editorState);

              case "delete":
              case "delete-word":
              case "delete-to-end-of-block":
                return RichTextEditorUtil.onDelete(editorState);

              default:
                // they may have custom editor commands; ignore those
                return null;
            }
        },
        insertSoftNewline: function(editorState) {
            var contentState = DraftModifier.insertText(editorState.getCurrentContent(), editorState.getSelection(), "\n", editorState.getCurrentInlineStyle(), null), newEditorState = EditorState.push(editorState, contentState, "insert-characters");
            return EditorState.forceSelection(newEditorState, contentState.getSelectionAfter());
        },
        /**
   * For collapsed selections at the start of styled blocks, backspace should
   * just remove the existing style.
   */
        onBackspace: function(editorState) {
            var selection = editorState.getSelection();
            if (!selection.isCollapsed() || selection.getAnchorOffset() || selection.getFocusOffset()) return null;
            // First, try to remove a preceding atomic block.
            var content = editorState.getCurrentContent(), startKey = selection.getStartKey(), blockBefore = content.getBlockBefore(startKey);
            if (blockBefore && "atomic" === blockBefore.getType()) {
                var blockMap = content.getBlockMap().delete(blockBefore.getKey()), withoutAtomicBlock = content.merge({
                    blockMap: blockMap,
                    selectionAfter: selection
                });
                if (withoutAtomicBlock !== content) return EditorState.push(editorState, withoutAtomicBlock, "remove-range");
            }
            // If that doesn't succeed, try to remove the current block style.
            var withoutBlockStyle = RichTextEditorUtil.tryToRemoveBlockStyle(editorState);
            return withoutBlockStyle ? EditorState.push(editorState, withoutBlockStyle, "change-block-type") : null;
        },
        onDelete: function(editorState) {
            var selection = editorState.getSelection();
            if (!selection.isCollapsed()) return null;
            var content = editorState.getCurrentContent(), startKey = selection.getStartKey(), block = content.getBlockForKey(startKey), length = block.getLength();
            // The cursor is somewhere within the text. Behave normally.
            if (selection.getStartOffset() < length) return null;
            var blockAfter = content.getBlockAfter(startKey);
            if (!blockAfter || "atomic" !== blockAfter.getType()) return null;
            var atomicBlockTarget = selection.merge({
                focusKey: blockAfter.getKey(),
                focusOffset: blockAfter.getLength()
            }), withoutAtomicBlock = DraftModifier.removeRange(content, atomicBlockTarget, "forward");
            return withoutAtomicBlock !== content ? EditorState.push(editorState, withoutAtomicBlock, "remove-range") : null;
        },
        onTab: function(event, editorState, maxDepth) {
            var selection = editorState.getSelection(), key = selection.getAnchorKey();
            if (key !== selection.getFocusKey()) return editorState;
            var content = editorState.getCurrentContent(), block = content.getBlockForKey(key), type = block.getType();
            if ("unordered-list-item" !== type && "ordered-list-item" !== type) return editorState;
            event.preventDefault();
            // Only allow indenting one level beyond the block above, and only if
            // the block above is a list item as well.
            var blockAbove = content.getBlockBefore(key);
            if (!blockAbove) return editorState;
            var typeAbove = blockAbove.getType();
            if ("unordered-list-item" !== typeAbove && "ordered-list-item" !== typeAbove) return editorState;
            var depth = block.getDepth();
            if (!event.shiftKey && depth === maxDepth) return editorState;
            maxDepth = Math.min(blockAbove.getDepth() + 1, maxDepth);
            var withAdjustment = adjustBlockDepthForContentState(content, selection, event.shiftKey ? -1 : 1, maxDepth);
            return EditorState.push(editorState, withAdjustment, "adjust-depth");
        },
        toggleBlockType: function(editorState, blockType) {
            var selection = editorState.getSelection(), startKey = selection.getStartKey(), endKey = selection.getEndKey(), content = editorState.getCurrentContent(), target = selection;
            // Triple-click can lead to a selection that includes offset 0 of the
            // following block. The `SelectionState` for this case is accurate, but
            // we should avoid toggling block type for the trailing block because it
            // is a confusing interaction.
            if (startKey !== endKey && 0 === selection.getEndOffset()) {
                var blockBefore = nullthrows(content.getBlockBefore(endKey));
                endKey = blockBefore.getKey(), target = target.merge({
                    anchorKey: startKey,
                    anchorOffset: selection.getStartOffset(),
                    focusKey: endKey,
                    focusOffset: blockBefore.getLength(),
                    isBackward: !1
                });
            }
            if (content.getBlockMap().skipWhile(function(_, k) {
                return k !== startKey;
            }).reverse().skipWhile(function(_, k) {
                return k !== endKey;
            }).some(function(v) {
                return "atomic" === v.getType();
            })) return editorState;
            var typeToSet = content.getBlockForKey(startKey).getType() === blockType ? "unstyled" : blockType;
            return EditorState.push(editorState, DraftModifier.setBlockType(content, target, typeToSet), "change-block-type");
        },
        toggleCode: function(editorState) {
            var selection = editorState.getSelection(), anchorKey = selection.getAnchorKey(), focusKey = selection.getFocusKey();
            return selection.isCollapsed() || anchorKey !== focusKey ? RichTextEditorUtil.toggleBlockType(editorState, "code-block") : RichTextEditorUtil.toggleInlineStyle(editorState, "CODE");
        },
        /**
   * Toggle the specified inline style for the selection. If the
   * user's selection is collapsed, apply or remove the style for the
   * internal state. If it is not collapsed, apply the change directly
   * to the document state.
   */
        toggleInlineStyle: function(editorState, inlineStyle) {
            var selection = editorState.getSelection(), currentStyle = editorState.getCurrentInlineStyle();
            // If the selection is collapsed, toggle the specified style on or off and
            // set the result as the new inline style override. This will then be
            // used as the inline style for the next character to be inserted.
            if (selection.isCollapsed()) return EditorState.setInlineStyleOverride(editorState, currentStyle.has(inlineStyle) ? currentStyle.remove(inlineStyle) : currentStyle.add(inlineStyle));
            // If characters are selected, immediately apply or remove the
            // inline style on the document state itself.
            var newContent, content = editorState.getCurrentContent();
            // If the style is already present for the selection range, remove it.
            // Otherwise, apply it.
            return newContent = currentStyle.has(inlineStyle) ? DraftModifier.removeInlineStyle(content, selection, inlineStyle) : DraftModifier.applyInlineStyle(content, selection, inlineStyle), 
            EditorState.push(editorState, newContent, "change-inline-style");
        },
        toggleLink: function(editorState, targetSelection, entityKey) {
            var withoutLink = DraftModifier.applyEntity(editorState.getCurrentContent(), targetSelection, entityKey);
            return EditorState.push(editorState, withoutLink, "apply-entity");
        },
        /**
   * When a collapsed cursor is at the start of an empty styled block, allow
   * certain key commands (newline, backspace) to simply change the
   * style of the block instead of the default behavior.
   */
        tryToRemoveBlockStyle: function(editorState) {
            var selection = editorState.getSelection(), offset = selection.getAnchorOffset();
            if (selection.isCollapsed() && 0 === offset) {
                var key = selection.getAnchorKey(), content = editorState.getCurrentContent(), block = content.getBlockForKey(key);
                if (block.getLength() > 0) return null;
                var type = block.getType(), blockBefore = content.getBlockBefore(key);
                if ("code-block" === type && blockBefore && "code-block" === blockBefore.getType()) return null;
                if ("unstyled" !== type) return DraftModifier.setBlockType(content, selection, "unstyled");
            }
            return null;
        }
    };
    module.exports = RichTextEditorUtil;
}, /* 255 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule adjustBlockDepthForContentState
 * @typechecks
 * 
 */
    function adjustBlockDepthForContentState(contentState, selectionState, adjustment, maxDepth) {
        var startKey = selectionState.getStartKey(), endKey = selectionState.getEndKey(), blockMap = contentState.getBlockMap(), blocks = blockMap.toSeq().skipUntil(function(_, k) {
            return k === startKey;
        }).takeUntil(function(_, k) {
            return k === endKey;
        }).concat([ [ endKey, blockMap.get(endKey) ] ]).map(function(block) {
            var depth = block.getDepth() + adjustment;
            return depth = Math.max(0, Math.min(depth, maxDepth)), block.set("depth", depth);
        });
        return blockMap = blockMap.merge(blocks), contentState.merge({
            blockMap: blockMap,
            selectionBefore: selectionState,
            selectionAfter: selectionState
        });
    }
    module.exports = adjustBlockDepthForContentState;
}, /* 256 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function convertFromDraftStateToRaw(contentState) {
        var entityStorageKey = 0, entityStorageMap = {}, rawBlocks = [];
        contentState.getBlockMap().forEach(function(block, blockKey) {
            block.findEntityRanges(function(character) {
                return null !== character.getEntity();
            }, function(start) {
                // Stringify to maintain order of otherwise numeric keys.
                var stringifiedEntityKey = DraftStringKey.stringify(block.getEntityAt(start));
                entityStorageMap.hasOwnProperty(stringifiedEntityKey) || (entityStorageMap[stringifiedEntityKey] = "" + entityStorageKey++);
            }), rawBlocks.push({
                key: blockKey,
                text: block.getText(),
                type: block.getType(),
                depth: block.getDepth(),
                inlineStyleRanges: encodeInlineStyleRanges(block),
                entityRanges: encodeEntityRanges(block, entityStorageMap),
                data: block.getData().toObject()
            });
        });
        // Flip storage map so that our storage keys map to global
        // DraftEntity keys.
        var entityKeys = Object.keys(entityStorageMap), flippedStorageMap = {};
        return entityKeys.forEach(function(key, jj) {
            var entity = contentState.getEntity(DraftStringKey.unstringify(key));
            flippedStorageMap[jj] = {
                type: entity.getType(),
                mutability: entity.getMutability(),
                data: entity.getData()
            };
        }), {
            entityMap: flippedStorageMap,
            blocks: rawBlocks
        };
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule convertFromDraftStateToRaw
 * 
 */
    var DraftStringKey = __webpack_require__(132), encodeEntityRanges = __webpack_require__(257), encodeInlineStyleRanges = __webpack_require__(258);
    module.exports = convertFromDraftStateToRaw;
}, /* 257 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Convert to UTF-8 character counts for storage.
 */
    function encodeEntityRanges(block, storageMap) {
        var encoded = [];
        return block.findEntityRanges(function(character) {
            return !!character.getEntity();
        }, function(/*number*/ start, /*number*/ end) {
            var text = block.getText(), key = block.getEntityAt(start);
            encoded.push({
                offset: strlen(text.slice(0, start)),
                length: strlen(text.slice(start, end)),
                // Encode the key as a number for range storage.
                key: Number(storageMap[DraftStringKey.stringify(key)])
            });
        }), encoded;
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule encodeEntityRanges
 * @typechecks
 * 
 */
    var DraftStringKey = __webpack_require__(132), UnicodeUtils = __webpack_require__(37), strlen = UnicodeUtils.strlen;
    module.exports = encodeEntityRanges;
}, /* 258 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Helper function for getting encoded styles for each inline style. Convert
 * to UTF-8 character counts for storage.
 */
    function getEncodedInlinesForType(block, styleList, styleToEncode) {
        var ranges = [], filteredInlines = styleList.map(function(style) {
            return style.has(styleToEncode);
        }).toList();
        // We only want to keep ranges with nonzero style values.
        return findRangesImmutable(filteredInlines, areEqual, isTruthy, function(start, end) {
            var text = block.getText();
            ranges.push({
                offset: UnicodeUtils.strlen(text.slice(0, start)),
                length: UnicodeUtils.strlen(text.slice(start, end)),
                style: styleToEncode
            });
        }), ranges;
    }
    /*
 * Retrieve the encoded arrays of inline styles, with each individual style
 * treated separately.
 */
    function encodeInlineStyleRanges(block) {
        var styleList = block.getCharacterList().map(function(c) {
            return c.getStyle();
        }).toList(), ranges = styleList.flatten().toSet().map(function(style) {
            return getEncodedInlinesForType(block, styleList, style);
        });
        return Array.prototype.concat.apply(EMPTY_ARRAY, ranges.toJS());
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule encodeInlineStyleRanges
 * 
 */
    var UnicodeUtils = __webpack_require__(37), findRangesImmutable = __webpack_require__(56), areEqual = function(a, b) {
        return a === b;
    }, isTruthy = function(a) {
        return !!a;
    }, EMPTY_ARRAY = [];
    module.exports = encodeInlineStyleRanges;
}, /* 259 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function convertFromRawToDraftState(rawState) {
        var blocks = rawState.blocks, entityMap = rawState.entityMap, fromStorageToLocal = {};
        // TODO: Update this once we completely remove DraftEntity
        Object.keys(entityMap).forEach(function(storageKey) {
            var encodedEntity = entityMap[storageKey], type = encodedEntity.type, mutability = encodedEntity.mutability, data = encodedEntity.data, newKey = DraftEntity.__create(type, mutability, data || {});
            fromStorageToLocal[storageKey] = newKey;
        });
        var contentBlocks = blocks.map(function(block) {
            var key = block.key, type = block.type, text = block.text, depth = block.depth, inlineStyleRanges = block.inlineStyleRanges, entityRanges = block.entityRanges, data = block.data;
            key = key || generateRandomKey(), type = type || "unstyled", depth = depth || 0, 
            inlineStyleRanges = inlineStyleRanges || [], entityRanges = entityRanges || [], 
            data = Map(data);
            var inlineStyles = decodeInlineStyleRanges(text, inlineStyleRanges), filteredEntityRanges = entityRanges.filter(function(range) {
                return fromStorageToLocal.hasOwnProperty(range.key);
            }).map(function(range) {
                return _extends({}, range, {
                    key: fromStorageToLocal[range.key]
                });
            }), entities = decodeEntityRanges(text, filteredEntityRanges), characterList = createCharacterList(inlineStyles, entities);
            return new ContentBlock({
                key: key,
                type: type,
                text: text,
                depth: depth,
                characterList: characterList,
                data: data
            });
        });
        return ContentState.createFromBlockArray(contentBlocks);
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule convertFromRawToDraftState
 * 
 */
    var _assign = __webpack_require__(35), _extends = _assign || function(target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
        }
        return target;
    }, ContentBlock = __webpack_require__(34), ContentState = __webpack_require__(81), DraftEntity = __webpack_require__(58), createCharacterList = __webpack_require__(260), decodeEntityRanges = __webpack_require__(261), decodeInlineStyleRanges = __webpack_require__(262), generateRandomKey = __webpack_require__(16), Immutable = __webpack_require__(1), Map = Immutable.Map;
    module.exports = convertFromRawToDraftState;
}, /* 260 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function createCharacterList(inlineStyles, entities) {
        var characterArray = inlineStyles.map(function(style, ii) {
            var entity = entities[ii];
            return CharacterMetadata.create({
                style: style,
                entity: entity
            });
        });
        return List(characterArray);
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule createCharacterList
 * @typechecks
 * 
 */
    var CharacterMetadata = __webpack_require__(11), Immutable = __webpack_require__(1), List = Immutable.List;
    module.exports = createCharacterList;
}, /* 261 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Convert to native JavaScript string lengths to determine ranges.
 */
    function decodeEntityRanges(text, ranges) {
        var entities = Array(text.length).fill(null);
        return ranges && ranges.forEach(function(range) {
            for (var start = substr(text, 0, range.offset).length, end = start + substr(text, range.offset, range.length).length, ii = start; ii < end; ii++) entities[ii] = range.key;
        }), entities;
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule decodeEntityRanges
 * @typechecks
 * 
 */
    var UnicodeUtils = __webpack_require__(37), substr = UnicodeUtils.substr;
    module.exports = decodeEntityRanges;
}, /* 262 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Convert to native JavaScript string lengths to determine ranges.
 */
    function decodeInlineStyleRanges(text, ranges) {
        var styles = Array(text.length).fill(EMPTY_SET);
        return ranges && ranges.forEach(function(/*object*/ range) {
            for (var cursor = substr(text, 0, range.offset).length, end = cursor + substr(text, range.offset, range.length).length; cursor < end; ) styles[cursor] = styles[cursor].add(range.style), 
            cursor++;
        }), styles;
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule decodeInlineStyleRanges
 * @typechecks
 * 
 */
    var UnicodeUtils = __webpack_require__(37), _require = __webpack_require__(1), OrderedSet = _require.OrderedSet, substr = UnicodeUtils.substr, EMPTY_SET = OrderedSet();
    module.exports = decodeInlineStyleRanges;
}, /* 263 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Return the bounding ClientRect for the visible DOM selection, if any.
 * In cases where there are no selected ranges or the bounding rect is
 * temporarily invalid, return null.
 */
    function getVisibleSelectionRect(global) {
        var selection = global.getSelection();
        if (!selection.rangeCount) return null;
        var range = selection.getRangeAt(0), boundingRect = getRangeBoundingClientRect(range), top = boundingRect.top, right = boundingRect.right, bottom = boundingRect.bottom, left = boundingRect.left;
        // When a re-render leads to a node being removed, the DOM selection will
        // temporarily be placed on an ancestor node, which leads to an invalid
        // bounding rect. Discard this state.
        // When a re-render leads to a node being removed, the DOM selection will
        // temporarily be placed on an ancestor node, which leads to an invalid
        // bounding rect. Discard this state.
        return 0 === top && 0 === right && 0 === bottom && 0 === left ? null : boundingRect;
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getVisibleSelectionRect
 * @typechecks
 * 
 */
    var getRangeBoundingClientRect = __webpack_require__(264);
    module.exports = getVisibleSelectionRect;
}, /* 264 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    /**
 * Like range.getBoundingClientRect() but normalizes for browser bugs.
 */
    function getRangeBoundingClientRect(range) {
        // "Return a DOMRect object describing the smallest rectangle that includes
        // the first rectangle in list and all of the remaining rectangles of which
        // the height or width is not zero."
        // http://www.w3.org/TR/cssom-view/#dom-range-getboundingclientrect
        var rects = getRangeClientRects(range), top = 0, right = 0, bottom = 0, left = 0;
        if (rects.length) {
            // If the first rectangle has 0 width, we use the second, this is needed
            // because Chrome renders a 0 width rectangle when the selection contains
            // a line break.
            if (rects.length > 1 && 0 === rects[0].width) {
                var _rects$ = rects[1];
                top = _rects$.top, right = _rects$.right, bottom = _rects$.bottom, left = _rects$.left;
            } else {
                var _rects$2 = rects[0];
                top = _rects$2.top, right = _rects$2.right, bottom = _rects$2.bottom, left = _rects$2.left;
            }
            for (var ii = 1; ii < rects.length; ii++) {
                var rect = rects[ii];
                0 !== rect.height && 0 !== rect.width && (top = Math.min(top, rect.top), right = Math.max(right, rect.right), 
                bottom = Math.max(bottom, rect.bottom), left = Math.min(left, rect.left));
            }
        }
        return {
            top: top,
            right: right,
            bottom: bottom,
            left: left,
            width: right - left,
            height: bottom - top
        };
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getRangeBoundingClientRect
 * @typechecks
 * 
 */
    var getRangeClientRects = __webpack_require__(126);
    module.exports = getRangeBoundingClientRect;
}, /* 265 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function changeBlockDepth(editorState, blockKey, newDepth) {
        var content = editorState.getCurrentContent(), block = content.getBlockForKey(blockKey);
        if (block.getDepth() === newDepth) return editorState;
        var newBlock = block.set("depth", newDepth), newContent = content.merge({
            blockMap: content.getBlockMap().set(blockKey, newBlock)
        });
        return _draftJs.EditorState.push(editorState, newContent, "adjust-depth");
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.default = changeBlockDepth;
    var _draftJs = __webpack_require__(10);
}, /* 266 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function changeBlockType(editorState, blockKey, newType) {
        var content = editorState.getCurrentContent(), block = content.getBlockForKey(blockKey);
        if (block.getType() === newType) return editorState;
        var newBlock = block.set("type", newType), newContent = content.merge({
            blockMap: content.getBlockMap().set(blockKey, newBlock)
        });
        return _draftJs.EditorState.push(editorState, newContent, "change-block-type");
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.default = changeBlockType;
    var _draftJs = __webpack_require__(10);
}, /* 267 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function getBlocksInSelection(editorState) {
        var contentState = editorState.getCurrentContent(), blockMap = contentState.getBlockMap(), selection = editorState.getSelection();
        if (selection.isCollapsed()) return new _immutable.OrderedMap();
        var startKey = selection.getStartKey(), endKey = selection.getEndKey();
        return startKey === endKey ? new _immutable.OrderedMap({
            startKey: contentState.getBlockForKey(startKey)
        }) : blockMap.takeUntil(function(block, key) {
            return key === endKey;
        }).skipUntil(function(block, key) {
            return key === startKey;
        });
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.default = getBlocksInSelection;
    var _immutable = (__webpack_require__(10), __webpack_require__(91));
}, /* 268 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function insertBlockAfter(editorState, blockKey, newType) {
        var content = editorState.getCurrentContent(), blockMap = content.getBlockMap(), block = blockMap.get(blockKey), blocksBefore = blockMap.toSeq().takeUntil(function(v) {
            return v === block;
        }), blocksAfter = blockMap.toSeq().skipUntil(function(v) {
            return v === block;
        }).rest(), newBlockKey = (0, _draftJs.genKey)(), newBlock = new _draftJs.ContentBlock({
            key: newBlockKey,
            type: newType,
            text: "",
            characterList: block.getCharacterList().slice(0, 0),
            depth: 0
        }), newBlockMap = blocksBefore.concat([ [ blockKey, block ], [ newBlockKey, newBlock ] ], blocksAfter).toOrderedMap(), selection = editorState.getSelection(), newContent = content.merge({
            blockMap: newBlockMap,
            selectionBefore: selection,
            selectionAfter: selection.merge({
                anchorKey: newBlockKey,
                anchorOffset: 0,
                focusKey: newBlockKey,
                focusOffset: 0,
                isBackward: !1
            })
        });
        return _draftJs.EditorState.push(editorState, newContent, "split-block");
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.default = insertBlockAfter;
    var _draftJs = __webpack_require__(10);
}, /* 269 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function isListItem(block) {
        var blockType = block.getType();
        return blockType === _draftJsUtils.BLOCK_TYPE.UNORDERED_LIST_ITEM || blockType === _draftJsUtils.BLOCK_TYPE.ORDERED_LIST_ITEM;
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.default = isListItem;
    var _draftJsUtils = __webpack_require__(29);
}, /* 270 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var BLOCK_TYPE = exports.BLOCK_TYPE = {
        // This is used to represent a normal text block (paragraph).
        UNSTYLED: "unstyled",
        HEADER_ONE: "header-one",
        HEADER_TWO: "header-two",
        HEADER_THREE: "header-three",
        HEADER_FOUR: "header-four",
        HEADER_FIVE: "header-five",
        HEADER_SIX: "header-six",
        UNORDERED_LIST_ITEM: "unordered-list-item",
        ORDERED_LIST_ITEM: "ordered-list-item",
        BLOCKQUOTE: "blockquote",
        PULLQUOTE: "pullquote",
        CODE: "code-block",
        ATOMIC: "atomic"
    }, ENTITY_TYPE = exports.ENTITY_TYPE = {
        LINK: "LINK",
        IMAGE: "IMAGE"
    }, INLINE_STYLE = exports.INLINE_STYLE = {
        BOLD: "BOLD",
        CODE: "CODE",
        ITALIC: "ITALIC",
        STRIKETHROUGH: "STRIKETHROUGH",
        UNDERLINE: "UNDERLINE"
    };
    exports.default = {
        BLOCK_TYPE: BLOCK_TYPE,
        ENTITY_TYPE: ENTITY_TYPE,
        INLINE_STYLE: INLINE_STYLE
    };
}, /* 271 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function getEntityRanges(text, charMetaList) {
        for (var charEntity = null, prevCharEntity = null, ranges = [], rangeStart = 0, i = 0, len = text.length; i < len; i++) {
            prevCharEntity = charEntity;
            var meta = charMetaList.get(i);
            charEntity = meta ? meta.getEntity() : null, i > 0 && charEntity !== prevCharEntity && (ranges.push([ prevCharEntity, getStyleRanges(text.slice(rangeStart, i), charMetaList.slice(rangeStart, i)) ]), 
            rangeStart = i);
        }
        return ranges.push([ charEntity, getStyleRanges(text.slice(rangeStart), charMetaList.slice(rangeStart)) ]), 
        ranges;
    }
    function getStyleRanges(text, charMetaList) {
        for (var charStyle = EMPTY_SET, prevCharStyle = EMPTY_SET, ranges = [], rangeStart = 0, i = 0, len = text.length; i < len; i++) {
            prevCharStyle = charStyle;
            var meta = charMetaList.get(i);
            charStyle = meta ? meta.getStyle() : EMPTY_SET, i > 0 && !(0, _immutable.is)(charStyle, prevCharStyle) && (ranges.push([ text.slice(rangeStart, i), prevCharStyle ]), 
            rangeStart = i);
        }
        return ranges.push([ text.slice(rangeStart), charStyle ]), ranges;
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.EMPTY_SET = void 0, exports.default = getEntityRanges;
    var _immutable = __webpack_require__(91), EMPTY_SET = exports.EMPTY_SET = new _immutable.OrderedSet();
}, /* 272 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getSelectedBlocks = __webpack_require__(92), _getSelectedBlocks2 = function(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }(_getSelectedBlocks);
    exports.default = function(strategy) {
        return function(editorState, selection) {
            var contentState = editorState.getCurrentContent(), currentSelection = selection || editorState.getSelection(), startKey = currentSelection.getStartKey(), endKey = currentSelection.getEndKey(), startOffset = currentSelection.getStartOffset(), endOffset = currentSelection.getEndOffset(), isSameBlock = startKey === endKey, selectedBlocks = (0, 
            _getSelectedBlocks2.default)(contentState, startKey, endKey), entityFound = !1, finalStartOffset = startOffset + 1, finalEndOffset = endOffset - 1;
            return selectedBlocks.forEach(function(block) {
                strategy(block, function(start, end) {
                    if (!entityFound) {
                        var blockKey = block.getKey();
                        isSameBlock && (end < finalStartOffset || start > finalEndOffset) || blockKey === startKey && end < finalStartOffset || blockKey === endKey && start > finalEndOffset || (entityFound = !0);
                    }
                }, contentState);
            }), entityFound;
        };
    };
}, /* 273 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _draftJs = __webpack_require__(10), _getSelectedBlocks = __webpack_require__(92), _getSelectedBlocks2 = function(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }(_getSelectedBlocks);
    /**
 * Calls a provided `modifier` function with a selection for each
 * selected block in the current editor selection. Passes through additional
 * arguments to the modifier.
 *
 * Note: At the moment it will retain the original selection and override
 * possible selection changes from modifiers
 *
 * @param  {object} editorState The current draft.js editor state object
 *
 * @param  {function} modifier  A modifier function to be executed.
 *                              Must have the signature (editorState, selection, ...)
 *
 * @param  {mixed} ...args      Additional arguments to be passed through to the modifier
 *
 * @return {object} The new editor state
 */
    exports.default = function(editorState, modifier) {
        for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) args[_key - 2] = arguments[_key];
        var contentState = editorState.getCurrentContent(), currentSelection = editorState.getSelection(), startKey = currentSelection.getStartKey(), endKey = currentSelection.getEndKey(), startOffset = currentSelection.getStartOffset(), endOffset = currentSelection.getEndOffset(), isSameBlock = startKey === endKey, selectedBlocks = (0, 
        _getSelectedBlocks2.default)(contentState, startKey, endKey), finalEditorState = editorState;
        return selectedBlocks.forEach(function(block) {
            var currentBlockKey = block.getKey(), selectionStart = startOffset, selectionEnd = endOffset;
            currentBlockKey === startKey ? (selectionStart = startOffset, selectionEnd = isSameBlock ? endOffset : block.getText().length) : currentBlockKey === endKey ? (selectionStart = isSameBlock ? startOffset : 0, 
            selectionEnd = endOffset) : (selectionStart = 0, selectionEnd = block.getText().length);
            var selection = new _draftJs.SelectionState({
                anchorKey: currentBlockKey,
                anchorOffset: selectionStart,
                focusKey: currentBlockKey,
                focusOffset: selectionEnd
            });
            finalEditorState = modifier.apply(void 0, [ finalEditorState, selection ].concat(args));
        }), _draftJs.EditorState.forceSelection(finalEditorState, currentSelection);
    };
}, /* 274 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function isSoftNewlineEvent(e) {
        return e.which === Keys.RETURN && (e.getModifierState("Shift") || e.getModifierState("Alt") || e.getModifierState("Control"));
    }
    /**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isSoftNewlineEvent
 * @typechecks
 * 
 */
    var Keys = __webpack_require__(59);
    module.exports = isSoftNewlineEvent;
}, /* 275 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _from = __webpack_require__(133), _from2 = _interopRequireDefault(_from), _map = __webpack_require__(280), _map2 = _interopRequireDefault(_map), _defineProperty2 = __webpack_require__(52), _defineProperty3 = _interopRequireDefault(_defineProperty2), _extends3 = __webpack_require__(19), _extends4 = _interopRequireDefault(_extends3), _typeof2 = __webpack_require__(74), _typeof3 = _interopRequireDefault(_typeof2), _getPrototypeOf = __webpack_require__(20), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(14), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(15), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(21), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(22), _inherits3 = _interopRequireDefault(_inherits2), _KeyBindingUtil = __webpack_require__(62), _react = __webpack_require__(3), _react2 = _interopRequireDefault(_react), _reactDom = __webpack_require__(36), _reactDom2 = _interopRequireDefault(_reactDom), _draftJs = __webpack_require__(10), _draftJsUtils = __webpack_require__(29), _EditorToolbarConfig = __webpack_require__(296), _EditorToolbarConfig2 = _interopRequireDefault(_EditorToolbarConfig), _StyleButton = __webpack_require__(297), _StyleButton2 = _interopRequireDefault(_StyleButton), _PopoverIconButton = __webpack_require__(306), _PopoverIconButton2 = _interopRequireDefault(_PopoverIconButton), _ButtonGroup = __webpack_require__(95), _ButtonGroup2 = _interopRequireDefault(_ButtonGroup), _Dropdown = __webpack_require__(140), _Dropdown2 = _interopRequireDefault(_Dropdown), _IconButton = __webpack_require__(64), _IconButton2 = _interopRequireDefault(_IconButton), _getEntityAtCursor2 = __webpack_require__(321), _getEntityAtCursor3 = _interopRequireDefault(_getEntityAtCursor2), _clearEntityForRange = __webpack_require__(322), _clearEntityForRange2 = _interopRequireDefault(_clearEntityForRange), _classAutobind = __webpack_require__(30), _classAutobind2 = _interopRequireDefault(_classAutobind), _classnames = __webpack_require__(23), _classnames2 = _interopRequireDefault(_classnames), _EditorToolbar = __webpack_require__(323), _EditorToolbar2 = _interopRequireDefault(_EditorToolbar), EditorToolbar = function(_Component) {
        function EditorToolbar() {
            (0, _classCallCheck3.default)(this, EditorToolbar);
            var _this = (0, _possibleConstructorReturn3.default)(this, (EditorToolbar.__proto__ || (0, 
            _getPrototypeOf2.default)(EditorToolbar)).apply(this, arguments));
            return (0, _classAutobind2.default)(_this), _this.state = {
                showLinkInput: !1,
                showImageInput: !1,
                customControlState: {}
            }, _this;
        }
        return (0, _inherits3.default)(EditorToolbar, _Component), (0, _createClass3.default)(EditorToolbar, [ {
            key: "componentWillMount",
            value: function() {
                // Technically, we should also attach/detach event listeners when the
                // `keyEmitter` prop changes.
                this.props.keyEmitter.on("keypress", this._onKeypress);
            }
        }, {
            key: "componentWillUnmount",
            value: function() {
                this.props.keyEmitter.removeListener("keypress", this._onKeypress);
            }
        }, {
            key: "render",
            value: function() {
                var _this2 = this, _props = this.props, className = _props.className, toolbarConfig = _props.toolbarConfig, rootStyle = _props.rootStyle;
                null == toolbarConfig && (toolbarConfig = _EditorToolbarConfig2.default);
                var display = toolbarConfig.display || _EditorToolbarConfig2.default.display, buttonGroups = display.map(function(groupName) {
                    switch (groupName) {
                      case "INLINE_STYLE_BUTTONS":
                        return _this2._renderInlineStyleButtons(groupName, toolbarConfig);

                      case "BLOCK_TYPE_DROPDOWN":
                        return _this2._renderBlockTypeDropdown(groupName, toolbarConfig);

                      case "LINK_BUTTONS":
                        return _this2._renderLinkButtons(groupName, toolbarConfig);

                      case "IMAGE_BUTTON":
                        return _this2._renderImageButton(groupName, toolbarConfig);

                      case "BLOCK_TYPE_BUTTONS":
                        return _this2._renderBlockTypeButtons(groupName, toolbarConfig);

                      case "HISTORY_BUTTONS":
                        return _this2._renderUndoRedo(groupName, toolbarConfig);
                    }
                });
                return _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_EditorToolbar2.default.root, className),
                    style: rootStyle
                }, buttonGroups, this._renderCustomControls());
            }
        }, {
            key: "_renderCustomControls",
            value: function() {
                var _this3 = this, _props2 = this.props, customControls = _props2.customControls, editorState = _props2.editorState;
                if (null != customControls) return customControls.map(function(f) {
                    switch (void 0 === f ? "undefined" : (0, _typeof3.default)(f)) {
                      case "function":
                        return f(_this3._setCustomControlState, _this3._getCustomControlState, editorState);

                      default:
                        return f;
                    }
                });
            }
        }, {
            key: "_setCustomControlState",
            value: function(key, value) {
                this.setState(function(_ref) {
                    var customControlState = _ref.customControlState;
                    return {
                        customControlState: (0, _extends4.default)({}, customControlState, (0, _defineProperty3.default)({}, key, value))
                    };
                });
            }
        }, {
            key: "_getCustomControlState",
            value: function(key) {
                return this.state.customControlState[key];
            }
        }, {
            key: "_renderBlockTypeDropdown",
            value: function(name, toolbarConfig) {
                var blockType = this._getCurrentBlockType(), choices = new _map2.default((toolbarConfig.BLOCK_TYPE_DROPDOWN || []).map(function(type) {
                    return [ type.style, {
                        label: type.label,
                        className: type.className
                    } ];
                }));
                return choices.has(blockType) || (blockType = (0, _from2.default)(choices.keys())[0]), 
                _react2.default.createElement(_ButtonGroup2.default, {
                    key: name
                }, _react2.default.createElement(_Dropdown2.default, (0, _extends4.default)({}, toolbarConfig.extraProps, {
                    choices: choices,
                    selectedKey: blockType,
                    onChange: this._selectBlockType
                })));
            }
        }, {
            key: "_renderBlockTypeButtons",
            value: function(name, toolbarConfig) {
                var _this4 = this, blockType = this._getCurrentBlockType(), buttons = (toolbarConfig.BLOCK_TYPE_BUTTONS || []).map(function(type, index) {
                    return _react2.default.createElement(_StyleButton2.default, (0, _extends4.default)({}, toolbarConfig.extraProps, {
                        key: String(index),
                        isActive: type.style === blockType,
                        label: type.label,
                        onToggle: _this4._toggleBlockType,
                        style: type.style,
                        className: type.className
                    }));
                });
                return _react2.default.createElement(_ButtonGroup2.default, {
                    key: name
                }, buttons);
            }
        }, {
            key: "_renderInlineStyleButtons",
            value: function(name, toolbarConfig) {
                var _this5 = this, editorState = this.props.editorState, currentStyle = editorState.getCurrentInlineStyle(), buttons = (toolbarConfig.INLINE_STYLE_BUTTONS || []).map(function(type, index) {
                    return _react2.default.createElement(_StyleButton2.default, (0, _extends4.default)({}, toolbarConfig.extraProps, {
                        key: String(index),
                        isActive: currentStyle.has(type.style),
                        label: type.label,
                        onToggle: _this5._toggleInlineStyle,
                        style: type.style,
                        className: type.className
                    }));
                });
                return _react2.default.createElement(_ButtonGroup2.default, {
                    key: name
                }, buttons);
            }
        }, {
            key: "_renderLinkButtons",
            value: function(name, toolbarConfig) {
                var editorState = this.props.editorState, selection = editorState.getSelection(), entity = this._getEntityAtCursor(), hasSelection = !selection.isCollapsed(), isCursorOnLink = null != entity && entity.type === _draftJsUtils.ENTITY_TYPE.LINK, shouldShowLinkButton = hasSelection || isCursorOnLink;
                return _react2.default.createElement(_ButtonGroup2.default, {
                    key: name
                }, _react2.default.createElement(_PopoverIconButton2.default, {
                    label: "Link",
                    iconName: "link",
                    isDisabled: !shouldShowLinkButton,
                    showPopover: this.state.showLinkInput,
                    onTogglePopover: this._toggleShowLinkInput,
                    onSubmit: this._setLink
                }), _react2.default.createElement(_IconButton2.default, (0, _extends4.default)({}, toolbarConfig.extraProps, {
                    label: "Remove Link",
                    iconName: "remove-link",
                    isDisabled: !isCursorOnLink,
                    onClick: this._removeLink,
                    focusOnClick: !1
                })));
            }
        }, {
            key: "_renderImageButton",
            value: function(name) {
                return _react2.default.createElement(_ButtonGroup2.default, {
                    key: name
                }, _react2.default.createElement(_PopoverIconButton2.default, {
                    label: "Image",
                    iconName: "image",
                    showPopover: this.state.showImageInput,
                    onTogglePopover: this._toggleShowImageInput,
                    onSubmit: this._setImage
                }));
            }
        }, {
            key: "_renderUndoRedo",
            value: function(name, toolbarConfig) {
                var editorState = this.props.editorState, canUndo = 0 !== editorState.getUndoStack().size, canRedo = 0 !== editorState.getRedoStack().size;
                return _react2.default.createElement(_ButtonGroup2.default, {
                    key: name
                }, _react2.default.createElement(_IconButton2.default, (0, _extends4.default)({}, toolbarConfig.extraProps, {
                    label: "Undo",
                    iconName: "undo",
                    isDisabled: !canUndo,
                    onClick: this._undo,
                    focusOnClick: !1
                })), _react2.default.createElement(_IconButton2.default, (0, _extends4.default)({}, toolbarConfig.extraProps, {
                    label: "Redo",
                    iconName: "redo",
                    isDisabled: !canRedo,
                    onClick: this._redo,
                    focusOnClick: !1
                })));
            }
        }, {
            key: "_onKeypress",
            value: function(event, eventFlags) {
                // Catch cmd+k for use with link insertion.
                if ((0, _KeyBindingUtil.hasCommandModifier)(event) && 75 === event.keyCode) {
                    this.props.editorState.getSelection().isCollapsed() || (this.setState({
                        showLinkInput: !0
                    }), eventFlags.wasHandled = !0);
                }
            }
        }, {
            key: "_toggleShowLinkInput",
            value: function(event) {
                var isShowing = this.state.showLinkInput;
                // If this is a hide request, decide if we should focus the editor.
                if (isShowing) {
                    var shouldFocusEditor = !0;
                    if (event && "click" === event.type) {
                        // TODO: Use a better way to get the editor root node.
                        var editorRoot = _reactDom2.default.findDOMNode(this).parentNode, _document = document, activeElement = _document.activeElement;
                        null == activeElement || activeElement === document.body || editorRoot.contains(activeElement) || (shouldFocusEditor = !1);
                    }
                    shouldFocusEditor && this.props.focusEditor();
                }
                this.setState({
                    showLinkInput: !isShowing
                });
            }
        }, {
            key: "_toggleShowImageInput",
            value: function(event) {
                var isShowing = this.state.showImageInput;
                // If this is a hide request, decide if we should focus the editor.
                if (isShowing) {
                    var shouldFocusEditor = !0;
                    if (event && "click" === event.type) {
                        // TODO: Use a better way to get the editor root node.
                        var editorRoot = _reactDom2.default.findDOMNode(this).parentNode, _document2 = document, activeElement = _document2.activeElement;
                        null == activeElement || activeElement === document.body || editorRoot.contains(activeElement) || (shouldFocusEditor = !1);
                    }
                    shouldFocusEditor && this.props.focusEditor();
                }
                this.setState({
                    showImageInput: !isShowing
                });
            }
        }, {
            key: "_setImage",
            value: function(src) {
                var editorState = this.props.editorState, contentState = editorState.getCurrentContent(), selection = editorState.getSelection();
                contentState = contentState.createEntity(_draftJsUtils.ENTITY_TYPE.IMAGE, "IMMUTABLE", {
                    src: src
                });
                var entityKey = contentState.getLastCreatedEntityKey(), newContentState = _draftJs.Modifier.insertText(contentState, selection, " ", null, entityKey);
                this.setState({
                    showImageInput: !1
                }), this.props.onChange(_draftJs.EditorState.push(editorState, newContentState)), 
                this._focusEditor();
            }
        }, {
            key: "_setLink",
            value: function(url) {
                var editorState = this.props.editorState, contentState = editorState.getCurrentContent(), selection = editorState.getSelection();
                contentState = contentState.createEntity(_draftJsUtils.ENTITY_TYPE.LINK, "MUTABLE", {
                    url: url
                });
                var entityKey = contentState.getLastCreatedEntityKey(), newEditorState = _draftJs.EditorState.push(editorState, contentState);
                this.setState({
                    showLinkInput: !1
                }), this.props.onChange(_draftJs.RichUtils.toggleLink(newEditorState, selection, entityKey)), 
                this._focusEditor();
            }
        }, {
            key: "_removeLink",
            value: function() {
                var editorState = this.props.editorState, entity = (0, _getEntityAtCursor3.default)(editorState);
                if (null != entity) {
                    var blockKey = entity.blockKey, startOffset = entity.startOffset, endOffset = entity.endOffset;
                    this.props.onChange((0, _clearEntityForRange2.default)(editorState, blockKey, startOffset, endOffset));
                }
            }
        }, {
            key: "_getEntityAtCursor",
            value: function() {
                var editorState = this.props.editorState, contentState = editorState.getCurrentContent(), entity = (0, 
                _getEntityAtCursor3.default)(editorState);
                return null == entity ? null : contentState.getEntity(entity.entityKey);
            }
        }, {
            key: "_getCurrentBlockType",
            value: function() {
                var editorState = this.props.editorState, selection = editorState.getSelection();
                return editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
            }
        }, {
            key: "_selectBlockType",
            value: function() {
                this._toggleBlockType.apply(this, arguments), this._focusEditor();
            }
        }, {
            key: "_toggleBlockType",
            value: function(blockType) {
                this.props.onChange(_draftJs.RichUtils.toggleBlockType(this.props.editorState, blockType));
            }
        }, {
            key: "_toggleInlineStyle",
            value: function(inlineStyle) {
                this.props.onChange(_draftJs.RichUtils.toggleInlineStyle(this.props.editorState, inlineStyle));
            }
        }, {
            key: "_undo",
            value: function() {
                var editorState = this.props.editorState;
                this.props.onChange(_draftJs.EditorState.undo(editorState));
            }
        }, {
            key: "_redo",
            value: function() {
                var editorState = this.props.editorState;
                this.props.onChange(_draftJs.EditorState.redo(editorState));
            }
        }, {
            key: "_focusEditor",
            value: function() {
                var _this6 = this;
                // Hacky: Wait to focus the editor so we don't lose selection.
                setTimeout(function() {
                    _this6.props.focusEditor();
                }, 50);
            }
        } ]), EditorToolbar;
    }(_react.Component);
    exports.default = EditorToolbar;
}, /* 276 */
/***/
function(module, exports, __webpack_require__) {
    __webpack_require__(43), __webpack_require__(277), module.exports = __webpack_require__(4).Array.from;
}, /* 277 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    var ctx = __webpack_require__(31), $export = __webpack_require__(7), toObject = __webpack_require__(42), call = __webpack_require__(134), isArrayIter = __webpack_require__(135), toLength = __webpack_require__(49), createProperty = __webpack_require__(278), getIterFn = __webpack_require__(93);
    $export($export.S + $export.F * !__webpack_require__(279)(function(iter) {
        Array.from(iter);
    }), "Array", {
        // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
        from: function(arrayLike) {
            var length, result, step, iterator, O = toObject(arrayLike), C = "function" == typeof this ? this : Array, aLen = arguments.length, mapfn = aLen > 1 ? arguments[1] : void 0, mapping = void 0 !== mapfn, index = 0, iterFn = getIterFn(O);
            // if object isn't iterable or it's array with default iterator - use simple case
            if (mapping && (mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : void 0, 2)), void 0 == iterFn || C == Array && isArrayIter(iterFn)) for (length = toLength(O.length), 
            result = new C(length); length > index; index++) createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]); else for (iterator = iterFn.call(O), 
            result = new C(); !(step = iterator.next()).done; index++) createProperty(result, index, mapping ? call(iterator, mapfn, [ step.value, index ], !0) : step.value);
            return result.length = index, result;
        }
    });
}, /* 278 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    var $defineProperty = __webpack_require__(9), createDesc = __webpack_require__(41);
    module.exports = function(object, index, value) {
        index in object ? $defineProperty.f(object, index, createDesc(0, value)) : object[index] = value;
    };
}, /* 279 */
/***/
function(module, exports, __webpack_require__) {
    var ITERATOR = __webpack_require__(6)("iterator"), SAFE_CLOSING = !1;
    try {
        var riter = [ 7 ][ITERATOR]();
        riter.return = function() {
            SAFE_CLOSING = !0;
        }, // eslint-disable-next-line no-throw-literal
        Array.from(riter, function() {
            throw 2;
        });
    } catch (e) {}
    module.exports = function(exec, skipClosing) {
        if (!skipClosing && !SAFE_CLOSING) return !1;
        var safe = !1;
        try {
            var arr = [ 7 ], iter = arr[ITERATOR]();
            iter.next = function() {
                return {
                    done: safe = !0
                };
            }, arr[ITERATOR] = function() {
                return iter;
            }, exec(arr);
        } catch (e) {}
        return safe;
    };
}, /* 280 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = {
        default: __webpack_require__(281),
        __esModule: !0
    };
}, /* 281 */
/***/
function(module, exports, __webpack_require__) {
    __webpack_require__(108), __webpack_require__(43), __webpack_require__(55), __webpack_require__(282), 
    __webpack_require__(289), __webpack_require__(292), __webpack_require__(294), module.exports = __webpack_require__(4).Map;
}, /* 282 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    var strong = __webpack_require__(283), validate = __webpack_require__(138);
    // 23.1 Map Objects
    module.exports = __webpack_require__(285)("Map", function(get) {
        return function() {
            return get(this, arguments.length > 0 ? arguments[0] : void 0);
        };
    }, {
        // 23.1.3.6 Map.prototype.get(key)
        get: function(key) {
            var entry = strong.getEntry(validate(this, "Map"), key);
            return entry && entry.v;
        },
        // 23.1.3.9 Map.prototype.set(key, value)
        set: function(key, value) {
            return strong.def(validate(this, "Map"), 0 === key ? 0 : key, value);
        }
    }, strong, !0);
}, /* 283 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    var dP = __webpack_require__(9).f, create = __webpack_require__(53), redefineAll = __webpack_require__(136), ctx = __webpack_require__(31), anInstance = __webpack_require__(137), forOf = __webpack_require__(63), $iterDefine = __webpack_require__(75), step = __webpack_require__(104), setSpecies = __webpack_require__(284), DESCRIPTORS = __webpack_require__(13), fastKey = __webpack_require__(78).fastKey, validate = __webpack_require__(138), SIZE = DESCRIPTORS ? "_s" : "size", getEntry = function(that, key) {
        // fast case
        var entry, index = fastKey(key);
        if ("F" !== index) return that._i[index];
        // frozen object case
        for (entry = that._f; entry; entry = entry.n) if (entry.k == key) return entry;
    };
    module.exports = {
        getConstructor: function(wrapper, NAME, IS_MAP, ADDER) {
            var C = wrapper(function(that, iterable) {
                anInstance(that, C, NAME, "_i"), that._t = NAME, // collection type
                that._i = create(null), // index
                that._f = void 0, // first entry
                that._l = void 0, // last entry
                that[SIZE] = 0, // size
                void 0 != iterable && forOf(iterable, IS_MAP, that[ADDER], that);
            });
            return redefineAll(C.prototype, {
                // 23.1.3.1 Map.prototype.clear()
                // 23.2.3.2 Set.prototype.clear()
                clear: function() {
                    for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) entry.r = !0, 
                    entry.p && (entry.p = entry.p.n = void 0), delete data[entry.i];
                    that._f = that._l = void 0, that[SIZE] = 0;
                },
                // 23.1.3.3 Map.prototype.delete(key)
                // 23.2.3.4 Set.prototype.delete(value)
                delete: function(key) {
                    var that = validate(this, NAME), entry = getEntry(that, key);
                    if (entry) {
                        var next = entry.n, prev = entry.p;
                        delete that._i[entry.i], entry.r = !0, prev && (prev.n = next), next && (next.p = prev), 
                        that._f == entry && (that._f = next), that._l == entry && (that._l = prev), that[SIZE]--;
                    }
                    return !!entry;
                },
                // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
                // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
                forEach: function(callbackfn) {
                    validate(this, NAME);
                    for (var entry, f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : void 0, 3); entry = entry ? entry.n : this._f; ) // revert to the last existing entry
                    for (f(entry.v, entry.k, this); entry && entry.r; ) entry = entry.p;
                },
                // 23.1.3.7 Map.prototype.has(key)
                // 23.2.3.7 Set.prototype.has(value)
                has: function(key) {
                    return !!getEntry(validate(this, NAME), key);
                }
            }), DESCRIPTORS && dP(C.prototype, "size", {
                get: function() {
                    return validate(this, NAME)[SIZE];
                }
            }), C;
        },
        def: function(that, key, value) {
            var prev, index, entry = getEntry(that, key);
            // change existing entry
            // add to index
            return entry ? entry.v = value : (that._l = entry = {
                i: index = fastKey(key, !0),
                // <- index
                k: key,
                // <- key
                v: value,
                // <- value
                p: prev = that._l,
                // <- previous entry
                n: void 0,
                // <- next entry
                r: !1
            }, that._f || (that._f = entry), prev && (prev.n = entry), that[SIZE]++, "F" !== index && (that._i[index] = entry)), 
            that;
        },
        getEntry: getEntry,
        setStrong: function(C, NAME, IS_MAP) {
            // add .keys, .values, .entries, [@@iterator]
            // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
            $iterDefine(C, NAME, function(iterated, kind) {
                this._t = validate(iterated, NAME), // target
                this._k = kind, // kind
                this._l = void 0;
            }, function() {
                // revert to the last existing entry
                for (var that = this, kind = that._k, entry = that._l; entry && entry.r; ) entry = entry.p;
                // get next entry
                // get next entry
                // return step by kind
                // or finish the iteration
                return that._t && (that._l = entry = entry ? entry.n : that._t._f) ? "keys" == kind ? step(0, entry.k) : "values" == kind ? step(0, entry.v) : step(0, [ entry.k, entry.v ]) : (that._t = void 0, 
                step(1));
            }, IS_MAP ? "entries" : "values", !IS_MAP, !0), // add [@@species], 23.1.2.2, 23.2.2.2
            setSpecies(NAME);
        }
    };
}, /* 284 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    var global = __webpack_require__(12), core = __webpack_require__(4), dP = __webpack_require__(9), DESCRIPTORS = __webpack_require__(13), SPECIES = __webpack_require__(6)("species");
    module.exports = function(KEY) {
        var C = "function" == typeof core[KEY] ? core[KEY] : global[KEY];
        DESCRIPTORS && C && !C[SPECIES] && dP.f(C, SPECIES, {
            configurable: !0,
            get: function() {
                return this;
            }
        });
    };
}, /* 285 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    var global = __webpack_require__(12), $export = __webpack_require__(7), meta = __webpack_require__(78), fails = __webpack_require__(32), hide = __webpack_require__(25), redefineAll = __webpack_require__(136), forOf = __webpack_require__(63), anInstance = __webpack_require__(137), isObject = __webpack_require__(27), setToStringTag = __webpack_require__(54), dP = __webpack_require__(9).f, each = __webpack_require__(286)(0), DESCRIPTORS = __webpack_require__(13);
    module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
        var Base = global[NAME], C = Base, ADDER = IS_MAP ? "set" : "add", proto = C && C.prototype, O = {};
        // create collection constructor
        return DESCRIPTORS && "function" == typeof C && (IS_WEAK || proto.forEach && !fails(function() {
            new C().entries().next();
        })) ? (C = wrapper(function(target, iterable) {
            anInstance(target, C, NAME, "_c"), target._c = new Base(), void 0 != iterable && forOf(iterable, IS_MAP, target[ADDER], target);
        }), each("add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON".split(","), function(KEY) {
            var IS_ADDER = "add" == KEY || "set" == KEY;
            KEY in proto && (!IS_WEAK || "clear" != KEY) && hide(C.prototype, KEY, function(a, b) {
                if (anInstance(this, C, KEY), !IS_ADDER && IS_WEAK && !isObject(a)) return "get" == KEY && void 0;
                var result = this._c[KEY](0 === a ? 0 : a, b);
                return IS_ADDER ? this : result;
            });
        }), IS_WEAK || dP(C.prototype, "size", {
            get: function() {
                return this._c.size;
            }
        })) : (C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER), redefineAll(C.prototype, methods), 
        meta.NEED = !0), setToStringTag(C, NAME), O[NAME] = C, $export($export.G + $export.W + $export.F, O), 
        IS_WEAK || common.setStrong(C, NAME, IS_MAP), C;
    };
}, /* 286 */
/***/
function(module, exports, __webpack_require__) {
    // 0 -> Array#forEach
    // 1 -> Array#map
    // 2 -> Array#filter
    // 3 -> Array#some
    // 4 -> Array#every
    // 5 -> Array#find
    // 6 -> Array#findIndex
    var ctx = __webpack_require__(31), IObject = __webpack_require__(66), toObject = __webpack_require__(42), toLength = __webpack_require__(49), asc = __webpack_require__(287);
    module.exports = function(TYPE, $create) {
        var IS_MAP = 1 == TYPE, IS_FILTER = 2 == TYPE, IS_SOME = 3 == TYPE, IS_EVERY = 4 == TYPE, IS_FIND_INDEX = 6 == TYPE, NO_HOLES = 5 == TYPE || IS_FIND_INDEX, create = $create || asc;
        return function($this, callbackfn, that) {
            for (var val, res, O = toObject($this), self = IObject(O), f = ctx(callbackfn, that, 3), length = toLength(self.length), index = 0, result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : void 0; length > index; index++) if ((NO_HOLES || index in self) && (val = self[index], 
            res = f(val, index, O), TYPE)) if (IS_MAP) result[index] = res; else if (res) switch (TYPE) {
              case 3:
                return !0;

              // some
                case 5:
                return val;

              // find
                case 6:
                return index;

              // findIndex
                case 2:
                result.push(val);
            } else if (IS_EVERY) return !1;
            return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
        };
    };
}, /* 287 */
/***/
function(module, exports, __webpack_require__) {
    // 9.4.2.3 ArraySpeciesCreate(originalArray, length)
    var speciesConstructor = __webpack_require__(288);
    module.exports = function(original, length) {
        return new (speciesConstructor(original))(length);
    };
}, /* 288 */
/***/
function(module, exports, __webpack_require__) {
    var isObject = __webpack_require__(27), isArray = __webpack_require__(105), SPECIES = __webpack_require__(6)("species");
    module.exports = function(original) {
        var C;
        // cross-realm fallback
        return isArray(original) && (C = original.constructor, "function" != typeof C || C !== Array && !isArray(C.prototype) || (C = void 0), 
        isObject(C) && null === (C = C[SPECIES]) && (C = void 0)), void 0 === C ? Array : C;
    };
}, /* 289 */
/***/
function(module, exports, __webpack_require__) {
    // https://github.com/DavidBruant/Map-Set.prototype.toJSON
    var $export = __webpack_require__(7);
    $export($export.P + $export.R, "Map", {
        toJSON: __webpack_require__(290)("Map")
    });
}, /* 290 */
/***/
function(module, exports, __webpack_require__) {
    // https://github.com/DavidBruant/Map-Set.prototype.toJSON
    var classof = __webpack_require__(94), from = __webpack_require__(291);
    module.exports = function(NAME) {
        return function() {
            if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
            return from(this);
        };
    };
}, /* 291 */
/***/
function(module, exports, __webpack_require__) {
    var forOf = __webpack_require__(63);
    module.exports = function(iter, ITERATOR) {
        var result = [];
        return forOf(iter, !1, result.push, result, ITERATOR), result;
    };
}, /* 292 */
/***/
function(module, exports, __webpack_require__) {
    // https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
    __webpack_require__(293)("Map");
}, /* 293 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    // https://tc39.github.io/proposal-setmap-offrom/
    var $export = __webpack_require__(7);
    module.exports = function(COLLECTION) {
        $export($export.S, COLLECTION, {
            of: function() {
                for (var length = arguments.length, A = Array(length); length--; ) A[length] = arguments[length];
                return new this(A);
            }
        });
    };
}, /* 294 */
/***/
function(module, exports, __webpack_require__) {
    // https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
    __webpack_require__(295)("Map");
}, /* 295 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    // https://tc39.github.io/proposal-setmap-offrom/
    var $export = __webpack_require__(7), aFunction = __webpack_require__(97), ctx = __webpack_require__(31), forOf = __webpack_require__(63);
    module.exports = function(COLLECTION) {
        $export($export.S, COLLECTION, {
            from: function(source) {
                var mapping, A, n, cb, mapFn = arguments[1];
                return aFunction(this), mapping = void 0 !== mapFn, mapping && aFunction(mapFn), 
                void 0 == source ? new this() : (A = [], mapping ? (n = 0, cb = ctx(mapFn, arguments[2], 2), 
                forOf(source, !1, function(nextItem) {
                    A.push(cb(nextItem, n++));
                })) : forOf(source, !1, A.push, A), new this(A));
            }
        });
    };
}, /* 296 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var INLINE_STYLE_BUTTONS = exports.INLINE_STYLE_BUTTONS = [ {
        label: "Bold",
        style: "BOLD"
    }, {
        label: "Italic",
        style: "ITALIC"
    }, {
        label: "Strikethrough",
        style: "STRIKETHROUGH"
    }, {
        label: "Monospace",
        style: "CODE"
    }, {
        label: "Underline",
        style: "UNDERLINE"
    } ], BLOCK_TYPE_DROPDOWN = exports.BLOCK_TYPE_DROPDOWN = [ {
        label: "Normal",
        style: "unstyled"
    }, {
        label: "Heading Large",
        style: "header-one"
    }, {
        label: "Heading Medium",
        style: "header-two"
    }, {
        label: "Heading Small",
        style: "header-three"
    }, {
        label: "Code Block",
        style: "code-block"
    } ], BLOCK_TYPE_BUTTONS = exports.BLOCK_TYPE_BUTTONS = [ {
        label: "UL",
        style: "unordered-list-item"
    }, {
        label: "OL",
        style: "ordered-list-item"
    }, {
        label: "Blockquote",
        style: "blockquote"
    } ], EditorToolbarConfig = {
        display: [ "INLINE_STYLE_BUTTONS", "BLOCK_TYPE_BUTTONS", "LINK_BUTTONS", "IMAGE_BUTTON", "BLOCK_TYPE_DROPDOWN", "HISTORY_BUTTONS" ],
        INLINE_STYLE_BUTTONS: INLINE_STYLE_BUTTONS,
        BLOCK_TYPE_DROPDOWN: BLOCK_TYPE_DROPDOWN,
        BLOCK_TYPE_BUTTONS: BLOCK_TYPE_BUTTONS
    };
    exports.default = EditorToolbarConfig;
}, /* 297 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _objectWithoutProperties2 = __webpack_require__(39), _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2), _getPrototypeOf = __webpack_require__(20), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(14), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(15), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(21), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(22), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(3), _react2 = _interopRequireDefault(_react), _IconButton = __webpack_require__(64), _IconButton2 = _interopRequireDefault(_IconButton), _classAutobind = __webpack_require__(30), _classAutobind2 = _interopRequireDefault(_classAutobind), StyleButton = function(_Component) {
        function StyleButton() {
            (0, _classCallCheck3.default)(this, StyleButton);
            var _this = (0, _possibleConstructorReturn3.default)(this, (StyleButton.__proto__ || (0, 
            _getPrototypeOf2.default)(StyleButton)).apply(this, arguments));
            return (0, _classAutobind2.default)(_this), _this;
        }
        return (0, _inherits3.default)(StyleButton, _Component), (0, _createClass3.default)(StyleButton, [ {
            key: "render",
            value: function() {
                var _props = this.props, style = _props.style, otherProps = (_props.onToggle, (0, 
                _objectWithoutProperties3.default)(_props, [ "style", "onToggle" ])), iconName = style.toLowerCase();
                // `focusOnClick` will prevent the editor from losing focus when a control
                // button is clicked.
                return _react2.default.createElement(_IconButton2.default, (0, _extends3.default)({}, otherProps, {
                    iconName: iconName,
                    onClick: this._onClick,
                    focusOnClick: !1
                }));
            }
        }, {
            key: "_onClick",
            value: function() {
                this.props.onToggle(this.props.style);
            }
        } ]), StyleButton;
    }(_react.Component);
    exports.default = StyleButton;
}, /* 298 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(299);
    "string" == typeof content && (content = [ [ module.i, content, "" ] ]);
    // Prepare cssTransformation
    var options = {
        sourceMap: !0
    };
    options.transform = void 0;
    // add the styles to the DOM
    __webpack_require__(18)(content, options);
    content.locals && (module.exports = content.locals);
}, /* 299 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(24)(void 0), // imports
    // module
    exports.push([ module.i, ".Button__root___1gz0c {\n  display: inline-block;\n  margin: 0 5px 0 0;\n  padding: 3px 8px;\n  height: 30px;\n  line-height: 22px;\n  box-sizing: border-box;\n  background: none #fdfdfd;\n  background: linear-gradient(to bottom, #fdfdfd 0%,#f6f7f8 100%);\n  border: 1px solid #999;\n  border-radius: 2px;\n  color: #333;\n  text-decoration: none;\n  font-size: inherit;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.Button__root___1gz0c:disabled {\n  cursor: not-allowed;\n  background: none transparent;\n}\n\n.Button__root___1gz0c:disabled > * {\n  opacity: .5;\n}\n", "" ]), 
    // exports
    exports.locals = {
        root: "Button__root___1gz0c"
    };
}, /* 300 */
/***/
function(module, exports) {
    /**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */
    module.exports = function(css) {
        // get current location
        var location = "undefined" != typeof window && window.location;
        if (!location) throw new Error("fixUrls requires window.location");
        // blank or null?
        if (!css || "string" != typeof css) return css;
        var baseUrl = location.protocol + "//" + location.host, currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");
        // send back the fixed css
        return css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
            // strip quotes (if they exist)
            var unquotedOrigUrl = origUrl.trim().replace(/^"(.*)"$/, function(o, $1) {
                return $1;
            }).replace(/^'(.*)'$/, function(o, $1) {
                return $1;
            });
            // already a full url? no change
            if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) return fullMatch;
            // convert the url to a full url
            var newUrl;
            // send back the fixed url(...)
            //TODO: should we add protocol?
            return newUrl = 0 === unquotedOrigUrl.indexOf("//") ? unquotedOrigUrl : 0 === unquotedOrigUrl.indexOf("/") ? baseUrl + unquotedOrigUrl : currentDir + unquotedOrigUrl.replace(/^\.\//, ""), 
            "url(" + JSON.stringify(newUrl) + ")";
        });
    };
}, /* 301 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function ButtonWrap(props) {
        var className = (0, _classnames2.default)(props.className, _ButtonWrap2.default.root);
        return _react2.default.createElement("div", (0, _extends3.default)({}, props, {
            className: className
        }));
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2);
    exports.default = ButtonWrap;
    var _react = __webpack_require__(3), _react2 = _interopRequireDefault(_react), _classnames = __webpack_require__(23), _classnames2 = _interopRequireDefault(_classnames), _ButtonWrap = __webpack_require__(302), _ButtonWrap2 = _interopRequireDefault(_ButtonWrap);
}, /* 302 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(303);
    "string" == typeof content && (content = [ [ module.i, content, "" ] ]);
    // Prepare cssTransformation
    var options = {
        sourceMap: !0
    };
    options.transform = void 0;
    // add the styles to the DOM
    __webpack_require__(18)(content, options);
    content.locals && (module.exports = content.locals);
}, /* 303 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(24)(void 0), // imports
    // module
    exports.push([ module.i, ".ButtonWrap__root___1EO_R {\n  display: inline-block;\n  position: relative;\n  /* This ensures the popover will show on top of the editor. */\n  z-index: 10;\n}\n", "" ]), 
    // exports
    exports.locals = {
        root: "ButtonWrap__root___1EO_R"
    };
}, /* 304 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(305);
    "string" == typeof content && (content = [ [ module.i, content, "" ] ]);
    // Prepare cssTransformation
    var options = {
        sourceMap: !0
    };
    options.transform = void 0;
    // add the styles to the DOM
    __webpack_require__(18)(content, options);
    content.locals && (module.exports = content.locals);
}, /* 305 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(24)(void 0), // imports
    // module
    exports.push([ module.i, '.IconButton__root___3tqZW {\n  padding-left: 3px;\n  padding-right: 3px;\n}\n\n.IconButton__icon___3YgOS {\n  display: inline-block;\n  width: 22px;\n  height: 22px;\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-size: 18px;\n}\n\n.IconButton__isActive___2Ey8p {\n  background: none #d8d8d8;\n}\n\n.IconButton__icon-undo___EQSRP {\n  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTcuODU2IDI0YzIuNjY1LTQuODMgMy4xMTUtMTIuMTk1LTcuMzU2LTExLjk1VjE4bC05LTkgOS05djUuODJDMjMuMDM4IDUuNDk1IDI0LjQzNSAxNi44OSAxNy44NTYgMjR6Ii8+PC9zdmc+");\n  background-size: 14px;\n}\n.IconButton__icon-redo___30MVz {\n  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTMuNSA1LjgyVjBsOSA5LTkgOXYtNS45NUMzLjAzIDExLjgwNiAzLjQ3OCAxOS4xNyA2LjE0NCAyNC0uNDM2IDE2Ljg5Ljk2MiA1LjQ5NCAxMy41IDUuODJ6Ii8+PC9zdmc+");\n  background-size: 14px;\n}\n\n.IconButton__icon-unordered-list-item___Pvkrr {\n  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij48cGF0aCBkPSJNNC42NTYgMy4zNDRIMTR2MS4zMTNINC42NTZWMy4zNDR6bTAgNS4zMTJWNy4zNDNIMTR2MS4zMTNINC42NTZ6bTAgNHYtMS4zMTNIMTR2MS4zMTNINC42NTZ6bS0yLTEuNTNxLjM3NSAwIC42NC4yNXQuMjY3LjYyNC0uMjY2LjYyNS0uNjQuMjUtLjYyNi0uMjVUMS43OCAxMnQuMjUtLjYyNS42MjYtLjI1em0wLTguMTI2cS40MDYgMCAuNzAzLjI4dC4yOTYuNzItLjI5Ny43Mi0uNzA0LjI4LS43MDMtLjI4VDEuNjU2IDR0LjI5Ny0uNzIuNzAzLS4yOHptMCA0cS40MDYgMCAuNzAzLjI4dC4yOTYuNzItLjI5Ny43Mi0uNzA0LjI4LS43MDMtLjI4VDEuNjU2IDh0LjI5Ny0uNzIuNzAzLS4yOHoiLz48L3N2Zz4=");\n}\n.IconButton__icon-ordered-list-item___2rzD0 {\n  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij48cGF0aCBkPSJNNC42NTYgOC42NTZWNy4zNDNIMTR2MS4zMTNINC42NTZ6bTAgNHYtMS4zMTNIMTR2MS4zMTNINC42NTZ6bTAtOS4zMTJIMTR2MS4zMTNINC42NTZWMy4zNDR6bS0zLjMxMiA0di0uNjg4aDJ2LjYyNWwtMS4yMiAxLjM3NmgxLjIydi42ODhoLTJWOC43MmwxLjE4OC0xLjM3NkgxLjM0NHptLjY1Ni0ydi0yaC0uNjU2di0uNjg4aDEuMzEzdjIuNjg4SDJ6bS0uNjU2IDZ2LS42ODhoMnYyLjY4OGgtMnYtLjY4OGgxLjMxM3YtLjMxM0gydi0uNjg4aC42NTd2LS4zMTNIMS4zNDR6Ii8+PC9zdmc+");\n}\n.IconButton__icon-blockquote___17VSX {\n  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij48cGF0aCBkPSJNOS4zNDQgMTEuMzQ0bDEuMzEzLTIuNjg4aC0ydi00aDR2NGwtMS4zMTMgMi42ODhoLTJ6bS01LjM0NCAwbDEuMzQ0LTIuNjg4aC0ydi00aDR2NEw2IDExLjM0NEg0eiIvPjwvc3ZnPg==");\n}\n\n.IconButton__icon-bold___2zl9t {\n  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij48cGF0aCBkPSJNOSAxMC4zNDRxLjQzOCAwIC43Mi0uMjk3dC4yOC0uNzAzLS4yOC0uNzAzVDkgOC4zNDVINi42NTZ2Mkg5em0tMi4zNDQtNnYyaDJxLjQwNiAwIC43MDMtLjI5N3QuMjk2LS43MDMtLjI5Ny0uNzAzLS43MDQtLjI5NmgtMnptMy43NSAyLjg0NHExLjQzOC42NTYgMS40MzggMi4yOCAwIDEuMDY0LS43MDMgMS43OThUOS4zNzYgMTJoLTQuNzJWMi42NTZoNC4xOXExLjEyNCAwIDEuODkuNzh0Ljc2NiAxLjkwNy0xLjA5MyAxLjg0NHoiLz48L3N2Zz4=");\n}\n.IconButton__icon-italic___2hHzc {\n  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij48cGF0aCBkPSJNNi42NTYgMi42NTZIMTJ2MmgtMS44NzVMNy44NzUgMTBoMS40N3YySDR2LTJoMS44NzVsMi4yNS01LjM0NGgtMS40N3YtMnoiLz48L3N2Zz4=");\n}\n.IconButton__icon-underline___2EmZJ {\n  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij48cGF0aCBkPSJNMy4zNDQgMTIuNjU2aDkuMzEzVjE0SDMuMzQ0di0xLjM0NHpNOCAxMS4zNDRxLTEuNjU2IDAtMi44MjgtMS4xNzJUNCA3LjM0NFYyaDEuNjU2djUuMzQ0cTAgLjk3LjY4OCAxLjY0VDggOS42NTh0MS42NTYtLjY3Mi42ODgtMS42NFYySDEydjUuMzQ0UTEyIDkgMTAuODI4IDEwLjE3MlQ4IDExLjM0NHoiLz48L3N2Zz4=");\n}\n.IconButton__icon-strikethrough___QtE2X {\n  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMjMuNTcgMTJxLjE5IDAgLjMxLjEydC4xMi4zMXYuODU2cTAgLjE4OC0uMTIuMzA4dC0uMzEuMTJILjQzcS0uMTg4IDAtLjMwOC0uMTJUMCAxMy4yODZ2LS44NTdxMC0uMTkuMTItLjMxVC40MjggMTJIMjMuNTd6bS0xNy4xLS44NTdxLS4zNzYtLjQ3LS42ODQtMS4wNy0uNjQzLTEuMy0uNjQzLTIuNTIgMC0yLjQyMyAxLjc5NS00LjEzNyAxLjc4LTEuNyA1LjI2My0xLjcuNjcgMCAyLjIzOC4yNTMuODg0LjE2IDIuMzcuNjQyLjEzNS41MS4yODIgMS41OC4xODggMS42NDcuMTg4IDIuNDUgMCAuMjQyLS4wNjcuNjA0bC0uMTYuMDQtMS4xMjUtLjA4LS4xODgtLjAyN3EtLjY3LTEuOTk3LTEuMzgtMi43NDctMS4xNzgtMS4yMi0yLjgxMi0xLjIyLTEuNTI3IDAtMi40MzguNzktLjg5Ny43NzgtLjg5NyAxLjk1NiAwIC45NzcuODg0IDEuODc0dDMuNzM3IDEuNzI4cS45MjUuMjY4IDIuMzE4Ljg4NC43NzcuMzc1IDEuMjcyLjY5Nkg2LjQ3em02Ljc5IDMuNDI4aDUuNTAzcS4wOTQuNTIzLjA5NCAxLjIzMyAwIDEuNDg3LS41NSAyLjg0LS4zMDcuNzM2LS45NSAxLjM5Mi0uNDk2LjQ3LTEuNDYgMS4wODUtMS4wNy42NDMtMi4wNS44ODQtMS4wNy4yOC0yLjcxOC4yOC0xLjUyOCAwLTIuNjEzLS4zMDdsLTEuODc1LS41MzZxLS43NjMtLjIxMy0uOTY0LS4zNzQtLjEwNy0uMTA3LS4xMDctLjI5NXYtLjE3M3EwLTEuNDQ2LS4wMjYtMi4wOS0uMDEzLS40IDAtLjkxbC4wMjctLjQ5NnYtLjU4OGwxLjM2Ny0uMDI3cS4yLjQ1NS40MDIuOTV0LjMuNzUuMTY3LjM2M3EuNDcuNzYzIDEuMDcgMS4yNi41NzcuNDggMS40MDcuNzYyLjc5LjI5NSAxLjc2OC4yOTUuODU3IDAgMS44NjItLjM2MiAxLjAzLS4zNDggMS42MzQtMS4xNTIuNjMtLjgxNi42My0xLjcyNyAwLTEuMTI1LTEuMDg2LTIuMTAzLS40NTUtLjM4OC0xLjgzNS0uOTV6Ii8+PC9zdmc+");\n  background-size: 14px;\n}\n.IconButton__icon-code___3F1pe {\n  background-image: url("data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTE2IDExNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEuNDE0Ij48ZyBmaWxsLXJ1bGU9Im5vbnplcm8iPjxwYXRoIGQ9Ik0yMi40NjQgMjguNDhjMCAyLjg5NS4zNDQgNS45MDUuODA2IDkuMDIuMzQyIDMuMDEuNjkgNi4wMi42OSA4LjkxNyAwIDMuNTYyLS45MTcgNy43OS04Ljk1NSA3LjkxMnY3LjIzNmM4LjAzNi4xMTUgOC45NTYgNC42NzIgOC45NTYgNy45MTIgMCAyLjg4Ni0uMzQ4IDUuNzgzLS42OSA4Ljc4Ny0uNDYyIDMuMDEzLS44MDYgNi4xMzQtLjgwNiA4LjkyIDAgMTEuMjM4IDcuMTA2IDE1LjI1MiAxNy4wODcgMTUuMjUyaDMuMzJ2LTcuOTEyaC0yLjA2MmMtNS43MjYgMC04LjAyNS0zLjIzMy04LjAyNS04Ljc5NiAwLTIuMjM2LjM0NC00LjU3LjgwNi03LjAyMy4yMjctMi40MzguNjg0LTUuMTIuNjg0LTguMTIuMTE1LTcuNzkyLTMuMzItMTEuMjUzLTkuMTc0LTEyLjU4NnYtLjIyNWM1Ljg1NC0xLjMzMiA5LjI5My00LjY3NiA5LjE3LTEyLjQ3IDAtMi44OTUtLjQ1Ny01LjU2NS0uNjg0LTguMDI0LS40NjItMi40NC0uODA3LTQuNzc3LS44MDctNy4wMTIgMC01LjQ1IDIuMDU4LTguNjg4IDguMDI0LTguNjg4aDIuMDY2di04LjAxNGgtMy4zMmMtMTAuMjA1LS4wMDMtMTcuMDg2IDQuNDQ0LTE3LjA4NiAxNC45MTV6TTkyLjA2IDQ2LjQxN2MwLTIuODkzLjQ1My01LjkwMy44MDMtOC45MTguMzQzLTMuMTE0Ljc5Ny02LjEyLjc5Ny05LjAyIDAtMTAuNDctNi44NzUtMTQuOTE3LTE3LjA4LTE0LjkxN2gtMy4zMjd2OC4wMTdoMi4wNmM1Ljg1Mi4xMTQgNy45MSAzLjIzMyA3LjkxIDguNjg4IDAgMi4yMy0uMzQyIDQuNTY1LS42ODUgNy4wMTItLjM1IDIuNDU1LS42OTIgNS4xMjYtLjY5MiA4LjAyNC0uMTA1IDcuNzk3IDMuMzI3IDExLjEzNiA5LjA1NiAxMi40N3YuMjIyYy01LjcyIDEuMzMzLTkuMTYgNC43OTYtOS4wNTYgMTIuNTg3IDAgMyAuMzQyIDUuNjg2LjY5MiA4LjEyLjM0MyAyLjQ1NS42ODYgNC43OS42ODYgNy4wMjUgMCA1LjU1NC0yLjE4IDguNjgtNy45MTIgOC43ODhoLTIuMDZ2Ny45MTJoMy4zMjVjOS45NzUgMCAxNy4wNzYtNC4wMSAxNy4wNzYtMTUuMjUgMC0yLjc4My0uNDU0LTUuOS0uNzk2LTguOTE0LS4zNDctMy4wMS0uODA1LTUuOS0uODA1LTguNzk1IDAtMy4yMzMgMS4wMzUtNy43OSA4Ljk0My03LjkxM1Y1NC4zMmMtNy45MDQtLjExMi04LjkzNS00LjM0LTguOTM1LTcuOTAzeiIvPjwvZz48L3N2Zz4=");\n}\n\n.IconButton__icon-link___2umEl {\n  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDIyIDI0Ij48cGF0aCBkPSJNMTkuNSAxNi4yODZxMC0uNTM2LS4zNzUtLjkxbC0yLjc4Ni0yLjc4N3EtLjM3Ni0uMzc2LS45MTItLjM3Ni0uNTYzIDAtLjk2NC40M2wuMjU0LjI0N3EuMjE0LjIwOC4yODguMjl0LjIuMjUzLjE3NS4zNDIuMDQ4LjM2OHEwIC41MzYtLjM3NS45MXQtLjkxLjM3NnEtLjIwMiAwLS4zNy0uMDQ4dC0uMzQtLjE3NC0uMjU1LS4yLS4yODgtLjI5LS4yNDgtLjI1M3EtLjQ0Mi40MTUtLjQ0Mi45NzggMCAuNTM2LjM3NS45MWwyLjc2IDIuNzczcS4zNi4zNjIuOTEuMzYyLjUzNiAwIC45MS0uMzQ4bDEuOTctMS45NTVxLjM3NS0uMzc1LjM3NS0uODk3em0tOS40MTUtOS40NDJxMC0uNTM2LS4zNzUtLjkxTDYuOTUgMy4xNnEtLjM3NC0uMzc0LS45MS0uMzc0LS41MjIgMC0uOTEuMzYyTDMuMTYgNS4xMDNxLS4zNzUuMzc1LS4zNzUuODk3IDAgLjUzNi4zNzUuOTFsMi43ODYgMi43ODdxLjM2Mi4zNjIuOTEuMzYyLjU2NCAwIC45NjUtLjQxNmwtLjI1My0uMjQ4cS0uMjEzLS4yMDgtLjI4OC0uMjg4dC0uMjAyLS4yNTQtLjE3NC0uMzQyLS4wNDctLjM2OHEwLS41MzYuMzc1LS45MXQuOTEtLjM3NnEuMjAyIDAgLjM3LjA0N3QuMzQuMTc0LjI1NS4yLjI4OC4yODguMjQ4LjI1NHEuNDQyLS40MTUuNDQyLS45Nzh6bTExLjk4NiA5LjQ0MnEwIDEuNjA3LTEuMTM3IDIuNzJsLTEuOTcgMS45NTRxLTEuMTEgMS4xMTItMi43MTggMS4xMTItMS42MiAwLTIuNzMyLTEuMTM4bC0yLjc2LTIuNzcycS0xLjExLTEuMTEyLTEuMTEtMi43MiAwLTEuNjQ2IDEuMTc4LTIuNzk4bC0xLjE3OC0xLjE4cS0xLjE1MiAxLjE4LTIuNzg2IDEuMTgtMS42MDcgMC0yLjczMi0xLjEyNUwxLjMzOCA4LjczMlEuMjEzIDcuNjA4LjIxMyA2VDEuMzUgMy4yODNsMS45Ny0xLjk1NVE0LjQzMi4yMTUgNi4wNC4yMTVxMS42MiAwIDIuNzMgMS4xMzhsMi43NiAyLjc3MnExLjExMiAxLjExMiAxLjExMiAyLjcyIDAgMS42NDYtMS4xOCAyLjc5OGwxLjE4IDEuMThxMS4xNTItMS4xOCAyLjc4Ni0xLjE4IDEuNjA3IDAgMi43MzIgMS4xMjVsMi43ODYgMi43ODZxMS4xMjUgMS4xMjUgMS4xMjUgMi43MzJ6Ii8+PC9zdmc+");\n  background-size: 14px;\n}\n\n.IconButton__icon-remove-link___j61pw {\n  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDIyIDI0Ij48cGF0aCBkPSJNNS44OCAxNy4wMjJsLTMuNDMgMy40M3EtLjEzNC4xMi0uMzA4LjEyLS4xNiAwLS4zMDgtLjEyLS4xMi0uMTM1LS4xMi0uMzF0LjEyLS4zMDdsMy40My0zLjQzcS4xMzMtLjEyLjMwNy0uMTJ0LjMxLjEycS4xMi4xMzUuMTIuMzF0LS4xMi4zMDd6bTIuMjYzLjU1djQuMjg1cTAgLjE4OC0uMTIuMzA4dC0uMzEuMTItLjMwNy0uMTItLjEyLS4zMDhWMTcuNTdxMC0uMTg3LjEyLS4zMDd0LjMwOC0uMTIuMzA4LjEyLjEyLjMwOHptLTMtM3EwIC4xODctLjEyLjMwN3QtLjMxLjEySC40M3EtLjE4OCAwLS4zMDgtLjEyVDAgMTQuNTd0LjEyLS4zMDcuMzA4LS4xMmg0LjI4NnEuMTg4IDAgLjMwOC4xMnQuMTIuMzA4em0xNi45MjggMS43MTRxMCAxLjYwNy0xLjEzNyAyLjcybC0xLjk3IDEuOTU0cS0xLjExIDEuMTEyLTIuNzE4IDEuMTEyLTEuNjIgMC0yLjczMi0xLjEzOEw5LjA0IDE2LjQ0N3EtLjI4LS4yOC0uNTYzLS43NWwzLjItLjI0IDMuNjU3IDMuNjdxLjM2Mi4zNi45MS4zNjd0LjkxMi0uMzU1bDEuOTctMS45NTZxLjM3NC0uMzc1LjM3NC0uODk3IDAtLjUzNi0uMzc1LS45MWwtMy42Ny0zLjY4NC4yNC0zLjJxLjQ3LjI4Ljc1LjU2Mmw0LjUgNC41cTEuMTI2IDEuMTUyIDEuMTI2IDIuNzMyek0xMy44MSA2LjU5bC0zLjIuMjRMNi45NSAzLjE2cS0uMzc0LS4zNzUtLjkxLS4zNzUtLjUyMiAwLS45MS4zNjJMMy4xNiA1LjEwMnEtLjM3NS4zNzUtLjM3NS44OTcgMCAuNTM1LjM3NS45MWwzLjY3IDMuNjctLjI0IDMuMjE0cS0uNDctLjI4LS43NS0uNTYzbC00LjUtNC41US4yMTMgNy41OC4yMTMgNnEwLTEuNjA4IDEuMTM4LTIuNzJsMS45Ny0xLjk1NVE0LjQzLjIxMyA2LjA0LjIxM3ExLjYyIDAgMi43MzIgMS4xMzhsNC40NzMgNC40ODhxLjI4LjI4LjU2My43NXptOC40NzggMS4xMjRxMCAuMTg4LS4xMi4zMDh0LS4zMS4xMmgtNC4yODVxLS4xODcgMC0uMzA3LS4xMnQtLjEyLS4zMDguMTItLjMwOC4zMDgtLjEyaDQuMjg3cS4xODggMCAuMzA4LjEydC4xMi4zMDh6TTE1IC40M3Y0LjI4NXEwIC4xODgtLjEyLjMwOHQtLjMxLjEyLS4zMDctLjEyLS4xMi0uMzA4Vi40M3EwLS4xOS4xMi0uMzFUMTQuNTcgMHQuMzEuMTIuMTIuMzF6bTUuNDUgMi4wMmwtMy40MjggMy40M3EtLjE0Ny4xMi0uMzA4LjEydC0uMzA4LS4xMnEtLjEyLS4xMzQtLjEyLS4zMDh0LjEyLS4zMDhsMy40My0zLjQzcS4xMzMtLjEyLjMwNy0uMTJ0LjMwOC4xMnEuMTIyLjEzNS4xMjIuMzF0LS4xMi4zMDd6Ii8+PC9zdmc+");\n  background-size: 14px;\n}\n\n.IconButton__icon-image___1gW7U {\n  background-image: url("data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4IiB2aWV3Qm94PSIwIDAgNTMzLjMzMyA1MzMuMzM0IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MzMuMzMzIDUzMy4zMzQ7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPGc+Cgk8cGF0aCBkPSJNNDY2LjY2NywxMDBoLTQwMHYzMzMuMzMzaDQwMFYxMDB6IE01MzMuMzMzLDMzLjMzM0w1MzMuMzMzLDMzLjMzM1Y1MDBIMFYzMy4zMzNINTMzLjMzM3ogTTQzMy4zMzMsNDAwSDEwMHYtNjYuNjY3ICAgbDEwMC0xNjYuNjY3bDEzNi45NzksMTY2LjY2N2w5Ni4zNTQtNjYuNjY2VjMwMFY0MDB6IE0zMzMuMzMzLDE4My4zMzNjMCwyNy42MTQsMjIuMzg2LDUwLDUwLDUwczUwLTIyLjM4Niw1MC01MHMtMjIuMzg2LTUwLTUwLTUwICAgUzMzMy4zMzMsMTU1LjcxOSwzMzMuMzMzLDE4My4zMzN6IiBmaWxsPSIjMDAwMDAwIi8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==");\n  background-size: 14px;\n}\n\n.IconButton__icon-cancel___fx4TT {\n  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMjMuNzggMTkuMjhMMTYuNSAxMmw3LjI4LTcuMjhhLjc0OC43NDggMCAwIDAgMC0xLjA2TDIwLjM0LjIxOGEuNzUuNzUgMCAwIDAtMS4wNi0uMDAyTDEyIDcuNDk4IDQuNzE3LjIyYS43NDguNzQ4IDAgMCAwLTEuMDYgMEwuMjE3IDMuNjZhLjc1Ljc1IDAgMCAwIDAgMS4wNkw3LjQ5NyAxMmwtNy4yOCA3LjI4YS43NDguNzQ4IDAgMCAwIDAgMS4wNmwzLjQ0IDMuNDRhLjc1Ljc1IDAgMCAwIDEuMDYuMDAybDcuMjgtNy4yOCA3LjI4MiA3LjI4Yy4wNzguMDc4LjE3LjEzNS4yNjguMTcuMjY3LjEuNTguMDQ0Ljc5My0uMTdsMy40NC0zLjQ0YS43NS43NSAwIDAgMCAwLTEuMDZ6Ii8+PC9zdmc+");\n  background-size: 13px;\n}\n\n.IconButton__icon-accept___2D6M9 {\n  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMjAuMjUgM0w5IDE0LjI1IDMuNzUgOSAwIDEyLjc1bDkgOSAxNS0xNXoiLz48L3N2Zz4=");\n  background-size: 13px;\n}\n', "" ]), 
    // exports
    exports.locals = {
        root: "IconButton__root___3tqZW",
        icon: "IconButton__icon___3YgOS",
        isActive: "IconButton__isActive___2Ey8p",
        "icon-undo": "IconButton__icon-undo___EQSRP IconButton__icon___3YgOS",
        "icon-redo": "IconButton__icon-redo___30MVz IconButton__icon___3YgOS",
        "icon-unordered-list-item": "IconButton__icon-unordered-list-item___Pvkrr IconButton__icon___3YgOS",
        "icon-ordered-list-item": "IconButton__icon-ordered-list-item___2rzD0 IconButton__icon___3YgOS",
        "icon-blockquote": "IconButton__icon-blockquote___17VSX IconButton__icon___3YgOS",
        "icon-bold": "IconButton__icon-bold___2zl9t IconButton__icon___3YgOS",
        "icon-italic": "IconButton__icon-italic___2hHzc IconButton__icon___3YgOS",
        "icon-underline": "IconButton__icon-underline___2EmZJ IconButton__icon___3YgOS",
        "icon-strikethrough": "IconButton__icon-strikethrough___QtE2X IconButton__icon___3YgOS",
        "icon-code": "IconButton__icon-code___3F1pe IconButton__icon___3YgOS",
        "icon-link": "IconButton__icon-link___2umEl IconButton__icon___3YgOS",
        "icon-remove-link": "IconButton__icon-remove-link___j61pw IconButton__icon___3YgOS",
        "icon-image": "IconButton__icon-image___1gW7U IconButton__icon___3YgOS",
        "icon-cancel": "IconButton__icon-cancel___fx4TT IconButton__icon___3YgOS",
        "icon-accept": "IconButton__icon-accept___2D6M9 IconButton__icon___3YgOS"
    };
}, /* 306 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _objectWithoutProperties2 = __webpack_require__(39), _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2), _getPrototypeOf = __webpack_require__(20), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(14), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(15), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(21), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(22), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(3), _react2 = _interopRequireDefault(_react), _IconButton = __webpack_require__(64), _IconButton2 = _interopRequireDefault(_IconButton), _InputPopover = __webpack_require__(307), _InputPopover2 = _interopRequireDefault(_InputPopover), _classAutobind = __webpack_require__(30), _classAutobind2 = _interopRequireDefault(_classAutobind), PopoverIconButton = function(_Component) {
        function PopoverIconButton() {
            (0, _classCallCheck3.default)(this, PopoverIconButton);
            var _this = (0, _possibleConstructorReturn3.default)(this, (PopoverIconButton.__proto__ || (0, 
            _getPrototypeOf2.default)(PopoverIconButton)).apply(this, arguments));
            return (0, _classAutobind2.default)(_this), _this;
        }
        return (0, _inherits3.default)(PopoverIconButton, _Component), (0, _createClass3.default)(PopoverIconButton, [ {
            key: "render",
            value: function() {
                var _props = this.props, onTogglePopover = _props.onTogglePopover, props = (_props.showPopover, 
                (0, _objectWithoutProperties3.default)(_props, [ "onTogglePopover", "showPopover" ]));
                // eslint-disable-line no-unused-vars
                return _react2.default.createElement(_IconButton2.default, (0, _extends3.default)({}, props, {
                    onClick: onTogglePopover
                }), this._renderPopover());
            }
        }, {
            key: "_renderPopover",
            value: function() {
                return this.props.showPopover ? _react2.default.createElement(_InputPopover2.default, {
                    onSubmit: this._onSubmit,
                    onCancel: this._hidePopover
                }) : null;
            }
        }, {
            key: "_onSubmit",
            value: function() {
                var _props2;
                (_props2 = this.props).onSubmit.apply(_props2, arguments);
            }
        }, {
            key: "_hidePopover",
            value: function() {
                if (this.props.showPopover) {
                    var _props3;
                    (_props3 = this.props).onTogglePopover.apply(_props3, arguments);
                }
            }
        } ]), PopoverIconButton;
    }(_react.Component);
    exports.default = PopoverIconButton;
}, /* 307 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(20), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(14), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(15), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(21), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(22), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(3), _react2 = _interopRequireDefault(_react), _reactDom = __webpack_require__(36), _reactDom2 = _interopRequireDefault(_reactDom), _IconButton = __webpack_require__(64), _IconButton2 = _interopRequireDefault(_IconButton), _ButtonGroup = __webpack_require__(95), _ButtonGroup2 = _interopRequireDefault(_ButtonGroup), _classAutobind = __webpack_require__(30), _classAutobind2 = _interopRequireDefault(_classAutobind), _classnames = __webpack_require__(23), _classnames2 = _interopRequireDefault(_classnames), _InputPopover = __webpack_require__(310), _InputPopover2 = _interopRequireDefault(_InputPopover), InputPopover = function(_Component) {
        function InputPopover() {
            (0, _classCallCheck3.default)(this, InputPopover);
            var _this = (0, _possibleConstructorReturn3.default)(this, (InputPopover.__proto__ || (0, 
            _getPrototypeOf2.default)(InputPopover)).apply(this, arguments));
            return (0, _classAutobind2.default)(_this), _this;
        }
        return (0, _inherits3.default)(InputPopover, _Component), (0, _createClass3.default)(InputPopover, [ {
            key: "componentDidMount",
            value: function() {
                document.addEventListener("click", this._onDocumentClick), document.addEventListener("keydown", this._onDocumentKeydown), 
                this._inputRef && this._inputRef.focus();
            }
        }, {
            key: "componentWillUnmount",
            value: function() {
                document.removeEventListener("click", this._onDocumentClick), document.removeEventListener("keydown", this._onDocumentKeydown);
            }
        }, {
            key: "render",
            value: function() {
                var props = this.props, className = (0, _classnames2.default)(props.className, _InputPopover2.default.root);
                return _react2.default.createElement("div", {
                    className: className
                }, _react2.default.createElement("div", {
                    className: _InputPopover2.default.inner
                }, _react2.default.createElement("input", {
                    ref: this._setInputRef,
                    type: "text",
                    placeholder: "https://example.com/",
                    className: _InputPopover2.default.input,
                    onKeyPress: this._onInputKeyPress
                }), _react2.default.createElement(_ButtonGroup2.default, {
                    className: _InputPopover2.default.buttonGroup
                }, _react2.default.createElement(_IconButton2.default, {
                    label: "Cancel",
                    iconName: "cancel",
                    onClick: props.onCancel
                }), _react2.default.createElement(_IconButton2.default, {
                    label: "Submit",
                    iconName: "accept",
                    onClick: this._onSubmit
                }))));
            }
        }, {
            key: "_setInputRef",
            value: function(inputElement) {
                this._inputRef = inputElement;
            }
        }, {
            key: "_onInputKeyPress",
            value: function(event) {
                13 === event.which && (// Avoid submitting a <form> somewhere up the element tree.
                event.preventDefault(), this._onSubmit());
            }
        }, {
            key: "_onSubmit",
            value: function() {
                var value = this._inputRef ? this._inputRef.value : "";
                this.props.onSubmit(value);
            }
        }, {
            key: "_onDocumentClick",
            value: function(event) {
                _reactDom2.default.findDOMNode(this).contains(event.target) || // Here we pass the event so the parent can manage focus.
                this.props.onCancel(event);
            }
        }, {
            key: "_onDocumentKeydown",
            value: function(event) {
                27 === event.keyCode && this.props.onCancel();
            }
        } ]), InputPopover;
    }(_react.Component);
    exports.default = InputPopover;
}, /* 308 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(309);
    "string" == typeof content && (content = [ [ module.i, content, "" ] ]);
    // Prepare cssTransformation
    var options = {
        sourceMap: !0
    };
    options.transform = void 0;
    // add the styles to the DOM
    __webpack_require__(18)(content, options);
    content.locals && (module.exports = content.locals);
}, /* 309 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(24)(void 0), // imports
    // module
    exports.push([ module.i, ".ButtonGroup__root___3lEAn {\n  display: inline-block;\n  vertical-align: top;\n  margin: 0 5px 5px 0;\n  white-space: nowrap;\n}\n\n.ButtonGroup__root___3lEAn:last-child {\n  margin-right: 0;\n}\n\n/* TODO: remove all this child selector and tag selector stuff. */\n\n.ButtonGroup__root___3lEAn > div > button {\n  margin-right: 0;\n  border-radius: 0;\n}\n\n.ButtonGroup__root___3lEAn > div > button:focus {\n  position: relative;\n  z-index: 1;\n}\n\n.ButtonGroup__root___3lEAn > div:first-child > button {\n  border-top-left-radius: 2px;\n  border-bottom-left-radius: 2px;\n}\n\n.ButtonGroup__root___3lEAn > div + div > button {\n  border-left-width: 0;\n}\n\n.ButtonGroup__root___3lEAn > div:last-child > button {\n  border-top-right-radius: 2px;\n  border-bottom-right-radius: 2px;\n}\n", "" ]), 
    // exports
    exports.locals = {
        root: "ButtonGroup__root___3lEAn"
    };
}, /* 310 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(311);
    "string" == typeof content && (content = [ [ module.i, content, "" ] ]);
    // Prepare cssTransformation
    var options = {
        sourceMap: !0
    };
    options.transform = void 0;
    // add the styles to the DOM
    __webpack_require__(18)(content, options);
    content.locals && (module.exports = content.locals);
}, /* 311 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(24)(void 0), // imports
    // module
    exports.push([ module.i, '.InputPopover__root___3Hpj9 {\n  position: absolute;\n  top: calc(100% + 5px);\n  left: 0;\n  width: 260px;\n  background: none #fdfdfd;\n  background: linear-gradient(to bottom, #fdfdfd 0%,#f6f7f8 100%);\n  border: 1px solid #999;\n  border-radius: 2px;\n  box-sizing: border-box;\n  padding: 4px;\n}\n\n.InputPopover__root___3Hpj9:before {\n  content: "";\n  display: block;\n  position: absolute;\n  width: 0;\n  height: 0;\n  top: -10px;\n  left: 10px;\n  border: 5px solid transparent;\n  border-bottom-color: #999;\n}\n\n.InputPopover__root___3Hpj9:after {\n  content: "";\n  display: block;\n  position: absolute;\n  width: 0;\n  height: 0;\n  top: -9px;\n  left: 10px;\n  border: 5px solid transparent;\n  border-bottom-color: #fdfdfd;\n}\n\n.InputPopover__inner___32V5P {\n  display: flex;\n}\n\n.InputPopover__input___264Za {\n  display: block;\n  flex: 1 0 auto;\n  height: 30px;\n  background: none white;\n  border: 1px solid #999;\n  border-radius: 2px;\n  box-sizing: border-box;\n  padding: 2px 6px;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: 24px;\n}\n\n.InputPopover__inner___32V5P .InputPopover__buttonGroup___2c3Sl {\n  flex: 0 1 auto;\n  margin-left: 4px;\n  margin-bottom: 0;\n}\n', "" ]), 
    // exports
    exports.locals = {
        root: "InputPopover__root___3Hpj9",
        inner: "InputPopover__inner___32V5P",
        input: "InputPopover__input___264Za",
        buttonGroup: "InputPopover__buttonGroup___2c3Sl"
    };
}, /* 312 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    exports.__esModule = !0;
    var _isIterable2 = __webpack_require__(313), _isIterable3 = _interopRequireDefault(_isIterable2), _getIterator2 = __webpack_require__(316), _getIterator3 = _interopRequireDefault(_getIterator2);
    exports.default = function() {
        function sliceIterator(arr, i) {
            var _arr = [], _n = !0, _d = !1, _e = void 0;
            try {
                for (var _s, _i = (0, _getIterator3.default)(arr); !(_n = (_s = _i.next()).done) && (_arr.push(_s.value), 
                !i || _arr.length !== i); _n = !0) ;
            } catch (err) {
                _d = !0, _e = err;
            } finally {
                try {
                    !_n && _i.return && _i.return();
                } finally {
                    if (_d) throw _e;
                }
            }
            return _arr;
        }
        return function(arr, i) {
            if (Array.isArray(arr)) return arr;
            if ((0, _isIterable3.default)(Object(arr))) return sliceIterator(arr, i);
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
    }();
}, /* 313 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = {
        default: __webpack_require__(314),
        __esModule: !0
    };
}, /* 314 */
/***/
function(module, exports, __webpack_require__) {
    __webpack_require__(55), __webpack_require__(43), module.exports = __webpack_require__(315);
}, /* 315 */
/***/
function(module, exports, __webpack_require__) {
    var classof = __webpack_require__(94), ITERATOR = __webpack_require__(6)("iterator"), Iterators = __webpack_require__(40);
    module.exports = __webpack_require__(4).isIterable = function(it) {
        var O = Object(it);
        return void 0 !== O[ITERATOR] || "@@iterator" in O || Iterators.hasOwnProperty(classof(O));
    };
}, /* 316 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = {
        default: __webpack_require__(317),
        __esModule: !0
    };
}, /* 317 */
/***/
function(module, exports, __webpack_require__) {
    __webpack_require__(55), __webpack_require__(43), module.exports = __webpack_require__(318);
}, /* 318 */
/***/
function(module, exports, __webpack_require__) {
    var anObject = __webpack_require__(26), get = __webpack_require__(93);
    module.exports = __webpack_require__(4).getIterator = function(it) {
        var iterFn = get(it);
        if ("function" != typeof iterFn) throw TypeError(it + " is not iterable!");
        return anObject(iterFn.call(it));
    };
}, /* 319 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(320);
    "string" == typeof content && (content = [ [ module.i, content, "" ] ]);
    // Prepare cssTransformation
    var options = {
        sourceMap: !0
    };
    options.transform = void 0;
    // add the styles to the DOM
    __webpack_require__(18)(content, options);
    content.locals && (module.exports = content.locals);
}, /* 320 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(24)(void 0), // imports
    // module
    exports.push([ module.i, '.Dropdown__root___3ALmx {\n  display: inline-block;\n  position: relative;\n  line-height: 22px;\n  vertical-align: top;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.Dropdown__root___3ALmx select {\n  position: relative;\n  z-index: 2;\n  display: inline-block;\n  box-sizing: border-box;\n  height: 30px;\n  line-height: inherit;\n  font-family: inherit;\n  font-size: inherit;\n  color: inherit;\n  margin: 0;\n  padding: 0;\n  border: 4px solid transparent;\n  border-right-width: 10px;\n  border-left-width: 5px;\n  background: none transparent;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.Dropdown__root___3ALmx .Dropdown__value___34Py9 {\n  display: block;\n  position: absolute;\n  z-index: 1;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  line-height: 23px;\n  border: 1px solid #999;\n  border-radius: 2px;\n  padding: 3px;\n  padding-right: 33px;\n  padding-left: 12px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.Dropdown__root___3ALmx .Dropdown__value___34Py9::before,\n.Dropdown__root___3ALmx .Dropdown__value___34Py9::after {\n  display: block;\n  content: "";\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  width: 0;\n  height: 0;\n  border: 4px solid transparent;\n}\n\n.Dropdown__root___3ALmx .Dropdown__value___34Py9::before {\n  margin-top: -10px;\n  border-bottom-color: #555;\n}\n\n.Dropdown__root___3ALmx .Dropdown__value___34Py9::after {\n  margin-top: 1px;\n  border-top-color: #555;\n}\n\n.Dropdown__root___3ALmx select:focus + .Dropdown__value___34Py9 {\n  border-color: #66afe9;\n}\n\n/* On Webkit we can style <select> to be transparant without turning off the\n   default focus styles. This is better for accessibility. */\n@media screen and (-webkit-min-device-pixel-ratio:0) {\n  .Dropdown__root___3ALmx select {\n    opacity: 1;\n    color: inherit;\n    -webkit-appearance: none;\n    border-left-width: 12px;\n    border-right-width: 35px;\n  }\n\n  .Dropdown__root___3ALmx select + .Dropdown__value___34Py9 {\n    color: transparent;\n  }\n\n  .Dropdown__root___3ALmx select:focus + .Dropdown__value___34Py9 {\n    border-color: #999;\n  }\n}\n', "" ]), 
    // exports
    exports.locals = {
        root: "Dropdown__root___3ALmx",
        value: "Dropdown__value___34Py9"
    };
}, /* 321 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function getEntityAtOffset(block, offset) {
        var entityKey = block.getEntityAt(offset);
        if (null == entityKey) return null;
        for (var startOffset = offset; startOffset > 0 && block.getEntityAt(startOffset - 1) === entityKey; ) startOffset -= 1;
        for (var endOffset = startOffset, blockLength = block.getLength(); endOffset < blockLength && block.getEntityAt(endOffset + 1) === entityKey; ) endOffset += 1;
        return {
            entityKey: entityKey,
            blockKey: block.getKey(),
            startOffset: startOffset,
            endOffset: endOffset + 1
        };
    }
    function getEntityAtCursor(editorState) {
        var selection = editorState.getSelection(), startKey = selection.getStartKey(), startBlock = editorState.getCurrentContent().getBlockForKey(startKey), startOffset = selection.getStartOffset();
        if (selection.isCollapsed()) // Get the entity before the cursor (unless the cursor is at the start).
        return getEntityAtOffset(startBlock, 0 === startOffset ? startOffset : startOffset - 1);
        if (startKey !== selection.getEndKey()) return null;
        for (var endOffset = selection.getEndOffset(), startEntityKey = startBlock.getEntityAt(startOffset), i = startOffset; i < endOffset; i++) {
            var _entityKey = startBlock.getEntityAt(i);
            if (null == _entityKey || _entityKey !== startEntityKey) return null;
        }
        return {
            entityKey: startEntityKey,
            blockKey: startBlock.getKey(),
            startOffset: startOffset,
            endOffset: endOffset
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.default = getEntityAtCursor;
}, /* 322 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function clearEntityForRange(editorState, blockKey, startOffset, endOffset) {
        var contentState = editorState.getCurrentContent(), blockMap = contentState.getBlockMap(), block = blockMap.get(blockKey), charList = block.getCharacterList(), newCharList = charList.map(function(char, i) {
            return i >= startOffset && i < endOffset ? _draftJs.CharacterMetadata.applyEntity(char, null) : char;
        }), newBlock = block.set("characterList", newCharList), newBlockMap = blockMap.set(blockKey, newBlock), newContentState = contentState.set("blockMap", newBlockMap);
        return _draftJs.EditorState.push(editorState, newContentState, "apply-entity");
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.default = clearEntityForRange;
    var _draftJs = __webpack_require__(10);
}, /* 323 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(324);
    "string" == typeof content && (content = [ [ module.i, content, "" ] ]);
    // Prepare cssTransformation
    var options = {
        sourceMap: !0
    };
    options.transform = void 0;
    // add the styles to the DOM
    __webpack_require__(18)(content, options);
    content.locals && (module.exports = content.locals);
}, /* 324 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(24)(void 0), // imports
    // module
    exports.push([ module.i, ".EditorToolbar__root___3_Aqz {\n  font-family: 'Helvetica', sans-serif;\n  font-size: 14px;\n  margin: 0 10px;\n  padding: 10px 0 5px;\n  border-bottom: 1px solid #ddd;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n", "" ]), 
    // exports
    exports.locals = {
        root: "EditorToolbar__root___3_Aqz"
    };
}, /* 325 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function _toString(editorState, format, options) {
        var contentState = editorState.getCurrentContent();
        switch (format) {
          case "html":
            return (0, _draftJsExportHtml.stateToHTML)(contentState, options);

          case "markdown":
            return (0, _draftJsExportMarkdown.stateToMarkdown)(contentState);

          case "raw":
            return (0, _stringify2.default)((0, _draftJs.convertToRaw)(contentState));

          default:
            throw new Error("Format not supported: " + format);
        }
    }
    function fromString(markup, format, options) {
        switch (format) {
          case "html":
            return (0, _draftJsImportHtml.stateFromHTML)(markup, options);

          case "markdown":
            return (0, _draftJsImportMarkdown.stateFromMarkdown)(markup, options);

          case "raw":
            return (0, _draftJs.convertFromRaw)(JSON.parse(markup));

          default:
            throw new Error("Format not supported: " + format);
        }
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _stringify = __webpack_require__(326), _stringify2 = _interopRequireDefault(_stringify), _defineProperty2 = __webpack_require__(52), _defineProperty3 = _interopRequireDefault(_defineProperty2), _classCallCheck2 = __webpack_require__(14), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(15), _createClass3 = _interopRequireDefault(_createClass2), _draftJs = __webpack_require__(10), _draftJsExportHtml = __webpack_require__(328), _draftJsImportHtml = __webpack_require__(333), _draftJsExportMarkdown = __webpack_require__(340), _draftJsImportMarkdown = __webpack_require__(342), EditorValue = function() {
        function EditorValue(editorState) {
            var cache = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            (0, _classCallCheck3.default)(this, EditorValue), this._cache = cache, this._editorState = editorState;
        }
        return (0, _createClass3.default)(EditorValue, [ {
            key: "getEditorState",
            value: function() {
                return this._editorState;
            }
        }, {
            key: "setEditorState",
            value: function(editorState) {
                return this._editorState === editorState ? this : new EditorValue(editorState);
            }
        }, {
            key: "toString",
            value: function(format, options) {
                var fromCache = this._cache[format];
                return null != fromCache ? fromCache : this._cache[format] = _toString(this.getEditorState(), format, options);
            }
        }, {
            key: "setContentFromString",
            value: function(markup, format, options) {
                return new EditorValue(_draftJs.EditorState.push(this._editorState, fromString(markup, format, options), "secondary-paste"), (0, 
                _defineProperty3.default)({}, format, markup));
            }
        } ], [ {
            key: "createEmpty",
            value: function(decorator) {
                return new EditorValue(_draftJs.EditorState.createEmpty(decorator));
            }
        }, {
            key: "createFromState",
            value: function(editorState) {
                return new EditorValue(editorState);
            }
        }, {
            key: "createFromString",
            value: function(markup, format, decorator, options) {
                var contentState = fromString(markup, format, options);
                return new EditorValue(_draftJs.EditorState.createWithContent(contentState, decorator), (0, 
                _defineProperty3.default)({}, format, markup));
            }
        } ]), EditorValue;
    }();
    exports.default = EditorValue;
}, /* 326 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = {
        default: __webpack_require__(327),
        __esModule: !0
    };
}, /* 327 */
/***/
function(module, exports, __webpack_require__) {
    var core = __webpack_require__(4), $JSON = core.JSON || (core.JSON = {
        stringify: JSON.stringify
    });
    module.exports = function(it) {
        // eslint-disable-line no-unused-vars
        return $JSON.stringify.apply($JSON, arguments);
    };
}, /* 328 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _stateToHTML = __webpack_require__(329);
    Object.defineProperty(exports, "stateToHTML", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_stateToHTML).default;
        }
    });
}, /* 329 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperty(obj, key, value) {
        return key in obj ? Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : obj[key] = value, obj;
    }
    // The reason this returns an array is because a single block might get wrapped
    // in two tags.
    function getTags(blockType, defaultBlockTag) {
        switch (blockType) {
          case _draftJsUtils.BLOCK_TYPE.HEADER_ONE:
            return [ "h1" ];

          case _draftJsUtils.BLOCK_TYPE.HEADER_TWO:
            return [ "h2" ];

          case _draftJsUtils.BLOCK_TYPE.HEADER_THREE:
            return [ "h3" ];

          case _draftJsUtils.BLOCK_TYPE.HEADER_FOUR:
            return [ "h4" ];

          case _draftJsUtils.BLOCK_TYPE.HEADER_FIVE:
            return [ "h5" ];

          case _draftJsUtils.BLOCK_TYPE.HEADER_SIX:
            return [ "h6" ];

          case _draftJsUtils.BLOCK_TYPE.UNORDERED_LIST_ITEM:
          case _draftJsUtils.BLOCK_TYPE.ORDERED_LIST_ITEM:
            return [ "li" ];

          case _draftJsUtils.BLOCK_TYPE.BLOCKQUOTE:
            return [ "blockquote" ];

          case _draftJsUtils.BLOCK_TYPE.CODE:
            return [ "pre", "code" ];

          case _draftJsUtils.BLOCK_TYPE.ATOMIC:
            return [ "figure" ];

          default:
            return [ defaultBlockTag || "p" ];
        }
    }
    function getWrapperTag(blockType) {
        switch (blockType) {
          case _draftJsUtils.BLOCK_TYPE.UNORDERED_LIST_ITEM:
            return "ul";

          case _draftJsUtils.BLOCK_TYPE.ORDERED_LIST_ITEM:
            return "ol";

          default:
            return null;
        }
    }
    function stringifyAttrs(attrs) {
        if (null == attrs) return "";
        var parts = [], _iteratorNormalCompletion6 = !0, _didIteratorError6 = !1, _iteratorError6 = void 0;
        try {
            for (var _step6, _iterator6 = Object.keys(attrs)[Symbol.iterator](); !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = !0) {
                var name = _step6.value, value = attrs[name];
                null != value && parts.push(" " + name + '="' + encodeAttr(value + "") + '"');
            }
        } catch (err) {
            _didIteratorError6 = !0, _iteratorError6 = err;
        } finally {
            try {
                !_iteratorNormalCompletion6 && _iterator6.return && _iterator6.return();
            } finally {
                if (_didIteratorError6) throw _iteratorError6;
            }
        }
        return parts.join("");
    }
    function canHaveDepth(blockType) {
        switch (blockType) {
          case _draftJsUtils.BLOCK_TYPE.UNORDERED_LIST_ITEM:
          case _draftJsUtils.BLOCK_TYPE.ORDERED_LIST_ITEM:
            return !0;

          default:
            return !1;
        }
    }
    function encodeContent(text) {
        return text.split("&").join("&amp;").split("<").join("&lt;").split(">").join("&gt;").split(" ").join("&nbsp;").split("\n").join(BREAK + "\n");
    }
    function encodeAttr(text) {
        return text.split("&").join("&amp;").split("<").join("&lt;").split(">").join("&gt;").split('"').join("&quot;");
    }
    function stateToHTML(content, options) {
        return new MarkupGenerator(content, options).generate();
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _DEFAULT_STYLE_MAP, _ENTITY_ATTR_MAP, _DATA_TO_ATTR, _extends = Object.assign || function(target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
        }
        return target;
    }, _slicedToArray = function() {
        function sliceIterator(arr, i) {
            var _arr = [], _n = !0, _d = !1, _e = void 0;
            try {
                for (var _s, _i = arr[Symbol.iterator](); !(_n = (_s = _i.next()).done) && (_arr.push(_s.value), 
                !i || _arr.length !== i); _n = !0) ;
            } catch (err) {
                _d = !0, _e = err;
            } finally {
                try {
                    !_n && _i.return && _i.return();
                } finally {
                    if (_d) throw _e;
                }
            }
            return _arr;
        }
        return function(arr, i) {
            if (Array.isArray(arr)) return arr;
            if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
    }(), _createClass = function() {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 
                "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), 
            Constructor;
        };
    }();
    exports.default = stateToHTML;
    var _combineOrderedStyles3 = __webpack_require__(330), _combineOrderedStyles4 = _interopRequireDefault(_combineOrderedStyles3), _normalizeAttributes = __webpack_require__(331), _normalizeAttributes2 = _interopRequireDefault(_normalizeAttributes), _styleToCSS = __webpack_require__(332), _styleToCSS2 = _interopRequireDefault(_styleToCSS), _draftJsUtils = __webpack_require__(29), BOLD = _draftJsUtils.INLINE_STYLE.BOLD, CODE = _draftJsUtils.INLINE_STYLE.CODE, ITALIC = _draftJsUtils.INLINE_STYLE.ITALIC, STRIKETHROUGH = _draftJsUtils.INLINE_STYLE.STRIKETHROUGH, UNDERLINE = _draftJsUtils.INLINE_STYLE.UNDERLINE, INDENT = "  ", BREAK = "<br>", DATA_ATTRIBUTE = /^data-([a-z0-9-]+)$/, DEFAULT_STYLE_MAP = (_DEFAULT_STYLE_MAP = {}, 
    _defineProperty(_DEFAULT_STYLE_MAP, BOLD, {
        element: "strong"
    }), _defineProperty(_DEFAULT_STYLE_MAP, CODE, {
        element: "code"
    }), _defineProperty(_DEFAULT_STYLE_MAP, ITALIC, {
        element: "em"
    }), _defineProperty(_DEFAULT_STYLE_MAP, STRIKETHROUGH, {
        element: "del"
    }), _defineProperty(_DEFAULT_STYLE_MAP, UNDERLINE, {
        element: "u"
    }), _DEFAULT_STYLE_MAP), DEFAULT_STYLE_ORDER = [ BOLD, ITALIC, UNDERLINE, STRIKETHROUGH, CODE ], ENTITY_ATTR_MAP = (_ENTITY_ATTR_MAP = {}, 
    _defineProperty(_ENTITY_ATTR_MAP, _draftJsUtils.ENTITY_TYPE.LINK, {
        url: "href",
        href: "href",
        rel: "rel",
        target: "target",
        title: "title",
        className: "class"
    }), _defineProperty(_ENTITY_ATTR_MAP, _draftJsUtils.ENTITY_TYPE.IMAGE, {
        src: "src",
        height: "height",
        width: "width",
        alt: "alt",
        className: "class"
    }), _ENTITY_ATTR_MAP), DATA_TO_ATTR = (_DATA_TO_ATTR = {}, _defineProperty(_DATA_TO_ATTR, _draftJsUtils.ENTITY_TYPE.LINK, function(entityType, entity) {
        var attrMap = ENTITY_ATTR_MAP.hasOwnProperty(entityType) ? ENTITY_ATTR_MAP[entityType] : {}, data = entity.getData(), attrs = {}, _iteratorNormalCompletion = !0, _didIteratorError = !1, _iteratorError = void 0;
        try {
            for (var _step, _iterator = Object.keys(data)[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = !0) {
                var dataKey = _step.value, dataValue = data[dataKey];
                if (attrMap.hasOwnProperty(dataKey)) {
                    attrs[attrMap[dataKey]] = dataValue;
                } else DATA_ATTRIBUTE.test(dataKey) && (attrs[dataKey] = dataValue);
            }
        } catch (err) {
            _didIteratorError = !0, _iteratorError = err;
        } finally {
            try {
                !_iteratorNormalCompletion && _iterator.return && _iterator.return();
            } finally {
                if (_didIteratorError) throw _iteratorError;
            }
        }
        return attrs;
    }), _defineProperty(_DATA_TO_ATTR, _draftJsUtils.ENTITY_TYPE.IMAGE, function(entityType, entity) {
        var attrMap = ENTITY_ATTR_MAP.hasOwnProperty(entityType) ? ENTITY_ATTR_MAP[entityType] : {}, data = entity.getData(), attrs = {}, _iteratorNormalCompletion2 = !0, _didIteratorError2 = !1, _iteratorError2 = void 0;
        try {
            for (var _step2, _iterator2 = Object.keys(data)[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = !0) {
                var dataKey = _step2.value, dataValue = data[dataKey];
                if (attrMap.hasOwnProperty(dataKey)) {
                    attrs[attrMap[dataKey]] = dataValue;
                } else DATA_ATTRIBUTE.test(dataKey) && (attrs[dataKey] = dataValue);
            }
        } catch (err) {
            _didIteratorError2 = !0, _iteratorError2 = err;
        } finally {
            try {
                !_iteratorNormalCompletion2 && _iterator2.return && _iterator2.return();
            } finally {
                if (_didIteratorError2) throw _iteratorError2;
            }
        }
        return attrs;
    }), _DATA_TO_ATTR), MarkupGenerator = function() {
        // These are related to state.
        function MarkupGenerator(contentState, options) {
            _classCallCheck(this, MarkupGenerator), null == options && (options = {}), this.contentState = contentState, 
            this.options = options;
            var _combineOrderedStyles = (0, _combineOrderedStyles4.default)(options.inlineStyles, [ DEFAULT_STYLE_MAP, DEFAULT_STYLE_ORDER ]), _combineOrderedStyles2 = _slicedToArray(_combineOrderedStyles, 2), inlineStyles = _combineOrderedStyles2[0], styleOrder = _combineOrderedStyles2[1];
            this.inlineStyles = inlineStyles, this.styleOrder = styleOrder;
        }
        // These are related to user-defined options.
        return _createClass(MarkupGenerator, [ {
            key: "generate",
            value: function() {
                for (this.output = [], this.blocks = this.contentState.getBlocksAsArray(), this.totalBlocks = this.blocks.length, 
                this.currentBlock = 0, this.indentLevel = 0, this.wrapperTag = null; this.currentBlock < this.totalBlocks; ) this.processBlock();
                return this.closeWrapperTag(), this.output.join("").trim();
            }
        }, {
            key: "processBlock",
            value: function() {
                var _options = this.options, blockRenderers = _options.blockRenderers, defaultBlockTag = _options.defaultBlockTag, block = this.blocks[this.currentBlock], blockType = block.getType(), newWrapperTag = getWrapperTag(blockType);
                this.wrapperTag !== newWrapperTag && (this.wrapperTag && this.closeWrapperTag(), 
                newWrapperTag && this.openWrapperTag(newWrapperTag)), this.indent();
                // Allow blocks to be rendered using a custom renderer.
                var customRenderer = null != blockRenderers && blockRenderers.hasOwnProperty(blockType) ? blockRenderers[blockType] : null, customRendererOutput = customRenderer ? customRenderer(block) : null;
                // Renderer can return null, which will cause processing to continue as normal.
                if (null != customRendererOutput) return this.output.push(customRendererOutput), 
                this.output.push("\n"), void (this.currentBlock += 1);
                this.writeStartTag(block, defaultBlockTag), this.output.push(this.renderBlockContent(block));
                // Look ahead and see if we will nest list.
                var nextBlock = this.getNextBlock();
                if (canHaveDepth(blockType) && nextBlock && nextBlock.getDepth() === block.getDepth() + 1) {
                    this.output.push("\n");
                    // This is a litle hacky: temporarily stash our current wrapperTag and
                    // render child list(s).
                    var thisWrapperTag = this.wrapperTag;
                    this.wrapperTag = null, this.indentLevel += 1, this.currentBlock += 1, this.processBlocksAtDepth(nextBlock.getDepth()), 
                    this.wrapperTag = thisWrapperTag, this.indentLevel -= 1, this.indent();
                } else this.currentBlock += 1;
                this.writeEndTag(block, defaultBlockTag);
            }
        }, {
            key: "processBlocksAtDepth",
            value: function(depth) {
                for (var block = this.blocks[this.currentBlock]; block && block.getDepth() === depth; ) this.processBlock(), 
                block = this.blocks[this.currentBlock];
                this.closeWrapperTag();
            }
        }, {
            key: "getNextBlock",
            value: function() {
                return this.blocks[this.currentBlock + 1];
            }
        }, {
            key: "writeStartTag",
            value: function(block, defaultBlockTag) {
                var tags = getTags(block.getType(), defaultBlockTag), attrString = void 0;
                if (this.options.blockStyleFn) {
                    var _ref = this.options.blockStyleFn(block) || {}, _attributes = _ref.attributes, _style = _ref.style;
                    if (// Normalize `className` -> `class`, etc.
                    _attributes = (0, _normalizeAttributes2.default)(_attributes), null != _style) {
                        var styleAttr = (0, _styleToCSS2.default)(_style);
                        _attributes = null == _attributes ? {
                            style: styleAttr
                        } : _extends({}, _attributes, {
                            style: styleAttr
                        });
                    }
                    attrString = stringifyAttrs(_attributes);
                } else attrString = "";
                var _iteratorNormalCompletion3 = !0, _didIteratorError3 = !1, _iteratorError3 = void 0;
                try {
                    for (var _step3, _iterator3 = tags[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = !0) {
                        var tag = _step3.value;
                        this.output.push("<" + tag + attrString + ">");
                    }
                } catch (err) {
                    _didIteratorError3 = !0, _iteratorError3 = err;
                } finally {
                    try {
                        !_iteratorNormalCompletion3 && _iterator3.return && _iterator3.return();
                    } finally {
                        if (_didIteratorError3) throw _iteratorError3;
                    }
                }
            }
        }, {
            key: "writeEndTag",
            value: function(block, defaultBlockTag) {
                var tags = getTags(block.getType(), defaultBlockTag);
                if (1 === tags.length) this.output.push("</" + tags[0] + ">\n"); else {
                    var output = [], _iteratorNormalCompletion4 = !0, _didIteratorError4 = !1, _iteratorError4 = void 0;
                    try {
                        for (var _step4, _iterator4 = tags[Symbol.iterator](); !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = !0) {
                            var tag = _step4.value;
                            output.unshift("</" + tag + ">");
                        }
                    } catch (err) {
                        _didIteratorError4 = !0, _iteratorError4 = err;
                    } finally {
                        try {
                            !_iteratorNormalCompletion4 && _iterator4.return && _iterator4.return();
                        } finally {
                            if (_didIteratorError4) throw _iteratorError4;
                        }
                    }
                    this.output.push(output.join("") + "\n");
                }
            }
        }, {
            key: "openWrapperTag",
            value: function(wrapperTag) {
                this.wrapperTag = wrapperTag, this.indent(), this.output.push("<" + wrapperTag + ">\n"), 
                this.indentLevel += 1;
            }
        }, {
            key: "closeWrapperTag",
            value: function() {
                var wrapperTag = this.wrapperTag;
                wrapperTag && (this.indentLevel -= 1, this.indent(), this.output.push("</" + wrapperTag + ">\n"), 
                this.wrapperTag = null);
            }
        }, {
            key: "indent",
            value: function() {
                this.output.push(INDENT.repeat(this.indentLevel));
            }
        }, {
            key: "renderBlockContent",
            value: function(block) {
                var _this = this, blockType = block.getType(), text = block.getText();
                if ("" === text) // Prevent element collapse if completely empty.
                return BREAK;
                text = this.preserveWhitespace(text);
                var charMetaList = block.getCharacterList();
                return (0, _draftJsUtils.getEntityRanges)(text, charMetaList).map(function(_ref2) {
                    var _ref3 = _slicedToArray(_ref2, 2), entityKey = _ref3[0], stylePieces = _ref3[1], content = stylePieces.map(function(_ref4) {
                        var _ref5 = _slicedToArray(_ref4, 2), text = _ref5[0], styleSet = _ref5[1], content = encodeContent(text), _iteratorNormalCompletion5 = !0, _didIteratorError5 = !1, _iteratorError5 = void 0;
                        try {
                            for (var _step5, _iterator5 = _this.styleOrder[Symbol.iterator](); !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = !0) {
                                var _styleName = _step5.value;
                                // If our block type is CODE then don't wrap inline code elements.
                                if ((_styleName !== CODE || blockType !== _draftJsUtils.BLOCK_TYPE.CODE) && styleSet.has(_styleName)) {
                                    var _inlineStyles$_styleN = _this.inlineStyles[_styleName], _element = _inlineStyles$_styleN.element, _attributes2 = _inlineStyles$_styleN.attributes, _style2 = _inlineStyles$_styleN.style;
                                    if (null == _element && (_element = "span"), // Normalize `className` -> `class`, etc.
                                    _attributes2 = (0, _normalizeAttributes2.default)(_attributes2), null != _style2) {
                                        var styleAttr = (0, _styleToCSS2.default)(_style2);
                                        _attributes2 = null == _attributes2 ? {
                                            style: styleAttr
                                        } : _extends({}, _attributes2, {
                                            style: styleAttr
                                        });
                                    }
                                    content = "<" + _element + stringifyAttrs(_attributes2) + ">" + content + "</" + _element + ">";
                                }
                            }
                        } catch (err) {
                            _didIteratorError5 = !0, _iteratorError5 = err;
                        } finally {
                            try {
                                !_iteratorNormalCompletion5 && _iterator5.return && _iterator5.return();
                            } finally {
                                if (_didIteratorError5) throw _iteratorError5;
                            }
                        }
                        return content;
                    }).join(""), entity = entityKey ? _this.contentState.getEntity(entityKey) : null, entityType = null == entity ? null : entity.getType().toUpperCase(), entityStyle = void 0;
                    if (null != entity && _this.options.entityStyleFn && (entityStyle = _this.options.entityStyleFn(entity))) {
                        var _entityStyle = entityStyle, _element2 = _entityStyle.element, _attributes3 = _entityStyle.attributes, _style3 = _entityStyle.style;
                        if (null == _element2 && (_element2 = "span"), // Normalize `className` -> `class`, etc.
                        _attributes3 = (0, _normalizeAttributes2.default)(_attributes3), null != _style3) {
                            var styleAttr = (0, _styleToCSS2.default)(_style3);
                            _attributes3 = null == _attributes3 ? {
                                style: styleAttr
                            } : _extends({}, _attributes3, {
                                style: styleAttr
                            });
                        }
                        return "<" + _element2 + stringifyAttrs(_attributes3) + ">" + content + "</" + _element2 + ">";
                    }
                    return null != entityType && entityType === _draftJsUtils.ENTITY_TYPE.LINK ? "<a" + stringifyAttrs(DATA_TO_ATTR.hasOwnProperty(entityType) ? DATA_TO_ATTR[entityType](entityType, entity) : null) + ">" + content + "</a>" : null != entityType && entityType === _draftJsUtils.ENTITY_TYPE.IMAGE ? "<img" + stringifyAttrs(DATA_TO_ATTR.hasOwnProperty(entityType) ? DATA_TO_ATTR[entityType](entityType, entity) : null) + "/>" : content;
                }).join("");
            }
        }, {
            key: "preserveWhitespace",
            value: function(text) {
                for (var length = text.length, newText = new Array(length), i = 0; i < length; i++) " " !== text[i] || 0 !== i && i !== length - 1 && " " !== text[i - 1] ? newText[i] = text[i] : newText[i] = " ";
                return newText.join("");
            }
        } ]), MarkupGenerator;
    }();
}, /* 330 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _toConsumableArray(arr) {
        if (Array.isArray(arr)) {
            for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
            return arr2;
        }
        return Array.from(arr);
    }
    function combineOrderedStyles(customMap, defaults) {
        if (null == customMap) return defaults;
        var _defaults = _slicedToArray(defaults, 2), defaultStyleMap = _defaults[0], defaultStyleOrder = _defaults[1], styleMap = _extends({}, defaultStyleMap), styleOrder = [].concat(_toConsumableArray(defaultStyleOrder)), _iteratorNormalCompletion = !0, _didIteratorError = !1, _iteratorError = void 0;
        try {
            for (var _step, _iterator = Object.keys(customMap)[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = !0) {
                var _styleName = _step.value;
                if (defaultStyleMap.hasOwnProperty(_styleName)) {
                    var defaultStyles = defaultStyleMap[_styleName];
                    styleMap[_styleName] = _extends({}, defaultStyles, customMap[_styleName]);
                } else styleMap[_styleName] = customMap[_styleName], styleOrder.push(_styleName);
            }
        } catch (err) {
            _didIteratorError = !0, _iteratorError = err;
        } finally {
            try {
                !_iteratorNormalCompletion && _iterator.return && _iterator.return();
            } finally {
                if (_didIteratorError) throw _iteratorError;
            }
        }
        return [ styleMap, styleOrder ];
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends = Object.assign || function(target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
        }
        return target;
    }, _slicedToArray = function() {
        function sliceIterator(arr, i) {
            var _arr = [], _n = !0, _d = !1, _e = void 0;
            try {
                for (var _s, _i = arr[Symbol.iterator](); !(_n = (_s = _i.next()).done) && (_arr.push(_s.value), 
                !i || _arr.length !== i); _n = !0) ;
            } catch (err) {
                _d = !0, _e = err;
            } finally {
                try {
                    !_n && _i.return && _i.return();
                } finally {
                    if (_d) throw _e;
                }
            }
            return _arr;
        }
        return function(arr, i) {
            if (Array.isArray(arr)) return arr;
            if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
    }();
    exports.default = combineOrderedStyles;
}, /* 331 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function normalizeAttributes(attributes) {
        if (null == attributes) return attributes;
        var normalized = {}, didNormalize = !1, _iteratorNormalCompletion = !0, _didIteratorError = !1, _iteratorError = void 0;
        try {
            for (var _step, _iterator = Object.keys(attributes)[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = !0) {
                var name = _step.value, newName = name;
                ATTR_NAME_MAP.hasOwnProperty(name) && (newName = ATTR_NAME_MAP[name], didNormalize = !0), 
                normalized[newName] = attributes[name];
            }
        } catch (err) {
            _didIteratorError = !0, _iteratorError = err;
        } finally {
            try {
                !_iteratorNormalCompletion && _iterator.return && _iterator.return();
            } finally {
                if (_didIteratorError) throw _iteratorError;
            }
        }
        return didNormalize ? normalized : attributes;
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    // Lifted from: https://github.com/facebook/react/blob/master/src/renderers/dom/shared/HTMLDOMPropertyConfig.js
    var ATTR_NAME_MAP = {
        acceptCharset: "accept-charset",
        className: "class",
        htmlFor: "for",
        httpEquiv: "http-equiv"
    };
    exports.default = normalizeAttributes;
}, /* 332 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    // Lifted from: https://github.com/facebook/react/blob/master/src/renderers/dom/shared/CSSPropertyOperations.js
    function processStyleName(name) {
        return name.replace(UPPERCASE_PATTERN, "-$1").toLowerCase().replace(VENDOR_PREFIX, "-$1-");
    }
    // Lifted from: https://github.com/facebook/react/blob/master/src/renderers/dom/shared/dangerousStyleValue.js
    function processStyleValue(name, value) {
        var isNumeric = void 0;
        return "string" == typeof value ? isNumeric = NUMERIC_STRING.test(value) : (isNumeric = !0, 
        value = String(value)), isNumeric && "0" !== value && !0 !== isUnitlessNumber[name] ? value + "px" : value;
    }
    function styleToCSS(styleDescr) {
        return Object.keys(styleDescr).map(function(name) {
            var styleValue = processStyleValue(name, styleDescr[name]);
            return processStyleName(name) + ": " + styleValue;
        }).join("; ");
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var VENDOR_PREFIX = /^(moz|ms|o|webkit)-/, NUMERIC_STRING = /^\d+$/, UPPERCASE_PATTERN = /([A-Z])/g, isUnitlessNumber = {
        animationIterationCount: !0,
        borderImageOutset: !0,
        borderImageSlice: !0,
        borderImageWidth: !0,
        boxFlex: !0,
        boxFlexGroup: !0,
        boxOrdinalGroup: !0,
        columnCount: !0,
        flex: !0,
        flexGrow: !0,
        flexPositive: !0,
        flexShrink: !0,
        flexNegative: !0,
        flexOrder: !0,
        gridRow: !0,
        gridRowEnd: !0,
        gridRowSpan: !0,
        gridRowStart: !0,
        gridColumn: !0,
        gridColumnEnd: !0,
        gridColumnSpan: !0,
        gridColumnStart: !0,
        fontWeight: !0,
        lineClamp: !0,
        lineHeight: !0,
        opacity: !0,
        order: !0,
        orphans: !0,
        tabSize: !0,
        widows: !0,
        zIndex: !0,
        zoom: !0,
        // SVG-related properties
        fillOpacity: !0,
        floodOpacity: !0,
        stopOpacity: !0,
        strokeDasharray: !0,
        strokeDashoffset: !0,
        strokeMiterlimit: !0,
        strokeOpacity: !0,
        strokeWidth: !0
    };
    exports.default = styleToCSS;
}, /* 333 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _stateFromHTML = __webpack_require__(334);
    Object.defineProperty(exports, "stateFromHTML", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_stateFromHTML).default;
        }
    });
}, /* 334 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _objectWithoutProperties(obj, keys) {
        var target = {};
        for (var i in obj) keys.indexOf(i) >= 0 || Object.prototype.hasOwnProperty.call(obj, i) && (target[i] = obj[i]);
        return target;
    }
    function stateFromHTML(html, options) {
        var _ref = options || {}, parser = _ref.parser, otherOptions = _objectWithoutProperties(_ref, [ "parser" ]);
        null == parser && (parser = _parseHTML2.default);
        var element = parser(html);
        return (0, _draftJsImportElement.stateFromElement)(element, otherOptions);
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.default = stateFromHTML;
    var _draftJsImportElement = __webpack_require__(141), _parseHTML = __webpack_require__(339), _parseHTML2 = function(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }(_parseHTML);
}, /* 335 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function trimLeadingNewline(text, characterMeta) {
        return "\n" === text.charAt(0) && (text = text.slice(1), characterMeta = characterMeta.slice(1)), 
        {
            text: text,
            characterMeta: characterMeta
        };
    }
    function trimLeadingSpace(text, characterMeta) {
        for (;" " === text.charAt(0); ) text = text.slice(1), characterMeta = characterMeta.slice(1);
        return {
            text: text,
            characterMeta: characterMeta
        };
    }
    function trimTrailingSpace(text, characterMeta) {
        for (;" " === text.slice(-1); ) text = text.slice(0, -1), characterMeta = characterMeta.slice(0, -1);
        return {
            text: text,
            characterMeta: characterMeta
        };
    }
    function collapseWhiteSpace(text, characterMeta) {
        text = text.replace(/[ \t\n]/g, " ");
        var _trimLeadingSpace = trimLeadingSpace(text, characterMeta);
        text = _trimLeadingSpace.text, characterMeta = _trimLeadingSpace.characterMeta;
        var _trimTrailingSpace = trimTrailingSpace(text, characterMeta);
        text = _trimTrailingSpace.text, characterMeta = _trimTrailingSpace.characterMeta;
        for (var i = text.length; i--; ) " " === text.charAt(i) && " " === text.charAt(i - 1) && (text = text.slice(0, i) + text.slice(i + 1), 
        characterMeta = characterMeta.slice(0, i).concat(characterMeta.slice(i + 1)));
        // There could still be one space on either side of a softbreak.
        var _replaceTextWithMeta = (0, _replaceTextWithMeta4.default)({
            text: text,
            characterMeta: characterMeta
        }, SOFT_BREAK_PLACEHOLDER + " ", SOFT_BREAK_PLACEHOLDER);
        text = _replaceTextWithMeta.text, characterMeta = _replaceTextWithMeta.characterMeta;
        var _replaceTextWithMeta2 = (0, _replaceTextWithMeta4.default)({
            text: text,
            characterMeta: characterMeta
        }, " " + SOFT_BREAK_PLACEHOLDER, SOFT_BREAK_PLACEHOLDER);
        return text = _replaceTextWithMeta2.text, characterMeta = _replaceTextWithMeta2.characterMeta, 
        {
            text: text,
            characterMeta: characterMeta
        };
    }
    function canHaveDepth(blockType) {
        switch (blockType) {
          case _draftJsUtils.BLOCK_TYPE.UNORDERED_LIST_ITEM:
          case _draftJsUtils.BLOCK_TYPE.ORDERED_LIST_ITEM:
            return !0;

          default:
            return !1;
        }
    }
    function concatFragments(fragments) {
        var text = "", characterMeta = (0, _immutable.Seq)();
        return fragments.forEach(function(textFragment) {
            text += textFragment.text, characterMeta = characterMeta.concat(textFragment.characterMeta);
        }), {
            text: text,
            characterMeta: characterMeta
        };
    }
    function addStyleFromTagName(styleSet, tagName, elementStyles) {
        switch (tagName) {
          case "b":
          case "strong":
            return styleSet.add(_draftJsUtils.INLINE_STYLE.BOLD);

          case "i":
          case "em":
            return styleSet.add(_draftJsUtils.INLINE_STYLE.ITALIC);

          case "u":
          case "ins":
            return styleSet.add(_draftJsUtils.INLINE_STYLE.UNDERLINE);

          case "code":
            return styleSet.add(_draftJsUtils.INLINE_STYLE.CODE);

          case "s":
          case "del":
            return styleSet.add(_draftJsUtils.INLINE_STYLE.STRIKETHROUGH);

          default:
            // Allow custom styles to be provided.
            // Allow custom styles to be provided.
            return elementStyles && elementStyles[tagName] ? styleSet.add(elementStyles[tagName]) : styleSet;
        }
    }
    function hasSemanticMeaning(blockType) {
        return blockType !== _draftJsUtils.BLOCK_TYPE.UNSTYLED;
    }
    function stateFromElement(element, options) {
        return new ContentGenerator(options).process(element);
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _createClass = function() {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 
                "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), 
            Constructor;
        };
    }();
    exports.stateFromElement = stateFromElement;
    var _replaceTextWithMeta3 = __webpack_require__(336), _replaceTextWithMeta4 = function(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }(_replaceTextWithMeta3), _draftJs = __webpack_require__(10), _immutable = __webpack_require__(91), _draftJsUtils = __webpack_require__(29), _syntheticDom = __webpack_require__(142), _Constants = __webpack_require__(338), NO_STYLE = (0, 
    _immutable.OrderedSet)(), EMPTY_BLOCK = new _draftJs.ContentBlock({
        key: (0, _draftJs.genKey)(),
        text: "",
        type: _draftJsUtils.BLOCK_TYPE.UNSTYLED,
        characterList: (0, _immutable.List)(),
        depth: 0
    }), LINE_BREAKS = /(\r\n|\r|\n)/g, SOFT_BREAK_PLACEHOLDER = "\r", DATA_ATTRIBUTE = /^data-([a-z0-9-]+)$/, ELEM_ATTR_MAP = {
        a: {
            href: "url",
            rel: "rel",
            target: "target",
            title: "title"
        },
        img: {
            src: "src",
            alt: "alt"
        }
    }, getEntityData = function(tagName, element) {
        var data = {};
        if (ELEM_ATTR_MAP.hasOwnProperty(tagName)) for (var attrMap = ELEM_ATTR_MAP[tagName], i = 0; i < element.attributes.length; i++) {
            var _element$attributes$i = element.attributes[i], name = _element$attributes$i.name, value = _element$attributes$i.value;
            if (null != value) if (attrMap.hasOwnProperty(name)) {
                var newName = attrMap[name];
                data[newName] = value;
            } else DATA_ATTRIBUTE.test(name) && (data[name] = value);
        }
        return data;
    }, ElementToEntity = {
        a: function(generator, tagName, element) {
            var data = getEntityData(tagName, element);
            // Don't add `<a>` elements with no href.
            if (null != data.url) return generator.createEntity(_draftJsUtils.ENTITY_TYPE.LINK, data);
        },
        img: function(generator, tagName, element) {
            var data = getEntityData(tagName, element);
            // Don't add `<img>` elements with no src.
            if (null != data.src) return generator.createEntity(_draftJsUtils.ENTITY_TYPE.IMAGE, data);
        }
    }, ContentGenerator = function() {
        function ContentGenerator() {
            var _this = this, options = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            _classCallCheck(this, ContentGenerator), this.inlineCreators = {
                Style: function(style) {
                    return {
                        type: "STYLE",
                        style: style
                    };
                },
                Entity: function(type, data) {
                    var mutability = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "MUTABLE";
                    return {
                        type: "ENTITY",
                        entityKey: _this.createEntity(type, data, mutability)
                    };
                }
            }, this.options = options, this.contentStateForEntities = _draftJs.ContentState.createFromBlockArray([]), 
            // This represents the hierarchy as we traverse nested elements; for
            // example [body, ul, li] where we must know li's parent type (ul or ol).
            this.blockStack = [], // This is a linear list of blocks that will form the output; for example
            // [p, li, li, blockquote].
            this.blockList = [], this.depth = 0;
        }
        // This will be passed to the customInlineFn to allow it
        // to return a Style() or Entity().
        return _createClass(ContentGenerator, [ {
            key: "process",
            value: function(element) {
                this.processBlockElement(element);
                var contentBlocks = [];
                return this.blockList.forEach(function(block) {
                    var _concatFragments = concatFragments(block.textFragments), text = _concatFragments.text, characterMeta = _concatFragments.characterMeta, includeEmptyBlock = !1;
                    if (// If the block contains only a soft break then don't discard the block,
                    // but discard the soft break.
                    text === SOFT_BREAK_PLACEHOLDER && (includeEmptyBlock = !0, text = ""), "pre" === block.tagName) {
                        var _trimLeadingNewline = trimLeadingNewline(text, characterMeta);
                        text = _trimLeadingNewline.text, characterMeta = _trimLeadingNewline.characterMeta;
                    } else {
                        var _collapseWhiteSpace = collapseWhiteSpace(text, characterMeta);
                        text = _collapseWhiteSpace.text, characterMeta = _collapseWhiteSpace.characterMeta;
                    }
                    // Previously we were using a placeholder for soft breaks. Now that we
                    // have collapsed whitespace we can change it back to normal line breaks.
                    text = text.split(SOFT_BREAK_PLACEHOLDER).join("\n"), // Discard empty blocks (unless otherwise specified).
                    (text.length || includeEmptyBlock) && contentBlocks.push(new _draftJs.ContentBlock({
                        key: (0, _draftJs.genKey)(),
                        text: text,
                        type: block.type,
                        characterList: characterMeta.toList(),
                        depth: block.depth,
                        data: block.data ? (0, _immutable.Map)(block.data) : (0, _immutable.Map)()
                    }));
                }), contentBlocks.length || (contentBlocks = [ EMPTY_BLOCK ]), _draftJs.ContentState.createFromBlockArray(contentBlocks, this.contentStateForEntities.getEntityMap());
            }
        }, {
            key: "getBlockTypeFromTagName",
            value: function(tagName) {
                var blockTypes = this.options.blockTypes;
                if (blockTypes && blockTypes[tagName]) return blockTypes[tagName];
                switch (tagName) {
                  case "li":
                    return "ol" === this.blockStack.slice(-1)[0].tagName ? _draftJsUtils.BLOCK_TYPE.ORDERED_LIST_ITEM : _draftJsUtils.BLOCK_TYPE.UNORDERED_LIST_ITEM;

                  case "blockquote":
                    return _draftJsUtils.BLOCK_TYPE.BLOCKQUOTE;

                  case "h1":
                    return _draftJsUtils.BLOCK_TYPE.HEADER_ONE;

                  case "h2":
                    return _draftJsUtils.BLOCK_TYPE.HEADER_TWO;

                  case "h3":
                    return _draftJsUtils.BLOCK_TYPE.HEADER_THREE;

                  case "h4":
                    return _draftJsUtils.BLOCK_TYPE.HEADER_FOUR;

                  case "h5":
                    return _draftJsUtils.BLOCK_TYPE.HEADER_FIVE;

                  case "h6":
                    return _draftJsUtils.BLOCK_TYPE.HEADER_SIX;

                  case "pre":
                    return _draftJsUtils.BLOCK_TYPE.CODE;

                  case "figure":
                    return _draftJsUtils.BLOCK_TYPE.ATOMIC;

                  default:
                    return _draftJsUtils.BLOCK_TYPE.UNSTYLED;
                }
            }
        }, {
            key: "processBlockElement",
            value: function(element) {
                if (element) {
                    var customBlockFn = this.options.customBlockFn, tagName = element.nodeName.toLowerCase(), type = void 0, data = void 0;
                    if (customBlockFn) {
                        var customBlock = customBlockFn(element);
                        null != customBlock && (type = customBlock.type, data = customBlock.data);
                    }
                    var isCustomType = !0;
                    null == type && (isCustomType = !1, type = this.getBlockTypeFromTagName(tagName));
                    var hasDepth = canHaveDepth(type), allowRender = !_Constants.SPECIAL_ELEMENTS.hasOwnProperty(tagName);
                    if (!isCustomType && !hasSemanticMeaning(type)) {
                        var parent = this.blockStack.slice(-1)[0];
                        parent && (type = parent.type);
                    }
                    var block = {
                        tagName: tagName,
                        textFragments: [],
                        type: type,
                        styleStack: [ NO_STYLE ],
                        entityStack: [ null ],
                        depth: hasDepth ? this.depth : 0,
                        data: data
                    };
                    allowRender && (this.blockList.push(block), hasDepth && (this.depth += 1)), this.blockStack.push(block), 
                    null != element.childNodes && Array.from(element.childNodes).forEach(this.processNode, this), 
                    this.blockStack.pop(), allowRender && hasDepth && (this.depth -= 1);
                }
            }
        }, {
            key: "processInlineElement",
            value: function(element) {
                var tagName = element.nodeName.toLowerCase();
                if ("br" === tagName) return void this.processText(SOFT_BREAK_PLACEHOLDER);
                var block = this.blockStack.slice(-1)[0], style = block.styleStack.slice(-1)[0], entityKey = block.entityStack.slice(-1)[0], customInlineFn = this.options.customInlineFn, customInline = customInlineFn ? customInlineFn(element, this.inlineCreators) : null;
                if (null != customInline) switch (customInline.type) {
                  case "STYLE":
                    style = style.add(customInline.style);
                    break;

                  case "ENTITY":
                    entityKey = customInline.entityKey;
                } else style = addStyleFromTagName(style, tagName, this.options.elementStyles), 
                ElementToEntity.hasOwnProperty(tagName) && (// If the to-entity function returns nothing, use the existing entity.
                entityKey = ElementToEntity[tagName](this, tagName, element) || entityKey);
                block.styleStack.push(style), block.entityStack.push(entityKey), null != element.childNodes && Array.from(element.childNodes).forEach(this.processNode, this), 
                _Constants.SELF_CLOSING_ELEMENTS.hasOwnProperty(tagName) && this.processText(" "), 
                block.entityStack.pop(), block.styleStack.pop();
            }
        }, {
            key: "processTextNode",
            value: function(node) {
                var text = node.nodeValue;
                // This is important because we will use \r as a placeholder for a soft break.
                text = text.replace(LINE_BREAKS, "\n"), // Replace zero-width space (we use it as a placeholder in markdown) with a
                // soft break.
                // TODO: The import-markdown package should correctly turn breaks into <br>
                // elements so we don't need to include this hack.
                text = text.split("​").join(SOFT_BREAK_PLACEHOLDER), this.processText(text);
            }
        }, {
            key: "processText",
            value: function(text) {
                var block = this.blockStack.slice(-1)[0], style = block.styleStack.slice(-1)[0], entity = block.entityStack.slice(-1)[0], charMetadata = _draftJs.CharacterMetadata.create({
                    style: style,
                    entity: entity
                }), seq = (0, _immutable.Repeat)(charMetadata, text.length);
                block.textFragments.push({
                    text: text,
                    characterMeta: seq
                });
            }
        }, {
            key: "processNode",
            value: function(node) {
                if (node.nodeType === _syntheticDom.NODE_TYPE_ELEMENT) {
                    // $FlowIssue
                    var _element = node, _tagName = _element.nodeName.toLowerCase();
                    _Constants.INLINE_ELEMENTS.hasOwnProperty(_tagName) ? this.processInlineElement(_element) : this.processBlockElement(_element);
                } else node.nodeType === _syntheticDom.NODE_TYPE_TEXT && this.processTextNode(node);
            }
        }, {
            key: "createEntity",
            value: function(type, data) {
                var mutability = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "MUTABLE";
                return this.contentStateForEntities = this.contentStateForEntities.createEntity(type, mutability, data), 
                this.contentStateForEntities.getLastCreatedEntityKey();
            }
        } ]), ContentGenerator;
    }();
    exports.default = stateFromElement;
}, /* 336 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function replaceTextWithMeta(subject, searchText, replaceText) {
        for (var text = subject.text, characterMeta = subject.characterMeta, searchTextLength = searchText.length, replaceTextLength = replaceText.length, resultTextParts = [], resultCharMeta = characterMeta.slice(0, 0), lastEndIndex = 0, index = text.indexOf(searchText); -1 !== index; ) resultTextParts.push(text.slice(lastEndIndex, index) + replaceText), 
        resultCharMeta = resultCharMeta.concat(characterMeta.slice(lastEndIndex, index), // Use the metadata of the first char we are replacing.
        repeatSeq(characterMeta.slice(index, index + 1), replaceTextLength)), lastEndIndex = index + searchTextLength, 
        index = text.indexOf(searchText, lastEndIndex);
        return resultTextParts.push(text.slice(lastEndIndex)), resultCharMeta = resultCharMeta.concat(characterMeta.slice(lastEndIndex)), 
        {
            text: resultTextParts.join(""),
            characterMeta: resultCharMeta
        };
    }
    function repeatSeq(seq, count) {
        for (var result = seq.slice(0, 0); count-- > 0; ) result = result.concat(seq);
        return result;
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.default = replaceTextWithMeta;
}, /* 337 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _toConsumableArray(arr) {
        if (Array.isArray(arr)) {
            for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
            return arr2;
        }
        return Array.from(arr);
    }
    function _possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !call || "object" != typeof call && "function" != typeof call ? self : call;
    }
    function _inherits(subClass, superClass) {
        if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function escape(html) {
        return html.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }
    function escapeAttr(html) {
        return html.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _createClass = function() {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 
                "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), 
            Constructor;
        };
    }(), EMPTY_ATTR_LIST = [], NODE_TYPE_ELEMENT = exports.NODE_TYPE_ELEMENT = 1, NODE_TYPE_TEXT = exports.NODE_TYPE_TEXT = 3, NODE_TYPE_FRAGMENT = exports.NODE_TYPE_FRAGMENT = 11, SELF_CLOSING = exports.SELF_CLOSING = {
        area: !0,
        base: !0,
        br: !0,
        col: !0,
        embed: !0,
        hr: !0,
        img: !0,
        input: !0,
        keygen: !0,
        link: !0,
        meta: !0,
        param: !0,
        source: !0,
        track: !0,
        wbr: !0
    }, Node = exports.Node = function Node() {
        _classCallCheck(this, Node);
    };
    exports.TextNode = function(_Node) {
        function TextNode(value) {
            _classCallCheck(this, TextNode);
            var _this = _possibleConstructorReturn(this, (TextNode.__proto__ || Object.getPrototypeOf(TextNode)).apply(this, arguments));
            return _this.nodeType = NODE_TYPE_TEXT, _this.nodeName = "#text", _this.nodeValue = value, 
            _this;
        }
        return _inherits(TextNode, _Node), _createClass(TextNode, [ {
            key: "toString",
            value: function() {
                return escape(this.nodeValue);
            }
        } ]), TextNode;
    }(Node), exports.ElementNode = function(_Node2) {
        function ElementNode(name, attributes, childNodes) {
            _classCallCheck(this, ElementNode);
            var _this2 = _possibleConstructorReturn(this, (ElementNode.__proto__ || Object.getPrototypeOf(ElementNode)).apply(this, arguments));
            null == attributes && (attributes = EMPTY_ATTR_LIST);
            var isSelfClosing = !0 === SELF_CLOSING[name];
            return _this2.nodeType = NODE_TYPE_ELEMENT, _this2._name = name.toLowerCase(), _this2.attributes = attributes, 
            _this2._attrMap = new Map(attributes.map(function(attr) {
                return [ attr.name, attr ];
            })), _this2.nodeName = name.toUpperCase(), _this2.childNodes = [], _this2._isSelfClosing = isSelfClosing, 
            !isSelfClosing && childNodes && childNodes.forEach(_this2.appendChild, _this2), 
            _this2;
        }
        return _inherits(ElementNode, _Node2), _createClass(ElementNode, [ {
            key: "appendChild",
            value: function(node) {
                if (node.nodeType === NODE_TYPE_FRAGMENT) {
                    if (null != node.childNodes) {
                        var _childNodes, childNodes = node.childNodes;
                        (_childNodes = this.childNodes).push.apply(_childNodes, _toConsumableArray(childNodes));
                    }
                } else this.childNodes.push(node);
            }
        }, {
            key: "getAttribute",
            value: function(name) {
                var attr = this._attrMap.get(name);
                if (attr) return attr.value;
            }
        }, {
            key: "toString",
            value: function(isXHTML) {
                var attributes = [], _iteratorNormalCompletion = !0, _didIteratorError = !1, _iteratorError = void 0;
                try {
                    for (var _step, _iterator = this.attributes[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = !0) {
                        var _ref2 = _step.value, _name = _ref2.name, _value = _ref2.value;
                        attributes.push(_name + (_value ? '="' + escapeAttr(_value) + '"' : ""));
                    }
                } catch (err) {
                    _didIteratorError = !0, _iteratorError = err;
                } finally {
                    try {
                        !_iteratorNormalCompletion && _iterator.return && _iterator.return();
                    } finally {
                        if (_didIteratorError) throw _iteratorError;
                    }
                }
                var attrString = attributes.length ? " " + attributes.join(" ") : "";
                if (this._isSelfClosing) return "<" + this._name + attrString + (isXHTML ? "/>" : ">");
                var childNodes = this.childNodes.map(function(node) {
                    return node.toString(isXHTML);
                }).join("");
                return "<" + this._name + attrString + ">" + childNodes + "</" + this._name + ">";
            }
        }, {
            key: "tagName",
            get: function() {
                return this.nodeName;
            }
        }, {
            key: "className",
            get: function() {
                return this.getAttribute("class") || "";
            }
        } ]), ElementNode;
    }(Node), exports.FragmentNode = function(_Node3) {
        function FragmentNode(childNodes) {
            _classCallCheck(this, FragmentNode);
            var _this3 = _possibleConstructorReturn(this, (FragmentNode.__proto__ || Object.getPrototypeOf(FragmentNode)).apply(this, arguments));
            return _this3.nodeType = NODE_TYPE_FRAGMENT, _this3.childNodes = [], childNodes && childNodes.forEach(_this3.appendChild, _this3), 
            _this3;
        }
        return _inherits(FragmentNode, _Node3), _createClass(FragmentNode, [ {
            key: "appendChild",
            value: function(node) {
                if (node.nodeType === NODE_TYPE_FRAGMENT) {
                    if (null != node.childNodes) {
                        var _childNodes2, childNodes = node.childNodes;
                        (_childNodes2 = this.childNodes).push.apply(_childNodes2, _toConsumableArray(childNodes));
                    }
                } else this.childNodes.push(node);
            }
        }, {
            key: "toString",
            value: function(isXHTML) {
                return this.childNodes.map(function(node) {
                    return node.toString(isXHTML);
                }).join("");
            }
        } ]), FragmentNode;
    }(Node);
}, /* 338 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    exports.INLINE_ELEMENTS = {
        a: 1,
        abbr: 1,
        area: 1,
        audio: 1,
        b: 1,
        bdi: 1,
        bdo: 1,
        br: 1,
        button: 1,
        canvas: 1,
        cite: 1,
        code: 1,
        command: 1,
        datalist: 1,
        del: 1,
        dfn: 1,
        em: 1,
        embed: 1,
        i: 1,
        iframe: 1,
        img: 1,
        input: 1,
        ins: 1,
        kbd: 1,
        keygen: 1,
        label: 1,
        map: 1,
        mark: 1,
        meter: 1,
        noscript: 1,
        object: 1,
        output: 1,
        progress: 1,
        q: 1,
        ruby: 1,
        s: 1,
        samp: 1,
        script: 1,
        select: 1,
        small: 1,
        span: 1,
        strong: 1,
        sub: 1,
        sup: 1,
        textarea: 1,
        time: 1,
        u: 1,
        var: 1,
        video: 1,
        wbr: 1,
        acronym: 1,
        applet: 1,
        basefont: 1,
        big: 1,
        font: 1,
        isindex: 1,
        strike: 1,
        style: 1,
        tt: 1
    }, exports.SPECIAL_ELEMENTS = {
        area: 1,
        base: 1,
        br: 1,
        col: 1,
        colgroup: 1,
        command: 1,
        dl: 1,
        embed: 1,
        head: 1,
        hgroup: 1,
        hr: 1,
        iframe: 1,
        img: 1,
        input: 1,
        keygen: 1,
        link: 1,
        meta: 1,
        ol: 1,
        optgroup: 1,
        option: 1,
        param: 1,
        script: 1,
        select: 1,
        source: 1,
        style: 1,
        table: 1,
        tbody: 1,
        textarea: 1,
        tfoot: 1,
        thead: 1,
        title: 1,
        tr: 1,
        track: 1,
        ul: 1,
        wbr: 1,
        basefont: 1,
        dialog: 1,
        dir: 1,
        isindex: 1
    }, exports.SELF_CLOSING_ELEMENTS = {
        img: 1
    };
}, /* 339 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function parseHTML(html) {
        var doc = void 0;
        if ("undefined" != typeof DOMParser) {
            doc = new DOMParser().parseFromString(html, "text/html");
        } else doc = document.implementation.createHTMLDocument(""), doc.documentElement && (doc.documentElement.innerHTML = html);
        // This makes Flow happy
        return doc.body || doc.createElement("body");
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.default = parseHTML;
}, /* 340 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _stateToMarkdown = __webpack_require__(341);
    Object.defineProperty(exports, "stateToMarkdown", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_stateToMarkdown).default;
        }
    });
}, /* 341 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function canHaveDepth(blockType) {
        switch (blockType) {
          case _draftJsUtils.BLOCK_TYPE.UNORDERED_LIST_ITEM:
          case _draftJsUtils.BLOCK_TYPE.ORDERED_LIST_ITEM:
            return !0;

          default:
            return !1;
        }
    }
    function encodeContent(text) {
        return text.replace(/[*_`]/g, "\\$&");
    }
    // Encode chars that would normally be allowed in a URL but would conflict with
    // our markdown syntax: `[foo](http://foo/)`
    function encodeURL(url) {
        return url.replace(/\)/g, "%29");
    }
    // Escape quotes using backslash.
    function escapeTitle(text) {
        return text.replace(/"/g, '\\"');
    }
    function stateToMarkdown(content) {
        return new MarkupGenerator(content).generate();
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _slicedToArray = function() {
        function sliceIterator(arr, i) {
            var _arr = [], _n = !0, _d = !1, _e = void 0;
            try {
                for (var _s, _i = arr[Symbol.iterator](); !(_n = (_s = _i.next()).done) && (_arr.push(_s.value), 
                !i || _arr.length !== i); _n = !0) ;
            } catch (err) {
                _d = !0, _e = err;
            } finally {
                try {
                    !_n && _i.return && _i.return();
                } finally {
                    if (_d) throw _e;
                }
            }
            return _arr;
        }
        return function(arr, i) {
            if (Array.isArray(arr)) return arr;
            if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
    }(), _createClass = function() {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 
                "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), 
            Constructor;
        };
    }();
    exports.default = stateToMarkdown;
    var _draftJsUtils = __webpack_require__(29), BOLD = _draftJsUtils.INLINE_STYLE.BOLD, CODE = _draftJsUtils.INLINE_STYLE.CODE, ITALIC = _draftJsUtils.INLINE_STYLE.ITALIC, STRIKETHROUGH = _draftJsUtils.INLINE_STYLE.STRIKETHROUGH, UNDERLINE = _draftJsUtils.INLINE_STYLE.UNDERLINE, MarkupGenerator = function() {
        function MarkupGenerator(contentState) {
            _classCallCheck(this, MarkupGenerator), this.contentState = contentState;
        }
        return _createClass(MarkupGenerator, [ {
            key: "generate",
            value: function() {
                for (this.output = [], this.blocks = this.contentState.getBlockMap().toArray(), 
                this.totalBlocks = this.blocks.length, this.currentBlock = 0, this.listItemCounts = {}; this.currentBlock < this.totalBlocks; ) this.processBlock();
                return this.output.join("");
            }
        }, {
            key: "processBlock",
            value: function() {
                var block = this.blocks[this.currentBlock], blockType = block.getType();
                switch (blockType) {
                  case _draftJsUtils.BLOCK_TYPE.HEADER_ONE:
                    this.insertLineBreaks(1), this.output.push("# " + this.renderBlockContent(block) + "\n");
                    break;

                  case _draftJsUtils.BLOCK_TYPE.HEADER_TWO:
                    this.insertLineBreaks(1), this.output.push("## " + this.renderBlockContent(block) + "\n");
                    break;

                  case _draftJsUtils.BLOCK_TYPE.HEADER_THREE:
                    this.insertLineBreaks(1), this.output.push("### " + this.renderBlockContent(block) + "\n");
                    break;

                  case _draftJsUtils.BLOCK_TYPE.HEADER_FOUR:
                    this.insertLineBreaks(1), this.output.push("#### " + this.renderBlockContent(block) + "\n");
                    break;

                  case _draftJsUtils.BLOCK_TYPE.HEADER_FIVE:
                    this.insertLineBreaks(1), this.output.push("##### " + this.renderBlockContent(block) + "\n");
                    break;

                  case _draftJsUtils.BLOCK_TYPE.HEADER_SIX:
                    this.insertLineBreaks(1), this.output.push("###### " + this.renderBlockContent(block) + "\n");
                    break;

                  case _draftJsUtils.BLOCK_TYPE.UNORDERED_LIST_ITEM:
                    var blockDepth = block.getDepth(), lastBlock = this.getLastBlock(), lastBlockType = lastBlock ? lastBlock.getType() : null, lastBlockDepth = lastBlock && canHaveDepth(lastBlockType) ? lastBlock.getDepth() : null;
                    lastBlockType !== blockType && lastBlockDepth !== blockDepth - 1 && (this.insertLineBreaks(1), 
                    // Insert an additional line break if following opposite list type.
                    lastBlockType === _draftJsUtils.BLOCK_TYPE.ORDERED_LIST_ITEM && this.insertLineBreaks(1));
                    var indent = " ".repeat(4 * block.depth);
                    this.output.push(indent + "- " + this.renderBlockContent(block) + "\n");
                    break;

                  case _draftJsUtils.BLOCK_TYPE.ORDERED_LIST_ITEM:
                    var _blockDepth = block.getDepth(), _lastBlock = this.getLastBlock(), _lastBlockType = _lastBlock ? _lastBlock.getType() : null, _lastBlockDepth = _lastBlock && canHaveDepth(_lastBlockType) ? _lastBlock.getDepth() : null;
                    _lastBlockType !== blockType && _lastBlockDepth !== _blockDepth - 1 && (this.insertLineBreaks(1), 
                    // Insert an additional line break if following opposite list type.
                    _lastBlockType === _draftJsUtils.BLOCK_TYPE.UNORDERED_LIST_ITEM && this.insertLineBreaks(1));
                    var _indent = " ".repeat(4 * _blockDepth), count = this.getListItemCount(block) % 10;
                    this.output.push(_indent + (count + ". ") + this.renderBlockContent(block) + "\n");
                    break;

                  case _draftJsUtils.BLOCK_TYPE.BLOCKQUOTE:
                    this.insertLineBreaks(1), this.output.push(" > " + this.renderBlockContent(block) + "\n");
                    break;

                  case _draftJsUtils.BLOCK_TYPE.CODE:
                    this.insertLineBreaks(1), this.output.push("    " + this.renderBlockContent(block) + "\n");
                    break;

                  default:
                    this.insertLineBreaks(1), this.output.push(this.renderBlockContent(block) + "\n");
                }
                this.currentBlock += 1;
            }
        }, {
            key: "getLastBlock",
            value: function() {
                return this.blocks[this.currentBlock - 1];
            }
        }, {
            key: "getNextBlock",
            value: function() {
                return this.blocks[this.currentBlock + 1];
            }
        }, {
            key: "getListItemCount",
            value: function(block) {
                for (var blockType = block.getType(), blockDepth = block.getDepth(), index = this.currentBlock - 1, prevBlock = this.blocks[index]; prevBlock && canHaveDepth(prevBlock.getType()) && prevBlock.getDepth() > blockDepth; ) index -= 1, 
                prevBlock = this.blocks[index];
                return prevBlock && prevBlock.getType() === blockType && prevBlock.getDepth() === blockDepth || (this.listItemCounts[blockDepth] = 0), 
                this.listItemCounts[blockDepth] = this.listItemCounts[blockDepth] + 1;
            }
        }, {
            key: "insertLineBreaks",
            value: function() {
                this.currentBlock > 0 && this.output.push("\n");
            }
        }, {
            key: "renderBlockContent",
            value: function(block) {
                var contentState = this.contentState, blockType = block.getType(), text = block.getText();
                if ("" === text) // Prevent element collapse if completely empty.
                // TODO: Replace with constant.
                return "​";
                var charMetaList = block.getCharacterList();
                return (0, _draftJsUtils.getEntityRanges)(text, charMetaList).map(function(_ref) {
                    var _ref2 = _slicedToArray(_ref, 2), entityKey = _ref2[0], stylePieces = _ref2[1], content = stylePieces.map(function(_ref3) {
                        var _ref4 = _slicedToArray(_ref3, 2), text = _ref4[0], style = _ref4[1];
                        // Don't allow empty inline elements.
                        if (!text) return "";
                        var content = encodeContent(text);
                        // TODO: encode `+`?
                        // TODO: encode `~`?
                        return style.has(BOLD) && (content = "**" + content + "**"), style.has(UNDERLINE) && (content = "++" + content + "++"), 
                        style.has(ITALIC) && (content = "_" + content + "_"), style.has(STRIKETHROUGH) && (content = "~~" + content + "~~"), 
                        style.has(CODE) && (content = blockType === _draftJsUtils.BLOCK_TYPE.CODE ? content : "`" + content + "`"), 
                        content;
                    }).join(""), entity = entityKey ? contentState.getEntity(entityKey) : null;
                    if (null != entity && entity.getType() === _draftJsUtils.ENTITY_TYPE.LINK) {
                        var data = entity.getData(), url = data.url || "", title = data.title ? ' "' + escapeTitle(data.title) + '"' : "";
                        return "[" + content + "](" + encodeURL(url) + title + ")";
                    }
                    if (null != entity && entity.getType() === _draftJsUtils.ENTITY_TYPE.IMAGE) {
                        var _data = entity.getData(), src = _data.src || "";
                        return "![" + (_data.alt ? ' "' + escapeTitle(_data.alt) + '"' : "") + "](" + encodeURL(src) + ")";
                    }
                    return content;
                }).join("");
            }
        } ]), MarkupGenerator;
    }();
}, /* 342 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _stateFromMarkdown = __webpack_require__(343);
    Object.defineProperty(exports, "stateFromMarkdown", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_stateFromMarkdown).default;
        }
    });
    var _MarkdownParser = __webpack_require__(143);
    Object.defineProperty(exports, "MarkdownParser", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_MarkdownParser).default;
        }
    });
}, /* 343 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function stateFromMarkdown(markdown, options) {
        var element = _MarkdownParser2.default.parse(markdown, {
            getAST: !0
        });
        return (0, _draftJsImportElement.stateFromElement)(element, options);
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.default = stateFromMarkdown;
    var _MarkdownParser = __webpack_require__(143), _MarkdownParser2 = function(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }(_MarkdownParser), _draftJsImportElement = __webpack_require__(141);
}, /* 344 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function Link(props) {
        var _props$contentState$g = props.contentState.getEntity(props.entityKey).getData(), url = _props$contentState$g.url;
        return _react2.default.createElement("a", {
            href: url
        }, props.children);
    }
    function findLinkEntities(contentBlock, callback, contentState) {
        contentBlock.findEntityRanges(function(character) {
            var entityKey = character.getEntity();
            if (null != entityKey) {
                var entity = contentState ? contentState.getEntity(entityKey) : null;
                return null != entity && entity.getType() === _draftJsUtils.ENTITY_TYPE.LINK;
            }
            return !1;
        }, callback);
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _react = __webpack_require__(3), _react2 = function(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }(_react), _draftJsUtils = __webpack_require__(29);
    exports.default = {
        strategy: findLinkEntities,
        component: Link
    };
}, /* 345 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function findImageEntities(contentBlock, callback, contentState) {
        contentBlock.findEntityRanges(function(character) {
            var entityKey = character.getEntity();
            if (null != entityKey) {
                var entity = contentState ? contentState.getEntity(entityKey) : null;
                return null != entity && entity.getType() === _draftJsUtils.ENTITY_TYPE.IMAGE;
            }
            return !1;
        }, callback);
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _ImageSpan = __webpack_require__(346), _ImageSpan2 = function(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }(_ImageSpan), _draftJsUtils = __webpack_require__(29);
    exports.default = {
        strategy: findImageEntities,
        component: _ImageSpan2.default
    };
}, /* 346 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(20), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(14), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(15), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(21), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(22), _inherits3 = _interopRequireDefault(_inherits2), _classAutobind = __webpack_require__(30), _classAutobind2 = _interopRequireDefault(_classAutobind), _classnames = __webpack_require__(23), _classnames2 = _interopRequireDefault(_classnames), _react = __webpack_require__(3), _react2 = _interopRequireDefault(_react), _draftJs = __webpack_require__(10), _ImageSpan = __webpack_require__(347), _ImageSpan2 = _interopRequireDefault(_ImageSpan), ImageSpan = function(_Component) {
        function ImageSpan(props) {
            (0, _classCallCheck3.default)(this, ImageSpan);
            var _this = (0, _possibleConstructorReturn3.default)(this, (ImageSpan.__proto__ || (0, 
            _getPrototypeOf2.default)(ImageSpan)).call(this, props));
            (0, _classAutobind2.default)(_this);
            var entity = props.contentState.getEntity(props.entityKey), _entity$getData = entity.getData(), width = _entity$getData.width, height = _entity$getData.height;
            return _this.state = {
                width: width,
                height: height
            }, _this;
        }
        return (0, _inherits3.default)(ImageSpan, _Component), (0, _createClass3.default)(ImageSpan, [ {
            key: "componentDidMount",
            value: function() {
                var _this2 = this, _state = this.state, width = _state.width, height = _state.height, entity = this.props.contentState.getEntity(this.props.entityKey), image = new Image(), _entity$getData2 = entity.getData(), src = _entity$getData2.src;
                image.src = src, image.onload = function() {
                    null != width && null != height || (// TODO: isMounted?
                    _this2.setState({
                        width: image.width,
                        height: image.height
                    }), _draftJs.Entity.mergeData(_this2.props.entityKey, {
                        width: image.width,
                        height: image.height,
                        originalWidth: image.width,
                        originalHeight: image.height
                    }));
                };
            }
        }, {
            key: "render",
            value: function() {
                var _state2 = this.state, width = _state2.width, height = _state2.height, className = this.props.className, entity = this.props.contentState.getEntity(this.props.entityKey), _entity$getData3 = entity.getData(), src = _entity$getData3.src;
                className = (0, _classnames2.default)(className, _ImageSpan2.default.root);
                var imageStyle = {
                    verticalAlign: "bottom",
                    backgroundImage: 'url("' + src + '")',
                    backgroundSize: width + "px " + height + "px",
                    lineHeight: height + "px",
                    fontSize: height + "px",
                    width: width,
                    height: height,
                    letterSpacing: width
                };
                return _react2.default.createElement("span", {
                    className: className,
                    style: imageStyle,
                    onClick: this._onClick
                }, this.props.children);
            }
        }, {
            key: "_onClick",
            value: function() {
                console.log("image clicked");
            }
        }, {
            key: "_handleResize",
            value: function(event, data) {
                var _data$size = data.size, width = _data$size.width, height = _data$size.height;
                this.setState({
                    width: width,
                    height: height
                }), _draftJs.Entity.mergeData(this.props.entityKey, {
                    width: width,
                    height: height
                });
            }
        } ]), ImageSpan;
    }(_react.Component);
    exports.default = ImageSpan;
}, /* 347 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(348);
    "string" == typeof content && (content = [ [ module.i, content, "" ] ]);
    // Prepare cssTransformation
    var options = {
        sourceMap: !0
    };
    options.transform = void 0;
    // add the styles to the DOM
    __webpack_require__(18)(content, options);
    content.locals && (module.exports = content.locals);
}, /* 348 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(24)(void 0), // imports
    // module
    exports.push([ module.i, ".ImageSpan__root___RoAqL {\n  background-repeat: no-repeat;\n  display: inline-block;\n  overflow: hidden;\n  cursor: pointer;\n}\n\n.ImageSpan__resize___1Hx5M {\n  border: 1px dashed #78a300;\n  position: relative;\n  max-width: 100%;\n  display: inline-block;\n  line-height: 0;\n  top: -1px;\n  left: -1px,\n}\n\n.ImageSpan__resizeHandle___18rou {\n  cursor: nwse-resize;\n  position: absolute;\n  z-index: 2;\n  line-height: 1;\n  bottom: -4px;\n  right: -5px;\n  border: 1px solid white;\n  background-color: #78a300;\n  width: 8px;\n  height: 8px;\n}\n", "" ]), 
    // exports
    exports.locals = {
        root: "ImageSpan__root___RoAqL",
        resize: "ImageSpan__resize___1Hx5M",
        resizeHandle: "ImageSpan__resizeHandle___18rou"
    };
}, /* 349 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function composite(defaultFunc, customFunc) {
        return function(input) {
            if (customFunc) {
                var result = customFunc(input);
                if (null != result) return result;
            }
            return defaultFunc(input);
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.default = composite;
}, /* 350 */
/***/
function(module, exports) {
    // Copyright Joyent, Inc. and other Node contributors.
    //
    // Permission is hereby granted, free of charge, to any person obtaining a
    // copy of this software and associated documentation files (the
    // "Software"), to deal in the Software without restriction, including
    // without limitation the rights to use, copy, modify, merge, publish,
    // distribute, sublicense, and/or sell copies of the Software, and to permit
    // persons to whom the Software is furnished to do so, subject to the
    // following conditions:
    //
    // The above copyright notice and this permission notice shall be included
    // in all copies or substantial portions of the Software.
    //
    // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
    // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
    // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
    // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
    // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
    // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
    // USE OR OTHER DEALINGS IN THE SOFTWARE.
    function EventEmitter() {
        this._events = this._events || {}, this._maxListeners = this._maxListeners || void 0;
    }
    function isFunction(arg) {
        return "function" == typeof arg;
    }
    function isNumber(arg) {
        return "number" == typeof arg;
    }
    function isObject(arg) {
        return "object" == typeof arg && null !== arg;
    }
    function isUndefined(arg) {
        return void 0 === arg;
    }
    module.exports = EventEmitter, // Backwards-compat with node 0.10.x
    EventEmitter.EventEmitter = EventEmitter, EventEmitter.prototype._events = void 0, 
    EventEmitter.prototype._maxListeners = void 0, // By default EventEmitters will print a warning if more than 10 listeners are
    // added to it. This is a useful default which helps finding memory leaks.
    EventEmitter.defaultMaxListeners = 10, // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.setMaxListeners = function(n) {
        if (!isNumber(n) || n < 0 || isNaN(n)) throw TypeError("n must be a positive number");
        return this._maxListeners = n, this;
    }, EventEmitter.prototype.emit = function(type) {
        var er, handler, len, args, i, listeners;
        // If there is no 'error' event listener then throw.
        if (this._events || (this._events = {}), "error" === type && (!this._events.error || isObject(this._events.error) && !this._events.error.length)) {
            if ((er = arguments[1]) instanceof Error) throw er;
            // At least give some kind of context to the user
            var err = new Error('Uncaught, unspecified "error" event. (' + er + ")");
            throw err.context = er, err;
        }
        if (handler = this._events[type], isUndefined(handler)) return !1;
        if (isFunction(handler)) switch (arguments.length) {
          // fast cases
            case 1:
            handler.call(this);
            break;

          case 2:
            handler.call(this, arguments[1]);
            break;

          case 3:
            handler.call(this, arguments[1], arguments[2]);
            break;

          // slower
            default:
            args = Array.prototype.slice.call(arguments, 1), handler.apply(this, args);
        } else if (isObject(handler)) for (args = Array.prototype.slice.call(arguments, 1), 
        listeners = handler.slice(), len = listeners.length, i = 0; i < len; i++) listeners[i].apply(this, args);
        return !0;
    }, EventEmitter.prototype.addListener = function(type, listener) {
        var m;
        if (!isFunction(listener)) throw TypeError("listener must be a function");
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        // If we've already got an array, just append.
        // Adding the second element, need to change to array.
        // Optimize the case of one listener. Don't need the extra array object.
        // Check for listener leak
        // not supported in IE 10
        return this._events || (this._events = {}), this._events.newListener && this.emit("newListener", type, isFunction(listener.listener) ? listener.listener : listener), 
        this._events[type] ? isObject(this._events[type]) ? this._events[type].push(listener) : this._events[type] = [ this._events[type], listener ] : this._events[type] = listener, 
        isObject(this._events[type]) && !this._events[type].warned && (m = isUndefined(this._maxListeners) ? EventEmitter.defaultMaxListeners : this._maxListeners) && m > 0 && this._events[type].length > m && (this._events[type].warned = !0, 
        console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.", this._events[type].length), 
        "function" == typeof console.trace && console.trace()), this;
    }, EventEmitter.prototype.on = EventEmitter.prototype.addListener, EventEmitter.prototype.once = function(type, listener) {
        function g() {
            this.removeListener(type, g), fired || (fired = !0, listener.apply(this, arguments));
        }
        if (!isFunction(listener)) throw TypeError("listener must be a function");
        var fired = !1;
        return g.listener = listener, this.on(type, g), this;
    }, // emits a 'removeListener' event iff the listener was removed
    EventEmitter.prototype.removeListener = function(type, listener) {
        var list, position, length, i;
        if (!isFunction(listener)) throw TypeError("listener must be a function");
        if (!this._events || !this._events[type]) return this;
        if (list = this._events[type], length = list.length, position = -1, list === listener || isFunction(list.listener) && list.listener === listener) delete this._events[type], 
        this._events.removeListener && this.emit("removeListener", type, listener); else if (isObject(list)) {
            for (i = length; i-- > 0; ) if (list[i] === listener || list[i].listener && list[i].listener === listener) {
                position = i;
                break;
            }
            if (position < 0) return this;
            1 === list.length ? (list.length = 0, delete this._events[type]) : list.splice(position, 1), 
            this._events.removeListener && this.emit("removeListener", type, listener);
        }
        return this;
    }, EventEmitter.prototype.removeAllListeners = function(type) {
        var key, listeners;
        if (!this._events) return this;
        // not listening for removeListener, no need to emit
        if (!this._events.removeListener) return 0 === arguments.length ? this._events = {} : this._events[type] && delete this._events[type], 
        this;
        // emit removeListener for all listeners on all events
        if (0 === arguments.length) {
            for (key in this._events) "removeListener" !== key && this.removeAllListeners(key);
            return this.removeAllListeners("removeListener"), this._events = {}, this;
        }
        if (listeners = this._events[type], isFunction(listeners)) this.removeListener(type, listeners); else if (listeners) // LIFO order
        for (;listeners.length; ) this.removeListener(type, listeners[listeners.length - 1]);
        return delete this._events[type], this;
    }, EventEmitter.prototype.listeners = function(type) {
        return this._events && this._events[type] ? isFunction(this._events[type]) ? [ this._events[type] ] : this._events[type].slice() : [];
    }, EventEmitter.prototype.listenerCount = function(type) {
        if (this._events) {
            var evlistener = this._events[type];
            if (isFunction(evlistener)) return 1;
            if (evlistener) return evlistener.length;
        }
        return 0;
    }, EventEmitter.listenerCount = function(emitter, type) {
        return emitter.listenerCount(type);
    };
}, /* 351 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(352);
    "string" == typeof content && (content = [ [ module.i, content, "" ] ]);
    // Prepare cssTransformation
    var options = {};
    options.transform = void 0;
    // add the styles to the DOM
    __webpack_require__(18)(content, options);
    content.locals && (module.exports = content.locals);
}, /* 352 */
/***/
function(module, exports) {
    module.exports = '/**\n * We inherit the height of the container by default\n */\n\n.DraftEditor-root,\n.DraftEditor-editorContainer,\n.public-DraftEditor-content {\n  height: inherit;\n  text-align: initial;\n}\n\n.DraftEditor-root {\n  position: relative;\n}\n\n/**\n * Zero-opacity background used to allow focus in IE. Otherwise, clicks\n * fall through to the placeholder.\n */\n\n.DraftEditor-editorContainer {\n  background-color: rgba(255, 255, 255, 0);\n  /* Repair mysterious missing Safari cursor */\n  border: 1px solid transparent;\n  position: relative;\n  z-index: 1;\n}\n\n.public-DraftEditor-content {\n  outline: none;\n  white-space: pre-wrap;\n}\n\n.public-DraftEditor-block {\n  position: relative;\n}\n\n.DraftEditor-alignLeft .public-DraftEditor-block {\n  text-align: left;\n}\n\n.DraftEditor-alignLeft .public-DraftEditorPlaceholder-root {\n  left: 0;\n  text-align: left;\n}\n\n.DraftEditor-alignCenter .public-DraftEditor-block {\n  text-align: center;\n}\n\n.DraftEditor-alignCenter .public-DraftEditorPlaceholder-root {\n  margin: 0 auto;\n  text-align: center;\n  width: 100%;\n}\n\n.DraftEditor-alignRight .public-DraftEditor-block {\n  text-align: right;\n}\n\n.DraftEditor-alignRight .public-DraftEditorPlaceholder-root {\n  right: 0;\n  text-align: right;\n}\n/**\n * @providesModule DraftEditorPlaceholder\n */\n\n.public-DraftEditorPlaceholder-root {\n  color: #9197a3;\n  position: absolute;\n  z-index: 0;\n}\n\n.public-DraftEditorPlaceholder-hasFocus {\n  color: #bdc1c9;\n}\n\n.DraftEditorPlaceholder-hidden {\n  display: none;\n}\n/**\n * @providesModule DraftStyleDefault\n */\n\n.public-DraftStyleDefault-block {\n  position: relative;\n  white-space: pre-wrap;\n}\n\n/* @noflip */\n\n.public-DraftStyleDefault-ltr {\n  direction: ltr;\n  text-align: left;\n}\n\n/* @noflip */\n\n.public-DraftStyleDefault-rtl {\n  direction: rtl;\n  text-align: right;\n}\n\n/**\n * These rules provide appropriate text direction for counter pseudo-elements.\n */\n\n/* @noflip */\n\n.public-DraftStyleDefault-listLTR {\n  direction: ltr;\n}\n\n/* @noflip */\n\n.public-DraftStyleDefault-listRTL {\n  direction: rtl;\n}\n\n/**\n * Default spacing for list container elements. Override with CSS as needed.\n */\n\n.public-DraftStyleDefault-ul,\n.public-DraftStyleDefault-ol {\n  margin: 16px 0;\n  padding: 0;\n}\n\n/**\n * Default counters and styles are provided for five levels of nesting.\n * If you require nesting beyond that level, you should use your own CSS\n * classes to do so. If you care about handling RTL languages, the rules you\n * create should look a lot like these.\n */\n\n/* @noflip */\n\n.public-DraftStyleDefault-depth0.public-DraftStyleDefault-listLTR {\n  margin-left: 1.5em;\n}\n\n/* @noflip */\n\n.public-DraftStyleDefault-depth0.public-DraftStyleDefault-listRTL {\n  margin-right: 1.5em;\n}\n\n/* @noflip */\n\n.public-DraftStyleDefault-depth1.public-DraftStyleDefault-listLTR {\n  margin-left: 3em;\n}\n\n/* @noflip */\n\n.public-DraftStyleDefault-depth1.public-DraftStyleDefault-listRTL {\n  margin-right: 3em;\n}\n\n/* @noflip */\n\n.public-DraftStyleDefault-depth2.public-DraftStyleDefault-listLTR {\n  margin-left: 4.5em;\n}\n\n/* @noflip */\n\n.public-DraftStyleDefault-depth2.public-DraftStyleDefault-listRTL {\n  margin-right: 4.5em;\n}\n\n/* @noflip */\n\n.public-DraftStyleDefault-depth3.public-DraftStyleDefault-listLTR {\n  margin-left: 6em;\n}\n\n/* @noflip */\n\n.public-DraftStyleDefault-depth3.public-DraftStyleDefault-listRTL {\n  margin-right: 6em;\n}\n\n/* @noflip */\n\n.public-DraftStyleDefault-depth4.public-DraftStyleDefault-listLTR {\n  margin-left: 7.5em;\n}\n\n/* @noflip */\n\n.public-DraftStyleDefault-depth4.public-DraftStyleDefault-listRTL {\n  margin-right: 7.5em;\n}\n\n/**\n * Only use `square` list-style after the first two levels.\n */\n\n.public-DraftStyleDefault-unorderedListItem {\n  list-style-type: square;\n  position: relative;\n}\n\n.public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth0 {\n  list-style-type: disc;\n}\n\n.public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth1 {\n  list-style-type: circle;\n}\n\n/**\n * Ordered list item counters are managed with CSS, since all list nesting is\n * purely visual.\n */\n\n.public-DraftStyleDefault-orderedListItem {\n  list-style-type: none;\n  position: relative;\n}\n\n/* @noflip */\n\n.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listLTR:before {\n  left: -36px;\n  position: absolute;\n  text-align: right;\n  width: 30px;\n}\n\n/* @noflip */\n\n.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listRTL:before {\n  position: absolute;\n  right: -36px;\n  text-align: left;\n  width: 30px;\n}\n\n/**\n * Counters are reset in JavaScript. If you need different counter styles,\n * override these rules. If you need more nesting, create your own rules to\n * do so.\n */\n\n.public-DraftStyleDefault-orderedListItem:before {\n  content: counter(ol0) ". ";\n  counter-increment: ol0;\n}\n\n.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth1:before {\n  content: counter(ol1) ". ";\n  counter-increment: ol1;\n}\n\n.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth2:before {\n  content: counter(ol2) ". ";\n  counter-increment: ol2;\n}\n\n.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth3:before {\n  content: counter(ol3) ". ";\n  counter-increment: ol3;\n}\n\n.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth4:before {\n  content: counter(ol4) ". ";\n  counter-increment: ol4;\n}\n\n.public-DraftStyleDefault-depth0.public-DraftStyleDefault-reset {\n  counter-reset: ol0;\n}\n\n.public-DraftStyleDefault-depth1.public-DraftStyleDefault-reset {\n  counter-reset: ol1;\n}\n\n.public-DraftStyleDefault-depth2.public-DraftStyleDefault-reset {\n  counter-reset: ol2;\n}\n\n.public-DraftStyleDefault-depth3.public-DraftStyleDefault-reset {\n  counter-reset: ol3;\n}\n\n.public-DraftStyleDefault-depth4.public-DraftStyleDefault-reset {\n  counter-reset: ol4;\n}\n';
}, /* 353 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(354);
    "string" == typeof content && (content = [ [ module.i, content, "" ] ]);
    // Prepare cssTransformation
    var options = {
        sourceMap: !0
    };
    options.transform = void 0;
    // add the styles to the DOM
    __webpack_require__(18)(content, options);
    content.locals && (module.exports = content.locals);
}, /* 354 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(24)(void 0), // imports
    // module
    exports.push([ module.i, ".RichTextEditor__root___2QXK- {\n  background: #fff;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  font-family: 'Georgia', serif;\n  font-size: 14px;\n}\n\n.RichTextEditor__editor___1QqIU {\n  cursor: text;\n  font-size: 16px;\n}\n\n.RichTextEditor__editor___1QqIU .public-DraftEditorPlaceholder-root,\n.RichTextEditor__editor___1QqIU .public-DraftEditor-content {\n  margin: 0;\n  /* 1px is added as transparent border on .DraftEditor-editorContainer */\n  padding: 9px;\n}\n\n.RichTextEditor__editor___1QqIU .public-DraftEditor-content {\n  overflow: auto;\n}\n\n.RichTextEditor__hidePlaceholder___3WLid .public-DraftEditorPlaceholder-root {\n  display: none;\n}\n\n.RichTextEditor__editor___1QqIU .RichTextEditor__paragraph___3NTf9 {\n  margin: 14px 0;\n}\n\n/* Consecutive code blocks are nested inside a single parent <pre> (like <li>\n  inside <ul>). Unstyle the parent and style the children. */\n.RichTextEditor__editor___1QqIU pre {\n  margin: 14px 0;\n}\n\n.RichTextEditor__editor___1QqIU .RichTextEditor__codeBlock____KD4Q {\n  background-color: #f3f3f3;\n  font-family: \"Inconsolata\", \"Menlo\", \"Consolas\", monospace;\n  font-size: 16px;\n  /* This should collapse with the margin around the parent <pre>. */\n  margin: 14px 0;\n  padding: 20px;\n}\n\n/* Hacky: Remove padding from inline <code> within code block. */\n.RichTextEditor__editor___1QqIU .RichTextEditor__codeBlock____KD4Q span[style] {\n  padding: 0 !important;\n}\n\n.RichTextEditor__editor___1QqIU .RichTextEditor__blockquote___1vCYl {\n  border-left: 5px solid #eee;\n  color: #666;\n  font-family: 'Hoefler Text', 'Georgia', serif;\n  font-style: italic;\n  margin: 16px 0;\n  padding: 10px 20px;\n}\n\n/* There shouldn't be margin outside the first/last blocks */\n.RichTextEditor__editor___1QqIU .RichTextEditor__block___2Vs_D:first-child,\n.RichTextEditor__editor___1QqIU pre:first-child,\n.RichTextEditor__editor___1QqIU ul:first-child,\n.RichTextEditor__editor___1QqIU ol:first-child {\n  margin-top: 0;\n}\n.RichTextEditor__editor___1QqIU .RichTextEditor__block___2Vs_D:last-child,\n.RichTextEditor__editor___1QqIU pre:last-child,\n.RichTextEditor__editor___1QqIU ul:last-child,\n.RichTextEditor__editor___1QqIU ol:last-child {\n  margin-bottom: 0;\n}\n", "" ]), 
    // exports
    exports.locals = {
        root: "RichTextEditor__root___2QXK-",
        editor: "RichTextEditor__editor___1QqIU",
        hidePlaceholder: "RichTextEditor__hidePlaceholder___3WLid",
        paragraph: "RichTextEditor__paragraph___3NTf9",
        codeBlock: "RichTextEditor__codeBlock____KD4Q",
        blockquote: "RichTextEditor__blockquote___1vCYl",
        block: "RichTextEditor__block___2Vs_D"
    };
} ]);


//////////////////
// WEBPACK FOOTER
// ./~/react-rte/dist/react-rte.js
// module id = 1468
// module chunks = 0